webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_dynamic_1 = __webpack_require__(19);
	var app_module_1 = __webpack_require__(23);
	if (location.search === "?noload") {
	    throw new Error("User flag (?noload) indicated bootstrap should abort.");
	}
	core_1.enableProdMode();
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var bootstrap_1 = __webpack_require__(24);
	var platform_browser_1 = __webpack_require__(21);
	var angular2_modal_1 = __webpack_require__(25);
	var core_1 = __webpack_require__(1);
	var aggregation_module_1 = __webpack_require__(40);
	var shared_module_1 = __webpack_require__(63);
	var core_module_1 = __webpack_require__(917);
	var mcp_application_component_1 = __webpack_require__(947);
	var admin_chat_modal_component_1 = __webpack_require__(894);
	var management_module_1 = __webpack_require__(887);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                core_module_1.CoreModule,
	                shared_module_1.SharedModule,
	                management_module_1.ManagementModule,
	                aggregation_module_1.AggregationModule.forRoot(),
	                angular2_modal_1.ModalModule.forRoot(),
	                bootstrap_1.BootstrapModalModule,
	            ],
	            declarations: [mcp_application_component_1.MCPApplicationComponent, admin_chat_modal_component_1.AdminChatModalComponent],
	            bootstrap: [mcp_application_component_1.MCPApplicationComponent],
	            entryComponents: [admin_chat_modal_component_1.AdminChatModalComponent]
	        })
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(25), __webpack_require__(1), __webpack_require__(28), __webpack_require__(22)) :
	        typeof define === 'function' && define.amd ? define(['exports', 'angular2-modal', '@angular/core', 'rxjs/add/operator/combineLatest', '@angular/common'], factory) :
	            (factory((global.angular2Modal = global.angular2Modal || {}, global.angular2Modal.plugins = global.angular2Modal.plugins || {}, global.angular2Modal.plugins.bootstrap = global.angular2Modal.plugins.bootstrap || {}), global.angular2Modal, global.ng.core, global.rxjs_add_operator_combineLatest, global.ng.common));
	}(this, (function (exports, angular2Modal, _angular_core, rxjs_add_operator_combineLatest, _angular_common) {
	    'use strict';
	    var __extends = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var DEFAULT_VALUES = {
	        dialogClass: 'modal-dialog',
	        showClose: false
	    };
	    var DEFAULT_SETTERS = [
	        'dialogClass',
	        'size',
	        'showClose'
	    ];
	    var BSModalContext = (function (_super) {
	        __extends(BSModalContext, _super);
	        function BSModalContext() {
	            _super.apply(this, arguments);
	        }
	        BSModalContext.prototype.normalize = function () {
	            if (!this.dialogClass) {
	                this.dialogClass = DEFAULT_VALUES.dialogClass;
	            }
	            _super.prototype.normalize.call(this);
	        };
	        return BSModalContext;
	    }(angular2Modal.ModalOpenContext));
	    var BSModalContextBuilder = (function (_super) {
	        __extends(BSModalContextBuilder, _super);
	        function BSModalContextBuilder(defaultValues, initialSetters, baseType) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            if (initialSetters === void 0) {
	                initialSetters = undefined;
	            }
	            if (baseType === void 0) {
	                baseType = undefined;
	            }
	            _super.call(this, angular2Modal.extend(DEFAULT_VALUES, defaultValues || {}), angular2Modal.arrayUnion(DEFAULT_SETTERS, initialSetters || []), baseType || BSModalContext // https://github.com/Microsoft/TypeScript/issues/7234
	            );
	        }
	        return BSModalContextBuilder;
	    }(angular2Modal.ModalOpenContextBuilder));
	    var __extends$1 = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var BSModalContainer = (function (_super) {
	        __extends$1(BSModalContainer, _super);
	        function BSModalContainer(dialog, el, renderer) {
	            _super.call(this, el, renderer);
	            this.dialog = dialog;
	            this.activateAnimationListener();
	        }
	        BSModalContainer.decorators = [
	            { type: _angular_core.Component, args: [{
	                        selector: 'bs-modal-container',
	                        host: {
	                            'tabindex': '-1',
	                            'role': 'dialog',
	                            'class': 'modal fade',
	                            'style': 'position: absolute; display: block'
	                        },
	                        encapsulation: _angular_core.ViewEncapsulation.None,
	                        template: "<div [ngClass]=\"dialog.context.dialogClass\" \n      [class.modal-lg]=\"dialog.context.size == 'lg'\"\n      [class.modal-sm]=\"dialog.context.size == 'sm'\">\n  <div class=\"modal-content\" style=\"display:block\" role=\"document\" overlayDialogBoundary>\n    <ng-content></ng-content>\n  </div>    \n</div>"
	                    },] },
	        ];
	        /** @nocollapse */
	        BSModalContainer.ctorParameters = [
	            { type: angular2Modal.DialogRef, },
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	        ];
	        return BSModalContainer;
	    }(angular2Modal.BaseDynamicComponent));
	    var BSMessageModalTitle = (function () {
	        function BSMessageModalTitle(dialog) {
	            this.dialog = dialog;
	            this.context = dialog.context;
	        }
	        Object.defineProperty(BSMessageModalTitle.prototype, "titleHtml", {
	            get: function () {
	                return this.context.titleHtml ? 1 : 0;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        BSMessageModalTitle.decorators = [
	            { type: _angular_core.Component, args: [{
	                        selector: 'modal-title',
	                        encapsulation: _angular_core.ViewEncapsulation.None,
	                        template: "<div [ngClass]=\"context.headerClass\" [ngSwitch]=\"titleHtml\">\n      <button *ngIf=\"context.showClose\" type=\"button\" class=\"close\" \n              aria-label=\"Close\" (click)=\"dialog.dismiss()\">\n          <span aria-hidden=\"true\">\u00D7</span>\n      </button>\n      <div *ngSwitchCase=\"1\" [innerHtml]=\"context.titleHtml\"></div>\n      <h3 *ngSwitchDefault class=\"modal-title\">{{context.title}}</h3>\n </div>"
	                    },] },
	        ];
	        /** @nocollapse */
	        BSMessageModalTitle.ctorParameters = [
	            { type: angular2Modal.DialogRef, },
	        ];
	        return BSMessageModalTitle;
	    }());
	    var BSMessageModalBody = (function () {
	        function BSMessageModalBody(dialog) {
	            this.dialog = dialog;
	            this.context = dialog.context;
	        }
	        BSMessageModalBody.decorators = [
	            { type: _angular_core.Component, args: [{
	                        selector: 'modal-body',
	                        encapsulation: _angular_core.ViewEncapsulation.None,
	                        styles: [".form-group {\n    margin-top: 10px;\n  }"],
	                        template: "<div [ngClass]=\"context.bodyClass\"> \n    <div [innerHtml]=\"context.message\"></div>\n      <div *ngIf=\"context.showInput\" class=\"form-group\">\n        <input autofocus #input\n            name=\"bootstrap\" \n            type=\"text\" \n            class=\"form-control\"\n            [value]=\"context.defaultValue\"\n            (change)=\"context.defaultValue = input.value\"  \n            placeholder=\"{{context.placeholder}}\">\n      </div>\n    </div>\n"
	                    },] },
	        ];
	        /** @nocollapse */
	        BSMessageModalBody.ctorParameters = [
	            { type: angular2Modal.DialogRef, },
	        ];
	        return BSMessageModalBody;
	    }());
	    /**
	     * Represents the modal footer for storing buttons.
	     */
	    var BSModalFooter = (function () {
	        function BSModalFooter(dialog) {
	            this.dialog = dialog;
	        }
	        BSModalFooter.prototype.onClick = function (btn, $event) {
	            $event.stopPropagation();
	            btn.onClick(this, $event);
	        };
	        BSModalFooter.decorators = [
	            { type: _angular_core.Component, args: [{
	                        selector: 'modal-footer',
	                        encapsulation: _angular_core.ViewEncapsulation.None,
	                        template: "<div [ngClass]=\"dialog.context.footerClass\">\n    <button *ngFor=\"let btn of dialog.context.buttons;\"\n            [ngClass]=\"btn.cssClass\"\n            (click)=\"onClick(btn, $event)\">{{btn.caption}}</button>\n</div>"
	                    },] },
	        ];
	        /** @nocollapse */
	        BSModalFooter.ctorParameters = [
	            { type: angular2Modal.DialogRef, },
	        ];
	        return BSModalFooter;
	    }());
	    /**
	     * A Component representing a generic bootstrap modal content element.
	     *
	     * By configuring a MessageModalContext instance you can:
	     *
	     *  Header:
	     *      - Set header container class (default: modal-header)
	     *      - Set title text (enclosed in H3 element)
	     *      - Set title html (overrides text)
	     *
	     *  Body:
	     *      - Set body container class.  (default: modal-body)
	     *      - Set body container HTML.
	     *
	     *  Footer:
	     *      - Set footer class.  (default: modal-footer)
	     *      - Set button configuration (from 0 to n)
	     */
	    var BSMessageModal = (function () {
	        function BSMessageModal(dialog) {
	            this.dialog = dialog;
	        }
	        BSMessageModal.decorators = [
	            { type: _angular_core.Component, args: [{
	                        selector: 'modal-content',
	                        encapsulation: _angular_core.ViewEncapsulation.None,
	                        template: "<modal-title></modal-title><modal-body></modal-body><modal-footer></modal-footer>"
	                    },] },
	        ];
	        /** @nocollapse */
	        BSMessageModal.ctorParameters = [
	            { type: angular2Modal.DialogRef, },
	        ];
	        return BSMessageModal;
	    }());
	    var __extends$2 = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var DEFAULT_VALUES$1 = {
	        component: BSMessageModal,
	        headerClass: 'modal-header',
	        bodyClass: 'modal-body',
	        footerClass: 'modal-footer'
	    };
	    var DEFAULT_SETTERS$1 = [
	        'headerClass',
	        'title',
	        'titleHtml',
	        'bodyClass',
	        'footerClass'
	    ];
	    /**
	     * A Preset representing the configuration needed to open MessageModal.
	     * This is an abstract implementation with no concrete behaviour.
	     * Use derived implementation.
	     */
	    var MessageModalPresetBuilder = (function (_super) {
	        __extends$2(MessageModalPresetBuilder, _super);
	        function MessageModalPresetBuilder(defaultValues, initialSetters, baseType) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            if (initialSetters === void 0) {
	                initialSetters = undefined;
	            }
	            if (baseType === void 0) {
	                baseType = undefined;
	            }
	            _super.call(this, angular2Modal.extend(angular2Modal.extend({ buttons: [] }, DEFAULT_VALUES$1), defaultValues || {}), angular2Modal.arrayUnion(DEFAULT_SETTERS$1, initialSetters || []), baseType);
	            angular2Modal.setAssignAlias(this, 'body', 'message', true);
	        }
	        MessageModalPresetBuilder.prototype.addButton = function (css, caption, onClick) {
	            var btn = {
	                cssClass: css,
	                caption: caption,
	                onClick: onClick
	            };
	            var key = angular2Modal.privateKey('buttons');
	            this[key].push(btn);
	            return this;
	        };
	        return MessageModalPresetBuilder;
	    }(BSModalContextBuilder));
	    var __extends$3 = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * A Preset for a classic 1 button modal window.
	     */
	    var OneButtonPresetBuilder = (function (_super) {
	        __extends$3(OneButtonPresetBuilder, _super);
	        function OneButtonPresetBuilder(modal, defaultValues) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            _super.call(this, angular2Modal.extend({
	                modal: modal,
	                okBtn: 'OK',
	                okBtnClass: 'btn btn-primary'
	            }, defaultValues || {}), [
	                'okBtn',
	                'okBtnClass'
	            ]);
	        }
	        OneButtonPresetBuilder.prototype.$$beforeOpen = function (config) {
	            this.addButton(config.okBtnClass, config.okBtn, function (cmp, $event) { return cmp.dialog.close(true); });
	            return _super.prototype.$$beforeOpen.call(this, config);
	        };
	        return OneButtonPresetBuilder;
	    }(MessageModalPresetBuilder));
	    var __extends$4 = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /** Common two button preset */
	    var AbstractTwoButtonPresetBuilder = (function (_super) {
	        __extends$4(AbstractTwoButtonPresetBuilder, _super);
	        function AbstractTwoButtonPresetBuilder(modal, defaultValues, initialSetters) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            if (initialSetters === void 0) {
	                initialSetters = [];
	            }
	            _super.call(this, angular2Modal.extend({
	                modal: modal,
	                okBtn: 'OK',
	                okBtnClass: 'btn btn-primary',
	                cancelBtn: 'Cancel',
	                cancelBtnClass: 'btn btn-default'
	            }, defaultValues || {}), angular2Modal.arrayUnion([
	                'okBtn',
	                'okBtnClass',
	                'cancelBtn',
	                'cancelBtnClass',
	            ], initialSetters));
	        }
	        AbstractTwoButtonPresetBuilder.prototype.$$beforeOpen = function (config) {
	            this.addButton(config.cancelBtnClass, config.cancelBtn, function (cmp, $event) { return cmp.dialog.dismiss(); });
	            return _super.prototype.$$beforeOpen.call(this, config);
	        };
	        return AbstractTwoButtonPresetBuilder;
	    }(MessageModalPresetBuilder));
	    /**
	     * A Preset for a classic 2 button modal window.
	     */
	    var TwoButtonPresetBuilder = (function (_super) {
	        __extends$4(TwoButtonPresetBuilder, _super);
	        function TwoButtonPresetBuilder(modal, defaultValues) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            _super.call(this, modal, defaultValues);
	        }
	        TwoButtonPresetBuilder.prototype.$$beforeOpen = function (config) {
	            this.addButton(config.okBtnClass, config.okBtn, function (cmp, $event) { return cmp.dialog.close(true); });
	            return _super.prototype.$$beforeOpen.call(this, config);
	        };
	        return TwoButtonPresetBuilder;
	    }(AbstractTwoButtonPresetBuilder));
	    var PromptPresetBuilder = (function (_super) {
	        __extends$4(PromptPresetBuilder, _super);
	        function PromptPresetBuilder(modal, defaultValues) {
	            if (defaultValues === void 0) {
	                defaultValues = undefined;
	            }
	            _super.call(this, modal, angular2Modal.extend({ showInput: true, defaultValue: '' }, defaultValues || {}), ['placeholder', 'defaultValue']);
	        }
	        PromptPresetBuilder.prototype.$$beforeOpen = function (config) {
	            this.addButton(config.okBtnClass, config.okBtn, function (cmp, $event) {
	                return cmp.dialog.close(cmp.dialog.context.defaultValue);
	            });
	            return _super.prototype.$$beforeOpen.call(this, config);
	        };
	        return PromptPresetBuilder;
	    }(AbstractTwoButtonPresetBuilder));
	    var __extends$5 = (undefined && undefined.__extends) || function (d, b) {
	        for (var p in b)
	            if (b.hasOwnProperty(p))
	                d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var Modal$1 = (function (_super) {
	        __extends$5(Modal$$1, _super);
	        function Modal$$1(overlay) {
	            _super.call(this, overlay);
	        }
	        Modal$$1.prototype.alert = function () {
	            return new OneButtonPresetBuilder(this, { isBlocking: false });
	        };
	        Modal$$1.prototype.prompt = function () {
	            return new PromptPresetBuilder(this, { isBlocking: true, keyboard: null });
	        };
	        Modal$$1.prototype.confirm = function () {
	            return new TwoButtonPresetBuilder(this, { isBlocking: true, keyboard: null });
	        };
	        Modal$$1.prototype.create = function (dialogRef, content, bindings) {
	            var _this = this;
	            var backdropRef = this.createBackdrop(dialogRef, angular2Modal.CSSBackdrop);
	            var containerRef = this.createContainer(dialogRef, BSModalContainer, content, bindings);
	            var overlay = dialogRef.overlayRef.instance;
	            var backdrop = backdropRef.instance;
	            var container = containerRef.instance;
	            dialogRef.inElement ? overlay.insideElement() : overlay.fullscreen();
	            // add body class if this is the only dialog in the stack
	            if (!document.body.classList.contains('modal-open')) {
	                document.body.classList.add('modal-open');
	            }
	            if (dialogRef.inElement) {
	                backdrop.setStyle('position', 'absolute');
	            }
	            backdrop.addClass('modal-backdrop fade', true);
	            backdrop.addClass('in');
	            container.addClass('in');
	            if (containerRef.location.nativeElement) {
	                containerRef.location.nativeElement.focus();
	            }
	            overlay.beforeDestroy(function () {
	                var completer = new angular2Modal.PromiseCompleter();
	                backdrop.removeClass('in');
	                container.removeClass('in');
	                backdrop.myAnimationEnd$()
	                    .combineLatest(container.myAnimationEnd$(), function (s1, s2) { return [s1, s2]; })
	                    .subscribe(function (sources) {
	                    _this.overlay.groupStackLength(dialogRef) === 1 && document.body.classList.remove('modal-open');
	                    completer.resolve();
	                });
	                return completer.promise;
	            });
	            return dialogRef;
	        };
	        Modal$$1.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        Modal$$1.ctorParameters = [
	            { type: angular2Modal.Overlay, },
	        ];
	        return Modal$$1;
	    }(angular2Modal.Modal));
	    var providers = [
	        { provide: angular2Modal.Modal, useClass: Modal$1 },
	        { provide: Modal$1, useClass: Modal$1 }
	    ];
	    var BootstrapModalModule = (function () {
	        function BootstrapModalModule() {
	        }
	        BootstrapModalModule.getProviders = function () {
	            return providers;
	        };
	        BootstrapModalModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        imports: [angular2Modal.ModalModule, _angular_common.CommonModule],
	                        declarations: [
	                            BSModalFooter,
	                            BSMessageModalTitle,
	                            BSMessageModalBody,
	                            BSMessageModal,
	                            BSModalContainer
	                        ],
	                        providers: providers,
	                        entryComponents: [
	                            BSModalContainer,
	                            BSMessageModal
	                        ]
	                    },] },
	        ];
	        /** @nocollapse */
	        BootstrapModalModule.ctorParameters = [];
	        return BootstrapModalModule;
	    }());
	    exports.BSModalContext = BSModalContext;
	    exports.BSModalContextBuilder = BSModalContextBuilder;
	    exports.BSModalContainer = BSModalContainer;
	    exports.BSMessageModal = BSMessageModal;
	    exports.BSMessageModalTitle = BSMessageModalTitle;
	    exports.BSMessageModalBody = BSMessageModalBody;
	    exports.BSModalFooter = BSModalFooter;
	    exports.MessageModalPresetBuilder = MessageModalPresetBuilder;
	    exports.ModalOpenContext = angular2Modal.ModalOpenContext;
	    exports.ModalOpenContextBuilder = angular2Modal.ModalOpenContextBuilder;
	    exports.OneButtonPresetBuilder = OneButtonPresetBuilder;
	    exports.TwoButtonPresetBuilder = TwoButtonPresetBuilder;
	    exports.PromptPresetBuilder = PromptPresetBuilder;
	    exports.Modal = Modal$1;
	    exports.BootstrapModalModule = BootstrapModalModule;
	    exports.providers = providers;
	    Object.defineProperty(exports, '__esModule', { value: true });
	})));


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var shared_module_1 = __webpack_require__(63);
	var aggregation_service_1 = __webpack_require__(809);
	var aggregation_task_component_1 = __webpack_require__(907);
	var aggregation_component_1 = __webpack_require__(909);
	var aggregator_list_component_1 = __webpack_require__(910);
	var column_selection_input_component_1 = __webpack_require__(911);
	var export_task_component_1 = __webpack_require__(913);
	var filter_node_component_1 = __webpack_require__(914);
	var simple_filter_node_component_1 = __webpack_require__(915);
	var task_progress_component_1 = __webpack_require__(916);
	var advanced_column_selection_modal_component_1 = __webpack_require__(912);
	var AGGREGATION_ROUTING = router_1.RouterModule.forChild([{ path: "", component: aggregation_component_1.AggregationComponent }]);
	var AggregationModule = (function () {
	    function AggregationModule() {
	    }
	    AggregationModule_1 = AggregationModule;
	    AggregationModule.forRoot = function () {
	        return {
	            ngModule: AggregationModule_1,
	            providers: [aggregation_service_1.AggregationService]
	        };
	    };
	    var AggregationModule_1;
	    AggregationModule = AggregationModule_1 = __decorate([
	        core_1.NgModule({
	            imports: [shared_module_1.SharedModule, AGGREGATION_ROUTING],
	            declarations: [
	                advanced_column_selection_modal_component_1.AdvancedColumnSelectionModalComponent,
	                aggregation_component_1.AggregationComponent,
	                aggregator_list_component_1.AggregatorListComponent,
	                aggregation_task_component_1.AggregationTaskComponent,
	                column_selection_input_component_1.ColumnSelectionInputComponent,
	                export_task_component_1.DataExportTaskComponent,
	                filter_node_component_1.FilterNodeComponent,
	                simple_filter_node_component_1.SimpleFilterNodeComponent,
	                task_progress_component_1.TaskProgressComponent
	            ],
	            entryComponents: [
	                advanced_column_selection_modal_component_1.AdvancedColumnSelectionModalComponent
	            ],
	            exports: [],
	            providers: []
	        })
	    ], AggregationModule);
	    return AggregationModule;
	}());
	exports.AggregationModule = AggregationModule;


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var http_1 = __webpack_require__(66);
	var comment_list_component_1 = __webpack_require__(67);
	var checkbox_list_value_accessor_1 = __webpack_require__(729);
	var date_value_accessor_1 = __webpack_require__(730);
	var datetime_value_accessor_1 = __webpack_require__(731);
	var autosize_directive_1 = __webpack_require__(732);
	var boolean_pill_component_1 = __webpack_require__(733);
	var countdown_component_1 = __webpack_require__(734);
	var group_validation_component_1 = __webpack_require__(735);
	var match_frame_content_height_directive_1 = __webpack_require__(736);
	var membership_input_component_1 = __webpack_require__(737);
	var validation_messages_component_1 = __webpack_require__(738);
	var pager_component_1 = __webpack_require__(739);
	var repeat_to_directive_1 = __webpack_require__(741);
	var control_group_component_1 = __webpack_require__(742);
	var copyable_literal_component_1 = __webpack_require__(747);
	var data_sorting_header_component_1 = __webpack_require__(748);
	var typed_control_component_1 = __webpack_require__(749);
	var typed_display_component_1 = __webpack_require__(757);
	var typed_field_component_1 = __webpack_require__(758);
	var force_directed_graph_component_1 = __webpack_require__(760);
	var frequency_chart_component_1 = __webpack_require__(773);
	var preauth_aware_router_link_directive_1 = __webpack_require__(776);
	var spinner_component_1 = __webpack_require__(789);
	var angular2_prettyjson_1 = __webpack_require__(790);
	var COMPONENTS = [
	    boolean_pill_component_1.BooleanPillComponent,
	    checkbox_list_value_accessor_1.CheckboxListValueAccessor,
	    comment_list_component_1.CommentListComponent,
	    control_group_component_1.ControlGroupComponent,
	    countdown_component_1.CountdownComponent,
	    copyable_literal_component_1.CopyableLiteralComponent,
	    data_sorting_header_component_1.DataSortingHeaderComponent,
	    date_value_accessor_1.DateValueAccessor,
	    datetime_value_accessor_1.DatetimeValueAccessor,
	    force_directed_graph_component_1.ForceDirectedGraphComponent,
	    frequency_chart_component_1.FrequencyChartComponent,
	    group_validation_component_1.GroupValidationComponent,
	    membership_input_component_1.MembershipInputComponent,
	    pager_component_1.PagerComponent,
	    preauth_aware_router_link_directive_1.PreauthAwareRouterLink,
	    angular2_prettyjson_1.PrettyJsonComponent,
	    spinner_component_1.SpinnerComponent,
	    typed_control_component_1.TypedControlComponent,
	    typed_display_component_1.TypedDisplayComponent,
	    typed_field_component_1.TypedFieldComponent,
	    validation_messages_component_1.ValidationMessagesComponent,
	];
	var DIRECTIVES = [
	    autosize_directive_1.AutosizeDirective,
	    match_frame_content_height_directive_1.MatchFrameContentHeightDirective,
	    repeat_to_directive_1.RepeatToDirective
	];
	var index_1 = __webpack_require__(790);
	var array_segments_pipe_1 = __webpack_require__(795);
	var bytes_pipe_1 = __webpack_require__(796);
	var calendar_time_pipe_1 = __webpack_require__(797);
	var join_pipe_1 = __webpack_require__(798);
	var keys_pipe_1 = __webpack_require__(799);
	var ordinal_pipe_1 = __webpack_require__(800);
	var paginate_pipe_1 = __webpack_require__(740);
	var percentage_pipe_1 = __webpack_require__(801);
	var plural_pipe_1 = __webpack_require__(802);
	var reverse_pipe_1 = __webpack_require__(803);
	var squash_indices_pipe_1 = __webpack_require__(804);
	var thousands_pipe_1 = __webpack_require__(805);
	var unicode_offset_pipe_1 = __webpack_require__(806);
	var utc_date_pipe_1 = __webpack_require__(807);
	var unsafe_pipe_1 = __webpack_require__(808);
	var PIPES = [
	    array_segments_pipe_1.ArraySegmentsPipe,
	    bytes_pipe_1.BytesPipe,
	    calendar_time_pipe_1.CalendarTimePipe,
	    keys_pipe_1.EntriesPipe,
	    unicode_offset_pipe_1.FlagifyPipe,
	    join_pipe_1.JoinPipe,
	    keys_pipe_1.KeysPipe,
	    ordinal_pipe_1.OrdinalPipe,
	    paginate_pipe_1.PageQueryPipe,
	    paginate_pipe_1.PaginationPipe,
	    percentage_pipe_1.PercentagePipe,
	    plural_pipe_1.PluralizationPipe,
	    index_1.PrettyJsonPipe,
	    reverse_pipe_1.ReversePipe,
	    squash_indices_pipe_1.SquashIndicesPipe,
	    thousands_pipe_1.ThousandsPipe,
	    unicode_offset_pipe_1.UnicodeOffsetPipe,
	    unsafe_pipe_1.UnsafePipe,
	    utc_date_pipe_1.UtcDatePipe
	];
	var SharedModule = (function () {
	    function SharedModule() {
	    }
	    SharedModule = __decorate([
	        core_1.NgModule({
	            imports: [common_1.CommonModule, forms_1.ReactiveFormsModule, http_1.HttpModule],
	            declarations: [COMPONENTS, DIRECTIVES, PIPES],
	            exports: [
	                common_1.CommonModule,
	                http_1.HttpModule,
	                forms_1.ReactiveFormsModule,
	                COMPONENTS,
	                DIRECTIVES,
	                PIPES
	            ]
	        })
	    ], SharedModule);
	    return SharedModule;
	}());
	exports.SharedModule = SharedModule;


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v2.4.10
	 * (c) 2010-2017 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(1), __webpack_require__(5), __webpack_require__(21)) :
	    typeof define === 'function' && define.amd ? define(['exports', '@angular/core', 'rxjs/Observable', '@angular/platform-browser'], factory) :
	    (factory((global.ng = global.ng || {}, global.ng.http = global.ng.http || {}),global.ng.core,global.Rx,global.ng.platformBrowser));
	}(this, function (exports,_angular_core,rxjs_Observable,_angular_platformBrowser) { 'use strict';
	
	    /**
	     * A backend for http that uses the `XMLHttpRequest` browser API.
	     *
	     * Take care not to evaluate this in non-browser contexts.
	     *
	     * \@experimental
	     */
	    var BrowserXhr = (function () {
	        function BrowserXhr() {
	        }
	        /**
	         * @return {?}
	         */
	        BrowserXhr.prototype.build = function () { return ((new XMLHttpRequest())); };
	        BrowserXhr.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        BrowserXhr.ctorParameters = function () { return []; };
	        return BrowserXhr;
	    }());
	
	    var RequestMethod = {};
	    RequestMethod.Get = 0;
	    RequestMethod.Post = 1;
	    RequestMethod.Put = 2;
	    RequestMethod.Delete = 3;
	    RequestMethod.Options = 4;
	    RequestMethod.Head = 5;
	    RequestMethod.Patch = 6;
	    RequestMethod[RequestMethod.Get] = "Get";
	    RequestMethod[RequestMethod.Post] = "Post";
	    RequestMethod[RequestMethod.Put] = "Put";
	    RequestMethod[RequestMethod.Delete] = "Delete";
	    RequestMethod[RequestMethod.Options] = "Options";
	    RequestMethod[RequestMethod.Head] = "Head";
	    RequestMethod[RequestMethod.Patch] = "Patch";
	    var ReadyState = {};
	    ReadyState.Unsent = 0;
	    ReadyState.Open = 1;
	    ReadyState.HeadersReceived = 2;
	    ReadyState.Loading = 3;
	    ReadyState.Done = 4;
	    ReadyState.Cancelled = 5;
	    ReadyState[ReadyState.Unsent] = "Unsent";
	    ReadyState[ReadyState.Open] = "Open";
	    ReadyState[ReadyState.HeadersReceived] = "HeadersReceived";
	    ReadyState[ReadyState.Loading] = "Loading";
	    ReadyState[ReadyState.Done] = "Done";
	    ReadyState[ReadyState.Cancelled] = "Cancelled";
	    var ResponseType = {};
	    ResponseType.Basic = 0;
	    ResponseType.Cors = 1;
	    ResponseType.Default = 2;
	    ResponseType.Error = 3;
	    ResponseType.Opaque = 4;
	    ResponseType[ResponseType.Basic] = "Basic";
	    ResponseType[ResponseType.Cors] = "Cors";
	    ResponseType[ResponseType.Default] = "Default";
	    ResponseType[ResponseType.Error] = "Error";
	    ResponseType[ResponseType.Opaque] = "Opaque";
	    var ContentType = {};
	    ContentType.NONE = 0;
	    ContentType.JSON = 1;
	    ContentType.FORM = 2;
	    ContentType.FORM_DATA = 3;
	    ContentType.TEXT = 4;
	    ContentType.BLOB = 5;
	    ContentType.ARRAY_BUFFER = 6;
	    ContentType[ContentType.NONE] = "NONE";
	    ContentType[ContentType.JSON] = "JSON";
	    ContentType[ContentType.FORM] = "FORM";
	    ContentType[ContentType.FORM_DATA] = "FORM_DATA";
	    ContentType[ContentType.TEXT] = "TEXT";
	    ContentType[ContentType.BLOB] = "BLOB";
	    ContentType[ContentType.ARRAY_BUFFER] = "ARRAY_BUFFER";
	    var ResponseContentType = {};
	    ResponseContentType.Text = 0;
	    ResponseContentType.Json = 1;
	    ResponseContentType.ArrayBuffer = 2;
	    ResponseContentType.Blob = 3;
	    ResponseContentType[ResponseContentType.Text] = "Text";
	    ResponseContentType[ResponseContentType.Json] = "Json";
	    ResponseContentType[ResponseContentType.ArrayBuffer] = "ArrayBuffer";
	    ResponseContentType[ResponseContentType.Blob] = "Blob";
	
	    /**
	     * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
	     * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
	     *
	     * The only known difference between this `Headers` implementation and the spec is the
	     * lack of an `entries` method.
	     *
	     * ### Example
	     *
	     * ```
	     * import {Headers} from '\@angular/http';
	     *
	     * var firstHeaders = new Headers();
	     * firstHeaders.append('Content-Type', 'image/jpeg');
	     * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
	     *
	     * // Create headers from Plain Old JavaScript Object
	     * var secondHeaders = new Headers({
	     *   'X-My-Custom-Header': 'Angular'
	     * });
	     * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
	     *
	     * var thirdHeaders = new Headers(secondHeaders);
	     * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
	     * ```
	     *
	     * \@experimental
	     */
	    var Headers = (function () {
	        /**
	         * @param {?=} headers
	         */
	        function Headers(headers) {
	            var _this = this;
	            /** @internal header names are lower case */
	            this._headers = new Map();
	            /** @internal map lower case names to actual names */
	            this._normalizedNames = new Map();
	            if (!headers) {
	                return;
	            }
	            if (headers instanceof Headers) {
	                headers.forEach(function (values, name) {
	                    values.forEach(function (value) { return _this.append(name, value); });
	                });
	                return;
	            }
	            Object.keys(headers).forEach(function (name) {
	                var values = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
	                _this.delete(name);
	                values.forEach(function (value) { return _this.append(name, value); });
	            });
	        }
	        /**
	         * Returns a new Headers instance from the given DOMString of Response Headers
	         * @param {?} headersString
	         * @return {?}
	         */
	        Headers.fromResponseHeaderString = function (headersString) {
	            var /** @type {?} */ headers = new Headers();
	            headersString.split('\n').forEach(function (line) {
	                var /** @type {?} */ index = line.indexOf(':');
	                if (index > 0) {
	                    var /** @type {?} */ name_1 = line.slice(0, index);
	                    var /** @type {?} */ value = line.slice(index + 1).trim();
	                    headers.set(name_1, value);
	                }
	            });
	            return headers;
	        };
	        /**
	         * Appends a header to existing list of header values for a given header name.
	         * @param {?} name
	         * @param {?} value
	         * @return {?}
	         */
	        Headers.prototype.append = function (name, value) {
	            var /** @type {?} */ values = this.getAll(name);
	            if (values === null) {
	                this.set(name, value);
	            }
	            else {
	                values.push(value);
	            }
	        };
	        /**
	         * Deletes all header values for the given name.
	         * @param {?} name
	         * @return {?}
	         */
	        Headers.prototype.delete = function (name) {
	            var /** @type {?} */ lcName = name.toLowerCase();
	            this._normalizedNames.delete(lcName);
	            this._headers.delete(lcName);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        Headers.prototype.forEach = function (fn) {
	            var _this = this;
	            this._headers.forEach(function (values, lcName) { return fn(values, _this._normalizedNames.get(lcName), _this._headers); });
	        };
	        /**
	         * Returns first header that matches given name.
	         * @param {?} name
	         * @return {?}
	         */
	        Headers.prototype.get = function (name) {
	            var /** @type {?} */ values = this.getAll(name);
	            if (values === null) {
	                return null;
	            }
	            return values.length > 0 ? values[0] : null;
	        };
	        /**
	         * Checks for existence of header by given name.
	         * @param {?} name
	         * @return {?}
	         */
	        Headers.prototype.has = function (name) { return this._headers.has(name.toLowerCase()); };
	        /**
	         * Returns the names of the headers
	         * @return {?}
	         */
	        Headers.prototype.keys = function () { return Array.from(this._normalizedNames.values()); };
	        /**
	         * Sets or overrides header value for given name.
	         * @param {?} name
	         * @param {?} value
	         * @return {?}
	         */
	        Headers.prototype.set = function (name, value) {
	            if (Array.isArray(value)) {
	                if (value.length) {
	                    this._headers.set(name.toLowerCase(), [value.join(',')]);
	                }
	            }
	            else {
	                this._headers.set(name.toLowerCase(), [value]);
	            }
	            this.mayBeSetNormalizedName(name);
	        };
	        /**
	         * Returns values of all headers.
	         * @return {?}
	         */
	        Headers.prototype.values = function () { return Array.from(this._headers.values()); };
	        /**
	         * @return {?}
	         */
	        Headers.prototype.toJSON = function () {
	            var _this = this;
	            var /** @type {?} */ serialized = {};
	            this._headers.forEach(function (values, name) {
	                var /** @type {?} */ split = [];
	                values.forEach(function (v) { return split.push.apply(split, v.split(',')); });
	                serialized[_this._normalizedNames.get(name)] = split;
	            });
	            return serialized;
	        };
	        /**
	         * Returns list of header values for a given name.
	         * @param {?} name
	         * @return {?}
	         */
	        Headers.prototype.getAll = function (name) {
	            return this.has(name) ? this._headers.get(name.toLowerCase()) : null;
	        };
	        /**
	         * This method is not implemented.
	         * @return {?}
	         */
	        Headers.prototype.entries = function () { throw new Error('"entries" method is not implemented on Headers class'); };
	        /**
	         * @param {?} name
	         * @return {?}
	         */
	        Headers.prototype.mayBeSetNormalizedName = function (name) {
	            var /** @type {?} */ lcName = name.toLowerCase();
	            if (!this._normalizedNames.has(lcName)) {
	                this._normalizedNames.set(lcName, name);
	            }
	        };
	        return Headers;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$1 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Creates a response options object to be optionally provided when instantiating a
	     * {\@link Response}.
	     *
	     * This class is based on the `ResponseInit` description in the [Fetch
	     * Spec](https://fetch.spec.whatwg.org/#responseinit).
	     *
	     * All values are null by default. Typical defaults can be found in the
	     * {\@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
	     *
	     * This class may be used in tests to build {\@link Response Responses} for
	     * mock responses (see {\@link MockBackend}).
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/P9Jkk8e8cz6NVzbcxEsD?p=preview))
	     *
	     * ```typescript
	     * import {ResponseOptions, Response} from '\@angular/http';
	     *
	     * var options = new ResponseOptions({
	     *   body: '{"name":"Jeff"}'
	     * });
	     * var res = new Response(options);
	     *
	     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	     * ```
	     *
	     * \@experimental
	     */
	    var ResponseOptions = (function () {
	        /**
	         * @param {?=} __0
	         */
	        function ResponseOptions(_a) {
	            var _b = _a === void 0 ? {} : _a, body = _b.body, status = _b.status, headers = _b.headers, statusText = _b.statusText, type = _b.type, url = _b.url;
	            this.body = body != null ? body : null;
	            this.status = status != null ? status : null;
	            this.headers = headers != null ? headers : null;
	            this.statusText = statusText != null ? statusText : null;
	            this.type = type != null ? type : null;
	            this.url = url != null ? url : null;
	        }
	        /**
	         * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
	         * override
	         * existing values. This method will not change the values of the instance on which it is being
	         * called.
	         *
	         * This may be useful when sharing a base `ResponseOptions` object inside tests,
	         * where certain properties may change from test to test.
	         *
	         * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
	         *
	         * ```typescript
	         * import {ResponseOptions, Response} from '\@angular/http';
	         *
	         * var options = new ResponseOptions({
	         *   body: {name: 'Jeff'}
	         * });
	         * var res = new Response(options.merge({
	         *   url: 'https://google.com'
	         * }));
	         * console.log('options.url:', options.url); // null
	         * console.log('res.json():', res.json()); // Object {name: "Jeff"}
	         * console.log('res.url:', res.url); // https://google.com
	         * ```
	         * @param {?=} options
	         * @return {?}
	         */
	        ResponseOptions.prototype.merge = function (options) {
	            return new ResponseOptions({
	                body: options && options.body != null ? options.body : this.body,
	                status: options && options.status != null ? options.status : this.status,
	                headers: options && options.headers != null ? options.headers : this.headers,
	                statusText: options && options.statusText != null ? options.statusText : this.statusText,
	                type: options && options.type != null ? options.type : this.type,
	                url: options && options.url != null ? options.url : this.url,
	            });
	        };
	        return ResponseOptions;
	    }());
	    /**
	     * Subclass of {\@link ResponseOptions}, with default values.
	     *
	     * Default values:
	     *  * status: 200
	     *  * headers: empty {\@link Headers} object
	     *
	     * This class could be extended and bound to the {\@link ResponseOptions} class
	     * when configuring an {\@link Injector}, in order to override the default options
	     * used by {\@link Http} to create {\@link Response Responses}.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/qv8DLT?p=preview))
	     *
	     * ```typescript
	     * import {provide} from '\@angular/core';
	     * import {bootstrap} from '\@angular/platform-browser/browser';
	     * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
	     * '\@angular/http';
	     * import {App} from './myapp';
	     *
	     * class MyOptions extends BaseResponseOptions {
	     *   headers:Headers = new Headers({network: 'github'});
	     * }
	     *
	     * bootstrap(App, [HTTP_PROVIDERS, {provide: ResponseOptions, useClass: MyOptions}]);
	     * ```
	     *
	     * The options could also be extended when manually creating a {\@link Response}
	     * object.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/VngosOWiaExEtbstDoix?p=preview))
	     *
	     * ```
	     * import {BaseResponseOptions, Response} from '\@angular/http';
	     *
	     * var options = new BaseResponseOptions();
	     * var res = new Response(options.merge({
	     *   body: 'Angular',
	     *   headers: new Headers({framework: 'angular'})
	     * }));
	     * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
	     * console.log('res.text():', res.text()); // Angular;
	     * ```
	     *
	     * \@experimental
	     */
	    var BaseResponseOptions = (function (_super) {
	        __extends$1(BaseResponseOptions, _super);
	        function BaseResponseOptions() {
	            _super.call(this, { status: 200, statusText: 'Ok', type: ResponseType.Default, headers: new Headers() });
	        }
	        BaseResponseOptions.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        BaseResponseOptions.ctorParameters = function () { return []; };
	        return BaseResponseOptions;
	    }(ResponseOptions));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    /**
	     * Abstract class from which real backends are derived.
	     *
	     * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
	     * {\@link Request}.
	     *
	     * \@experimental
	     * @abstract
	     */
	    var ConnectionBackend = (function () {
	        function ConnectionBackend() {
	        }
	        /**
	         * @abstract
	         * @param {?} request
	         * @return {?}
	         */
	        ConnectionBackend.prototype.createConnection = function (request) { };
	        return ConnectionBackend;
	    }());
	    /**
	     * Abstract class from which real connections are derived.
	     *
	     * \@experimental
	     * @abstract
	     */
	    var Connection = (function () {
	        function Connection() {
	        }
	        return Connection;
	    }());
	    /**
	     * An XSRFStrategy configures XSRF protection (e.g. via headers) on an HTTP request.
	     *
	     * \@experimental
	     * @abstract
	     */
	    var XSRFStrategy = (function () {
	        function XSRFStrategy() {
	        }
	        /**
	         * @abstract
	         * @param {?} req
	         * @return {?}
	         */
	        XSRFStrategy.prototype.configureRequest = function (req) { };
	        return XSRFStrategy;
	    }());
	
	    /**
	     * @param {?} method
	     * @return {?}
	     */
	    function normalizeMethodName(method) {
	        if (typeof method !== 'string')
	            return method;
	        switch (method.toUpperCase()) {
	            case 'GET':
	                return RequestMethod.Get;
	            case 'POST':
	                return RequestMethod.Post;
	            case 'PUT':
	                return RequestMethod.Put;
	            case 'DELETE':
	                return RequestMethod.Delete;
	            case 'OPTIONS':
	                return RequestMethod.Options;
	            case 'HEAD':
	                return RequestMethod.Head;
	            case 'PATCH':
	                return RequestMethod.Patch;
	        }
	        throw new Error("Invalid request method. The method \"" + method + "\" is not supported.");
	    }
	    var /** @type {?} */ isSuccess = function (status) { return (status >= 200 && status < 300); };
	    /**
	     * @param {?} xhr
	     * @return {?}
	     */
	    function getResponseURL(xhr) {
	        if ('responseURL' in xhr) {
	            return xhr.responseURL;
	        }
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	            return xhr.getResponseHeader('X-Request-URL');
	        }
	        return;
	    }
	    /**
	     * @param {?} input
	     * @return {?}
	     */
	    function stringToArrayBuffer(input) {
	        var /** @type {?} */ view = new Uint16Array(input.length);
	        for (var /** @type {?} */ i = 0, /** @type {?} */ strLen = input.length; i < strLen; i++) {
	            view[i] = input.charCodeAt(i);
	        }
	        return view.buffer;
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     * @param {?=} rawParams
	     * @return {?}
	     */
	    function paramParser(rawParams) {
	        if (rawParams === void 0) { rawParams = ''; }
	        var /** @type {?} */ map = new Map();
	        if (rawParams.length > 0) {
	            var /** @type {?} */ params = rawParams.split('&');
	            params.forEach(function (param) {
	                var /** @type {?} */ eqIdx = param.indexOf('=');
	                var _a = eqIdx == -1 ? [param, ''] : [param.slice(0, eqIdx), param.slice(eqIdx + 1)], key = _a[0], val = _a[1];
	                var /** @type {?} */ list = map.get(key) || [];
	                list.push(val);
	                map.set(key, list);
	            });
	        }
	        return map;
	    }
	    /**
	     * \@experimental
	     *
	     */
	    var QueryEncoder = (function () {
	        function QueryEncoder() {
	        }
	        /**
	         * @param {?} k
	         * @return {?}
	         */
	        QueryEncoder.prototype.encodeKey = function (k) { return standardEncoding(k); };
	        /**
	         * @param {?} v
	         * @return {?}
	         */
	        QueryEncoder.prototype.encodeValue = function (v) { return standardEncoding(v); };
	        return QueryEncoder;
	    }());
	    /**
	     * @param {?} v
	     * @return {?}
	     */
	    function standardEncoding(v) {
	        return encodeURIComponent(v)
	            .replace(/%40/gi, '@')
	            .replace(/%3A/gi, ':')
	            .replace(/%24/gi, '$')
	            .replace(/%2C/gi, ',')
	            .replace(/%3B/gi, ';')
	            .replace(/%2B/gi, '+')
	            .replace(/%3D/gi, '=')
	            .replace(/%3F/gi, '?')
	            .replace(/%2F/gi, '/');
	    }
	    /**
	     * Map-like representation of url search parameters, based on
	     * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
	     * with several extensions for merging URLSearchParams objects:
	     *   - setAll()
	     *   - appendAll()
	     *   - replaceAll()
	     *
	     * This class accepts an optional second parameter of ${\@link QueryEncoder},
	     * which is used to serialize parameters before making a request. By default,
	     * `QueryEncoder` encodes keys and values of parameters using `encodeURIComponent`,
	     * and then un-encodes certain characters that are allowed to be part of the query
	     * according to IETF RFC 3986: https://tools.ietf.org/html/rfc3986.
	     *
	     * These are the characters that are not encoded: `! $ \' ( ) * + , ; A 9 - . _ ~ ? /`
	     *
	     * If the set of allowed query characters is not acceptable for a particular backend,
	     * `QueryEncoder` can be subclassed and provided as the 2nd argument to URLSearchParams.
	     *
	     * ```
	     * import {URLSearchParams, QueryEncoder} from '\@angular/http';
	     * class MyQueryEncoder extends QueryEncoder {
	     *   encodeKey(k: string): string {
	     *     return myEncodingFunction(k);
	     *   }
	     *
	     *   encodeValue(v: string): string {
	     *     return myEncodingFunction(v);
	     *   }
	     * }
	     *
	     * let params = new URLSearchParams('', new MyQueryEncoder());
	     * ```
	     * \@experimental
	     */
	    var URLSearchParams = (function () {
	        /**
	         * @param {?=} rawParams
	         * @param {?=} queryEncoder
	         */
	        function URLSearchParams(rawParams, queryEncoder) {
	            if (rawParams === void 0) { rawParams = ''; }
	            if (queryEncoder === void 0) { queryEncoder = new QueryEncoder(); }
	            this.rawParams = rawParams;
	            this.queryEncoder = queryEncoder;
	            this.paramsMap = paramParser(rawParams);
	        }
	        /**
	         * @return {?}
	         */
	        URLSearchParams.prototype.clone = function () {
	            var /** @type {?} */ clone = new URLSearchParams('', this.queryEncoder);
	            clone.appendAll(this);
	            return clone;
	        };
	        /**
	         * @param {?} param
	         * @return {?}
	         */
	        URLSearchParams.prototype.has = function (param) { return this.paramsMap.has(param); };
	        /**
	         * @param {?} param
	         * @return {?}
	         */
	        URLSearchParams.prototype.get = function (param) {
	            var /** @type {?} */ storedParam = this.paramsMap.get(param);
	            return Array.isArray(storedParam) ? storedParam[0] : null;
	        };
	        /**
	         * @param {?} param
	         * @return {?}
	         */
	        URLSearchParams.prototype.getAll = function (param) { return this.paramsMap.get(param) || []; };
	        /**
	         * @param {?} param
	         * @param {?} val
	         * @return {?}
	         */
	        URLSearchParams.prototype.set = function (param, val) {
	            if (val === void 0 || val === null) {
	                this.delete(param);
	                return;
	            }
	            var /** @type {?} */ list = this.paramsMap.get(param) || [];
	            list.length = 0;
	            list.push(val);
	            this.paramsMap.set(param, list);
	        };
	        /**
	         * @param {?} searchParams
	         * @return {?}
	         */
	        URLSearchParams.prototype.setAll = function (searchParams) {
	            var _this = this;
	            searchParams.paramsMap.forEach(function (value, param) {
	                var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	                list.length = 0;
	                list.push(value[0]);
	                _this.paramsMap.set(param, list);
	            });
	        };
	        /**
	         * @param {?} param
	         * @param {?} val
	         * @return {?}
	         */
	        URLSearchParams.prototype.append = function (param, val) {
	            if (val === void 0 || val === null)
	                return;
	            var /** @type {?} */ list = this.paramsMap.get(param) || [];
	            list.push(val);
	            this.paramsMap.set(param, list);
	        };
	        /**
	         * @param {?} searchParams
	         * @return {?}
	         */
	        URLSearchParams.prototype.appendAll = function (searchParams) {
	            var _this = this;
	            searchParams.paramsMap.forEach(function (value, param) {
	                var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	                for (var /** @type {?} */ i = 0; i < value.length; ++i) {
	                    list.push(value[i]);
	                }
	                _this.paramsMap.set(param, list);
	            });
	        };
	        /**
	         * @param {?} searchParams
	         * @return {?}
	         */
	        URLSearchParams.prototype.replaceAll = function (searchParams) {
	            var _this = this;
	            searchParams.paramsMap.forEach(function (value, param) {
	                var /** @type {?} */ list = _this.paramsMap.get(param) || [];
	                list.length = 0;
	                for (var /** @type {?} */ i = 0; i < value.length; ++i) {
	                    list.push(value[i]);
	                }
	                _this.paramsMap.set(param, list);
	            });
	        };
	        /**
	         * @return {?}
	         */
	        URLSearchParams.prototype.toString = function () {
	            var _this = this;
	            var /** @type {?} */ paramsList = [];
	            this.paramsMap.forEach(function (values, k) {
	                values.forEach(function (v) { return paramsList.push(_this.queryEncoder.encodeKey(k) + '=' + _this.queryEncoder.encodeValue(v)); });
	            });
	            return paramsList.join('&');
	        };
	        /**
	         * @param {?} param
	         * @return {?}
	         */
	        URLSearchParams.prototype.delete = function (param) { this.paramsMap.delete(param); };
	        return URLSearchParams;
	    }());
	
	    /**
	     * HTTP request body used by both {\@link Request} and {\@link Response}
	     * https://fetch.spec.whatwg.org/#body
	     * @abstract
	     */
	    var Body = (function () {
	        function Body() {
	        }
	        /**
	         * Attempts to return body as parsed `JSON` object, or raises an exception.
	         * @return {?}
	         */
	        Body.prototype.json = function () {
	            if (typeof this._body === 'string') {
	                return JSON.parse(/** @type {?} */ (this._body));
	            }
	            if (this._body instanceof ArrayBuffer) {
	                return JSON.parse(this.text());
	            }
	            return this._body;
	        };
	        /**
	         * Returns the body as a string, presuming `toString()` can be called on the response body.
	         * @return {?}
	         */
	        Body.prototype.text = function () {
	            if (this._body instanceof URLSearchParams) {
	                return this._body.toString();
	            }
	            if (this._body instanceof ArrayBuffer) {
	                return String.fromCharCode.apply(null, new Uint16Array(/** @type {?} */ (this._body)));
	            }
	            if (this._body == null) {
	                return '';
	            }
	            if (typeof this._body === 'object') {
	                return JSON.stringify(this._body, null, 2);
	            }
	            return this._body.toString();
	        };
	        /**
	         * Return the body as an ArrayBuffer
	         * @return {?}
	         */
	        Body.prototype.arrayBuffer = function () {
	            if (this._body instanceof ArrayBuffer) {
	                return (this._body);
	            }
	            return stringToArrayBuffer(this.text());
	        };
	        /**
	         * Returns the request's body as a Blob, assuming that body exists.
	         * @return {?}
	         */
	        Body.prototype.blob = function () {
	            if (this._body instanceof Blob) {
	                return (this._body);
	            }
	            if (this._body instanceof ArrayBuffer) {
	                return new Blob([this._body]);
	            }
	            throw new Error('The request body isn\'t either a blob or an array buffer');
	        };
	        return Body;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$2 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Creates `Response` instances from provided values.
	     *
	     * Though this object isn't
	     * usually instantiated by end-users, it is the primary object interacted with when it comes time to
	     * add data to a view.
	     *
	     * ### Example
	     *
	     * ```
	     * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
	     * ```
	     *
	     * The Response's interface is inspired by the Response constructor defined in the [Fetch
	     * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
	     * can be accessed many times. There are other differences in the implementation, but this is the
	     * most significant.
	     *
	     * \@experimental
	     */
	    var Response = (function (_super) {
	        __extends$2(Response, _super);
	        /**
	         * @param {?} responseOptions
	         */
	        function Response(responseOptions) {
	            _super.call(this);
	            this._body = responseOptions.body;
	            this.status = responseOptions.status;
	            this.ok = (this.status >= 200 && this.status <= 299);
	            this.statusText = responseOptions.statusText;
	            this.headers = responseOptions.headers;
	            this.type = responseOptions.type;
	            this.url = responseOptions.url;
	        }
	        /**
	         * @return {?}
	         */
	        Response.prototype.toString = function () {
	            return "Response with status: " + this.status + " " + this.statusText + " for URL: " + this.url;
	        };
	        return Response;
	    }(Body));
	
	    var /** @type {?} */ _nextRequestId = 0;
	    var /** @type {?} */ JSONP_HOME = '__ng_jsonp__';
	    var /** @type {?} */ _jsonpConnections = null;
	    /**
	     * @return {?}
	     */
	    function _getJsonpConnections() {
	        var /** @type {?} */ w = typeof window == 'object' ? window : {};
	        if (_jsonpConnections === null) {
	            _jsonpConnections = w[JSONP_HOME] = {};
	        }
	        return _jsonpConnections;
	    }
	    var BrowserJsonp = (function () {
	        function BrowserJsonp() {
	        }
	        /**
	         * @param {?} url
	         * @return {?}
	         */
	        BrowserJsonp.prototype.build = function (url) {
	            var /** @type {?} */ node = document.createElement('script');
	            node.src = url;
	            return node;
	        };
	        /**
	         * @return {?}
	         */
	        BrowserJsonp.prototype.nextRequestID = function () { return "__req" + _nextRequestId++; };
	        /**
	         * @param {?} id
	         * @return {?}
	         */
	        BrowserJsonp.prototype.requestCallback = function (id) { return JSONP_HOME + "." + id + ".finished"; };
	        /**
	         * @param {?} id
	         * @param {?} connection
	         * @return {?}
	         */
	        BrowserJsonp.prototype.exposeConnection = function (id, connection) {
	            var /** @type {?} */ connections = _getJsonpConnections();
	            connections[id] = connection;
	        };
	        /**
	         * @param {?} id
	         * @return {?}
	         */
	        BrowserJsonp.prototype.removeConnection = function (id) {
	            var /** @type {?} */ connections = _getJsonpConnections();
	            connections[id] = null;
	        };
	        /**
	         * @param {?} node
	         * @return {?}
	         */
	        BrowserJsonp.prototype.send = function (node) { document.body.appendChild(/** @type {?} */ ((node))); };
	        /**
	         * @param {?} node
	         * @return {?}
	         */
	        BrowserJsonp.prototype.cleanup = function (node) {
	            if (node.parentNode) {
	                node.parentNode.removeChild(/** @type {?} */ ((node)));
	            }
	        };
	        BrowserJsonp.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        BrowserJsonp.ctorParameters = function () { return []; };
	        return BrowserJsonp;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
	    var /** @type {?} */ JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
	    /**
	     * Abstract base class for an in-flight JSONP request.
	     *
	     * \@experimental
	     * @abstract
	     */
	    var JSONPConnection = (function () {
	        function JSONPConnection() {
	        }
	        /**
	         * Callback called when the JSONP request completes, to notify the application
	         * of the new data.
	         * @abstract
	         * @param {?=} data
	         * @return {?}
	         */
	        JSONPConnection.prototype.finished = function (data) { };
	        return JSONPConnection;
	    }());
	    var JSONPConnection_ = (function (_super) {
	        __extends(JSONPConnection_, _super);
	        /**
	         * @param {?} req
	         * @param {?} _dom
	         * @param {?=} baseResponseOptions
	         */
	        function JSONPConnection_(req, _dom, baseResponseOptions) {
	            var _this = this;
	            _super.call(this);
	            this._dom = _dom;
	            this.baseResponseOptions = baseResponseOptions;
	            this._finished = false;
	            if (req.method !== RequestMethod.Get) {
	                throw new TypeError(JSONP_ERR_WRONG_METHOD);
	            }
	            this.request = req;
	            this.response = new rxjs_Observable.Observable(function (responseObserver) {
	                _this.readyState = ReadyState.Loading;
	                var id = _this._id = _dom.nextRequestID();
	                _dom.exposeConnection(id, _this);
	                // Workaround Dart
	                // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
	                var callback = _dom.requestCallback(_this._id);
	                var url = req.url;
	                if (url.indexOf('=JSONP_CALLBACK&') > -1) {
	                    url = url.replace('=JSONP_CALLBACK&', "=" + callback + "&");
	                }
	                else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
	                    url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
	                }
	                var script = _this._script = _dom.build(url);
	                var onLoad = function (event) {
	                    if (_this.readyState === ReadyState.Cancelled)
	                        return;
	                    _this.readyState = ReadyState.Done;
	                    _dom.cleanup(script);
	                    if (!_this._finished) {
	                        var responseOptions_1 = new ResponseOptions({ body: JSONP_ERR_NO_CALLBACK, type: ResponseType.Error, url: url });
	                        if (baseResponseOptions) {
	                            responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
	                        }
	                        responseObserver.error(new Response(responseOptions_1));
	                        return;
	                    }
	                    var responseOptions = new ResponseOptions({ body: _this._responseData, url: url });
	                    if (_this.baseResponseOptions) {
	                        responseOptions = _this.baseResponseOptions.merge(responseOptions);
	                    }
	                    responseObserver.next(new Response(responseOptions));
	                    responseObserver.complete();
	                };
	                var onError = function (error) {
	                    if (_this.readyState === ReadyState.Cancelled)
	                        return;
	                    _this.readyState = ReadyState.Done;
	                    _dom.cleanup(script);
	                    var responseOptions = new ResponseOptions({ body: error.message, type: ResponseType.Error });
	                    if (baseResponseOptions) {
	                        responseOptions = baseResponseOptions.merge(responseOptions);
	                    }
	                    responseObserver.error(new Response(responseOptions));
	                };
	                script.addEventListener('load', onLoad);
	                script.addEventListener('error', onError);
	                _dom.send(script);
	                return function () {
	                    _this.readyState = ReadyState.Cancelled;
	                    script.removeEventListener('load', onLoad);
	                    script.removeEventListener('error', onError);
	                    _this._dom.cleanup(script);
	                };
	            });
	        }
	        /**
	         * @param {?=} data
	         * @return {?}
	         */
	        JSONPConnection_.prototype.finished = function (data) {
	            // Don't leak connections
	            this._finished = true;
	            this._dom.removeConnection(this._id);
	            if (this.readyState === ReadyState.Cancelled)
	                return;
	            this._responseData = data;
	        };
	        return JSONPConnection_;
	    }(JSONPConnection));
	    /**
	     * A {\@link ConnectionBackend} that uses the JSONP strategy of making requests.
	     *
	     * \@experimental
	     * @abstract
	     */
	    var JSONPBackend = (function (_super) {
	        __extends(JSONPBackend, _super);
	        function JSONPBackend() {
	            _super.apply(this, arguments);
	        }
	        return JSONPBackend;
	    }(ConnectionBackend));
	    var JSONPBackend_ = (function (_super) {
	        __extends(JSONPBackend_, _super);
	        /**
	         * @param {?} _browserJSONP
	         * @param {?} _baseResponseOptions
	         */
	        function JSONPBackend_(_browserJSONP, _baseResponseOptions) {
	            _super.call(this);
	            this._browserJSONP = _browserJSONP;
	            this._baseResponseOptions = _baseResponseOptions;
	        }
	        /**
	         * @param {?} request
	         * @return {?}
	         */
	        JSONPBackend_.prototype.createConnection = function (request) {
	            return new JSONPConnection_(request, this._browserJSONP, this._baseResponseOptions);
	        };
	        JSONPBackend_.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        JSONPBackend_.ctorParameters = function () { return [
	            { type: BrowserJsonp, },
	            { type: ResponseOptions, },
	        ]; };
	        return JSONPBackend_;
	    }(JSONPBackend));
	
	    var /** @type {?} */ XSSI_PREFIX = /^\)\]\}',?\n/;
	    /**
	     * Creates connections using `XMLHttpRequest`. Given a fully-qualified
	     * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
	     * request.
	     *
	     * This class would typically not be created or interacted with directly inside applications, though
	     * the {\@link MockConnection} may be interacted with in tests.
	     *
	     * \@experimental
	     */
	    var XHRConnection = (function () {
	        /**
	         * @param {?} req
	         * @param {?} browserXHR
	         * @param {?=} baseResponseOptions
	         */
	        function XHRConnection(req, browserXHR, baseResponseOptions) {
	            var _this = this;
	            this.request = req;
	            this.response = new rxjs_Observable.Observable(function (responseObserver) {
	                var _xhr = browserXHR.build();
	                _xhr.open(RequestMethod[req.method].toUpperCase(), req.url);
	                if (req.withCredentials != null) {
	                    _xhr.withCredentials = req.withCredentials;
	                }
	                // load event handler
	                var onLoad = function () {
	                    // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                    var status = _xhr.status === 1223 ? 204 : _xhr.status;
	                    var body = null;
	                    // HTTP 204 means no content
	                    if (status !== 204) {
	                        // responseText is the old-school way of retrieving response (supported by IE8 & 9)
	                        // response/responseType properties were introduced in ResourceLoader Level2 spec
	                        // (supported by IE10)
	                        body = (typeof _xhr.response === 'undefined') ? _xhr.responseText : _xhr.response;
	                        // Implicitly strip a potential XSSI prefix.
	                        if (typeof body === 'string') {
	                            body = body.replace(XSSI_PREFIX, '');
	                        }
	                    }
	                    // fix status code when it is 0 (0 status is undocumented).
	                    // Occurs when accessing file resources or on Android 4.1 stock browser
	                    // while retrieving files from application cache.
	                    if (status === 0) {
	                        status = body ? 200 : 0;
	                    }
	                    var headers = Headers.fromResponseHeaderString(_xhr.getAllResponseHeaders());
	                    // IE 9 does not provide the way to get URL of response
	                    var url = getResponseURL(_xhr) || req.url;
	                    var statusText = _xhr.statusText || 'OK';
	                    var responseOptions = new ResponseOptions({ body: body, status: status, headers: headers, statusText: statusText, url: url });
	                    if (baseResponseOptions != null) {
	                        responseOptions = baseResponseOptions.merge(responseOptions);
	                    }
	                    var response = new Response(responseOptions);
	                    response.ok = isSuccess(status);
	                    if (response.ok) {
	                        responseObserver.next(response);
	                        // TODO(gdi2290): defer complete if array buffer until done
	                        responseObserver.complete();
	                        return;
	                    }
	                    responseObserver.error(response);
	                };
	                // error event handler
	                var onError = function (err) {
	                    var responseOptions = new ResponseOptions({
	                        body: err,
	                        type: ResponseType.Error,
	                        status: _xhr.status,
	                        statusText: _xhr.statusText,
	                    });
	                    if (baseResponseOptions != null) {
	                        responseOptions = baseResponseOptions.merge(responseOptions);
	                    }
	                    responseObserver.error(new Response(responseOptions));
	                };
	                _this.setDetectedContentType(req, _xhr);
	                if (req.headers == null) {
	                    req.headers = new Headers();
	                }
	                if (!req.headers.has('Accept')) {
	                    req.headers.append('Accept', 'application/json, text/plain, */*');
	                }
	                req.headers.forEach(function (values, name) { return _xhr.setRequestHeader(name, values.join(',')); });
	                // Select the correct buffer type to store the response
	                if (req.responseType != null && _xhr.responseType != null) {
	                    switch (req.responseType) {
	                        case ResponseContentType.ArrayBuffer:
	                            _xhr.responseType = 'arraybuffer';
	                            break;
	                        case ResponseContentType.Json:
	                            _xhr.responseType = 'json';
	                            break;
	                        case ResponseContentType.Text:
	                            _xhr.responseType = 'text';
	                            break;
	                        case ResponseContentType.Blob:
	                            _xhr.responseType = 'blob';
	                            break;
	                        default:
	                            throw new Error('The selected responseType is not supported');
	                    }
	                }
	                _xhr.addEventListener('load', onLoad);
	                _xhr.addEventListener('error', onError);
	                _xhr.send(_this.request.getBody());
	                return function () {
	                    _xhr.removeEventListener('load', onLoad);
	                    _xhr.removeEventListener('error', onError);
	                    _xhr.abort();
	                };
	            });
	        }
	        /**
	         * @param {?} req
	         * @param {?} _xhr
	         * @return {?}
	         */
	        XHRConnection.prototype.setDetectedContentType = function (req /** TODO Request */, _xhr /** XMLHttpRequest */) {
	            // Skip if a custom Content-Type header is provided
	            if (req.headers != null && req.headers.get('Content-Type') != null) {
	                return;
	            }
	            // Set the detected content type
	            switch (req.contentType) {
	                case ContentType.NONE:
	                    break;
	                case ContentType.JSON:
	                    _xhr.setRequestHeader('content-type', 'application/json');
	                    break;
	                case ContentType.FORM:
	                    _xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	                    break;
	                case ContentType.TEXT:
	                    _xhr.setRequestHeader('content-type', 'text/plain');
	                    break;
	                case ContentType.BLOB:
	                    var /** @type {?} */ blob = req.blob();
	                    if (blob.type) {
	                        _xhr.setRequestHeader('content-type', blob.type);
	                    }
	                    break;
	            }
	        };
	        return XHRConnection;
	    }());
	    /**
	     * `XSRFConfiguration` sets up Cross Site Request Forgery (XSRF) protection for the application
	     * using a cookie. See https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)
	     * for more information on XSRF.
	     *
	     * Applications can configure custom cookie and header names by binding an instance of this class
	     * with different `cookieName` and `headerName` values. See the main HTTP documentation for more
	     * details.
	     *
	     * \@experimental
	     */
	    var CookieXSRFStrategy = (function () {
	        /**
	         * @param {?=} _cookieName
	         * @param {?=} _headerName
	         */
	        function CookieXSRFStrategy(_cookieName, _headerName) {
	            if (_cookieName === void 0) { _cookieName = 'XSRF-TOKEN'; }
	            if (_headerName === void 0) { _headerName = 'X-XSRF-TOKEN'; }
	            this._cookieName = _cookieName;
	            this._headerName = _headerName;
	        }
	        /**
	         * @param {?} req
	         * @return {?}
	         */
	        CookieXSRFStrategy.prototype.configureRequest = function (req) {
	            var /** @type {?} */ xsrfToken = _angular_platformBrowser.__platform_browser_private__.getDOM().getCookie(this._cookieName);
	            if (xsrfToken) {
	                req.headers.set(this._headerName, xsrfToken);
	            }
	        };
	        return CookieXSRFStrategy;
	    }());
	    /**
	     * Creates {\@link XHRConnection} instances.
	     *
	     * This class would typically not be used by end users, but could be
	     * overridden if a different backend implementation should be used,
	     * such as in a node backend.
	     *
	     * ### Example
	     *
	     * ```
	     * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from '\@angular/http';
	     * \@Component({
	     *   viewProviders: [
	     *     HTTP_PROVIDERS,
	     *     {provide: Http, useFactory: (backend, options) => {
	     *       return new Http(backend, options);
	     *     }, deps: [MyNodeBackend, BaseRequestOptions]}]
	     * })
	     * class MyComponent {
	     *   constructor(http:Http) {
	     *     http.request('people.json').subscribe(res => this.people = res.json());
	     *   }
	     * }
	     * ```
	     * \@experimental
	     */
	    var XHRBackend = (function () {
	        /**
	         * @param {?} _browserXHR
	         * @param {?} _baseResponseOptions
	         * @param {?} _xsrfStrategy
	         */
	        function XHRBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy) {
	            this._browserXHR = _browserXHR;
	            this._baseResponseOptions = _baseResponseOptions;
	            this._xsrfStrategy = _xsrfStrategy;
	        }
	        /**
	         * @param {?} request
	         * @return {?}
	         */
	        XHRBackend.prototype.createConnection = function (request) {
	            this._xsrfStrategy.configureRequest(request);
	            return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
	        };
	        XHRBackend.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        XHRBackend.ctorParameters = function () { return [
	            { type: BrowserXhr, },
	            { type: ResponseOptions, },
	            { type: XSRFStrategy, },
	        ]; };
	        return XHRBackend;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$3 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Creates a request options object to be optionally provided when instantiating a
	     * {\@link Request}.
	     *
	     * This class is based on the `RequestInit` description in the [Fetch
	     * Spec](https://fetch.spec.whatwg.org/#requestinit).
	     *
	     * All values are null by default. Typical defaults can be found in the {\@link BaseRequestOptions}
	     * class, which sub-classes `RequestOptions`.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/7Wvi3lfLq41aQPKlxB4O?p=preview))
	     *
	     * ```typescript
	     * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
	     *
	     * var options = new RequestOptions({
	     *   method: RequestMethod.Post,
	     *   url: 'https://google.com'
	     * });
	     * var req = new Request(options);
	     * console.log('req.method:', RequestMethod[req.method]); // Post
	     * console.log('options.url:', options.url); // https://google.com
	     * ```
	     *
	     * \@experimental
	     */
	    var RequestOptions = (function () {
	        /**
	         * @param {?=} __0
	         */
	        function RequestOptions(_a) {
	            var _b = _a === void 0 ? {} : _a, method = _b.method, headers = _b.headers, body = _b.body, url = _b.url, search = _b.search, withCredentials = _b.withCredentials, responseType = _b.responseType;
	            this.method = method != null ? normalizeMethodName(method) : null;
	            this.headers = headers != null ? headers : null;
	            this.body = body != null ? body : null;
	            this.url = url != null ? url : null;
	            this.search =
	                search != null ? (typeof search === 'string' ? new URLSearchParams(search) : search) : null;
	            this.withCredentials = withCredentials != null ? withCredentials : null;
	            this.responseType = responseType != null ? responseType : null;
	        }
	        /**
	         * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
	         * existing values. This method will not change the values of the instance on which it is being
	         * called.
	         *
	         * Note that `headers` and `search` will override existing values completely if present in
	         * the `options` object. If these values should be merged, it should be done prior to calling
	         * `merge` on the `RequestOptions` instance.
	         *
	         * ### Example ([live demo](http://plnkr.co/edit/6w8XA8YTkDRcPYpdB9dk?p=preview))
	         *
	         * ```typescript
	         * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
	         *
	         * var options = new RequestOptions({
	         *   method: RequestMethod.Post
	         * });
	         * var req = new Request(options.merge({
	         *   url: 'https://google.com'
	         * }));
	         * console.log('req.method:', RequestMethod[req.method]); // Post
	         * console.log('options.url:', options.url); // null
	         * console.log('req.url:', req.url); // https://google.com
	         * ```
	         * @param {?=} options
	         * @return {?}
	         */
	        RequestOptions.prototype.merge = function (options) {
	            return new RequestOptions({
	                method: options && options.method != null ? options.method : this.method,
	                headers: options && options.headers != null ? options.headers : new Headers(this.headers),
	                body: options && options.body != null ? options.body : this.body,
	                url: options && options.url != null ? options.url : this.url,
	                search: options && options.search != null ?
	                    (typeof options.search === 'string' ? new URLSearchParams(options.search) :
	                        options.search.clone()) :
	                    this.search,
	                withCredentials: options && options.withCredentials != null ? options.withCredentials :
	                    this.withCredentials,
	                responseType: options && options.responseType != null ? options.responseType :
	                    this.responseType
	            });
	        };
	        return RequestOptions;
	    }());
	    /**
	     * Subclass of {\@link RequestOptions}, with default values.
	     *
	     * Default values:
	     *  * method: {\@link RequestMethod RequestMethod.Get}
	     *  * headers: empty {\@link Headers} object
	     *
	     * This class could be extended and bound to the {\@link RequestOptions} class
	     * when configuring an {\@link Injector}, in order to override the default options
	     * used by {\@link Http} to create and send {\@link Request Requests}.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/LEKVSx?p=preview))
	     *
	     * ```typescript
	     * import {provide} from '\@angular/core';
	     * import {bootstrap} from '\@angular/platform-browser/browser';
	     * import {HTTP_PROVIDERS, Http, BaseRequestOptions, RequestOptions} from '\@angular/http';
	     * import {App} from './myapp';
	     *
	     * class MyOptions extends BaseRequestOptions {
	     *   search: string = 'coreTeam=true';
	     * }
	     *
	     * bootstrap(App, [HTTP_PROVIDERS, {provide: RequestOptions, useClass: MyOptions}]);
	     * ```
	     *
	     * The options could also be extended when manually creating a {\@link Request}
	     * object.
	     *
	     * ### Example ([live demo](http://plnkr.co/edit/oyBoEvNtDhOSfi9YxaVb?p=preview))
	     *
	     * ```
	     * import {BaseRequestOptions, Request, RequestMethod} from '\@angular/http';
	     *
	     * var options = new BaseRequestOptions();
	     * var req = new Request(options.merge({
	     *   method: RequestMethod.Post,
	     *   url: 'https://google.com'
	     * }));
	     * console.log('req.method:', RequestMethod[req.method]); // Post
	     * console.log('options.url:', options.url); // null
	     * console.log('req.url:', req.url); // https://google.com
	     * ```
	     *
	     * \@experimental
	     */
	    var BaseRequestOptions = (function (_super) {
	        __extends$3(BaseRequestOptions, _super);
	        function BaseRequestOptions() {
	            _super.call(this, { method: RequestMethod.Get, headers: new Headers() });
	        }
	        BaseRequestOptions.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        BaseRequestOptions.ctorParameters = function () { return []; };
	        return BaseRequestOptions;
	    }(RequestOptions));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$5 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Creates `Request` instances from provided values.
	     *
	     * The Request's interface is inspired by the Request constructor defined in the [Fetch
	     * Spec](https://fetch.spec.whatwg.org/#request-class),
	     * but is considered a static value whose body can be accessed many times. There are other
	     * differences in the implementation, but this is the most significant.
	     *
	     * `Request` instances are typically created by higher-level classes, like {\@link Http} and
	     * {\@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
	     * One such example is when creating services that wrap higher-level services, like {\@link Http},
	     * where it may be useful to generate a `Request` with arbitrary headers and search params.
	     *
	     * ```typescript
	     * import {Injectable, Injector} from '\@angular/core';
	     * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from '\@angular/http';
	     *
	     * \@Injectable()
	     * class AutoAuthenticator {
	     *   constructor(public http:Http) {}
	     *   request(url:string) {
	     *     return this.http.request(new Request({
	     *       method: RequestMethod.Get,
	     *       url: url,
	     *       search: 'password=123'
	     *     }));
	     *   }
	     * }
	     *
	     * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
	     * var authenticator = injector.get(AutoAuthenticator);
	     * authenticator.request('people.json').subscribe(res => {
	     *   //URL should have included '?password=123'
	     *   console.log('people', res.json());
	     * });
	     * ```
	     *
	     * \@experimental
	     */
	    var Request = (function (_super) {
	        __extends$5(Request, _super);
	        /**
	         * @param {?} requestOptions
	         */
	        function Request(requestOptions) {
	            _super.call(this);
	            // TODO: assert that url is present
	            var url = requestOptions.url;
	            this.url = requestOptions.url;
	            if (requestOptions.search) {
	                var search = requestOptions.search.toString();
	                if (search.length > 0) {
	                    var prefix = '?';
	                    if (this.url.indexOf('?') != -1) {
	                        prefix = (this.url[this.url.length - 1] == '&') ? '' : '&';
	                    }
	                    // TODO: just delete search-query-looking string in url?
	                    this.url = url + prefix + search;
	                }
	            }
	            this._body = requestOptions.body;
	            this.method = normalizeMethodName(requestOptions.method);
	            // TODO(jeffbcross): implement behavior
	            // Defaults to 'omit', consistent with browser
	            this.headers = new Headers(requestOptions.headers);
	            this.contentType = this.detectContentType();
	            this.withCredentials = requestOptions.withCredentials;
	            this.responseType = requestOptions.responseType;
	        }
	        /**
	         * Returns the content type enum based on header options.
	         * @return {?}
	         */
	        Request.prototype.detectContentType = function () {
	            switch (this.headers.get('content-type')) {
	                case 'application/json':
	                    return ContentType.JSON;
	                case 'application/x-www-form-urlencoded':
	                    return ContentType.FORM;
	                case 'multipart/form-data':
	                    return ContentType.FORM_DATA;
	                case 'text/plain':
	                case 'text/html':
	                    return ContentType.TEXT;
	                case 'application/octet-stream':
	                    return this._body instanceof ArrayBuffer$1 ? ContentType.ARRAY_BUFFER : ContentType.BLOB;
	                default:
	                    return this.detectContentTypeFromBody();
	            }
	        };
	        /**
	         * Returns the content type of request's body based on its type.
	         * @return {?}
	         */
	        Request.prototype.detectContentTypeFromBody = function () {
	            if (this._body == null) {
	                return ContentType.NONE;
	            }
	            else if (this._body instanceof URLSearchParams) {
	                return ContentType.FORM;
	            }
	            else if (this._body instanceof FormData) {
	                return ContentType.FORM_DATA;
	            }
	            else if (this._body instanceof Blob$1) {
	                return ContentType.BLOB;
	            }
	            else if (this._body instanceof ArrayBuffer$1) {
	                return ContentType.ARRAY_BUFFER;
	            }
	            else if (this._body && typeof this._body === 'object') {
	                return ContentType.JSON;
	            }
	            else {
	                return ContentType.TEXT;
	            }
	        };
	        /**
	         * Returns the request's body according to its type. If body is undefined, return
	         * null.
	         * @return {?}
	         */
	        Request.prototype.getBody = function () {
	            switch (this.contentType) {
	                case ContentType.JSON:
	                    return this.text();
	                case ContentType.FORM:
	                    return this.text();
	                case ContentType.FORM_DATA:
	                    return this._body;
	                case ContentType.TEXT:
	                    return this.text();
	                case ContentType.BLOB:
	                    return this.blob();
	                case ContentType.ARRAY_BUFFER:
	                    return this.arrayBuffer();
	                default:
	                    return null;
	            }
	        };
	        return Request;
	    }(Body));
	    var /** @type {?} */ noop = function () { };
	    var /** @type {?} */ w = typeof window == 'object' ? window : noop;
	    var /** @type {?} */ FormData = ((w) /** TODO #9100 */)['FormData'] || noop;
	    var /** @type {?} */ Blob$1 = ((w) /** TODO #9100 */)['Blob'] || noop;
	    var /** @type {?} */ ArrayBuffer$1 = ((w) /** TODO #9100 */)['ArrayBuffer'] || noop;
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$4 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * @param {?} backend
	     * @param {?} request
	     * @return {?}
	     */
	    function httpRequest(backend, request) {
	        return backend.createConnection(request).response;
	    }
	    /**
	     * @param {?} defaultOpts
	     * @param {?} providedOpts
	     * @param {?} method
	     * @param {?} url
	     * @return {?}
	     */
	    function mergeOptions(defaultOpts, providedOpts, method, url) {
	        var /** @type {?} */ newOptions = defaultOpts;
	        if (providedOpts) {
	            // Hack so Dart can used named parameters
	            return newOptions.merge(new RequestOptions({
	                method: providedOpts.method || method,
	                url: providedOpts.url || url,
	                search: providedOpts.search,
	                headers: providedOpts.headers,
	                body: providedOpts.body,
	                withCredentials: providedOpts.withCredentials,
	                responseType: providedOpts.responseType
	            }));
	        }
	        return newOptions.merge(new RequestOptions({ method: method, url: url }));
	    }
	    /**
	     * Performs http requests using `XMLHttpRequest` as the default backend.
	     *
	     * `Http` is available as an injectable class, with methods to perform http requests. Calling
	     * `request` returns an `Observable` which will emit a single {\@link Response} when a
	     * response is received.
	     *
	     * ### Example
	     *
	     * ```typescript
	     * import {Http, HTTP_PROVIDERS} from '\@angular/http';
	     * import 'rxjs/add/operator/map'
	     * \@Component({
	     *   selector: 'http-app',
	     *   viewProviders: [HTTP_PROVIDERS],
	     *   templateUrl: 'people.html'
	     * })
	     * class PeopleComponent {
	     *   constructor(http: Http) {
	     *     http.get('people.json')
	     *       // Call map on the response observable to get the parsed people object
	     *       .map(res => res.json())
	     *       // Subscribe to the observable to get the parsed people object and attach it to the
	     *       // component
	     *       .subscribe(people => this.people = people);
	     *   }
	     * }
	     * ```
	     *
	     *
	     * ### Example
	     *
	     * ```
	     * http.get('people.json').subscribe((res:Response) => this.people = res.json());
	     * ```
	     *
	     * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
	     * {\@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
	     * the {\@link XHRBackend} provider, as in the following example:
	     *
	     * ### Example
	     *
	     * ```typescript
	     * import {BaseRequestOptions, Http} from '\@angular/http';
	     * import {MockBackend} from '\@angular/http/testing';
	     * var injector = Injector.resolveAndCreate([
	     *   BaseRequestOptions,
	     *   MockBackend,
	     *   {provide: Http, useFactory:
	     *       function(backend, defaultOptions) {
	     *         return new Http(backend, defaultOptions);
	     *       },
	     *       deps: [MockBackend, BaseRequestOptions]}
	     * ]);
	     * var http = injector.get(Http);
	     * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
	     * ```
	     *
	     * \@experimental
	     */
	    var Http = (function () {
	        /**
	         * @param {?} _backend
	         * @param {?} _defaultOptions
	         */
	        function Http(_backend, _defaultOptions) {
	            this._backend = _backend;
	            this._defaultOptions = _defaultOptions;
	        }
	        /**
	         * Performs any type of http request. First argument is required, and can either be a url or
	         * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	         * object can be provided as the 2nd argument. The options object will be merged with the values
	         * of {\@link BaseRequestOptions} before performing the request.
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.request = function (url, options) {
	            var /** @type {?} */ responseObservable;
	            if (typeof url === 'string') {
	                responseObservable = httpRequest(this._backend, new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url))));
	            }
	            else if (url instanceof Request) {
	                responseObservable = httpRequest(this._backend, url);
	            }
	            else {
	                throw new Error('First argument must be a url string or Request instance.');
	            }
	            return responseObservable;
	        };
	        /**
	         * Performs a request with `get` http method.
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.get = function (url, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url)));
	        };
	        /**
	         * Performs a request with `post` http method.
	         * @param {?} url
	         * @param {?} body
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.post = function (url, body, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Post, url)));
	        };
	        /**
	         * Performs a request with `put` http method.
	         * @param {?} url
	         * @param {?} body
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.put = function (url, body, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Put, url)));
	        };
	        /**
	         * Performs a request with `delete` http method.
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.delete = function (url, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Delete, url)));
	        };
	        /**
	         * Performs a request with `patch` http method.
	         * @param {?} url
	         * @param {?} body
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.patch = function (url, body, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Patch, url)));
	        };
	        /**
	         * Performs a request with `head` http method.
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.head = function (url, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Head, url)));
	        };
	        /**
	         * Performs a request with `options` http method.
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Http.prototype.options = function (url, options) {
	            return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Options, url)));
	        };
	        Http.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        Http.ctorParameters = function () { return [
	            { type: ConnectionBackend, },
	            { type: RequestOptions, },
	        ]; };
	        return Http;
	    }());
	    /**
	     * \@experimental
	     */
	    var Jsonp = (function (_super) {
	        __extends$4(Jsonp, _super);
	        /**
	         * @param {?} backend
	         * @param {?} defaultOptions
	         */
	        function Jsonp(backend, defaultOptions) {
	            _super.call(this, backend, defaultOptions);
	        }
	        /**
	         * Performs any type of http request. First argument is required, and can either be a url or
	         * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
	         * object can be provided as the 2nd argument. The options object will be merged with the values
	         * of {\@link BaseRequestOptions} before performing the request.
	         *
	         * \@security Regular XHR is the safest alternative to JSONP for most applications, and is
	         * supported by all current browsers. Because JSONP creates a `<script>` element with
	         * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
	         * source could expose your application to XSS risks. Data exposed by JSONP may also be
	         * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
	         * future security issues (e.g. content sniffing).  For more detail, see the
	         * [Security Guide](http://g.co/ng/security).
	         * @param {?} url
	         * @param {?=} options
	         * @return {?}
	         */
	        Jsonp.prototype.request = function (url, options) {
	            var /** @type {?} */ responseObservable;
	            if (typeof url === 'string') {
	                url =
	                    new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url)));
	            }
	            if (url instanceof Request) {
	                if (url.method !== RequestMethod.Get) {
	                    throw new Error('JSONP requests must use GET request method.');
	                }
	                responseObservable = httpRequest(this._backend, url);
	            }
	            else {
	                throw new Error('First argument must be a url string or Request instance.');
	            }
	            return responseObservable;
	        };
	        Jsonp.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        Jsonp.ctorParameters = function () { return [
	            { type: ConnectionBackend, },
	            { type: RequestOptions, },
	        ]; };
	        return Jsonp;
	    }(Http));
	
	    /**
	     * @return {?}
	     */
	    function _createDefaultCookieXSRFStrategy() {
	        return new CookieXSRFStrategy();
	    }
	    /**
	     * @param {?} xhrBackend
	     * @param {?} requestOptions
	     * @return {?}
	     */
	    function httpFactory(xhrBackend, requestOptions) {
	        return new Http(xhrBackend, requestOptions);
	    }
	    /**
	     * @param {?} jsonpBackend
	     * @param {?} requestOptions
	     * @return {?}
	     */
	    function jsonpFactory(jsonpBackend, requestOptions) {
	        return new Jsonp(jsonpBackend, requestOptions);
	    }
	    /**
	     * The module that includes http's providers
	     *
	     * \@experimental
	     */
	    var HttpModule = (function () {
	        function HttpModule() {
	        }
	        HttpModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        providers: [
	                            // TODO(pascal): use factory type annotations once supported in DI
	                            // issue: https://github.com/angular/angular/issues/3183
	                            { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },
	                            BrowserXhr,
	                            { provide: RequestOptions, useClass: BaseRequestOptions },
	                            { provide: ResponseOptions, useClass: BaseResponseOptions },
	                            XHRBackend,
	                            { provide: XSRFStrategy, useFactory: _createDefaultCookieXSRFStrategy },
	                        ],
	                    },] },
	        ];
	        /** @nocollapse */
	        HttpModule.ctorParameters = function () { return []; };
	        return HttpModule;
	    }());
	    /**
	     * The module that includes jsonp's providers
	     *
	     * \@experimental
	     */
	    var JsonpModule = (function () {
	        function JsonpModule() {
	        }
	        JsonpModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        providers: [
	                            // TODO(pascal): use factory type annotations once supported in DI
	                            // issue: https://github.com/angular/angular/issues/3183
	                            { provide: Jsonp, useFactory: jsonpFactory, deps: [JSONPBackend, RequestOptions] },
	                            BrowserJsonp,
	                            { provide: RequestOptions, useClass: BaseRequestOptions },
	                            { provide: ResponseOptions, useClass: BaseResponseOptions },
	                            { provide: JSONPBackend, useClass: JSONPBackend_ },
	                        ],
	                    },] },
	        ];
	        /** @nocollapse */
	        JsonpModule.ctorParameters = function () { return []; };
	        return JsonpModule;
	    }());
	
	    /**
	     * @stable
	     */
	    var /** @type {?} */ VERSION = new _angular_core.Version('2.4.10');
	
	    exports.BrowserXhr = BrowserXhr;
	    exports.JSONPBackend = JSONPBackend;
	    exports.JSONPConnection = JSONPConnection;
	    exports.CookieXSRFStrategy = CookieXSRFStrategy;
	    exports.XHRBackend = XHRBackend;
	    exports.XHRConnection = XHRConnection;
	    exports.BaseRequestOptions = BaseRequestOptions;
	    exports.RequestOptions = RequestOptions;
	    exports.BaseResponseOptions = BaseResponseOptions;
	    exports.ResponseOptions = ResponseOptions;
	    exports.ReadyState = ReadyState;
	    exports.RequestMethod = RequestMethod;
	    exports.ResponseContentType = ResponseContentType;
	    exports.ResponseType = ResponseType;
	    exports.Headers = Headers;
	    exports.Http = Http;
	    exports.Jsonp = Jsonp;
	    exports.HttpModule = HttpModule;
	    exports.JsonpModule = JsonpModule;
	    exports.Connection = Connection;
	    exports.ConnectionBackend = ConnectionBackend;
	    exports.XSRFStrategy = XSRFStrategy;
	    exports.Request = Request;
	    exports.Response = Response;
	    exports.QueryEncoder = QueryEncoder;
	    exports.URLSearchParams = URLSearchParams;
	    exports.VERSION = VERSION;
	
	}));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var intake_step_1 = __webpack_require__(68);
	var comment_1 = __webpack_require__(209);
	var comment_service_1 = __webpack_require__(212);
	var CommentListComponent = (function () {
	    function CommentListComponent(commentService) {
	        this.commentService = commentService;
	        this.showNewForm = true;
	        this.showComments = true;
	        this.smaller = false;
	        this.newComment = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newVisibility = new forms_1.FormControl(comment_1.Visibility.GroupOnly, forms_1.Validators.required);
	        this.visibilityControls = [];
	        this.visibilityOptions = [
	            { value: comment_1.Visibility.Public, label: "Public" },
	            { value: comment_1.Visibility.GroupOnly, label: "My Groups" },
	            { value: comment_1.Visibility.SelfOnly, label: "Only Me" }
	        ];
	        this.editingAny = false;
	    }
	    Object.defineProperty(CommentListComponent.prototype, "comments", {
	        set: function (c) {
	            if (!Array.isArray(c)) {
	                this._comments = [];
	                return;
	            }
	            this._comments = c.sort(function (a, b) { return a.created - b.created; });
	            this.generateVisibilityControls();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CommentListComponent.prototype.generateVisibilityControls = function () {
	        var _this = this;
	        this._comments.forEach(function (c) {
	            c.visControl = new forms_1.FormControl({ value: _this.visibilityFor(c), disabled: !c.editable });
	            c.visControl.valueChanges.subscribe(function (v) { return _this.changeVisibility(c, v); });
	        });
	    };
	    CommentListComponent.prototype.ngOnInit = function () {
	        this.form = new forms_1.FormGroup({
	            newComment: this.newComment,
	            newVisibility: this.newVisibility
	        });
	        this.registeredName =
	            ((this.parent instanceof intake_step_1.IntakeStep) ? "" + this.parent.id : "context");
	        this.commentService.globalForm.addControl(this.registeredName, this.form);
	    };
	    CommentListComponent.prototype.ngOnDestroy = function () {
	        this.commentService.globalForm.removeControl(this.registeredName);
	    };
	    CommentListComponent.prototype.addComment = function () {
	        var _this = this;
	        if (this.newComment.invalid) {
	            return;
	        }
	        if (this.newVisibility.invalid) {
	            return alert("You must select a visibility level for the comment.");
	        }
	        var text = this.newComment.value;
	        var vis = this.newVisibility.value;
	        console.log("adding with vis", vis, (typeof vis));
	        var commentResult = (this.parent instanceof intake_step_1.IntakeStep)
	            ? this.commentService.addForStep(this.parent.id, text, vis)
	            : this.commentService.addForSubject(text, vis);
	        commentResult.subscribe(function (added) {
	            if (!added) {
	                console.error("Unable to post comment!");
	            }
	            else {
	                _this.newComment.reset();
	                _this.newVisibility.reset(comment_1.Visibility.GroupOnly);
	            }
	        });
	    };
	    CommentListComponent.prototype.edit = function (comment) {
	        var _this = this;
	        if (!comment.editing) {
	            if (this.editingAny) {
	                return;
	            }
	            this.createControl(comment);
	            comment.editing = true;
	            this.editingAny = true;
	            return;
	        }
	        var control = this.form.controls["c" + comment.commentId];
	        if (control.invalid) {
	            return alert("You cannot submit a blank comment.");
	        }
	        var updatedComment = Object.assign(new comment_1.Comment(), comment, { comment: "" + control.value });
	        var updateResult = (this.parent instanceof intake_step_1.IntakeStep)
	            ? this.commentService.updateForStep(this.parent.id, updatedComment)
	            : this.commentService.updateForSubject(updatedComment);
	        updateResult.subscribe(function (updated) {
	            if (updated) {
	                comment.editing = false;
	                control.markAsPristine();
	                _this.editingAny = _this._comments.some(function (c) { return c.editing; });
	            }
	            else {
	                console.error("Unable to edit comment!");
	            }
	        });
	    };
	    CommentListComponent.prototype.changeVisibility = function (comment, vis) {
	        console.log(comment);
	        console.log(vis, (typeof vis));
	        var toggleResult = (this.parent instanceof intake_step_1.IntakeStep)
	            ? this.commentService.updateForStep(this.parent.id, comment, vis)
	            : this.commentService.updateForSubject(comment, vis);
	        toggleResult.subscribe(function (updated) {
	            if (!updated) {
	                console.error("Unable to change comment visitbility!");
	            }
	        });
	    };
	    CommentListComponent.prototype.delete = function (comment) {
	        var deleteResult = (this.parent instanceof intake_step_1.IntakeStep)
	            ? this.commentService.removeForStep(this.parent.id, comment)
	            : this.commentService.removeForSubject(comment);
	        deleteResult.subscribe(function (deleted) {
	            if (!deleted) {
	                console.error("Unable to delete comment!");
	            }
	        });
	    };
	    CommentListComponent.prototype.createControl = function (comment) {
	        this.form.setControl("c" + comment.commentId, new forms_1.FormControl(comment.comment, forms_1.Validators.required));
	    };
	    CommentListComponent.prototype.visibilityFor = function (comment) {
	        return comment_1.Comment.visibilityOf(comment);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CommentListComponent.prototype, "showNewForm", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CommentListComponent.prototype, "showComments", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], CommentListComponent.prototype, "comments", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", intake_step_1.IntakeStep)
	    ], CommentListComponent.prototype, "parent", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CommentListComponent.prototype, "smaller", void 0);
	    CommentListComponent = __decorate([
	        core_1.Component({
	            selector: "comment-list",
	            template: "\n  <form [formGroup]=\"form\">\n  <template [ngIf]=\"showComments\">\n    <div *ngFor=\"let comment of _comments; let i = index\" class=\"comment-block\">\n      <!-- Upper labels (author, group) -->\n      <div class=\"comment-labels\">\n        <strong>{{comment.creator}}</strong>\n        <span> [{{comment.org}}]</span>\n        <span class=\"pull-right\"></span>\n      </div>\n      <!-- Comment body -->\n      <div\n        *ngIf=\"!comment.editing\"\n        class=\"comment autohyphen\"\n        [class.bg-danger]=\"comment.public\"\n        [class.bg-success]=\"!comment.groupIds?.length\"\n        >{{comment.comment}}</div>\n      <textarea\n        *ngIf=\"comment.editing\"\n        class=\"comment\"\n        [class.bg-danger]=\"comment.public\"\n        [formControlName]=\"'c' + comment.commentId\"\n        (blur)=\"edit(comment)\">\n      </textarea>\n      <!-- Lower labels (visibility, buttons, timestamp) -->\n      <div class=\"text-right comment-labels\">\n        <small class=\"visibility\">\n          <span *ngIf=\"!smaller\">Visibility:</span>\n          <select [formControl]=\"comment.visControl\">\n            <option *ngFor=\"let opt of visibilityOptions\" [ngValue]=\"opt.value\">\n              {{opt.label}}\n            </option>\n          </select>\n        </small>\n        <span\n          *ngIf=\"comment.editable && (!editingAny || comment.editing)\"\n          class=\"comment-edits\">\n          <a\n            *ngIf=\"!comment.editing\"\n            (click)=\"edit(comment)\">\n            <span *ngIf=\"!smaller\">\n              {{comment.editing ? \"(Editing)\" : \"Edit\"}}\n            </span>\n            <span\n              *ngIf=\"smaller\"\n              class=\"glyphicon\"\n              [class.glyphicon-pencil]=\"!comment.editing\"\n              [class.glyphicon-option-horizontal]=\"comment.editing\">\n            </span>\n          </a>\n          <a (click)=\"delete(comment)\" class=\"text-danger\">\n            <span *ngIf=\"!smaller\">Delete</span>\n            <span\n              *ngIf=\"smaller\"\n              class=\"glyphicon glyphicon-trash\">\n            </span>\n          </a>\n        </span>\n        <br *ngIf=\"smaller\">\n        {{comment.created | date:'short'}}\n        <strong *ngIf=\"comment.created !== comment.updated\">*</strong>\n      </div>\n    </div>\n  </template>\n\n  <!-- New comment form field -->\n  <div class=\"new-comment\" *ngIf=\"showNewForm\">\n    <textarea\n      class=\"form-control\"\n      formControlName=\"newComment\"\n      placeholder=\"New comment\"\n      tabindex=\"-1\"\n      (blur)=\"addComment()\">\n    </textarea>\n    <table *ngIf=\"!smaller\">\n      <tr>\n        <td style=\"width: 80px\">\n          <label>Visibility:</label>\n        </td>\n        <td>\n          <select\n            formControlName=\"newVisibility\"\n            class=\"form-control\"\n            tabindex=\"-1\">\n            <option *ngFor=\"let opt of visibilityOptions\" [ngValue]=\"opt.value\">\n              {{opt.label}}\n            </option>\n          </select>\n        </td>\n        <!--<td>\n          <button\n            class=\"btn btn-primary form-control\"\n            (click)=\"addComment()\"\n            tabindex=\"-1\"\n            [disabled]=\"editingAny\">\n            Add\n          </button>\n        </td>-->\n      </tr>\n    </table>\n    <template [ngIf]=\"smaller\">\n      <select\n        formControlName=\"newVisibility\"\n        class=\"form-control\"\n        tabindex=\"-1\">\n        <option *ngFor=\"let opt of visibilityOptions\" [ngValue]=\"opt.value\">\n          {{opt.label}}\n        </option>\n      </select>\n      <button\n          class=\"btn btn-primary form-control\"\n          (click)=\"addComment()\"\n          tabindex=\"-1\">\n          Add\n      </button>\n    </template>\n  </div>\n  </form>\n",
	            styles: [
	                "\n    .comment-labels>* {\n      padding: 5px;\n    }\n    .comment-labels .pull-right {\n      padding-top: 0px;\n    }\n    .comment {\n      white-space: pre-wrap; /* preserve newlines/etc in comment context */\n      padding: 10px;\n      background-color: #f5f5f5;\n      border-radius: 10px;\n      width: 100%;\n    }\n    textarea.comment {\n      resize: vertical;\n    }\n    .comment.bg-danger {\n      background-color: #f2dede;\n    }\n    .comment.bg-success {\n      background-color: #dff0d8;\n    }\n    .comment-block {\n      margin-bottom: 1em;\n    }\n    .new-comment {\n      margin-bottom: 1em;\n    }\n    .new-comment textarea {\n      border-radius: 10px;\n      background-color: #f5f5f5;\n      resize: vertical;\n    }\n    table {\n      width: 100%;\n      text-align: right;\n      vertical-align: middle;\n    }\n    table td {\n      padding: 5px;\n    }\n    table label {\n      margin-bottom: 0;\n    }\n    "
	            ]
	        }),
	        __metadata("design:paramtypes", [comment_service_1.CommentService])
	    ], CommentListComponent);
	    return CommentListComponent;
	}());
	exports.CommentListComponent = CommentListComponent;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var typed_data_1 = __webpack_require__(69);
	var comment_1 = __webpack_require__(209);
	var algorithm_step_1 = __webpack_require__(210);
	var intake_answer_1 = __webpack_require__(211);
	var IntakeStep = (function (_super) {
	    __extends(IntakeStep, _super);
	    function IntakeStep(data) {
	        var _this = _super.call(this, data) || this;
	        _this.isActive = true;
	        _this.searchable = false;
	        _this.differsFromOriginalValue = false;
	        _this.order = data.order;
	        _this.type = data.type;
	        _this.cardinality = data.cardinality;
	        _this.allowsDuplicates = data.allowsDuplicates;
	        _this.restrictions = data.restrictions || [];
	        _this.comments = (data.comments || []).map(comment_1.Comment.fromData);
	        _this.searchable = data.searchable || false;
	        _this.differsFromOriginalValue = data.differsFromOriginalValue || false;
	        if (data.value !== undefined && data.value !== null) {
	            _this.value = typed_data_1.TypedData.deserialize(data);
	        }
	        else {
	            _this.value = null;
	        }
	        return _this;
	    }
	    IntakeStep.prototype.providesMultipleAnswers = function () {
	        return this.cardinality !== 1;
	    };
	    IntakeStep.prototype.completedIntakeStep = function () {
	        var value = typed_data_1.TypedData.serialize(this);
	        return new intake_answer_1.IntakeAnswer(this.id, value);
	    };
	    IntakeStep.prototype.lowerBound = function () {
	        switch (this.type) {
	            case "whole number":
	                return 0;
	            case "natural number":
	                return 1;
	            case "integer":
	            case "float":
	                return -Infinity;
	            default:
	                throw new Error("semantic type is nonnumeric");
	        }
	    };
	    IntakeStep.ordered = function (step) {
	        return step.order !== Number.MAX_SAFE_INTEGER;
	    };
	    return IntakeStep;
	}(algorithm_step_1.AlgorithmStep));
	exports.IntakeStep = IntakeStep;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(70);
	var functions_1 = __webpack_require__(206);
	var data_types_1 = __webpack_require__(208);
	var TypedData = (function () {
	    function TypedData(type, value, cardinality, restrictions) {
	        if (type === void 0) { type = "string"; }
	        if (value === void 0) { value = null; }
	        if (cardinality === void 0) { cardinality = 1; }
	        if (restrictions === void 0) { restrictions = []; }
	        this.type = type;
	        this.value = value;
	        this.cardinality = cardinality;
	        this.restrictions = restrictions;
	    }
	    TypedData.applyDefaults = function (data) {
	        if (!Array.isArray(data.restrictions)) {
	            data.restrictions = [];
	        }
	        if (!data.name) {
	            data.name = data.id ? "" + data.id : "UNKNOWN-" + functions_1.randomInt(10000);
	        }
	        if (!Number.isInteger(data.cardinality)) {
	            data.cardinality = 1;
	        }
	        if (data.allowsDuplicates !== false) {
	            data.allowsDuplicates = true;
	        }
	        data.hints = data.hints || {};
	        return true;
	    };
	    TypedData.create = function (holder) {
	        var td = new TypedData();
	        Object.assign(td, holder);
	        return td;
	    };
	    TypedData.prototype.deserialize = function () {
	        this.value = TypedData.deserialize(this);
	    };
	    TypedData.deserialize = function (data) {
	        if (data.value === null) {
	            return null;
	        }
	        var cardinality = (Number.isInteger(data.cardinality) ? data.cardinality : 1);
	        switch (data.type) {
	            case "date":
	            case "datetime":
	                if (cardinality === 1) {
	                    return new Date(+data.value);
	                }
	                else {
	                    if (!Array.isArray(data.value)) {
	                        console.error(data.value);
	                        throw new Error("Multivalued input returned non-array data!");
	                    }
	                    var dates = data.value.map(function (v) {
	                        if (Number.isInteger(v)) {
	                            return new Date(v);
	                        }
	                        if (v === null) {
	                            return null;
	                        }
	                        throw Error("Deserialization failure: " + v + " -> date");
	                    });
	                    return dates;
	                }
	            default:
	                return data.value;
	        }
	    };
	    TypedData.dateToInput = function (value) {
	        return moment(value).utc().format("YYYY-MM-DD");
	    };
	    TypedData.inputToDate = function (input) {
	        var m = moment.utc(input, "YYYY-MM-DD");
	        if (m.isValid()) {
	            return m.toDate();
	        }
	        return null;
	    };
	    TypedData.prototype.serialize = function () {
	        this.value = TypedData.serialize(this);
	    };
	    TypedData.serializeValueBy = function (value, data) {
	        return TypedData.serialize(Object.assign({}, data, { value: value }));
	    };
	    TypedData.serialize = function (data) {
	        if (data.restrictions && data.value === "0: null") {
	            data.value = null;
	            return null;
	        }
	        var cardinality = Number.isInteger(data.cardinality) ? data.cardinality : 1;
	        if (cardinality === 1) {
	            return TypedData.serializeSingle(data.value, data.type);
	        }
	        return TypedData.serializeArray(data.value, data.type, cardinality);
	    };
	    TypedData.serializeArray = function (value, type, cardinality) {
	        if (!Array.isArray(value)) {
	            throw new Error("Data must be an array for multi-valued inputs");
	        }
	        if (cardinality > 1 && cardinality !== value.length) {
	            throw new Error("Data size does not match fixed cardinality");
	        }
	        var results = value.map(function (v) { return TypedData.serializeSingle(v, type); });
	        return results;
	    };
	    TypedData.serializeSingle = function (value, type) {
	        if (value === null) {
	            return null;
	        }
	        switch (type) {
	            case "date":
	                if (!(value instanceof Date)) {
	                    throw new Error("Data claims to be date, but not Date object");
	                }
	                return value.valueOf();
	            case "string":
	                if (value === "") {
	                    return null;
	                }
	                return value;
	            default:
	                return value;
	        }
	    };
	    TypedData.compare = function (a, b) {
	        if (a === null || typeof a !== "object") {
	            return -1;
	        }
	        if (b === null || typeof b !== "object") {
	            return 1;
	        }
	        if (a.type !== b.type || a.cardinality !== b.cardinality) {
	            console.error(a, b);
	            debugger;
	            throw new Error("Cannot compare different types!");
	        }
	        if (a.value === null || a.value === undefined) {
	            return -1;
	        }
	        if (b.value === null || b.value === undefined) {
	            return 1;
	        }
	        if (a.cardinality === -1 || a.cardinality > 1) {
	            return a.value.length - b.value.length;
	        }
	        if (a.type === "string") {
	            return a.value.localeCompare(b.value);
	        }
	        return a.value - b.value;
	    };
	    TypedData.compareIndices = function (arr, a, b) {
	        if (arr.cardinality === 1 || !Array.isArray(arr.value)) {
	            console.error(arr, a, b);
	            throw new Error("Cannot compare indices of non-array data");
	        }
	        var data = arr.value;
	        if (!Number.isInteger(a) || a < 0 || a >= data.length
	            || !Number.isInteger(b) || b < 0 || b >= data.length) {
	            console.error(arr, a, b);
	            throw new Error("Invalid indices for comparison of array data");
	        }
	        if (a === b) {
	            return 0;
	        }
	        if (data[a] === null) {
	            return -1;
	        }
	        if (data[b] === null) {
	            return 1;
	        }
	        if (arr.type === "string") {
	            return data[a].localeCompare(data[b]);
	        }
	        return data[a] - data[b];
	    };
	    TypedData.toString = function (a, value) {
	        if (value === undefined) {
	            value = a.value;
	        }
	        switch (a.type) {
	            case "boolean":
	                return (value ? "true" : "false");
	            case "date":
	                return moment.utc(value).format("MM/DD/YYYY");
	            default:
	                return "" + value;
	        }
	    };
	    TypedData.hasProperties = function (tvLike) {
	        return (tvLike !== null && typeof tvLike === 'object' && data_types_1.SERVER_TYPES.includes(tvLike.type) && "value" in tvLike);
	    };
	    TypedData.guessType = function (value) {
	        switch (typeof value) {
	            case "boolean":
	                return "boolean";
	            case "string":
	                return "string";
	            case "number":
	                return "float";
	            case "object":
	                return undefined;
	        }
	    };
	    return TypedData;
	}());
	exports.TypedData = TypedData;


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var assertions_1 = __webpack_require__(207);
	function compose(f, g) {
	    return function (a) { return f(g(a)); };
	}
	exports.compose = compose;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function inverse(x) {
	    return !x;
	}
	exports.inverse = inverse;
	function inverted(fn) {
	    return function (t) { return (inverse(fn(t))); };
	}
	exports.inverted = inverted;
	function oneline(literals) {
	    var keys = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        keys[_i - 1] = arguments[_i];
	    }
	    return literals.map(function (literal, i) {
	        return (i < keys.length) ? (literal + ("" + keys[i])) : literal;
	    }).join("").replace(/\n\s*/g, " ").replace(/^\s*/, "");
	}
	exports.oneline = oneline;
	function arrayRemove(arr, item) {
	    assertions_1.assertArray(arr);
	    var i = arr.indexOf(item);
	    if (i === -1) {
	        throw new Error("Can only remove entries that exist in array");
	    }
	    arr.splice(i, 1);
	    return arr;
	}
	exports.arrayRemove = arrayRemove;
	function arraySwap(arr, i, j) {
	    if (j === void 0) { j = (i + 1); }
	    assertions_1.assertArray(arr);
	    assertions_1.assertIndexInto(i, arr);
	    assertions_1.assertIndexInto(j, arr);
	    var swapped = arr[i];
	    arr[i] = arr[j];
	    arr[j] = swapped;
	    return arr;
	}
	exports.arraySwap = arraySwap;
	function arrayIntersects(a, b) {
	    return a.some(function (x) { return b.indexOf(x) > -1; });
	}
	exports.arrayIntersects = arrayIntersects;
	function arraySubset(sub, sup) {
	    return sub.every(function (val) { return sup.indexOf(val) > -1; });
	}
	exports.arraySubset = arraySubset;
	function deepCopyViaMarshal(x) {
	    return JSON.parse(JSON.stringify(x));
	}
	exports.deepCopyViaMarshal = deepCopyViaMarshal;
	function sequentialPairs(arr) {
	    return arr.reduce(function (prev, curr, i) {
	        if (i % 2 === 0) {
	            prev.push([curr, null]);
	        }
	        else {
	            prev.slice(-1)[0][1] = curr;
	        }
	        return prev;
	    }, []);
	}
	exports.sequentialPairs = sequentialPairs;
	function setEquals(a, b) {
	    if (a === b) {
	        return true;
	    }
	    if (a === null || b === null || a.size !== b.size) {
	        return false;
	    }
	    return Array.from(a).every(function (t) { return b.has(t); });
	}
	exports.setEquals = setEquals;
	function textualList(items, conj) {
	    if (conj === void 0) { conj = "and"; }
	    if (items.length < 2) {
	        return items.join("");
	    }
	    if (items.length === 2) {
	        return items[0] + " " + conj + " " + items[1];
	    }
	    return items.map(function (str, i) {
	        return (i === items.length - 1) ? conj + " " + str : str + ", ";
	    }).join("");
	}
	exports.textualList = textualList;
	function escapeForHTML(text) {
	    return (String(text)
	        .replace(/&/g, "&amp;")
	        .replace(/</g, "&lt;")
	        .replace(/>/g, "&gt;")
	        .replace(/"/g, "&quot;"));
	}
	exports.escapeForHTML = escapeForHTML;
	function insertFactory(compare) {
	    return function (arr, item) {
	        var i;
	        for (i = 0; i < arr.length; i++) {
	            if (compare(item, arr[i]) < 0) {
	                break;
	            }
	        }
	        arr.splice(i, 0, item);
	        return arr;
	    };
	}
	exports.insertFactory = insertFactory;
	function valueless(obj) {
	    return (obj === null || obj === undefined);
	}
	exports.valueless = valueless;
	function valueDefault(obj, fallback) {
	    if (valueless(obj)) {
	        return fallback;
	    }
	    return obj;
	}
	exports.valueDefault = valueDefault;
	function inputless(obj) {
	    return valueless(obj) || obj === "";
	}
	exports.inputless = inputless;
	function emptyObject(obj) {
	    return (typeof obj === "object"
	        && obj !== null
	        && !(obj instanceof Date)
	        && Object.keys(obj).length === 0);
	}
	function emptyArray(obj) {
	    return (Array.isArray(obj) && obj.length === 0);
	}
	function empty(obj) {
	    return inputless(obj) || emptyArray(obj) || emptyObject(obj);
	}
	exports.empty = empty;
	function isNumberString(str) {
	    return (str === ((+str) + ""));
	}
	exports.isNumberString = isNumberString;
	function isIntegerString(str) {
	    return (str === (Number.parseInt(str) + ""));
	}
	exports.isIntegerString = isIntegerString;
	function assert(test, message) {
	    if (!test) {
	        message = message || "assertion failed";
	        throw new Error(message);
	    }
	}
	exports.assert = assert;
	function partition(arr, separator) {
	    var trues = [];
	    var falses = [];
	    arr.forEach(function (value) {
	        if (separator(value)) {
	            trues.push(value);
	        }
	        else {
	            falses.push(value);
	        }
	    });
	    return [trues, falses];
	}
	exports.partition = partition;
	function randomNoun() {
	    var words = [
	        "cat", "dog", "fish", "microscope", "compass",
	        "spectrometer", "thunder", "hail", "sleet", "oceans", "deserts",
	        "arroyo", "adage", "suggestion", "nostalgia", "lemongrass",
	        "pitcher plant", "ghostpipe", "rhythm", "groove", "pocket", "gibberish",
	        "chalkdust", "golf magazine", "wine glass", "t-shirt", "bolo tie",
	        "stockings", "antacid", "Antarctica", "penguin", "table saw",
	        "tennis racket", "murder", "laser", "chess board", "frog", "thermometer",
	        "crop rotation", "rufous-throated honeyeater", "sparkle", "dull pencil",
	        "fire extinguisher", "real estate agent", "riot", "poet"
	    ];
	    return words[Math.floor(Math.random() * words.length)];
	}
	exports.randomNoun = randomNoun;
	function randomInt(limit) {
	    return Math.floor(Math.random() * limit);
	}
	exports.randomInt = randomInt;
	function jsonify(o, objLimit, skipUnderscores) {
	    if (objLimit === void 0) { objLimit = 1000; }
	    if (skipUnderscores === void 0) { skipUnderscores = false; }
	    var objCount = 0;
	    var seenObjects = new WeakSet();
	    return JSON.stringify(o, function (key, value) {
	        if (skipUnderscores && key[0] === "_") {
	            return;
	        }
	        if (typeof value === "object" && value !== null) {
	            if (seenObjects.has(value)) {
	                return "<circular>";
	            }
	            objCount++;
	            if (objCount > objLimit) {
	                return "<object limit>";
	            }
	            try {
	                seenObjects.add(value);
	            }
	            catch (err) {
	                console.error("Could not add to weak set:", value);
	                return "weakset error";
	            }
	        }
	        return value;
	    });
	}
	exports.jsonify = jsonify;
	function assignExcept(target, source, exclusions) {
	    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
	        var key = _a[_i];
	        if (exclusions.indexOf(key) === -1) {
	            target[key] = source[key];
	        }
	    }
	}
	exports.assignExcept = assignExcept;
	function assignOnly(target, source, inclusions) {
	    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
	        var key = _a[_i];
	        if (inclusions.indexOf(key) > -1) {
	            target[key] = source[key];
	        }
	    }
	}
	exports.assignOnly = assignOnly;
	function dot(object, path) {
	    if (typeof path !== "string") {
	        return object;
	    }
	    var segments = path.split(".");
	    var seg;
	    for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
	        seg = segments_1[_i];
	        if (typeof object !== "object") {
	            return null;
	        }
	        object = object[seg];
	    }
	    return object;
	}
	exports.dot = dot;
	function hardEquals(comparator) {
	    return function (x) { return (x === comparator); };
	}
	exports.hardEquals = hardEquals;
	function getOrInit(map, key, init) {
	    if (map.has(key)) {
	        return map.get(key);
	    }
	    else {
	        map.set(key, init);
	        return init;
	    }
	}
	exports.getOrInit = getOrInit;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AssertionError = (function () {
	    function AssertionError(message, logObjects) {
	        if (logObjects === void 0) { logObjects = []; }
	        this.message = message;
	        this.logObjects = logObjects;
	        this.name = "Assertion Error";
	    }
	    return AssertionError;
	}());
	exports.AssertionError = AssertionError;
	function assertBoolean(val) {
	    if (val !== true && val !== false) {
	        throw new AssertionError(val + " is not a boolean!");
	    }
	    return true;
	}
	exports.assertBoolean = assertBoolean;
	function assertString(val) {
	    if (typeof val !== "string") {
	        throw new AssertionError(val + " is not a string!");
	    }
	    return true;
	}
	exports.assertString = assertString;
	function assertDate(val) {
	    if (!(val instanceof Date)) {
	        throw new AssertionError(val + " is not a Date!");
	    }
	    return true;
	}
	exports.assertDate = assertDate;
	function assertInteger(val) {
	    if (!Number.isSafeInteger(val)) {
	        throw new AssertionError(val + " is not a safe integer!", [val]);
	    }
	    return true;
	}
	exports.assertInteger = assertInteger;
	function assertNumber(val) {
	    if (!Number.isFinite(val)) {
	        throw new AssertionError(val + " is not a number!", [val]);
	    }
	    return true;
	}
	exports.assertNumber = assertNumber;
	function assertRange(val, _a) {
	    var min = _a[0], max = _a[1];
	    if ((val < min) || (val > max)) {
	        throw new AssertionError(val + " is outside range " + [min, max] + "!", [val, min, max]);
	    }
	}
	exports.assertRange = assertRange;
	function assertArray(val) {
	    if (!Array.isArray(val)) {
	        throw new AssertionError(val + " is not an array!", [val]);
	    }
	    return true;
	}
	exports.assertArray = assertArray;
	function assertIndexInto(val, target) {
	    assertInteger(val);
	    if (!(val in target)) {
	        throw new AssertionError(val + " is not a valid index for " + target, [val, target]);
	    }
	}
	exports.assertIndexInto = assertIndexInto;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SERVER_TYPES = [
	    "string", "boolean", "date", "float", "integer", "whole number",
	    "natural number"
	];
	exports.IntegerTypes = new Set(["integer", "whole number", "natural number"]);
	exports.NumberTypeOrder = ["natural number", "whole number", "integer", "float"];
	exports.NumberTypes = new Set(exports.NumberTypeOrder);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var typed_data_1 = __webpack_require__(69);
	var CommentType;
	(function (CommentType) {
	    CommentType[CommentType["SubjectContext"] = 0] = "SubjectContext";
	    CommentType[CommentType["IntakeStep"] = 1] = "IntakeStep";
	})(CommentType = exports.CommentType || (exports.CommentType = {}));
	var Visibility;
	(function (Visibility) {
	    Visibility[Visibility["Public"] = 0] = "Public";
	    Visibility[Visibility["GroupOnly"] = 1] = "GroupOnly";
	    Visibility[Visibility["SelfOnly"] = 2] = "SelfOnly";
	})(Visibility = exports.Visibility || (exports.Visibility = {}));
	var Comment = (function () {
	    function Comment() {
	        this.editable = false;
	        this.editing = false;
	        this.public = false;
	    }
	    Object.defineProperty(Comment.prototype, "typedCreated", {
	        get: function () {
	            return new typed_data_1.TypedData("datetime", new Date(+this.created));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Comment.prototype, "typedUpdated", {
	        get: function () {
	            return new typed_data_1.TypedData("datetime", new Date(+this.updated));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Comment.fromData = function (existing) {
	        var comment = new Comment();
	        return Object.assign(comment, existing);
	    };
	    Comment.applyVisibilityToMessage = function (msg, visibility, groupIds) {
	        if (visibility !== Visibility.SelfOnly) {
	            msg.isPublic = (visibility === Visibility.Public);
	            msg.groupIds = groupIds;
	            console.log("visibility", visibility, (typeof visibility));
	            console.log("public?", msg.isPublic);
	        }
	        else {
	            msg.isPublic = false;
	            msg.groupIds = [];
	        }
	    };
	    Comment.visibilityOf = function (comment) {
	        if (comment.groupIds.length === 0) {
	            return Visibility.SelfOnly;
	        }
	        return comment.public ? Visibility.Public : Visibility.GroupOnly;
	    };
	    return Comment;
	}());
	exports.Comment = Comment;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AlgorithmStep = (function () {
	    function AlgorithmStep(data) {
	        this.id = data.id;
	        this.name = data.name;
	        this.displayName = data.displayName;
	        this.classifications = data.classifications;
	        this.hints = data.hints;
	        this.presentation = data.presentation;
	    }
	    return AlgorithmStep;
	}());
	exports.AlgorithmStep = AlgorithmStep;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var IntakeAnswer = (function () {
	    function IntakeAnswer(id, value, provider) {
	        this.id = id;
	        this.value = value;
	        this.provider = provider;
	    }
	    return IntakeAnswer;
	}());
	exports.IntakeAnswer = IntakeAnswer;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var algorithm_service_1 = __webpack_require__(213);
	var user_service_1 = __webpack_require__(713);
	var alert_service_1 = __webpack_require__(689);
	var collaboration_1 = __webpack_require__(592);
	var message_tag_1 = __webpack_require__(515);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var comment_1 = __webpack_require__(209);
	var CommentService = (function () {
	    function CommentService(messaging, alerts, algorithms, users) {
	        var _this = this;
	        this.messaging = messaging;
	        this.alerts = alerts;
	        this.algorithms = algorithms;
	        this.users = users;
	        this.comments = new Map();
	        this.globalForm = new forms_1.FormGroup({});
	        this.changesSinceSave = false;
	        this.selfInitiatedChange = false;
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    CommentService.prototype.clear = function () {
	        this.comments.clear();
	        this.globalForm = new forms_1.FormGroup({});
	        this.changesSinceSave = false;
	        this.selfInitiatedChange = false;
	    };
	    CommentService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(message_tag_1.MessageTag.RSP_COMMENT).subscribe(function (message) { return _this.receiveComments(message); });
	    };
	    CommentService.prototype.disconnected = function () { };
	    CommentService.prototype.receiveComments = function (message) {
	        if (!this.algorithms.isRunning) {
	            throw new Error("Cannot set comments outside of algorithm context");
	        }
	        if (message.commentType === comment_1.CommentType.SubjectContext) {
	            this.algorithms.running.subject.comments = message.comments;
	            if (!this.selfInitiatedChange
	                && !this.algorithms.running.recentlyLaunched) {
	                this.alerts.notify("The comments for the subject context were changed");
	            }
	        }
	        else {
	            this.algorithms.running.steps.comment(message.stepId, message.comments);
	        }
	        this.selfInitiatedChange = false;
	    };
	    CommentService.prototype.getGroupIds = function () {
	        return this.users.self.groupIds();
	    };
	    CommentService.prototype.addForStep = function (stepId, comment, visibility) {
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.DeprecatedAddStepCommentRequest(stepId, comment, visibility, this.getGroupIds()));
	    };
	    CommentService.prototype.addForSubject = function (comment, visibility) {
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.AddCommentRequest(comment, visibility, this.getGroupIds()));
	    };
	    CommentService.prototype.updateForStep = function (stepId, comment, visibility) {
	        if (visibility === void 0) { visibility = comment_1.Comment.visibilityOf(comment); }
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.DeprecatedModifyStepCommentRequest(stepId, comment.commentId, comment.comment, visibility, this.getGroupIds()));
	    };
	    CommentService.prototype.updateForSubject = function (comment, visibility) {
	        if (visibility === void 0) { visibility = comment_1.Comment.visibilityOf(comment); }
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.ModifyCommentRequest(comment.commentId, comment.comment, visibility, this.getGroupIds()));
	    };
	    CommentService.prototype.removeForStep = function (stepId, comment) {
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.DeprecatedDeleteStepCommentRequest(comment.commentId, stepId));
	    };
	    CommentService.prototype.removeForSubject = function (comment) {
	        this.setFlags();
	        return this.messaging.resultOf(new collaboration_1.DeleteCommentRequest(comment.commentId));
	    };
	    CommentService.prototype.setFlags = function () {
	        this.changesSinceSave = true;
	        this.selfInitiatedChange = true;
	    };
	    CommentService.prototype.resetChangeFlag = function () {
	        this.changesSinceSave = false;
	    };
	    CommentService.prototype.hasUnsubmittedContent = function () {
	        if (this.globalForm.dirty) {
	            console.info("Dirty comment forms:", Object.values(this.globalForm.controls).filter(function (f) { return f.dirty; }));
	            return true;
	        }
	        return false;
	    };
	    __decorate([
	        decorators_1.onDisconnect(),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CommentService.prototype, "clear", null);
	    CommentService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService])
	    ], CommentService);
	    return CommentService;
	}());
	exports.CommentService = CommentService;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var Rx_1 = __webpack_require__(214);
	var configuration_service_1 = __webpack_require__(512);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var functions_1 = __webpack_require__(206);
	var algorithm_1 = __webpack_require__(582);
	var running_algorithm_1 = __webpack_require__(695);
	var transformer_service_1 = __webpack_require__(698);
	var setting_service_1 = __webpack_require__(690);
	var AlgorithmService = (function () {
	    function AlgorithmService(messaging, router, config, transformer, settings) {
	        var _this = this;
	        this.messaging = messaging;
	        this.router = router;
	        this.config = config;
	        this.transformer = transformer;
	        this.settings = settings;
	        this.zoneIsAdmin = false;
	        this.subscription = new Rx_1.Subscription();
	        this.ready = new Rx_1.BehaviorSubject(false);
	        this.all = [];
	        this.standard = [];
	        this.createable = [];
	        this.issueReporting = false;
	        this.issueReporters = [];
	        this.referralsEnabled = false;
	        this.referralOrganization = "unknown";
	        this.name = "Unconfigured Zone";
	        this.isRunning = false;
	        this.running = null;
	        this.runningObservable = new Rx_1.BehaviorSubject(null);
	        this.smoothUpdates = this.runningObservable.switchMap(function (r) {
	            return (r === null) ? Rx_1.Observable.never() : r.steps.updates;
	        });
	        this.lockedByComponent = false;
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	        if (this.config.client.type === "admin") {
	            this.zoneIsAdmin = true;
	        }
	        this.runningObservable.subscribe(function (ra) {
	            _this.running = ra;
	            _this.isRunning = !!ra;
	        });
	    }
	    AlgorithmService_1 = AlgorithmService;
	    AlgorithmService.prototype.connected = function () {
	        var _this = this;
	        this.subscription = this.messaging.receive(general_1.MessageTag.RSP_CFG_ZONE)
	            .subscribe(function (msg) {
	            _this.all = msg.algorithms.map(function (alg) {
	                return new algorithm_1.Algorithm(alg.name, alg.type, alg.displayName, alg.description, undefined, alg.supportsIntake, alg.useCustomFlow);
	            });
	            if (msg.supportRequestEnabled) {
	                _this.issueReporting = true;
	                _this.issueReporters = [];
	                _this.all.forEach(function (alg) {
	                    return _this.categorizeByType(alg, msg.supportAlgorithms);
	                });
	                if (!Array.isArray(_this.issueReporters)
	                    || _this.issueReporters.length === 0) {
	                    console.warn("No valid issue reporting algorithms!");
	                }
	            }
	            else {
	                _this.issueReporting = false;
	                _this.issueReporters = [];
	            }
	            _this.referralsEnabled = functions_1.valueDefault(msg.referrals, true);
	            _this.referralOrganization =
	                functions_1.valueDefault(msg.referralOrg, "external agency");
	            _this.standard = _this.all.filter(function (a) { return a.type === algorithm_1.AlgorithmType.Standard; });
	            _this.createable = _this.standard.filter(function (a) { return a.supportsIntake; });
	            _this.name = msg.title;
	            _this.ready.next(true);
	        });
	    };
	    AlgorithmService.prototype.categorizeByType = function (algorithm, supportAlgorithmNames) {
	        if (supportAlgorithmNames.indexOf(algorithm.name) > -1) {
	            algorithm.type = algorithm_1.AlgorithmType.BugReporting;
	            this.issueReporters.push(algorithm);
	        }
	        else {
	            algorithm.type = algorithm_1.AlgorithmType.Standard;
	        }
	    };
	    AlgorithmService.prototype.bySCType = function (sct) {
	        return this.all.filter(function (a) { return a.contextType === sct; });
	    };
	    AlgorithmService.prototype.findAlgorithm = function (name) {
	        return this.all.find(function (alg) { return alg.name === name; }) || null;
	    };
	    AlgorithmService.prototype.findLoosely = function (name) {
	        var lc = name.toLowerCase();
	        return this.all.find(function (alg) {
	            return (alg.displayName.toLowerCase() === lc || alg.name === lc);
	        }) || null;
	    };
	    AlgorithmService.prototype.defaultForOpen = function (sct) {
	        var setting = AlgorithmService_1.OPEN_SETTING_FOR_SCT.get(sct);
	        if (setting) {
	            var name_1 = this.settings.get(setting);
	            if (name_1) {
	                return this.findLoosely(name_1);
	            }
	        }
	        return null;
	    };
	    AlgorithmService.prototype.disconnected = function () { };
	    AlgorithmService.prototype.assertRunning = function () {
	        if (!this.isRunning) {
	            throw new Error("Method expects active running algorithm; none found!");
	        }
	    };
	    AlgorithmService.prototype.lock = function (component) {
	        this.lockedByComponent = true;
	        this.lockingComponent = component;
	        this.running.subject.running = true;
	    };
	    AlgorithmService.prototype.unlock = function () {
	        this.lockedByComponent = false;
	        this.lockingComponent = null;
	        this.running.subject.running = false;
	    };
	    AlgorithmService.prototype.run = function (algorithm, subject) {
	        var _this = this;
	        var next = new running_algorithm_1.RunningAlgorithm(algorithm, subject, this.transformer, this.messaging);
	        var wasLocked = this.lockedByComponent;
	        if (wasLocked) {
	            console.info("Waiting for unlock by current algorithm", this);
	        }
	        return this.release().flatMap(function (released) { return released ? next.start() : [false]; }).do(function (ran) {
	            if (ran) {
	                _this.runningObservable.next(next);
	            }
	        }).map(function (ran) { return [ran, wasLocked]; });
	    };
	    AlgorithmService.prototype.open = function (algorithm, subject) {
	        var _this = this;
	        this.run(algorithm, subject).subscribe(function (_a) {
	            var running = _a[0], wasLocked = _a[1];
	            if (running) {
	                _this.navigateToIntake(wasLocked);
	            }
	        });
	    };
	    AlgorithmService.prototype.navigateToIntake = function (useInterstitial) {
	        var _this = this;
	        if (useInterstitial === void 0) { useInterstitial = false; }
	        if (useInterstitial) {
	            this.router.navigate(["empty"]).then(function (success) {
	                if (success) {
	                    _this.router.navigate(_this.intakeRoute());
	                }
	                else {
	                    console.error("Interstitial page load failed!");
	                }
	            });
	        }
	        else {
	            this.router.navigate(this.intakeRoute());
	        }
	    };
	    AlgorithmService.prototype.intakeRoute = function () {
	        this.assertRunning();
	        if (this.running.algorithm.useCustomFlow
	            || (this.config.client.customFlows && this.config.client.customFlows.includes(this.running.algorithm.name))) {
	            return ["subject", this.running.subject.id, "custom"];
	        }
	        else {
	            return ["subject", this.running.subject.id, this.running.algorithm.name];
	        }
	    };
	    AlgorithmService.prototype.release = function (target) {
	        var _this = this;
	        if (target && target !== this.running) {
	            console.warn("Requested release of a different algorithm");
	            return Rx_1.Observable.empty();
	        }
	        if (this.isRunning) {
	            if (this.lockedByComponent) {
	                return this.lockingComponent.canLeave().flatMap(function (leavable) { return leavable ? _this.running.stop() : [false]; }).do(function (success) {
	                    if (success) {
	                        _this.unlock();
	                        _this.runningObservable.next(null);
	                    }
	                });
	            }
	            return this.running.stop().do(function () {
	                _this.runningObservable.next(null);
	            });
	        }
	        else {
	            console.warn("No active algorithm to release");
	            return Rx_1.Observable.of(true);
	        }
	    };
	    var AlgorithmService_1;
	    AlgorithmService.OPEN_SETTING_FOR_SCT = new Map([
	        ["healthcare benefits", "open button default"]
	    ]);
	    __decorate([
	        decorators_1.disconnectWith("unsubscribe"),
	        __metadata("design:type", Rx_1.Subscription)
	    ], AlgorithmService.prototype, "subscription", void 0);
	    __decorate([
	        decorators_1.disconnectWith("next", false),
	        __metadata("design:type", Rx_1.BehaviorSubject)
	    ], AlgorithmService.prototype, "ready", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AlgorithmService.prototype, "all", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AlgorithmService.prototype, "standard", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AlgorithmService.prototype, "createable", void 0);
	    __decorate([
	        decorators_1.disconnectValue(false),
	        __metadata("design:type", Boolean)
	    ], AlgorithmService.prototype, "issueReporting", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AlgorithmService.prototype, "issueReporters", void 0);
	    __decorate([
	        decorators_1.disconnectValue(false),
	        __metadata("design:type", Boolean)
	    ], AlgorithmService.prototype, "referralsEnabled", void 0);
	    __decorate([
	        decorators_1.disconnectValue("unknown"),
	        __metadata("design:type", String)
	    ], AlgorithmService.prototype, "referralOrganization", void 0);
	    __decorate([
	        decorators_1.disconnectValue("Unconfigured Zone"),
	        __metadata("design:type", String)
	    ], AlgorithmService.prototype, "name", void 0);
	    __decorate([
	        decorators_1.disconnectValue(false),
	        __metadata("design:type", Boolean)
	    ], AlgorithmService.prototype, "isRunning", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", running_algorithm_1.RunningAlgorithm)
	    ], AlgorithmService.prototype, "running", void 0);
	    AlgorithmService = AlgorithmService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            router_1.Router,
	            configuration_service_1.ConfigurationService,
	            transformer_service_1.TransformerService,
	            setting_service_1.SettingService])
	    ], AlgorithmService);
	    return AlgorithmService;
	}());
	exports.AlgorithmService = AlgorithmService;


/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(66);
	var Rx_1 = __webpack_require__(214);
	var ConfigurationService = (function () {
	    function ConfigurationService(http) {
	        var _this = this;
	        this.http = http;
	        this.map = new Map();
	        this.loaded = new Rx_1.BehaviorSubject(false);
	        this.ready = new Rx_1.BehaviorSubject(false);
	        this.injectedTags = [];
	        console.group("App initialization");
	        this.retrieve();
	        this.loaded.first(function (loaded) { return loaded; }).subscribe(function () { return _this.process(); });
	        this.ready.subscribe(function () { return console.groupEnd(); });
	        window.__RECONFIG = this.debugSet.bind(this);
	    }
	    ConfigurationService_1 = ConfigurationService;
	    Object.defineProperty(ConfigurationService.prototype, "client", {
	        get: function () {
	            return this.map.get("client");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConfigurationService.prototype, "protocol", {
	        get: function () {
	            return this.map.get("protocol");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConfigurationService.prototype, "reports", {
	        get: function () {
	            return this.map.get("reports");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConfigurationService.prototype, "settings", {
	        get: function () {
	            return this.map.get("settings");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ConfigurationService.prototype.debugSet = function (category, key, value) {
	        this.map.get(category)[key] = value;
	    };
	    ConfigurationService.prototype.validateLoad = function () {
	        if (this.map.size === ConfigurationService_1.CONFIG_RESOURCES.length) {
	            this.loaded.next(true);
	            return true;
	        }
	        else {
	            this.loaded.next(false);
	            return false;
	        }
	    };
	    ConfigurationService.prototype.retrieve = function () {
	        var _this = this;
	        ConfigurationService_1.CONFIG_RESOURCES.forEach(function (_a) {
	            var name = _a[0], resource = _a[1];
	            return _this.http.get(resource).subscribe(function (r) {
	                var json = r.json();
	                var count = Object.keys(json).length;
	                _this.map.set(name, json);
	                console.info("Loaded " + name + " configuration (" + count + " entries)");
	                if (_this.validateLoad()) {
	                    console.info("Loading complete");
	                }
	            });
	        });
	    };
	    ConfigurationService.prototype.process = function () {
	        try {
	            this.addBrandInjections();
	            if (this.client.allowParameterizedStyles) {
	                this.swapSubstyle();
	            }
	            this.ready.next(true);
	        }
	        catch (err) {
	            this.ready.error(err);
	        }
	    };
	    ConfigurationService.prototype.addBrandInjections = function () {
	        var _this = this;
	        if (Array.isArray(this.client.cssInjections)) {
	            this.client.cssInjections.forEach(function (href) {
	                var e = new HTMLLinkElement();
	                e.href = href;
	                e.rel = "stylesheet";
	                document.head.appendChild(e);
	                _this.injectedTags.push(e);
	            });
	            console.info(this.client.cssInjections.length
	                + "custom stylesheet(s) appended");
	        }
	        if (Array.isArray(this.client.jsInjections)) {
	            this.client.jsInjections.forEach(function (src) {
	                console.warn("Cannot inject " + src + ", scripts not permitted");
	            });
	        }
	    };
	    ConfigurationService.prototype.swapSubstyle = function () {
	        var brandStyles = document.getElementById("brand-styles");
	        if (!brandStyles) {
	            throw new Error("Could not find link element for primary styles");
	        }
	    };
	    ConfigurationService.prototype.done = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            return _this.ready.first(function (ready) { return ready; })
	                .subscribe(function () { return resolve(true); });
	        });
	    };
	    var ConfigurationService_1;
	    ConfigurationService.CONFIG_RESOURCES = [
	        ["client", "/zone/config/client.json"],
	        ["protocol", "/static/config/protocol.json"],
	        ["reports", "/zone/config/reports.json"],
	        ["settings", "/static/config/settings.json"]
	    ];
	    ConfigurationService = ConfigurationService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], ConfigurationService);
	    return ConfigurationService;
	}());
	exports.ConfigurationService = ConfigurationService;
	exports.CONFIG_INITIALIZER = {
	    provide: core_1.APP_INITIALIZER,
	    useFactory: function (config) { return function () { return config.done(); }; },
	    deps: [ConfigurationService],
	    multi: true
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PRIVATE_internal_message_1 = __webpack_require__(514);
	exports.ConnectionFailure = PRIVATE_internal_message_1.ConnectionFailure;
	exports.ConnectionFailureMessage = PRIVATE_internal_message_1.ConnectionFailureMessage;
	exports.InternalMessage = PRIVATE_internal_message_1.InternalMessage;
	var PRIVATE_invalid_message_1 = __webpack_require__(519);
	exports.InvalidMessage = PRIVATE_invalid_message_1.InvalidMessage;
	var acknowledgment_response_1 = __webpack_require__(520);
	exports.AcknowledgmentResponse = acknowledgment_response_1.AcknowledgmentResponse;
	var errors_1 = __webpack_require__(528);
	exports.BadReplyError = errors_1.BadReplyError;
	exports.MessageError = errors_1.MessageError;
	exports.MissingReplyError = errors_1.MissingReplyError;
	exports.ReplyTimeoutError = errors_1.ReplyTimeoutError;
	var incoming_message_1 = __webpack_require__(522);
	exports.IncomingMessage = incoming_message_1.IncomingMessage;
	var message_1 = __webpack_require__(516);
	exports.Message = message_1.Message;
	var reply_message_1 = __webpack_require__(529);
	exports.ReplyMessage = reply_message_1.ReplyMessage;
	exports.ReplyVerifyingMessage = reply_message_1.ReplyVerifyingMessage;
	var response_code_1 = __webpack_require__(527);
	exports.DISCONNECTION_TEXT = response_code_1.DISCONNECTION_TEXT;
	exports.GENERIC_REASON_TEXT = response_code_1.GENERIC_REASON_TEXT;
	exports.ResponseCode = response_code_1.ResponseCode;
	var version_request_1 = __webpack_require__(530);
	exports.VersionRequest = version_request_1.VersionRequest;
	var version_response_1 = __webpack_require__(531);
	exports.VersionResponse = version_response_1.VersionResponse;
	var ping_request_1 = __webpack_require__(532);
	exports.PingRequest = ping_request_1.PingRequest;
	var message_tag_1 = __webpack_require__(515);
	exports.MessageTag = message_tag_1.MessageTag;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_tag_1 = __webpack_require__(515);
	var message_1 = __webpack_require__(516);
	var InternalMessage = (function (_super) {
	    __extends(InternalMessage, _super);
	    function InternalMessage(content) {
	        var _this = _super.call(this) || this;
	        _this.content = content;
	        _this.tag = message_tag_1.MessageTag.PVT_INTERNAL;
	        _this.timestamp = Date.now();
	        return _this;
	    }
	    InternalMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    InternalMessage.prototype.sendable = function () {
	        return false;
	    };
	    InternalMessage.tag = message_tag_1.MessageTag.PVT_INTERNAL;
	    return InternalMessage;
	}(message_1.Message));
	exports.InternalMessage = InternalMessage;
	var ConnectionFailure;
	(function (ConnectionFailure) {
	    ConnectionFailure[ConnectionFailure["NoResponse"] = 0] = "NoResponse";
	})(ConnectionFailure = exports.ConnectionFailure || (exports.ConnectionFailure = {}));
	exports.ConnectionFailureContent = "Connection failed";
	var ConnectionFailureMessage = (function (_super) {
	    __extends(ConnectionFailureMessage, _super);
	    function ConnectionFailureMessage(reason, message) {
	        if (message === void 0) { message = exports.ConnectionFailureContent; }
	        var _this = _super.call(this, message) || this;
	        _this.reason = reason;
	        return _this;
	    }
	    return ConnectionFailureMessage;
	}(InternalMessage));
	exports.ConnectionFailureMessage = ConnectionFailureMessage;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MessageTag;
	(function (MessageTag) {
	    MessageTag[MessageTag["PVT_INTERNAL"] = -1] = "PVT_INTERNAL";
	    MessageTag[MessageTag["PVT_INVALID"] = 0] = "PVT_INVALID";
	    MessageTag[MessageTag["REQ_VERSION"] = 1] = "REQ_VERSION";
	    MessageTag[MessageTag["RSP_VERSION"] = 2] = "RSP_VERSION";
	    MessageTag[MessageTag["RSP_ACKNOWLEDGEMENT"] = 3] = "RSP_ACKNOWLEDGEMENT";
	    MessageTag[MessageTag["PVT_BINARY"] = 4] = "PVT_BINARY";
	    MessageTag[MessageTag["REQ_PING"] = 7] = "REQ_PING";
	    MessageTag[MessageTag["RSP_CFG_USER"] = 8] = "RSP_CFG_USER";
	    MessageTag[MessageTag["RSP_CFG_ZONE"] = 9] = "RSP_CFG_ZONE";
	    MessageTag[MessageTag["REQ_CFG_APP"] = 10] = "REQ_CFG_APP";
	    MessageTag[MessageTag["RSP_CFG_APP"] = 11] = "RSP_CFG_APP";
	    MessageTag[MessageTag["REQ_STATUS_APP"] = 12] = "REQ_STATUS_APP";
	    MessageTag[MessageTag["RSP_STATUS_APP"] = 13] = "RSP_STATUS_APP";
	    MessageTag[MessageTag["REQ_STATUS_CLIENTS"] = 14] = "REQ_STATUS_CLIENTS";
	    MessageTag[MessageTag["RSP_STATUS_CLIENTS"] = 15] = "RSP_STATUS_CLIENTS";
	    MessageTag[MessageTag["REQ_LOGIN"] = 24] = "REQ_LOGIN";
	    MessageTag[MessageTag["REQ_AUTH_TOKEN"] = 25] = "REQ_AUTH_TOKEN";
	    MessageTag[MessageTag["RSP_AUTH_TOKEN"] = 26] = "RSP_AUTH_TOKEN";
	    MessageTag[MessageTag["REQ_AUTH_TOKEN_LOGIN"] = 27] = "REQ_AUTH_TOKEN_LOGIN";
	    MessageTag[MessageTag["UP_DISCONNECT"] = 28] = "UP_DISCONNECT";
	    MessageTag[MessageTag["DOWN_DISCONNECT"] = 29] = "DOWN_DISCONNECT";
	    MessageTag[MessageTag["RSP_ACTIVE_SESSIONS"] = 30] = "RSP_ACTIVE_SESSIONS";
	    MessageTag[MessageTag["REQ_TERMINATE_ACTIVE_SESSIONS"] = 31] = "REQ_TERMINATE_ACTIVE_SESSIONS";
	    MessageTag[MessageTag["RSP_WATCHLIST"] = 32] = "RSP_WATCHLIST";
	    MessageTag[MessageTag["REQ_WATCH_SUBJECT_CONTEXT"] = 33] = "REQ_WATCH_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["RSP_WATCHLIST_ITEM_UPDATED"] = 34] = "RSP_WATCHLIST_ITEM_UPDATED";
	    MessageTag[MessageTag["REQ_WATCHLIST_ITEM"] = 35] = "REQ_WATCHLIST_ITEM";
	    MessageTag[MessageTag["REQ_STOP_WATCHING"] = 36] = "REQ_STOP_WATCHING";
	    MessageTag[MessageTag["RSP_STOP_WATCHING"] = 37] = "RSP_STOP_WATCHING";
	    MessageTag[MessageTag["REQ_EDIT_WATCHLIST_ITEM"] = 38] = "REQ_EDIT_WATCHLIST_ITEM";
	    MessageTag[MessageTag["REQ_REFRESH_WATCHLIST_ITEM"] = 39] = "REQ_REFRESH_WATCHLIST_ITEM";
	    MessageTag[MessageTag["REQ_ACKNOWLEDGE_WATCHLIST_ALERT"] = 40] = "REQ_ACKNOWLEDGE_WATCHLIST_ALERT";
	    MessageTag[MessageTag["REQ_GROUP_WORKLISTS"] = 41] = "REQ_GROUP_WORKLISTS";
	    MessageTag[MessageTag["RSP_GROUP_WORKLISTS"] = 42] = "RSP_GROUP_WORKLISTS";
	    MessageTag[MessageTag["REQ_SHARED_WORKLIST"] = 43] = "REQ_SHARED_WORKLIST";
	    MessageTag[MessageTag["REQ_CREATE_SHARED_WORKLIST"] = 44] = "REQ_CREATE_SHARED_WORKLIST";
	    MessageTag[MessageTag["REQ_EDIT_SHARED_WORKLIST"] = 45] = "REQ_EDIT_SHARED_WORKLIST";
	    MessageTag[MessageTag["RSP_REMINDERS"] = 48] = "RSP_REMINDERS";
	    MessageTag[MessageTag["REQ_ADD_REMINDER"] = 49] = "REQ_ADD_REMINDER";
	    MessageTag[MessageTag["REQ_DELETE_REMINDER"] = 50] = "REQ_DELETE_REMINDER";
	    MessageTag[MessageTag["REQ_REMINDER_LINKED_ITEM"] = 53] = "REQ_REMINDER_LINKED_ITEM";
	    MessageTag[MessageTag["RSP_SUBJECT_CONTEXT_SEARCH_TREE"] = 54] = "RSP_SUBJECT_CONTEXT_SEARCH_TREE";
	    MessageTag[MessageTag["REQ_SUBJECT_CONTEXT_SEARCH"] = 55] = "REQ_SUBJECT_CONTEXT_SEARCH";
	    MessageTag[MessageTag["RSP_SUBJECT_CONTEXT_SEARCH"] = 56] = "RSP_SUBJECT_CONTEXT_SEARCH";
	    MessageTag[MessageTag["REQ_SUBJECT_CONTEXT_SEARCH_RESULT"] = 57] = "REQ_SUBJECT_CONTEXT_SEARCH_RESULT";
	    MessageTag[MessageTag["REQ_ADDITIONAL_SEARCH_RESULTS"] = 58] = "REQ_ADDITIONAL_SEARCH_RESULTS";
	    MessageTag[MessageTag["RSP_SUBJECT_CONTEXT"] = 61] = "RSP_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["REQ_RELEASE_OBJECT"] = 62] = "REQ_RELEASE_OBJECT";
	    MessageTag[MessageTag["RSP_CFG_RELATIONSHIPS"] = 64] = "RSP_CFG_RELATIONSHIPS";
	    MessageTag[MessageTag["RSP_SUBJECT_CONTEXT_RELATIONSHIPS"] = 65] = "RSP_SUBJECT_CONTEXT_RELATIONSHIPS";
	    MessageTag[MessageTag["REQ_RELATIONSHIP_PARTNER"] = 66] = "REQ_RELATIONSHIP_PARTNER";
	    MessageTag[MessageTag["REQ_RELATION_GRAPH"] = 67] = "REQ_RELATION_GRAPH";
	    MessageTag[MessageTag["REQ_RELATION_GRAPH_EXPANSION"] = 68] = "REQ_RELATION_GRAPH_EXPANSION";
	    MessageTag[MessageTag["REQ_RELATION_GRAPH_SUBJECT_CONTEXT"] = 69] = "REQ_RELATION_GRAPH_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["RSP_RELATION_GRAPH"] = 70] = "RSP_RELATION_GRAPH";
	    MessageTag[MessageTag["REQ_LOAD_ALGORITHM"] = 72] = "REQ_LOAD_ALGORITHM";
	    MessageTag[MessageTag["REQ_START_ALGORITHM"] = 73] = "REQ_START_ALGORITHM";
	    MessageTag[MessageTag["RSP_NEXT_STEPS"] = 74] = "RSP_NEXT_STEPS";
	    MessageTag[MessageTag["UP_SUBMIT_ANSWERS"] = 75] = "UP_SUBMIT_ANSWERS";
	    MessageTag[MessageTag["REQ_ADDITIONAL_STEPS"] = 76] = "REQ_ADDITIONAL_STEPS";
	    MessageTag[MessageTag["BCST_ALGORITHM_USERS"] = 77] = "BCST_ALGORITHM_USERS";
	    MessageTag[MessageTag["REQ_STOP_ALGORITHM"] = 78] = "REQ_STOP_ALGORITHM";
	    MessageTag[MessageTag["RSP_STOP_ALGORITHM"] = 79] = "RSP_STOP_ALGORITHM";
	    MessageTag[MessageTag["BCST_RESTART_ALGORITHM"] = 80] = "BCST_RESTART_ALGORITHM";
	    MessageTag[MessageTag["REQ_EXPLANATION"] = 84] = "REQ_EXPLANATION";
	    MessageTag[MessageTag["RSP_EXPLANATION"] = 85] = "RSP_EXPLANATION";
	    MessageTag[MessageTag["REQ_PREDECESSOR_STEPS"] = 86] = "REQ_PREDECESSOR_STEPS";
	    MessageTag[MessageTag["RSP_PREDECESSOR_STEPS"] = 87] = "RSP_PREDECESSOR_STEPS";
	    MessageTag[MessageTag["REQ_SUCCESSOR_STEPS"] = 88] = "REQ_SUCCESSOR_STEPS";
	    MessageTag[MessageTag["RSP_SUCCESSOR_STEPS"] = 89] = "RSP_SUCCESSOR_STEPS";
	    MessageTag[MessageTag["REQ_STEP_DEFINITIONS"] = 90] = "REQ_STEP_DEFINITIONS";
	    MessageTag[MessageTag["DEP_REQ_ADD_STEP_COMMENT"] = 94] = "DEP_REQ_ADD_STEP_COMMENT";
	    MessageTag[MessageTag["DEP_REQ_MODIFY_STEP_COMMENT"] = 95] = "DEP_REQ_MODIFY_STEP_COMMENT";
	    MessageTag[MessageTag["DEP_REQ_DELETE_STEP_COMMENT"] = 96] = "DEP_REQ_DELETE_STEP_COMMENT";
	    MessageTag[MessageTag["RSP_COMMENT"] = 97] = "RSP_COMMENT";
	    MessageTag[MessageTag["REQ_ADD_COMMENT"] = 98] = "REQ_ADD_COMMENT";
	    MessageTag[MessageTag["REQ_MODIFY_COMMENT"] = 99] = "REQ_MODIFY_COMMENT";
	    MessageTag[MessageTag["REQ_DELETE_COMMENT"] = 100] = "REQ_DELETE_COMMENT";
	    MessageTag[MessageTag["REQ_POST_CHAT_MESSAGE"] = 104] = "REQ_POST_CHAT_MESSAGE";
	    MessageTag[MessageTag["BCST_CHAT_MESSAGE"] = 105] = "BCST_CHAT_MESSAGE";
	    MessageTag[MessageTag["REQ_SAVE_SUBJECT_CONTEXT"] = 108] = "REQ_SAVE_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["REQ_CREATE_SUBJECT_CONTEXT"] = 109] = "REQ_CREATE_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["REQ_REFER_SUBJECT_CONTEXT"] = 110] = "REQ_REFER_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY"] = 111] = "REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY";
	    MessageTag[MessageTag["RSP_SAVE"] = 112] = "RSP_SAVE";
	    MessageTag[MessageTag["REQ_STATUS_AGGREGATOR"] = 116] = "REQ_STATUS_AGGREGATOR";
	    MessageTag[MessageTag["RSP_STATUS_AGGREGATOR"] = 117] = "RSP_STATUS_AGGREGATOR";
	    MessageTag[MessageTag["REQ_STATUS_DATA_EXPORT"] = 118] = "REQ_STATUS_DATA_EXPORT";
	    MessageTag[MessageTag["RSP_STATUS_DATA_EXPORT"] = 119] = "RSP_STATUS_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_SEND_PASSWORD_RESET_EMAIL"] = 128] = "REQ_SEND_PASSWORD_RESET_EMAIL";
	    MessageTag[MessageTag["REQ_BEGIN_PASSWORD_RESET"] = 129] = "REQ_BEGIN_PASSWORD_RESET";
	    MessageTag[MessageTag["SREQ_CREDENTIAL_CHALLENGE"] = 130] = "SREQ_CREDENTIAL_CHALLENGE";
	    MessageTag[MessageTag["CRSP_CREDENTIAL_CHALLENGE"] = 131] = "CRSP_CREDENTIAL_CHALLENGE";
	    MessageTag[MessageTag["SREQ_NEW_PASSWORD"] = 132] = "SREQ_NEW_PASSWORD";
	    MessageTag[MessageTag["CRSP_NEW_PASSWORD"] = 133] = "CRSP_NEW_PASSWORD";
	    MessageTag[MessageTag["REQ_CHANGE_PASSWORD"] = 134] = "REQ_CHANGE_PASSWORD";
	    MessageTag[MessageTag["SREQ_MODIFY_SECURITY_QUESTIONS"] = 135] = "SREQ_MODIFY_SECURITY_QUESTIONS";
	    MessageTag[MessageTag["CRSP_MODIFY_SECURITY_QUESTIONS"] = 136] = "CRSP_MODIFY_SECURITY_QUESTIONS";
	    MessageTag[MessageTag["REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP"] = 200] = "REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP";
	    MessageTag[MessageTag["REQ_MODIFY_SUBJECT_CONTEXT_RELATIONSHIP"] = 201] = "REQ_MODIFY_SUBJECT_CONTEXT_RELATIONSHIP";
	    MessageTag[MessageTag["REQ_DELETE_SUBJECT_CONTEXT_RELATIONSHIP"] = 202] = "REQ_DELETE_SUBJECT_CONTEXT_RELATIONSHIP";
	    MessageTag[MessageTag["RSP_AVAILABLE_AGGREGATORS"] = 256] = "RSP_AVAILABLE_AGGREGATORS";
	    MessageTag[MessageTag["REQ_CREATE_AGGREGATOR"] = 257] = "REQ_CREATE_AGGREGATOR";
	    MessageTag[MessageTag["RSP_CREATE_AGGREGATOR"] = 258] = "RSP_CREATE_AGGREGATOR";
	    MessageTag[MessageTag["REQ_START_AGGREGATOR"] = 259] = "REQ_START_AGGREGATOR";
	    MessageTag[MessageTag["RSP_AGGREGATOR_REPORT"] = 260] = "RSP_AGGREGATOR_REPORT";
	    MessageTag[MessageTag["REQ_DELETE_AGGREGATOR"] = 261] = "REQ_DELETE_AGGREGATOR";
	    MessageTag[MessageTag["REQ_PAUSE_AGGREGATOR"] = 262] = "REQ_PAUSE_AGGREGATOR";
	    MessageTag[MessageTag["REQ_RESUME_AGGREGATOR"] = 263] = "REQ_RESUME_AGGREGATOR";
	    MessageTag[MessageTag["REQ_CANCEL_AGGREGATION"] = 264] = "REQ_CANCEL_AGGREGATION";
	    MessageTag[MessageTag["RSP_AGGREGATOR_FAILURE"] = 265] = "RSP_AGGREGATOR_FAILURE";
	    MessageTag[MessageTag["REQ_AGGREGATION_SUBJECT_CONTEXT"] = 266] = "REQ_AGGREGATION_SUBJECT_CONTEXT";
	    MessageTag[MessageTag["RSP_AVAILABLE_DATA_EXPORTS"] = 279] = "RSP_AVAILABLE_DATA_EXPORTS";
	    MessageTag[MessageTag["REQ_CREATE_DATA_EXPORT"] = 280] = "REQ_CREATE_DATA_EXPORT";
	    MessageTag[MessageTag["RSP_CREATE_DATA_EXPORT"] = 281] = "RSP_CREATE_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_START_DATA_EXPORT"] = 282] = "REQ_START_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_DELETE_DATA_EXPORT"] = 284] = "REQ_DELETE_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_PAUSE_DATA_EXPORT"] = 285] = "REQ_PAUSE_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_RESUME_DATA_EXPORT"] = 286] = "REQ_RESUME_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_CANCEL_DATA_EXPORT"] = 287] = "REQ_CANCEL_DATA_EXPORT";
	    MessageTag[MessageTag["RSP_DATA_EXPORT_FAILURE"] = 288] = "RSP_DATA_EXPORT_FAILURE";
	    MessageTag[MessageTag["RSP_DATA_EXPORT_REPORT"] = 289] = "RSP_DATA_EXPORT_REPORT";
	    MessageTag[MessageTag["RSP_START_DATA_EXPORT"] = 290] = "RSP_START_DATA_EXPORT";
	    MessageTag[MessageTag["REQ_REFRESH_REPORT_SCHEMAS"] = 291] = "REQ_REFRESH_REPORT_SCHEMAS";
	    MessageTag[MessageTag["RSP_REFRESH_REPORT_SCHEMAS"] = 292] = "RSP_REFRESH_REPORT_SCHEMAS";
	    MessageTag[MessageTag["REQ_SAVE_DATA_EXPORT_SCHEMA"] = 293] = "REQ_SAVE_DATA_EXPORT_SCHEMA";
	    MessageTag[MessageTag["RSP_SAVE_REPORT_SCHEMA"] = 294] = "RSP_SAVE_REPORT_SCHEMA";
	    MessageTag[MessageTag["REQ_SAVE_AGGREGATION_SCHEMA"] = 295] = "REQ_SAVE_AGGREGATION_SCHEMA";
	    MessageTag[MessageTag["REQ_DELETE_DATA_EXPORT_SCHEMA"] = 296] = "REQ_DELETE_DATA_EXPORT_SCHEMA";
	    MessageTag[MessageTag["REQ_DELETE_AGGREGATION_SCHEMA"] = 297] = "REQ_DELETE_AGGREGATION_SCHEMA";
	    MessageTag[MessageTag["REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY"] = 298] = "REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY";
	    MessageTag[MessageTag["REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY"] = 299] = "REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY";
	    MessageTag[MessageTag["REQ_START_GUEST_SESSION"] = 328] = "REQ_START_GUEST_SESSION";
	    MessageTag[MessageTag["RSP_START_GUEST_SESSION"] = 329] = "RSP_START_GUEST_SESSION";
	    MessageTag[MessageTag["REQ_EXTENSION_SIGNAL"] = 360] = "REQ_EXTENSION_SIGNAL";
	    MessageTag[MessageTag["BCST_EXTENSION_SIGNAL"] = 361] = "BCST_EXTENSION_SIGNAL";
	    MessageTag[MessageTag["DOWN_NOTIFY"] = 504] = "DOWN_NOTIFY";
	    MessageTag[MessageTag["REQ_ANNOUNCEMENT"] = 505] = "REQ_ANNOUNCEMENT";
	    MessageTag[MessageTag["BCST_ANNOUNCEMENT"] = 506] = "BCST_ANNOUNCEMENT";
	    MessageTag[MessageTag["REQ_KILL_CLIENT"] = 509] = "REQ_KILL_CLIENT";
	    MessageTag[MessageTag["BCST_ADMIN_CLIENT_LIST"] = 510] = "BCST_ADMIN_CLIENT_LIST";
	    MessageTag[MessageTag["REQ_CFG_QUARANTINE"] = 511] = "REQ_CFG_QUARANTINE";
	    MessageTag[MessageTag["RSP_CFG_QUARANTINE"] = 512] = "RSP_CFG_QUARANTINE";
	    MessageTag[MessageTag["REQ_SHUTDOWN"] = 513] = "REQ_SHUTDOWN";
	    MessageTag[MessageTag["RSP_SHUTDOWN"] = 514] = "RSP_SHUTDOWN";
	    MessageTag[MessageTag["REQ_QUARANTINE_ZONE"] = 515] = "REQ_QUARANTINE_ZONE";
	    MessageTag[MessageTag["REQ_CREATE_GROUP"] = 528] = "REQ_CREATE_GROUP";
	    MessageTag[MessageTag["REQ_EDIT_GROUP"] = 529] = "REQ_EDIT_GROUP";
	    MessageTag[MessageTag["REQ_GROUP_USERS"] = 550] = "REQ_GROUP_USERS";
	    MessageTag[MessageTag["RSP_GROUP_USERS"] = 551] = "RSP_GROUP_USERS";
	    MessageTag[MessageTag["REQ_USER"] = 552] = "REQ_USER";
	    MessageTag[MessageTag["REQ_CHANGE_USER_ACTIVE_STATUS"] = 553] = "REQ_CHANGE_USER_ACTIVE_STATUS";
	    MessageTag[MessageTag["RSP_USER"] = 554] = "RSP_USER";
	    MessageTag[MessageTag["REQ_EDIT_USER"] = 555] = "REQ_EDIT_USER";
	    MessageTag[MessageTag["REQ_RESET_USER_PASSWORD"] = 556] = "REQ_RESET_USER_PASSWORD";
	    MessageTag[MessageTag["REQ_CREATE_USER"] = 557] = "REQ_CREATE_USER";
	    MessageTag[MessageTag["REQ_EDIT_OTHER_USER"] = 558] = "REQ_EDIT_OTHER_USER";
	    MessageTag[MessageTag["REQ_SET_USER_GROUPS"] = 559] = "REQ_SET_USER_GROUPS";
	    MessageTag[MessageTag["REQ_REMOVE_USER_GROUPS"] = 560] = "REQ_REMOVE_USER_GROUPS";
	    MessageTag[MessageTag["DBG_UP_BREAKPOINT"] = 1000] = "DBG_UP_BREAKPOINT";
	    MessageTag[MessageTag["DBG_REQ_CFG_MODE"] = 1001] = "DBG_REQ_CFG_MODE";
	    MessageTag[MessageTag["DBG_REQ_CFG_CODE_GEN_MODE"] = 1002] = "DBG_REQ_CFG_CODE_GEN_MODE";
	    MessageTag[MessageTag["DBG_UP_LOG"] = 1024] = "DBG_UP_LOG";
	    MessageTag[MessageTag["DBG_DOWN_LOG"] = 1025] = "DBG_DOWN_LOG";
	    MessageTag[MessageTag["DBG_REQ_RESTART_ALGORITHM"] = 1072] = "DBG_REQ_RESTART_ALGORITHM";
	})(MessageTag = exports.MessageTag || (exports.MessageTag = {}));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(517);
	var Message = (function () {
	    function Message() {
	    }
	    Message.isA = function (message, compare) {
	        var tag = (typeof compare === "number") ? compare : compare.tag;
	        return (message.tag === tag);
	    };
	    Message.prototype.isA = function (compare) {
	        return (this.tag === compare.tag);
	    };
	    __decorate([
	        decorators_1.descriptor({ enumerable: false, value: {} }),
	        __metadata("design:type", Object)
	    ], Message.prototype, "meta", void 0);
	    return Message;
	}());
	exports.Message = Message;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var errors_1 = __webpack_require__(518);
	var PERMISSIVE_DESCRIPTOR = {
	    writable: true,
	    configurable: true,
	    enumerable: true
	};
	function descriptor(options) {
	    return function (target, propertyKey) {
	        var descriptor = Object.assign(Object.getOwnPropertyDescriptor(target, propertyKey) || {}, options);
	        Object.defineProperty(target, propertyKey, descriptor);
	    };
	}
	exports.descriptor = descriptor;
	function protocolDefault(req, fallback) {
	    var satisfiesReq = ((typeof req === "number")
	        ? function (version) { return (version >= req); }
	        : req);
	    return function (target, propertyKey) {
	        var value;
	        return {
	            get: function () { return (!satisfiesReq(window.protocolVersion)) ? fallback : value; },
	            set: function (newValue) { return value = newValue; }
	        };
	    };
	}
	exports.protocolDefault = protocolDefault;
	function protocolMinimum(minimum) {
	    return function (target, propertyKey) {
	        var value;
	        return {
	            get: function () {
	                if (window.protocolVersion < minimum) {
	                    throw new errors_1.ProtocolVersionError(minimum, window.protocolVersion);
	                }
	                else {
	                    return value;
	                }
	            },
	            set: function (newValue) { return value = newValue; }
	        };
	    };
	}
	exports.protocolMinimum = protocolMinimum;
	function initDisconnector(target) {
	    if (typeof target.disconnected !== "function") {
	        console.error(target);
	        throw new Error("disconnect() is not defined on target");
	    }
	    if (!target.disconnected.wrapped) {
	        var oldFn_1 = target.disconnected;
	        var map_1 = new Map();
	        target.disconnected = function () {
	            var _this = this;
	            map_1.forEach(function (fn, property) {
	                return _this[property] = fn.call(_this, _this[property]);
	            });
	            oldFn_1.call(this);
	        };
	        target.disconnected.add =
	            function (property, fn) { return map_1.set(property, fn); };
	        target.disconnected.wrapped = true;
	    }
	}
	function disconnectDo(fn) {
	    return function (target, key) {
	        initDisconnector(target);
	        target.disconnected.add(key, fn);
	    };
	}
	exports.disconnectDo = disconnectDo;
	function disconnectWith(method, arg) {
	    return disconnectDo(function (obj) {
	        obj[method](arg);
	        return obj;
	    });
	}
	exports.disconnectWith = disconnectWith;
	function disconnectValue(value) {
	    return disconnectDo(function () { return value; });
	}
	exports.disconnectValue = disconnectValue;
	function disconnectEmpty() {
	    return disconnectDo(function () { return []; });
	}
	exports.disconnectEmpty = disconnectEmpty;
	function onDisconnect() {
	    return function (target, method, descriptor) {
	        initDisconnector(target);
	        target.disconnected.add(Symbol(method), descriptor.value);
	    };
	}
	exports.onDisconnect = onDisconnect;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ProtocolVersionError = (function () {
	    function ProtocolVersionError(requiredVersion, currentVersion) {
	        this.requiredVersion = requiredVersion;
	        this.currentVersion = currentVersion;
	        this.name = "ProtocolVersionError";
	        this.message = "The application requested a feature not available in the agreed protocol";
	    }
	    return ProtocolVersionError;
	}());
	exports.ProtocolVersionError = ProtocolVersionError;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_tag_1 = __webpack_require__(515);
	var message_1 = __webpack_require__(516);
	var InvalidMessage = (function (_super) {
	    __extends(InvalidMessage, _super);
	    function InvalidMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.PVT_INVALID;
	        _this.timestamp = Date.now();
	        return _this;
	    }
	    InvalidMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    InvalidMessage.prototype.sendable = function () {
	        return false;
	    };
	    return InvalidMessage;
	}(message_1.Message));
	exports.InvalidMessage = InvalidMessage;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var message_tag_1 = __webpack_require__(515);
	var incoming_message_1 = __webpack_require__(522);
	var message_1 = __webpack_require__(516);
	var response_code_1 = __webpack_require__(527);
	var AcknowledgmentResponse = (function (_super) {
	    __extends(AcknowledgmentResponse, _super);
	    function AcknowledgmentResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_ACKNOWLEDGEMENT;
	        return _this;
	    }
	    AcknowledgmentResponse.isOk = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_ACKNOWLEDGEMENT)
	            && reply.ok;
	    };
	    AcknowledgmentResponse.elevateErrors = function (reply) {
	        if (!reply.ok) {
	            console.error(reply);
	            var msg = reply.reason || "Reply not OK: unknown reason";
	            throw new Error(msg);
	        }
	        return reply;
	    };
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AcknowledgmentResponse.prototype, "ok", void 0);
	    __decorate([
	        decorators_1.validateAs("string", true, null),
	        __metadata("design:type", String)
	    ], AcknowledgmentResponse.prototype, "reason", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }, { max: 10 }], true, null),
	        __metadata("design:type", Number)
	    ], AcknowledgmentResponse.prototype, "code", void 0);
	    AcknowledgmentResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_ACKNOWLEDGEMENT)
	    ], AcknowledgmentResponse);
	    return AcknowledgmentResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AcknowledgmentResponse = AcknowledgmentResponse;


/***/ }),
/* 521 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function makeValidatable(cls) {
	    if (!Array.isArray(cls.validators)) {
	        cls.validators = [];
	    }
	}
	function validateFor(tag) {
	    return function (constructor) {
	        constructor.selfValidates = true;
	        constructor.tag = tag;
	    };
	}
	exports.validateFor = validateFor;
	function validateAs(rules, optional, defaultValue, customRules) {
	    if (optional === void 0) { optional = false; }
	    if (defaultValue === void 0) { defaultValue = null; }
	    if (customRules === void 0) { customRules = []; }
	    if (!Array.isArray(rules)) {
	        rules = [rules];
	    }
	    if (!Array.isArray(customRules)) {
	        customRules = [customRules];
	    }
	    return function (target, key) {
	        makeValidatable(target);
	        target.validators.push({
	            key: key,
	            optional: optional,
	            defaultValue: defaultValue,
	            rules: rules,
	            customRules: customRules
	        });
	    };
	}
	exports.validateAs = validateAs;
	function validateTSEnum(e, isArray) {
	    if (isArray === void 0) { isArray = false; }
	    var values = Object.values(e).filter(function (v) { return typeof v === "number"; });
	    return (isArray
	        ? validateAs({ array: { enum: values } })
	        : validateAs({ enum: values }));
	}
	exports.validateTSEnum = validateTSEnum;
	function validateOpaqueID(optional, defaultValue, nullable) {
	    if (optional === void 0) { optional = false; }
	    if (defaultValue === void 0) { defaultValue = null; }
	    if (nullable === void 0) { nullable = false; }
	    if (nullable) {
	        return function (target, key) {
	            makeValidatable(target);
	            target.validators.push({
	                key: key,
	                optional: optional,
	                defaultValue: defaultValue,
	                rules: [],
	                customRules: [function (json) {
	                        if (json[key] !== null && !Number.isSafeInteger(json[key])) {
	                            errorOut("ID must be integer or null!", json[key]);
	                        }
	                    }]
	            });
	        };
	    }
	    else {
	        return validateAs(["integer", { min: 0 }], optional, defaultValue);
	    }
	}
	exports.validateOpaqueID = validateOpaqueID;
	function errorOut(msg, obj) {
	    console.error(msg, obj);
	    throw new Error(msg);
	}
	exports.errorOut = errorOut;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var message_1 = __webpack_require__(516);
	var utilities_1 = __webpack_require__(523);
	var IncomingMessage = (function (_super) {
	    __extends(IncomingMessage, _super);
	    function IncomingMessage(json) {
	        var _this = _super.call(this) || this;
	        _this.readJSON(json);
	        return _this;
	    }
	    IncomingMessage.prototype.sendable = function () {
	        return false;
	    };
	    IncomingMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    IncomingMessage.fromJSON = function (json) {
	        return new this(json);
	    };
	    IncomingMessage.prototype.readJSON = function (json) {
	        var _this = this;
	        if (typeof json !== "object" || json === null) {
	            decorators_1.errorOut("JSON must be object-rooted.", json);
	        }
	        if (Array.isArray(this.validators)) {
	            this.validators.forEach(function (v) { return _this.validateKey(json, v); });
	        }
	        else {
	            console.warn("Validation enabled, but no rules defined: passing through." +
	                "Was this created as the IncomingMessage superclass?", this, json);
	        }
	        Object.assign(this, json);
	    };
	    IncomingMessage.prototype.validateKey = function (json, validator) {
	        var _this = this;
	        if (!(validator.key in json)) {
	            if (validator.optional) {
	                json[validator.key] = validator.defaultValue;
	            }
	            else {
	                decorators_1.errorOut(utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["JSON tag ", " missing required key '", "'"], ["JSON tag ", " missing required key '", "'"])), json.tag, validator.key), json);
	            }
	        }
	        else {
	            validator.rules.forEach(function (r) {
	                return _this.validateValue(json[validator.key], r);
	            });
	            if (validator.customRules) {
	                validator.customRules.forEach(function (r) { return r(json); });
	            }
	        }
	    };
	    IncomingMessage.prototype.validateValue = function (value, v) {
	        var _this = this;
	        var _a;
	        var name;
	        var param;
	        if (typeof v === "object") {
	            _a = Object.entries(v)[0], name = _a[0], param = _a[1];
	        }
	        else {
	            name = v;
	            param = null;
	        }
	        switch (name) {
	            case "boolean":
	                if (typeof value !== "boolean") {
	                    decorators_1.errorOut("JSON value expected to be boolean", value);
	                }
	                break;
	            case "string":
	                if (typeof value !== "string") {
	                    decorators_1.errorOut("JSON value expected to be string", value);
	                }
	                break;
	            case "integer":
	                if (!Number.isSafeInteger(value)) {
	                    decorators_1.errorOut("JSON value expected to be safe int", value);
	                }
	                break;
	            case "float":
	                if (Number.isFinite(value)) {
	                    decorators_1.errorOut("JSON value expected to be finite number", value);
	                }
	                break;
	            case "object":
	                if (typeof value !== "object" || value === null) {
	                    decorators_1.errorOut("JSON value expected to be object", value);
	                }
	                break;
	            case "min":
	                if (value < param) {
	                    decorators_1.errorOut("JSON value expected to be >= " + param, value);
	                }
	                break;
	            case "max":
	                if (value > param) {
	                    decorators_1.errorOut("JSON value expected to be <= " + param, value);
	                }
	                break;
	            case "enum":
	                if (param.indexOf(value) === -1) {
	                    decorators_1.errorOut("JSON value expected to be in {" + param.join(",") + "}", value);
	                }
	                break;
	            case "array":
	                if (!Array.isArray(value)) {
	                    decorators_1.errorOut("JSON value expected to be array!", value);
	                }
	                value.forEach(function (subvalue) { return _this.validateValue(subvalue, param); });
	                break;
	            case "nullable":
	                if (value !== null) {
	                    this.validateValue(value, param);
	                }
	                break;
	        }
	    };
	    return IncomingMessage;
	}(message_1.Message));
	exports.IncomingMessage = IncomingMessage;
	var templateObject_1;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(524));
	__export(__webpack_require__(207));
	__export(__webpack_require__(206));
	var tree_1 = __webpack_require__(525);
	exports.Tree = tree_1.Tree;
	exports.TreeNode = tree_1.TreeNode;
	var modals_1 = __webpack_require__(526);
	exports.ModalHelpers = modals_1.ModalHelpers;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var SLOW_REMOVAL_DEF = [
	    core_1.transition("keep => remove", [
	        core_1.style({ opacity: 1, height: "*", overflow: "hidden" }),
	        core_1.animate("1s 0.3s ease-out", core_1.style({ opacity: 0, height: 0 }))
	    ]),
	    core_1.state("remove", core_1.style({ opacity: 0, height: 0, display: "none" }))
	];
	var SLOW_DETACH_DEF = [
	    core_1.transition("* => void", [
	        core_1.style({ opacity: 1, height: "*", overflow: "hidden" }),
	        core_1.animate("0.7s 0.3s ease-out", core_1.style({ opacity: 0, height: 0 }))
	    ]),
	    core_1.state("void", core_1.style({ opacity: 0, height: 0, display: "none" }))
	];
	var SLOW_ATTACH_DEF = [
	    core_1.state("void", core_1.style({ opacity: 0, height: 0, display: "none" })),
	    core_1.transition("void => *", [
	        core_1.style({ opacity: 0, height: 0, overflow: "hidden" }),
	        core_1.animate("0.3s 0.7s", core_1.style({ opacity: 1, height: "*", display: "*" }))
	    ])
	];
	exports.SLOW_REMOVAL = core_1.trigger("slowRemoval", SLOW_REMOVAL_DEF);
	exports.SLOW_DETACH = core_1.trigger("slowDetach", SLOW_DETACH_DEF);
	exports.SLOW_ATTACH = core_1.trigger("slowAttach", SLOW_ATTACH_DEF);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DEPTH_LIMIT = 1000;
	var Tree = (function () {
	    function Tree(root) {
	        this.root = null;
	        if (root !== undefined) {
	            this.root = (root instanceof TreeNode) ? root : new TreeNode(root);
	        }
	    }
	    Tree.prototype.isEmpty = function () {
	        return this.root === null;
	    };
	    Tree.depthFirst = function (start, previsit, visit, postvisit) {
	        if (start instanceof Tree) {
	            if (start.isEmpty()) {
	                return;
	            }
	            start = start.root;
	        }
	        previsit = previsit || (function () { return null; });
	        visit = visit || (function () { return null; });
	        postvisit = postvisit || (function () { return null; });
	        var CheckPhase;
	        (function (CheckPhase) {
	            CheckPhase[CheckPhase["Previsited"] = 0] = "Previsited";
	            CheckPhase[CheckPhase["LeftVisited"] = 1] = "LeftVisited";
	            CheckPhase[CheckPhase["SelfVisited"] = 2] = "SelfVisited";
	            CheckPhase[CheckPhase["RightVisited"] = 3] = "RightVisited";
	        })(CheckPhase || (CheckPhase = {}));
	        var quit;
	        quit = previsit(start);
	        var revisit = [[start, CheckPhase.Previsited]];
	        while (revisit.length > 0) {
	            if (quit === true) {
	                return;
	            }
	            var _a = revisit.shift(), parent_1 = _a[0], phase = _a[1];
	            switch (phase) {
	                case CheckPhase.Previsited:
	                    revisit.unshift([parent_1, CheckPhase.LeftVisited]);
	                    if (parent_1.hasLeft()) {
	                        quit = previsit(parent_1.left);
	                        revisit.unshift([parent_1.left, CheckPhase.Previsited]);
	                    }
	                    break;
	                case CheckPhase.LeftVisited:
	                    quit = visit(parent_1);
	                    revisit.unshift([parent_1, CheckPhase.SelfVisited]);
	                    break;
	                case CheckPhase.SelfVisited:
	                    revisit.unshift([parent_1, CheckPhase.RightVisited]);
	                    if (parent_1.hasRight()) {
	                        quit = previsit(parent_1.right);
	                        revisit.unshift([parent_1.right, CheckPhase.Previsited]);
	                    }
	                    break;
	                case CheckPhase.RightVisited:
	                    quit = postvisit(parent_1);
	                    break;
	                default:
	                    throw new Error("Unknown visitor state: " + phase + "!");
	            }
	        }
	    };
	    Tree.prototype.has = function (item, equals) {
	        if (!equals) {
	            equals = function (a, b) { return a === b; };
	        }
	        var found = false;
	        Tree.depthFirst(this, function (node) {
	            found = equals(item, node.value);
	            return found;
	        });
	        return found;
	    };
	    Tree.prototype.list = function () {
	        var out = [];
	        Tree.depthFirst(this, null, function (node) { return out.push(node.value); });
	        return out;
	    };
	    Tree.prototype.depthFirstList = function () {
	        var out = [];
	        Tree.depthFirst(this, function (node) { return out.push(node.value); });
	        return out;
	    };
	    Tree.prototype.insert = function (nodeOrValue, rightOf) {
	        var insertion = (nodeOrValue instanceof TreeNode)
	            ? nodeOrValue
	            : new TreeNode(nodeOrValue);
	        if (this.isEmpty()) {
	            this.root = insertion;
	            return;
	        }
	        if (!rightOf) {
	            rightOf = function (node, comparison) {
	                return comparison.value < node.value;
	            };
	        }
	        var prev = this.root;
	        var i;
	        for (i = 0; i < DEPTH_LIMIT; i++) {
	            if (rightOf(insertion, prev)) {
	                if (prev.hasRight()) {
	                    prev = prev.right;
	                }
	                else {
	                    prev.right = insertion;
	                    return;
	                }
	            }
	            else {
	                if (prev.hasLeft()) {
	                    prev = prev.left;
	                }
	                else {
	                    prev.left = insertion;
	                    return;
	                }
	            }
	        }
	        if (i === DEPTH_LIMIT) {
	            throw new Error("Could not insert element due to tree depth limit");
	        }
	    };
	    Tree.stickFromList = function (list, left) {
	        if (left === void 0) { left = true; }
	        if (list.length < 1) {
	            throw new Error("Cannot tree-ify empty list");
	        }
	        var parent = new TreeNode(list[0]);
	        var tree = new Tree(parent);
	        list.slice(1).forEach(function (item) {
	            if (left) {
	                parent.left = new TreeNode(item);
	                parent = parent.left;
	            }
	            else {
	                parent.right = new TreeNode(item);
	                parent = parent.right;
	            }
	        });
	        return tree;
	    };
	    return Tree;
	}());
	exports.Tree = Tree;
	var TreeNode = (function () {
	    function TreeNode(value, left, right) {
	        if (left === void 0) { left = null; }
	        if (right === void 0) { right = null; }
	        this.value = value;
	        this.left = left;
	        this.right = right;
	    }
	    TreeNode.prototype.hasLeft = function () {
	        return this.left !== null;
	    };
	    TreeNode.prototype.hasRight = function () {
	        return this.right !== null;
	    };
	    TreeNode.prototype.isLeaf = function () {
	        return !this.hasLeft() && !this.hasRight();
	    };
	    TreeNode.prototype.leftDescendantValues = function () {
	        var descendants = [];
	        Tree.depthFirst(this, function (node) {
	            descendants.push(node.value);
	            return !node.hasLeft();
	        });
	        return descendants;
	    };
	    return TreeNode;
	}());
	exports.TreeNode = TreeNode;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var Rx_1 = __webpack_require__(214);
	var DEPTH_LIMIT = 1000;
	var ModalHelpers = (function () {
	    function ModalHelpers() {
	    }
	    ModalHelpers.observeBooleanConfirmation = function (modalPromise) {
	        return Rx_1.Observable.create(function (o) {
	            modalPromise.then(function (dialog) {
	                dialog.result.then(function (result) { return (o.next(true) || o.complete()); }, function () { return (o.next(false) || o.complete()); });
	            });
	        });
	    };
	    ModalHelpers.observeResult = function (modalPromise, dismissValue) {
	        return Rx_1.Observable.create(function (o) {
	            modalPromise.then(function (dialog) {
	                dialog.result.then(function (result) {
	                    o.next(result);
	                    o.complete();
	                }, function () {
	                    if (dismissValue !== undefined) {
	                        o.next(dismissValue);
	                    }
	                    o.complete();
	                });
	            });
	        });
	    };
	    ModalHelpers.openCustom = function (modalService, componentClass, configuration, context) {
	        if (configuration === void 0) { configuration = {}; }
	        if (context === void 0) { context = bootstrap_1.BSModalContext; }
	        return modalService.open(componentClass, angular2_modal_1.overlayConfigFactory(configuration, context));
	    };
	    ModalHelpers.observeCustom = function (modalService, componentClass, configuration) {
	        return ModalHelpers.observeResult(ModalHelpers.openCustom(modalService, componentClass, configuration), null);
	    };
	    ModalHelpers.alert = function (modalService, title, message) {
	        return modalService.alert()
	            .size("sm")
	            .title(title)
	            .body(message)
	            .open();
	    };
	    return ModalHelpers;
	}());
	exports.ModalHelpers = ModalHelpers;
	var UseModalsForBrowserAlerts = (function () {
	    function UseModalsForBrowserAlerts(modal) {
	        var _this = this;
	        this.modal = modal;
	        this.browserAlert = alert;
	        window.alert = function (msg) { return _this.alertWithModal(msg); };
	    }
	    UseModalsForBrowserAlerts.prototype.alertWithModal = function (msg) {
	        ModalHelpers.alert(this.modal, "Warning!", msg);
	    };
	    UseModalsForBrowserAlerts = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [bootstrap_1.Modal])
	    ], UseModalsForBrowserAlerts);
	    return UseModalsForBrowserAlerts;
	}());
	exports.UseModalsForBrowserAlerts = UseModalsForBrowserAlerts;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResponseCode;
	(function (ResponseCode) {
	    ResponseCode[ResponseCode["META_AlreadyHandled"] = -1] = "META_AlreadyHandled";
	    ResponseCode[ResponseCode["OK"] = 0] = "OK";
	    ResponseCode[ResponseCode["UnspecifiedError"] = 1] = "UnspecifiedError";
	    ResponseCode[ResponseCode["LoginFailure"] = 2] = "LoginFailure";
	    ResponseCode[ResponseCode["InvalidRequest"] = 3] = "InvalidRequest";
	    ResponseCode[ResponseCode["RequestExpired"] = 4] = "RequestExpired";
	    ResponseCode[ResponseCode["MissingData"] = 5] = "MissingData";
	    ResponseCode[ResponseCode["RequestFailed"] = 6] = "RequestFailed";
	    ResponseCode[ResponseCode["DuplicateEmail"] = 7] = "DuplicateEmail";
	    ResponseCode[ResponseCode["PermissionDenied"] = 8] = "PermissionDenied";
	    ResponseCode[ResponseCode["Irretrievable"] = 9] = "Irretrievable";
	    ResponseCode[ResponseCode["SystemDown"] = 10] = "SystemDown";
	    ResponseCode[ResponseCode["Maintenance"] = 11] = "Maintenance";
	    ResponseCode[ResponseCode["DataCorruption"] = 12] = "DataCorruption";
	})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
	exports.DISCONNECTION_TEXT = new Map([
	    [
	        ResponseCode.UnspecifiedError,
	        "The server has disconnected for an unknown reason"
	    ],
	    [
	        ResponseCode.LoginFailure,
	        "Your credentials could not be authenticated."
	    ],
	    [
	        ResponseCode.InvalidRequest,
	        "The server declared your request invalid."
	    ],
	    [
	        ResponseCode.RequestExpired,
	        "Your request expired before it could be handled."
	    ],
	    [
	        ResponseCode.MissingData,
	        "You were disconnected because the server found a fault in the data."
	    ],
	    [
	        ResponseCode.RequestFailed,
	        "Your request could not be completed and the server chose to disconnect."
	    ],
	    [
	        ResponseCode.DuplicateEmail,
	        "Invalid request: that email is already in use!"
	    ],
	    [
	        ResponseCode.PermissionDenied,
	        "You didn't have the permission to make that request and were disconnected."
	    ],
	    [
	        ResponseCode.SystemDown,
	        "The system is now offline."
	    ],
	    [
	        ResponseCode.Maintenance,
	        "Maintenance has begun on the application, requiring you to disconnect."
	    ],
	    [
	        ResponseCode.DataCorruption,
	        "A user submitted bad data that necessitated a disconnect."
	    ],
	]);
	exports.DISCONNECTION_TEXT.default =
	    "The server has disconnected for an unknown reason";
	exports.GENERIC_REASON_TEXT = new Map([
	    [
	        ResponseCode.UnspecifiedError,
	        "an unspecified error occurred"
	    ],
	    [
	        ResponseCode.LoginFailure,
	        "your credentials were invalid"
	    ],
	    [
	        ResponseCode.InvalidRequest,
	        "the server could not interpret the request"
	    ],
	    [
	        ResponseCode.RequestExpired,
	        "the request was outdated or took too long"
	    ],
	    [
	        ResponseCode.MissingData,
	        "the server encountered missing data"
	    ],
	    [
	        ResponseCode.RequestFailed,
	        "the server could not complete the request successfully"
	    ],
	    [
	        ResponseCode.DuplicateEmail,
	        "that email is already in use"
	    ],
	    [
	        ResponseCode.PermissionDenied,
	        "you do not have permission to perform that action"
	    ],
	    [
	        ResponseCode.Irretrievable,
	        "the data would become irretrievable"
	    ],
	    [
	        ResponseCode.SystemDown,
	        "parts of the system are down or otherwise unavailable"
	    ],
	    [
	        ResponseCode.Maintenance,
	        "the system is actively undergoing maintenance"
	    ],
	    [
	        ResponseCode.DataCorruption,
	        "a user has submitted bad data that must be discarded"
	    ],
	]);
	exports.GENERIC_REASON_TEXT.default = "an unspecified error occurred";


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var MessageError = (function (_super) {
	    __extends(MessageError, _super);
	    function MessageError(message) {
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        return _this;
	    }
	    return MessageError;
	}(Error));
	exports.MessageError = MessageError;
	var MissingReplyError = (function (_super) {
	    __extends(MissingReplyError, _super);
	    function MissingReplyError(request) {
	        var _this = _super.call(this, "Stream closed before reply") || this;
	        _this.request = request;
	        _this.name = "Missing Reply Error";
	        return _this;
	    }
	    return MissingReplyError;
	}(MessageError));
	exports.MissingReplyError = MissingReplyError;
	var ReplyTimeoutError = (function (_super) {
	    __extends(ReplyTimeoutError, _super);
	    function ReplyTimeoutError(request, timeout) {
	        var _this = _super.call(this, "Server did not reply within given timeout "
	            + (timeout ? "of " + timeout + "ms" : "(unknown)")) || this;
	        _this.request = request;
	        _this.timeout = timeout;
	        _this.name = "Reply Timeout Error";
	        return _this;
	    }
	    return ReplyTimeoutError;
	}(MessageError));
	exports.ReplyTimeoutError = ReplyTimeoutError;
	var BadReplyError = (function (_super) {
	    __extends(BadReplyError, _super);
	    function BadReplyError(request, response) {
	        var _this = _super.call(this, "Reply failed request's validation") || this;
	        _this.request = request;
	        _this.response = response;
	        _this.name = "Bad Reply Error";
	        return _this;
	    }
	    return BadReplyError;
	}(MessageError));
	exports.BadReplyError = BadReplyError;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var acknowledgment_response_1 = __webpack_require__(520);
	var message_1 = __webpack_require__(516);
	var message_2 = __webpack_require__(516);
	exports.Message = message_2.Message;
	var ReplyVerifyingMessage = (function (_super) {
	    __extends(ReplyVerifyingMessage, _super);
	    function ReplyVerifyingMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReplyVerifyingMessage.prototype.expectsReply = function () {
	        return true;
	    };
	    ReplyVerifyingMessage.prototype.verifyReply = function (reply) {
	        return acknowledgment_response_1.AcknowledgmentResponse.isOk(reply);
	    };
	    return ReplyVerifyingMessage;
	}(message_1.Message));
	exports.ReplyVerifyingMessage = ReplyVerifyingMessage;
	var ReplyMessage = (function (_super) {
	    __extends(ReplyMessage, _super);
	    function ReplyMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReplyMessage.prototype.verify = function () {
	        return this.request.verifyReply(this);
	    };
	    ReplyMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    ReplyMessage.create = function (data, request) {
	        return Object.assign(new ReplyMessage(), data, { request: request });
	    };
	    return ReplyMessage;
	}(message_1.Message));
	exports.ReplyMessage = ReplyMessage;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_tag_1 = __webpack_require__(515);
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var VersionRequest = (function (_super) {
	    __extends(VersionRequest, _super);
	    function VersionRequest(version) {
	        var _this = _super.call(this) || this;
	        _this.version = version;
	        _this.tag = message_tag_1.MessageTag.REQ_VERSION;
	        return _this;
	    }
	    VersionRequest.prototype.expectsReply = function () {
	        return true;
	    };
	    VersionRequest.prototype.verifyReply = function (reply) {
	        return (message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_VERSION)
	            && reply.ok);
	    };
	    VersionRequest.tag = message_tag_1.MessageTag.REQ_VERSION;
	    return VersionRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.VersionRequest = VersionRequest;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var message_tag_1 = __webpack_require__(515);
	var incoming_message_1 = __webpack_require__(522);
	var VersionResponse = (function (_super) {
	    __extends(VersionResponse, _super);
	    function VersionResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_VERSION;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], VersionResponse.prototype, "ok", void 0);
	    VersionResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_VERSION)
	    ], VersionResponse);
	    return VersionResponse;
	}(incoming_message_1.IncomingMessage));
	exports.VersionResponse = VersionResponse;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_tag_1 = __webpack_require__(515);
	var reply_message_1 = __webpack_require__(529);
	var PingRequest = (function (_super) {
	    __extends(PingRequest, _super);
	    function PingRequest(generateMetrics) {
	        if (generateMetrics === void 0) { generateMetrics = false; }
	        var _this = _super.call(this) || this;
	        _this.generateMetrics = generateMetrics;
	        _this.tag = message_tag_1.MessageTag.REQ_PING;
	        return _this;
	    }
	    PingRequest.prototype.expectsReply = function () {
	        return true;
	    };
	    PingRequest.tag = message_tag_1.MessageTag.REQ_PING;
	    return PingRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.PingRequest = PingRequest;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var build_flags_1 = __webpack_require__(534);
	var configuration_service_1 = __webpack_require__(512);
	var auth_1 = __webpack_require__(535);
	var general_1 = __webpack_require__(513);
	var message_validator_1 = __webpack_require__(545);
	var index_1 = __webpack_require__(681);
	var alert_service_1 = __webpack_require__(689);
	var functions_1 = __webpack_require__(206);
	var ring_buffer_1 = __webpack_require__(693);
	var protocol_version_service_1 = __webpack_require__(694);
	var setting_service_1 = __webpack_require__(690);
	var DEFAULT_REPLY_TIMEOUT = 3000;
	var NEGOTIATION_TIMEOUT = 6000;
	var MessagingState;
	(function (MessagingState) {
	    MessagingState[MessagingState["Starting"] = 0] = "Starting";
	    MessagingState[MessagingState["Negotiating"] = 1] = "Negotiating";
	    MessagingState[MessagingState["Ready"] = 2] = "Ready";
	    MessagingState[MessagingState["Restarting"] = 3] = "Restarting";
	    MessagingState[MessagingState["Dead"] = 4] = "Dead";
	})(MessagingState = exports.MessagingState || (exports.MessagingState = {}));
	function stateName(m) {
	    switch (m) {
	        case MessagingState.Starting:
	            return "not yet connected";
	        case MessagingState.Negotiating:
	            return "negotiating";
	        case MessagingState.Ready:
	            return "connected";
	        case MessagingState.Restarting:
	            return "reconnecting";
	        case MessagingState.Dead:
	            return "disconnected";
	    }
	}
	var MessagingFailureType;
	(function (MessagingFailureType) {
	    MessagingFailureType[MessagingFailureType["FeatureAbsence"] = 0] = "FeatureAbsence";
	    MessagingFailureType[MessagingFailureType["SocketCreationFailure"] = 1] = "SocketCreationFailure";
	    MessagingFailureType[MessagingFailureType["RemoteAddressPermissions"] = 2] = "RemoteAddressPermissions";
	    MessagingFailureType[MessagingFailureType["NegotiationFailure"] = 3] = "NegotiationFailure";
	    MessagingFailureType[MessagingFailureType["AdminAction"] = 4] = "AdminAction";
	    MessagingFailureType[MessagingFailureType["BadData"] = 5] = "BadData";
	    MessagingFailureType[MessagingFailureType["Unknown"] = 6] = "Unknown";
	})(MessagingFailureType || (MessagingFailureType = {}));
	var MessagingService = (function () {
	    function MessagingService(config, alerts, protocolVersionService, settings) {
	        var _this = this;
	        this.config = config;
	        this.alerts = alerts;
	        this.protocolVersionService = protocolVersionService;
	        this.settings = settings;
	        this.state = MessagingState.Starting;
	        this.ready = new Rx_1.BehaviorSubject(false);
	        this.connectionId = 1;
	        this.recentLog = new ring_buffer_1.RingBuffer(30);
	        this.recentPingsRTT = new ring_buffer_1.RingBuffer(10);
	        this.lastPingSuccessful = null;
	        this.retryOnFail = true;
	        this.retryDelayRandomization = 0;
	        this._retryDelay = 5;
	        this._deadRetryDelay = 15;
	        this._deadRetryExponent = 0;
	        this.retryLimit = 5;
	        this.retryCount = 0;
	        this.restartCount = 0;
	        this.restartLimit = 5;
	        this.idAllocator = 0;
	        this.handledTags = [];
	        this.unclaimed = [];
	        this.buildUrl();
	        this.startConnection();
	        this.ready.subscribe(function (b) {
	            console.info(b ? "READY" : "NOT READY");
	            if (!b) {
	                _this.protocolVersionService.reset();
	                _this.handledTags = [];
	            }
	        });
	        var heartbeat = this.settings.get("connection heartbeat");
	        if (heartbeat > 0) {
	            setInterval(function () {
	                if (_this.state === MessagingState.Ready) {
	                    var pingSent_1 = Date.now();
	                    _this.send(new general_1.PingRequest()).subscribe(function (r) {
	                        _this.lastPingSuccessful = general_1.AcknowledgmentResponse.isOk(r);
	                        if (_this.lastPingSuccessful) {
	                            var RTT = Date.now() - pingSent_1;
	                            _this.checkDeficientPing(RTT);
	                            _this.recentPingsRTT.add(RTT);
	                        }
	                    });
	                }
	            }, heartbeat * 60000);
	        }
	    }
	    MessagingService.prototype.pingStats = function () {
	        var pings = this.recentPingsRTT.list();
	        var n = pings.length;
	        if (n === 0) {
	            return [1, Number.MAX_SAFE_INTEGER];
	        }
	        var mean = pings.reduce(function (a, b) { return a + b; }) / n;
	        return [
	            mean,
	            pings.reduce(function (prev, current) { return prev + Math.pow(current - mean, 2); })
	                / (n - 1)
	        ];
	    };
	    MessagingService.prototype.checkDeficientPing = function (newPing) {
	        var minimumForCheck = 5;
	        var varianceThreshold = Math.sqrt(3);
	        var msRequiredForAlert = 50;
	        if (this.recentPingsRTT.size() < minimumForCheck) {
	            return;
	        }
	        var _a = this.pingStats(), mean = _a[0], variance = _a[1];
	        if (newPing > msRequiredForAlert
	            && Math.abs((newPing - mean) / variance) > varianceThreshold) {
	            this.alerts.warnAndReplace(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["You may be experiencing connection issues. (Your last heartbeat\n          took ", "ms compared to an average of ", "ms.)"], ["You may be experiencing connection issues. (Your last heartbeat\n          took ", "ms compared to an average of ", "ms.)"])), newPing, mean), "slowPing");
	        }
	    };
	    MessagingService.prototype.buildUrl = function () {
	        var host = this.config.protocol.socketHost || location.hostname;
	        var protocol = this.config.protocol.socketProtocol ||
	            ((location.protocol === "https:") ? "wss:" : "ws:");
	        var port = (build_flags_1.BuildFlags.useProductionHostValues
	            ? this.config.protocol.socketPort
	            : this.config.protocol.devSocketPort);
	        this.socketUrl = protocol + "//" + host + ":" + port + "/";
	    };
	    MessagingService.prototype.be = function (state) {
	        console.warn("attempting state: " + stateName(this.state) + "\u2192" + stateName(state));
	        if (this.state === state) {
	            return state;
	        }
	        if (this.state === MessagingState.Dead || state === MessagingState.Starting) {
	            throw new Error("MessagingService attempted an illegal state transition");
	        }
	        if (this.state === MessagingState.Ready) {
	            this.ready.next(false);
	            return this.state = state;
	        }
	        if (state === MessagingState.Ready) {
	            this.ready.next(true);
	            return this.state = state;
	        }
	    };
	    Object.defineProperty(MessagingService.prototype, "retryDelay", {
	        get: function () {
	            if (!this.retryDelayRandomization) {
	                return this._retryDelay;
	            }
	            return Math.ceil(this._retryDelay
	                - this.retryDelayRandomization
	                + 2 * Math.random() * this.retryDelayRandomization);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MessagingService.prototype, "deadRetryDelay", {
	        get: function () {
	            return this._deadRetryDelay * Math.pow(2, this._deadRetryExponent++);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MessagingService.prototype.buildConnection = function () {
	        var trueConnection = new index_1.WebSocketConnection(this.socketUrl, new auth_1.DisconnectUpstreamMessage(this.nextId), this.connectionId++);
	        if (build_flags_1.BuildFlags.debugMode) {
	            this.mockInput = new index_1.MockConnection();
	            this.connection = new index_1.CompositeConnection([
	                new message_validator_1.MessageValidator(trueConnection),
	                new message_validator_1.MessageValidator(this.mockInput)
	            ]);
	        }
	        else {
	            this.connection = new message_validator_1.MessageValidator(trueConnection);
	        }
	        this.incoming = this.connection.incoming;
	    };
	    MessagingService.prototype.startConnection = function () {
	        var _this = this;
	        console.info("Starting websocket connection #" + this.connectionId);
	        this.buildConnection();
	        this.subscription = this.incoming.subscribe(function (message) { return null; }, function (error) { return _this.incomingError(error); }, function () { return _this.incomingComplete(); });
	        var logSub = this.incoming.materialize().map(function (event) { return (event.kind === "N")
	            ? Object.assign({ timestamp: Date.now() }, event.value)
	            : new general_1.InternalMessage("Socket closed"); }).subscribe(function (m) { return _this.recentLog.add(m); });
	        var unhandledSub = this.incoming
	            .filter(function (m) {
	            return (m.id < 0) && (_this.handledTags.indexOf(m.tag) === -1);
	        })
	            .subscribe(function (m) { return _this.nonconversational(m); });
	        this.subscription.add(unhandledSub).add(logSub);
	        this.negotiate();
	    };
	    MessagingService.prototype.negotiate = function () {
	        var _this = this;
	        this.be(MessagingState.Negotiating);
	        var attempt = this.protocolVersionService.negotiate(function (m) {
	            m.meta.timeout = NEGOTIATION_TIMEOUT;
	            return _this.send(m);
	        });
	        attempt.subscribe(function (result) {
	            return result ? _this.be(MessagingState.Ready) : _this.be(MessagingState.Dead);
	        });
	    };
	    MessagingService.prototype.releaseConnection = function () {
	        this.subscription.unsubscribe();
	        if (!this.connection.dead) {
	            this.connection.close();
	        }
	        this.connection = index_1.EMPTY;
	    };
	    MessagingService.prototype.incomingComplete = function () {
	        this.alerts.errorAndReplace(functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      You have been disconnected from the server!\n      If you have any unsaved work below, consider copying it elsewhere for use\n      when you reconnect."], ["\n      You have been disconnected from the server!\n      If you have any unsaved work below, consider copying it elsewhere for use\n      when you reconnect."]))), "disconnect");
	        console.log("Websocket incoming stream has ended.");
	        if (this.retryOnFail) {
	            this.retryConnection();
	        }
	    };
	    MessagingService.prototype.incomingError = function (reason) {
	        if (reason instanceof general_1.ConnectionFailureMessage) {
	            this.retryConnection(true);
	        }
	        else {
	            throw new Error("Internal stream threw error (unexpected behavior)");
	        }
	    };
	    MessagingService.prototype.retryConnection = function (wasInitial) {
	        var _this = this;
	        if (wasInitial === void 0) { wasInitial = false; }
	        if (this.state === MessagingState.Restarting) {
	            return;
	        }
	        this.be(MessagingState.Restarting);
	        this.releaseConnection();
	        this.retryCount++;
	        if (this.retryCount >= this.retryLimit) {
	            this.alerts.error("Connection retry limit reached! You must restart to try again.");
	            this.be(MessagingState.Dead);
	            return;
	        }
	        var preamble = wasInitial
	            ? "Could not connect to the server; retrying"
	            : "Connection closed; restarting";
	        var delay = wasInitial
	            ? this.deadRetryDelay
	            : this.retryDelay;
	        if (delay === 0) {
	            this.alerts.warn(preamble + " [attempt #" + this.retryCount + "]");
	            this.startConnection();
	        }
	        else {
	            this.alerts.add({
	                type: "countdown",
	                timeout: delay * 1000,
	                message: preamble + " in " + delay
	                    + " seconds [attempt #" + this.retryCount + "]",
	                action: function () { return _this.restart(false); },
	                actionLabel: "Restart now"
	            });
	            this.retryTimeout = setTimeout(function () { return _this.startConnection(); }, delay * 1000);
	        }
	    };
	    MessagingService.prototype.abort = function () {
	        this.be(MessagingState.Dead);
	        this.releaseConnection();
	    };
	    MessagingService.prototype.restart = function (release, userInitiated) {
	        if (release === void 0) { release = true; }
	        if (userInitiated === void 0) { userInitiated = false; }
	        if (!userInitiated) {
	            this.restartCount += 1;
	        }
	        this.lastRestart = new Date();
	        if (this.restartCount >= this.restartLimit) {
	            this.alerts.error("Connection restart limit reached! Please close the app to try again.");
	            this.be(MessagingState.Dead);
	            return;
	        }
	        this.be(MessagingState.Restarting);
	        if (release) {
	            this.releaseConnection();
	        }
	        if (this.retryTimeout) {
	            clearTimeout(this.retryTimeout);
	        }
	        this.startConnection();
	    };
	    Object.defineProperty(MessagingService.prototype, "nextId", {
	        get: function () {
	            return this.idAllocator++;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MessagingService.prototype.catchRepliesAfter = function (request, count) {
	        if (count === void 0) { count = 1; }
	        var catchSub = this.incoming.filter(function (m) { return m.id === request.id; })
	            .skip(count).subscribe(function (extraneous) {
	            console.error("Unexpected reply:", extraneous);
	            throw new Error("Server returned too many replies for message #" + request.id);
	        });
	        this.subscription.add(catchSub);
	    };
	    MessagingService.prototype.firstReplyTo = function (message) {
	        var _this = this;
	        var timeout = message.meta.timeout || DEFAULT_REPLY_TIMEOUT;
	        return this.incoming.first(function (response) { return response.id === message.id; })
	            .map(function (reply) { return general_1.ReplyMessage.create(reply, message); })
	            .catch(function (err, caught) {
	            if (err instanceof general_1.ReplyTimeoutError) {
	                _this.alerts.error("The server could not respond to a request in time\n            and may have encountered a fatal error.");
	                console.error("Timeout on message", message);
	            }
	            return (err instanceof Rx_1.EmptyError)
	                ? Rx_1.Observable.throw(new general_1.MissingReplyError(message))
	                : Rx_1.Observable.throw(err);
	        });
	    };
	    MessagingService.prototype.send = function (message) {
	        var _this = this;
	        message.id = this.nextId;
	        var logEntity = { id: 0, tag: 0, outgoing: true, timestamp: Date.now() };
	        this.recentLog.add(Object.assign(logEntity, message));
	        return Rx_1.Observable.create(function (observer) {
	            _this.connection.send(message);
	            if (message.meta.allowUnboundedReplies) {
	                console.warn("Sending message without bounds on replies!", message);
	                _this.repliesTo(message).subscribe(observer);
	            }
	            else if (message.expectsReply()) {
	                _this.catchRepliesAfter(message, 1);
	                _this.firstReplyTo(message).subscribe(observer);
	            }
	            else {
	                _this.catchRepliesAfter(message, 0);
	                observer.complete();
	            }
	        }).share();
	    };
	    MessagingService.prototype.converse = function (message, error) {
	        return this.send(message).map(function (reply) {
	            if (message.verifyReply(reply)) {
	                return reply;
	            }
	            else {
	                if (error) {
	                    error(reply);
	                }
	                else {
	                    console.error("Reply failed request's validation:", message, reply);
	                    throw new general_1.BadReplyError(message, reply);
	                }
	            }
	        });
	    };
	    MessagingService.prototype.resultOf = function (message, notify) {
	        var _this = this;
	        if (notify === void 0) { notify = false; }
	        return this.send(message).map(function (reply) {
	            var verified = message.verifyReply(reply);
	            if (!verified) {
	                var reasonText = reply.reason;
	                if (reasonText && notify) {
	                    _this.alerts.error(functions_1.escapeForHTML(reasonText));
	                }
	            }
	            return verified;
	        });
	    };
	    MessagingService.prototype.successful = function (message) {
	        function verifyOrError(r) {
	            if (!message.verifyReply(r)) {
	                throw new general_1.BadReplyError(message, r);
	            }
	            return true;
	        }
	        return this.converse(message).map(verifyOrError);
	    };
	    MessagingService.prototype.receive = function (filter, ignoreConversational) {
	        if (ignoreConversational === void 0) { ignoreConversational = false; }
	        var tag = (typeof filter === "number") ? filter : filter.tag;
	        this.handledTags.push(tag);
	        return this.incoming.filter(function (message) {
	            return (message.tag === tag)
	                && (!ignoreConversational || message.id < 0);
	        });
	    };
	    MessagingService.prototype.receiveAnyOf = function (tags) {
	        this.handledTags = this.handledTags.concat(tags);
	        return this.incoming.filter(function (message) { return (tags.indexOf(message.tag) > -1); });
	    };
	    MessagingService.prototype.repliesTo = function (idOrMsg) {
	        var id = (typeof idOrMsg === "number") ? idOrMsg : idOrMsg.id;
	        return this.incoming.filter(function (m) { return m.id === id; });
	    };
	    MessagingService.prototype.nextOfType = function (filter, timeLimit) {
	        var tag = (typeof filter === "number") ? filter : filter.tag;
	        if (timeLimit === undefined) {
	            return this.incoming.first(function (m) { return m.tag === tag; });
	        }
	        return this.incoming.first(function (m) { return m.tag === tag; })
	            .timeout(timeLimit);
	    };
	    MessagingService.prototype.nonconversational = function (message) {
	        console.warn("Server message did not have a local listener:", message);
	        this.unclaimed.push(message);
	    };
	    MessagingService.prototype.receiveMissed = function (tag) {
	        return Rx_1.Observable.from(this.unclaimed.filter(function (m) { return general_1.Message.isA(m, tag); }));
	    };
	    MessagingService.prototype.downloadFile = function (token, secret, type) {
	        return (new index_1.DownloadSocket(this.socketUrl, token, secret, type)).completion;
	    };
	    MessagingService.prototype.sendSideChannelOneOff = function (message) {
	        var connection = new index_1.WebSocketConnection(this.socketUrl, new auth_1.DisconnectUpstreamMessage(-1), -1);
	        var localId = 1;
	        var negotiation = this.protocolVersionService.negotiate(function (m) {
	            m.meta.timeout = NEGOTIATION_TIMEOUT;
	            m.id = localId++;
	            connection.send(m);
	            return connection.incoming.first(function (response) { return response.id === m.id; })
	                .map(function (reply) { return general_1.ReplyMessage.create(reply, message); });
	        });
	        return negotiation.map(function (success) {
	            if (success) {
	                message.id = localId++;
	                connection.send(message);
	                setTimeout(function () { return connection.close(); }, 2000);
	            }
	            return success;
	        });
	        ;
	    };
	    MessagingService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService,
	            alert_service_1.AlertService,
	            protocol_version_service_1.ProtocolVersionService,
	            setting_service_1.SettingService])
	    ], MessagingService);
	    return MessagingService;
	}());
	exports.MessagingService = MessagingService;
	var templateObject_1, templateObject_2;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BuildFlags = (function () {
	    function BuildFlags() {
	    }
	    BuildFlags.debugMode = (false) || false;
	    BuildFlags.effectiveDebugMode = BuildFlags.debugMode;
	    BuildFlags.useProductionHostValues = !!(true);
	    return BuildFlags;
	}());
	exports.BuildFlags = BuildFlags;
	console.info("Application is running in " + ( false ? "debug" : "standard") + " mode for " +
	    (( true ? "nginx" : "simulated") + " server"));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var active_sessions_response_1 = __webpack_require__(536);
	exports.ActiveSessionsResponse = active_sessions_response_1.ActiveSessionsResponse;
	var auth_token_login_request_1 = __webpack_require__(537);
	exports.AuthTokenLoginRequest = auth_token_login_request_1.AuthTokenLoginRequest;
	var auth_token_request_1 = __webpack_require__(538);
	exports.AuthTokenRequest = auth_token_request_1.AuthTokenRequest;
	var auth_token_response_1 = __webpack_require__(539);
	exports.AuthTokenResponse = auth_token_response_1.AuthTokenResponse;
	var disconnect_downstream_message_1 = __webpack_require__(540);
	exports.DisconnectDownstreamMessage = disconnect_downstream_message_1.DisconnectDownstreamMessage;
	var disconnect_upstream_message_1 = __webpack_require__(541);
	exports.DisconnectUpstreamMessage = disconnect_upstream_message_1.DisconnectUpstreamMessage;
	var login_request_1 = __webpack_require__(542);
	exports.LoginRequest = login_request_1.LoginRequest;
	var start_guest_session_request_1 = __webpack_require__(543);
	exports.StartGuestSessionRequest = start_guest_session_request_1.StartGuestSessionRequest;
	var terminate_active_sessions_request_1 = __webpack_require__(544);
	exports.TerminateActiveSessionsRequest = terminate_active_sessions_request_1.TerminateActiveSessionsRequest;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var general_1 = __webpack_require__(513);
	var ActiveSessionsResponse = (function (_super) {
	    __extends(ActiveSessionsResponse, _super);
	    function ActiveSessionsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = general_1.MessageTag.RSP_ACTIVE_SESSIONS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], ActiveSessionsResponse.prototype, "sessionCount", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ActiveSessionsResponse.prototype, "channels", void 0);
	    ActiveSessionsResponse = __decorate([
	        decorators_1.validateFor(general_1.MessageTag.RSP_ACTIVE_SESSIONS)
	    ], ActiveSessionsResponse);
	    return ActiveSessionsResponse;
	}(general_1.IncomingMessage));
	exports.ActiveSessionsResponse = ActiveSessionsResponse;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AuthTokenLoginRequest = (function (_super) {
	    __extends(AuthTokenLoginRequest, _super);
	    function AuthTokenLoginRequest(token) {
	        var _this = _super.call(this) || this;
	        _this.token = token;
	        _this.tag = message_tag_1.MessageTag.REQ_AUTH_TOKEN_LOGIN;
	        return _this;
	    }
	    AuthTokenLoginRequest.tag = message_tag_1.MessageTag.REQ_AUTH_TOKEN_LOGIN;
	    return AuthTokenLoginRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AuthTokenLoginRequest = AuthTokenLoginRequest;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AuthTokenRequest = (function (_super) {
	    __extends(AuthTokenRequest, _super);
	    function AuthTokenRequest() {
	        var _this = _super.call(this) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_AUTH_TOKEN;
	        return _this;
	    }
	    AuthTokenRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_AUTH_TOKEN);
	    };
	    AuthTokenRequest.tag = message_tag_1.MessageTag.REQ_AUTH_TOKEN;
	    return AuthTokenRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AuthTokenRequest = AuthTokenRequest;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AuthTokenResponse = (function (_super) {
	    __extends(AuthTokenResponse, _super);
	    function AuthTokenResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_AUTH_TOKEN;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AuthTokenResponse.prototype, "token", void 0);
	    AuthTokenResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_AUTH_TOKEN)
	    ], AuthTokenResponse);
	    return AuthTokenResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AuthTokenResponse = AuthTokenResponse;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var response_code_1 = __webpack_require__(527);
	var message_tag_1 = __webpack_require__(515);
	var DisconnectDownstreamMessage = (function (_super) {
	    __extends(DisconnectDownstreamMessage, _super);
	    function DisconnectDownstreamMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.DOWN_DISCONNECT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateTSEnum(response_code_1.ResponseCode),
	        __metadata("design:type", Number)
	    ], DisconnectDownstreamMessage.prototype, "code", void 0);
	    DisconnectDownstreamMessage = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.DOWN_DISCONNECT)
	    ], DisconnectDownstreamMessage);
	    return DisconnectDownstreamMessage;
	}(incoming_message_1.IncomingMessage));
	exports.DisconnectDownstreamMessage = DisconnectDownstreamMessage;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var DisconnectUpstreamMessage = (function (_super) {
	    __extends(DisconnectUpstreamMessage, _super);
	    function DisconnectUpstreamMessage(id) {
	        if (id === void 0) { id = 0; }
	        var _this = _super.call(this) || this;
	        _this.id = id;
	        _this.tag = message_tag_1.MessageTag.UP_DISCONNECT;
	        return _this;
	    }
	    DisconnectUpstreamMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    DisconnectUpstreamMessage.tag = message_tag_1.MessageTag.UP_DISCONNECT;
	    return DisconnectUpstreamMessage;
	}(message_1.Message));
	exports.DisconnectUpstreamMessage = DisconnectUpstreamMessage;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var LoginRequest = (function (_super) {
	    __extends(LoginRequest, _super);
	    function LoginRequest(login, password) {
	        var _this = _super.call(this) || this;
	        _this.login = login;
	        _this.password = password;
	        _this.tag = message_tag_1.MessageTag.REQ_LOGIN;
	        return _this;
	    }
	    LoginRequest.prototype.expectsReply = function () {
	        return true;
	    };
	    LoginRequest.tag = message_tag_1.MessageTag.REQ_LOGIN;
	    return LoginRequest;
	}(message_1.Message));
	exports.LoginRequest = LoginRequest;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StartGuestSessionRequest = (function (_super) {
	    __extends(StartGuestSessionRequest, _super);
	    function StartGuestSessionRequest(isEmbedded, embeddedURL) {
	        if (isEmbedded === void 0) { isEmbedded = false; }
	        if (embeddedURL === void 0) { embeddedURL = ""; }
	        var _this = _super.call(this) || this;
	        _this.isEmbedded = isEmbedded;
	        _this.embeddedURL = embeddedURL;
	        _this.tag = message_tag_1.MessageTag.REQ_START_GUEST_SESSION;
	        return _this;
	    }
	    StartGuestSessionRequest.tag = message_tag_1.MessageTag.REQ_START_GUEST_SESSION;
	    return StartGuestSessionRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StartGuestSessionRequest = StartGuestSessionRequest;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var TerminateActiveSessionsRequest = (function (_super) {
	    __extends(TerminateActiveSessionsRequest, _super);
	    function TerminateActiveSessionsRequest(includeSelf) {
	        if (includeSelf === void 0) { includeSelf = true; }
	        var _this = _super.call(this) || this;
	        _this.includeSelf = includeSelf;
	        _this.tag = general_1.MessageTag.REQ_TERMINATE_ACTIVE_SESSIONS;
	        return _this;
	    }
	    TerminateActiveSessionsRequest.prototype.expectsReply = function () { return true; };
	    TerminateActiveSessionsRequest.tag = general_1.MessageTag.REQ_TERMINATE_ACTIVE_SESSIONS;
	    return TerminateActiveSessionsRequest;
	}(general_1.Message));
	exports.TerminateActiveSessionsRequest = TerminateActiveSessionsRequest;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var connection_1 = __webpack_require__(546);
	var general_1 = __webpack_require__(513);
	var incoming_message_map_1 = __webpack_require__(547);
	var MessageValidator = (function (_super) {
	    __extends(MessageValidator, _super);
	    function MessageValidator(connection) {
	        var _this = _super.call(this) || this;
	        _this.connection = connection;
	        _this.incoming = new Rx_1.Subject();
	        _this.localDead = false;
	        _this.connection.incoming.map(function (json) { return _this.validate(json); }).catch(function (err, caught) {
	            if (err instanceof general_1.ConnectionFailureMessage) {
	                throw err;
	            }
	            else {
	                console.error("skipping message due to validation error:", err);
	                return caught;
	            }
	        }).subscribe(_this.incoming);
	        return _this;
	    }
	    Object.defineProperty(MessageValidator.prototype, "dead", {
	        get: function () {
	            return this.connection.dead || this.localDead;
	        },
	        set: function (value) {
	            this.localDead = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MessageValidator.prototype.validate = function (json) {
	        if (typeof json !== "object" || json === null) {
	            console.error("non-object", json);
	            throw new Error("Received non-object on incoming stream");
	        }
	        if (!Number.isInteger(json.tag)) {
	            console.error("non-integer or missing tag", json);
	            throw new Error("Received message does not have an integer 'tag'");
	        }
	        return this.validateTagged(json);
	    };
	    MessageValidator.prototype.validateTagged = function (json) {
	        var messageClass = incoming_message_map_1.INCOMING_MESSAGE_MAP.get(json.tag);
	        if (messageClass === undefined) {
	            console.error("no validator found", json);
	            return json;
	        }
	        try {
	            return new messageClass(json);
	        }
	        catch (err) {
	            console.error(err, json);
	            throw err;
	        }
	    };
	    MessageValidator.prototype.close = function () {
	        this.connection.close();
	    };
	    MessageValidator.prototype.send = function (message) {
	        this.connection.send(message);
	    };
	    return MessageValidator;
	}(connection_1.Connection));
	exports.MessageValidator = MessageValidator;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Connection = (function () {
	    function Connection() {
	        this.dead = false;
	    }
	    return Connection;
	}());
	exports.Connection = Connection;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Admin = __webpack_require__(548);
	var Aggregation = __webpack_require__(565);
	var Algorithms = __webpack_require__(576);
	var Auth = __webpack_require__(535);
	var Collaboration = __webpack_require__(592);
	var Contexts = __webpack_require__(604);
	var Debug = __webpack_require__(613);
	var Export = __webpack_require__(618);
	var General = __webpack_require__(513);
	var Groups = __webpack_require__(629);
	var Metadata = __webpack_require__(637);
	var Reminders = __webpack_require__(642);
	var Schemas = __webpack_require__(646);
	var Search = __webpack_require__(654);
	var Subjects = __webpack_require__(660);
	var Watchlists = __webpack_require__(671);
	exports.INCOMING_MESSAGE_MAP = new Map();
	exports.OUTGOING_MESSAGE_MAP = new Map();
	[].concat.apply([], [
	    Admin,
	    Aggregation,
	    Algorithms,
	    Auth,
	    Collaboration,
	    Contexts,
	    Debug,
	    Export,
	    General,
	    Groups,
	    Metadata,
	    Reminders,
	    Schemas,
	    Search,
	    Subjects,
	    Watchlists
	].map(function (mod) { return Object.values(mod); })).filter(function (imported) {
	    return (typeof imported === "function") && (Number.isInteger(imported.tag));
	})
	    .forEach(function (imported) {
	    if (imported.selfValidates === true) {
	        exports.INCOMING_MESSAGE_MAP.set(imported.tag, imported);
	    }
	    else {
	        exports.OUTGOING_MESSAGE_MAP.set(imported.tag, imported);
	    }
	});
	console.info("incoming message map ⤵\n", exports.INCOMING_MESSAGE_MAP);
	console.info("outgoing message map ⤵\n", exports.OUTGOING_MESSAGE_MAP);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var admin_client_list_broadcast_1 = __webpack_require__(549);
	exports.AdminClientListBroadcast = admin_client_list_broadcast_1.AdminClientListBroadcast;
	var announcement_request_1 = __webpack_require__(550);
	exports.AnnouncementRequest = announcement_request_1.AnnouncementRequest;
	var announcement_broadcast_1 = __webpack_require__(551);
	exports.AnnouncementBroadcast = announcement_broadcast_1.AnnouncementBroadcast;
	var app_configuration_request_1 = __webpack_require__(552);
	exports.AppConfigurationRequest = app_configuration_request_1.AppConfigurationRequest;
	var app_configuration_response_1 = __webpack_require__(553);
	exports.AppConfigurationResponse = app_configuration_response_1.AppConfigurationResponse;
	var app_status_request_1 = __webpack_require__(554);
	exports.AppStatusRequest = app_status_request_1.AppStatusRequest;
	var app_status_response_1 = __webpack_require__(555);
	exports.AppStatusResponse = app_status_response_1.AppStatusResponse;
	var clients_status_request_1 = __webpack_require__(556);
	exports.ClientsStatusRequest = clients_status_request_1.ClientsStatusRequest;
	var clients_status_response_1 = __webpack_require__(557);
	exports.ClientsStatusResponse = clients_status_response_1.ClientsStatusResponse;
	var debug_mode_requests_1 = __webpack_require__(558);
	exports.DebugModeConfigurationRequest = debug_mode_requests_1.DebugModeConfigurationRequest;
	exports.DebugCodeGenModeConfigurationRequest = debug_mode_requests_1.DebugCodeGenModeConfigurationRequest;
	var kill_client_request_1 = __webpack_require__(559);
	exports.KillClientRequest = kill_client_request_1.KillClientRequest;
	var notify_downstream_message_1 = __webpack_require__(560);
	exports.NotificationLevel = notify_downstream_message_1.NotificationLevel;
	exports.NotifyDownstreamMessage = notify_downstream_message_1.NotifyDownstreamMessage;
	var quarantine_configuration_request_1 = __webpack_require__(561);
	exports.QuarantineConfigurationRequest = quarantine_configuration_request_1.QuarantineConfigurationRequest;
	var quarantine_configuration_response_1 = __webpack_require__(562);
	exports.QuarantineConfigurationResponse = quarantine_configuration_response_1.QuarantineConfigurationResponse;
	var shutdown_request_1 = __webpack_require__(563);
	exports.ShutdownRequest = shutdown_request_1.ShutdownRequest;
	var shutdown_response_1 = __webpack_require__(564);
	exports.ShutdownResponse = shutdown_response_1.ShutdownResponse;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AdminClientListBroadcast = (function (_super) {
	    __extends(AdminClientListBroadcast, _super);
	    function AdminClientListBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_ADMIN_CLIENT_LIST;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AdminClientListBroadcast.prototype, "changedId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AdminClientListBroadcast.prototype, "adminChannels", void 0);
	    AdminClientListBroadcast = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.BCST_ADMIN_CLIENT_LIST)
	    ], AdminClientListBroadcast);
	    return AdminClientListBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.AdminClientListBroadcast = AdminClientListBroadcast;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AnnouncementRequest = (function (_super) {
	    __extends(AnnouncementRequest, _super);
	    function AnnouncementRequest(message) {
	        var _this = _super.call(this) || this;
	        _this.message = message;
	        _this.tag = message_tag_1.MessageTag.REQ_ANNOUNCEMENT;
	        return _this;
	    }
	    AnnouncementRequest.tag = message_tag_1.MessageTag.REQ_ANNOUNCEMENT;
	    return AnnouncementRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AnnouncementRequest = AnnouncementRequest;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AnnouncementBroadcast = (function (_super) {
	    __extends(AnnouncementBroadcast, _super);
	    function AnnouncementBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_ANNOUNCEMENT;
	        return _this;
	    }
	    return AnnouncementBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.AnnouncementBroadcast = AnnouncementBroadcast;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AppConfigurationRequest = (function (_super) {
	    __extends(AppConfigurationRequest, _super);
	    function AppConfigurationRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_CFG_APP;
	        return _this;
	    }
	    AppConfigurationRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_CFG_APP);
	    };
	    AppConfigurationRequest.tag = message_tag_1.MessageTag.REQ_CFG_APP;
	    return AppConfigurationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AppConfigurationRequest = AppConfigurationRequest;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AppConfigurationResponse = (function (_super) {
	    __extends(AppConfigurationResponse, _super);
	    function AppConfigurationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CFG_APP;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AppConfigurationResponse.prototype, "developmentMode", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "string" }),
	        __metadata("design:type", Array)
	    ], AppConfigurationResponse.prototype, "errorNotificationEmails", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AppConfigurationResponse.prototype, "filterLocation", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 1 }, { max: 65535 }]),
	        __metadata("design:type", Number)
	    ], AppConfigurationResponse.prototype, "listenPort", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AppConfigurationResponse.prototype, "listenHost", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AppConfigurationResponse.prototype, "jars", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, true),
	        __metadata("design:type", Array)
	    ], AppConfigurationResponse.prototype, "roles", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AppConfigurationResponse.prototype, "rules", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AppConfigurationResponse.prototype, "zones", void 0);
	    __decorate([
	        decorators_1.validateAs("object"),
	        __metadata("design:type", Object)
	    ], AppConfigurationResponse.prototype, "indices", void 0);
	    AppConfigurationResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CFG_APP)
	    ], AppConfigurationResponse);
	    return AppConfigurationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AppConfigurationResponse = AppConfigurationResponse;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AppStatusRequest = (function (_super) {
	    __extends(AppStatusRequest, _super);
	    function AppStatusRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_STATUS_APP;
	        return _this;
	    }
	    AppStatusRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_STATUS_APP);
	    };
	    AppStatusRequest.tag = message_tag_1.MessageTag.REQ_STATUS_APP;
	    return AppStatusRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AppStatusRequest = AppStatusRequest;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AppStatusResponse = (function (_super) {
	    __extends(AppStatusResponse, _super);
	    function AppStatusResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STATUS_APP;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AppStatusResponse.prototype, "debugMode", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AppStatusResponse.prototype, "codeGenDebugMode", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AppStatusResponse.prototype, "administrativelyLocked", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "timeUntilAdministrativelyLocked", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AppStatusResponse.prototype, "adminRequestingLock", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "timeUntilShutdown", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AppStatusResponse.prototype, "adminRequestingShutdown", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], AppStatusResponse.prototype, "databaseConnected", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }]),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "activeAuthenticatedChannelCount", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }]),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "loggedInUserCount", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }]),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "unauthenticatedActiveChannelCount", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AppStatusResponse.prototype, "startTime", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AppStatusResponse.prototype, "caches", void 0);
	    AppStatusResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STATUS_APP)
	    ], AppStatusResponse);
	    return AppStatusResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AppStatusResponse = AppStatusResponse;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ClientsStatusRequest = (function (_super) {
	    __extends(ClientsStatusRequest, _super);
	    function ClientsStatusRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_STATUS_CLIENTS;
	        return _this;
	    }
	    ClientsStatusRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_STATUS_CLIENTS);
	    };
	    ClientsStatusRequest.tag = message_tag_1.MessageTag.REQ_STATUS_CLIENTS;
	    return ClientsStatusRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ClientsStatusRequest = ClientsStatusRequest;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SERVER_STATES = [
	    "VERSION_NEGOTIATION",
	    "UNAUTHENTICATED",
	    "DISCONNECTED",
	    "DISCONNECTING",
	    "AUTHENTICATED",
	    "PASSWORD_RESET",
	    "SET_NEW_CREDENTIALS",
	    "ALGORITHM_RUNNING"
	];
	var ClientsStatusResponse = (function (_super) {
	    __extends(ClientsStatusResponse, _super);
	    function ClientsStatusResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STATUS_CLIENTS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ClientsStatusResponse.prototype, "unauthenticated", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ClientsStatusResponse.prototype, "authenticated", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], ClientsStatusResponse.prototype, "currentIpAddress", void 0);
	    ClientsStatusResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STATUS_CLIENTS)
	    ], ClientsStatusResponse);
	    return ClientsStatusResponse;
	}(incoming_message_1.IncomingMessage));
	exports.ClientsStatusResponse = ClientsStatusResponse;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DebugModeConfigurationRequest = (function (_super) {
	    __extends(DebugModeConfigurationRequest, _super);
	    function DebugModeConfigurationRequest(enableDebug) {
	        var _this = _super.call(this) || this;
	        _this.enableDebug = enableDebug;
	        _this.tag = message_tag_1.MessageTag.DBG_REQ_CFG_MODE;
	        return _this;
	    }
	    DebugModeConfigurationRequest.tag = message_tag_1.MessageTag.DBG_REQ_CFG_MODE;
	    return DebugModeConfigurationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DebugModeConfigurationRequest = DebugModeConfigurationRequest;
	var DebugCodeGenModeConfigurationRequest = (function (_super) {
	    __extends(DebugCodeGenModeConfigurationRequest, _super);
	    function DebugCodeGenModeConfigurationRequest(enableDebug) {
	        var _this = _super.call(this) || this;
	        _this.enableDebug = enableDebug;
	        _this.tag = message_tag_1.MessageTag.DBG_REQ_CFG_CODE_GEN_MODE;
	        return _this;
	    }
	    DebugCodeGenModeConfigurationRequest.tag = message_tag_1.MessageTag.DBG_REQ_CFG_CODE_GEN_MODE;
	    return DebugCodeGenModeConfigurationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DebugCodeGenModeConfigurationRequest = DebugCodeGenModeConfigurationRequest;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var KillClientRequest = (function (_super) {
	    __extends(KillClientRequest, _super);
	    function KillClientRequest(channelId) {
	        var _this = _super.call(this) || this;
	        _this.channelId = channelId;
	        _this.tag = message_tag_1.MessageTag.REQ_KILL_CLIENT;
	        return _this;
	    }
	    KillClientRequest.tag = message_tag_1.MessageTag.REQ_KILL_CLIENT;
	    return KillClientRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.KillClientRequest = KillClientRequest;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var NotificationLevel;
	(function (NotificationLevel) {
	    NotificationLevel[NotificationLevel["Info"] = 0] = "Info";
	    NotificationLevel[NotificationLevel["Urgent"] = 1] = "Urgent";
	    NotificationLevel[NotificationLevel["Error"] = 2] = "Error";
	})(NotificationLevel = exports.NotificationLevel || (exports.NotificationLevel = {}));
	var NotificationSource;
	(function (NotificationSource) {
	    NotificationSource[NotificationSource["Admin"] = 0] = "Admin";
	    NotificationSource[NotificationSource["Server"] = 1] = "Server";
	})(NotificationSource = exports.NotificationSource || (exports.NotificationSource = {}));
	var NotifyDownstreamMessage = (function (_super) {
	    __extends(NotifyDownstreamMessage, _super);
	    function NotifyDownstreamMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.DOWN_NOTIFY;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], NotifyDownstreamMessage.prototype, "message", void 0);
	    __decorate([
	        decorators_1.validateTSEnum(NotificationSource),
	        __metadata("design:type", Number)
	    ], NotifyDownstreamMessage.prototype, "source", void 0);
	    __decorate([
	        decorators_1.validateTSEnum(NotificationLevel),
	        __metadata("design:type", Number)
	    ], NotifyDownstreamMessage.prototype, "level", void 0);
	    NotifyDownstreamMessage = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.DOWN_NOTIFY)
	    ], NotifyDownstreamMessage);
	    return NotifyDownstreamMessage;
	}(incoming_message_1.IncomingMessage));
	exports.NotifyDownstreamMessage = NotifyDownstreamMessage;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var QuarantineConfigurationRequest = (function (_super) {
	    __extends(QuarantineConfigurationRequest, _super);
	    function QuarantineConfigurationRequest(lock, minutes) {
	        var _this = _super.call(this) || this;
	        _this.lock = lock;
	        _this.minutes = minutes;
	        _this.tag = message_tag_1.MessageTag.REQ_CFG_QUARANTINE;
	        return _this;
	    }
	    QuarantineConfigurationRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_CFG_QUARANTINE);
	    };
	    QuarantineConfigurationRequest.tag = message_tag_1.MessageTag.REQ_CFG_QUARANTINE;
	    return QuarantineConfigurationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.QuarantineConfigurationRequest = QuarantineConfigurationRequest;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var QuarantineConfigurationResponse = (function (_super) {
	    __extends(QuarantineConfigurationResponse, _super);
	    function QuarantineConfigurationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CFG_QUARANTINE;
	        return _this;
	    }
	    QuarantineConfigurationResponse.StandardMessage = " minutes until the application is locked (approximate). Please save your work.";
	    return QuarantineConfigurationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.QuarantineConfigurationResponse = QuarantineConfigurationResponse;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ShutdownRequest = (function (_super) {
	    __extends(ShutdownRequest, _super);
	    function ShutdownRequest(shutdown, minutes) {
	        var _this = _super.call(this) || this;
	        _this.shutdown = shutdown;
	        _this.minutes = minutes;
	        _this.tag = message_tag_1.MessageTag.REQ_SHUTDOWN;
	        return _this;
	    }
	    ShutdownRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SHUTDOWN);
	    };
	    ShutdownRequest.tag = message_tag_1.MessageTag.REQ_SHUTDOWN;
	    return ShutdownRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ShutdownRequest = ShutdownRequest;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ShutdownResponse = (function (_super) {
	    __extends(ShutdownResponse, _super);
	    function ShutdownResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SHUTDOWN;
	        return _this;
	    }
	    ShutdownResponse.StandardMessage = " minutes until the application is shut down (approximate). Please save your work.";
	    return ShutdownResponse;
	}(incoming_message_1.IncomingMessage));
	exports.ShutdownResponse = ShutdownResponse;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var aggregation_subject_context_request_1 = __webpack_require__(566);
	exports.AggregationSubjectContextRequest = aggregation_subject_context_request_1.AggregationSubjectContextRequest;
	var aggregator_failure_response_1 = __webpack_require__(567);
	exports.AggregatorFailureResponse = aggregator_failure_response_1.AggregatorFailureResponse;
	var aggregator_report_response_1 = __webpack_require__(568);
	exports.AggregatorReportResponse = aggregator_report_response_1.AggregatorReportResponse;
	var aggregator_status_response_1 = __webpack_require__(570);
	exports.AggregatorStatusResponse = aggregator_status_response_1.AggregatorStatusResponse;
	var available_aggregators_response_1 = __webpack_require__(571);
	exports.AvailableAggregatorsResponse = available_aggregators_response_1.AvailableAggregatorsResponse;
	var basic_aggregation_requests_1 = __webpack_require__(572);
	exports.AggregatorStatusRequest = basic_aggregation_requests_1.AggregatorStatusRequest;
	exports.CancelAggregationRequest = basic_aggregation_requests_1.CancelAggregationRequest;
	exports.DeleteAggregatorRequest = basic_aggregation_requests_1.DeleteAggregatorRequest;
	exports.PauseAggregatorRequest = basic_aggregation_requests_1.PauseAggregatorRequest;
	exports.ResumeAggregatorRequest = basic_aggregation_requests_1.ResumeAggregatorRequest;
	var create_aggregator_request_1 = __webpack_require__(573);
	exports.CreateAggregatorRequest = create_aggregator_request_1.CreateAggregatorRequest;
	var create_aggregator_response_1 = __webpack_require__(574);
	exports.CreateAggregatorResponse = create_aggregator_response_1.CreateAggregatorResponse;
	var start_aggregator_request_1 = __webpack_require__(575);
	exports.StartAggregatorRequest = start_aggregator_request_1.StartAggregatorRequest;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AggregationSubjectContextRequest = (function (_super) {
	    __extends(AggregationSubjectContextRequest, _super);
	    function AggregationSubjectContextRequest(aggregationId, itemId) {
	        var _this = _super.call(this) || this;
	        _this.aggregationId = aggregationId;
	        _this.itemId = itemId;
	        _this.tag = message_tag_1.MessageTag.REQ_AGGREGATION_SUBJECT_CONTEXT;
	        return _this;
	    }
	    AggregationSubjectContextRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    AggregationSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_AGGREGATION_SUBJECT_CONTEXT;
	    return AggregationSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AggregationSubjectContextRequest = AggregationSubjectContextRequest;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var response_code_1 = __webpack_require__(527);
	var message_tag_1 = __webpack_require__(515);
	var AggregatorFailureResponse = (function (_super) {
	    __extends(AggregatorFailureResponse, _super);
	    function AggregatorFailureResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_AGGREGATOR_FAILURE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], AggregatorFailureResponse.prototype, "aggregationId", void 0);
	    __decorate([
	        decorators_1.validateTSEnum(response_code_1.ResponseCode),
	        __metadata("design:type", Number)
	    ], AggregatorFailureResponse.prototype, "code", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AggregatorFailureResponse.prototype, "reason", void 0);
	    AggregatorFailureResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_AGGREGATOR_FAILURE)
	    ], AggregatorFailureResponse);
	    return AggregatorFailureResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AggregatorFailureResponse = AggregatorFailureResponse;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var subject_context_type_1 = __webpack_require__(569);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AggregatorReportResponse = (function (_super) {
	    __extends(AggregatorReportResponse, _super);
	    function AggregatorReportResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_AGGREGATOR_REPORT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "aggregationId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "groupId", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], AggregatorReportResponse.prototype, "aggregator", void 0);
	    __decorate([
	        decorators_1.validateAs({ enum: Object.values(subject_context_type_1.KnownSubjectContextTypes) }),
	        __metadata("design:type", String)
	    ], AggregatorReportResponse.prototype, "subjectContextType", void 0);
	    __decorate([
	        decorators_1.validateAs("string", true, undefined),
	        __metadata("design:type", String)
	    ], AggregatorReportResponse.prototype, "variable", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "viable", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "unanswered", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "processed", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "rejected", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "start", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "ended", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorReportResponse.prototype, "duration", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AggregatorReportResponse.prototype, "results", void 0);
	    AggregatorReportResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_AGGREGATOR_REPORT)
	    ], AggregatorReportResponse);
	    return AggregatorReportResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AggregatorReportResponse = AggregatorReportResponse;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KnownSubjectContextTypes = (function () {
	    function KnownSubjectContextTypes() {
	    }
	    KnownSubjectContextTypes.Healthcare = "healthcare benefits";
	    KnownSubjectContextTypes.IssueReport = "issue report";
	    KnownSubjectContextTypes.ClientTest = "client test";
	    KnownSubjectContextTypes.PathChooser = "path chooser";
	    return KnownSubjectContextTypes;
	}());
	exports.KnownSubjectContextTypes = KnownSubjectContextTypes;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AggregatorStatusResponse = (function (_super) {
	    __extends(AggregatorStatusResponse, _super);
	    function AggregatorStatusResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STATUS_AGGREGATOR;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], AggregatorStatusResponse.prototype, "aggregationId", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorStatusResponse.prototype, "viable", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorStatusResponse.prototype, "processed", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], AggregatorStatusResponse.prototype, "rejected", void 0);
	    AggregatorStatusResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STATUS_AGGREGATOR)
	    ], AggregatorStatusResponse);
	    return AggregatorStatusResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AggregatorStatusResponse = AggregatorStatusResponse;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AvailableAggregatorsResponse = (function (_super) {
	    __extends(AvailableAggregatorsResponse, _super);
	    function AvailableAggregatorsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_AVAILABLE_AGGREGATORS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AvailableAggregatorsResponse.prototype, "aggregators", void 0);
	    AvailableAggregatorsResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_AVAILABLE_AGGREGATORS)
	    ], AvailableAggregatorsResponse);
	    return AvailableAggregatorsResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AvailableAggregatorsResponse = AvailableAggregatorsResponse;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var BasicAggregationRequest = (function (_super) {
	    __extends(BasicAggregationRequest, _super);
	    function BasicAggregationRequest(aggregationId) {
	        var _this = _super.call(this) || this;
	        _this.aggregationId = aggregationId;
	        return _this;
	    }
	    return BasicAggregationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	var DeleteAggregatorRequest = (function (_super) {
	    __extends(DeleteAggregatorRequest, _super);
	    function DeleteAggregatorRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_AGGREGATOR;
	        return _this;
	    }
	    return DeleteAggregatorRequest;
	}(BasicAggregationRequest));
	exports.DeleteAggregatorRequest = DeleteAggregatorRequest;
	var PauseAggregatorRequest = (function (_super) {
	    __extends(PauseAggregatorRequest, _super);
	    function PauseAggregatorRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_PAUSE_AGGREGATOR;
	        return _this;
	    }
	    return PauseAggregatorRequest;
	}(BasicAggregationRequest));
	exports.PauseAggregatorRequest = PauseAggregatorRequest;
	var ResumeAggregatorRequest = (function (_super) {
	    __extends(ResumeAggregatorRequest, _super);
	    function ResumeAggregatorRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_RESUME_AGGREGATOR;
	        return _this;
	    }
	    return ResumeAggregatorRequest;
	}(BasicAggregationRequest));
	exports.ResumeAggregatorRequest = ResumeAggregatorRequest;
	var CancelAggregationRequest = (function (_super) {
	    __extends(CancelAggregationRequest, _super);
	    function CancelAggregationRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_CANCEL_AGGREGATION;
	        return _this;
	    }
	    return CancelAggregationRequest;
	}(BasicAggregationRequest));
	exports.CancelAggregationRequest = CancelAggregationRequest;
	var AggregatorStatusRequest = (function (_super) {
	    __extends(AggregatorStatusRequest, _super);
	    function AggregatorStatusRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_STATUS_AGGREGATOR;
	        return _this;
	    }
	    AggregatorStatusRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_STATUS_AGGREGATOR);
	    };
	    return AggregatorStatusRequest;
	}(BasicAggregationRequest));
	exports.AggregatorStatusRequest = AggregatorStatusRequest;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var CreateAggregatorRequest = (function (_super) {
	    __extends(CreateAggregatorRequest, _super);
	    function CreateAggregatorRequest(aggregator, algorithm, subjectContextType, groupId) {
	        var _this = _super.call(this) || this;
	        _this.aggregator = aggregator;
	        _this.algorithm = algorithm;
	        _this.subjectContextType = subjectContextType;
	        _this.groupId = groupId;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_AGGREGATOR;
	        return _this;
	    }
	    CreateAggregatorRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_CREATE_AGGREGATOR);
	    };
	    CreateAggregatorRequest.tag = message_tag_1.MessageTag.REQ_CREATE_AGGREGATOR;
	    return CreateAggregatorRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.CreateAggregatorRequest = CreateAggregatorRequest;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var CreateAggregatorResponse = (function (_super) {
	    __extends(CreateAggregatorResponse, _super);
	    function CreateAggregatorResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CREATE_AGGREGATOR;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], CreateAggregatorResponse.prototype, "aggregationId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], CreateAggregatorResponse.prototype, "targetVariableOptions", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], CreateAggregatorResponse.prototype, "filterOptions", void 0);
	    CreateAggregatorResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CREATE_AGGREGATOR)
	    ], CreateAggregatorResponse);
	    return CreateAggregatorResponse;
	}(incoming_message_1.IncomingMessage));
	exports.CreateAggregatorResponse = CreateAggregatorResponse;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StartAggregatorRequest = (function (_super) {
	    __extends(StartAggregatorRequest, _super);
	    function StartAggregatorRequest(aggregationId, filterTree, targetVariable, rerun) {
	        if (rerun === void 0) { rerun = false; }
	        var _this = _super.call(this) || this;
	        _this.aggregationId = aggregationId;
	        _this.filterTree = filterTree;
	        _this.targetVariable = targetVariable;
	        _this.rerun = rerun;
	        _this.tag = message_tag_1.MessageTag.REQ_START_AGGREGATOR;
	        if (!targetVariable) {
	            delete _this.targetVariable;
	        }
	        if (!filterTree) {
	            delete _this.filterTree;
	        }
	        return _this;
	    }
	    StartAggregatorRequest.tag = message_tag_1.MessageTag.REQ_START_AGGREGATOR;
	    return StartAggregatorRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StartAggregatorRequest = StartAggregatorRequest;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var additional_steps_request_1 = __webpack_require__(577);
	exports.AdditionalStepsRequest = additional_steps_request_1.AdditionalStepsRequest;
	var algorithm_users_broadcast_1 = __webpack_require__(578);
	exports.AlgorithmUsersBroadcast = algorithm_users_broadcast_1.AlgorithmUsersBroadcast;
	var load_algorithm_request_1 = __webpack_require__(579);
	exports.LoadAlgorithmRequest = load_algorithm_request_1.LoadAlgorithmRequest;
	var next_steps_response_1 = __webpack_require__(580);
	exports.NextStepsResponse = next_steps_response_1.NextStepsResponse;
	var restart_algorithm_broadcast_1 = __webpack_require__(587);
	exports.RestartAlgorithmBroadcast = restart_algorithm_broadcast_1.RestartAlgorithmBroadcast;
	var start_algorithm_request_1 = __webpack_require__(588);
	exports.StartAlgorithmRequest = start_algorithm_request_1.StartAlgorithmRequest;
	var stop_algorithm_request_1 = __webpack_require__(589);
	exports.StopAlgorithmRequest = stop_algorithm_request_1.StopAlgorithmRequest;
	var stop_algorithm_response_1 = __webpack_require__(590);
	exports.StopAlgorithmResponse = stop_algorithm_response_1.StopAlgorithmResponse;
	var submit_answers_upstream_message_1 = __webpack_require__(591);
	exports.SubmitAnswersUpstreamMessage = submit_answers_upstream_message_1.SubmitAnswersUpstreamMessage;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AdditionalStepsRequest = (function (_super) {
	    __extends(AdditionalStepsRequest, _super);
	    function AdditionalStepsRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_ADDITIONAL_STEPS;
	        return _this;
	    }
	    AdditionalStepsRequest.tag = message_tag_1.MessageTag.REQ_ADDITIONAL_STEPS;
	    return AdditionalStepsRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AdditionalStepsRequest = AdditionalStepsRequest;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AlgorithmUsersBroadcast = (function (_super) {
	    __extends(AlgorithmUsersBroadcast, _super);
	    function AlgorithmUsersBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_ALGORITHM_USERS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AlgorithmUsersBroadcast.prototype, "users", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(false, null, true),
	        __metadata("design:type", Number)
	    ], AlgorithmUsersBroadcast.prototype, "removedId", void 0);
	    AlgorithmUsersBroadcast = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.BCST_ALGORITHM_USERS)
	    ], AlgorithmUsersBroadcast);
	    return AlgorithmUsersBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.AlgorithmUsersBroadcast = AlgorithmUsersBroadcast;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var LoadAlgorithmRequest = (function (_super) {
	    __extends(LoadAlgorithmRequest, _super);
	    function LoadAlgorithmRequest(name) {
	        var _this = _super.call(this) || this;
	        _this.name = name;
	        _this.tag = message_tag_1.MessageTag.REQ_LOAD_ALGORITHM;
	        return _this;
	    }
	    LoadAlgorithmRequest.tag = message_tag_1.MessageTag.REQ_LOAD_ALGORITHM;
	    return LoadAlgorithmRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.LoadAlgorithmRequest = LoadAlgorithmRequest;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var structure_1 = __webpack_require__(581);
	var decorators_1 = __webpack_require__(521);
	var interpolation_1 = __webpack_require__(585);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var NextStepsResponse = (function (_super) {
	    __extends(NextStepsResponse, _super);
	    function NextStepsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_NEXT_STEPS;
	        return _this;
	    }
	    NextStepsResponse.InstantiateSteps = function (nsr) {
	        return [].concat(nsr.intakeSteps.map(function (step) { return new structure_1.IntakeStep(step); }), nsr.reportSteps.map(function (step) { return new structure_1.ReportStep(step); }), nsr.computationSteps.map(function (step) { return new structure_1.ComputationStep(step); }));
	    };
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, true, [], function (json) { return json.intakeSteps.forEach(function (i) { return interpolation_1.interpolateInPlace(i); }); }),
	        __metadata("design:type", Array)
	    ], NextStepsResponse.prototype, "intakeSteps", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, true, [], function (json) {
	            json.reportSteps.forEach(function (r) { return interpolation_1.interpolateInPlace(r); });
	            if (json.reportSteps.length) {
	                console.log("reportSteps", json.reportSteps);
	            }
	        }),
	        __metadata("design:type", Array)
	    ], NextStepsResponse.prototype, "reportSteps", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, true, []),
	        __metadata("design:type", Array)
	    ], NextStepsResponse.prototype, "computationSteps", void 0);
	    NextStepsResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_NEXT_STEPS)
	    ], NextStepsResponse);
	    return NextStepsResponse;
	}(incoming_message_1.IncomingMessage));
	exports.NextStepsResponse = NextStepsResponse;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var algorithm_1 = __webpack_require__(582);
	exports.Algorithm = algorithm_1.Algorithm;
	var algorithm_step_1 = __webpack_require__(210);
	exports.AlgorithmStep = algorithm_step_1.AlgorithmStep;
	var computation_step_1 = __webpack_require__(583);
	exports.ComputationStep = computation_step_1.ComputationStep;
	var intake_step_1 = __webpack_require__(68);
	exports.IntakeStep = intake_step_1.IntakeStep;
	var report_step_1 = __webpack_require__(584);
	exports.ReportStep = report_step_1.ReportStep;
	var intake_answer_1 = __webpack_require__(211);
	exports.IntakeAnswer = intake_answer_1.IntakeAnswer;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function humanizeAlgoritmName(name) {
	    return name.slice(1).replace(/-([a-z])/g, function (_, letter) { return " " + letter.toLocaleUpperCase(); }).slice(1);
	}
	var AlgorithmType;
	(function (AlgorithmType) {
	    AlgorithmType[AlgorithmType["Standard"] = 0] = "Standard";
	    AlgorithmType[AlgorithmType["BugReporting"] = 1] = "BugReporting";
	})(AlgorithmType = exports.AlgorithmType || (exports.AlgorithmType = {}));
	var Algorithm = (function () {
	    function Algorithm(name, contextType, displayName, description, type, supportsIntake, useCustomFlow) {
	        if (displayName === void 0) { displayName = humanizeAlgoritmName(name); }
	        if (description === void 0) { description = ""; }
	        if (type === void 0) { type = AlgorithmType.Standard; }
	        if (supportsIntake === void 0) { supportsIntake = true; }
	        if (useCustomFlow === void 0) { useCustomFlow = undefined; }
	        this.name = name;
	        this.contextType = contextType;
	        this.displayName = displayName;
	        this.description = description;
	        this.type = type;
	        this.supportsIntake = supportsIntake;
	        this.useCustomFlow = useCustomFlow;
	        this.loadedThisSession = false;
	    }
	    return Algorithm;
	}());
	exports.Algorithm = Algorithm;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var algorithm_step_1 = __webpack_require__(210);
	var ComputationStep = (function (_super) {
	    __extends(ComputationStep, _super);
	    function ComputationStep() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ComputationStep;
	}(algorithm_step_1.AlgorithmStep));
	exports.ComputationStep = ComputationStep;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var algorithm_step_1 = __webpack_require__(210);
	var intake_step_1 = __webpack_require__(68);
	var INTAKE_SHIM = {
	    type: "empty",
	    cardinality: 1,
	    allowsDuplicates: false
	};
	var ReportStep = (function (_super) {
	    __extends(ReportStep, _super);
	    function ReportStep(data) {
	        var _this = _super.call(this, data) || this;
	        _this.isActive = data.isActive;
	        _this.order = data.order || Number.MAX_SAFE_INTEGER;
	        return _this;
	    }
	    ReportStep.prototype.asEmptyIntake = function () {
	        if (!this.intakeForm) {
	            this.intakeForm = new intake_step_1.IntakeStep(Object.assign({}, this, INTAKE_SHIM));
	        }
	        return this.intakeForm;
	    };
	    return ReportStep;
	}(algorithm_step_1.AlgorithmStep));
	exports.ReportStep = ReportStep;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var interpolation_directives_1 = __webpack_require__(586);
	var typed_data_1 = __webpack_require__(69);
	var NULL_FOR_HUMANS = "<code>(unknown)</code>";
	function dumpInterpolation(template, values, htmlNewLines) {
	    if (htmlNewLines === void 0) { htmlNewLines = true; }
	    var s = "";
	    values.forEach(function (v) {
	        s += (htmlNewLines ? "<br>" : "\n") + ((v.displayName || v.name) + ": ");
	        if (v.value) {
	            s += typed_data_1.TypedData.toString(v);
	        }
	    });
	    return (s + (htmlNewLines ? "<br>" : "\n") + "template: " + template);
	}
	function interpolateInPlace(obj) {
	    if (typeof obj.presentation === "object") {
	        try {
	            obj.presentation = interpolateString(obj.presentation.template, obj.presentation.values);
	        }
	        catch (err) {
	            obj.presentation = dumpInterpolation(obj.presentation.template, obj.presentation.values);
	        }
	    }
	}
	exports.interpolateInPlace = interpolateInPlace;
	function interpolateString(template, variables) {
	    try {
	        return buildInterpolator(template, variables)(variables);
	    }
	    catch (err) {
	        if (err instanceof TypeError) {
	            throw err;
	        }
	        return "<code>Interpolator failure: " + err + "</code>";
	    }
	}
	exports.interpolateString = interpolateString;
	var TextState;
	(function (TextState) {
	    TextState[TextState["Normal"] = 0] = "Normal";
	    TextState[TextState["VariableName"] = 1] = "VariableName";
	    TextState[TextState["DirectiveName"] = 2] = "DirectiveName";
	    TextState[TextState["SawTick"] = 3] = "SawTick";
	    TextState[TextState["Saw$"] = 4] = "Saw$";
	})(TextState || (TextState = {}));
	var ParseNode = (function () {
	    function ParseNode() {
	        this.content = [];
	    }
	    ParseNode.prototype.addString = function (str) {
	        if (str === "") {
	            return;
	        }
	        this.content.push(new StringNode(str));
	    };
	    ParseNode.prototype.add = function (node) {
	        this.content.push(node);
	        return node;
	    };
	    ParseNode.prototype.finish = function () {
	    };
	    ParseNode.prototype.finishTarget = function (variables) {
	        throw new Error("Cannot add target to non-binding-site");
	    };
	    ParseNode.prototype.finishParameter = function () {
	        throw new Error("Arbitrary nodes do not have parameters");
	    };
	    ParseNode.prototype.replaceLast = function (node) {
	        if (this.content.length === 0) {
	            throw new Error("Cannot replace node; node has no content");
	        }
	        this.content.splice(-1, 1, node);
	        return node;
	    };
	    ParseNode.prototype.setDirective = function (name, required) {
	        if (required === void 0) { required = false; }
	        throw new Error("Cannot add directive to non-binding-site");
	    };
	    ParseNode.prototype.returnCardinality = function () {
	        return 1;
	    };
	    return ParseNode;
	}());
	var StringNode = (function (_super) {
	    __extends(StringNode, _super);
	    function StringNode(value) {
	        var _this = _super.call(this) || this;
	        _this.value = value;
	        return _this;
	    }
	    StringNode.prototype.returnType = function () {
	        return "parseable";
	    };
	    StringNode.prototype.eject = function () {
	        var _this = this;
	        return function () { return interpolation_directives_1.wrap("parseable", _this.value); };
	    };
	    return StringNode;
	}(ParseNode));
	var ReferenceNode = (function (_super) {
	    __extends(ReferenceNode, _super);
	    function ReferenceNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ReferenceNode.prototype.returnCardinality = function () {
	        return this.cardinality;
	    };
	    ReferenceNode.prototype.finishTarget = function (variables) {
	        var _this = this;
	        if (this.variableName) {
	            throw new Error("Variable name already parsed");
	        }
	        if (this.content.length !== 1
	            || !(this.content[0] instanceof StringNode)) {
	            throw new Error("Variable name must be 1 string node!");
	        }
	        this.variableName = this.content[0].value;
	        var variable = variables.find(function (v) { return v.name === _this.variableName; });
	        if (!variable) {
	            throw new Error("Unknown variable " + this.variableName);
	        }
	        this.type = variable.type;
	        this.cardinality = variable.cardinality;
	    };
	    ReferenceNode.prototype.returnType = function () {
	        return this.type;
	    };
	    ReferenceNode.prototype.eject = function () {
	        var _this = this;
	        return function (variables) {
	            return variables.find(function (v) { return v.name === _this.variableName; });
	        };
	    };
	    return ReferenceNode;
	}(ParseNode));
	var DirectiveNode = (function (_super) {
	    __extends(DirectiveNode, _super);
	    function DirectiveNode(initialTarget, variables) {
	        var _this = _super.call(this) || this;
	        _this.parameters = [];
	        if (initialTarget) {
	            _this.content.push(initialTarget);
	            _this.finishTarget(variables);
	        }
	        return _this;
	    }
	    DirectiveNode.prototype.returnType = function () {
	        return this.directive.returnType();
	    };
	    DirectiveNode.prototype.finishTarget = function (variables) {
	        if (this.content.length !== 1) {
	            throw new Error("Target must be exactly 1 node");
	        }
	        this.target = this.content.pop();
	    };
	    DirectiveNode.prototype.finishParameter = function () {
	        if (this.content.length === 0) {
	            this.parameters.push(new StringNode(""));
	        }
	        else if (this.content.length === 1) {
	            this.parameters.push(this.content[0]);
	        }
	        else {
	            var cNode_1 = new ConcatNode();
	            this.content.forEach(function (node) { return cNode_1.add(node); });
	            this.parameters.push(cNode_1);
	        }
	        this.content = [];
	        return true;
	    };
	    DirectiveNode.prototype.setDirective = function (name, required) {
	        if (required === void 0) { required = false; }
	        var directiveIndex = interpolation_directives_1.Directives.get(name);
	        if (!directiveIndex) {
	            throw new Error("Unknown directive " + name);
	        }
	        var type = this.target.returnType();
	        if (directiveIndex.terminates) {
	            var DC = directiveIndex.byType(type);
	            if (DC) {
	                this.directive = new DC();
	                return true;
	            }
	        }
	        if (required || !directiveIndex.hasSubdirectives) {
	            throw new Error("Could not find directive " + name + " for type " + type);
	        }
	        else {
	            return false;
	        }
	    };
	    DirectiveNode.prototype.finish = function () {
	        var paramTypes = this.parameters.map(function (node) { return node.returnType(); });
	        var cardinalities = this.parameters.map(function (node) { return node.returnCardinality(); });
	        this.directive.verifyParameters(paramTypes, this.target.returnType(), cardinalities);
	    };
	    DirectiveNode.prototype.eject = function () {
	        var _this = this;
	        return function (variables) {
	            var params = _this.parameters.map(function (p) {
	                return p.eject()(variables);
	            });
	            var targetType = _this.target.returnType();
	            return interpolation_directives_1.wrap(_this.directive.returnType(), _this.directive.execute(_this.directive.parseTarget(_this.target.eject()(variables)), _this.directive.parseParameters(params)));
	        };
	    };
	    return DirectiveNode;
	}(ParseNode));
	var ParseRoot = (function (_super) {
	    __extends(ParseRoot, _super);
	    function ParseRoot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParseRoot.prototype.finishParameter = function () {
	        return false;
	    };
	    ParseRoot.prototype.returnType = function () {
	        return "string";
	    };
	    ParseRoot.prototype.eject = function () {
	        throw new Error("Use ejectRoot() instead of eject()!");
	    };
	    ParseRoot.prototype.ejectRoot = function () {
	        var _this = this;
	        return (function (variables) {
	            return _this.content.map(function (n) {
	                return interpolation_directives_1.DefaultDirective.execute(n.eject()(variables));
	            }).join("");
	        });
	    };
	    return ParseRoot;
	}(ParseNode));
	var ConcatNode = (function (_super) {
	    __extends(ConcatNode, _super);
	    function ConcatNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ConcatNode.prototype.returnType = function () {
	        if (this.content.length === 1) {
	            return this.content[0].returnType();
	        }
	        return "string";
	    };
	    ConcatNode.prototype.eject = function () {
	        var _this = this;
	        if (this.content.length === 0) {
	            return function () { return interpolation_directives_1.wrap("string", ""); };
	        }
	        if (this.content.length === 1) {
	            return this.content[0].eject();
	        }
	        return (function (variables) {
	            return interpolation_directives_1.wrap("string", _this.content.map(function (n) {
	                return interpolation_directives_1.DefaultDirective.execute(n.eject()(variables));
	            }).join(""));
	        });
	    };
	    return ConcatNode;
	}(ParseNode));
	var METACHARACTERS = new Set(["`", "$", "{", "}", "|", ","]);
	var StringAccumulator = (function () {
	    function StringAccumulator() {
	        this.value = "";
	    }
	    StringAccumulator.prototype.add = function (char) {
	        if (char.length !== 1) {
	            throw new Error("Can only accumulate 1 character at a time!");
	        }
	        this.value += char;
	    };
	    StringAccumulator.prototype.flush = function () {
	        var a = this.value;
	        this.value = "";
	        return a;
	    };
	    return StringAccumulator;
	}());
	function buildInterpolator(template, variables) {
	    if (!template.match(/(^|[^`])\{/)) {
	        var unescaped_1 = template.replace(/`([`${|},])/, "$1");
	        return function () { return unescaped_1; };
	    }
	    var root = new ParseRoot();
	    var node = root;
	    var acc = new StringAccumulator();
	    var state = TextState.Normal;
	    var prev = null;
	    var path = [];
	    for (var _i = 0, template_1 = template; _i < template_1.length; _i++) {
	        var char = template_1[_i];
	        if (!node) {
	            throw new Error("Shouldn't happen: no current node!");
	        }
	        switch (state) {
	            case (TextState.SawTick):
	                if (METACHARACTERS.has(char)) {
	                    acc.add(char);
	                    state = prev;
	                    continue;
	                }
	                else {
	                    throw new Error("Unknown metacharacter (" + char + ")");
	                }
	            case (TextState.Saw$):
	                if (char === "{") {
	                    state = TextState.VariableName;
	                    path.push(node);
	                    node = node.add(new ReferenceNode());
	                    continue;
	                }
	                else {
	                    throw new Error("Illegal char sequence: saw $ without {");
	                }
	            case (TextState.VariableName):
	                if (char === "`") {
	                    prev = state;
	                    state = TextState.SawTick;
	                    continue;
	                }
	                if (char === "|") {
	                    node.addString(acc.flush());
	                    node.finishTarget(variables);
	                    node.finish();
	                    node = path.slice(-1)[0].replaceLast(new DirectiveNode(node, variables));
	                    state = TextState.DirectiveName;
	                    continue;
	                }
	                if (char === "}") {
	                    node.addString(acc.flush());
	                    node.finishTarget(variables);
	                    node.finish();
	                    state = TextState.Normal;
	                    node = path.pop();
	                    continue;
	                }
	                if (METACHARACTERS.has(char)) {
	                    throw new Error("Unexpected metacharacter (" + char + ")");
	                }
	                break;
	            case (TextState.DirectiveName):
	                if (char === "`") {
	                    prev = state;
	                    state = TextState.SawTick;
	                    continue;
	                }
	                if (char === "|") {
	                    node.setDirective(acc.flush(), true);
	                    node.finish();
	                    node = path.slice(-1)[0].replaceLast(new DirectiveNode(node, variables));
	                    continue;
	                }
	                if (char === ",") {
	                    if (node.setDirective(acc.value, false)) {
	                        acc.flush();
	                        state = TextState.Normal;
	                        continue;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                if (char === "}") {
	                    node.setDirective(acc.flush(), true);
	                    node.finish();
	                    node = path.pop();
	                    state = TextState.Normal;
	                    continue;
	                }
	                if (METACHARACTERS.has(char)) {
	                    throw new Error("Directive contains dynamic reference!");
	                }
	                break;
	            case (TextState.Normal):
	                if (char === "`") {
	                    prev = state;
	                    state = TextState.SawTick;
	                    continue;
	                }
	                if (char === "$") {
	                    node.addString(acc.flush());
	                    prev = state;
	                    state = TextState.Saw$;
	                    continue;
	                }
	                if (char === "{") {
	                    node.addString(acc.flush());
	                    path.push(node);
	                    node = node.add(new ConcatNode());
	                    continue;
	                }
	                if (char === "|") {
	                    if (node instanceof DirectiveNode) {
	                        node.addString(acc.flush());
	                        node.finishParameter();
	                        node.finish();
	                        node = path.slice(-1)[0].replaceLast(new DirectiveNode(node, variables));
	                        state = TextState.DirectiveName;
	                        continue;
	                    }
	                    else if (node instanceof ConcatNode) {
	                        node.addString(acc.flush());
	                        node.finish();
	                        node = path.slice(-1)[0].replaceLast(new DirectiveNode(node, variables));
	                        state = TextState.DirectiveName;
	                        continue;
	                    }
	                    else if (node instanceof ParseRoot) {
	                        break;
	                    }
	                    else {
	                        throw new Error("Shouldn't happen: bad node type");
	                    }
	                }
	                if (char === "}") {
	                    if (node instanceof DirectiveNode) {
	                        node.addString(acc.flush());
	                        node.finishParameter();
	                        node.finish();
	                        node = path.pop();
	                        continue;
	                    }
	                    else if (node instanceof ConcatNode) {
	                        throw new Error("String expression has no directives!");
	                    }
	                    else if (node instanceof ParseRoot) {
	                        break;
	                    }
	                    else {
	                        throw new Error("Shouldn't happen: bad node type");
	                    }
	                }
	                if (char === ",") {
	                    node.addString(acc.flush());
	                    if (node.finishParameter()) {
	                        continue;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                break;
	            default:
	                throw new Error("Unknown parser state " + state);
	        }
	        acc.add(char);
	    }
	    if (path.length > 0) {
	        throw new Error("Unclosed interpolation site!");
	    }
	    if (node !== root) {
	        throw new Error("Shouldn't happen: current did not return to root");
	    }
	    root.addString(acc.flush());
	    console.warn(template, variables, root);
	    return root.ejectRoot();
	}
	exports.buildInterpolator = buildInterpolator;
	function stringAsVariable(str) {
	    return {
	        name: "<raw input>",
	        value: str,
	        type: "string",
	        collectionType: "none",
	        cardinality: 1
	    };
	}
	exports.stringAsVariable = stringAsVariable;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(70);
	var data_types_1 = __webpack_require__(208);
	var functions_1 = __webpack_require__(206);
	var VAR_INCREMENTER = 0;
	function wrap(type, value, cardinality) {
	    if (cardinality === void 0) { cardinality = 1; }
	    return {
	        name: "wrapped value " + VAR_INCREMENTER++,
	        type: type,
	        cardinality: cardinality,
	        collectionType: (cardinality === 1 ? "none" : "list"),
	        value: value
	    };
	}
	exports.wrap = wrap;
	function comparableTypes(a, b) {
	    if (a === "parseable" || b === "parseable") {
	        return true;
	    }
	    if (data_types_1.NumberTypes.has(a) && data_types_1.NumberTypes.has(b)) {
	        return true;
	    }
	    return a === b;
	}
	function supertypeOf(a, b) {
	    if (a === b) {
	        return true;
	    }
	    if (b === "parseable") {
	        return true;
	    }
	    if (a === "string") {
	        return true;
	    }
	    if (data_types_1.NumberTypes.has(a) && data_types_1.NumberTypes.has(b)) {
	        return data_types_1.NumberTypeOrder.indexOf(a) > data_types_1.NumberTypeOrder.indexOf(b);
	    }
	    if (a === "datetime" && b === "date") {
	        return true;
	    }
	    return false;
	}
	var AVAIL_DATE_FORMAT = "YYYY/MM/DD HH:mm:ss.SSS ZZ";
	function parseAvailMoment(timestamp) {
	    return moment(timestamp, AVAIL_DATE_FORMAT);
	}
	function parseAvailDate(timestamp) {
	    return parseAvailMoment(timestamp).toDate();
	}
	function parseAs(value, type) {
	    if (value === "null") {
	        return null;
	    }
	    switch (type) {
	        case "string":
	            return value;
	        case "integer":
	        case "whole number":
	        case "natural number":
	            return Number.parseInt(value, 10);
	        case "float":
	            return Number.parseFloat(value);
	        case "boolean":
	            return ("" + value).toLocaleLowerCase() === "true";
	        case "date":
	            return parseAvailDate(value);
	        default:
	            throw new Error("Cannot yet parse for non-server datatypes!");
	    }
	}
	function parseVarAs(variable, type) {
	    return Object.assign({}, variable, {
	        type: type,
	        value: extractParsed(variable, type, true)
	    });
	}
	function extractParsed(variable, type, preserveCardinality) {
	    if (preserveCardinality === void 0) { preserveCardinality = false; }
	    if (type === "string" && variable.type !== "string") {
	        if (preserveCardinality
	            && variable.cardinality !== 1
	            && Array.isArray(variable.value)) {
	            return variable.value.map(function (v) { return DefaultDirective.execute(wrap(variable.type, v)); });
	        }
	        return DefaultDirective.execute(variable);
	    }
	    if (variable.type === "parseable") {
	        if (variable.cardinality !== 1) {
	            throw new Error("Non-scalar parseables not supported");
	        }
	        return parseAs(variable.value, type);
	    }
	    return variable.value;
	}
	function inRange(min, max) {
	    if (min === void 0) { min = Number.MIN_SAFE_INTEGER; }
	    if (max === void 0) { max = Number.MAX_SAFE_INTEGER; }
	    return function (x) { return (x >= min && x <= max); };
	}
	exports.inRange = inRange;
	function compareParseableString(variable, compare) {
	    if (variable.value === null) {
	        return null;
	    }
	    switch (variable.type) {
	        case "string":
	            return ("" + variable.value).localeCompare(compare);
	        case "integer":
	        case "whole number":
	        case "natural number":
	            return variable.value - Number.parseInt(compare, 10);
	        case "float":
	            return variable.value - Number.parseFloat(compare);
	        case "boolean":
	            console.error("Bad comparison: inequality on boolean");
	            return null;
	        case "date":
	            return +variable.value - +parseAvailDate(compare);
	        default:
	            throw new Error("Extended type comparsion unsupported");
	    }
	}
	function compareInType(a, b, type) {
	    if (a === null) {
	        return Number.MIN_SAFE_INTEGER;
	    }
	    if (b === null) {
	        return Number.MAX_SAFE_INTEGER;
	    }
	    if (a === b) {
	        return 0;
	    }
	    switch (type) {
	        case "string":
	            return ("" + a).localeCompare(b);
	        case "integer":
	        case "whole number":
	        case "natural number":
	        case "float":
	            return a - b;
	        case "boolean":
	            return a ? 1 : -1;
	        case "date":
	            return +a - +b;
	        default:
	            throw new Error("Extended type comparsion unsupported");
	    }
	}
	var Directive = (function () {
	    function Directive() {
	        this.parameterTypeDefault = "string";
	        this.targetCoercionType = "string";
	    }
	    Object.defineProperty(Directive.prototype, "targetType", {
	        get: function () {
	            if (this._targetType) {
	                return this._targetType;
	            }
	            throw Error("Interpolation target type not yet set!");
	        },
	        set: function (type) {
	            this._targetType = type;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Directive.prototype.initialParamCheck = function (types, targetType, cardinalities) {
	        if (targetType === "parseable") {
	            if (this.targetCoercionType) {
	                targetType = this.targetCoercionType;
	                console.warn("Target type is parseable. Coercing to " + targetType);
	            }
	            else {
	                throw new Error(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          Directive's target type was a parseable<any> and coercion\n          is forbidden by directive."], ["\n          Directive's target type was a parseable<any> and coercion\n          is forbidden by directive."]))));
	            }
	        }
	        this.targetType = targetType;
	        if (!this.parameterRange(types.length)) {
	            throw new Error("Incorrect number of parameters " + types);
	        }
	        if (this.parameterTypes
	            && !this.parameterRange(this.parameterTypes.length)) {
	            throw new Error("Type configuration does not match param range");
	        }
	    };
	    Directive.prototype.verifyParameters = function (types, targetType, cardinalities) {
	        this.initialParamCheck(types, targetType);
	        for (var i = 0; i < this.parameterTypes.length; i++) {
	            var provided = types[i];
	            if (!provided) {
	                break;
	            }
	            var goal = this.parameterTypes[i] === "match"
	                ? targetType
	                : this.parameterTypes[i];
	            if (!supertypeOf(goal, provided)) {
	                throw new Error("Provided " + provided + " cannot be used as " + goal + " parameter");
	            }
	        }
	    };
	    Directive.prototype.parseParameters = function (params) {
	        var output = [];
	        for (var i = 0; i < params.length; i++) {
	            var variable = params[i];
	            var type = (i in this.parameterTypes)
	                ? ((this.parameterTypes[i] === "match")
	                    ? this.targetType
	                    : this.parameterTypes[i])
	                : this.parameterTypeDefault;
	            output.push(extractParsed(variable, type));
	        }
	        return output;
	    };
	    Directive.prototype.parseTarget = function (target) {
	        return target;
	    };
	    return Directive;
	}());
	exports.Directive = Directive;
	var StringDirective = (function (_super) {
	    __extends(StringDirective, _super);
	    function StringDirective() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StringDirective.prototype.returnType = function () {
	        return "string";
	    };
	    return StringDirective;
	}(Directive));
	var PureDirective = (function (_super) {
	    __extends(PureDirective, _super);
	    function PureDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.parameterRange = inRange(0, 0);
	        _this.parameterTypes = [];
	        return _this;
	    }
	    return PureDirective;
	}(Directive));
	var PureStringDirective = (function (_super) {
	    __extends(PureStringDirective, _super);
	    function PureStringDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.parameterRange = inRange(0, 0);
	        _this.parameterTypes = [];
	        return _this;
	    }
	    return PureStringDirective;
	}(StringDirective));
	function leafEntry(dc, allowedTypes) {
	    if (allowedTypes && allowedTypes.indexOf("string") === -1) {
	        return {
	            terminates: true,
	            hasSubdirectives: false,
	            isProtocolDirective: true,
	            byType: function (type) {
	                return (allowedTypes.indexOf(type) > -1 ? dc : null);
	            }
	        };
	    }
	    else {
	        return {
	            terminates: true,
	            hasSubdirectives: false,
	            isProtocolDirective: true,
	            byType: function (type) { return dc; }
	        };
	    }
	}
	var PassThroughDirective = (function (_super) {
	    __extends(PassThroughDirective, _super);
	    function PassThroughDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "passthrough";
	        return _this;
	    }
	    PassThroughDirective.prototype.returnType = function () {
	        return this.targetType;
	    };
	    PassThroughDirective.prototype.execute = function (variable, parameters) {
	        return variable;
	    };
	    PassThroughDirective.Entry = leafEntry(PassThroughDirective);
	    return PassThroughDirective;
	}(PureDirective));
	exports.PassThroughDirective = PassThroughDirective;
	var DefaultDirective = (function (_super) {
	    __extends(DefaultDirective, _super);
	    function DefaultDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = Symbol.for("default");
	        return _this;
	    }
	    DefaultDirective.prototype.execute = function (variable) {
	        return DefaultDirective.execute(variable);
	    };
	    DefaultDirective.ReplaceIfNull = function (value) {
	        return (value === null) ? DefaultDirective.NullString : value;
	    };
	    DefaultDirective.execute = function (variable) {
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        if (variable.cardinality !== 1) {
	            if (!Array.isArray(variable.value)) {
	                console.error(functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Variable with cardinality ", "\n          had non-array, non-null value ", ""], ["Variable with cardinality ", "\n          had non-array, non-null value ", ""])), variable.cardinality, variable.value));
	                return DefaultDirective.NullString;
	            }
	            return variable.value.map(function (value) { return DefaultDirective.execute({
	                value: value,
	                type: variable.type,
	                cardinality: 1,
	                name: "",
	                collectionType: "none"
	            }); }).join(", ");
	        }
	        if (variable.type === "boolean") {
	            return (variable.value === true) ? "true" : "false";
	        }
	        if (variable.type === "date") {
	            return new Date(variable.value).toLocaleDateString(undefined, { timeZone: "UTC" });
	        }
	        if (typeof variable.value === "symbol") {
	            throw new Error("Symbol atom leaked to stringifier");
	        }
	        return "" + variable.value;
	    };
	    DefaultDirective.NullString = "«unknown»";
	    DefaultDirective.Entry = leafEntry(DefaultDirective);
	    return DefaultDirective;
	}(PureStringDirective));
	exports.DefaultDirective = DefaultDirective;
	var ComparativeDirective = (function (_super) {
	    __extends(ComparativeDirective, _super);
	    function ComparativeDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.parameterRange = inRange(3, 3);
	        _this.parameterTypes = ["match", "string", "string"];
	        return _this;
	    }
	    ComparativeDirective.prototype.returnType = function () {
	        return "string";
	    };
	    return ComparativeDirective;
	}(Directive));
	var EqualsDirective = (function (_super) {
	    __extends(EqualsDirective, _super);
	    function EqualsDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "=";
	        return _this;
	    }
	    EqualsDirective.prototype.execute = function (variable, _a) {
	        var compare = _a[0], positive = _a[1], negative = _a[2];
	        if ((compare === null || compare === "null")
	            && variable.value === null) {
	            return positive;
	        }
	        return (compareInType(variable.value, compare, variable.type) === 0
	            ? positive
	            : negative);
	    };
	    EqualsDirective.Entry = leafEntry(EqualsDirective);
	    return EqualsDirective;
	}(ComparativeDirective));
	var NotEqualsDirective = (function (_super) {
	    __extends(NotEqualsDirective, _super);
	    function NotEqualsDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "≠";
	        return _this;
	    }
	    NotEqualsDirective.prototype.execute = function (variable, _a) {
	        var compare = _a[0], positive = _a[1], negative = _a[2];
	        if ((compare === null || compare === "null")
	            && variable.value === null) {
	            return negative;
	        }
	        return (compareInType(variable.value, compare, variable.type) !== 0
	            ? positive
	            : negative);
	    };
	    NotEqualsDirective.Entry = leafEntry(NotEqualsDirective);
	    return NotEqualsDirective;
	}(ComparativeDirective));
	var BucketedComparisonDirective = (function (_super) {
	    __extends(BucketedComparisonDirective, _super);
	    function BucketedComparisonDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.parameterRange = (function (x) { return (x > 0) && (x % 2 === 1); });
	        _this.parameterTypes = null;
	        return _this;
	    }
	    BucketedComparisonDirective.prototype.verifyParameters = function (types, targetType) {
	        this.initialParamCheck(types, targetType);
	        var last = types[types.length - 1];
	        if ((types.length % 2 === 1) && !supertypeOf("string", types.pop())) {
	            throw new Error("Default value parameter must be string");
	        }
	        for (var i = 0; i < types.length; i += 2) {
	            if (!supertypeOf(targetType, types[i])
	                || !supertypeOf("string", types[i + 1])) {
	                throw new Error("Bucket params must alternate " + targetType + " and string");
	            }
	        }
	    };
	    BucketedComparisonDirective.prototype.parseParameters = function (params) {
	        var _this = this;
	        if (params.length % 2 === 1) {
	            params.splice(-1, 0, { type: "string", value: Symbol.for("default") });
	        }
	        var buckets = functions_1.sequentialPairs(params).map(function (_a) {
	            var item = _a[0], output = _a[1];
	            return [
	                extractParsed(item, _this.targetType),
	                extractParsed(output, "string")
	            ];
	        });
	        return buckets;
	    };
	    BucketedComparisonDirective.prototype.execute = function (variable, params) {
	        if (variable.value === null) {
	            return params[params.length - 1][1];
	        }
	        for (var _i = 0, _a = params.slice(0, -1); _i < _a.length; _i++) {
	            var _b = _a[_i], compare = _b[0], output = _b[1];
	            var delta = compareInType(variable.value, compare, variable.type);
	            if (delta === null) {
	                break;
	            }
	            if ((delta > 0) && this.returnIfGreater
	                || (delta < 0) && !this.returnIfGreater
	                || (delta === 0) && this.returnIfEquals) {
	                return output;
	            }
	        }
	        return params[params.length - 1][1];
	    };
	    BucketedComparisonDirective.Allowed = [
	        "float", "integer", "whole number", "natural number", "string", "date"
	    ];
	    return BucketedComparisonDirective;
	}(StringDirective));
	var GreaterThanDirective = (function (_super) {
	    __extends(GreaterThanDirective, _super);
	    function GreaterThanDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = ">";
	        _this.returnIfEquals = false;
	        _this.returnIfGreater = true;
	        return _this;
	    }
	    GreaterThanDirective.Entry = leafEntry(GreaterThanDirective, BucketedComparisonDirective.Allowed);
	    return GreaterThanDirective;
	}(BucketedComparisonDirective));
	var GreaterThanOrEqualDirective = (function (_super) {
	    __extends(GreaterThanOrEqualDirective, _super);
	    function GreaterThanOrEqualDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "≥";
	        _this.returnIfEquals = true;
	        _this.returnIfGreater = true;
	        return _this;
	    }
	    GreaterThanOrEqualDirective.Entry = leafEntry(GreaterThanOrEqualDirective, BucketedComparisonDirective.Allowed);
	    return GreaterThanOrEqualDirective;
	}(BucketedComparisonDirective));
	var LessThanDirective = (function (_super) {
	    __extends(LessThanDirective, _super);
	    function LessThanDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "<";
	        _this.returnIfEquals = false;
	        _this.returnIfGreater = false;
	        return _this;
	    }
	    LessThanDirective.Entry = leafEntry(LessThanDirective, BucketedComparisonDirective.Allowed);
	    return LessThanDirective;
	}(BucketedComparisonDirective));
	var LessThanOrEqualDirective = (function (_super) {
	    __extends(LessThanOrEqualDirective, _super);
	    function LessThanOrEqualDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "≤";
	        _this.returnIfEquals = true;
	        _this.returnIfGreater = false;
	        return _this;
	    }
	    LessThanOrEqualDirective.Entry = leafEntry(LessThanOrEqualDirective, BucketedComparisonDirective.Allowed);
	    return LessThanOrEqualDirective;
	}(BucketedComparisonDirective));
	var MapDirective = (function (_super) {
	    __extends(MapDirective, _super);
	    function MapDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "map";
	        _this.parameterRange = inRange(1);
	        _this.returnIfGreater = null;
	        _this.returnIfEquals = null;
	        return _this;
	    }
	    MapDirective.prototype.execute = function (variable, params) {
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var _a = params_1[_i], compare = _a[0], output = _a[1];
	            if (compare === Symbol.for("default")
	                || compareInType(variable.value, compare, variable.type) === 0) {
	                return output;
	            }
	        }
	        return DefaultDirective.execute(variable);
	    };
	    MapDirective.Entry = leafEntry(MapDirective);
	    return MapDirective;
	}(BucketedComparisonDirective));
	var FormatDirectiveEntry = {
	    terminates: true,
	    hasSubdirectives: false,
	    isProtocolDirective: true,
	    byType: function (type) {
	        if (data_types_1.NumberTypes.has(type)) {
	            return FormatNumberDirective;
	        }
	        if (type === "date") {
	            return FormatTimestampDirective;
	        }
	        return null;
	    }
	};
	var FormatTimestampDirective = (function (_super) {
	    __extends(FormatTimestampDirective, _super);
	    function FormatTimestampDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "format";
	        _this.parameterRange = inRange(1, 1);
	        _this.parameterTypes = ["string"];
	        return _this;
	    }
	    FormatTimestampDirective.prototype.execute = function (variable, _a) {
	        var format = _a[0];
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        return moment.utc(variable.value).format(format);
	    };
	    return FormatTimestampDirective;
	}(StringDirective));
	var FormatNumberDirective = (function (_super) {
	    __extends(FormatNumberDirective, _super);
	    function FormatNumberDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "format";
	        _this.parameterRange = inRange(1, 1);
	        _this.parameterTypes = ["float"];
	        return _this;
	    }
	    FormatNumberDirective.prototype.execute = function (variable, _a) {
	        var format = _a[0];
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        return numeral(variable.value).format(format);
	    };
	    return FormatNumberDirective;
	}(StringDirective));
	var IndexDirective = (function (_super) {
	    __extends(IndexDirective, _super);
	    function IndexDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "index";
	        _this.parameterRange = inRange(2);
	        _this.parameterTypes = ["string"];
	        return _this;
	    }
	    IndexDirective.prototype.verifyParameters = function (types, targetType, cardinalities) {
	        this.initialParamCheck(types, targetType);
	        if (!supertypeOf("string", types[0])) {
	            throw new Error("Index default must be string");
	        }
	        if (cardinalities[1] !== 1) {
	            this.variableMode = true;
	            if (types.length > 2) {
	                throw new Error("Variable mode index should only have two params");
	            }
	        }
	        else {
	            this.variableMode = false;
	            if (types.slice(1).some(function (type) { return !supertypeOf("string", type); })) {
	                throw new Error("All lexical list entries must be strings");
	            }
	        }
	    };
	    IndexDirective.prototype.parseParameters = function (params) {
	        if (this.variableMode) {
	            var output = extractParsed(params[1], "string", true);
	            output.unshift(extractParsed(params[0], "string"));
	        }
	        else {
	            return params.map(function (v) { return extractParsed(v, "string"); });
	        }
	    };
	    IndexDirective.prototype.execute = function (variable, params) {
	        var index = (Number.isInteger(variable.value) && variable.value in params)
	            ? variable.value
	            : 0;
	        return params[index];
	    };
	    IndexDirective.Entry = leafEntry(IndexDirective, ["natural number"]);
	    return IndexDirective;
	}(StringDirective));
	var UppercaseDirective = (function (_super) {
	    __extends(UppercaseDirective, _super);
	    function UppercaseDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "uppercase";
	        return _this;
	    }
	    UppercaseDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            variable.value = DefaultDirective.NullString;
	        }
	        return ("" + variable.value).toLocaleUpperCase();
	    };
	    UppercaseDirective.Entry = leafEntry(UppercaseDirective, ["string"]);
	    return UppercaseDirective;
	}(PureStringDirective));
	var LowercaseDirective = (function (_super) {
	    __extends(LowercaseDirective, _super);
	    function LowercaseDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "lowercase";
	        return _this;
	    }
	    LowercaseDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            variable.value = DefaultDirective.NullString;
	        }
	        return ("" + variable.value).toLocaleLowerCase();
	    };
	    LowercaseDirective.Entry = leafEntry(LowercaseDirective, ["string"]);
	    return LowercaseDirective;
	}(PureStringDirective));
	var CapitalizeDirective = (function (_super) {
	    __extends(CapitalizeDirective, _super);
	    function CapitalizeDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "capitalize";
	        return _this;
	    }
	    CapitalizeDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            variable.value = DefaultDirective.NullString;
	        }
	        return (variable.value.slice(0, 1).toLocaleUpperCase()
	            + variable.value.slice(1));
	    };
	    CapitalizeDirective.Entry = leafEntry(CapitalizeDirective, ["string"]);
	    return CapitalizeDirective;
	}(PureStringDirective));
	var TitleCaseDirective = (function (_super) {
	    __extends(TitleCaseDirective, _super);
	    function TitleCaseDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "titlecase";
	        return _this;
	    }
	    TitleCaseDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            variable.value = DefaultDirective.NullString;
	        }
	        return variable.value.replace(/(^|\s)\w/g, function (match) { return match.toLocaleUpperCase(); });
	    };
	    TitleCaseDirective.Entry = leafEntry(TitleCaseDirective, ["string"]);
	    return TitleCaseDirective;
	}(PureStringDirective));
	var InflectIndefiniteArticleDirective = (function (_super) {
	    __extends(InflectIndefiniteArticleDirective, _super);
	    function InflectIndefiniteArticleDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,indefinite article";
	        return _this;
	    }
	    InflectIndefiniteArticleDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            return "an " + DefaultDirective.NullString;
	        }
	        return ((variable.value.match(/^[aeiouAEIOU]/) ? "an " : "a ")
	            + variable.value);
	    };
	    InflectIndefiniteArticleDirective.Entry = leafEntry(InflectIndefiniteArticleDirective, ["string"]);
	    return InflectIndefiniteArticleDirective;
	}(PureStringDirective));
	var InflectDefiniteArticleDirective = (function (_super) {
	    __extends(InflectDefiniteArticleDirective, _super);
	    function InflectDefiniteArticleDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,definite article";
	        _this.maxArgs = 0;
	        return _this;
	    }
	    InflectDefiniteArticleDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            return "the " + DefaultDirective.NullString;
	        }
	        return "the " + variable.value;
	    };
	    InflectDefiniteArticleDirective.Entry = leafEntry(InflectDefiniteArticleDirective, ["string"]);
	    return InflectDefiniteArticleDirective;
	}(PureStringDirective));
	var Gender;
	(function (Gender) {
	    Gender[Gender["Female"] = 0] = "Female";
	    Gender[Gender["Male"] = 1] = "Male";
	    Gender[Gender["Other"] = 2] = "Other";
	})(Gender || (Gender = {}));
	var GenderDirective = (function (_super) {
	    __extends(GenderDirective, _super);
	    function GenderDirective() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GenderDirective.prototype.getGender = function (str) {
	        if (str.toLowerCase() === "male") {
	            return Gender.Male;
	        }
	        if (str.toLowerCase() === "female") {
	            return Gender.Female;
	        }
	        return Gender.Other;
	    };
	    GenderDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            return this.values.get(Gender.Other);
	        }
	        return this.values.get(this.getGender(variable.value));
	    };
	    return GenderDirective;
	}(PureStringDirective));
	var GenderedSubject = (function (_super) {
	    __extends(GenderedSubject, _super);
	    function GenderedSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,gendered,subject";
	        _this.values = new Map([
	            [Gender.Female, "she"],
	            [Gender.Male, "he"],
	            [Gender.Other, "they"]
	        ]);
	        return _this;
	    }
	    GenderedSubject.Entry = leafEntry(GenderedSubject, ["string"]);
	    return GenderedSubject;
	}(GenderDirective));
	var GenderedObject = (function (_super) {
	    __extends(GenderedObject, _super);
	    function GenderedObject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,gendered,object";
	        _this.values = new Map([
	            [Gender.Female, "her"],
	            [Gender.Male, "him"],
	            [Gender.Other, "them"]
	        ]);
	        return _this;
	    }
	    GenderedObject.Entry = leafEntry(GenderedObject, ["string"]);
	    return GenderedObject;
	}(GenderDirective));
	var GenderedPossessiveAdjective = (function (_super) {
	    __extends(GenderedPossessiveAdjective, _super);
	    function GenderedPossessiveAdjective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,gendered,possessive adjective";
	        _this.values = new Map([
	            [Gender.Female, "her"],
	            [Gender.Male, "his"],
	            [Gender.Other, "their"]
	        ]);
	        return _this;
	    }
	    GenderedPossessiveAdjective.Entry = leafEntry(GenderedPossessiveAdjective, ["string"]);
	    return GenderedPossessiveAdjective;
	}(GenderDirective));
	var GenderedPossessivePronoun = (function (_super) {
	    __extends(GenderedPossessivePronoun, _super);
	    function GenderedPossessivePronoun() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,gendered,possessive pronoun";
	        _this.values = new Map([
	            [Gender.Female, "hers"],
	            [Gender.Male, "his"],
	            [Gender.Other, "theirs"]
	        ]);
	        return _this;
	    }
	    GenderedPossessivePronoun.Entry = leafEntry(GenderedPossessivePronoun, ["string"]);
	    return GenderedPossessivePronoun;
	}(GenderDirective));
	var GenderedReflexiveObject = (function (_super) {
	    __extends(GenderedReflexiveObject, _super);
	    function GenderedReflexiveObject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,gendered,reflexive object";
	        _this.values = new Map([
	            [Gender.Female, "herself"],
	            [Gender.Male, "himself"],
	            [Gender.Other, "themself"]
	        ]);
	        return _this;
	    }
	    GenderedReflexiveObject.Entry = leafEntry(GenderedReflexiveObject, ["string"]);
	    return GenderedReflexiveObject;
	}(GenderDirective));
	var InflectPossessiveDirective = (function (_super) {
	    __extends(InflectPossessiveDirective, _super);
	    function InflectPossessiveDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,possessive";
	        _this.irregulars = new Map([
	            ["it", "its"],
	            ["he", "his"],
	            ["she", "her"],
	            ["they", "their"]
	        ]);
	        return _this;
	    }
	    InflectPossessiveDirective.prototype.execute = function (variable) {
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        var irregular = this.irregulars.get(variable.value);
	        if (irregular) {
	            return irregular;
	        }
	        else {
	            return (variable.value.match(/s$/)
	                ? variable.value + "'"
	                : variable.value + "'s");
	        }
	    };
	    InflectPossessiveDirective.Entry = leafEntry(InflectPossessiveDirective, ["string"]);
	    return InflectPossessiveDirective;
	}(PureStringDirective));
	var InflectPluralDirective = (function (_super) {
	    __extends(InflectPluralDirective, _super);
	    function InflectPluralDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,plural";
	        _this.parameterRange = inRange(1, 1);
	        _this.parameterTypes = ["float"];
	        _this.massNounList = new Set([
	            "water",
	            "glass",
	        ]);
	        _this.irregulars = new Map([
	            ["foot", "feet"],
	            ["tooth", "teeth"]
	        ]);
	        _this.irregularCategories = [
	            [/[^aeo]y$/, "$1ies"],
	            [/fe?$/, "ves"],
	            [/man$/, "men"],
	            [/(s|sh|ch|x)$/, "$1es"],
	        ];
	        return _this;
	    }
	    InflectPluralDirective.prototype.isMassNoun = function (noun) {
	        return false;
	    };
	    InflectPluralDirective.prototype.execute = function (variable, _a) {
	        var count = _a[0];
	        variable = parseVarAs(variable, "string");
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        if (count <= 1 || this.isMassNoun(variable.value)) {
	            return variable.value;
	        }
	        var irregular = this.irregulars.get(variable.value);
	        if (irregular) {
	            return irregular;
	        }
	        this.irregularCategories.forEach(function (_a) {
	            var re = _a[0], replacement = _a[1];
	            var replaced = variable.value.replace(re, replacement);
	            if (replaced !== variable.value) {
	                return replaced;
	            }
	        });
	        return variable.value + "s";
	    };
	    InflectPluralDirective.Entry = leafEntry(InflectPluralDirective, ["string"]);
	    return InflectPluralDirective;
	}(StringDirective));
	var ConjugateCopulaDirective = (function (_super) {
	    __extends(ConjugateCopulaDirective, _super);
	    function ConjugateCopulaDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "inflect,copula";
	        return _this;
	    }
	    ConjugateCopulaDirective.prototype.execute = function (variable) {
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        return variable.value > 1 ? "are" : "is";
	    };
	    ConjugateCopulaDirective.Entry = leafEntry(InflectPluralDirective, Array.from(data_types_1.NumberTypes));
	    return ConjugateCopulaDirective;
	}(PureStringDirective));
	var JoinDirective = (function (_super) {
	    __extends(JoinDirective, _super);
	    function JoinDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.blockPrefix = "";
	        _this.blockSuffix = "";
	        _this.delimiter = "";
	        return _this;
	    }
	    JoinDirective.prototype.preprocess = function (value, params) {
	        return value;
	    };
	    JoinDirective.prototype.wrapperBuilder = function (params) {
	        return function (item) { return "" + item; };
	    };
	    JoinDirective.prototype.execute = function (variable, params) {
	        if (variable.value === null) {
	            return DefaultDirective.NullString;
	        }
	        if (variable.collectionType === "set") {
	            variable.value.sort(function (a, b) {
	                return compareInType(a.value, b.value, a.type);
	            });
	        }
	        var items = this.preprocess(variable.value, params).map(this.wrapperBuilder(params));
	        return this.blockPrefix + items.join(this.delimiter) + this.blockSuffix;
	    };
	    return JoinDirective;
	}(StringDirective));
	var SimpleJoinDirective = (function (_super) {
	    __extends(SimpleJoinDirective, _super);
	    function SimpleJoinDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,simple";
	        _this.parameterRange = inRange(0, 1);
	        _this.parameterTypes = ["string"];
	        return _this;
	    }
	    SimpleJoinDirective.prototype.preprocess = function (arr, _a) {
	        var delim = _a[0];
	        this.delimiter = delim || ", ";
	        return arr;
	    };
	    SimpleJoinDirective.Entry = leafEntry(SimpleJoinDirective);
	    return SimpleJoinDirective;
	}(JoinDirective));
	var BookendedJoinDirective = (function (_super) {
	    __extends(BookendedJoinDirective, _super);
	    function BookendedJoinDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,bookends";
	        _this.parameterRange = inRange(2, 2);
	        _this.parameterTypes = ["string", "string"];
	        return _this;
	    }
	    BookendedJoinDirective.prototype.wrapperBuilder = function (_a) {
	        var prefix = _a[0], suffix = _a[1];
	        return function (item) { return "" + prefix + item + suffix; };
	    };
	    BookendedJoinDirective.Entry = leafEntry(BookendedJoinDirective);
	    return BookendedJoinDirective;
	}(JoinDirective));
	var OxfordJoinDirective = (function (_super) {
	    __extends(OxfordJoinDirective, _super);
	    function OxfordJoinDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,oxford";
	        _this.parameterRange = inRange(1, 1);
	        _this.parameterTypes = ["string"];
	        return _this;
	    }
	    OxfordJoinDirective.prototype.preprocess = function (arr, _a) {
	        var conjunction = _a[0];
	        this.delimiter = ", ";
	        switch (arr.length) {
	            case 0:
	            case 1:
	                return arr;
	            case 2:
	                this.delimiter = " " + conjunction + " ";
	                return arr;
	            default:
	                arr.push(conjunction + " " + arr.pop());
	                return arr;
	        }
	    };
	    OxfordJoinDirective.Entry = leafEntry(OxfordJoinDirective);
	    return OxfordJoinDirective;
	}(JoinDirective));
	var HtmlListDirective = (function (_super) {
	    __extends(HtmlListDirective, _super);
	    function HtmlListDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.parameterRange = inRange(0);
	        _this.parameterTypes = null;
	        _this.blockSuffix = "</" + _this.listTag + ">";
	        return _this;
	    }
	    HtmlListDirective.prototype.verifyParameters = function (types, targetType, cardinalities) {
	        this.initialParamCheck(types, targetType);
	        this.usesCountParameter = supertypeOf("integer", types[0]);
	    };
	    HtmlListDirective.prototype.parseParameters = function (params) {
	        var listAttrCount = this.usesCountParameter
	            ? extractParsed(params.shift(), "integer")
	            : params.length;
	        var attrs = params.map(function (v) { return extractParsed(v, "string"); });
	        return [attrs.slice(0, listAttrCount), attrs.slice(listAttrCount)];
	    };
	    HtmlListDirective.prototype.wrapperBuilder = function (_a) {
	        var listAttrs = _a[0], itemAttrs = _a[1];
	        this.blockPrefix = "<" + this.listTag + " " + listAttrs.join(" ") + ">";
	        return function (item) { return "<li " + itemAttrs.join(" ") + ">" + item + "</li>"; };
	    };
	    return HtmlListDirective;
	}(JoinDirective));
	var UnorderedListDirective = (function (_super) {
	    __extends(UnorderedListDirective, _super);
	    function UnorderedListDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,unordered";
	        _this.listTag = "ul";
	        return _this;
	    }
	    UnorderedListDirective.Entry = leafEntry(UnorderedListDirective);
	    return UnorderedListDirective;
	}(HtmlListDirective));
	var OrderedListDirective = (function (_super) {
	    __extends(OrderedListDirective, _super);
	    function OrderedListDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,ordered";
	        _this.listTag = "ol";
	        return _this;
	    }
	    OrderedListDirective.Entry = leafEntry(OrderedListDirective);
	    return OrderedListDirective;
	}(HtmlListDirective));
	var TruncatedListDirective = (function (_super) {
	    __extends(TruncatedListDirective, _super);
	    function TruncatedListDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "join,truncated";
	        _this.parameterRange = inRange(2, 2);
	        _this.parameterTypes = ["integer", "string"];
	        _this.delimiter = ", ";
	        return _this;
	    }
	    TruncatedListDirective.prototype.preprocess = function (value, _a) {
	        var count = _a[0], ellipsisText = _a[1];
	        if (value.length > count) {
	            this.blockSuffix = ellipsisText;
	            return value.slice(0, count);
	        }
	        else {
	            this.blockSuffix = "";
	            return value;
	        }
	    };
	    TruncatedListDirective.Entry = leafEntry(TruncatedListDirective);
	    return TruncatedListDirective;
	}(JoinDirective));
	var ZipDirective = (function (_super) {
	    __extends(ZipDirective, _super);
	    function ZipDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "zip";
	        _this.parameterRange = inRange(1, 1);
	        _this.parameterTypes = ["string"];
	        _this.delimiter = "), ";
	        _this.blockSuffix = ")";
	        _this.zipConnector = " (";
	        return _this;
	    }
	    ZipDirective.prototype.preprocess = function (value, _a) {
	        var _this = this;
	        var toPair = _a[0];
	        toPair = toPair || [];
	        return value.map(function (v, i) {
	            return "" + v + _this.zipConnector + ((i < toPair.length) ? toPair[i] : "?");
	        });
	    };
	    ZipDirective.Entry = leafEntry(ZipDirective);
	    return ZipDirective;
	}(JoinDirective));
	var ShowProgressDirective = (function (_super) {
	    __extends(ShowProgressDirective, _super);
	    function ShowProgressDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "show-progress";
	        _this.parameterRange = (function (x) { return (x === 0 || x === 2 || x === 3); });
	        _this.parameterTypes = ["float", "float", "string"];
	        return _this;
	    }
	    ShowProgressDirective.prototype.execute = function (variable, _a) {
	        var min = _a[0], max = _a[1], label = _a[2];
	        min = Number.isFinite(min) ? min : 0;
	        max = Number.isFinite(max) ? max : 100;
	        label = (typeof label === "string" && label.length !== 0)
	            ? label
	            : "" + variable.value;
	        var fill = Number.isFinite(variable.value)
	            ? 100 * (variable.value - min) / max
	            : 0;
	        var barStyle = fill < 100 / 3
	            ? "danger"
	            : (fill < 200 / 3
	                ? "warning"
	                : "success");
	        return "\n      <div class=\"progress\">\n        <div\n          class=\"progress-bar progress-bar-" + barStyle + "\"\n          role=\"progressbar\"\n          aria-valuenow=\"" + variable.value + "\"\n          style=\"min-width: 5px; width: " + fill + "%;\"\n          aria-valuemin=\"" + min + "\"\n          aria-valuemax=\"" + max + "\">\n        </div>\n        <label>" + label + "</label>\n      </div>\n      ";
	    };
	    ShowProgressDirective.Entry = leafEntry(ShowProgressDirective, Array.from(data_types_1.NumberTypes));
	    return ShowProgressDirective;
	}(StringDirective));
	var TagWrappedDirective = (function (_super) {
	    __extends(TagWrappedDirective, _super);
	    function TagWrappedDirective() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "tag-for";
	        _this.parameterRange = inRange(1);
	        _this.parameterTypes = ["string"];
	        return _this;
	    }
	    TagWrappedDirective.prototype.execute = function (variable, entries) {
	        variable = parseVarAs(variable, "string");
	        var tag = variable.value || "div";
	        console.warn(entries);
	        return (entries
	            .filter(function (e) { return e && e.replace("&#xA;", "").trim().length > 0; })
	            .map(function (e) { return "<" + tag + ">" + e + "</" + tag + ">"; })
	            .join(""));
	    };
	    TagWrappedDirective.Entry = leafEntry(TagWrappedDirective, ["string"]);
	    return TagWrappedDirective;
	}(StringDirective));
	var INTERNAL_NODE = {
	    terminates: false,
	    hasSubdirectives: true,
	    isProtocolDirective: true,
	    byType: function () { return null; }
	};
	exports.Directives = new Map([
	    [Symbol.for("default"), DefaultDirective.Entry],
	    ["passthrough", PassThroughDirective.Entry],
	    ["=", EqualsDirective.Entry],
	    ["≠", NotEqualsDirective.Entry],
	    [">", GreaterThanDirective.Entry],
	    ["≥", GreaterThanOrEqualDirective.Entry],
	    ["<", LessThanDirective.Entry],
	    ["≤", LessThanOrEqualDirective.Entry],
	    ["map", MapDirective.Entry],
	    ["format", FormatDirectiveEntry],
	    ["index", IndexDirective.Entry],
	    ["uppercase", UppercaseDirective.Entry],
	    ["lowercase", LowercaseDirective.Entry],
	    ["titlecase", TitleCaseDirective.Entry],
	    ["capitalize", CapitalizeDirective.Entry],
	    ["inflect", INTERNAL_NODE],
	    ["inflect,indefinite article", InflectIndefiniteArticleDirective.Entry],
	    ["inflect,definite article", InflectDefiniteArticleDirective.Entry],
	    ["inflect,possessive", InflectPossessiveDirective.Entry],
	    ["inflect,plural", InflectPluralDirective.Entry],
	    ["inflect,copula", ConjugateCopulaDirective.Entry],
	    ["inflect,gendered", INTERNAL_NODE],
	    ["inflect,gendered,subject", GenderedSubject.Entry],
	    ["inflect,gendered,object", GenderedObject.Entry],
	    ["inflect,gendered,possessive adjective",
	        GenderedPossessiveAdjective.Entry],
	    ["inflect,gendered,possessive pronoun", GenderedPossessivePronoun.Entry],
	    ["inflect,gendered,reflexive object", GenderedReflexiveObject.Entry],
	    ["join", INTERNAL_NODE],
	    ["join,simple", SimpleJoinDirective.Entry],
	    ["join,bookends", BookendedJoinDirective.Entry],
	    ["join,oxford", OxfordJoinDirective.Entry],
	    ["join,unordered", UnorderedListDirective.Entry],
	    ["join,ordered", OrderedListDirective.Entry],
	    ["join,truncated", TruncatedListDirective.Entry],
	    ["zip", ZipDirective.Entry],
	    ["tag-for", TagWrappedDirective.Entry],
	    ["show-progress", ShowProgressDirective.Entry]
	]);
	var templateObject_1, templateObject_2;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var RestartAlgorithmBroadcast = (function (_super) {
	    __extends(RestartAlgorithmBroadcast, _super);
	    function RestartAlgorithmBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_RESTART_ALGORITHM;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], RestartAlgorithmBroadcast.prototype, "maybeLostData", void 0);
	    RestartAlgorithmBroadcast = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.BCST_RESTART_ALGORITHM)
	    ], RestartAlgorithmBroadcast);
	    return RestartAlgorithmBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.RestartAlgorithmBroadcast = RestartAlgorithmBroadcast;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StartAlgorithmRequest = (function (_super) {
	    __extends(StartAlgorithmRequest, _super);
	    function StartAlgorithmRequest(name, objectId) {
	        var _this = _super.call(this) || this;
	        _this.name = name;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_START_ALGORITHM;
	        return _this;
	    }
	    StartAlgorithmRequest.tag = message_tag_1.MessageTag.REQ_START_ALGORITHM;
	    return StartAlgorithmRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StartAlgorithmRequest = StartAlgorithmRequest;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StopAlgorithmRequest = (function (_super) {
	    __extends(StopAlgorithmRequest, _super);
	    function StopAlgorithmRequest() {
	        var _this = _super.call(this) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_STOP_ALGORITHM;
	        return _this;
	    }
	    StopAlgorithmRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_STOP_ALGORITHM);
	    };
	    StopAlgorithmRequest.tag = message_tag_1.MessageTag.REQ_STOP_ALGORITHM;
	    return StopAlgorithmRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StopAlgorithmRequest = StopAlgorithmRequest;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var StopAlgorithmResponse = (function (_super) {
	    __extends(StopAlgorithmResponse, _super);
	    function StopAlgorithmResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STOP_ALGORITHM;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], StopAlgorithmResponse.prototype, "name", void 0);
	    StopAlgorithmResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STOP_ALGORITHM)
	    ], StopAlgorithmResponse);
	    return StopAlgorithmResponse;
	}(incoming_message_1.IncomingMessage));
	exports.StopAlgorithmResponse = StopAlgorithmResponse;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var SubmitAnswersUpstreamMessage = (function (_super) {
	    __extends(SubmitAnswersUpstreamMessage, _super);
	    function SubmitAnswersUpstreamMessage(answers) {
	        var _this = _super.call(this) || this;
	        _this.answers = answers;
	        _this.tag = message_tag_1.MessageTag.UP_SUBMIT_ANSWERS;
	        return _this;
	    }
	    SubmitAnswersUpstreamMessage.prototype.expectsReply = function () {
	        return true;
	    };
	    SubmitAnswersUpstreamMessage.tag = message_tag_1.MessageTag.UP_SUBMIT_ANSWERS;
	    return SubmitAnswersUpstreamMessage;
	}(message_1.Message));
	exports.SubmitAnswersUpstreamMessage = SubmitAnswersUpstreamMessage;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var add_comment_request_1 = __webpack_require__(593);
	exports.AddCommentRequest = add_comment_request_1.AddCommentRequest;
	var chat_message_broadcast_1 = __webpack_require__(594);
	exports.ChatMessageBroadcast = chat_message_broadcast_1.ChatMessageBroadcast;
	var comment_response_1 = __webpack_require__(595);
	exports.CommentResponse = comment_response_1.CommentResponse;
	var delete_comment_request_1 = __webpack_require__(596);
	exports.DeleteCommentRequest = delete_comment_request_1.DeleteCommentRequest;
	var extension_signal_request_1 = __webpack_require__(597);
	exports.ExtensionSignalRequest = extension_signal_request_1.ExtensionSignalRequest;
	var extension_signal_broadcast_1 = __webpack_require__(598);
	exports.ExtensionSignalBroadcast = extension_signal_broadcast_1.ExtensionSignalBroadcast;
	var modify_comment_request_1 = __webpack_require__(599);
	exports.ModifyCommentRequest = modify_comment_request_1.ModifyCommentRequest;
	var post_chat_message_request_1 = __webpack_require__(600);
	exports.PostChatMessageRequest = post_chat_message_request_1.PostChatMessageRequest;
	var DEPRECATED_add_step_comment_request_1 = __webpack_require__(601);
	exports.DeprecatedAddStepCommentRequest = DEPRECATED_add_step_comment_request_1.DeprecatedAddStepCommentRequest;
	var DEPRECATED_delete_step_comment_request_1 = __webpack_require__(602);
	exports.DeprecatedDeleteStepCommentRequest = DEPRECATED_delete_step_comment_request_1.DeprecatedDeleteStepCommentRequest;
	var DEPRECATED_modify_step_comment_request_1 = __webpack_require__(603);
	exports.DeprecatedModifyStepCommentRequest = DEPRECATED_modify_step_comment_request_1.DeprecatedModifyStepCommentRequest;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var comment_1 = __webpack_require__(209);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AddCommentRequest = (function (_super) {
	    __extends(AddCommentRequest, _super);
	    function AddCommentRequest(comment, visibility, selfGroupIds) {
	        var _this = _super.call(this) || this;
	        _this.comment = comment;
	        _this.tag = message_tag_1.MessageTag.REQ_ADD_COMMENT;
	        comment_1.Comment.applyVisibilityToMessage(_this, visibility, selfGroupIds);
	        return _this;
	    }
	    AddCommentRequest.tag = message_tag_1.MessageTag.REQ_ADD_COMMENT;
	    return AddCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AddCommentRequest = AddCommentRequest;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ChatMessageBroadcast = (function (_super) {
	    __extends(ChatMessageBroadcast, _super);
	    function ChatMessageBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_CHAT_MESSAGE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], ChatMessageBroadcast.prototype, "message", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }]),
	        __metadata("design:type", Number)
	    ], ChatMessageBroadcast.prototype, "userId", void 0);
	    ChatMessageBroadcast = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.BCST_CHAT_MESSAGE)
	    ], ChatMessageBroadcast);
	    return ChatMessageBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.ChatMessageBroadcast = ChatMessageBroadcast;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var comment_1 = __webpack_require__(209);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var CommentResponse = (function (_super) {
	    __extends(CommentResponse, _super);
	    function CommentResponse() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    __decorate([
	        decorators_1.validateTSEnum(comment_1.CommentType),
	        __metadata("design:type", Number)
	    ], CommentResponse.prototype, "commentType", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(true),
	        __metadata("design:type", Number)
	    ], CommentResponse.prototype, "commentId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(true),
	        __metadata("design:type", Number)
	    ], CommentResponse.prototype, "stepId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, false, undefined, [
	            function (json) { return json.comments = json.comments.map(function (c) { return comment_1.Comment.fromData(c); }); }
	        ]),
	        __metadata("design:type", Array)
	    ], CommentResponse.prototype, "comments", void 0);
	    CommentResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_COMMENT)
	    ], CommentResponse);
	    return CommentResponse;
	}(incoming_message_1.IncomingMessage));
	exports.CommentResponse = CommentResponse;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeleteCommentRequest = (function (_super) {
	    __extends(DeleteCommentRequest, _super);
	    function DeleteCommentRequest(commentId) {
	        var _this = _super.call(this) || this;
	        _this.commentId = commentId;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_COMMENT;
	        return _this;
	    }
	    DeleteCommentRequest.tag = message_tag_1.MessageTag.REQ_DELETE_COMMENT;
	    return DeleteCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeleteCommentRequest = DeleteCommentRequest;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var ExtensionSignalRequest = (function (_super) {
	    __extends(ExtensionSignalRequest, _super);
	    function ExtensionSignalRequest(payload) {
	        var _this = _super.call(this) || this;
	        _this.payload = payload;
	        _this.tag = message_tag_1.MessageTag.REQ_EXTENSION_SIGNAL;
	        return _this;
	    }
	    ExtensionSignalRequest.prototype.expectsReply = function () {
	        return true;
	    };
	    ExtensionSignalRequest.tag = message_tag_1.MessageTag.REQ_EXTENSION_SIGNAL;
	    return ExtensionSignalRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.ExtensionSignalRequest = ExtensionSignalRequest;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ExtensionSignalBroadcast = (function (_super) {
	    __extends(ExtensionSignalBroadcast, _super);
	    function ExtensionSignalBroadcast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.BCST_EXTENSION_SIGNAL;
	        return _this;
	    }
	    var _a;
	    __decorate([
	        decorators_1.validateAs("object"),
	        __metadata("design:type", typeof (_a = typeof P !== "undefined" && P) === "function" && _a || Object)
	    ], ExtensionSignalBroadcast.prototype, "payload", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], ExtensionSignalBroadcast.prototype, "senderId", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], ExtensionSignalBroadcast.prototype, "senderName", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], ExtensionSignalBroadcast.prototype, "senderOrganization", void 0);
	    ExtensionSignalBroadcast = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.BCST_EXTENSION_SIGNAL)
	    ], ExtensionSignalBroadcast);
	    return ExtensionSignalBroadcast;
	}(incoming_message_1.IncomingMessage));
	exports.ExtensionSignalBroadcast = ExtensionSignalBroadcast;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var comment_1 = __webpack_require__(209);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ModifyCommentRequest = (function (_super) {
	    __extends(ModifyCommentRequest, _super);
	    function ModifyCommentRequest(commentId, comment, visibility, selfGroupIds) {
	        var _this = _super.call(this) || this;
	        _this.commentId = commentId;
	        _this.comment = comment;
	        _this.tag = message_tag_1.MessageTag.REQ_MODIFY_COMMENT;
	        comment_1.Comment.applyVisibilityToMessage(_this, visibility, selfGroupIds);
	        return _this;
	    }
	    ModifyCommentRequest.tag = message_tag_1.MessageTag.REQ_MODIFY_COMMENT;
	    return ModifyCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ModifyCommentRequest = ModifyCommentRequest;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var PostChatMessageRequest = (function (_super) {
	    __extends(PostChatMessageRequest, _super);
	    function PostChatMessageRequest(message) {
	        var _this = _super.call(this) || this;
	        _this.message = message;
	        _this.tag = message_tag_1.MessageTag.REQ_POST_CHAT_MESSAGE;
	        return _this;
	    }
	    PostChatMessageRequest.tag = message_tag_1.MessageTag.REQ_POST_CHAT_MESSAGE;
	    return PostChatMessageRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.PostChatMessageRequest = PostChatMessageRequest;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var comment_1 = __webpack_require__(209);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeprecatedAddStepCommentRequest = (function (_super) {
	    __extends(DeprecatedAddStepCommentRequest, _super);
	    function DeprecatedAddStepCommentRequest(stepId, comment, visibility, selfGroupIds) {
	        var _this = _super.call(this) || this;
	        _this.stepId = stepId;
	        _this.comment = comment;
	        _this.tag = message_tag_1.MessageTag.DEP_REQ_ADD_STEP_COMMENT;
	        _this.isPublic = false;
	        _this.groupIds = [];
	        comment_1.Comment.applyVisibilityToMessage(_this, visibility, selfGroupIds);
	        return _this;
	    }
	    DeprecatedAddStepCommentRequest.tag = message_tag_1.MessageTag.DEP_REQ_ADD_STEP_COMMENT;
	    return DeprecatedAddStepCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeprecatedAddStepCommentRequest = DeprecatedAddStepCommentRequest;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeprecatedDeleteStepCommentRequest = (function (_super) {
	    __extends(DeprecatedDeleteStepCommentRequest, _super);
	    function DeprecatedDeleteStepCommentRequest(commentId, stepId) {
	        var _this = _super.call(this) || this;
	        _this.commentId = commentId;
	        _this.stepId = stepId;
	        _this.tag = message_tag_1.MessageTag.DEP_REQ_DELETE_STEP_COMMENT;
	        return _this;
	    }
	    DeprecatedDeleteStepCommentRequest.tag = message_tag_1.MessageTag.DEP_REQ_DELETE_STEP_COMMENT;
	    return DeprecatedDeleteStepCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeprecatedDeleteStepCommentRequest = DeprecatedDeleteStepCommentRequest;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var comment_1 = __webpack_require__(209);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeprecatedModifyStepCommentRequest = (function (_super) {
	    __extends(DeprecatedModifyStepCommentRequest, _super);
	    function DeprecatedModifyStepCommentRequest(stepId, commentId, comment, visibility, selfGroupIds) {
	        var _this = _super.call(this) || this;
	        _this.stepId = stepId;
	        _this.commentId = commentId;
	        _this.comment = comment;
	        _this.tag = message_tag_1.MessageTag.DEP_REQ_MODIFY_STEP_COMMENT;
	        comment_1.Comment.applyVisibilityToMessage(_this, visibility, selfGroupIds);
	        return _this;
	    }
	    DeprecatedModifyStepCommentRequest.tag = message_tag_1.MessageTag.DEP_REQ_MODIFY_STEP_COMMENT;
	    return DeprecatedModifyStepCommentRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeprecatedModifyStepCommentRequest = DeprecatedModifyStepCommentRequest;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var create_subject_context_request_1 = __webpack_require__(605);
	exports.CreateSubjectContextRequest = create_subject_context_request_1.CreateSubjectContextRequest;
	var increase_subject_context_visibility_request_1 = __webpack_require__(606);
	exports.IncreaseSubjectContextVisibilityRequest = increase_subject_context_visibility_request_1.IncreaseSubjectContextVisibilityRequest;
	var refer_subject_context_request_1 = __webpack_require__(608);
	exports.ReferSubjectContextRequest = refer_subject_context_request_1.ReferSubjectContextRequest;
	var release_object_request_1 = __webpack_require__(609);
	exports.ReleaseObjectRequest = release_object_request_1.ReleaseObjectRequest;
	var save_response_1 = __webpack_require__(610);
	exports.SaveResponse = save_response_1.SaveResponse;
	var save_subject_context_request_1 = __webpack_require__(611);
	exports.SaveSubjectContextRequest = save_subject_context_request_1.SaveSubjectContextRequest;
	var subject_context_response_1 = __webpack_require__(612);
	exports.SubjectContextResponse = subject_context_response_1.SubjectContextResponse;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var CreateSubjectContextRequest = (function (_super) {
	    __extends(CreateSubjectContextRequest, _super);
	    function CreateSubjectContextRequest(type, groupIds, asDuplicateOfCurrent) {
	        if (asDuplicateOfCurrent === void 0) { asDuplicateOfCurrent = false; }
	        var _this = _super.call(this) || this;
	        _this.type = type;
	        _this.groupIds = groupIds;
	        _this.asDuplicateOfCurrent = asDuplicateOfCurrent;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_SUBJECT_CONTEXT;
	        return _this;
	    }
	    CreateSubjectContextRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    CreateSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_CREATE_SUBJECT_CONTEXT;
	    return CreateSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.CreateSubjectContextRequest = CreateSubjectContextRequest;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var group_1 = __webpack_require__(607);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var IncreaseSubjectContextVisibilityRequest = (function (_super) {
	    __extends(IncreaseSubjectContextVisibilityRequest, _super);
	    function IncreaseSubjectContextVisibilityRequest(group) {
	        var _this = _super.call(this) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY;
	        _this.groupId = (group instanceof group_1.Group) ? group.id : group;
	        return _this;
	    }
	    IncreaseSubjectContextVisibilityRequest.tag = message_tag_1.MessageTag.REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY;
	    return IncreaseSubjectContextVisibilityRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.IncreaseSubjectContextVisibilityRequest = IncreaseSubjectContextVisibilityRequest;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Group = (function () {
	    function Group(data, self) {
	        this.rules = [];
	        this.users = [];
	        this.name = data.groupName;
	        this.id = data.groupId;
	        this.rules = data.rules || [];
	        this.primaryGroupId =
	            (data.primaryGroupId === -1) ? null : data.primaryGroupId;
	        if (self) {
	            this.users.push(self);
	        }
	    }
	    Object.defineProperty(Group.prototype, "isPrimary", {
	        get: function () {
	            return this.primaryGroupId === this.id;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Group.prototype.allows = function (rules, disjunctive) {
	        var _this = this;
	        if (disjunctive === void 0) { disjunctive = false; }
	        if (!Array.isArray(rules)) {
	            return (this.rules.indexOf(rules) > -1);
	        }
	        if (disjunctive) {
	            return rules.some(function (r) { return _this.rules.indexOf(r) > -1; });
	        }
	        else {
	            return rules.every(function (r) { return _this.rules.indexOf(r) > -1; });
	        }
	    };
	    Object.defineProperty(Group.prototype, "member", {
	        get: function () {
	            return this.rules.length > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Group;
	}());
	exports.Group = Group;
	var ManagedGroup = (function (_super) {
	    __extends(ManagedGroup, _super);
	    function ManagedGroup() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ManagedGroup;
	}(Group));
	exports.ManagedGroup = ManagedGroup;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ReferSubjectContextRequest = (function (_super) {
	    __extends(ReferSubjectContextRequest, _super);
	    function ReferSubjectContextRequest(objectId, note) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.note = note;
	        _this.tag = message_tag_1.MessageTag.REQ_REFER_SUBJECT_CONTEXT;
	        return _this;
	    }
	    ReferSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_REFER_SUBJECT_CONTEXT;
	    return ReferSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ReferSubjectContextRequest = ReferSubjectContextRequest;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ReleaseObjectRequest = (function (_super) {
	    __extends(ReleaseObjectRequest, _super);
	    function ReleaseObjectRequest(objectId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_RELEASE_OBJECT;
	        return _this;
	    }
	    ReleaseObjectRequest.tag = message_tag_1.MessageTag.REQ_RELEASE_OBJECT;
	    return ReleaseObjectRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ReleaseObjectRequest = ReleaseObjectRequest;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SaveResponse = (function (_super) {
	    __extends(SaveResponse, _super);
	    function SaveResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SAVE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], SaveResponse.prototype, "userId", void 0);
	    SaveResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SAVE)
	    ], SaveResponse);
	    return SaveResponse;
	}(incoming_message_1.IncomingMessage));
	exports.SaveResponse = SaveResponse;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SaveSubjectContextRequest = (function (_super) {
	    __extends(SaveSubjectContextRequest, _super);
	    function SaveSubjectContextRequest(objectId, saveForcibly) {
	        if (saveForcibly === void 0) { saveForcibly = false; }
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.saveForcibly = saveForcibly;
	        _this.tag = message_tag_1.MessageTag.REQ_SAVE_SUBJECT_CONTEXT;
	        return _this;
	    }
	    SaveSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_SAVE_SUBJECT_CONTEXT;
	    return SaveSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SaveSubjectContextRequest = SaveSubjectContextRequest;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var subject_context_type_1 = __webpack_require__(569);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextResponse = (function (_super) {
	    __extends(SubjectContextResponse, _super);
	    function SubjectContextResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], SubjectContextResponse.prototype, "created", void 0);
	    __decorate([
	        decorators_1.validateAs("object"),
	        __metadata("design:type", Object)
	    ], SubjectContextResponse.prototype, "summary", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], SubjectContextResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(false, null, true),
	        __metadata("design:type", Number)
	    ], SubjectContextResponse.prototype, "watchId", void 0);
	    __decorate([
	        decorators_1.validateAs({ enum: Object.values(subject_context_type_1.KnownSubjectContextTypes) }),
	        __metadata("design:type", String)
	    ], SubjectContextResponse.prototype, "contextType", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "string" }),
	        __metadata("design:type", Array)
	    ], SubjectContextResponse.prototype, "algorithms", void 0);
	    SubjectContextResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT)
	    ], SubjectContextResponse);
	    return SubjectContextResponse;
	}(incoming_message_1.IncomingMessage));
	exports.SubjectContextResponse = SubjectContextResponse;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DEBUG_breakpoint_upstream_message_1 = __webpack_require__(614);
	exports.DebugBreakpointUpstreamMessage = DEBUG_breakpoint_upstream_message_1.DebugBreakpointUpstreamMessage;
	var DEBUG_log_downstream_message_1 = __webpack_require__(615);
	exports.DebugLogDownstreamMessage = DEBUG_log_downstream_message_1.DebugLogDownstreamMessage;
	var DEBUG_log_upstream_message_1 = __webpack_require__(616);
	exports.DebugLogUpstreamMessage = DEBUG_log_upstream_message_1.DebugLogUpstreamMessage;
	var DEBUG_restart_algorithm_request_1 = __webpack_require__(617);
	exports.DeubgRestartAlgorithmRequest = DEBUG_restart_algorithm_request_1.DeubgRestartAlgorithmRequest;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var DebugBreakpointUpstreamMessage = (function (_super) {
	    __extends(DebugBreakpointUpstreamMessage, _super);
	    function DebugBreakpointUpstreamMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.DBG_UP_BREAKPOINT;
	        return _this;
	    }
	    DebugBreakpointUpstreamMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    DebugBreakpointUpstreamMessage.tag = message_tag_1.MessageTag.DBG_UP_BREAKPOINT;
	    return DebugBreakpointUpstreamMessage;
	}(message_1.Message));
	exports.DebugBreakpointUpstreamMessage = DebugBreakpointUpstreamMessage;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var DebugLogDownstreamMessage = (function (_super) {
	    __extends(DebugLogDownstreamMessage, _super);
	    function DebugLogDownstreamMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.DBG_DOWN_LOG;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs([]),
	        __metadata("design:type", Object)
	    ], DebugLogDownstreamMessage.prototype, "content", void 0);
	    DebugLogDownstreamMessage = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.DBG_DOWN_LOG)
	    ], DebugLogDownstreamMessage);
	    return DebugLogDownstreamMessage;
	}(incoming_message_1.IncomingMessage));
	exports.DebugLogDownstreamMessage = DebugLogDownstreamMessage;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var DebugLogUpstreamMessage = (function (_super) {
	    __extends(DebugLogUpstreamMessage, _super);
	    function DebugLogUpstreamMessage(level, message, useSecondaryLog) {
	        if (useSecondaryLog === void 0) { useSecondaryLog = true; }
	        var _this = _super.call(this) || this;
	        _this.level = level;
	        _this.message = message;
	        _this.useSecondaryLog = useSecondaryLog;
	        _this.tag = message_tag_1.MessageTag.DBG_UP_LOG;
	        return _this;
	    }
	    DebugLogUpstreamMessage.prototype.expectsReply = function () {
	        return false;
	    };
	    DebugLogUpstreamMessage.tag = message_tag_1.MessageTag.DBG_UP_LOG;
	    return DebugLogUpstreamMessage;
	}(message_1.Message));
	exports.DebugLogUpstreamMessage = DebugLogUpstreamMessage;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeubgRestartAlgorithmRequest = (function (_super) {
	    __extends(DeubgRestartAlgorithmRequest, _super);
	    function DeubgRestartAlgorithmRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.DBG_REQ_RESTART_ALGORITHM;
	        return _this;
	    }
	    DeubgRestartAlgorithmRequest.tag = message_tag_1.MessageTag.DBG_REQ_RESTART_ALGORITHM;
	    return DeubgRestartAlgorithmRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeubgRestartAlgorithmRequest = DeubgRestartAlgorithmRequest;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var available_data_exports_response_1 = __webpack_require__(619);
	exports.AvailableDataExportsResponse = available_data_exports_response_1.AvailableDataExportsResponse;
	var basic_data_export_requests_1 = __webpack_require__(620);
	exports.CancelDataExportRequest = basic_data_export_requests_1.CancelDataExportRequest;
	exports.DataExportStatusRequest = basic_data_export_requests_1.DataExportStatusRequest;
	exports.PauseDataExportRequest = basic_data_export_requests_1.PauseDataExportRequest;
	exports.ResumeDataExportRequest = basic_data_export_requests_1.ResumeDataExportRequest;
	var create_data_export_request_1 = __webpack_require__(621);
	exports.CreateDataExportRequest = create_data_export_request_1.CreateDataExportRequest;
	var create_data_export_response_1 = __webpack_require__(622);
	exports.CreateDataExportResponse = create_data_export_response_1.CreateDataExportResponse;
	var data_export_failure_response_1 = __webpack_require__(623);
	exports.DataExportFailureResponse = data_export_failure_response_1.DataExportFailureResponse;
	var data_export_report_response_1 = __webpack_require__(624);
	exports.DataExportReportResponse = data_export_report_response_1.DataExportReportResponse;
	var data_export_status_response_1 = __webpack_require__(625);
	exports.DataExportStatusResponse = data_export_status_response_1.DataExportStatusResponse;
	var start_data_export_request_1 = __webpack_require__(626);
	exports.StartDataExportRequest = start_data_export_request_1.StartDataExportRequest;
	var start_data_export_response_1 = __webpack_require__(627);
	exports.StartDataExportResponse = start_data_export_response_1.StartDataExportResponse;
	var refresh_report_schemas_response_1 = __webpack_require__(628);
	exports.RefreshReportSchemasResponse = refresh_report_schemas_response_1.RefreshReportSchemasResponse;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var AvailableDataExportsResponse = (function (_super) {
	    __extends(AvailableDataExportsResponse, _super);
	    function AvailableDataExportsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_AVAILABLE_DATA_EXPORTS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], AvailableDataExportsResponse.prototype, "formats", void 0);
	    AvailableDataExportsResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_AVAILABLE_DATA_EXPORTS)
	    ], AvailableDataExportsResponse);
	    return AvailableDataExportsResponse;
	}(incoming_message_1.IncomingMessage));
	exports.AvailableDataExportsResponse = AvailableDataExportsResponse;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var BasicDataExportRequest = (function (_super) {
	    __extends(BasicDataExportRequest, _super);
	    function BasicDataExportRequest(exportId) {
	        var _this = _super.call(this) || this;
	        _this.exportId = exportId;
	        return _this;
	    }
	    return BasicDataExportRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	var PauseDataExportRequest = (function (_super) {
	    __extends(PauseDataExportRequest, _super);
	    function PauseDataExportRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_PAUSE_DATA_EXPORT;
	        return _this;
	    }
	    return PauseDataExportRequest;
	}(BasicDataExportRequest));
	exports.PauseDataExportRequest = PauseDataExportRequest;
	var ResumeDataExportRequest = (function (_super) {
	    __extends(ResumeDataExportRequest, _super);
	    function ResumeDataExportRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_RESUME_DATA_EXPORT;
	        return _this;
	    }
	    return ResumeDataExportRequest;
	}(BasicDataExportRequest));
	exports.ResumeDataExportRequest = ResumeDataExportRequest;
	var CancelDataExportRequest = (function (_super) {
	    __extends(CancelDataExportRequest, _super);
	    function CancelDataExportRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_CANCEL_DATA_EXPORT;
	        return _this;
	    }
	    return CancelDataExportRequest;
	}(BasicDataExportRequest));
	exports.CancelDataExportRequest = CancelDataExportRequest;
	var DataExportStatusRequest = (function (_super) {
	    __extends(DataExportStatusRequest, _super);
	    function DataExportStatusRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_STATUS_DATA_EXPORT;
	        return _this;
	    }
	    DataExportStatusRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_STATUS_DATA_EXPORT);
	    };
	    return DataExportStatusRequest;
	}(BasicDataExportRequest));
	exports.DataExportStatusRequest = DataExportStatusRequest;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var CreateDataExportRequest = (function (_super) {
	    __extends(CreateDataExportRequest, _super);
	    function CreateDataExportRequest(formatName, algorithm, subjectContextType, groupId, exportName) {
	        if (exportName === void 0) { exportName = "new export"; }
	        var _this = _super.call(this) || this;
	        _this.formatName = formatName;
	        _this.algorithm = algorithm;
	        _this.subjectContextType = subjectContextType;
	        _this.groupId = groupId;
	        _this.exportName = exportName;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_DATA_EXPORT;
	        return _this;
	    }
	    CreateDataExportRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_CREATE_DATA_EXPORT);
	    };
	    CreateDataExportRequest.tag = message_tag_1.MessageTag.REQ_CREATE_DATA_EXPORT;
	    return CreateDataExportRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.CreateDataExportRequest = CreateDataExportRequest;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var CreateDataExportResponse = (function (_super) {
	    __extends(CreateDataExportResponse, _super);
	    function CreateDataExportResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CREATE_DATA_EXPORT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], CreateDataExportResponse.prototype, "exportId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], CreateDataExportResponse.prototype, "targetVariableOptions", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], CreateDataExportResponse.prototype, "filterOptions", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], CreateDataExportResponse.prototype, "tables", void 0);
	    CreateDataExportResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CREATE_DATA_EXPORT)
	    ], CreateDataExportResponse);
	    return CreateDataExportResponse;
	}(incoming_message_1.IncomingMessage));
	exports.CreateDataExportResponse = CreateDataExportResponse;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var response_code_1 = __webpack_require__(527);
	var message_tag_1 = __webpack_require__(515);
	var DataExportFailureResponse = (function (_super) {
	    __extends(DataExportFailureResponse, _super);
	    function DataExportFailureResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_DATA_EXPORT_FAILURE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], DataExportFailureResponse.prototype, "exportId", void 0);
	    __decorate([
	        decorators_1.validateTSEnum(response_code_1.ResponseCode),
	        __metadata("design:type", Number)
	    ], DataExportFailureResponse.prototype, "code", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], DataExportFailureResponse.prototype, "reason", void 0);
	    DataExportFailureResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_DATA_EXPORT_FAILURE)
	    ], DataExportFailureResponse);
	    return DataExportFailureResponse;
	}(incoming_message_1.IncomingMessage));
	exports.DataExportFailureResponse = DataExportFailureResponse;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var subject_context_type_1 = __webpack_require__(569);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var DataExportReportResponse = (function (_super) {
	    __extends(DataExportReportResponse, _super);
	    function DataExportReportResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_DATA_EXPORT_REPORT;
	        return _this;
	    }
	    Object.defineProperty(DataExportReportResponse.prototype, "checksumUnsigned", {
	        get: function () {
	            return this.checksum & 0xFFFFFFFF;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "exportId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "groupId", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], DataExportReportResponse.prototype, "exportName", void 0);
	    __decorate([
	        decorators_1.validateAs({ enum: Object.values(subject_context_type_1.KnownSubjectContextTypes) }),
	        __metadata("design:type", String)
	    ], DataExportReportResponse.prototype, "subjectContextType", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "processed", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "rejected", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "viable", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "recordCount", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "start", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "ended", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "duration", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "paused", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], DataExportReportResponse.prototype, "export", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "bytesSent", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportReportResponse.prototype, "checksum", void 0);
	    DataExportReportResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_DATA_EXPORT_REPORT)
	    ], DataExportReportResponse);
	    return DataExportReportResponse;
	}(incoming_message_1.IncomingMessage));
	exports.DataExportReportResponse = DataExportReportResponse;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var DataExportStatusResponse = (function (_super) {
	    __extends(DataExportStatusResponse, _super);
	    function DataExportStatusResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STATUS_DATA_EXPORT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], DataExportStatusResponse.prototype, "exportId", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportStatusResponse.prototype, "processed", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportStatusResponse.prototype, "rejected", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportStatusResponse.prototype, "viable", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], DataExportStatusResponse.prototype, "recordCount", void 0);
	    DataExportStatusResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STATUS_DATA_EXPORT)
	    ], DataExportStatusResponse);
	    return DataExportStatusResponse;
	}(incoming_message_1.IncomingMessage));
	exports.DataExportStatusResponse = DataExportStatusResponse;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var StartDataExportRequest = (function (_super) {
	    __extends(StartDataExportRequest, _super);
	    function StartDataExportRequest(exportId, filterTree, targetColumns, useHeaders, customInnerDelimiter, useExcelDates, excludeRecordsFailingCollectionFilters) {
	        if (useHeaders === void 0) { useHeaders = true; }
	        if (useExcelDates === void 0) { useExcelDates = true; }
	        if (excludeRecordsFailingCollectionFilters === void 0) { excludeRecordsFailingCollectionFilters = true; }
	        var _this = _super.call(this) || this;
	        _this.exportId = exportId;
	        _this.filterTree = filterTree;
	        _this.targetColumns = targetColumns;
	        _this.useHeaders = useHeaders;
	        _this.customInnerDelimiter = customInnerDelimiter;
	        _this.useExcelDates = useExcelDates;
	        _this.excludeRecordsFailingCollectionFilters = excludeRecordsFailingCollectionFilters;
	        _this.tag = message_tag_1.MessageTag.REQ_START_DATA_EXPORT;
	        if (!filterTree) {
	            delete _this.filterTree;
	        }
	        return _this;
	    }
	    StartDataExportRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, message_tag_1.MessageTag.RSP_START_DATA_EXPORT);
	    };
	    StartDataExportRequest.tag = message_tag_1.MessageTag.REQ_START_DATA_EXPORT;
	    return StartDataExportRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.StartDataExportRequest = StartDataExportRequest;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var StartDataExportResponse = (function (_super) {
	    __extends(StartDataExportResponse, _super);
	    function StartDataExportResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_START_DATA_EXPORT;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], StartDataExportResponse.prototype, "exportId", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], StartDataExportResponse.prototype, "token", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], StartDataExportResponse.prototype, "urlId", void 0);
	    StartDataExportResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_START_DATA_EXPORT)
	    ], StartDataExportResponse);
	    return StartDataExportResponse;
	}(incoming_message_1.IncomingMessage));
	exports.StartDataExportResponse = StartDataExportResponse;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var RefreshReportSchemasResponse = (function (_super) {
	    __extends(RefreshReportSchemasResponse, _super);
	    function RefreshReportSchemasResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_REFRESH_REPORT_SCHEMAS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RefreshReportSchemasResponse.prototype, "aggregationSchemas", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RefreshReportSchemasResponse.prototype, "dataExportSchemas", void 0);
	    RefreshReportSchemasResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_REFRESH_REPORT_SCHEMAS)
	    ], RefreshReportSchemasResponse);
	    return RefreshReportSchemasResponse;
	}(incoming_message_1.IncomingMessage));
	exports.RefreshReportSchemasResponse = RefreshReportSchemasResponse;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var create_group_request_1 = __webpack_require__(630);
	exports.CreateGroupRequest = create_group_request_1.CreateGroupRequest;
	var group_users_request_1 = __webpack_require__(631);
	exports.GroupUsersRequest = group_users_request_1.GroupUsersRequest;
	var group_users_response_1 = __webpack_require__(632);
	exports.GroupUsersResponse = group_users_response_1.GroupUsersResponse;
	var modify_user_metadata_request_1 = __webpack_require__(633);
	exports.ModifyUserMetadataRequest = modify_user_metadata_request_1.ModifyUserMetadataRequest;
	var save_group_request_1 = __webpack_require__(634);
	exports.SaveGroupRequest = save_group_request_1.SaveGroupRequest;
	var user_request_1 = __webpack_require__(635);
	exports.UserRequest = user_request_1.UserRequest;
	var user_response_1 = __webpack_require__(636);
	exports.UserResponse = user_response_1.UserResponse;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var CreateGroupRequest = (function (_super) {
	    __extends(CreateGroupRequest, _super);
	    function CreateGroupRequest(name, objectId, copyContacts) {
	        var _this = _super.call(this) || this;
	        _this.name = name;
	        _this.objectId = objectId;
	        _this.copyContacts = copyContacts;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_GROUP;
	        throw new Error("This message is reserved but unimplemented.");
	        return _this;
	    }
	    CreateGroupRequest.tag = message_tag_1.MessageTag.REQ_CREATE_GROUP;
	    return CreateGroupRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.CreateGroupRequest = CreateGroupRequest;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var GroupUsersRequest = (function (_super) {
	    __extends(GroupUsersRequest, _super);
	    function GroupUsersRequest(groupId) {
	        var _this = _super.call(this) || this;
	        _this.groupId = groupId;
	        _this.tag = message_tag_1.MessageTag.REQ_GROUP_USERS;
	        return _this;
	    }
	    GroupUsersRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, message_tag_1.MessageTag.RSP_GROUP_USERS);
	    };
	    GroupUsersRequest.tag = message_tag_1.MessageTag.REQ_GROUP_USERS;
	    return GroupUsersRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.GroupUsersRequest = GroupUsersRequest;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var decorators_1 = __webpack_require__(521);
	var GroupUsersResponse = (function (_super) {
	    __extends(GroupUsersResponse, _super);
	    function GroupUsersResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_GROUP_USERS;
	        return _this;
	    }
	    GroupUsersResponse.tag = message_tag_1.MessageTag.RSP_GROUP_USERS;
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], GroupUsersResponse.prototype, "resultSet", void 0);
	    GroupUsersResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_GROUP_USERS)
	    ], GroupUsersResponse);
	    return GroupUsersResponse;
	}(general_1.IncomingMessage));
	exports.GroupUsersResponse = GroupUsersResponse;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ModifyUserMetadataRequest = (function (_super) {
	    __extends(ModifyUserMetadataRequest, _super);
	    function ModifyUserMetadataRequest(objectId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_EDIT_USER;
	        throw new Error("This message is reserved but unimplemented.");
	        return _this;
	    }
	    ModifyUserMetadataRequest.tag = message_tag_1.MessageTag.REQ_EDIT_USER;
	    return ModifyUserMetadataRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ModifyUserMetadataRequest = ModifyUserMetadataRequest;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SaveGroupRequest = (function (_super) {
	    __extends(SaveGroupRequest, _super);
	    function SaveGroupRequest(objectId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_EDIT_GROUP;
	        throw new Error("This message is reserved but unimplemented.");
	        return _this;
	    }
	    SaveGroupRequest.tag = message_tag_1.MessageTag.REQ_EDIT_GROUP;
	    return SaveGroupRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SaveGroupRequest = SaveGroupRequest;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var UserRequest = (function (_super) {
	    __extends(UserRequest, _super);
	    function UserRequest(recordId) {
	        var _this = _super.call(this) || this;
	        _this.recordId = recordId;
	        _this.tag = message_tag_1.MessageTag.REQ_USER;
	        return _this;
	    }
	    UserRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, message_tag_1.MessageTag.RSP_USER);
	    };
	    UserRequest.tag = message_tag_1.MessageTag.REQ_USER;
	    return UserRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.UserRequest = UserRequest;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var decorators_1 = __webpack_require__(521);
	var UserResponse = (function (_super) {
	    __extends(UserResponse, _super);
	    function UserResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_USER;
	        return _this;
	    }
	    UserResponse.tag = message_tag_1.MessageTag.RSP_USER;
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserResponse.prototype, "name", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], UserResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], UserResponse.prototype, "id", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], UserResponse.prototype, "isCurrent", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], UserResponse.prototype, "isActive", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserResponse.prototype, "email", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserResponse.prototype, "phone", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], UserResponse.prototype, "language code index", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], UserResponse.prototype, "country code index", void 0);
	    __decorate([
	        decorators_1.validateAs({ "array": "object" }),
	        __metadata("design:type", Array)
	    ], UserResponse.prototype, "groups", void 0);
	    __decorate([
	        decorators_1.validateAs({ "array": "object" }),
	        __metadata("design:type", Array)
	    ], UserResponse.prototype, "zones", void 0);
	    UserResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_USER)
	    ], UserResponse);
	    return UserResponse;
	}(general_1.IncomingMessage));
	exports.UserResponse = UserResponse;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_configuration_response_1 = __webpack_require__(638);
	exports.UserConfigurationResponse = user_configuration_response_1.UserConfigurationResponse;
	var zone_configuration_response_1 = __webpack_require__(641);
	exports.ZoneConfigurationResponse = zone_configuration_response_1.ZoneConfigurationResponse;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_1 = __webpack_require__(639);
	var rules_1 = __webpack_require__(640);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var UserConfigurationResponse = (function (_super) {
	    __extends(UserConfigurationResponse, _super);
	    function UserConfigurationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CFG_USER;
	        return _this;
	    }
	    UserConfigurationResponse.CreateUser = function (msg) {
	        var self = new user_1.Self(msg.name, msg.login, msg.org, msg.groups, msg.rules, msg.dev, msg.support, msg.minimumSecurePrompts, msg.zones, msg.guest);
	        return self;
	    };
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserConfigurationResponse.prototype, "name", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserConfigurationResponse.prototype, "login", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], UserConfigurationResponse.prototype, "org", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], UserConfigurationResponse.prototype, "support", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean", true, false),
	        __metadata("design:type", Boolean)
	    ], UserConfigurationResponse.prototype, "dev", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean", true, false),
	        __metadata("design:type", Boolean)
	    ], UserConfigurationResponse.prototype, "guest", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }]),
	        __metadata("design:type", Number)
	    ], UserConfigurationResponse.prototype, "minimumSecurePrompts", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], UserConfigurationResponse.prototype, "groups", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], UserConfigurationResponse.prototype, "hasMoreGroups", void 0);
	    __decorate([
	        decorators_1.validateTSEnum(rules_1.Rule, true),
	        __metadata("design:type", Array)
	    ], UserConfigurationResponse.prototype, "rules", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }, true, []),
	        __metadata("design:type", Array)
	    ], UserConfigurationResponse.prototype, "zones", void 0);
	    UserConfigurationResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CFG_USER)
	    ], UserConfigurationResponse);
	    return UserConfigurationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.UserConfigurationResponse = UserConfigurationResponse;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var rules_1 = __webpack_require__(640);
	var group_1 = __webpack_require__(607);
	var User = (function () {
	    function User(name, login, org) {
	        if (login === void 0) { login = ""; }
	        if (org === void 0) { org = ""; }
	        this.name = name;
	        this.login = login;
	        this.org = org;
	        this.groups = [];
	        this.managedGroups = [];
	        this.sharedListGroups = [];
	        this.loadedManagementDetails = false;
	        this.isSelf = false;
	    }
	    User.prototype.groupById = function (id) {
	        return this.groups.find(function (g) { return g.id === id; });
	    };
	    User.fromManagementRecord = function (data) {
	        var u = new User(data.name);
	        u.login = data.login;
	        u.managementId = data.recordId;
	        return u;
	    };
	    User.prototype.extendWithUserResponse = function (data, langCodes, countryCodes) {
	        this.isSelf = data.isCurrent;
	        this.isActive = data.isActive;
	        this.login = data.email;
	        this.phone = data.phone;
	        this.languageCodeID = data["language code index"];
	        this.countryCodeID = data["country code index"];
	        this.languageCode = langCodes[data["language code index"]];
	        this.countryCode = countryCodes[data["country code index"]];
	        this.readGroups(data.groups);
	        this.zones = data.zones;
	        this.loadedManagementDetails = true;
	        this.objectId = data.objectId;
	    };
	    User.prototype.readGroups = function (groups) {
	        var _this = this;
	        this.groups = groups.map(function (data) { return new group_1.Group(data, _this); }).sort(function (a, b) { return a.name.localeCompare(b.name); });
	        this.groups.forEach(function (g) {
	            if (g.primaryGroupId) {
	                g.primaryGroup = _this.groups.find(function (pg) { return pg.id === g.primaryGroupId; });
	            }
	            if (g.allows(rules_1.Rule.VIEW_GROUP_USERS)) {
	                if (!_this.managedGroups.find(function (managedGroup) { return managedGroup.id === g.id; })) {
	                    _this.managedGroups.push(g);
	                }
	            }
	            if (g.allows(rules_1.Rule.VIEW_SHARED_WORKLIST)) {
	                if (!_this.sharedListGroups.find(function (shareGroup) { return shareGroup.id === g.id; })) {
	                    _this.sharedListGroups.push(g);
	                }
	            }
	        });
	    };
	    User.compare = function (a, b) {
	        var orgComparison = a.org.localeCompare(b.org);
	        return (orgComparison !== 0
	            ? orgComparison
	            : a.name.localeCompare(b.name));
	    };
	    User.sort = function (users) {
	        return users.sort(function (a, b) { return User.compare(a, b); });
	    };
	    return User;
	}());
	exports.User = User;
	var Self = (function (_super) {
	    __extends(Self, _super);
	    function Self(name, login, org, groups, rules, dev, support, minumumSecurePrompts, zones, guest) {
	        if (name === void 0) { name = "no user data"; }
	        if (login === void 0) { login = ""; }
	        if (org === void 0) { org = ""; }
	        if (groups === void 0) { groups = []; }
	        if (rules === void 0) { rules = []; }
	        if (dev === void 0) { dev = false; }
	        if (support === void 0) { support = false; }
	        if (minumumSecurePrompts === void 0) { minumumSecurePrompts = 1; }
	        if (zones === void 0) { zones = []; }
	        if (guest === void 0) { guest = false; }
	        var _this = _super.call(this, name, login, org) || this;
	        _this.rules = rules;
	        _this.dev = dev;
	        _this.support = support;
	        _this.minumumSecurePrompts = minumumSecurePrompts;
	        _this.zones = zones;
	        _this.guest = guest;
	        _this.isSelf = true;
	        _this.cachedAggRules = null;
	        _this.cachedRuleLookups = new Map();
	        _this.readGroups(groups);
	        return _this;
	    }
	    Self.prototype.isAggregationUser = function () {
	        return this.hasRule(rules_1.Rule.RUN_AGGREGATOR) ||
	            this.hasRule(rules_1.Rule.RUN_DATA_EXPORT);
	    };
	    Self.prototype.isManagementUser = function () {
	        return this.hasRule(rules_1.Rule.VIEW_GROUP_USERS);
	    };
	    Self.prototype.groupIds = function () {
	        return this.groups.map(function (g) { return g.id; });
	    };
	    Object.defineProperty(Self.prototype, "algorithmDev", {
	        get: function () {
	            return this.rules.indexOf(rules_1.Rule.DEVELOP_ALGORITHM) > -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Self.prototype, "aggregateRules", {
	        get: function () {
	            return [].concat.apply(this.rules, this.groups.map(function (g) { return g.rules; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Self.prototype.hasRule = function (r) {
	        if (!this.cachedRuleLookups.has(r)) {
	            this.cachedRuleLookups.set(r, (this.rules.indexOf(r) > -1
	                || this.aggregateRules.indexOf(r) > -1));
	        }
	        return this.cachedRuleLookups.get(r);
	    };
	    return Self;
	}(User));
	exports.Self = Self;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rule;
	(function (Rule) {
	    Rule[Rule["ALLOW_NON_TRUSTED_LOCATION"] = 3] = "ALLOW_NON_TRUSTED_LOCATION";
	    Rule[Rule["VIEW_SUBJECT"] = 5] = "VIEW_SUBJECT";
	    Rule[Rule["SEARCH_SUBJECT"] = 6] = "SEARCH_SUBJECT";
	    Rule[Rule["POPULATE_SUBJECT"] = 7] = "POPULATE_SUBJECT";
	    Rule[Rule["LOAD_ALGORITHM"] = 8] = "LOAD_ALGORITHM";
	    Rule[Rule["EXPLAIN_SUBJECT"] = 9] = "EXPLAIN_SUBJECT";
	    Rule[Rule["CHAT"] = 15] = "CHAT";
	    Rule[Rule["VIEW_COMMENT"] = 20] = "VIEW_COMMENT";
	    Rule[Rule["COMMENT"] = 21] = "COMMENT";
	    Rule[Rule["SUBSCRIBE_SUBJECT"] = 27] = "SUBSCRIBE_SUBJECT";
	    Rule[Rule["SET_REMINDER"] = 28] = "SET_REMINDER";
	    Rule[Rule["RUN_AGGREGATOR"] = 40] = "RUN_AGGREGATOR";
	    Rule[Rule["CREATE_AGGREGATOR"] = 41] = "CREATE_AGGREGATOR";
	    Rule[Rule["RUN_DATA_EXPORT"] = 45] = "RUN_DATA_EXPORT";
	    Rule[Rule["CREATE_DATA_EXPORT"] = 46] = "CREATE_DATA_EXPORT";
	    Rule[Rule["VIEW_SHARED_WORKLIST"] = 52] = "VIEW_SHARED_WORKLIST";
	    Rule[Rule["CREATE_SHARED_WORKLIST"] = 53] = "CREATE_SHARED_WORKLIST";
	    Rule[Rule["REFER_SUBJECT"] = 61] = "REFER_SUBJECT";
	    Rule[Rule["USE_CLIENT_EXTENSIONS"] = 70] = "USE_CLIENT_EXTENSIONS";
	    Rule[Rule["POSTPONE_SESSION_TIMEOUT"] = 71] = "POSTPONE_SESSION_TIMEOUT";
	    Rule[Rule["REVOKE_GROUP_VISIBILITY"] = 126] = "REVOKE_GROUP_VISIBILITY";
	    Rule[Rule["AUTHORIZE_GROUP_VISIBILITY"] = 127] = "AUTHORIZE_GROUP_VISIBILITY";
	    Rule[Rule["SUPPORT_SYSTEM"] = 128] = "SUPPORT_SYSTEM";
	    Rule[Rule["DELETE_SUBJECT"] = 139] = "DELETE_SUBJECT";
	    Rule[Rule["CREATE_GROUP"] = 140] = "CREATE_GROUP";
	    Rule[Rule["CREATE_ANY_GROUP"] = 141] = "CREATE_ANY_GROUP";
	    Rule[Rule["MANAGE_GROUP_COMMENTS"] = 142] = "MANAGE_GROUP_COMMENTS";
	    Rule[Rule["MANAGE_GROUP_REPORTS"] = 143] = "MANAGE_GROUP_REPORTS";
	    Rule[Rule["ACCESS_USER_WORKLIST"] = 146] = "ACCESS_USER_WORKLIST";
	    Rule[Rule["CREATE_GROUP_USER"] = 147] = "CREATE_GROUP_USER";
	    Rule[Rule["RESET_USER_PASSWORD"] = 148] = "RESET_USER_PASSWORD";
	    Rule[Rule["RESET_NETWORK_USER_PASSWORD"] = 149] = "RESET_NETWORK_USER_PASSWORD";
	    Rule[Rule["VIEW_GROUP_USERS"] = 150] = "VIEW_GROUP_USERS";
	    Rule[Rule["VIEW_USER"] = 151] = "VIEW_USER";
	    Rule[Rule["VIEW_NETWORK_USERS"] = 152] = "VIEW_NETWORK_USERS";
	    Rule[Rule["VIEW_NETWORK_USER"] = 153] = "VIEW_NETWORK_USER";
	    Rule[Rule["UPDATE_USER"] = 154] = "UPDATE_USER";
	    Rule[Rule["EDIT_USER_GROUP_RULES"] = 155] = "EDIT_USER_GROUP_RULES";
	    Rule[Rule["EDIT_USER_GROUP_NETWORK_RULES"] = 156] = "EDIT_USER_GROUP_NETWORK_RULES";
	    Rule[Rule["EDIT_USER_RULES"] = 157] = "EDIT_USER_RULES";
	    Rule[Rule["CREATE_USER"] = 158] = "CREATE_USER";
	    Rule[Rule["DEACTIVATE_USER"] = 159] = "DEACTIVATE_USER";
	    Rule[Rule["VIEW_GROUP_NETWORK"] = 160] = "VIEW_GROUP_NETWORK";
	    Rule[Rule["VIEW_GROUP"] = 161] = "VIEW_GROUP";
	    Rule[Rule["EDIT_GROUP"] = 162] = "EDIT_GROUP";
	    Rule[Rule["EDIT_GROUP_RULES"] = 163] = "EDIT_GROUP_RULES";
	    Rule[Rule["EDIT_PRIMARY_GROUP_RULES"] = 164] = "EDIT_PRIMARY_GROUP_RULES";
	    Rule[Rule["VIEW_ALL_ZONES"] = 170] = "VIEW_ALL_ZONES";
	    Rule[Rule["EDIT_USER_ZONE_RULES"] = 171] = "EDIT_USER_ZONE_RULES";
	    Rule[Rule["REQUEST_DELETE_SUBJECT"] = 180] = "REQUEST_DELETE_SUBJECT";
	    Rule[Rule["VIEW_ALL_GROUP_NETWORKS"] = 200] = "VIEW_ALL_GROUP_NETWORKS";
	    Rule[Rule["VIEW_ALL_USERS"] = 201] = "VIEW_ALL_USERS";
	    Rule[Rule["ADMINISTER_SYSTEM"] = 400] = "ADMINISTER_SYSTEM";
	    Rule[Rule["QUARANTINE_SYSTEM"] = 401] = "QUARANTINE_SYSTEM";
	    Rule[Rule["QUARANTINE_ZONE"] = 402] = "QUARANTINE_ZONE";
	    Rule[Rule["MANAGE_CLIENTS"] = 403] = "MANAGE_CLIENTS";
	    Rule[Rule["NOTIFY_CLIENTS"] = 404] = "NOTIFY_CLIENTS";
	    Rule[Rule["SHUTDOWN_SYSTEM"] = 420] = "SHUTDOWN_SYSTEM";
	    Rule[Rule["DEBUG_SYSTEM"] = 450] = "DEBUG_SYSTEM";
	    Rule[Rule["DEVELOP_ALGORITHM"] = 500] = "DEVELOP_ALGORITHM";
	    Rule[Rule["DEVELOP_SYSTEM"] = 501] = "DEVELOP_SYSTEM";
	    Rule[Rule["INITIATE_GUEST_SESSION"] = 600] = "INITIATE_GUEST_SESSION";
	    Rule[Rule["CREATE_TRANSIENT_SUBJECT"] = 601] = "CREATE_TRANSIENT_SUBJECT";
	})(Rule = exports.Rule || (exports.Rule = {}));
	var ZONE_RELATIVE_RULES = new Set([]);
	var GROUP_RELATIVE_RULES = new Set([]);
	exports.RULE_NAMES = new Map([
	    [Rule.ALLOW_NON_TRUSTED_LOCATION,
	        "use the app from outside its trusted IP range"],
	    [Rule.VIEW_SUBJECT, "view subjects"],
	    [Rule.SEARCH_SUBJECT, "search subjects"],
	    [Rule.POPULATE_SUBJECT, "populate subject data"],
	    [Rule.LOAD_ALGORITHM, "load algorithms"],
	    [Rule.EXPLAIN_SUBJECT, "request step explanations"],
	    [Rule.CHAT, "chat with active users"],
	    [Rule.VIEW_COMMENT, "view comments"],
	    [Rule.COMMENT, "add comments"],
	    [Rule.SUBSCRIBE_SUBJECT, "subscribe to subjects"],
	    [Rule.SET_REMINDER, "set reminders"],
	    [Rule.RUN_AGGREGATOR, "run aggregators"],
	    [Rule.CREATE_AGGREGATOR, "create aggregator presets"],
	    [Rule.RUN_DATA_EXPORT, "run data exports"],
	    [Rule.CREATE_DATA_EXPORT, "create data export presets"],
	    [Rule.REFER_SUBJECT, "refer subjects to external agencies"],
	    [Rule.USE_CLIENT_EXTENSIONS, "enable collaboration plugins"],
	    [Rule.POSTPONE_SESSION_TIMEOUT, "delay automated logout"],
	    [Rule.REVOKE_GROUP_VISIBILITY, "reduce group-visibility of records"],
	    [Rule.AUTHORIZE_GROUP_VISIBILITY, "expand group-visibility of records"],
	    [Rule.SUPPORT_SYSTEM, "handle support requests"],
	    [Rule.DELETE_SUBJECT, "delete subjects"],
	    [Rule.CREATE_GROUP, "create child groups"],
	    [Rule.CREATE_ANY_GROUP, "create root groups"],
	    [Rule.MANAGE_GROUP_COMMENTS, "manage comments"],
	    [Rule.MANAGE_GROUP_REPORTS, "manage reports owned by a group"],
	    [Rule.ACCESS_USER_WORKLIST, "browse colleagues' worklists"],
	    [Rule.CREATE_GROUP_USER, "create users within the group"],
	    [Rule.RESET_USER_PASSWORD, "reset a group member's password"],
	    [Rule.RESET_NETWORK_USER_PASSWORD, "reset a network member's password"],
	    [Rule.VIEW_GROUP_USERS, "view a list of a group's users"],
	    [Rule.VIEW_USER, "view a group member"],
	    [Rule.VIEW_NETWORK_USER, "view a network member"],
	    [Rule.VIEW_NETWORK_USERS, "view a list of users an entire network"],
	    [Rule.UPDATE_USER, "make changes to a user"],
	    [Rule.EDIT_USER_GROUP_RULES, "modify the rules of a user in a group"],
	    [Rule.EDIT_USER_GROUP_NETWORK_RULES, "modify the rules of a use"],
	    [Rule.EDIT_USER_RULES, "EDIT_USER_RULES"],
	    [Rule.CREATE_USER, "CREATE_USER"],
	    [Rule.DEACTIVATE_USER, "DEACTIVATE_USER"],
	    [Rule.VIEW_GROUP_NETWORK, "VIEW_GROUP_NETWORK"],
	    [Rule.VIEW_GROUP, "VIEW_GROUP"],
	    [Rule.EDIT_GROUP, "EDIT_GROUP"],
	    [Rule.EDIT_GROUP_RULES, "EDIT_GROUP_RULES"],
	    [Rule.EDIT_PRIMARY_GROUP_RULES, "EDIT_PRIMARY_GROUP_RULES"],
	    [Rule.VIEW_ALL_ZONES, "VIEW_ALL_ZONES"],
	    [Rule.EDIT_USER_ZONE_RULES, "EDIT_USER_ZONE_RULES"],
	    [Rule.REQUEST_DELETE_SUBJECT, "REQUEST_DELETE_SUBJECT"],
	    [Rule.VIEW_ALL_GROUP_NETWORKS, "VIEW_ALL_GROUP_NETWORKS"],
	    [Rule.VIEW_ALL_USERS, "VIEW_ALL_USERS"],
	    [Rule.ADMINISTER_SYSTEM, "administer the system"],
	    [Rule.QUARANTINE_SYSTEM, "quarantine the system"],
	    [Rule.QUARANTINE_ZONE, "quarantine zones"],
	    [Rule.MANAGE_CLIENTS, "view and terminate active connections"],
	    [Rule.NOTIFY_CLIENTS, "broadcast system announcements"],
	    [Rule.SHUTDOWN_SYSTEM, "prepare the system for shutdown"],
	    [Rule.DEBUG_SYSTEM, "debug the system"],
	    [Rule.DEVELOP_ALGORITHM, "develop algorithms"],
	    [Rule.DEVELOP_SYSTEM, "develop the system"],
	    [Rule.INITIATE_GUEST_SESSION, "INITIATE_GUEST_SESSION"],
	    [Rule.CREATE_TRANSIENT_SUBJECT, "CREATE_TRANSIENT_SUBJECT"],
	]);
	function and(args) {
	    var tests = args.map(function (arg) { return ((typeof arg === "function")
	        ? arg
	        : (function (rules) { return rules.indexOf(arg) > -1; })); });
	    return function (rules) { return tests.every(function (test) { return test(rules); }); };
	}
	function or(args) {
	    var tests = args.map(function (arg) { return ((typeof arg === "function")
	        ? arg
	        : (function (rules) { return rules.indexOf(arg) > -1; })); });
	    return function (rules) { return tests.some(function (test) { return test(rules); }); };
	}


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ZoneConfigurationResponse = (function (_super) {
	    __extends(ZoneConfigurationResponse, _super);
	    function ZoneConfigurationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CFG_ZONE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ZoneConfigurationResponse.prototype, "algorithms", void 0);
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], ZoneConfigurationResponse.prototype, "title", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], ZoneConfigurationResponse.prototype, "supportRequestEnabled", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "string" }),
	        __metadata("design:type", Array)
	    ], ZoneConfigurationResponse.prototype, "supportAlgorithms", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], ZoneConfigurationResponse.prototype, "referrals", void 0);
	    __decorate([
	        decorators_1.validateAs("string", true, "«no referral targets»"),
	        __metadata("design:type", String)
	    ], ZoneConfigurationResponse.prototype, "referralOrg", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ZoneConfigurationResponse.prototype, "availableCountryCodes", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], ZoneConfigurationResponse.prototype, "availableLanguageCodes", void 0);
	    ZoneConfigurationResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CFG_ZONE)
	    ], ZoneConfigurationResponse);
	    return ZoneConfigurationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.ZoneConfigurationResponse = ZoneConfigurationResponse;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var add_reminder_request_1 = __webpack_require__(643);
	exports.AddReminderRequest = add_reminder_request_1.AddReminderRequest;
	var delete_reminder_request_1 = __webpack_require__(644);
	exports.DeleteReminderRequest = delete_reminder_request_1.DeleteReminderRequest;
	var reminders_response_1 = __webpack_require__(645);
	exports.RemindersResponse = reminders_response_1.RemindersResponse;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AddReminderRequest = (function (_super) {
	    __extends(AddReminderRequest, _super);
	    function AddReminderRequest(objectId, summary, triggerTime, linkedRecordId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.summary = summary;
	        _this.triggerTime = triggerTime;
	        _this.linkedRecordId = linkedRecordId;
	        _this.tag = message_tag_1.MessageTag.REQ_ADD_REMINDER;
	        return _this;
	    }
	    AddReminderRequest.tag = message_tag_1.MessageTag.REQ_ADD_REMINDER;
	    return AddReminderRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AddReminderRequest = AddReminderRequest;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeleteReminderRequest = (function (_super) {
	    __extends(DeleteReminderRequest, _super);
	    function DeleteReminderRequest(objectId, notificationId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.notificationId = notificationId;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_REMINDER;
	        return _this;
	    }
	    DeleteReminderRequest.tag = message_tag_1.MessageTag.REQ_DELETE_REMINDER;
	    return DeleteReminderRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeleteReminderRequest = DeleteReminderRequest;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var RemindersResponse = (function (_super) {
	    __extends(RemindersResponse, _super);
	    function RemindersResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_REMINDERS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], RemindersResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RemindersResponse.prototype, "notificationList", void 0);
	    RemindersResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_REMINDERS)
	    ], RemindersResponse);
	    return RemindersResponse;
	}(incoming_message_1.IncomingMessage));
	exports.RemindersResponse = RemindersResponse;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var change_schema_visibility_requests_1 = __webpack_require__(647);
	exports.ChangeAggregationSchemaVisibility = change_schema_visibility_requests_1.ChangeAggregationSchemaVisibility;
	exports.ChangeDataExportSchemaVisibility = change_schema_visibility_requests_1.ChangeDataExportSchemaVisibility;
	var delete_schema_requests_1 = __webpack_require__(648);
	exports.DeleteAggregationSchemaRequest = delete_schema_requests_1.DeleteAggregationSchemaRequest;
	exports.DeleteDataExportSchemaRequest = delete_schema_requests_1.DeleteDataExportSchemaRequest;
	var refresh_report_schemas_request_1 = __webpack_require__(649);
	exports.RefreshReportSchemasRequest = refresh_report_schemas_request_1.RefreshReportSchemasRequest;
	var refresh_report_schemas_response_1 = __webpack_require__(650);
	exports.RefreshReportSchemasResponse = refresh_report_schemas_response_1.RefreshReportSchemasResponse;
	var save_aggregation_schema_request_1 = __webpack_require__(651);
	exports.SaveAggregrationSchemaRequest = save_aggregation_schema_request_1.SaveAggregrationSchemaRequest;
	var save_data_export_schema_request_1 = __webpack_require__(652);
	exports.SaveDataExportSchemaRequest = save_data_export_schema_request_1.SaveDataExportSchemaRequest;
	var save_report_schema_response_1 = __webpack_require__(653);
	exports.SaveReportSchemaResponse = save_report_schema_response_1.SaveReportSchemaResponse;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ChangeDataExportSchemaVisibility = (function (_super) {
	    __extends(ChangeDataExportSchemaVisibility, _super);
	    function ChangeDataExportSchemaVisibility(schemaId, isGroupPublic) {
	        var _this = _super.call(this) || this;
	        _this.schemaId = schemaId;
	        _this.isGroupPublic = isGroupPublic;
	        _this.tag = message_tag_1.MessageTag.REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY;
	        return _this;
	    }
	    ChangeDataExportSchemaVisibility.tag = message_tag_1.MessageTag.REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY;
	    return ChangeDataExportSchemaVisibility;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ChangeDataExportSchemaVisibility = ChangeDataExportSchemaVisibility;
	var ChangeAggregationSchemaVisibility = (function (_super) {
	    __extends(ChangeAggregationSchemaVisibility, _super);
	    function ChangeAggregationSchemaVisibility(schemaId, isGroupPublic) {
	        var _this = _super.call(this) || this;
	        _this.schemaId = schemaId;
	        _this.isGroupPublic = isGroupPublic;
	        _this.tag = message_tag_1.MessageTag.REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY;
	        return _this;
	    }
	    ChangeAggregationSchemaVisibility.tag = message_tag_1.MessageTag.REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY;
	    return ChangeAggregationSchemaVisibility;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ChangeAggregationSchemaVisibility = ChangeAggregationSchemaVisibility;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeleteDataExportSchemaRequest = (function (_super) {
	    __extends(DeleteDataExportSchemaRequest, _super);
	    function DeleteDataExportSchemaRequest(schemaId) {
	        var _this = _super.call(this) || this;
	        _this.schemaId = schemaId;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_DATA_EXPORT_SCHEMA;
	        return _this;
	    }
	    DeleteDataExportSchemaRequest.tag = message_tag_1.MessageTag.REQ_DELETE_DATA_EXPORT_SCHEMA;
	    return DeleteDataExportSchemaRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeleteDataExportSchemaRequest = DeleteDataExportSchemaRequest;
	var DeleteAggregationSchemaRequest = (function (_super) {
	    __extends(DeleteAggregationSchemaRequest, _super);
	    function DeleteAggregationSchemaRequest(schemaId) {
	        var _this = _super.call(this) || this;
	        _this.schemaId = schemaId;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_AGGREGATION_SCHEMA;
	        return _this;
	    }
	    DeleteAggregationSchemaRequest.tag = message_tag_1.MessageTag.REQ_DELETE_AGGREGATION_SCHEMA;
	    return DeleteAggregationSchemaRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeleteAggregationSchemaRequest = DeleteAggregationSchemaRequest;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var RefreshReportSchemasRequest = (function (_super) {
	    __extends(RefreshReportSchemasRequest, _super);
	    function RefreshReportSchemasRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.REQ_REFRESH_REPORT_SCHEMAS;
	        return _this;
	    }
	    RefreshReportSchemasRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_REFRESH_REPORT_SCHEMAS);
	    };
	    RefreshReportSchemasRequest.tag = message_tag_1.MessageTag.REQ_REFRESH_REPORT_SCHEMAS;
	    return RefreshReportSchemasRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.RefreshReportSchemasRequest = RefreshReportSchemasRequest;


/***/ }),
/* 650 */
628,
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SaveAggregrationSchemaRequest = (function (_super) {
	    __extends(SaveAggregrationSchemaRequest, _super);
	    function SaveAggregrationSchemaRequest(aggregationId, schemaName, isGroupPublic) {
	        if (isGroupPublic === void 0) { isGroupPublic = false; }
	        var _this = _super.call(this) || this;
	        _this.aggregationId = aggregationId;
	        _this.schemaName = schemaName;
	        _this.isGroupPublic = isGroupPublic;
	        _this.tag = message_tag_1.MessageTag.REQ_SAVE_AGGREGATION_SCHEMA;
	        return _this;
	    }
	    SaveAggregrationSchemaRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SAVE_REPORT_SCHEMA);
	    };
	    SaveAggregrationSchemaRequest.tag = message_tag_1.MessageTag.REQ_SAVE_AGGREGATION_SCHEMA;
	    return SaveAggregrationSchemaRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SaveAggregrationSchemaRequest = SaveAggregrationSchemaRequest;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SaveDataExportSchemaRequest = (function (_super) {
	    __extends(SaveDataExportSchemaRequest, _super);
	    function SaveDataExportSchemaRequest(exportId, schemaName, isGroupPublic, exportFilename) {
	        if (isGroupPublic === void 0) { isGroupPublic = false; }
	        if (exportFilename === void 0) { exportFilename = ""; }
	        var _this = _super.call(this) || this;
	        _this.exportId = exportId;
	        _this.schemaName = schemaName;
	        _this.isGroupPublic = isGroupPublic;
	        _this.exportFilename = exportFilename;
	        _this.tag = message_tag_1.MessageTag.REQ_SAVE_DATA_EXPORT_SCHEMA;
	        return _this;
	    }
	    SaveDataExportSchemaRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SAVE_REPORT_SCHEMA);
	    };
	    SaveDataExportSchemaRequest.tag = message_tag_1.MessageTag.REQ_SAVE_DATA_EXPORT_SCHEMA;
	    return SaveDataExportSchemaRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SaveDataExportSchemaRequest = SaveDataExportSchemaRequest;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SaveReportSchemaResponse = (function (_super) {
	    __extends(SaveReportSchemaResponse, _super);
	    function SaveReportSchemaResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SAVE_REPORT_SCHEMA;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], SaveReportSchemaResponse.prototype, "schemaId", void 0);
	    SaveReportSchemaResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SAVE_REPORT_SCHEMA)
	    ], SaveReportSchemaResponse);
	    return SaveReportSchemaResponse;
	}(incoming_message_1.IncomingMessage));
	exports.SaveReportSchemaResponse = SaveReportSchemaResponse;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var additional_search_results_request_1 = __webpack_require__(655);
	exports.AdditionalSearchResultsRequest = additional_search_results_request_1.AdditionalSearchResultsRequest;
	var subject_context_search_result_request_1 = __webpack_require__(656);
	exports.SubjectContextSearchResultRequest = subject_context_search_result_request_1.SubjectContextSearchResultRequest;
	var subject_context_search_request_1 = __webpack_require__(657);
	exports.SubjectContextSearchRequest = subject_context_search_request_1.SubjectContextSearchRequest;
	var subject_context_search_response_1 = __webpack_require__(658);
	exports.SubjectContextSearchResponse = subject_context_search_response_1.SubjectContextSearchResponse;
	var subject_context_search_tree_response_1 = __webpack_require__(659);
	exports.SubjectContextSearchTreeResponse = subject_context_search_tree_response_1.SubjectContextSearchTreeResponse;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var AdditionalSearchResultsRequest = (function (_super) {
	    __extends(AdditionalSearchResultsRequest, _super);
	    function AdditionalSearchResultsRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = general_1.MessageTag.REQ_ADDITIONAL_SEARCH_RESULTS;
	        return _this;
	    }
	    AdditionalSearchResultsRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, general_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH);
	    };
	    AdditionalSearchResultsRequest.tag = general_1.MessageTag.REQ_ADDITIONAL_SEARCH_RESULTS;
	    return AdditionalSearchResultsRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.AdditionalSearchResultsRequest = AdditionalSearchResultsRequest;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextSearchResultRequest = (function (_super) {
	    __extends(SubjectContextSearchResultRequest, _super);
	    function SubjectContextSearchResultRequest(recordId) {
	        var _this = _super.call(this) || this;
	        _this.recordId = recordId;
	        _this.tag = message_tag_1.MessageTag.REQ_SUBJECT_CONTEXT_SEARCH_RESULT;
	        return _this;
	    }
	    SubjectContextSearchResultRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    SubjectContextSearchResultRequest.tag = message_tag_1.MessageTag.REQ_SUBJECT_CONTEXT_SEARCH_RESULT;
	    return SubjectContextSearchResultRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SubjectContextSearchResultRequest = SubjectContextSearchResultRequest;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextSearchRequest = (function (_super) {
	    __extends(SubjectContextSearchRequest, _super);
	    function SubjectContextSearchRequest(contextType, searchPath, filterPath) {
	        var _this = _super.call(this) || this;
	        _this.contextType = contextType;
	        _this.searchPath = searchPath;
	        _this.filterPath = filterPath;
	        _this.tag = message_tag_1.MessageTag.REQ_SUBJECT_CONTEXT_SEARCH;
	        return _this;
	    }
	    SubjectContextSearchRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH);
	    };
	    SubjectContextSearchRequest.tag = message_tag_1.MessageTag.REQ_SUBJECT_CONTEXT_SEARCH;
	    return SubjectContextSearchRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SubjectContextSearchRequest = SubjectContextSearchRequest;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextSearchResponse = (function (_super) {
	    __extends(SubjectContextSearchResponse, _super);
	    function SubjectContextSearchResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], SubjectContextSearchResponse.prototype, "resultSet", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean", true, false),
	        __metadata("design:type", Boolean)
	    ], SubjectContextSearchResponse.prototype, "canGetMoreData", void 0);
	    SubjectContextSearchResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH)
	    ], SubjectContextSearchResponse);
	    return SubjectContextSearchResponse;
	}(incoming_message_1.IncomingMessage));
	exports.SubjectContextSearchResponse = SubjectContextSearchResponse;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextSearchTreeResponse = (function (_super) {
	    __extends(SubjectContextSearchTreeResponse, _super);
	    function SubjectContextSearchTreeResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH_TREE;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], SubjectContextSearchTreeResponse.prototype, "searchTrees", void 0);
	    __decorate([
	        decorators_1.validateAs(["integer", { min: 0 }], true, Number.MAX_SAFE_INTEGER),
	        __metadata("design:type", Number)
	    ], SubjectContextSearchTreeResponse.prototype, "queryFetchSize", void 0);
	    SubjectContextSearchTreeResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH_TREE)
	    ], SubjectContextSearchTreeResponse);
	    return SubjectContextSearchTreeResponse;
	}(general_1.IncomingMessage));
	exports.SubjectContextSearchTreeResponse = SubjectContextSearchTreeResponse;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var add_subject_context_relationship_request_1 = __webpack_require__(661);
	exports.AddSubjectContextRelationshipRequest = add_subject_context_relationship_request_1.AddSubjectContextRelationshipRequest;
	var delete_subject_context_relationship_request_1 = __webpack_require__(662);
	exports.DeleteSubjectContextRelationshipRequest = delete_subject_context_relationship_request_1.DeleteSubjectContextRelationshipRequest;
	var modify_subject_context_relationship_request_1 = __webpack_require__(663);
	exports.ModifySubjectContextRelationshipRequest = modify_subject_context_relationship_request_1.ModifySubjectContextRelationshipRequest;
	var relationship_partner_request_1 = __webpack_require__(664);
	exports.RelationshipPartnerRequest = relationship_partner_request_1.RelationshipPartnerRequest;
	var relationships_configuration_response_1 = __webpack_require__(665);
	exports.RelationshipsConfigurationResponse = relationships_configuration_response_1.RelationshipsConfigurationResponse;
	var subject_context_relationships_response_1 = __webpack_require__(666);
	exports.SubjectContextRelationshipsResponse = subject_context_relationships_response_1.SubjectContextRelationshipsResponse;
	var relation_graph_response_1 = __webpack_require__(667);
	exports.RelationGraphResponse = relation_graph_response_1.RelationGraphResponse;
	var relation_graph_expansion_request_1 = __webpack_require__(668);
	exports.RelationGraphExpansionRequest = relation_graph_expansion_request_1.RelationGraphExpansionRequest;
	var relation_graph_request_1 = __webpack_require__(669);
	exports.RelationGraphRequest = relation_graph_request_1.RelationGraphRequest;
	var relation_graph_subject_context_request_1 = __webpack_require__(670);
	exports.RelationGraphSubjectContextRequest = relation_graph_subject_context_request_1.RelationGraphSubjectContextRequest;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AddSubjectContextRelationshipRequest = (function (_super) {
	    __extends(AddSubjectContextRelationshipRequest, _super);
	    function AddSubjectContextRelationshipRequest(relationshipType, source, sourceRole, target, targetRole) {
	        var _this = _super.call(this) || this;
	        _this.relationshipType = relationshipType;
	        _this.source = source;
	        _this.sourceRole = sourceRole;
	        _this.target = target;
	        _this.targetRole = targetRole;
	        _this.tag = message_tag_1.MessageTag.REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP;
	        return _this;
	    }
	    AddSubjectContextRelationshipRequest.tag = message_tag_1.MessageTag.REQ_ADD_SUBJECT_CONTEXT_RELATIONSHIP;
	    return AddSubjectContextRelationshipRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AddSubjectContextRelationshipRequest = AddSubjectContextRelationshipRequest;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var DeleteSubjectContextRelationshipRequest = (function (_super) {
	    __extends(DeleteSubjectContextRelationshipRequest, _super);
	    function DeleteSubjectContextRelationshipRequest(subjectId, relationshipId) {
	        var _this = _super.call(this) || this;
	        _this.subjectId = subjectId;
	        _this.relationshipId = relationshipId;
	        _this.tag = message_tag_1.MessageTag.REQ_DELETE_SUBJECT_CONTEXT_RELATIONSHIP;
	        return _this;
	    }
	    return DeleteSubjectContextRelationshipRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.DeleteSubjectContextRelationshipRequest = DeleteSubjectContextRelationshipRequest;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ModifySubjectContextRelationshipRequest = (function (_super) {
	    __extends(ModifySubjectContextRelationshipRequest, _super);
	    function ModifySubjectContextRelationshipRequest(subjectId, relationshipId, sourceRole, targetRole) {
	        var _this = _super.call(this) || this;
	        _this.subjectId = subjectId;
	        _this.relationshipId = relationshipId;
	        _this.sourceRole = sourceRole;
	        _this.targetRole = targetRole;
	        _this.tag = message_tag_1.MessageTag.REQ_MODIFY_SUBJECT_CONTEXT_RELATIONSHIP;
	        return _this;
	    }
	    return ModifySubjectContextRelationshipRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ModifySubjectContextRelationshipRequest = ModifySubjectContextRelationshipRequest;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var RelationshipPartnerRequest = (function (_super) {
	    __extends(RelationshipPartnerRequest, _super);
	    function RelationshipPartnerRequest(subjectId, relationshipId) {
	        var _this = _super.call(this) || this;
	        _this.subjectId = subjectId;
	        _this.relationshipId = relationshipId;
	        _this.tag = message_tag_1.MessageTag.REQ_RELATIONSHIP_PARTNER;
	        return _this;
	    }
	    RelationshipPartnerRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    return RelationshipPartnerRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.RelationshipPartnerRequest = RelationshipPartnerRequest;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var RelationshipsConfigurationResponse = (function (_super) {
	    __extends(RelationshipsConfigurationResponse, _super);
	    function RelationshipsConfigurationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_CFG_RELATIONSHIPS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RelationshipsConfigurationResponse.prototype, "roles", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RelationshipsConfigurationResponse.prototype, "relationships", void 0);
	    RelationshipsConfigurationResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_CFG_RELATIONSHIPS)
	    ], RelationshipsConfigurationResponse);
	    return RelationshipsConfigurationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.RelationshipsConfigurationResponse = RelationshipsConfigurationResponse;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SubjectContextRelationshipsResponse = (function (_super) {
	    __extends(SubjectContextRelationshipsResponse, _super);
	    function SubjectContextRelationshipsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_RELATIONSHIPS;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], SubjectContextRelationshipsResponse.prototype, "subjectId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], SubjectContextRelationshipsResponse.prototype, "relationships", void 0);
	    SubjectContextRelationshipsResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT_RELATIONSHIPS)
	    ], SubjectContextRelationshipsResponse);
	    return SubjectContextRelationshipsResponse;
	}(incoming_message_1.IncomingMessage));
	exports.SubjectContextRelationshipsResponse = SubjectContextRelationshipsResponse;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var RelationGraphResponse = (function (_super) {
	    __extends(RelationGraphResponse, _super);
	    function RelationGraphResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_RELATION_GRAPH;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], RelationGraphResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RelationGraphResponse.prototype, "nodes", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], RelationGraphResponse.prototype, "edges", void 0);
	    RelationGraphResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_RELATION_GRAPH)
	    ], RelationGraphResponse);
	    return RelationGraphResponse;
	}(incoming_message_1.IncomingMessage));
	exports.RelationGraphResponse = RelationGraphResponse;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var RelationGraphExpansionRequest = (function (_super) {
	    __extends(RelationGraphExpansionRequest, _super);
	    function RelationGraphExpansionRequest(objectId, nodeId, depth) {
	        if (depth === void 0) { depth = 1; }
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.nodeId = nodeId;
	        _this.depth = depth;
	        _this.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH_EXPANSION;
	        return _this;
	    }
	    RelationGraphExpansionRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_RELATION_GRAPH);
	    };
	    RelationGraphExpansionRequest.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH_EXPANSION;
	    return RelationGraphExpansionRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.RelationGraphExpansionRequest = RelationGraphExpansionRequest;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var RelationGraphRequest = (function (_super) {
	    __extends(RelationGraphRequest, _super);
	    function RelationGraphRequest(objectId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH;
	        return _this;
	    }
	    RelationGraphRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_RELATION_GRAPH);
	    };
	    RelationGraphRequest.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH;
	    return RelationGraphRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.RelationGraphRequest = RelationGraphRequest;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var RelationGraphSubjectContextRequest = (function (_super) {
	    __extends(RelationGraphSubjectContextRequest, _super);
	    function RelationGraphSubjectContextRequest(objectId, nodeId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.nodeId = nodeId;
	        _this.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH_SUBJECT_CONTEXT;
	        return _this;
	    }
	    RelationGraphSubjectContextRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    RelationGraphSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_RELATION_GRAPH_SUBJECT_CONTEXT;
	    return RelationGraphSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.RelationGraphSubjectContextRequest = RelationGraphSubjectContextRequest;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var acknowledge_watchlist_alert_request_1 = __webpack_require__(672);
	exports.AcknowledgeWatchlistAlertRequest = acknowledge_watchlist_alert_request_1.AcknowledgeWatchlistAlertRequest;
	var edit_watchlist_item_request_1 = __webpack_require__(673);
	exports.EditWatchlistItemRequest = edit_watchlist_item_request_1.EditWatchlistItemRequest;
	var refresh_watchlist_item_request_1 = __webpack_require__(674);
	exports.RefreshWatchlistItemRequest = refresh_watchlist_item_request_1.RefreshWatchlistItemRequest;
	var stop_watching_request_1 = __webpack_require__(675);
	exports.StopWatchingRequest = stop_watching_request_1.StopWatchingRequest;
	var stop_watching_response_1 = __webpack_require__(676);
	exports.StopWatchingResponse = stop_watching_response_1.StopWatchingResponse;
	var watch_subject_context_request_1 = __webpack_require__(677);
	exports.WatchSubjectContextRequest = watch_subject_context_request_1.WatchSubjectContextRequest;
	var watchlist_item_request_1 = __webpack_require__(678);
	exports.WatchlistItemRequest = watchlist_item_request_1.WatchlistItemRequest;
	var watchlist_item_updated_response_1 = __webpack_require__(679);
	exports.WatchlistItemUpdatedResponse = watchlist_item_updated_response_1.WatchlistItemUpdatedResponse;
	var watchlist_response_1 = __webpack_require__(680);
	exports.WatchlistResponse = watchlist_response_1.WatchlistResponse;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var AcknowledgeWatchlistAlertRequest = (function (_super) {
	    __extends(AcknowledgeWatchlistAlertRequest, _super);
	    function AcknowledgeWatchlistAlertRequest(objectId, watchId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.watchId = watchId;
	        _this.tag = message_tag_1.MessageTag.REQ_ACKNOWLEDGE_WATCHLIST_ALERT;
	        return _this;
	    }
	    AcknowledgeWatchlistAlertRequest.tag = message_tag_1.MessageTag.REQ_ACKNOWLEDGE_WATCHLIST_ALERT;
	    return AcknowledgeWatchlistAlertRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.AcknowledgeWatchlistAlertRequest = AcknowledgeWatchlistAlertRequest;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var EditWatchlistItemRequest = (function (_super) {
	    __extends(EditWatchlistItemRequest, _super);
	    function EditWatchlistItemRequest(objectId, watchId, note, categories, emailNotifyOnUpdate) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.watchId = watchId;
	        _this.note = note;
	        _this.categories = categories;
	        _this.emailNotifyOnUpdate = emailNotifyOnUpdate;
	        _this.tag = message_tag_1.MessageTag.REQ_EDIT_WATCHLIST_ITEM;
	        return _this;
	    }
	    EditWatchlistItemRequest.tag = message_tag_1.MessageTag.REQ_EDIT_WATCHLIST_ITEM;
	    return EditWatchlistItemRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.EditWatchlistItemRequest = EditWatchlistItemRequest;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var RefreshWatchlistItemRequest = (function (_super) {
	    __extends(RefreshWatchlistItemRequest, _super);
	    function RefreshWatchlistItemRequest(objectId, watchId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.watchId = watchId;
	        _this.tag = message_tag_1.MessageTag.REQ_REFRESH_WATCHLIST_ITEM;
	        return _this;
	    }
	    RefreshWatchlistItemRequest.tag = message_tag_1.MessageTag.REQ_REFRESH_WATCHLIST_ITEM;
	    return RefreshWatchlistItemRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.RefreshWatchlistItemRequest = RefreshWatchlistItemRequest;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StopWatchingRequest = (function (_super) {
	    __extends(StopWatchingRequest, _super);
	    function StopWatchingRequest(objectId, watchId, forcePartialUpdate) {
	        if (forcePartialUpdate === void 0) { forcePartialUpdate = false; }
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.watchId = watchId;
	        _this.forcePartialUpdate = forcePartialUpdate;
	        _this.tag = message_tag_1.MessageTag.REQ_STOP_WATCHING;
	        return _this;
	    }
	    StopWatchingRequest.tag = message_tag_1.MessageTag.REQ_STOP_WATCHING;
	    return StopWatchingRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StopWatchingRequest = StopWatchingRequest;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var StopWatchingResponse = (function (_super) {
	    __extends(StopWatchingResponse, _super);
	    function StopWatchingResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_STOP_WATCHING;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], StopWatchingResponse.prototype, "watchId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], StopWatchingResponse.prototype, "objectId", void 0);
	    StopWatchingResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_STOP_WATCHING)
	    ], StopWatchingResponse);
	    return StopWatchingResponse;
	}(incoming_message_1.IncomingMessage));
	exports.StopWatchingResponse = StopWatchingResponse;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var WatchSubjectContextRequest = (function (_super) {
	    __extends(WatchSubjectContextRequest, _super);
	    function WatchSubjectContextRequest(objectId, watchObjectId, originListId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.watchObjectId = watchObjectId;
	        _this.tag = message_tag_1.MessageTag.REQ_WATCH_SUBJECT_CONTEXT;
	        if (originListId !== undefined) {
	            _this.originListId = originListId;
	        }
	        return _this;
	    }
	    WatchSubjectContextRequest.tag = message_tag_1.MessageTag.REQ_WATCH_SUBJECT_CONTEXT;
	    return WatchSubjectContextRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.WatchSubjectContextRequest = WatchSubjectContextRequest;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var WatchlistItemRequest = (function (_super) {
	    __extends(WatchlistItemRequest, _super);
	    function WatchlistItemRequest(watchId, objectId) {
	        var _this = _super.call(this) || this;
	        _this.watchId = watchId;
	        _this.objectId = objectId;
	        _this.tag = message_tag_1.MessageTag.REQ_WATCHLIST_ITEM;
	        return _this;
	    }
	    WatchlistItemRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    WatchlistItemRequest.tag = message_tag_1.MessageTag.REQ_WATCHLIST_ITEM;
	    return WatchlistItemRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.WatchlistItemRequest = WatchlistItemRequest;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var subject_context_type_1 = __webpack_require__(569);
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var WatchlistItemUpdatedResponse = (function (_super) {
	    __extends(WatchlistItemUpdatedResponse, _super);
	    function WatchlistItemUpdatedResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_WATCHLIST_ITEM_UPDATED;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], WatchlistItemUpdatedResponse.prototype, "note", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], WatchlistItemUpdatedResponse.prototype, "summary", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], WatchlistItemUpdatedResponse.prototype, "alert", void 0);
	    __decorate([
	        decorators_1.validateAs("integer"),
	        __metadata("design:type", Number)
	    ], WatchlistItemUpdatedResponse.prototype, "lastObserved", void 0);
	    __decorate([
	        decorators_1.validateAs("integer", true),
	        __metadata("design:type", Number)
	    ], WatchlistItemUpdatedResponse.prototype, "groupId", void 0);
	    __decorate([
	        decorators_1.validateAs({ enum: Object.values(subject_context_type_1.KnownSubjectContextTypes) }),
	        __metadata("design:type", String)
	    ], WatchlistItemUpdatedResponse.prototype, "contextType", void 0);
	    __decorate([
	        decorators_1.validateAs("boolean"),
	        __metadata("design:type", Boolean)
	    ], WatchlistItemUpdatedResponse.prototype, "emailNotifyOnUpdate", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], WatchlistItemUpdatedResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], WatchlistItemUpdatedResponse.prototype, "watchId", void 0);
	    WatchlistItemUpdatedResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_WATCHLIST_ITEM_UPDATED)
	    ], WatchlistItemUpdatedResponse);
	    return WatchlistItemUpdatedResponse;
	}(incoming_message_1.IncomingMessage));
	exports.WatchlistItemUpdatedResponse = WatchlistItemUpdatedResponse;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var WatchlistResponse = (function (_super) {
	    __extends(WatchlistResponse, _super);
	    function WatchlistResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_WATCHLIST;
	        return _this;
	    }
	    __decorate([
	        decorators_1.validateOpaqueID(),
	        __metadata("design:type", Number)
	    ], WatchlistResponse.prototype, "objectId", void 0);
	    __decorate([
	        decorators_1.validateAs({ array: "object" }),
	        __metadata("design:type", Array)
	    ], WatchlistResponse.prototype, "worklist", void 0);
	    WatchlistResponse = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.RSP_WATCHLIST)
	    ], WatchlistResponse);
	    return WatchlistResponse;
	}(incoming_message_1.IncomingMessage));
	exports.WatchlistResponse = WatchlistResponse;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_1 = __webpack_require__(546);
	exports.Connection = connection_1.Connection;
	var composite_connection_1 = __webpack_require__(682);
	exports.CompositeConnection = composite_connection_1.CompositeConnection;
	var empty_connection_1 = __webpack_require__(683);
	exports.EMPTY = empty_connection_1.EMPTY;
	exports.EmptyConnection = empty_connection_1.EmptyConnection;
	var mock_connection_1 = __webpack_require__(684);
	exports.MockConnection = mock_connection_1.MockConnection;
	var websocket_connection_1 = __webpack_require__(685);
	exports.WebSocketConnection = websocket_connection_1.WebSocketConnection;
	var download_socket_1 = __webpack_require__(687);
	exports.DownloadSocket = download_socket_1.DownloadSocket;
	exports.SocketFile = download_socket_1.SocketFile;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var connection_1 = __webpack_require__(546);
	exports.SYM_SKIP_SIPHON = Symbol("skip_siphon");
	var CompositeConnection = (function (_super) {
	    __extends(CompositeConnection, _super);
	    function CompositeConnection(sources, completionTrigger) {
	        if (completionTrigger === void 0) { completionTrigger = 1; }
	        var _this = _super.call(this) || this;
	        _this.sources = sources;
	        _this.completionTrigger = completionTrigger;
	        _this.outgoingTarget = 0;
	        _this.siphoning = false;
	        _this.siphoned = [];
	        _this.incoming = Rx_1.Observable.create(function (o) {
	            var sub = new Rx_1.Subscription();
	            var completions = 0;
	            sources.forEach(function (c) {
	                sub.add(c.incoming.subscribe(function (t) {
	                    if (_this.spigot(t)) {
	                        o.next(t);
	                    }
	                }, function (e) { return o.error(e); }, function () {
	                    completions++;
	                    if (completions >= _this.completionTrigger) {
	                        o.complete();
	                        sub.unsubscribe();
	                    }
	                }));
	            });
	        });
	        return _this;
	    }
	    Object.defineProperty(CompositeConnection.prototype, "dead", {
	        get: function () {
	            return this.sources.some(function (c) { return c.dead; });
	        },
	        set: function (deadness) {
	            if (deadness) {
	                this.close();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompositeConnection.prototype.spigot = function (item) {
	        if (this.siphoning && !item[exports.SYM_SKIP_SIPHON]) {
	            if (this.siphoned.indexOf(item) === -1) {
	                this.siphoned.push(item);
	            }
	            return false;
	        }
	        return true;
	    };
	    CompositeConnection.prototype.toggle = function () {
	        this.siphoning = !this.siphoning;
	    };
	    CompositeConnection.prototype.close = function () {
	        this.sources.forEach(function (c) { return c.close(); });
	    };
	    CompositeConnection.prototype.send = function (message) {
	        if (this.sources.length === 0) {
	            throw new Error("Cannot send; CompositeConnection has no targets!");
	        }
	        var target = this.sources[this.outgoingTarget];
	        target.send(message);
	    };
	    CompositeConnection.prototype.setTarget = function (index) {
	        if (Number.isInteger(index)) {
	            this.outgoingTarget = index % this.sources.length;
	        }
	        else {
	            throw new Error("Can only set target index to an integer!");
	        }
	    };
	    CompositeConnection.prototype.nextTarget = function () {
	        this.outgoingTarget = (this.outgoingTarget + 1) % this.sources.length;
	    };
	    return CompositeConnection;
	}(connection_1.Connection));
	exports.CompositeConnection = CompositeConnection;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_1 = __webpack_require__(546);
	var EmptyConnection = (function (_super) {
	    __extends(EmptyConnection, _super);
	    function EmptyConnection() {
	        return _super.call(this) || this;
	    }
	    EmptyConnection.prototype.launch = function () {
	    };
	    EmptyConnection.prototype.close = function () {
	        throw new Error("Cannot close EmptyConnection!");
	    };
	    EmptyConnection.prototype.send = function () {
	        throw new Error("Cannot send using EmptyConnection!");
	    };
	    EmptyConnection.prototype.sendRaw = function () {
	        this.send();
	    };
	    return EmptyConnection;
	}(connection_1.Connection));
	exports.EmptyConnection = EmptyConnection;
	exports.EMPTY = new EmptyConnection();


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var connection_1 = __webpack_require__(546);
	var MockConnection = (function (_super) {
	    __extends(MockConnection, _super);
	    function MockConnection() {
	        var _this = _super.call(this) || this;
	        _this.dead = false;
	        _this.incoming = new Rx_1.Subject();
	        _this.sent = [];
	        return _this;
	    }
	    MockConnection.prototype.close = function () {
	        this.dead = true;
	    };
	    MockConnection.prototype.send = function (message) {
	        if (!this.dead) {
	            this.sent.push(message);
	        }
	    };
	    MockConnection.prototype.receive = function (message) {
	        this.incoming.next(message);
	    };
	    return MockConnection;
	}(connection_1.Connection));
	exports.MockConnection = MockConnection;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var general_1 = __webpack_require__(513);
	var connection_1 = __webpack_require__(546);
	var enums_1 = __webpack_require__(686);
	var replayLimit = 4;
	var verboseSocket = false;
	var EXPECTED_DISCONNECT_TIME = 10 * 1000;
	var WebSocketConnection = (function (_super) {
	    __extends(WebSocketConnection, _super);
	    function WebSocketConnection(url, disconnectMessage, id) {
	        if (id === void 0) { id = 0; }
	        var _this = _super.call(this) || this;
	        _this.url = url;
	        _this.disconnectMessage = disconnectMessage;
	        _this.incoming = new Rx_1.Subject();
	        _this.outgoing = new Rx_1.ReplaySubject(replayLimit);
	        _this._dead = false;
	        _this.opened = false;
	        _this.id = "[ws" + id + "]";
	        _this.socket = new WebSocket(url);
	        _this.socket.onmessage = function (event) { return _this.receive(event); };
	        _this.socket.onerror = function (error) { return _this.receiveError(error); };
	        _this.socket.onclose = function (close) { return _this.receiveClose(close); };
	        _this.socket.onopen = function (openEvent) { return _this.receiveOpen(openEvent); };
	        return _this;
	    }
	    Object.defineProperty(WebSocketConnection.prototype, "dead", {
	        get: function () {
	            return this._dead;
	        },
	        set: function (value) {
	            this._dead = true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WebSocketConnection.prototype.assertAlive = function (action) {
	        if (this.dead) {
	            throw new Error("WebSocket is dead, but received command to " + action);
	        }
	    };
	    WebSocketConnection.prototype.receiveError = function (error) {
	        if (this.opened) {
	            console.error(this.id + " encountered an error:", error);
	        }
	        else {
	            this.incoming.error(new general_1.ConnectionFailureMessage(general_1.ConnectionFailure.NoResponse));
	            this.incoming.complete();
	        }
	    };
	    WebSocketConnection.prototype.receiveClose = function (close) {
	        if (verboseSocket) {
	            console.info(this.id + " closing:", close);
	        }
	        this.dead = true;
	        this.incoming.complete();
	    };
	    WebSocketConnection.prototype.receiveOpen = function (open) {
	        var _this = this;
	        this.opened = true;
	        if (verboseSocket) {
	            console.info(this.id + " open:", open);
	        }
	        this.outgoing.subscribe(function (message) { return _this.internalSend(message); }, function (err) { return _this.outgoingError(err); }, function () { return _this.outgoingClose(); });
	    };
	    WebSocketConnection.prototype.receive = function (event) {
	        if (verboseSocket) {
	            console.groupCollapsed(this.id + " incoming <=|");
	            console.log(event.data);
	            console.groupEnd();
	        }
	        var message;
	        try {
	            message = JSON.parse(event.data);
	        }
	        catch (err) {
	            return this.incomingParseError(err, event.data);
	        }
	        this.incoming.next(message);
	    };
	    WebSocketConnection.prototype.incomingParseError = function (err, data) {
	        if (err instanceof SyntaxError) {
	            console.error(this.id + " received malformed JSON from the server:", err);
	        }
	        else {
	            console.error(this.id + " hit an unknown error trying to read server data:", err);
	        }
	    };
	    WebSocketConnection.prototype.internalSend = function (message) {
	        if (verboseSocket) {
	            console.groupCollapsed(this.id + " outgoing |=>");
	            console.log(message);
	            console.groupEnd();
	        }
	        this.socket.send(JSON.stringify(message));
	    };
	    WebSocketConnection.prototype.send = function (message) {
	        this.assertAlive("send a message");
	        this.outgoing.next(message);
	    };
	    WebSocketConnection.prototype.sendRaw = function (message) {
	        console.warn("connection.sendRaw is for debugging only!");
	        this.socket.send(message);
	    };
	    WebSocketConnection.prototype.close = function () {
	        if (verboseSocket) {
	            console.log(this.id + " was instructed to close()");
	        }
	        this.assertAlive("close the stream");
	        this.outgoing.complete();
	    };
	    WebSocketConnection.prototype.outgoingError = function (err) {
	        throw new Error(this.id + "'s outgoing stream stopped due to error");
	    };
	    WebSocketConnection.prototype.outgoingClose = function () {
	        var _this = this;
	        this.internalSend(this.disconnectMessage);
	        setTimeout(function () { return _this.verifySocketClosed(); }, EXPECTED_DISCONNECT_TIME);
	    };
	    WebSocketConnection.prototype.verifySocketClosed = function () {
	        if (this.socket.readyState !== enums_1.ReadyState.Closed) {
	            console.error(this.id + " sent disconnect, but socket is still open after "
	                + EXPECTED_DISCONNECT_TIME + "ms; closing manually...");
	            this.socket.close(enums_1.CloseCode.Normal);
	        }
	    };
	    return WebSocketConnection;
	}(connection_1.Connection));
	exports.WebSocketConnection = WebSocketConnection;


/***/ }),
/* 686 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CloseCode;
	(function (CloseCode) {
	    CloseCode[CloseCode["Normal"] = 1000] = "Normal";
	    CloseCode[CloseCode["GoingAway"] = 1001] = "GoingAway";
	    CloseCode[CloseCode["ProtocolError"] = 1002] = "ProtocolError";
	    CloseCode[CloseCode["Unsupported"] = 1003] = "Unsupported";
	    CloseCode[CloseCode["NoStatus"] = 1005] = "NoStatus";
	    CloseCode[CloseCode["Abnormal"] = 1006] = "Abnormal";
	    CloseCode[CloseCode["UnsupportedData"] = 1007] = "UnsupportedData";
	    CloseCode[CloseCode["PolicyViolation"] = 1008] = "PolicyViolation";
	    CloseCode[CloseCode["TooLarge"] = 1009] = "TooLarge";
	    CloseCode[CloseCode["MissingExtension"] = 1010] = "MissingExtension";
	    CloseCode[CloseCode["InternalError"] = 1011] = "InternalError";
	    CloseCode[CloseCode["ServiceRestart"] = 1012] = "ServiceRestart";
	    CloseCode[CloseCode["TryAgainLater"] = 1013] = "TryAgainLater";
	    CloseCode[CloseCode["TLSFailure"] = 1015] = "TLSFailure";
	    CloseCode[CloseCode["LocalFailure"] = 4000] = "LocalFailure";
	})(CloseCode = exports.CloseCode || (exports.CloseCode = {}));
	var ReadyState;
	(function (ReadyState) {
	    ReadyState[ReadyState["Connecting"] = 0] = "Connecting";
	    ReadyState[ReadyState["Open"] = 1] = "Open";
	    ReadyState[ReadyState["Closing"] = 2] = "Closing";
	    ReadyState[ReadyState["Closed"] = 3] = "Closed";
	})(ReadyState = exports.ReadyState || (exports.ReadyState = {}));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var CRC32 = __webpack_require__(688);
	var Rx_1 = __webpack_require__(214);
	var functions_1 = __webpack_require__(206);
	var enums_1 = __webpack_require__(686);
	var DownloadSocket = (function () {
	    function DownloadSocket(baseUrl, publicToken, secretToken, filetype) {
	        var _this = this;
	        this.baseUrl = baseUrl;
	        this.publicToken = publicToken;
	        this.secretToken = secretToken;
	        this.initialMessages = [];
	        this.file = new SocketFile();
	        this.completion = new Rx_1.Subject();
	        if (secretToken.length !== DownloadSocket.BL_SECRET * 2
	            || publicToken.length !== DownloadSocket.BL_TOKEN * 2) {
	            throw new Error("Tokens have incorrect lengths "
	                + ("(" + secretToken.length + "+" + publicToken.length + ")"));
	        }
	        this.buildConnections();
	        var i = 0;
	        this.file.type = filetype;
	        this.incoming.subscribe(function (b) {
	            _this.file.addBlob(b);
	            i++;
	        }, function (err) { return console.error("Download socket error:", err); }, function () {
	            _this.file.complete();
	            _this.completion.next(_this.file);
	            _this.completion.complete();
	        });
	        var tokenMessage = this.buildTokenMessage();
	        this.outgoing.next(tokenMessage);
	    }
	    DownloadSocket.prototype.buildConnections = function () {
	        var _this = this;
	        this.socket = new WebSocket("" + this.baseUrl + this.publicToken);
	        this.socket.binaryType = "blob";
	        this.incoming = new Rx_1.Subject();
	        this.outgoing = new Rx_1.Subject();
	        this.socket.onclose = function () {
	            _this.incoming.complete();
	            console.warn("Socket closed!");
	        };
	        this.socket.onerror = function (err) { return _this.incoming.error(err); };
	        this.socket.onmessage = function (message) {
	            if (message.data instanceof Blob) {
	                _this.incoming.next(message.data);
	            }
	            else {
	                console.error("Received non-blob message", message);
	            }
	        };
	        this.socket.onopen = function () {
	            _this.initialMessages.forEach(function (b) { return _this.socket.send(b); });
	            _this.initialMessages = [];
	        };
	        this.outgoing.subscribe(function (b) {
	            if (_this.socket.readyState === enums_1.ReadyState.Open) {
	                _this.socket.send(b);
	            }
	            else {
	                _this.initialMessages.push(b);
	            }
	        });
	    };
	    DownloadSocket.prototype.buildTokenMessage = function () {
	        var token = new Uint8Array(DownloadSocket.BL_SECRET);
	        for (var i = 0; i < DownloadSocket.BL_SECRET; i++) {
	            token[i] = Number.parseInt(this.secretToken.slice(2 * i, 2 * (i + 1)), 16);
	        }
	        return new Blob([token]);
	    };
	    DownloadSocket.BL_TOKEN = 32;
	    DownloadSocket.BL_SECRET = 256;
	    return DownloadSocket;
	}());
	exports.DownloadSocket = DownloadSocket;
	var QueuingBufferReader = (function () {
	    function QueuingBufferReader() {
	        var _this = this;
	        this.reader = new FileReader();
	        this.reading = false;
	        this.toRead = [];
	        this.readCount = 0;
	        this.crc = 0;
	        this.out = new Rx_1.Subject();
	        this.reader.onload = function () { return _this.finishRead(); };
	    }
	    QueuingBufferReader.prototype.readNext = function () {
	        var b = this.toRead.shift();
	        if (b === null) {
	            console.warn("buffer reader finished");
	            this.reading = false;
	            this.out.complete();
	            return;
	        }
	        if (!(b instanceof Blob)) {
	            console.error(b, typeof b);
	        }
	        this.reading = true;
	        this.readCount++;
	        this.reader.readAsArrayBuffer(b);
	    };
	    QueuingBufferReader.prototype.finishRead = function () {
	        this.out.next(this.reader.result);
	        this.crc = CRC32.buf(new Uint8Array(this.reader.result), this.crc);
	        if (this.toRead.length > 0) {
	            this.readNext();
	        }
	        else {
	            this.reading = false;
	        }
	    };
	    QueuingBufferReader.prototype.read = function (blob) {
	        this.toRead.push(blob);
	        if (!this.reading) {
	            this.readNext();
	        }
	    };
	    QueuingBufferReader.prototype.complete = function () {
	        this.read(null);
	    };
	    return QueuingBufferReader;
	}());
	function debugObserver(name, useNext) {
	    if (useNext === void 0) { useNext = true; }
	    return {
	        next: useNext ? function (val) { return console.warn(name + ":", val); } : function () { return null; },
	        error: function (err) { return console.warn(name + ": error", err); },
	        complete: function () { return console.warn(name + ": complete!"); },
	    };
	}
	var SocketFile = (function () {
	    function SocketFile() {
	        var _this = this;
	        this.chunks = [];
	        this.done = false;
	        this.hasBOM = false;
	        this.bufferizer = new QueuingBufferReader();
	        this.finalCRC = this.bufferizer.out.last().map(function () { return _this.bufferizer.crc; }).do(function (crc) {
	            console.warn("CRC calculated", crc);
	            _this.crc = crc;
	            _this.crcHex = "0x" + _this.crc.toString(16);
	        });
	        this.emptyCount = 0;
	        this.bufferCount = 0;
	        this.forCheck = new Rx_1.Subject();
	        this.bufferizer.out.subscribe(debugObserver("bufferizer", false));
	        this.finalCRC.subscribe(debugObserver("final CRC"));
	    }
	    SocketFile.prototype.addBlob = function (b) {
	        if (b.size === 0) {
	            this.emptyCount++;
	        }
	        else {
	            this.chunks.push(b);
	            this.bufferizer.read(b);
	        }
	    };
	    SocketFile.prototype.complete = function () {
	        if (!this.done) {
	            this.bufferizer.complete();
	            this.file = new Blob(this.chunks, { type: this.type });
	            this.size = this.file.size;
	            this.bufferCount = this.chunks.length;
	            this.chunks = [];
	            this.done = true;
	            if (this.emptyCount > 0) {
	                console.error("Download socket received " + this.emptyCount + " empty frames!");
	            }
	        }
	    };
	    SocketFile.prototype.generateUrl = function () {
	        this.complete();
	        return URL.createObjectURL(this.file);
	    };
	    SocketFile.prototype.verify = function (serverFilesize, serverCRC) {
	        if (!this.done) {
	            throw new Error("Cannot verify before download is done");
	        }
	        else {
	            if (this.file.size !== serverFilesize) {
	                console.error(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    Server said file would be ", " bytes,\n                    got ", " bytes"], ["\n                    Server said file would be ", " bytes,\n                    got ", " bytes"])), serverFilesize, this.file.size));
	                return Rx_1.Observable.of(false);
	            }
	            if (this.crc) {
	                console.log("performing *IMMEDIATE* CRC validation");
	                if (this.crc !== serverCRC) {
	                    console.error(functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                        File checksums did not match. Client got ", "\n                        while server sent ", "."], ["\n                        File checksums did not match. Client got ", "\n                        while server sent ", "."])), this.crc, serverCRC));
	                    return Rx_1.Observable.of(false);
	                }
	                return Rx_1.Observable.of(true);
	            }
	            console.warn("requesting delayed CRC validation");
	            return this.finalCRC.map(function (localCRC) {
	                console.warn("performing delayed CRC validation");
	                if (localCRC !== serverCRC) {
	                    console.error(functions_1.oneline(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                        File checksums did not match. Client got ", "\n                        while server sent ", "."], ["\n                        File checksums did not match. Client got ", "\n                        while server sent ", "."])), localCRC, serverCRC));
	                    return false;
	                }
	                return true;
	            });
	        }
	    };
	    SocketFile.prototype.addBOM = function () {
	        if (!this.done) {
	            throw new Error("Can only add BOM after download is complete!");
	        }
	        if (this.hasBOM) {
	            throw new Error("File already has BOM!");
	        }
	        this.file = new Blob([SocketFile.BOM, this.file]);
	        this.size += SocketFile.BOMByteLength;
	        this.hasBOM = true;
	    };
	    SocketFile.BOM = "\uFEFF";
	    SocketFile.BOMByteLength = 3;
	    return SocketFile;
	}());
	exports.SocketFile = SocketFile;
	var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 688 */,
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(66);
	var setting_service_1 = __webpack_require__(690);
	var rxjs_1 = __webpack_require__(214);
	var ANNOUNCEMENT_URL = "/zone/documents/announcements.json";
	var RETRIEVAL_INTERVAL = 1000 * 60 * 60;
	var CONSOLE_BEHAVIOR = new Map([
	    ["error", function (content) { return console.error(content); }],
	    ["warning", function (content) { return console.warn(content); }],
	    ["notification", function (content) { return console.info(content); }],
	    ["user", function (content) { return console.info(content); }],
	    ["success", function (content) { return console.log(content); }],
	    ["countdown", function (content) { return console.warn(content); }]
	]);
	var AlertService = (function () {
	    function AlertService(settings, http) {
	        this.settings = settings;
	        this.http = http;
	        this.announcementsLoaded = new rxjs_1.BehaviorSubject(false);
	        this.userAnnouncements = [];
	        this.guestAnnouncements = [];
	        this.suppressedLevels = new Set();
	        this.alerts = [];
	        this.namedAlerts = new Map();
	        this.consoleDuplication = true;
	        this.loadAnnouncements();
	    }
	    AlertService_1 = AlertService;
	    AlertService.prototype.isAnnouncementLike = function (x) {
	        return (typeof x === "object" && "start" in x && "content" in x);
	    };
	    AlertService.prototype.loadAnnouncements = function () {
	        var _this = this;
	        this.http.get(ANNOUNCEMENT_URL).subscribe(function (res) {
	            var json = res.json();
	            if (!Array.isArray(json)) {
	                console.error("Could not read announcements file. [Non-array root!]");
	            }
	            var readDate = Date.now();
	            json.filter(_this.isAnnouncementLike).filter(function (a) {
	                return a.start < readDate && (a.expires == null || a.expires > readDate);
	            }).forEach(function (a) {
	                if (a.unauthenticated === true) {
	                    _this.guestAnnouncements.push(a);
	                }
	                else {
	                    _this.userAnnouncements.push(a);
	                }
	            });
	            if (_this.guestAnnouncements.length > 0) {
	                _this.add({
	                    message: _this.guestAnnouncements[0].content,
	                    type: AlertService_1.alertTypeFromAnnouncement(_this.guestAnnouncements[0]),
	                    timeout: null
	                });
	            }
	            _this.announcementsLoaded.next(true);
	        });
	    };
	    AlertService.alertTypeFromAnnouncement = function (a) {
	        switch (a.style) {
	            case "success":
	                return "success";
	            case "warning":
	                return "warning";
	            case "danger":
	                return "error";
	            case "info":
	            default:
	                return "notification";
	        }
	    };
	    AlertService.prototype.shouldSuppress = function (alert) {
	        if (this.suppressedLevels.has(alert.type)) {
	            return true;
	        }
	        return false;
	    };
	    AlertService.prototype.add = function (alert) {
	        var _this = this;
	        if (alert.name) {
	            if (this.namedAlerts.has(alert.name)) {
	                if (alert.replacePrevious === true) {
	                    this.remove(this.namedAlerts.get(alert.name), true);
	                }
	                else {
	                    return false;
	                }
	            }
	            this.namedAlerts.set(alert.name, alert);
	        }
	        this.alerts.push(alert);
	        if (this.shouldSuppress(alert)) {
	            alert.suppressed = true;
	        }
	        if (alert.timeout) {
	            if (alert.timeout === 'default') {
	                alert.timeout = this.getDefaultTimeout();
	            }
	            alert.timer = setTimeout(function () { return _this.remove(alert); }, alert.timeout);
	        }
	        this.fadeIn(alert);
	        if (this.consoleDuplication
	            && alert.type
	            && CONSOLE_BEHAVIOR.has(alert.type)) {
	            CONSOLE_BEHAVIOR.get(alert.type)(alert.message);
	            if (alert.data) {
	                CONSOLE_BEHAVIOR.get(alert.type)(alert.data);
	            }
	        }
	        return true;
	    };
	    AlertService.prototype.getDefaultTimeout = function () {
	        return this.settings.get("alert timeout");
	    };
	    AlertService.prototype.addStandard = function (message, type) {
	        this.add({
	            message: message,
	            type: type,
	            timeout: this.getDefaultTimeout()
	        });
	    };
	    AlertService.prototype.fadeIn = function (alert) {
	        var _this = this;
	        setTimeout(function () {
	            var pos = _this.alerts.indexOf(alert);
	            if (pos === -1) {
	                return false;
	            }
	            _this.alerts[pos].show = true;
	        }, 20);
	    };
	    AlertService.prototype.cancelTimeout = function (alert) {
	        if (alert.timer) {
	            clearTimeout(alert.timer);
	            alert.timer = null;
	        }
	    };
	    AlertService.prototype.remove = function (alert, immediate) {
	        var _this = this;
	        if (immediate === void 0) { immediate = false; }
	        alert.show = false;
	        this.cancelTimeout(alert);
	        if (alert.name) {
	            this.namedAlerts.delete(alert.name);
	        }
	        var remove = function () {
	            var pos = _this.alerts.indexOf(alert);
	            if (pos === -1) {
	                return false;
	            }
	            _this.alerts.splice(pos, 1);
	        };
	        if (immediate) {
	            remove();
	        }
	        else {
	            setTimeout(remove, 150);
	        }
	    };
	    AlertService.prototype.errorSubscriber = function (message) {
	        var _this = this;
	        return { error: function (err) { return _this.error(message); } };
	    };
	    AlertService.prototype.error = function (message) {
	        this.add({ message: message, type: "error" });
	    };
	    AlertService.prototype.errorAndReplace = function (message, name) {
	        this.add({ message: message, type: "error", name: name, replacePrevious: true });
	    };
	    AlertService.prototype.warn = function (message) {
	        this.addStandard(message, "warning");
	    };
	    AlertService.prototype.warnAndReplace = function (message, name) {
	        this.add({ message: message, type: "warning", name: name, replacePrevious: true,
	            timeout: this.getDefaultTimeout() });
	    };
	    AlertService.prototype.addAndReplace = function (message, type, name) {
	        this.add({ message: message, type: type, name: name, replacePrevious: true,
	            timeout: this.getDefaultTimeout() });
	    };
	    AlertService.prototype.notify = function (message) {
	        this.addStandard(message, "notification");
	    };
	    AlertService.prototype.success = function (message) {
	        this.addStandard(message, "success");
	    };
	    AlertService.prototype.userInfo = function (message) {
	        this.addStandard(message, "user");
	    };
	    AlertService.prototype.removeNamed = function (name) {
	        if (this.namedAlerts.has(name)) {
	            this.remove(this.namedAlerts.get(name));
	        }
	    };
	    AlertService.prototype.mute = function () {
	        this.alerts = [];
	        this.suppressedLevels = new Set(["error", "warning", "notification", "user", "success", "countdown"]);
	    };
	    var AlertService_1;
	    AlertService = AlertService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [setting_service_1.SettingService, http_1.Http])
	    ], AlertService);
	    return AlertService;
	}());
	exports.AlertService = AlertService;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(21);
	var storage_service_1 = __webpack_require__(691);
	var build_flags_1 = __webpack_require__(534);
	var configuration_service_1 = __webpack_require__(512);
	var SettingService = (function () {
	    function SettingService(storage, config, sanitizer) {
	        this.storage = storage;
	        this.config = config;
	        this.sanitizer = sanitizer;
	        this.settings = new Map();
	        this.mapSettings = [];
	        this.readDefaults([this.config.settings.defaults]);
	        this.readMapDefaults(this.config.settings.mapDefaults);
	    }
	    SettingService.prototype.readDefaults = function (configs) {
	        var _this = this;
	        configs.forEach(function (defaults) {
	            defaults.forEach(function (setting) {
	                return _this.add(setting);
	            });
	        });
	    };
	    SettingService.prototype.readMapDefaults = function (defaults) {
	        var _this = this;
	        defaults.forEach(function (setting) {
	            _this.add(setting, true);
	        });
	    };
	    SettingService.prototype.isMapSetting = function (setting) {
	        return "keyType" in setting;
	    };
	    SettingService.prototype.add = function (setting, isMap) {
	        if (isMap === void 0) { isMap = false; }
	        if (typeof setting.presentation === "string") {
	            setting.presentationUnsafe = this.sanitizer.bypassSecurityTrustHtml(setting.presentation);
	        }
	        this.settings.set(setting.name, setting);
	        this.load(setting.name);
	        if (isMap) {
	            this.mapSettings.push(setting);
	        }
	    };
	    SettingService.prototype.has = function (name) {
	        return this.settings.has(name);
	    };
	    SettingService.prototype.load = function (name) {
	        var item = this.storage.get(name);
	        if (item !== null) {
	            if (!this.settings.has(name)) {
	                throw new Error(name + " present in storage, but not in app settings");
	            }
	            var setting = this.settings.get(name);
	            if (!build_flags_1.BuildFlags.debugMode && setting.debugOnly) {
	                return;
	            }
	            setting.value = item;
	        }
	    };
	    SettingService.prototype.save = function (name) {
	        this.storage.set(name, this.settings.get(name).value);
	    };
	    SettingService.prototype.get = function (name) {
	        this.load(name);
	        return this.settings.get(name).value;
	    };
	    SettingService.prototype.getOr = function (name, fallback) {
	        if (this.has(name)) {
	            return this.get(name);
	        }
	        else {
	            return fallback;
	        }
	    };
	    SettingService.prototype.getSetting = function (name) {
	        this.load(name);
	        return this.settings.get(name);
	    };
	    SettingService.prototype.set = function (name, value, save) {
	        if (save === void 0) { save = true; }
	        console.log("Setting value for " + name, value);
	        if (!this.has(name)) {
	            throw new Error("No local setting with name '" + name + "'");
	        }
	        this.settings.get(name).value = value;
	        if (save) {
	            this.save(name);
	        }
	    };
	    SettingService.prototype.all = function () {
	        return Array.from(this.settings.values());
	    };
	    SettingService.prototype.visible = function () {
	        if (build_flags_1.BuildFlags.debugMode) {
	            return this.all();
	        }
	        else {
	            return this.all().filter(function (s) { return !s.debugOnly; });
	        }
	    };
	    SettingService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [storage_service_1.StorageService,
	            configuration_service_1.ConfigurationService,
	            platform_browser_1.DomSanitizer])
	    ], SettingService);
	    return SettingService;
	}());
	exports.SettingService = SettingService;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var in_memory_storage_1 = __webpack_require__(692);
	var STORAGE_PROTOCOL_VERSION = 0;
	var StorageService = (function () {
	    function StorageService() {
	        this.version = STORAGE_PROTOCOL_VERSION;
	        this.driver = this.supportsLS() ? localStorage : new in_memory_storage_1.InMemoryStorage();
	    }
	    StorageService.prototype.supportsLS = function () {
	        try {
	            var x = "support_test";
	            localStorage.setItem(x, x);
	            localStorage.removeItem(x);
	            return true;
	        }
	        catch (e) {
	            return false;
	        }
	    };
	    StorageService.prototype.get = function (name, fallback) {
	        if (fallback === void 0) { fallback = null; }
	        try {
	            var retrieved = JSON.parse(this.driver.getItem(name));
	            return (retrieved === null) ? fallback : retrieved;
	        }
	        catch (err) {
	            console.error(err);
	            return;
	        }
	    };
	    StorageService.prototype.set = function (name, value) {
	        this.driver.setItem(name, JSON.stringify(value));
	    };
	    StorageService.prototype.remove = function (name) {
	        this.driver.removeItem(name);
	    };
	    StorageService.prototype.clear = function () {
	        this.driver.clear();
	    };
	    StorageService.prototype.setWrapped = function (name, value, compressor) {
	        var existing = this.getWrappedRaw(name);
	        existing.content = value;
	        existing.version = this.version;
	        existing.modifyCount += 1;
	        existing.modified = new Date();
	        this.set(name, this.serializeWrapper(existing, compressor));
	    };
	    StorageService.prototype.getWrappedRaw = function (name, fallback, extractor) {
	        if (fallback === void 0) { fallback = null; }
	        var loaded = this.get(name);
	        if (loaded === null || typeof loaded !== "object") {
	            return this.wrappedFallback(name, fallback);
	        }
	        else {
	            return this.deserializeWrapper(loaded, extractor);
	        }
	    };
	    StorageService.prototype.getWrappedValue = function (name, fallback, extractor) {
	        if (fallback === void 0) { fallback = null; }
	        return this.getWrappedRaw(name, fallback, extractor).content;
	    };
	    StorageService.prototype.wrappedFallback = function (name, value) {
	        if (value === void 0) { value = null; }
	        var now = new Date();
	        return {
	            created: now,
	            modified: now,
	            key: name,
	            content: value,
	            modifyCount: 0,
	            version: this.version,
	            fresh: true
	        };
	    };
	    StorageService.prototype.deserializeWrapper = function (stored, extractor) {
	        var content = (extractor
	            ? extractor(stored.content)
	            : stored.content);
	        return {
	            created: new Date(stored.created),
	            modified: new Date(stored.modified),
	            key: stored.key,
	            modifyCount: stored.modifyCount,
	            version: stored.version,
	            content: content
	        };
	    };
	    StorageService.prototype.serializeWrapper = function (toSet, compressor) {
	        var content = (compressor
	            ? compressor(toSet.content)
	            : toSet.content);
	        return {
	            created: toSet.created.valueOf(),
	            modified: toSet.modified.valueOf(),
	            key: toSet.key,
	            modifyCount: toSet.modifyCount,
	            version: toSet.version,
	            content: content
	        };
	    };
	    StorageService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [])
	    ], StorageService);
	    return StorageService;
	}());
	exports.StorageService = StorageService;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InMemoryStorage = (function () {
	    function InMemoryStorage() {
	        this._store = {};
	        this._keys = [];
	    }
	    Object.defineProperty(InMemoryStorage.prototype, "length", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InMemoryStorage.prototype.clear = function () {
	        this._keys = [];
	        this._store = {};
	    };
	    InMemoryStorage.prototype.key = function (n) {
	        return this._keys[n];
	    };
	    InMemoryStorage.prototype.has = function (key) {
	        return (this._keys.indexOf(key) > -1);
	    };
	    InMemoryStorage.prototype.getItem = function (key) {
	        return this._store[key];
	    };
	    InMemoryStorage.prototype.setItem = function (key, value) {
	        if (!this.has(key)) {
	            this._keys.push(key);
	        }
	        this._store[key] = value;
	    };
	    InMemoryStorage.prototype.removeItem = function (key) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            return;
	        }
	        this._keys.splice(i, 1);
	        delete this._store[key];
	    };
	    return InMemoryStorage;
	}());
	exports.InMemoryStorage = InMemoryStorage;


/***/ }),
/* 693 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RingBuffer = (function () {
	    function RingBuffer(max) {
	        this.max = max;
	        this.start = 0;
	        this.end = 0;
	        this.empty = true;
	        this.buffer = new Array(max);
	    }
	    RingBuffer.prototype.add = function (entry) {
	        this.buffer[this.end] = entry;
	        if (this.empty) {
	            this.empty = false;
	        }
	        else if (this.start === this.end) {
	            this.start = (this.start + 1) % this.max;
	        }
	        this.end = (this.end + 1) % this.max;
	    };
	    RingBuffer.prototype.last = function () {
	        if (this.empty) {
	            return null;
	        }
	        var lastIndex = (this.end - 1) % this.max;
	        return this.buffer[lastIndex];
	    };
	    RingBuffer.prototype.size = function () {
	        if (this.empty) {
	            return 0;
	        }
	        return ((this.end > this.start)
	            ? (this.end - this.start)
	            : (this.max + this.end - this.start));
	    };
	    RingBuffer.prototype.list = function () {
	        if (this.empty) {
	            return [];
	        }
	        if (this.end > this.start) {
	            return this.buffer.slice(this.start, this.end);
	        }
	        return this.buffer.slice(this.start).concat(this.buffer.slice(0, this.end));
	    };
	    RingBuffer.prototype.clear = function () {
	        this.empty = true;
	        this.start = 0;
	        this.end = 0;
	    };
	    RingBuffer.prototype[Symbol.iterator] = function () {
	        var list = this.list();
	        return list[Symbol.iterator]();
	    };
	    return RingBuffer;
	}());
	exports.RingBuffer = RingBuffer;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var configuration_service_1 = __webpack_require__(512);
	var general_1 = __webpack_require__(513);
	var ProtocolVersionService = (function () {
	    function ProtocolVersionService(config) {
	        this.config = config;
	        this.selected = null;
	        this.preferred = this.config.protocol.clientProtocolVersion;
	        var supported = Array.from(this.config.protocol.supportedProtocolVersions);
	        var pos = supported.indexOf(this.preferred);
	        if (pos < 0) {
	            throw new Error("Client preferred version not present in client's supported list.");
	        }
	        this.supported = supported;
	        this.potential = Array.from(this.supported);
	    }
	    ProtocolVersionService.prototype.get = function () {
	        return this.selected;
	    };
	    ProtocolVersionService.prototype.reset = function () {
	        this.selected = null;
	        this.potential = Array.from(this.supported);
	    };
	    ProtocolVersionService.prototype.hasMorePotentials = function () {
	        return (this.potential.length > 0);
	    };
	    ProtocolVersionService.prototype.next = function () {
	        if (this.potential.length === 0) {
	            throw new Error("No more supported versions available!");
	        }
	        return new general_1.VersionRequest(this.potential.pop());
	    };
	    ProtocolVersionService.prototype.suggest = function (versions) {
	        this.potential = this.potential.filter(function (v) { return versions.indexOf(v) > -1; });
	    };
	    ProtocolVersionService.prototype.select = function (version) {
	        this.selected = version;
	        window.protocolVersion = version;
	        console.log("WS handshake succeeding, using version " + version);
	        return [true];
	    };
	    ProtocolVersionService.prototype.negotiate = function (send, serverVersions) {
	        var _this = this;
	        if (serverVersions && serverVersions.length) {
	            this.suggest(serverVersions);
	        }
	        if (!this.hasMorePotentials()) {
	            return Rx_1.Observable.of(false);
	        }
	        var versionRequest = this.next();
	        return send(versionRequest).flatMap(function (reply) {
	            return versionRequest.verifyReply(reply)
	                ? _this.select(versionRequest.version)
	                : _this.negotiate(send, reply.supported);
	        });
	    };
	    ProtocolVersionService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService])
	    ], ProtocolVersionService);
	    return ProtocolVersionService;
	}());
	exports.ProtocolVersionService = ProtocolVersionService;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var algorithms_1 = __webpack_require__(576);
	var context_management_1 = __webpack_require__(604);
	var general_1 = __webpack_require__(513);
	var step_manager_1 = __webpack_require__(696);
	var UI_LAUNCH_WINDOW = 4 * 1000;
	var RunningAlgorithm = (function () {
	    function RunningAlgorithm(algorithm, subject, transformer, sender) {
	        this.algorithm = algorithm;
	        this.subject = subject;
	        this.transformer = transformer;
	        this.sender = sender;
	        this.steps = new step_manager_1.StepManager(this.transformer);
	        this.isRunning = false;
	        this.recentlyLaunched = true;
	        this.mayHaveUnexploredSteps = false;
	        this.lastExternalSave = new Date(0);
	        this.lastInternalSave = new Date(0);
	        subject.assertTypeDefined();
	    }
	    Object.defineProperty(RunningAlgorithm.prototype, "type", {
	        get: function () {
	            return this.algorithm.type;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RunningAlgorithm.prototype, "name", {
	        get: function () {
	            return this.algorithm.name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RunningAlgorithm.prototype, "displayName", {
	        get: function () {
	            return this.algorithm.displayName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RunningAlgorithm.prototype.stop = function () {
	        if (this.isRunning) {
	            return this.sender.successful(new algorithms_1.StopAlgorithmRequest());
	        }
	        else {
	            console.warn("Request to stop non-running algorithm");
	            return Rx_1.Observable.empty();
	        }
	    };
	    RunningAlgorithm.prototype.start = function () {
	        var _this = this;
	        if (this.isRunning) {
	            console.info("Request to start already-running algorithm");
	            return Rx_1.Observable.empty();
	        }
	        else {
	            if (!this.subject.loaded) {
	                console.error(this);
	                throw new Error("Subject not loaded at algorithm start!");
	            }
	            return Rx_1.Observable.concat(this.load(), this.launch()).last().do(function () { return _this.isRunning = true; });
	        }
	    };
	    RunningAlgorithm.prototype.load = function () {
	        var _this = this;
	        if (this.algorithm.loadedThisSession) {
	            return Rx_1.Observable.empty();
	        }
	        return this.sender.successful(new algorithms_1.LoadAlgorithmRequest(this.algorithm.name)).do(function () { return _this.algorithm.loadedThisSession = true; });
	    };
	    RunningAlgorithm.prototype.launch = function () {
	        var _this = this;
	        return this.sender.successful(new algorithms_1.StartAlgorithmRequest(this.algorithm.name, this.subject.id)).do(function () { return setTimeout(function () { return _this.recentlyLaunched = false; }, UI_LAUNCH_WINDOW); });
	    };
	    RunningAlgorithm.prototype.save = function (force) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        return this.sender.send(new context_management_1.SaveSubjectContextRequest(this.subject.id, force)).map(function (msg) {
	            return (msg.ok ? general_1.ResponseCode.OK : msg.code);
	        }).do(function (code) {
	            if (code === general_1.ResponseCode.OK) {
	                _this.lastInternalSave = new Date();
	                _this.subject.newlyCreated = false;
	            }
	        });
	    };
	    return RunningAlgorithm;
	}());
	exports.RunningAlgorithm = RunningAlgorithm;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var structure_1 = __webpack_require__(581);
	var step_update_1 = __webpack_require__(697);
	var StepManager = (function () {
	    function StepManager(transformer) {
	        this.transformer = transformer;
	        this.map = new Map();
	        this._updates = new Rx_1.Subject();
	    }
	    StepManager.prototype.get = function (id) {
	        return this.map.get(id);
	    };
	    StepManager.prototype.has = function (id) {
	        return this.map.has(id);
	    };
	    StepManager.prototype.knownIds = function () {
	        return Array.from(this.map.keys());
	    };
	    StepManager.prototype.all = function () {
	        return Array.from(this.map.values());
	    };
	    StepManager.prototype.filtered = function (filter) {
	        return this.all().filter(filter);
	    };
	    StepManager.prototype.intakes = function () {
	        return this.filtered(function (step) { return (step instanceof structure_1.IntakeStep); });
	    };
	    StepManager.prototype.reports = function () {
	        return this.filtered(function (step) { return (step instanceof structure_1.ReportStep); });
	    };
	    StepManager.prototype.computations = function () {
	        return this.filtered(function (step) { return (step instanceof structure_1.ComputationStep); });
	    };
	    Object.defineProperty(StepManager.prototype, "updates", {
	        get: function () {
	            return this._updates;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StepManager.prototype.subscribe = function (next, error, complete) {
	        if (error) {
	            return this.updates.subscribe(next, error, complete);
	        }
	        else {
	            return this.updates.subscribe(next);
	        }
	    };
	    StepManager.prototype.applyAndSend = function (update) {
	        var found = update.getAndApply(this.map);
	        if (!found) {
	            if (update.canCreate) {
	                var step = update.create();
	                this.map.set(update.id, step);
	            }
	            else {
	                console.error(this.map, update);
	                throw new Error("Illegal update application: no local step");
	            }
	        }
	        this._updates.next(update);
	    };
	    StepManager.prototype.define = function (step) {
	        this.applyAndSend(new step_update_1.StepDefinition(step, this.transformer));
	    };
	    StepManager.prototype.answer = function (answer) {
	        this.applyAndSend(new step_update_1.ReceivedAnswer(answer, this.transformer));
	    };
	    StepManager.prototype.comment = function (id, comments) {
	        this.applyAndSend(new step_update_1.CommentChange(id, comments));
	    };
	    StepManager.prototype.focalize = function (id, reason, duration) {
	        this.applyAndSend(new step_update_1.Focalization({ id: id, reason: reason, duration: duration }));
	    };
	    StepManager.prototype.deactivateAll = function () {
	        this.applyAndSend(new step_update_1.GlobalDeactivation({ id: -1 }));
	    };
	    StepManager.prototype.close = function () {
	        this._updates.complete();
	        this.map.clear();
	    };
	    return StepManager;
	}());
	exports.StepManager = StepManager;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var typed_data_1 = __webpack_require__(69);
	var functions_1 = __webpack_require__(206);
	var structure_1 = __webpack_require__(581);
	var StepUpdate = (function () {
	    function StepUpdate(source) {
	        this.source = source;
	        this.canCreate = false;
	        this.id = source.id;
	    }
	    StepUpdate.prototype.matches = function (target) {
	        return target.id === this.id;
	    };
	    StepUpdate.prototype.findAndApply = function (target) {
	        var _this = this;
	        var result = target.find(function (el) { return _this.matches(el); });
	        if (result) {
	            this.apply(result);
	            return true;
	        }
	        return false;
	    };
	    StepUpdate.prototype.getAndApply = function (target) {
	        var result = target.get(this.id);
	        if (result) {
	            this.apply(result);
	            return true;
	        }
	        return false;
	    };
	    StepUpdate.prototype.create = function () {
	        console.error(this);
	        throw new Error("Cannot use this update type to create entry!");
	    };
	    return StepUpdate;
	}());
	exports.StepUpdate = StepUpdate;
	var StepDefinition = (function (_super) {
	    __extends(StepDefinition, _super);
	    function StepDefinition(step, transformer) {
	        var _this = _super.call(this, step) || this;
	        _this.transformer = transformer;
	        _this.canCreate = true;
	        return _this;
	    }
	    StepDefinition.prototype.apply = function (target) {
	        functions_1.assignExcept(target, this.source, ["type", "cardinality", "hints", "id", "value"]);
	        if (target instanceof structure_1.IntakeStep && this.source instanceof structure_1.IntakeStep) {
	            if (target.value !== this.source.value) {
	                target.value = this.source.value;
	                this.effects = this.transformer.run(target);
	                this.effects.modified_intake_value = true;
	            }
	            else {
	                this.effects = this.transformer.run(target);
	            }
	        }
	    };
	    StepDefinition.prototype.create = function () {
	        if (this.source instanceof structure_1.IntakeStep) {
	            this.effects = this.transformer.run(this.source, true);
	        }
	        return this.source;
	    };
	    StepDefinition.prototype.matchesType = function (type) {
	        return (this.source instanceof type);
	    };
	    return StepDefinition;
	}(StepUpdate));
	exports.StepDefinition = StepDefinition;
	var CommentChange = (function (_super) {
	    __extends(CommentChange, _super);
	    function CommentChange(id, comments) {
	        return _super.call(this, { id: id, comments: comments }) || this;
	    }
	    CommentChange.prototype.apply = function (target) {
	        target.comments = this.source.comments;
	    };
	    CommentChange.prototype.matchesType = function (type) {
	        return (type === structure_1.IntakeStep);
	    };
	    return CommentChange;
	}(StepUpdate));
	exports.CommentChange = CommentChange;
	var DEFAULT_HIGHLIGHT_DURATION = 4000;
	var Focalization = (function (_super) {
	    __extends(Focalization, _super);
	    function Focalization() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Focalization.prototype.apply = function (target) {
	        target.hints = Object.assign({}, target.hints, { highlighted: true });
	        setTimeout(function () { return target.hints.highlighted = false; }, this.source.duration || DEFAULT_HIGHLIGHT_DURATION);
	    };
	    Focalization.prototype.matchesType = function (type) {
	        return (type === structure_1.IntakeStep);
	    };
	    return Focalization;
	}(StepUpdate));
	exports.Focalization = Focalization;
	var ReceivedAnswer = (function (_super) {
	    __extends(ReceivedAnswer, _super);
	    function ReceivedAnswer(answer, transformer) {
	        var _this = _super.call(this, answer) || this;
	        _this.transformer = transformer;
	        return _this;
	    }
	    ReceivedAnswer.prototype.apply = function (target) {
	        target.value = typed_data_1.TypedData.deserialize(Object.assign({}, target, this.source));
	        this.transformer.run(target);
	    };
	    ReceivedAnswer.prototype.matchesType = function (type) {
	        return (type === structure_1.IntakeStep);
	    };
	    return ReceivedAnswer;
	}(StepUpdate));
	exports.ReceivedAnswer = ReceivedAnswer;
	var StepDeactivation = (function (_super) {
	    __extends(StepDeactivation, _super);
	    function StepDeactivation() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StepDeactivation.prototype.apply = function (target) {
	        target.isActive = false;
	    };
	    StepDeactivation.prototype.matchesType = function (type) {
	        return true;
	    };
	    return StepDeactivation;
	}(StepUpdate));
	exports.StepDeactivation = StepDeactivation;
	var GlobalDeactivation = (function (_super) {
	    __extends(GlobalDeactivation, _super);
	    function GlobalDeactivation() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GlobalDeactivation.prototype.matches = function () {
	        return true;
	    };
	    GlobalDeactivation.prototype.apply = function (target) {
	        target.isActive = false;
	    };
	    GlobalDeactivation.prototype.findAndApply = function (target) {
	        var _this = this;
	        target.forEach(function (step) { return _this.apply(step); });
	        return true;
	    };
	    GlobalDeactivation.prototype.getAndApply = function (target) {
	        var _this = this;
	        target.forEach(function (step) { return _this.apply(step); });
	        return true;
	    };
	    GlobalDeactivation.prototype.matchesType = function (type) {
	        return true;
	    };
	    return GlobalDeactivation;
	}(StepUpdate));
	exports.GlobalDeactivation = GlobalDeactivation;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var control_builder_1 = __webpack_require__(699);
	var structure_1 = __webpack_require__(581);
	var autofiller_1 = __webpack_require__(709);
	var categorizer_1 = __webpack_require__(726);
	var developer_step_disabler_1 = __webpack_require__(727);
	var hint_category_extractor_1 = __webpack_require__(728);
	var TransformerService = (function () {
	    function TransformerService(autofiller, categorizer, controlBuilder, devDisabler, hintExtractor) {
	        var _this = this;
	        this.autofiller = autofiller;
	        this.categorizer = categorizer;
	        this.controlBuilder = controlBuilder;
	        this.devDisabler = devDisabler;
	        this.hintExtractor = hintExtractor;
	        this.supportedTypes = [structure_1.IntakeStep, structure_1.ReportStep];
	        this.byType = new Map();
	        this.enabled = [
	            autofiller,
	            categorizer,
	            controlBuilder,
	            devDisabler,
	            hintExtractor
	        ];
	        this.enabled.sort(function (a, b) { return a.order - b.order; });
	        console.info("Available transformers:", this.enabled);
	        this.supportedTypes.forEach(function (type) { return _this.byType.set(type, _this.enabled.filter(function (t) { return t.matchesType(type); })); });
	    }
	    TransformerService.prototype.run = function (step, create) {
	        if (create === void 0) { create = false; }
	        var type = this.supportedTypes.find(function (possible) { return step instanceof possible; });
	        if (type === undefined) {
	            console.error(step);
	            throw new Error("Could not find an appropriate type for step");
	        }
	        var flags = {};
	        this.byType.get(type).forEach(function (t) {
	            Object.assign(flags, (create ? t.create(step) : t.apply(step)));
	        });
	        return flags;
	    };
	    TransformerService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [autofiller_1.Autofiller,
	            categorizer_1.Categorizer,
	            control_builder_1.IntakeControlBuilder,
	            developer_step_disabler_1.DeveloperStepDisabler,
	            hint_category_extractor_1.HintCategoryExtractor])
	    ], TransformerService);
	    return TransformerService;
	}());
	exports.TransformerService = TransformerService;
	exports.STEP_TRANSFORMER_LIST = [
	    autofiller_1.Autofiller,
	    categorizer_1.Categorizer,
	    developer_step_disabler_1.DeveloperStepDisabler,
	    hint_category_extractor_1.HintCategoryExtractor,
	    control_builder_1.IntakeControlBuilder
	];


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var structure_1 = __webpack_require__(581);
	var typed_data_1 = __webpack_require__(69);
	var functions_1 = __webpack_require__(206);
	var validation_builder_1 = __webpack_require__(700);
	var IntakeControlBuilder = (function () {
	    function IntakeControlBuilder() {
	        this.order = 100;
	    }
	    IntakeControlBuilder.prototype.matchesType = function (type) {
	        return type === structure_1.IntakeStep;
	    };
	    IntakeControlBuilder.prototype.create = function (step) {
	        if (step.control instanceof forms_1.AbstractControl) {
	            throw new Error("Create called on step with control!");
	        }
	        if (!typed_data_1.TypedData.applyDefaults(step)) {
	            console.error(step);
	            throw new Error("Could not apply defaults to data");
	        }
	        if (step.cardinality === 1
	            || (step.restrictions.length > 0 && !step.allowsDuplicates)) {
	            this.createSingular(step);
	        }
	        else if (step.cardinality === 0) {
	            this.createVariable(step);
	        }
	        else {
	            this.createPlural(step, step.cardinality);
	        }
	        return { control_created: true };
	    };
	    IntakeControlBuilder.prototype.isDisabled = function (data) {
	        return (data.hints && data.hints.editable === false);
	    };
	    IntakeControlBuilder.prototype.createSingular = function (data) {
	        data.control = new forms_1.FormControl({ value: data.value, disabled: this.isDisabled(data) }, validation_builder_1.ValidationBuilder.for(data));
	    };
	    IntakeControlBuilder.prototype.createVariable = function (data) {
	        if (Array.isArray(data.value) && data.value.length > 0) {
	            return this.createPlural(data, data.value.length);
	        }
	        this.createPlural(data, 1);
	    };
	    IntakeControlBuilder.prototype.createPlural = function (data, size) {
	        var fields = [];
	        var values = data.value || [];
	        var validators = validation_builder_1.ValidationBuilder.for(data);
	        var disabled = this.isDisabled(data);
	        for (var i = 0; i < size; i++) {
	            var value = (values[i] === undefined) ? null : values[i];
	            fields.push(new forms_1.FormControl({ value: value, disabled: disabled }, validators));
	        }
	        data.control = new forms_1.FormArray(fields);
	    };
	    IntakeControlBuilder.prototype.extend = function (data, value, validators) {
	        if (data instanceof structure_1.IntakeStep && !validators) {
	            validators = validation_builder_1.ValidationBuilder.for(data);
	        }
	        if (data.control instanceof forms_1.FormArray) {
	            data.control.push(new forms_1.FormControl(value || null, validators));
	        }
	        else {
	            console.error(data);
	            throw new Error("Can only extend controls backed by FormArray");
	        }
	    };
	    IntakeControlBuilder.prototype.remove = function (data, index) {
	        if (data.control instanceof forms_1.FormArray) {
	            index = index % data.control.length;
	            data.control.removeAt(index);
	        }
	        else {
	            console.error(data);
	            throw new Error("Can only remove fields from a FormArray control");
	        }
	    };
	    IntakeControlBuilder.prototype.apply = function (data) {
	        if (!(data.control instanceof forms_1.AbstractControl)) {
	            console.warn("data has no control", data.control);
	            return {};
	        }
	        var flags = {};
	        if (data.control instanceof forms_1.FormArray) {
	            if (functions_1.valueless(data.value) || data.value.length === 0) {
	                data.value = [null];
	                flags.coerced_null_value = true;
	            }
	            if (!Array.isArray(data.value)) {
	                console.error(data);
	                throw new Error("Cannot apply non-array data to a FormArray!");
	            }
	            if (data.cardinality === 0) {
	                flags.array_resized =
	                    this.autosize(data.control, data.value, data);
	            }
	        }
	        try {
	            data.control.setValue(data.value, { emitEvent: false });
	        }
	        catch (err) {
	            console.error("setValue encountered an array size mismatch!", data, data.value, err);
	            data.control.patchValue(data.value, { emitEvent: false });
	        }
	        if (data.hints._group) {
	            data.hints._group.autosize(true);
	        }
	        return flags;
	    };
	    IntakeControlBuilder.prototype.autosize = function (control, value, data) {
	        var targetSize = Math.max(1, value.length);
	        var delta = targetSize - control.length;
	        while (control.length > targetSize) {
	            this.remove({ control: control }, -1);
	        }
	        while (control.length < targetSize) {
	            this.extend({ control: control });
	        }
	        return delta;
	    };
	    IntakeControlBuilder = __decorate([
	        core_1.Injectable()
	    ], IntakeControlBuilder);
	    return IntakeControlBuilder;
	}());
	exports.IntakeControlBuilder = IntakeControlBuilder;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var validators_1 = __webpack_require__(701);
	var ValidationBuilder = (function () {
	    function ValidationBuilder() {
	    }
	    ValidationBuilder.isMandatory = function (data) {
	        return false;
	    };
	    ValidationBuilder.for = function (data) {
	        var validators = [];
	        if (ValidationBuilder.isMandatory(data)) {
	            validators.push(forms_1.Validators.required);
	        }
	        switch (data.type) {
	            case "natural number":
	                validators.push(validators_1.CustomValidators.nullOr([
	                    validators_1.CustomValidators.integer,
	                    validators_1.CustomValidators.safeInteger,
	                    validators_1.CustomValidators.min(1)
	                ]));
	                break;
	            case "whole number":
	                validators.push(validators_1.CustomValidators.nullOr([
	                    validators_1.CustomValidators.integer,
	                    validators_1.CustomValidators.safeInteger,
	                    validators_1.CustomValidators.min(0)
	                ]));
	                break;
	            case "integer":
	                validators.push(validators_1.CustomValidators.nullOr([
	                    validators_1.CustomValidators.integer,
	                    validators_1.CustomValidators.safeInteger
	                ]));
	                break;
	            case "float":
	                validators.push(validators_1.CustomValidators.nullOr(validators_1.CustomValidators.number));
	                break;
	            default:
	        }
	        if (data.restrictions && data.restrictions.length) {
	            if (data.cardinality === 1 || data.allowsDuplicates) {
	                validators.push(validators_1.CustomValidators.in(data.restrictions.concat(data.value)));
	            }
	            else {
	                validators.push(validators_1.CustomValidators.subset(data.restrictions.concat(data.value)));
	            }
	        }
	        return validators;
	    };
	    ValidationBuilder.forTableColumn = function (data) {
	        return [];
	    };
	    return ValidationBuilder;
	}());
	exports.ValidationBuilder = ValidationBuilder;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Zxcvbn) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	__webpack_require__(702);
	var functions_1 = __webpack_require__(206);
	var CustomValidators = (function () {
	    function CustomValidators() {
	    }
	    CustomValidators.nullOr = function (fn) {
	        if (!Array.isArray(fn)) {
	            fn = [fn];
	        }
	        return function (control) { return ((control.value === null)
	            ? null
	            : forms_1.Validators.compose(fn)(control)); };
	    };
	    CustomValidators.prototype.bubbles = function (fn) {
	        return function (control) {
	            var result = fn(control);
	            if (result) {
	                var errors = control.root.errors;
	                Object.assign(errors, { bubbled: result });
	                control.root.setErrors(errors);
	            }
	            return result;
	        };
	    };
	    CustomValidators.childErrors = function (group) {
	        console.log("Running childErrors");
	        var aggregate = {};
	        var hasErrors = false;
	        for (var _i = 0, _a = Object.values(group.controls); _i < _a.length; _i++) {
	            var control = _a[_i];
	            console.log(control);
	            if (control.errors) {
	                Object.assign(aggregate, control.errors);
	                hasErrors = true;
	            }
	        }
	        return hasErrors ? aggregate : null;
	    };
	    CustomValidators.number = function (control) {
	        return (Number.isFinite(control.value)) ? null : { number: true };
	    };
	    CustomValidators.integer = function (control) {
	        return (Number.isInteger(control.value)) ? null : { integer: true };
	    };
	    CustomValidators.safeInteger = function (control) {
	        if (control.value > Number.MAX_SAFE_INTEGER) {
	            return { safeInteger: "above" };
	        }
	        return ((control.value < Number.MIN_SAFE_INTEGER)
	            ? { safeInteger: "below" }
	            : null);
	    };
	    CustomValidators.requiredList = function (control) {
	        return (control.controls.some(function (c) { return functions_1.inputless(c.value); })
	            ? { requiredList: true }
	            : null);
	    };
	    CustomValidators.onlyLastEmpty = function (control) {
	        return (control.controls.slice(0, -1).some(function (c) { return functions_1.inputless(c.value); })
	            ? { onlyLastEmpty: true }
	            : null);
	    };
	    CustomValidators.noInternalNulls = function (control) {
	        var firstBlank = control.controls.findIndex(function (c) { return functions_1.inputless(c.value); });
	        if (firstBlank === -1) {
	            return null;
	        }
	        return ((control.controls.slice(firstBlank).every(function (c) { return functions_1.inputless(c.value); }))
	            ? null
	            : { noInternalNulls: firstBlank });
	    };
	    CustomValidators.min = function (min) {
	        return function (control) {
	            return (control.value >= min ? null : { min: true });
	        };
	    };
	    CustomValidators.max = function (max) {
	        return function (control) {
	            return (control.value <= max ? null : { max: true });
	        };
	    };
	    CustomValidators.date = function (control) {
	        return (control.value instanceof Date) ? null : { date: true };
	    };
	    CustomValidators.boolean = function (control) {
	        return (typeof control.value === "boolean") ? null : { boolean: true };
	    };
	    CustomValidators.arrayMin = function (min) {
	        return function (control) {
	            return ((Array.isArray(control.value) && control.value.length >= min)
	                ? null
	                : { arrayMin: true });
	        };
	    };
	    CustomValidators.in = function (options) {
	        return function (control) {
	            if (functions_1.valueless(control.value)) {
	                return null;
	            }
	            return (CustomValidators.contains(control.value, options)
	                ? null
	                : { in: options.value });
	        };
	    };
	    CustomValidators.subset = function (options) {
	        return function (control) {
	            if (functions_1.valueless(control.value)) {
	                return null;
	            }
	            if (!Array.isArray(control.value)) {
	                return { subset: "Value is not an array!" };
	            }
	            return (control.value.every(function (value) {
	                return CustomValidators.contains(value, options);
	            })
	                ? null
	                : { subset: false });
	        };
	    };
	    CustomValidators.contains = function (value, options) {
	        if (options.indexOf(value) === -1) {
	            console.error("could not find value in options", value, options);
	            return false;
	        }
	        return true;
	    };
	    CustomValidators.equalsTo = function () {
	        var controls = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            controls[_i] = arguments[_i];
	        }
	        return function (control) {
	            if (controls.length < 1) {
	                throw new Error("You must compare to at least 1 other field");
	            }
	            for (var _i = 0, controls_1 = controls; _i < controls_1.length; _i++) {
	                var compare = controls_1[_i];
	                if (compare.value !== control.value) {
	                    return { equalsTo: { unequalField: compare } };
	                }
	            }
	            return null;
	        };
	    };
	    CustomValidators.zxcvbnMagnitude = function (minimum) {
	        return function (c) {
	            var result = Zxcvbn(c.value);
	            if (result.guesses_log10 < minimum) {
	                return { guessMagnitude: result.guesses_log10 };
	            }
	            return null;
	        };
	    };
	    return CustomValidators;
	}());
	exports.CustomValidators = CustomValidators;
	function anyChildHasError(coll, err) {
	    if (coll instanceof forms_1.FormArray) {
	        return coll.controls.some(function (c) { return c.hasError(err); });
	    }
	    if (coll instanceof forms_1.FormGroup) {
	        return Object.values(coll.controls).some(function (c) { return c.hasError(err); });
	    }
	    return coll.hasError(err);
	}
	exports.anyChildHasError = anyChildHasError;
	function childErrors(coll) {
	    if (coll instanceof forms_1.FormArray) {
	        var errors_1 = {};
	        coll.controls.forEach(function (ctrl, i) {
	            if (ctrl.errors) {
	                errors_1[i] = ctrl.errors;
	            }
	        });
	        return errors_1;
	    }
	    if (coll instanceof forms_1.FormGroup) {
	        var errors_2 = {};
	        Object.entries(coll.controls).forEach(function (_a) {
	            var key = _a[0], ctrl = _a[1];
	            if (ctrl.errors) {
	                errors_2[key] = ctrl.errors;
	            }
	        });
	        return errors_2;
	    }
	    return { this: coll.errors };
	}
	exports.childErrors = childErrors;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(702)))

/***/ }),
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var moment = __webpack_require__(710);
	var user_service_1 = __webpack_require__(713);
	var console_interceptor_1 = __webpack_require__(722);
	var global_error_handler_1 = __webpack_require__(723);
	var navigation_history_service_1 = __webpack_require__(724);
	var messaging_service_1 = __webpack_require__(533);
	var functions_1 = __webpack_require__(206);
	var structure_1 = __webpack_require__(581);
	var step_transformer_1 = __webpack_require__(725);
	var Autofiller = (function (_super) {
	    __extends(Autofiller, _super);
	    function Autofiller(messaging, navHistory, handler, users) {
	        var _this = _super.call(this) || this;
	        _this.messaging = messaging;
	        _this.navHistory = navHistory;
	        _this.handler = handler;
	        _this.users = users;
	        _this.order = 30;
	        return _this;
	    }
	    Autofiller.prototype.matchesType = function (type) {
	        return type === structure_1.IntakeStep;
	    };
	    Autofiller.prototype.apply = function (step) {
	        var _this = this;
	        var flags = {};
	        if (step.hints && step.hints.autofill) {
	            if (this.validateDataShape(step, step.hints.autofill)) {
	                if (this.castToJSON(step.hints.autofill)) {
	                    flags.former_data_type = step.type;
	                    step.type = "json";
	                }
	                if (step.hints.autofillIteratively) {
	                    if (Array.isArray(step.value)) {
	                        step.value.forEach(function (v, i) {
	                            if (functions_1.valueless(v)) {
	                                step.value[i] =
	                                    _this.getData(step.hints.autofill);
	                                flags.autofilled = true;
	                                flags.autofillTarget = step;
	                            }
	                        });
	                    }
	                    else if (functions_1.valueless(step.value)
	                        && step.hints.editable !== false) {
	                        step.value = [this.getData(step.hints.autofill)];
	                        flags.autofilled = true;
	                        flags.autofillTarget = step;
	                    }
	                }
	                else {
	                    if (functions_1.valueless(step.value)) {
	                        step.value = this.getData(step.hints.autofill);
	                        flags.autofilled = true;
	                        flags.autofillTarget = step;
	                    }
	                }
	            }
	        }
	        return flags;
	    };
	    Autofiller.prototype.create = function (step) {
	        return this.apply(step);
	    };
	    Autofiller.prototype.validateDataShape = function (step, source) {
	        var expectedTypes = this.expectedDataTypes(source);
	        if (expectedTypes.indexOf(step.type) === -1) {
	            console.error("Autofill " + source + " expected different types:", expectedTypes, step);
	            return false;
	        }
	        var expectedCardinality = this.expectedCardinality(source);
	        if (step.cardinality !== expectedCardinality) {
	            if (expectedCardinality === 1
	                && this.canIterateScalar(source)) {
	                step.hints.autofillOnExtend = true;
	                step.hints.autofillIteratively = true;
	                return true;
	            }
	            else {
	                console.error("Autofill " + source + " expected different cardinality:", expectedCardinality, step);
	                return false;
	            }
	        }
	        return true;
	    };
	    Autofiller.prototype.expectedDataTypes = function (source) {
	        switch (source) {
	            case "now":
	            case "today":
	                return ["date"];
	            case "UTC-offset":
	                return ["integer"];
	            case "screen-size":
	            case "window-size":
	                return ["whole number"];
	            case "pixel-ratio":
	            case "geolocation":
	                return ["float"];
	            default:
	                if (this.castToJSON(source)) {
	                    return ["json", "string"];
	                }
	                return ["string"];
	        }
	    };
	    Autofiller.prototype.expectedCardinality = function (source) {
	        switch (source) {
	            case "geolocation":
	                return 2;
	            case "screen-size":
	            case "window-size":
	            case "console-history":
	            case "message-history":
	            case "navigation-history":
	                return 0;
	            default:
	                return 1;
	        }
	    };
	    Autofiller.prototype.castToJSON = function (source) {
	        return [
	            "console-history",
	            "stack-trace",
	            "message-history",
	            "navigation-history"
	        ].indexOf(source) > -1;
	    };
	    Autofiller.prototype.canIterateScalar = function (source) {
	        return [
	            "today",
	            "now",
	            "user-name",
	            "organization"
	        ].indexOf(source) > -1;
	    };
	    Autofiller.prototype.getData = function (source) {
	        switch (source) {
	            case "console-history":
	                return console_interceptor_1.CONSOLE_HISTORY.filter(function (_a) {
	                    var e = _a[0], t = _a[1], a = _a[2];
	                    return (e === "warn" || e === "error" || e === "table");
	                }).map(function (c) { return functions_1.jsonify(c, 200, true); });
	            case "stack-trace":
	                if (this.handler instanceof global_error_handler_1.GlobalErrorHandler) {
	                    return functions_1.jsonify(this.handler.lastError, 200, true);
	                }
	                return "Custom error handler not present; trace unknown.";
	            case "message-history":
	                return this.messaging.recentLog.list().map(function (m) { return functions_1.jsonify(m, 200, true); });
	            case "navigation-history":
	                return this.navHistory.getRecent().map(function (n) { return functions_1.jsonify(n, 200, true); });
	            case "user-name":
	                return (this.users.self.name || "UNKNOWN");
	            case "organization":
	                return (this.users.self.org || "UNKNOWN");
	            case "user-agent":
	                return navigator.userAgent;
	            case "client-language":
	                return (navigator.languages[0]
	                    || navigator.language);
	            case "UTC-offset":
	                return (new Date()).getTimezoneOffset();
	            case "IANA-timezone":
	                return moment.tz.guess();
	            case "now":
	                return moment().utc().toDate();
	            case "today":
	                return moment().utc().startOf("day").toDate();
	            case "window-size":
	                return [window.innerHeight, window.innerWidth];
	            case "screen-size":
	                return [window.screen.height, window.screen.width];
	            case "pixel-ratio":
	                return window.devicePixelRatio;
	            case "geolocation":
	                throw new Error("geolocation autofill not yet supported");
	            default:
	                throw new Error("Unknown autofill source \"" + source + "\"");
	        }
	    };
	    Autofiller = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            navigation_history_service_1.NavigationHistoryService,
	            core_1.ErrorHandler,
	            user_service_1.UserService])
	    ], Autofiller);
	    return Autofiller;
	}(step_transformer_1.StepTransformer));
	exports.Autofiller = Autofiller;
	exports.AUTOFILLER = {
	    provide: step_transformer_1.StepTransformer,
	    useClass: Autofiller,
	    multi: true
	};


/***/ }),
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var Rx_1 = __webpack_require__(214);
	var build_flags_1 = __webpack_require__(534);
	var general_1 = __webpack_require__(513);
	var group_management_1 = __webpack_require__(629);
	var metadata_1 = __webpack_require__(637);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var user_1 = __webpack_require__(639);
	var auth_1 = __webpack_require__(535);
	var change_user_active_status_request_1 = __webpack_require__(714);
	var edit_user_request_1 = __webpack_require__(715);
	var create_user_request_1 = __webpack_require__(716);
	var hasher_service_1 = __webpack_require__(717);
	var salter_service_1 = __webpack_require__(719);
	var set_user_group_request_1 = __webpack_require__(720);
	var remove_user_group_request_1 = __webpack_require__(721);
	var UNAUTHENTICATED_USER = new user_1.Self("unauthenticated");
	var UserService = (function () {
	    function UserService(messaging, router, hasher, salter) {
	        var _this = this;
	        this.messaging = messaging;
	        this.router = router;
	        this.hasher = hasher;
	        this.salter = salter;
	        this.self = UNAUTHENTICATED_USER;
	        this.ready = new Rx_1.BehaviorSubject(false);
	        this.subscription = new Rx_1.Subscription();
	        this.languageCodes = [];
	        this.countryCodes = [];
	        this.otherSessions = [];
	        this.messaging.ready.subscribe(function (on) {
	            return on ? _this.connected() : _this.disconnected();
	        });
	    }
	    UserService_1 = UserService;
	    UserService.prototype.connected = function () {
	        var _this = this;
	        this.subscription = this.messaging
	            .receive(general_1.MessageTag.RSP_CFG_USER)
	            .subscribe(function (message) {
	            _this.self = metadata_1.UserConfigurationResponse.CreateUser(message);
	            _this.ready.next(true);
	        });
	        this.subscription.add(this.messaging
	            .receive(general_1.MessageTag.RSP_CFG_ZONE)
	            .subscribe(function (msg) {
	            msg.availableLanguageCodes.forEach(function (_a) {
	                var languageCode = _a.languageCode, id = _a.id;
	                return (_this.languageCodes[id] = languageCode);
	            });
	            msg.availableCountryCodes.forEach(function (_a) {
	                var countryCode = _a.countryCode, id = _a.id;
	                return (_this.countryCodes[id] = countryCode);
	            });
	        }));
	        this.subscription.add(this.messaging
	            .receive(general_1.MessageTag.RSP_ACTIVE_SESSIONS)
	            .subscribe(function (msg) {
	            _this.otherSessions = msg.channels;
	        }));
	    };
	    UserService.prototype.disconnected = function () {
	    };
	    Object.defineProperty(UserService.prototype, "debugMode", {
	        get: function () {
	            return build_flags_1.BuildFlags.debugMode || (this.self && this.self.dev);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    UserService.prototype.undebug = function () {
	        build_flags_1.BuildFlags.debugMode = false;
	        if (this.self) {
	            this.self.dev = false;
	        }
	        console.error("Debug mode has been manually disabled. You must reload to enter again");
	    };
	    UserService.prototype.getGroupUsers = function (group) {
	        var _this = this;
	        var o = this.messaging.converse(new group_management_1.GroupUsersRequest(group.id));
	        return o.map(function (gur) {
	            group.users = gur.resultSet.map(function (uld) {
	                return user_1.User.fromManagementRecord(uld);
	            });
	            var selfIndex = group.users.findIndex(function (u) {
	                return u.login.toLocaleUpperCase() === _this.self.login.toLocaleUpperCase();
	            });
	            if (selfIndex === -1) {
	                console.error("Could not find own entry in users table!");
	            }
	            else {
	                _this.self.managementId = group.users[selfIndex].managementId;
	                group.users[selfIndex] = _this.self;
	            }
	            console.log("RUNNING HERE");
	            console.log(group);
	            return group;
	        });
	    };
	    UserService.prototype.requestUserDetails = function (user) {
	        var _this = this;
	        var o = this.messaging.converse(new group_management_1.UserRequest(user.managementId));
	        o.subscribe(function (rsp) {
	            console.log(rsp);
	            user.extendWithUserResponse(rsp, _this.languageCodes, _this.countryCodes);
	        });
	        return o.map(function () { return true; });
	    };
	    UserService.prototype.requestUserCreate = function (login, password, name, phone, countryCodeIndex, languageCodeIndex, group, groupRules, zoneRules) {
	        var groups = [
	            {
	                groupId: group.id,
	                rules: groupRules,
	            },
	        ];
	        var zones = this.self.zones.map(function (zoneData) {
	            var zoneMap = {
	                zoneId: zoneData.zoneId,
	                rules: zoneRules,
	            };
	            return zoneMap;
	        });
	        var o = this.messaging.converse(new create_user_request_1.CreateUserRequest(login, this.hasher.hexOf(this.salter.salt(password)), name, phone, countryCodeIndex, languageCodeIndex, groups, zones));
	        return o;
	    };
	    UserService.prototype.requestUserActiveStatusChange = function (group, user, isActive) {
	        var groupActiveMap = {
	            groupId: group.id,
	            status: isActive,
	        };
	        var message = new change_user_active_status_request_1.ChangeUserActiveStatusRequest(user.managementId, [groupActiveMap]);
	        var o = this.messaging.converse(message);
	        return o;
	    };
	    UserService.prototype.requestUserEditRequest = function (name, phone, countryCodeID, languageCodeID) {
	        var o = this.messaging.converse(new edit_user_request_1.EditUserRequest(name, phone, this.countryCodes[countryCodeID], this.languageCodes[languageCodeID]));
	        return o;
	    };
	    UserService.prototype.requestOtherUserEditRequest = function (objectId, name, phone, countryCodeID, languageCodeID) {
	        var o = this.messaging.converse(new edit_user_request_1.EditOtherUserRequest(objectId, name, phone, this.countryCodes[countryCodeID], this.languageCodes[languageCodeID]));
	        return o;
	    };
	    UserService.prototype.requestAddUserToGroupRequest = function (objectId, group, groupRules) {
	        var o = this.messaging.converse(new set_user_group_request_1.SetUserGroupsRequest([{
	                groupId: group.id,
	                rules: groupRules
	            }], objectId));
	        return o;
	    };
	    UserService.prototype.requestRemoveUserGroupsRequest = function (objectId, groups) {
	        var o = this.messaging.converse(new remove_user_group_request_1.RemoveUserGroupsRequest(groups, objectId));
	        return o;
	    };
	    UserService.prototype.killAllSessions = function (includeSelf) {
	        return this.messaging.send(new auth_1.TerminateActiveSessionsRequest(includeSelf));
	    };
	    UserService.prototype.getIPCommonName = function (ipAddress) {
	        for (var _i = 0, _a = UserService_1.KnownIPs; _i < _a.length; _i++) {
	            var pair = _a[_i];
	            if (pair[0].test(ipAddress)) {
	                return pair[1];
	            }
	        }
	        return "unknown location";
	    };
	    var UserService_1;
	    UserService.KnownIPs = [
	        [/127\.0\.0\.1/, "localhost"],
	        [/24\.196\.96\.13\d/, "ABC Madison office"],
	        [/72\.201\.25\.\d{1,3}/, "known remote: rlavigne"],
	        [/67\.149\.\d{1,3}\.\d{1,3}/, "known remote: tdsmith"],
	    ];
	    __decorate([
	        decorators_1.disconnectValue(UNAUTHENTICATED_USER),
	        __metadata("design:type", user_1.Self)
	    ], UserService.prototype, "self", void 0);
	    __decorate([
	        decorators_1.disconnectWith("next", false),
	        __metadata("design:type", Rx_1.BehaviorSubject)
	    ], UserService.prototype, "ready", void 0);
	    __decorate([
	        decorators_1.disconnectWith("unsubscribe"),
	        __metadata("design:type", Rx_1.Subscription)
	    ], UserService.prototype, "subscription", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], UserService.prototype, "languageCodes", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], UserService.prototype, "countryCodes", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], UserService.prototype, "otherSessions", void 0);
	    UserService = UserService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            router_1.Router,
	            hasher_service_1.Hasher,
	            salter_service_1.Salter])
	    ], UserService);
	    return UserService;
	}());
	exports.UserService = UserService;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var GroupActiveMap = (function () {
	    function GroupActiveMap() {
	    }
	    return GroupActiveMap;
	}());
	exports.GroupActiveMap = GroupActiveMap;
	var ChangeUserActiveStatusRequest = (function (_super) {
	    __extends(ChangeUserActiveStatusRequest, _super);
	    function ChangeUserActiveStatusRequest(recordId, groups) {
	        var _this = _super.call(this) || this;
	        _this.recordId = recordId;
	        _this.groups = groups;
	        _this.tag = message_tag_1.MessageTag.REQ_CHANGE_USER_ACTIVE_STATUS;
	        return _this;
	    }
	    ChangeUserActiveStatusRequest.tag = message_tag_1.MessageTag.REQ_CHANGE_USER_ACTIVE_STATUS;
	    return ChangeUserActiveStatusRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.ChangeUserActiveStatusRequest = ChangeUserActiveStatusRequest;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var EditUserRequest = (function (_super) {
	    __extends(EditUserRequest, _super);
	    function EditUserRequest(name, phone, country, language) {
	        var _this = _super.call(this) || this;
	        _this.name = name;
	        _this.phone = phone;
	        _this.country = country;
	        _this.language = language;
	        _this.tag = general_1.MessageTag.REQ_EDIT_USER;
	        return _this;
	    }
	    EditUserRequest.tag = general_1.MessageTag.REQ_EDIT_USER;
	    return EditUserRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.EditUserRequest = EditUserRequest;
	var EditOtherUserRequest = (function (_super) {
	    __extends(EditOtherUserRequest, _super);
	    function EditOtherUserRequest(objectId, name, phone, country, language) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.name = name;
	        _this.phone = phone;
	        _this.country = country;
	        _this.language = language;
	        _this.tag = general_1.MessageTag.REQ_EDIT_OTHER_USER;
	        return _this;
	    }
	    EditOtherUserRequest.tag = general_1.MessageTag.REQ_EDIT_OTHER_USER;
	    return EditOtherUserRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.EditOtherUserRequest = EditOtherUserRequest;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var CreateUserRequest = (function (_super) {
	    __extends(CreateUserRequest, _super);
	    function CreateUserRequest(login, password, name, phone, countryCodeIndex, languageCodeIndex, groups, zones) {
	        var _this = _super.call(this) || this;
	        _this.login = login;
	        _this.password = password;
	        _this.name = name;
	        _this.phone = phone;
	        _this.countryCodeIndex = countryCodeIndex;
	        _this.languageCodeIndex = languageCodeIndex;
	        _this.groups = groups;
	        _this.zones = zones;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_USER;
	        return _this;
	    }
	    CreateUserRequest.tag = message_tag_1.MessageTag.REQ_CREATE_USER;
	    return CreateUserRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.CreateUserRequest = CreateUserRequest;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jsSHA) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var configuration_service_1 = __webpack_require__(512);
	__webpack_require__(718);
	var Hasher = (function () {
	    function Hasher(config) {
	        this.config = config;
	        this.library = jsSHA;
	        this.algorithm = this.config.protocol.hashAlgorithm;
	    }
	    Hasher.prototype.encode_utf8 = function (s) {
	        return decodeURI(encodeURIComponent(s));
	    };
	    Hasher.prototype.hexOf = function (plaintext, inputType) {
	        if (inputType === void 0) { inputType = "ARRAYBUFFER"; }
	        var hash = new this.library(this.algorithm, inputType);
	        var byteArray = (new TextEncoder()).encode(plaintext);
	        hash.update(byteArray);
	        return hash.getHash("HEX").toUpperCase();
	    };
	    Hasher = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService])
	    ], Hasher);
	    return Hasher;
	}());
	exports.Hasher = Hasher;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(718)))

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 A JavaScript implementation of the SHA family of hashes, as
	 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
	 HMAC implementation as defined in FIPS PUB 198a
	
	 Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
	 Distributed under the BSD License
	 See http://caligatio.github.com/jsSHA/ for more information
	*/
	'use strict';(function(aa){function C(d,b,a){var h=0,k=[],m=0,g,l,c,f,n,q,u,r,I=!1,v=[],x=[],t,y=!1,z=!1,w=-1;a=a||{};g=a.encoding||"UTF8";t=a.numRounds||1;if(t!==parseInt(t,10)||1>t)throw Error("numRounds must a integer >= 1");if("SHA-1"===d)n=512,q=K,u=ba,f=160,r=function(b){return b.slice()};else if(0===d.lastIndexOf("SHA-",0))if(q=function(b,h){return L(b,h,d)},u=function(b,h,k,a){var e,f;if("SHA-224"===d||"SHA-256"===d)e=(h+65>>>9<<4)+15,f=16;else if("SHA-384"===d||"SHA-512"===d)e=(h+129>>>10<<
	5)+31,f=32;else throw Error("Unexpected error in SHA-2 implementation");for(;b.length<=e;)b.push(0);b[h>>>5]|=128<<24-h%32;h=h+k;b[e]=h&4294967295;b[e-1]=h/4294967296|0;k=b.length;for(h=0;h<k;h+=f)a=L(b.slice(h,h+f),a,d);if("SHA-224"===d)b=[a[0],a[1],a[2],a[3],a[4],a[5],a[6]];else if("SHA-256"===d)b=a;else if("SHA-384"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,a[4].b,a[5].a,a[5].b];else if("SHA-512"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,
	a[4].b,a[5].a,a[5].b,a[6].a,a[6].b,a[7].a,a[7].b];else throw Error("Unexpected error in SHA-2 implementation");return b},r=function(b){return b.slice()},"SHA-224"===d)n=512,f=224;else if("SHA-256"===d)n=512,f=256;else if("SHA-384"===d)n=1024,f=384;else if("SHA-512"===d)n=1024,f=512;else throw Error("Chosen SHA variant is not supported");else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0)){var F=6;q=D;r=function(b){var d=[],a;for(a=0;5>a;a+=1)d[a]=b[a].slice();return d};w=1;if("SHA3-224"===
	d)n=1152,f=224;else if("SHA3-256"===d)n=1088,f=256;else if("SHA3-384"===d)n=832,f=384;else if("SHA3-512"===d)n=576,f=512;else if("SHAKE128"===d)n=1344,f=-1,F=31,z=!0;else if("SHAKE256"===d)n=1088,f=-1,F=31,z=!0;else throw Error("Chosen SHA variant is not supported");u=function(b,d,a,h,k){a=n;var e=F,f,g=[],m=a>>>5,l=0,c=d>>>5;for(f=0;f<c&&d>=a;f+=m)h=D(b.slice(f,f+m),h),d-=a;b=b.slice(f);for(d%=a;b.length<m;)b.push(0);f=d>>>3;b[f>>2]^=e<<f%4*8;b[m-1]^=2147483648;for(h=D(b,h);32*g.length<k;){b=h[l%
	5][l/5|0];g.push(b.b);if(32*g.length>=k)break;g.push(b.a);l+=1;0===64*l%a&&(D(null,h),l=0)}return g}}else throw Error("Chosen SHA variant is not supported");c=M(b,g,w);l=A(d);this.setHMACKey=function(b,a,k){var e;if(!0===I)throw Error("HMAC key already set");if(!0===y)throw Error("Cannot set HMAC key after calling update");if(!0===z)throw Error("SHAKE is not supported for HMAC");g=(k||{}).encoding||"UTF8";a=M(a,g,w)(b);b=a.binLen;a=a.value;e=n>>>3;k=e/4-1;for(e<b/8&&(a=u(a,b,0,A(d),f));a.length<=
	k;)a.push(0);for(b=0;b<=k;b+=1)v[b]=a[b]^909522486,x[b]=a[b]^1549556828;l=q(v,l);h=n;I=!0};this.update=function(b){var d,a,e,f=0,g=n>>>5;d=c(b,k,m);b=d.binLen;a=d.value;d=b>>>5;for(e=0;e<d;e+=g)f+n<=b&&(l=q(a.slice(e,e+g),l),f+=n);h+=f;k=a.slice(f>>>5);m=b%n;y=!0};this.getHash=function(b,a){var e,g,c,n;if(!0===I)throw Error("Cannot call getHash after setting HMAC key");c=N(a);if(!0===z){if(-1===c.shakeLen)throw Error("shakeLen must be specified in options");f=c.shakeLen}switch(b){case "HEX":e=function(b){return O(b,
	f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{g=new ArrayBuffer(0)}catch(p){throw Error("ARRAYBUFFER not supported by this environment");}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{g=new Uint8Array(0)}catch(p){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}n=u(k.slice(),
	m,h,r(l),f);for(g=1;g<t;g+=1)!0===z&&0!==f%32&&(n[n.length-1]&=16777215>>>24-f%32),n=u(n,f,0,A(d),f);return e(n)};this.getHMAC=function(b,a){var e,g,c,p;if(!1===I)throw Error("Cannot call getHMAC without first setting HMAC key");c=N(a);switch(b){case "HEX":e=function(b){return O(b,f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{e=new ArrayBuffer(0)}catch(v){throw Error("ARRAYBUFFER not supported by this environment");
	}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{e=new Uint8Array(0)}catch(v){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}g=u(k.slice(),m,h,r(l),f);p=q(x,A(d));p=u(g,f,n,p,f);return e(p)}}function a(d,b){this.a=d;this.b=b}function T(d,b,a,h){var k,m,g,l,c;b=b||[0];a=a||0;m=a>>>3;c=-1===h?3:0;for(k=0;k<d.length;k+=1)l=k+m,g=l>>>2,b.length<=g&&b.push(0),
	b[g]|=d[k]<<8*(c+l%4*h);return{value:b,binLen:8*d.length+a}}function O(a,b,e,h){var k="";b/=8;var m,g,c;c=-1===e?3:0;for(m=0;m<b;m+=1)g=a[m>>>2]>>>8*(c+m%4*e),k+="0123456789abcdef".charAt(g>>>4&15)+"0123456789abcdef".charAt(g&15);return h.outputUpper?k.toUpperCase():k}function P(a,b,e,h){var k="",m=b/8,g,c,p,f;f=-1===e?3:0;for(g=0;g<m;g+=3)for(c=g+1<m?a[g+1>>>2]:0,p=g+2<m?a[g+2>>>2]:0,p=(a[g>>>2]>>>8*(f+g%4*e)&255)<<16|(c>>>8*(f+(g+1)%4*e)&255)<<8|p>>>8*(f+(g+2)%4*e)&255,c=0;4>c;c+=1)8*g+6*c<=b?k+=
	"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(p>>>6*(3-c)&63):k+=h.b64Pad;return k}function Q(a,b,e){var h="";b/=8;var k,c,g;g=-1===e?3:0;for(k=0;k<b;k+=1)c=a[k>>>2]>>>8*(g+k%4*e)&255,h+=String.fromCharCode(c);return h}function R(a,b,e){b/=8;var h,k=new ArrayBuffer(b),c,g;g=new Uint8Array(k);c=-1===e?3:0;for(h=0;h<b;h+=1)g[h]=a[h>>>2]>>>8*(c+h%4*e)&255;return k}function S(a,b,e){b/=8;var h,k=new Uint8Array(b),c;c=-1===e?3:0;for(h=0;h<b;h+=1)k[h]=a[h>>>2]>>>8*(c+h%4*e)&
	255;return k}function N(a){var b={outputUpper:!1,b64Pad:"=",shakeLen:-1};a=a||{};b.outputUpper=a.outputUpper||!1;!0===a.hasOwnProperty("b64Pad")&&(b.b64Pad=a.b64Pad);if(!0===a.hasOwnProperty("shakeLen")){if(0!==a.shakeLen%8)throw Error("shakeLen must be a multiple of 8");b.shakeLen=a.shakeLen}if("boolean"!==typeof b.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!==typeof b.b64Pad)throw Error("Invalid b64Pad formatting option");return b}function M(a,b,e){switch(b){case "UTF8":case "UTF16BE":case "UTF16LE":break;
	default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");}switch(a){case "HEX":a=function(b,a,d){var g=b.length,c,p,f,n,q,u;if(0!==g%2)throw Error("String of HEX type must be in byte increments");a=a||[0];d=d||0;q=d>>>3;u=-1===e?3:0;for(c=0;c<g;c+=2){p=parseInt(b.substr(c,2),16);if(isNaN(p))throw Error("String of HEX type contains invalid characters");n=(c>>>1)+q;for(f=n>>>2;a.length<=f;)a.push(0);a[f]|=p<<8*(u+n%4*e)}return{value:a,binLen:4*g+d}};break;case "TEXT":a=function(a,d,c){var g,
	l,p=0,f,n,q,u,r,t;d=d||[0];c=c||0;q=c>>>3;if("UTF8"===b)for(t=-1===e?3:0,f=0;f<a.length;f+=1)for(g=a.charCodeAt(f),l=[],128>g?l.push(g):2048>g?(l.push(192|g>>>6),l.push(128|g&63)):55296>g||57344<=g?l.push(224|g>>>12,128|g>>>6&63,128|g&63):(f+=1,g=65536+((g&1023)<<10|a.charCodeAt(f)&1023),l.push(240|g>>>18,128|g>>>12&63,128|g>>>6&63,128|g&63)),n=0;n<l.length;n+=1){r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=l[n]<<8*(t+r%4*e);p+=1}else if("UTF16BE"===b||"UTF16LE"===b)for(t=-1===e?2:0,l="UTF16LE"===
	b&&1!==e||"UTF16LE"!==b&&1===e,f=0;f<a.length;f+=1){g=a.charCodeAt(f);!0===l&&(n=g&255,g=n<<8|g>>>8);r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=g<<8*(t+r%4*e);p+=2}return{value:d,binLen:8*p+c}};break;case "B64":a=function(b,a,d){var c=0,l,p,f,n,q,u,r,t;if(-1===b.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");p=b.indexOf("=");b=b.replace(/\=/g,"");if(-1!==p&&p<b.length)throw Error("Invalid '=' found in base-64 string");a=a||[0];d=d||0;u=d>>>3;t=-1===e?3:0;for(p=
	0;p<b.length;p+=4){q=b.substr(p,4);for(f=n=0;f<q.length;f+=1)l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q.charAt(f)),n|=l<<18-6*f;for(f=0;f<q.length-1;f+=1){r=c+u;for(l=r>>>2;a.length<=l;)a.push(0);a[l]|=(n>>>16-8*f&255)<<8*(t+r%4*e);c+=1}}return{value:a,binLen:8*c+d}};break;case "BYTES":a=function(b,a,d){var c,l,p,f,n,q;a=a||[0];d=d||0;p=d>>>3;q=-1===e?3:0;for(l=0;l<b.length;l+=1)c=b.charCodeAt(l),n=l+p,f=n>>>2,a.length<=f&&a.push(0),a[f]|=c<<8*(q+n%4*e);return{value:a,
	binLen:8*b.length+d}};break;case "ARRAYBUFFER":try{a=new ArrayBuffer(0)}catch(h){throw Error("ARRAYBUFFER not supported by this environment");}a=function(b,a,d){return T(new Uint8Array(b),a,d,e)};break;case "UINT8ARRAY":try{a=new Uint8Array(0)}catch(h){throw Error("UINT8ARRAY not supported by this environment");}a=function(b,a,d){return T(b,a,d,e)};break;default:throw Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}return a}function y(a,b){return a<<b|a>>>32-b}function U(d,
	b){return 32<b?(b-=32,new a(d.b<<b|d.a>>>32-b,d.a<<b|d.b>>>32-b)):0!==b?new a(d.a<<b|d.b>>>32-b,d.b<<b|d.a>>>32-b):d}function x(a,b){return a>>>b|a<<32-b}function t(d,b){var e=null,e=new a(d.a,d.b);return e=32>=b?new a(e.a>>>b|e.b<<32-b&4294967295,e.b>>>b|e.a<<32-b&4294967295):new a(e.b>>>b-32|e.a<<64-b&4294967295,e.a>>>b-32|e.b<<64-b&4294967295)}function V(d,b){var e=null;return e=32>=b?new a(d.a>>>b,d.b>>>b|d.a<<32-b&4294967295):new a(0,d.a>>>b-32)}function ca(a,b,e){return a&b^~a&e}function da(d,
	b,e){return new a(d.a&b.a^~d.a&e.a,d.b&b.b^~d.b&e.b)}function W(a,b,e){return a&b^a&e^b&e}function ea(d,b,e){return new a(d.a&b.a^d.a&e.a^b.a&e.a,d.b&b.b^d.b&e.b^b.b&e.b)}function fa(a){return x(a,2)^x(a,13)^x(a,22)}function ga(d){var b=t(d,28),e=t(d,34);d=t(d,39);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ha(a){return x(a,6)^x(a,11)^x(a,25)}function ia(d){var b=t(d,14),e=t(d,18);d=t(d,41);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ja(a){return x(a,7)^x(a,18)^a>>>3}function ka(d){var b=t(d,
	1),e=t(d,8);d=V(d,7);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function la(a){return x(a,17)^x(a,19)^a>>>10}function ma(d){var b=t(d,19),e=t(d,61);d=V(d,6);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function G(a,b){var e=(a&65535)+(b&65535);return((a>>>16)+(b>>>16)+(e>>>16)&65535)<<16|e&65535}function na(a,b,e,h){var c=(a&65535)+(b&65535)+(e&65535)+(h&65535);return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)&65535)<<16|c&65535}function H(a,b,e,h,c){var m=(a&65535)+(b&65535)+(e&65535)+(h&65535)+(c&65535);
	return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)+(m>>>16)&65535)<<16|m&65535}function oa(d,b){var e,h,c;e=(d.b&65535)+(b.b&65535);h=(d.b>>>16)+(b.b>>>16)+(e>>>16);c=(h&65535)<<16|e&65535;e=(d.a&65535)+(b.a&65535)+(h>>>16);h=(d.a>>>16)+(b.a>>>16)+(e>>>16);return new a((h&65535)<<16|e&65535,c)}function pa(d,b,e,h){var c,m,g;c=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535);m=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c>>>16);g=(m&65535)<<16|c&65535;c=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+
	(m>>>16);m=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c>>>16);return new a((m&65535)<<16|c&65535,g)}function qa(d,b,e,h,c){var m,g,l;m=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535)+(c.b&65535);g=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c.b>>>16)+(m>>>16);l=(g&65535)<<16|m&65535;m=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+(c.a&65535)+(g>>>16);g=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c.a>>>16)+(m>>>16);return new a((g&65535)<<16|m&65535,l)}function B(d,b){return new a(d.a^b.a,d.b^
	b.b)}function A(d){var b=[],e;if("SHA-1"===d)b=[1732584193,4023233417,2562383102,271733878,3285377520];else if(0===d.lastIndexOf("SHA-",0))switch(b=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],e=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],d){case "SHA-224":break;case "SHA-256":b=e;break;case "SHA-384":b=[new a(3418070365,b[0]),new a(1654270250,b[1]),new a(2438529370,b[2]),new a(355462360,b[3]),new a(1731405415,
	b[4]),new a(41048885895,b[5]),new a(3675008525,b[6]),new a(1203062813,b[7])];break;case "SHA-512":b=[new a(e[0],4089235720),new a(e[1],2227873595),new a(e[2],4271175723),new a(e[3],1595750129),new a(e[4],2917565137),new a(e[5],725511199),new a(e[6],4215389547),new a(e[7],327033209)];break;default:throw Error("Unknown SHA variant");}else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0))for(d=0;5>d;d+=1)b[d]=[new a(0,0),new a(0,0),new a(0,0),new a(0,0),new a(0,0)];else throw Error("No SHA variants supported");
	return b}function K(a,b){var e=[],h,c,m,g,l,p,f;h=b[0];c=b[1];m=b[2];g=b[3];l=b[4];for(f=0;80>f;f+=1)e[f]=16>f?a[f]:y(e[f-3]^e[f-8]^e[f-14]^e[f-16],1),p=20>f?H(y(h,5),c&m^~c&g,l,1518500249,e[f]):40>f?H(y(h,5),c^m^g,l,1859775393,e[f]):60>f?H(y(h,5),W(c,m,g),l,2400959708,e[f]):H(y(h,5),c^m^g,l,3395469782,e[f]),l=g,g=m,m=y(c,30),c=h,h=p;b[0]=G(h,b[0]);b[1]=G(c,b[1]);b[2]=G(m,b[2]);b[3]=G(g,b[3]);b[4]=G(l,b[4]);return b}function ba(a,b,e,c){var k;for(k=(b+65>>>9<<4)+15;a.length<=k;)a.push(0);a[b>>>5]|=
	128<<24-b%32;b+=e;a[k]=b&4294967295;a[k-1]=b/4294967296|0;b=a.length;for(k=0;k<b;k+=16)c=K(a.slice(k,k+16),c);return c}function L(d,b,e){var h,k,m,g,l,p,f,n,q,u,r,t,v,x,y,A,z,w,F,B,C,D,E=[],J;if("SHA-224"===e||"SHA-256"===e)u=64,t=1,D=Number,v=G,x=na,y=H,A=ja,z=la,w=fa,F=ha,C=W,B=ca,J=c;else if("SHA-384"===e||"SHA-512"===e)u=80,t=2,D=a,v=oa,x=pa,y=qa,A=ka,z=ma,w=ga,F=ia,C=ea,B=da,J=X;else throw Error("Unexpected error in SHA-2 implementation");e=b[0];h=b[1];k=b[2];m=b[3];g=b[4];l=b[5];p=b[6];f=b[7];
	for(r=0;r<u;r+=1)16>r?(q=r*t,n=d.length<=q?0:d[q],q=d.length<=q+1?0:d[q+1],E[r]=new D(n,q)):E[r]=x(z(E[r-2]),E[r-7],A(E[r-15]),E[r-16]),n=y(f,F(g),B(g,l,p),J[r],E[r]),q=v(w(e),C(e,h,k)),f=p,p=l,l=g,g=v(m,n),m=k,k=h,h=e,e=v(n,q);b[0]=v(e,b[0]);b[1]=v(h,b[1]);b[2]=v(k,b[2]);b[3]=v(m,b[3]);b[4]=v(g,b[4]);b[5]=v(l,b[5]);b[6]=v(p,b[6]);b[7]=v(f,b[7]);return b}function D(d,b){var e,c,k,m,g=[],l=[];if(null!==d)for(c=0;c<d.length;c+=2)b[(c>>>1)%5][(c>>>1)/5|0]=B(b[(c>>>1)%5][(c>>>1)/5|0],new a(d[c+1],d[c]));
	for(e=0;24>e;e+=1){m=A("SHA3-");for(c=0;5>c;c+=1){k=b[c][0];var p=b[c][1],f=b[c][2],n=b[c][3],q=b[c][4];g[c]=new a(k.a^p.a^f.a^n.a^q.a,k.b^p.b^f.b^n.b^q.b)}for(c=0;5>c;c+=1)l[c]=B(g[(c+4)%5],U(g[(c+1)%5],1));for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(b[c][k],l[c]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)m[k][(2*c+3*k)%5]=U(b[c][k],Y[c][k]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(m[c][k],new a(~m[(c+1)%5][k].a&m[(c+2)%5][k].a,~m[(c+1)%5][k].b&m[(c+2)%5][k].b));b[0][0]=B(b[0][0],Z[e])}return b}var c,
	X,Y,Z;c=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];X=[new a(c[0],3609767458),new a(c[1],602891725),new a(c[2],3964484399),new a(c[3],2173295548),new a(c[4],4081628472),new a(c[5],3053834265),new a(c[6],2937671579),new a(c[7],3664609560),new a(c[8],2734883394),new a(c[9],1164996542),new a(c[10],1323610764),new a(c[11],3590304994),new a(c[12],4068182383),new a(c[13],
	991336113),new a(c[14],633803317),new a(c[15],3479774868),new a(c[16],2666613458),new a(c[17],944711139),new a(c[18],2341262773),new a(c[19],2007800933),new a(c[20],1495990901),new a(c[21],1856431235),new a(c[22],3175218132),new a(c[23],2198950837),new a(c[24],3999719339),new a(c[25],766784016),new a(c[26],2566594879),new a(c[27],3203337956),new a(c[28],1034457026),new a(c[29],2466948901),new a(c[30],3758326383),new a(c[31],168717936),new a(c[32],1188179964),new a(c[33],1546045734),new a(c[34],1522805485),
	new a(c[35],2643833823),new a(c[36],2343527390),new a(c[37],1014477480),new a(c[38],1206759142),new a(c[39],344077627),new a(c[40],1290863460),new a(c[41],3158454273),new a(c[42],3505952657),new a(c[43],106217008),new a(c[44],3606008344),new a(c[45],1432725776),new a(c[46],1467031594),new a(c[47],851169720),new a(c[48],3100823752),new a(c[49],1363258195),new a(c[50],3750685593),new a(c[51],3785050280),new a(c[52],3318307427),new a(c[53],3812723403),new a(c[54],2003034995),new a(c[55],3602036899),
	new a(c[56],1575990012),new a(c[57],1125592928),new a(c[58],2716904306),new a(c[59],442776044),new a(c[60],593698344),new a(c[61],3733110249),new a(c[62],2999351573),new a(c[63],3815920427),new a(3391569614,3928383900),new a(3515267271,566280711),new a(3940187606,3454069534),new a(4118630271,4000239992),new a(116418474,1914138554),new a(174292421,2731055270),new a(289380356,3203993006),new a(460393269,320620315),new a(685471733,587496836),new a(852142971,1086792851),new a(1017036298,365543100),new a(1126000580,
	2618297676),new a(1288033470,3409855158),new a(1501505948,4234509866),new a(1607167915,987167468),new a(1816402316,1246189591)];Z=[new a(0,1),new a(0,32898),new a(2147483648,32906),new a(2147483648,2147516416),new a(0,32907),new a(0,2147483649),new a(2147483648,2147516545),new a(2147483648,32777),new a(0,138),new a(0,136),new a(0,2147516425),new a(0,2147483658),new a(0,2147516555),new a(2147483648,139),new a(2147483648,32905),new a(2147483648,32771),new a(2147483648,32770),new a(2147483648,128),new a(0,
	32778),new a(2147483648,2147483658),new a(2147483648,2147516545),new a(2147483648,32896),new a(0,2147483649),new a(2147483648,2147516424)];Y=[[0,36,3,41,18],[1,44,10,45,2],[62,6,43,15,61],[28,55,25,21,56],[27,20,39,8,14]]; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return C}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof exports?("undefined"!==typeof module&&module.exports&&(module.exports=C),exports=C):aa.jsSHA=C})(this);


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var configuration_service_1 = __webpack_require__(512);
	var Salter = (function () {
	    function Salter(config) {
	        this.config = config;
	    }
	    Salter.prototype.decryptXOR = function (startByte, remaining) {
	        return new Int8Array(remaining).map(function (value, index) {
	            var output = value ^ startByte;
	            startByte = value;
	            return output;
	        });
	    };
	    Salter.prototype.buildSaltString = function (saltNums) {
	        if (!saltNums) {
	            console.warn(this.config.protocol);
	            throw new Error("Cannot build salt string, no salt defined!");
	        }
	        var startByte = 0xb7;
	        var saltBytes = this.decryptXOR(startByte, saltNums);
	        return saltBytes.reduce(function (prev, current) { return prev + String.fromCharCode(current); }, "");
	    };
	    Salter.prototype.salt = function (plaintext) {
	        return this.buildSaltString(this.config.protocol.applicationSalt)
	            + plaintext;
	    };
	    Salter = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService])
	    ], Salter);
	    return Salter;
	}());
	exports.Salter = Salter;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var SetUserGroupsRequest = (function (_super) {
	    __extends(SetUserGroupsRequest, _super);
	    function SetUserGroupsRequest(groups, objectId) {
	        var _this = _super.call(this) || this;
	        _this.groups = groups;
	        _this.objectId = objectId;
	        _this.tag = general_1.MessageTag.REQ_SET_USER_GROUPS;
	        return _this;
	    }
	    SetUserGroupsRequest.tag = general_1.MessageTag.REQ_SET_USER_GROUPS;
	    return SetUserGroupsRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.SetUserGroupsRequest = SetUserGroupsRequest;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var RemoveUserGroupsRequest = (function (_super) {
	    __extends(RemoveUserGroupsRequest, _super);
	    function RemoveUserGroupsRequest(groups, objectId) {
	        var _this = _super.call(this) || this;
	        _this.groups = groups;
	        _this.objectId = objectId;
	        _this.tag = general_1.MessageTag.REQ_REMOVE_USER_GROUPS;
	        return _this;
	    }
	    RemoveUserGroupsRequest.tag = general_1.MessageTag.REQ_REMOVE_USER_GROUPS;
	    return RemoveUserGroupsRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.RemoveUserGroupsRequest = RemoveUserGroupsRequest;


/***/ }),
/* 722 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var browserConsole = console;
	exports.CONSOLE_HISTORY = [];
	var HISTORY_LIMIT = 100;
	function consoleOp(type, args) {
	    exports.CONSOLE_HISTORY.push([type, Date.now(), args]);
	    if (exports.CONSOLE_HISTORY.length > HISTORY_LIMIT) {
	        exports.CONSOLE_HISTORY.shift();
	    }
	    browserConsole[type]
	        .apply(browserConsole, args);
	}
	function boundConsoleFunction(name) {
	    if (name in browserConsole) {
	        return browserConsole[name].bind(browserConsole);
	    }
	    return function () { return null; };
	}
	console = {
	    assert: boundConsoleFunction("assert"),
	    count: boundConsoleFunction("count"),
	    countReset: boundConsoleFunction("countReset"),
	    debug: boundConsoleFunction("debug"),
	    dir: boundConsoleFunction("dir"),
	    dirxml: boundConsoleFunction("dirxml"),
	    exception: boundConsoleFunction("exception"),
	    group: boundConsoleFunction("group"),
	    groupCollapsed: boundConsoleFunction("groupCollapsed"),
	    groupEnd: boundConsoleFunction("groupEnd"),
	    markTimeline: boundConsoleFunction("markTimeline"),
	    profile: boundConsoleFunction("profile"),
	    profileEnd: boundConsoleFunction("profileEnd"),
	    select: boundConsoleFunction("select"),
	    time: boundConsoleFunction("time"),
	    timeEnd: boundConsoleFunction("timeEnd"),
	    timeStamp: boundConsoleFunction("timeStamp"),
	    timeline: boundConsoleFunction("timeline"),
	    timelineEnd: boundConsoleFunction("timelineEnd"),
	    trace: boundConsoleFunction("trace"),
	    msIsIndependentlyComposed: function () { return false; },
	    memory: browserConsole.memory,
	    clear: function () {
	        consoleOp("clear", Array.from(arguments));
	    },
	    log: function (message) {
	        var optionalParams = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            optionalParams[_i - 1] = arguments[_i];
	        }
	        consoleOp("log", Array.from(arguments));
	    },
	    warn: function (message) {
	        var optionalParams = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            optionalParams[_i - 1] = arguments[_i];
	        }
	        consoleOp("warn", Array.from(arguments));
	    },
	    error: function (message) {
	        var optionalParams = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            optionalParams[_i - 1] = arguments[_i];
	        }
	        consoleOp("error", Array.from(arguments));
	    },
	    info: function (message) {
	        var optionalParams = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            optionalParams[_i - 1] = arguments[_i];
	        }
	        consoleOp("info", Array.from(arguments));
	    },
	    table: function () {
	        var data = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            data[_i] = arguments[_i];
	        }
	        consoleOp("table", Array.from(arguments));
	    },
	    Console: browserConsole.Console,
	};


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var ring_buffer_1 = __webpack_require__(693);
	var GlobalErrorHandler = (function () {
	    function GlobalErrorHandler(rethrow) {
	        if (rethrow === void 0) { rethrow = false; }
	        this.recentErrors = new ring_buffer_1.RingBuffer(5);
	        this.lastError = null;
	        this.rethrow = rethrow;
	    }
	    GlobalErrorHandler.prototype.handleError = function (error) {
	        this.recentErrors.add(error);
	        this.lastError = error;
	        error = this.unwrap(error);
	        console.error(error);
	        if (error.stack) {
	            console.error(error.stack);
	        }
	        if (this.rethrow) {
	            throw error;
	        }
	    };
	    GlobalErrorHandler.prototype.unwrap = function (error) {
	        while (error.originalError && typeof error.originalError === "object") {
	            error = error.originalError;
	        }
	        return error;
	    };
	    GlobalErrorHandler = __decorate([
	        __param(0, core_1.Optional()),
	        __metadata("design:paramtypes", [Boolean])
	    ], GlobalErrorHandler);
	    return GlobalErrorHandler;
	}());
	exports.GlobalErrorHandler = GlobalErrorHandler;
	exports.CUSTOM_ERROR_HANDLER = {
	    provide: core_1.ErrorHandler,
	    useClass: GlobalErrorHandler
	};


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var ring_buffer_1 = __webpack_require__(693);
	var ROUTER_HISTORY_SIZE = 20;
	var NavigationHistoryService = (function () {
	    function NavigationHistoryService(router) {
	        var _this = this;
	        this.router = router;
	        this.isLogging = false;
	        this.history = new ring_buffer_1.RingBuffer(ROUTER_HISTORY_SIZE);
	        this.router.events.subscribe(function (e) {
	            e.type = e.constructor.name;
	            _this.history.add(e);
	        });
	    }
	    NavigationHistoryService.prototype.getRecent = function () {
	        console.info(this.history.list());
	        return this.history.list();
	    };
	    NavigationHistoryService.prototype.logAll = function () {
	        if (!this.isLogging) {
	            this.loggingSub = this.router.events.subscribe(function (e) { return console.log(e); });
	            this.isLogging = true;
	        }
	    };
	    NavigationHistoryService.prototype.stopLogging = function () {
	        if (this.isLogging) {
	            this.loggingSub.unsubscribe();
	            this.isLogging = false;
	        }
	    };
	    NavigationHistoryService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router])
	    ], NavigationHistoryService);
	    return NavigationHistoryService;
	}());
	exports.NavigationHistoryService = NavigationHistoryService;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StepTransformer = (function () {
	    function StepTransformer() {
	    }
	    return StepTransformer;
	}());
	exports.StepTransformer = StepTransformer;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var messaging_service_1 = __webpack_require__(533);
	var structure_1 = __webpack_require__(581);
	var step_transformer_1 = __webpack_require__(725);
	var Categorizer = (function (_super) {
	    __extends(Categorizer, _super);
	    function Categorizer(messaging) {
	        var _this = _super.call(this) || this;
	        _this.messaging = messaging;
	        _this.order = 50;
	        _this.categories = [];
	        return _this;
	    }
	    Categorizer.prototype.matchesType = function (type) {
	        return type === structure_1.IntakeStep;
	    };
	    Categorizer.prototype.create = function (step) {
	        var nonHint = step.classifications.filter(function (classification) { return !classification.startsWith("hint"); });
	        if (nonHint.length > 1) {
	            step.hints.category = nonHint[1];
	        }
	        return {};
	    };
	    Categorizer.prototype.apply = function () {
	        return {};
	    };
	    Categorizer = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService])
	    ], Categorizer);
	    return Categorizer;
	}(step_transformer_1.StepTransformer));
	exports.Categorizer = Categorizer;
	exports.CATEGORIZER = {
	    provide: step_transformer_1.StepTransformer,
	    useClass: Categorizer,
	    multi: true
	};


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var user_service_1 = __webpack_require__(713);
	var structure_1 = __webpack_require__(581);
	var step_transformer_1 = __webpack_require__(725);
	var DeveloperStepDisabler = (function (_super) {
	    __extends(DeveloperStepDisabler, _super);
	    function DeveloperStepDisabler(user) {
	        var _this = _super.call(this) || this;
	        _this.user = user;
	        _this.order = 15;
	        return _this;
	    }
	    DeveloperStepDisabler.prototype.matchesType = function (type) {
	        return type === structure_1.IntakeStep;
	    };
	    DeveloperStepDisabler.prototype.create = function (step) {
	        if (step.hints.developer && !this.user.self.dev) {
	            step.hints.editable = false;
	        }
	        return {};
	    };
	    DeveloperStepDisabler.prototype.apply = function () {
	        return {};
	    };
	    DeveloperStepDisabler = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [user_service_1.UserService])
	    ], DeveloperStepDisabler);
	    return DeveloperStepDisabler;
	}(step_transformer_1.StepTransformer));
	exports.DeveloperStepDisabler = DeveloperStepDisabler;
	exports.DEVELOPER_STEP_DISABLER = {
	    provide: step_transformer_1.StepTransformer,
	    useClass: DeveloperStepDisabler,
	    multi: true
	};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var structure_1 = __webpack_require__(581);
	var step_transformer_1 = __webpack_require__(725);
	function assignProp(propName, convert) {
	    if (convert === void 0) { convert = (function (_) { return _; }); }
	    return function (t, param) {
	        t[propName] = convert(param);
	        return t;
	    };
	}
	function valueGetter(propName, convert) {
	    if (convert === void 0) { convert = (function (_) { return _; }); }
	    return { _evaluate: assignProp(propName, convert) };
	}
	var INTAKE_CONVERSION_TABLE = new Map([
	    ["hint-mandatory", { mandatory: true }],
	    ["hint-multiline", { multiline: true }],
	    ["hint-developer", { developer: true }],
	    ["hint-autofill-console-history",
	        { autofill: "console-history", editable: false }],
	    ["hint-autofill-message-history",
	        { autofill: "message-history", editable: false }],
	    ["hint-autofill-navigation-history",
	        { autofill: "navigation-history", editable: false }],
	    ["hint-autofill-stack-trace",
	        { autofill: "stack-trace", editable: false }],
	    ["hint-autofill-user-agent", { autofill: "user-agent", editable: false }],
	    ["hint-autofill-now", { autofill: "now" }],
	    ["hint-autofill-today", { autofill: "today" }],
	    ["hint-autofill-user-name", { autofill: "user-name", editable: false }],
	    ["hint-autofill-organization",
	        { autofill: "organization", editable: false }],
	    ["hint-autofill-window-size", { autofill: "window-size" }],
	    ["hint-autofill-screen-size", { autofill: "screen-size" }],
	    ["hint-autofill-pixel-ratio", { autofill: "pixel-ratio" }],
	    ["hint-table", valueGetter("table")],
	    ["hint-column", valueGetter("column")],
	    ["hint-comment-column", { commentColumn: true }],
	    ["hint-editable", valueGetter("editable", function (v) { return v.toLowerCase() === "true"; })],
	    ["hint-quick-link-bottom", valueGetter("quicklink")],
	    ["hint-table-sort-action", valueGetter("tableSorter")],
	    ["hint-highlight-inequality", valueGetter("highlightDifferenceWith")],
	    ["hint-boolean-submit-button", { useSubmitWithValue: true }],
	    ["hint-special-presentation", valueGetter("specialPresentation")]
	]);
	var REPORT_CONVERSION_TABLE = new Map([
	    ["hint-developer", { developer: true }],
	    ["hint-inline", { inline: true }],
	    ["hint-initially-expanded", { expanded: true }],
	    ["hint-alert", { alert: true }]
	]);
	var HintCategoryExtractor = (function (_super) {
	    __extends(HintCategoryExtractor, _super);
	    function HintCategoryExtractor() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.order = -10;
	        return _this;
	    }
	    HintCategoryExtractor.prototype.matchesType = function (type) {
	        return type === structure_1.IntakeStep || type === structure_1.ReportStep;
	    };
	    HintCategoryExtractor.prototype.create = function (step) {
	        step.classifications = step.classifications || [];
	        step.hints = step.hints || {};
	        var table = ((step instanceof structure_1.IntakeStep)
	            ? INTAKE_CONVERSION_TABLE
	            : REPORT_CONVERSION_TABLE);
	        step.classifications.forEach(function (category) {
	            var _a = category.split("="), label = _a[0], value = _a[1];
	            var hint = table.get(label);
	            if (hint) {
	                if (hint._evaluate) {
	                    hint = Object.assign({}, hint._evaluate(hint, value));
	                    delete hint._evaluate;
	                    if (step.type === "boolean") {
	                        hint.checkbox = true;
	                    }
	                }
	                Object.assign(step.hints, hint);
	            }
	        });
	        return {};
	    };
	    HintCategoryExtractor.prototype.apply = function () {
	        return {};
	    };
	    HintCategoryExtractor = __decorate([
	        core_1.Injectable()
	    ], HintCategoryExtractor);
	    return HintCategoryExtractor;
	}(step_transformer_1.StepTransformer));
	exports.HintCategoryExtractor = HintCategoryExtractor;
	exports.HINT_EXTRACTOR = {
	    provide: step_transformer_1.StepTransformer,
	    useClass: HintCategoryExtractor,
	    multi: true
	};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	exports.CHECKBOX_LIST_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CheckboxListValueAccessor; }),
	    multi: true
	};
	var CheckboxListValueAccessor = (function () {
	    function CheckboxListValueAccessor(renderer, elementRef) {
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        this.arrayRef = [];
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    CheckboxListValueAccessor.prototype.internalChange = function (checked) {
	        var pos = this.arrayRef.indexOf(this.value);
	        if (pos === -1 && checked) {
	            this.arrayRef.push(this.value);
	        }
	        else if (pos > -1 && !checked) {
	            this.arrayRef.splice(pos, 1);
	        }
	        this.onChange(this.arrayRef);
	    };
	    CheckboxListValueAccessor.prototype.setInputValue = function (checked) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "checked", checked);
	    };
	    CheckboxListValueAccessor.prototype.writeValue = function (array) {
	        if (array === null || array === undefined || !Array.isArray(array)) {
	            return this.setInputValue(false);
	        }
	        this.arrayRef = array;
	        var containsThis = (array.indexOf(this.value) > -1);
	        return this.setInputValue(containsThis);
	    };
	    CheckboxListValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    CheckboxListValueAccessor.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    CheckboxListValueAccessor.prototype.setDisabledState = function (isDisabled) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "disabled", isDisabled);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], CheckboxListValueAccessor.prototype, "value", void 0);
	    CheckboxListValueAccessor = __decorate([
	        core_1.Directive({
	            selector: "\n    input[type=checkbox][formControl][dynamicList],\n    input[type=checkbox][formControlName][dynamicList],\n    input[type=checkbox][ngModel][dynamicList]\n",
	            host: {
	                "(change)": "internalChange($event.target.checked)",
	                "(blur)": "onTouched()"
	            },
	            providers: [exports.CHECKBOX_LIST_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.Renderer,
	            core_1.ElementRef])
	    ], CheckboxListValueAccessor);
	    return CheckboxListValueAccessor;
	}());
	exports.CheckboxListValueAccessor = CheckboxListValueAccessor;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var typed_data_1 = __webpack_require__(69);
	exports.DATE_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DateValueAccessor; }),
	    multi: true
	};
	var DateValueAccessor = (function () {
	    function DateValueAccessor(renderer, elementRef) {
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        this.onChange = function (_) {
	        };
	        this.onTouched = function () {
	        };
	    }
	    DateValueAccessor_1 = DateValueAccessor;
	    DateValueAccessor.prototype.reissueAsChange = function (existing) {
	        if (existing.type === "blur") {
	            this.onTouched();
	        }
	        var event = new Event("change", { bubbles: true });
	        event.reissued = true;
	        this.elementRef.nativeElement.dispatchEvent(event);
	    };
	    DateValueAccessor.prototype.filterNative = function (event) {
	        if (!event.reissued) {
	            event.stopPropagation();
	        }
	        else {
	            this.internalChange(event.target.value);
	        }
	    };
	    DateValueAccessor.prototype.internalChange = function (value) {
	        if (typeof value !== "string") {
	            console.error("Date input value error", value);
	            throw new Error("Date input element returned non-string value");
	        }
	        var date = typed_data_1.TypedData.inputToDate(value);
	        if (DateValueAccessor_1.USE_2_DIGIT_FIX
	            && date !== null
	            && !isNaN(date.valueOf())) {
	            var yr = date.getUTCFullYear();
	            if (yr < 100 && yr > 0) {
	                date.setUTCFullYear(this.interpret2DigitYear(yr));
	            }
	        }
	        this.onChange(date);
	    };
	    DateValueAccessor.prototype.interpret2DigitYear = function (year) {
	        var cy = (new Date()).getUTCFullYear();
	        var current2Digit = cy % 100;
	        var currentCentury = Math.floor(cy / 100) * 100;
	        if (year < current2Digit + DateValueAccessor_1.CENTURY_TOLERANCE) {
	            return currentCentury + year;
	        }
	        else {
	            return currentCentury - 100 + year;
	        }
	    };
	    DateValueAccessor.prototype.setInputValue = function (value) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "value", value);
	    };
	    DateValueAccessor.prototype.writeValue = function (value) {
	        if (value === null || value === undefined) {
	            return this.setInputValue("");
	        }
	        if (!(value instanceof Date)) {
	            debugger;
	            console.error("Model is not a Date:", value);
	            throw new Error("Only Date objects can be bound to a date-control!");
	        }
	        this.setInputValue(typed_data_1.TypedData.dateToInput(value));
	    };
	    DateValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    DateValueAccessor.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    DateValueAccessor.prototype.setDisabledState = function (isDisabled) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "disabled", isDisabled);
	    };
	    var DateValueAccessor_1;
	    DateValueAccessor.USE_2_DIGIT_FIX = true;
	    DateValueAccessor.CENTURY_TOLERANCE = 1;
	    DateValueAccessor = DateValueAccessor_1 = __decorate([
	        core_1.Directive({
	            selector: "\n    input[type=date][formControl]\n",
	            host: {
	                "(change)": "filterNative($event)",
	                "(blur)": "reissueAsChange($event)",
	                "(keyup.enter)": "reissueAsChange($event)"
	            },
	            providers: [exports.DATE_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.Renderer,
	            core_1.ElementRef])
	    ], DateValueAccessor);
	    return DateValueAccessor;
	}());
	exports.DateValueAccessor = DateValueAccessor;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var moment = __webpack_require__(70);
	exports.DATETIME_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DatetimeValueAccessor; }),
	    multi: true
	};
	var DatetimeValueAccessor = (function () {
	    function DatetimeValueAccessor(renderer, elementRef) {
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        this.timezone = "local";
	        this.onChange = function (_) {
	        };
	        this.onTouched = function () {
	        };
	    }
	    DatetimeValueAccessor.prototype.reissueAsChange = function (existing) {
	        if (existing.type === "blur") {
	            this.onTouched();
	        }
	        var event = new Event("change", { bubbles: true });
	        event.reissued = true;
	        this.elementRef.nativeElement.dispatchEvent(event);
	    };
	    DatetimeValueAccessor.prototype.filterNative = function (event) {
	        if (!event.reissued) {
	            event.stopPropagation();
	        }
	        else {
	            this.internalChange(event.target.value);
	        }
	    };
	    DatetimeValueAccessor.prototype.internalChange = function (value) {
	        if (typeof value !== "string") {
	            console.error("Datetime-local input value error", value);
	            throw new Error("Datetime-local returned non-string value");
	        }
	        var m = moment(value, moment.ISO_8601);
	        if (m.isValid()) {
	            return this.onChange(m.toDate());
	        }
	        this.onChange(null);
	    };
	    DatetimeValueAccessor.prototype.setInputValue = function (value) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "value", value);
	    };
	    DatetimeValueAccessor.prototype.writeValue = function (value) {
	        if (value === null || value === undefined) {
	            return this.setInputValue("");
	        }
	        if (!(value instanceof Date)) {
	            console.error("Model is not a Date:", value);
	            throw new Error("Only Date objects can be bound to a datetime control!");
	        }
	        value = moment(value).format("YYYY-MM-DDTHH:mm");
	        this.setInputValue(value);
	    };
	    DatetimeValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    DatetimeValueAccessor.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    DatetimeValueAccessor.prototype.setDisabledState = function (isDisabled) {
	        this.renderer.setElementProperty(this.elementRef.nativeElement, "disabled", isDisabled);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DatetimeValueAccessor.prototype, "timezone", void 0);
	    DatetimeValueAccessor = __decorate([
	        core_1.Directive({
	            selector: "input[type=datetime-local][formControl]",
	            host: {
	                "(change)": "filterNative($event)",
	                "(blur)": "reissueAsChange($event)",
	                "(keyup.enter)": "reissueAsChange($event)"
	            },
	            providers: [exports.DATETIME_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.Renderer,
	            core_1.ElementRef])
	    ], DatetimeValueAccessor);
	    return DatetimeValueAccessor;
	}());
	exports.DatetimeValueAccessor = DatetimeValueAccessor;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var AutosizeDirective = (function () {
	    function AutosizeDirective(element) {
	        this.element = element;
	        this.minimum = 34;
	        this.expandOnly = false;
	    }
	    AutosizeDirective_1 = AutosizeDirective;
	    AutosizeDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.autosize === "expand") {
	            this.expandOnly = true;
	        }
	        this.resize();
	        if (AutosizeDirective_1.StartupRecheckDelay) {
	            setTimeout(function () { return _this.resize(); }, AutosizeDirective_1.StartupRecheckDelay);
	        }
	    };
	    AutosizeDirective.prototype.resize = function () {
	        var textarea = this.element.nativeElement;
	        if (!this.expandOnly) {
	            textarea.style.height = this.minimum + "px";
	        }
	        var height = Math.max(textarea.scrollHeight + 2, this.minimum);
	        textarea.style.height = height + "px";
	    };
	    var AutosizeDirective_1;
	    AutosizeDirective.StartupRecheckDelay = 300;
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], AutosizeDirective.prototype, "minimum", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], AutosizeDirective.prototype, "autosize", void 0);
	    __decorate([
	        core_1.HostListener("input"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AutosizeDirective.prototype, "resize", null);
	    AutosizeDirective = AutosizeDirective_1 = __decorate([
	        core_1.Directive({
	            selector: "textarea[autosize]"
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], AutosizeDirective);
	    return AutosizeDirective;
	}());
	exports.AutosizeDirective = AutosizeDirective;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var BooleanPillComponent = (function () {
	    function BooleanPillComponent() {
	        this.value = false;
	        this.trueString = "enabled";
	        this.falseString = "disabled";
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], BooleanPillComponent.prototype, "value", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], BooleanPillComponent.prototype, "trueString", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], BooleanPillComponent.prototype, "falseString", void 0);
	    BooleanPillComponent = __decorate([
	        core_1.Component({
	            selector: "boolean",
	            template: "\n<span class=\"badge\" [class.success]=\"value\">\n    {{value ? trueString : falseString}}\n</span>\n",
	            styles: ["span {font-size: 1em;}"]
	        })
	    ], BooleanPillComponent);
	    return BooleanPillComponent;
	}());
	exports.BooleanPillComponent = BooleanPillComponent;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var moment = __webpack_require__(70);
	var CountdownComponent = (function () {
	    function CountdownComponent() {
	        this.target = moment();
	        this.formatted = "";
	        this.resolution = 1000;
	    }
	    Object.defineProperty(CountdownComponent.prototype, "seconds", {
	        set: function (count) {
	            clearTimeout(this.timer);
	            this.target = moment().add(count, "seconds");
	            this.calculate();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CountdownComponent.prototype.calculate = function () {
	        var _this = this;
	        var length = moment.duration(this.target.diff(moment()));
	        if (length.asMilliseconds() < 0) {
	            this.formatted = "0:00";
	            return;
	        }
	        var mm = Math.floor(length.asMinutes()).toString(10);
	        var ss = (1000 + length.seconds()).toString(10).substring(2);
	        this.formatted = mm + ":" + ss;
	        setTimeout(function () { return _this.calculate(); }, this.resolution);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], CountdownComponent.prototype, "seconds", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], CountdownComponent.prototype, "resolution", void 0);
	    CountdownComponent = __decorate([
	        core_1.Component({
	            selector: "countdown",
	            template: "\n<span class=\"countdown\">\n    {{formatted}}\n</span>\n",
	        })
	    ], CountdownComponent);
	    return CountdownComponent;
	}());
	exports.CountdownComponent = CountdownComponent;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var GroupValidationComponent = (function () {
	    function GroupValidationComponent() {
	        this.groupLabel = "Table";
	    }
	    GroupValidationComponent.prototype.array = function (control) {
	        return (control instanceof forms_1.FormArray);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.FormGroup)
	    ], GroupValidationComponent.prototype, "group", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], GroupValidationComponent.prototype, "groupLabel", void 0);
	    GroupValidationComponent = __decorate([
	        core_1.Component({
	            selector: "group-validation",
	            template: "\n        <div *ngFor=\"let c of (group.controls | entries)\">\n            <div *ngIf=\"c[1].errors\">\n                <label>{{c[0]}}:</label>\n                <validation-messages [control]=\"c[1]\"></validation-messages>\n            </div>\n            <template [ngIf]=\"array(c[1])\">\n                <div *ngFor=\"let r of c[1].controls; let i = index\">\n                    <template [ngIf]=\"r.errors\">\n                        <label>{{c[0]}} #{{i+1}}:</label>\n                        <validation-messages [control]=\"r\">\n                        </validation-messages>\n                    </template>\n                </div>\n            </template>\n        </div>\n    ",
	            styles: [""]
	        })
	    ], GroupValidationComponent);
	    return GroupValidationComponent;
	}());
	exports.GroupValidationComponent = GroupValidationComponent;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var DEFAULT_RENDER_DELAY = 200;
	var MatchFrameContentHeightDirective = (function () {
	    function MatchFrameContentHeightDirective(element) {
	        this.element = element;
	    }
	    MatchFrameContentHeightDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.element.nativeElement.contentDocument) {
	            this.frame = this.element.nativeElement;
	            console.warn("Found iframe document!");
	            if (this.frame.contentDocument.readyState === "complete") {
	                this.resize();
	            }
	            else {
	                this.frame.contentDocument.addEventListener("load", function () { return _this.resize(); });
	            }
	        }
	    };
	    MatchFrameContentHeightDirective.prototype.delayed = function (cb) {
	        setTimeout(cb, this.delay || DEFAULT_RENDER_DELAY);
	    };
	    MatchFrameContentHeightDirective.prototype.resize = function () {
	        var _this = this;
	        this.delayed(function () { return _this.frame.style.height =
	            _this.frame.contentDocument.body.scrollHeight + "px"; });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], MatchFrameContentHeightDirective.prototype, "delay", void 0);
	    MatchFrameContentHeightDirective = __decorate([
	        core_1.Directive({
	            selector: "iframe[match-height]"
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], MatchFrameContentHeightDirective);
	    return MatchFrameContentHeightDirective;
	}());
	exports.MatchFrameContentHeightDirective = MatchFrameContentHeightDirective;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var MembershipInputComponent = (function () {
	    function MembershipInputComponent() {
	        this.ordered = true;
	        this.optionsSorted = true;
	        this._source = [];
	        this._lastSource = [];
	        this.options = [];
	        this.selectedOption = new forms_1.FormControl();
	        this.selectedTarget = new forms_1.FormControl();
	        this.target = [];
	        this.change = new core_1.EventEmitter();
	        this.max = 20;
	        this.min = 3;
	    }
	    Object.defineProperty(MembershipInputComponent.prototype, "source", {
	        set: function (source) {
	            if (this._lastSource === source) {
	                return;
	            }
	            if (Array.isArray(source)) {
	                this._source = source;
	                this._lastSource = source;
	            }
	            else {
	                console.error("Membership input received non-array source");
	                this._source = [];
	                this._lastSource = [];
	            }
	            this.reset();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MembershipInputComponent.prototype.sortOptions = function () {
	        if (this.optionsSorted) {
	            this.options.sort(function (a, b) {
	                if (!a || (typeof a.displayName !== "string")) {
	                    return -1;
	                }
	                else if (!b || (typeof b.displayName !== "string")) {
	                    return 1;
	                }
	                else {
	                    return a.displayName.localeCompare(b.displayName);
	                }
	            });
	        }
	    };
	    MembershipInputComponent.prototype.reset = function () {
	        var out = this.target;
	        this.options = Array.from(this._source);
	        this.sortOptions();
	        this.target.length = 0;
	        this.change.emit(this.target);
	        this.selectedTarget.reset();
	        this.selectedOption.reset();
	        return out;
	    };
	    MembershipInputComponent.prototype.size = function () {
	        return Math.min(Math.max(this._source.length, this.target.length, this.min), this.max);
	    };
	    MembershipInputComponent.prototype.add = function () {
	        var item = this.selectedOption.value;
	        if (item === null) {
	            return;
	        }
	        var i = this.options.indexOf(item);
	        if (i === -1) {
	            throw new Error("Could not find item in options: " + item);
	        }
	        this.target.push(this.options.splice(i, 1)[0]);
	        this.selectedOption.reset();
	        this.change.emit(this.target);
	    };
	    MembershipInputComponent.prototype.remove = function () {
	        var item = this.selectedTarget.value;
	        if (item === null) {
	            return;
	        }
	        var i = this.target.indexOf(item);
	        if (i === -1) {
	            throw new Error("Could not find item in options: " + item);
	        }
	        this.options.push(this.target.splice(i, 1)[0]);
	        this.sortOptions();
	        this.selectedTarget.reset();
	        this.change.emit(this.target);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], MembershipInputComponent.prototype, "source", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], MembershipInputComponent.prototype, "ordered", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], MembershipInputComponent.prototype, "optionsSorted", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], MembershipInputComponent.prototype, "target", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], MembershipInputComponent.prototype, "change", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], MembershipInputComponent.prototype, "max", void 0);
	    MembershipInputComponent = __decorate([
	        core_1.Component({
	            selector: "membership-input",
	            template: "\n<div class=\"row\">\n    <div class=\"col-sm-5\">\n        <select\n            [size]=\"size()\"\n            class=\"form-control\"\n            [formControl]=\"selectedOption\">\n            <option *ngIf=\"!options?.length\" disabled>\n                (empty)\n            </option>\n            <option\n                *ngFor=\"let item of options\"\n                [ngValue]=\"item\"\n                [class]=\"item.membershipClass\"\n                [disabled]=\"item.membershipDisabled\"\n                (dblclick)=\"add()\">\n                {{item.displayName}}\n            </option>\n        </select>\n    </div>\n    <div class=\"col-sm-2 button-col\">\n        <button class=\"btn btn-xs btn-default\" (click)=\"add()\">\n            \u2192\n        </button>\n        <button class=\"btn btn-xs btn-default\" (click)=\"remove()\">\n            \u2190\n        </button>\n        <button\n            class=\"btn btn-xs btn-default\"\n            (click)=\"reset()\">\n            Reset\n        </button>\n    </div>\n    <div class=\"col-sm-5\">\n        <select\n            [size]=\"size()\"\n            class=\"form-control\"\n            [formControl]=\"selectedTarget\">\n            <option *ngIf=\"!target?.length\" disabled>\n                (empty)\n            </option>\n            <option\n                *ngFor=\"let item of target\"\n                [ngValue]=\"item\"\n                [class]=\"item.membershipClass\"\n                [disabled]=\"item.membershipDisabled\"\n                (dblclick)=\"remove()\">\n                {{item.displayName}}\n            </option>\n        </select>\n    </div>\n</div>\n    ",
	            styles: ["\n        .button-col {\n            padding-left: 0;\n            padding-right: 0;\n        }\n        .button-col button {\n            width: 100%;\n        }\n        option.special1 {\n            font-style: italic;\n            color: var(--color-blue);\n        }\n        option.special2 {\n            font-style: italic;\n            color: var(--color-green);\n        }\n    "]
	        })
	    ], MembershipInputComponent);
	    return MembershipInputComponent;
	}());
	exports.MembershipInputComponent = MembershipInputComponent;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var ValidationMessages = (function () {
	    function ValidationMessages() {
	    }
	    ValidationMessages.getLevel = function (errorName) {
	        return "standard";
	    };
	    ValidationMessages.allowSubmit = function (errorName, value) {
	        if (errorName === "noInternalNulls") {
	            return true;
	        }
	        return false;
	    };
	    ValidationMessages.submittable = function (control) {
	        var _this = this;
	        if (control.errors
	            && Object.keys(control.errors).some(function (err) { return !_this.allowSubmit(err); })) {
	            return false;
	        }
	        if (control instanceof forms_1.FormArray) {
	            return control.controls.every(function (c) { return _this.submittable(c); });
	        }
	        if (control instanceof forms_1.FormGroup) {
	            return Object.values(control.controls).every(function (c) { return _this.submittable(c); });
	        }
	        return true;
	    };
	    ValidationMessages.getMessage = function (errorName, value) {
	        var msg = ValidationMessages.Messages.get(errorName);
	        if (!msg) {
	            return ValidationMessages.UnknownError;
	        }
	        if (typeof msg === "function") {
	            return msg(value);
	        }
	        return msg;
	    };
	    ValidationMessages.UnknownError = "(NO VALIDATION MSG DEFINED)";
	    ValidationMessages.Messages = new Map([
	        ["required", "This field is required."],
	        ["minLength", "This value is too short."],
	        ["maxLength", "This value is too long."],
	        ["integer", "The value must be an integer."],
	        ["number", "The value must be a number."],
	        ["min", "The value is less than the minimum."],
	        ["max", "The value is greater than the maximum."],
	        ["date", "The value is not a correctly formatted date."],
	        ["boolean", "The value is not a a boolean (true/false)."],
	        ["arrayMin", "The array must have a minimum number of values."],
	        ["equalsTo", "The fields do not match."],
	        ["safeInteger", function (v) {
	                return "The value is " + v + " the range of 'safe' numbers.";
	            }],
	        ["requiredList", "Empty values are not allowed."],
	        ["onlyLastEmpty", "Only the last entry can be empty."],
	        ["in", function (v) { return "The value \"" + v + "\" is not allowed."; }],
	        ["subset", "Not all values are in the allowed set."],
	        ["noInternalNulls",
	            function (v) {
	                return "The value in row " + (v + 1) + " is blank.\n                    Only use \"internal\" blanks when completely necessary.";
	            }
	        ]
	    ]);
	    return ValidationMessages;
	}());
	exports.ValidationMessages = ValidationMessages;
	var ValidationMessagesComponent = (function () {
	    function ValidationMessagesComponent() {
	    }
	    ValidationMessagesComponent.prototype.msgString = function (errorName, value) {
	        return ValidationMessages.getMessage(errorName, value);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.AbstractControl)
	    ], ValidationMessagesComponent.prototype, "control", void 0);
	    ValidationMessagesComponent = __decorate([
	        core_1.Component({
	            selector: "validation-messages",
	            template: "\n        <span *ngFor=\"let error of (control.errors | entries)\">\n            {{msgString(error[0], error[1])}}\n        </span>\n    ",
	            styles: [""]
	        })
	    ], ValidationMessagesComponent);
	    return ValidationMessagesComponent;
	}());
	exports.ValidationMessagesComponent = ValidationMessagesComponent;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var paginate_pipe_1 = __webpack_require__(740);
	var PagerComponent = (function () {
	    function PagerComponent() {
	        this.jumpButtons = false;
	        this.asNeeded = false;
	    }
	    PagerComponent.prototype.ngOnInit = function () {
	        if (Array.isArray(this.array) && !Number.isInteger(this.array._maxPage)) {
	            console.warn("Pager array does not appear to have pagination metadata!");
	            paginate_pipe_1.PaginationPipe.updatePagination(this.array);
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], PagerComponent.prototype, "array", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "jumpButtons", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "asNeeded", void 0);
	    PagerComponent = __decorate([
	        core_1.Component({
	            selector: "pager",
	            template: "\n    <nav *ngIf=\"!asNeeded || (array._maxPage > 1)\">\n      <ul class=\"pager\">\n        <li\n          *ngIf=\"jumpButtons\"\n          class=\"previous\"\n          [class.disabled]=\"array._pageIndex <= 0\">\n          <a (click)=\"array._goto(0)\">First</a>\n        </li>\n        <li\n          class=\"previous\"\n          [class.disabled]=\"array._pageIndex <= 0\">\n          <a (click)=\"array._previous()\">\n            Previous\n          </a>\n        </li>\n        <li class=\"text-center\">\n          <strong>\n            Page {{array._pageIndex + 1}} of {{array._maxPage}}\n          </strong>\n        </li>\n        <!-- note: the \"last\" button occurs first because it's pulled right -->\n        <li\n          *ngIf=\"jumpButtons\"\n          class=\"next\"\n          [class.disabled]=\"array._pageIndex >= array._maxPage - 1\">\n          <a (click)=\"array._goto(-1)\">Last</a>\n        </li>\n        <li\n          class=\"next\"\n          [class.disabled]=\"array._pageIndex >= array._maxPage - 1\">\n          <a (click)=\"array._next()\">Next</a>\n        </li>\n      </ul>\n    </nav>\n  ",
	            styles: ["\n    nav {\n        font-size: medium;\n        font-style: normal;\n        color: #333;\n    }\n    .pager {margin: 0;}\n  "]
	        })
	    ], PagerComponent);
	    return PagerComponent;
	}());
	exports.PagerComponent = PagerComponent;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var PaginationPipe = (function () {
	    function PaginationPipe() {
	    }
	    PaginationPipe_1 = PaginationPipe;
	    PaginationPipe.updatePagination = function (arr, perPage) {
	        if (perPage === void 0) { perPage = PaginationPipe_1.DEFAULT_PER_PAGE; }
	        arr._pageLength = perPage;
	        arr._maxPage = Math.ceil(arr.length / arr._pageLength);
	        if (!Number.isInteger(arr._pageIndex)) {
	            arr._pageIndex = 0;
	        }
	        if ((typeof arr._next) !== "function") {
	            arr._next =
	                function () { return arr._pageIndex = Math.min(arr._pageIndex + 1, arr._maxPage - 1); };
	            arr._previous =
	                function () { return arr._pageIndex = Math.max(arr._pageIndex - 1, 0); };
	            arr._goto =
	                function (page) { return arr._pageIndex =
	                    ((page % arr._maxPage) + ((page < 0) ? arr._maxPage : 0)); };
	        }
	    };
	    PaginationPipe.getPage = function (arr) {
	        var offset = arr._pageIndex * arr._pageLength;
	        return arr.slice(offset, offset + arr._pageLength);
	    };
	    PaginationPipe.prototype.transform = function (value, perPage) {
	        if (perPage === void 0) { perPage = PaginationPipe_1.DEFAULT_PER_PAGE; }
	        if (!Array.isArray(value)) {
	            console.error("Cannot paginate non-array structure");
	            return [];
	        }
	        PaginationPipe_1.updatePagination(value, perPage);
	        return PaginationPipe_1.getPage(value);
	    };
	    var PaginationPipe_1;
	    PaginationPipe.DEFAULT_PER_PAGE = 20;
	    PaginationPipe = PaginationPipe_1 = __decorate([
	        core_1.Pipe({ name: "paginate", pure: false })
	    ], PaginationPipe);
	    return PaginationPipe;
	}());
	exports.PaginationPipe = PaginationPipe;
	var PageQueryPipe = (function () {
	    function PageQueryPipe() {
	    }
	    PageQueryPipe.prototype.transform = function (value, query) {
	        if (!Array.isArray(value)) {
	            console.error("Cannot query page non-array structure");
	            return false;
	        }
	        if (query === "last") {
	            return (value._pageIndex === value._maxPage);
	        }
	        if (query === "first") {
	            return (value._pageIndex === 0);
	        }
	        if (query < 0) {
	            query += value._maxPage;
	        }
	        return (value._pageIndex === query);
	    };
	    PageQueryPipe = __decorate([
	        core_1.Pipe({ name: "onPage", pure: false })
	    ], PageQueryPipe);
	    return PageQueryPipe;
	}());
	exports.PageQueryPipe = PageQueryPipe;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var RepeatToContext = (function () {
	    function RepeatToContext(index) {
	        this.index = index;
	    }
	    return RepeatToContext;
	}());
	var MAX_REASONABLE_COUNT = 500;
	var RepeatToDirective = (function () {
	    function RepeatToDirective(templateRef, viewContainer) {
	        this.templateRef = templateRef;
	        this.viewContainer = viewContainer;
	        this.count = 0;
	    }
	    Object.defineProperty(RepeatToDirective.prototype, "repeatTo", {
	        set: function (newCount) {
	            if (!Number.isInteger(newCount) || newCount < 0) {
	                newCount = 0;
	            }
	            if (newCount === this.count) {
	                return;
	            }
	            this._applyChanges(newCount);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RepeatToDirective.prototype._applyChanges = function (newCount) {
	        if (newCount > MAX_REASONABLE_COUNT) {
	            throw new Error("Requested unreasonable number of sub-views (" + newCount + ")");
	        }
	        while (this.count < newCount) {
	            this.viewContainer.createEmbeddedView(this.templateRef, new RepeatToContext(this.count), this.count);
	            this.count++;
	        }
	        while (this.count > newCount) {
	            this.viewContainer.remove();
	            this.count--;
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], RepeatToDirective.prototype, "repeatTo", null);
	    RepeatToDirective = __decorate([
	        core_1.Directive({ selector: "[repeatTo]" }),
	        __metadata("design:paramtypes", [core_1.TemplateRef,
	            core_1.ViewContainerRef])
	    ], RepeatToDirective);
	    return RepeatToDirective;
	}());
	exports.RepeatToDirective = RepeatToDirective;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var bootstrap_1 = __webpack_require__(24);
	var answer_proxy_1 = __webpack_require__(743);
	var build_flags_1 = __webpack_require__(534);
	var utilities_1 = __webpack_require__(523);
	var control_group_1 = __webpack_require__(744);
	var control_table_modal_component_1 = __webpack_require__(745);
	var MULTI_ANSWER_ENABLED = false;
	var ControlGroupComponent = (function () {
	    function ControlGroupComponent(modal, answer) {
	        this.modal = modal;
	        this.answer = answer;
	        this.debugTools = build_flags_1.BuildFlags.debugMode;
	        this.validateInColumn = false;
	        this.action = new core_1.EventEmitter();
	        this.rowActions = true;
	        this.cachedSortLabel = null;
	        this.cachedSortStep = null;
	    }
	    ControlGroupComponent.prototype.asDefault = function () {
	        return Object.assign({}, this.group, { type: null });
	    };
	    ControlGroupComponent.prototype.act = function (name, args) {
	        if (name === "removeRow") {
	            return this.removeRow(args[0]);
	        }
	        if (name === "moveRow") {
	            return this.moveRow(args[0], args[1]);
	        }
	        this.action.emit([name, args]);
	    };
	    ControlGroupComponent.prototype.change = function (event, step) {
	        if (this.group instanceof control_group_1.TabularControlGroup) {
	            this.group.autosize(true);
	        }
	        if (this.group instanceof control_group_1.TabularControlGroup && MULTI_ANSWER_ENABLED) {
	            throw new Error("Multi-answer support is not available at present");
	        }
	        else {
	            this.answer.submitAnswer(step, event);
	        }
	    };
	    ControlGroupComponent.prototype.openTable = function () {
	        var _this = this;
	        utilities_1.ModalHelpers.openCustom(this.modal, control_table_modal_component_1.ControlTableModalComponent, {
	            group: this.group,
	            tunnel: function (e, s) { return _this.change(e, s); },
	            act: function (name, args) { return _this.act(name, args); },
	            dialogClass: "modal-dialog modal-full"
	        });
	    };
	    ControlGroupComponent.prototype.removeRow = function (row) {
	        if (this.group instanceof control_group_1.TabularControlGroup) {
	            this.group.remove(row);
	        }
	        else {
	            throw new Error("Cannot remove for non-tabular groups!");
	        }
	        this.answer.submitMultiple(this.group.steps, []);
	    };
	    ControlGroupComponent.prototype.moveRow = function (row, delta) {
	        if (this.group instanceof control_group_1.TabularControlGroup) {
	            this.group.move(row, delta);
	        }
	        else {
	            throw new Error("Cannot move for non-tabular groups!");
	        }
	        this.answer.submitMultiple(this.group.steps, []);
	    };
	    ControlGroupComponent.prototype.clearAll = function () {
	        if (this.group instanceof control_group_1.TabularControlGroup) {
	            try {
	                do {
	                    this.group.remove(0);
	                } while (true);
	            }
	            catch (err) {
	            }
	        }
	        else {
	            throw new Error("Cannot move for non-tabular groups!");
	        }
	        this.answer.submitMultiple(this.group.steps, []);
	    };
	    ControlGroupComponent.prototype.sort = function (stepName) {
	        var _this = this;
	        console.error("SORTING", this.group);
	        utilities_1.ModalHelpers.observeBooleanConfirmation(this.modal.confirm()
	            .title("Sorting will overwrite current order")
	            .okBtn("Sort table")
	            .cancelBtn("Nevermind")
	            .body(utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                Sorting this table will sort it for all users (not just you).\n                If you save the record, any order previously set for these items\n                will be lost."], ["\n                Sorting this table will sort it for all users (not just you).\n                If you save the record, any order previously set for these items\n                will be lost."]))))
	            .open()).subscribe(function (goAhead) {
	            if (goAhead) {
	                _this.group.sortByName(stepName);
	                _this.answer.submitMultiple(_this.group.steps, [new Event("sort")]);
	            }
	        });
	    };
	    ControlGroupComponent.prototype.cellPercentage = function (double) {
	        if (double === void 0) { double = false; }
	        var total = (this.group.steps.length
	            + this.group.steps.filter(function (step) { return step.hints && step.hints.multiline; }).length);
	        return Math.floor((double ? 2 : 1) * 100 / total) + "%";
	    };
	    ControlGroupComponent.prototype.handleCustom = function (_a) {
	        var name = _a[0], event = _a[1];
	        if (name === 'fcwi-income-table'
	            && event.target instanceof HTMLInputElement) {
	            var value = Number.parseInt(event.target.value, 10);
	            var stepName = event.target.id;
	            if (Number.isSafeInteger(value) && value >= 0) {
	                this.answer.submitRaw(stepName, value);
	            }
	        }
	        else {
	            console.error("Unknown custom intake \"" + name + "\" -- events are not handled");
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", control_group_1.ControlGroup)
	    ], ControlGroupComponent.prototype, "group", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ControlGroupComponent.prototype, "action", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ControlGroupComponent.prototype, "rowActions", void 0);
	    ControlGroupComponent = __decorate([
	        core_1.Component({
	            selector: "control-group",
	            template: __webpack_require__(746),
	            styles: ["\n    .intake-step, .tabular {\n      position: relative;\n    }\n    .hover-helper {\n      position: absolute;\n      height: 100%;\n      width: 100px;\n      top: 0px;\n      left: -100px;\n      background: transparent;\n    }\n    .menu-button {\n      display: block;\n      position: absolute;\n      left: -50px;\n      top: 0;\n      width: 20px;\n      margin: 10px;\n      text-align: center;\n      opacity: 0;\n      will-change: opacity;\n      transition: opacity 0.4s;\n    }\n    .has-comment .glyphicon-comment {\n      color: #3c763d; /* text-success color TODO: non-magic ref? */\n    }\n    .intake-step:hover .menu-button,\n    .tabular:hover .menu-button,\n    .has-comment .menu-button {\n      opacity: 1;\n    }\n    /deep/ .hide-comments .intake-step:hover .menu-button,\n    /deep/ .hide-comments .tabular:hover .menu-button,\n    /deep/ .hide-comments .has-comment .menu-button {\n        display: none;\n    }\n    .menu {\n      max-height: 0px;\n      opacity: 0;\n      will-change: opacity, max-height, height;\n      overflow-y: hidden;\n      transition: max-height 0.8s, opacity 0.8s;\n      padding-top: 5px;\n      padding-left: 1em;\n      border-left: 1px solid gray;\n    }\n    .menu.open {\n      max-height: 1600px;\n      opacity: 1;\n    }\n    .faded {\n      /* background-color: #00FF55; */\n      /* debugging, this is now handled by animation trigger */\n    }\n    ",
	                "\n    .tabular caption {\n        caption-side: bottom;\n        text-align: center;\n    }\n    .tabular table {\n        overflow-x: scroll;\n        width: 100%;\n    }\n    .tabular table.expanded {\n        /*\n        Absorb the intake form's left margin.\n        */\n        margin-left: -50px;\n        width: calc(100% + 50px);\n    }\n    .tabular .grid td {\n        /* border: 1px solid rgba(0,0,0,0.2); */\n        /* max-width: 200px; */\n        vertical-align: top;\n        padding: 1px;\n    }\n    .tabular th {\n        position: relative;\n    }\n    .tabular .grid .popover {\n        display: block;\n        top: 1.3em;\n        left: -0.5em;\n        min-width: 160px;\n        font-weight: normal;\n    }\n    .tabular .collated .popover {\n        display: block;\n        top: -50%;\n        left: 90%;\n        font-weight: normal;\n        width: 250px;\n    }\n    .collated {\n        margin-top: 2em;\n    }\n    .collated > h3 {\n        margin-top: 0;\n    }\n    .collated > table {\n        /* margin-top: 10px; */\n    }\n    .tabular tfoot .alert {\n        padding: 3px;\n    }\n    .tabular .grid >>> textarea {\n        padding: 3px 5px;\n        max-height: 80px;\n    }\n    .tabular .grid >>> .row-actions {\n        min-width: 84px;\n    }\n    .tabular .grid >>> .row-actions .btn {\n        padding: 6px;\n    }\n    .inline-report {\n        padding-left: 12px;\n        border-radius: 5px;\n        border-left: 2px solid rgba(50, 150, 0, 0.25);\n    }\n    /* make table margin-left 8vw  */\n    "],
	            animations: [utilities_1.SLOW_REMOVAL]
	        }),
	        __metadata("design:paramtypes", [bootstrap_1.Modal, answer_proxy_1.AnswerProxy])
	    ], ControlGroupComponent);
	    return ControlGroupComponent;
	}());
	exports.ControlGroupComponent = ControlGroupComponent;
	var templateObject_1;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AnswerProxy = (function () {
	    function AnswerProxy() {
	    }
	    return AnswerProxy;
	}());
	exports.AnswerProxy = AnswerProxy;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var validation_builder_1 = __webpack_require__(700);
	var functions_1 = __webpack_require__(206);
	var typed_data_1 = __webpack_require__(69);
	var ControlGroup = (function () {
	    function ControlGroup(type, name) {
	        this.type = type;
	        this.name = name;
	        this.steps = [];
	        this.postAdd = null;
	    }
	    ControlGroup.prototype.add = function (entry) {
	        this.steps.push(entry);
	        return true;
	    };
	    Object.defineProperty(ControlGroup.prototype, "enabled", {
	        get: function () {
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return ControlGroup;
	}());
	exports.ControlGroup = ControlGroup;
	var OrderedControlGroup = (function (_super) {
	    __extends(OrderedControlGroup, _super);
	    function OrderedControlGroup(min, max) {
	        if (min === void 0) { min = 0; }
	        if (max === void 0) { max = Number.MAX_SAFE_INTEGER - 1; }
	        var _this = _super.call(this, null) || this;
	        _this.min = min;
	        _this.max = max;
	        _this.name = "ordered";
	        _this.steps = [];
	        return _this;
	    }
	    OrderedControlGroup.prototype.setMax = function (max) {
	        this.max = max;
	        var removed = this.steps.filter(function (step) { return step.order > max; });
	        this.steps = this.steps.filter(function (step) { return step.order <= max; });
	        return removed;
	    };
	    OrderedControlGroup.prototype.setMin = function (min) {
	        this.min = min;
	        var removed = this.steps.filter(function (step) { return step.order < min; });
	        this.steps = this.steps.filter(function (step) { return step.order >= min; });
	        return removed;
	    };
	    OrderedControlGroup.prototype.ordered = function (entry) {
	        return (entry
	            && Number.isInteger(entry.order)
	            && entry.order !== Number.MAX_SAFE_INTEGER);
	    };
	    OrderedControlGroup.prototype.add = function (entry) {
	        if (!this.ordered(entry)) {
	            return false;
	        }
	        if (this.steps.length === 0) {
	            this.steps = [entry];
	            return true;
	        }
	        var i;
	        for (i = 0; i < this.steps.length; i++) {
	            if (entry.order < this.steps[i].order) {
	                break;
	            }
	        }
	        this.steps.splice(i, 0, entry);
	        return true;
	    };
	    return OrderedControlGroup;
	}(ControlGroup));
	exports.OrderedControlGroup = OrderedControlGroup;
	var TabularControlGroup = (function (_super) {
	    __extends(TabularControlGroup, _super);
	    function TabularControlGroup(name, gridStyleInflection) {
	        if (gridStyleInflection === void 0) { gridStyleInflection = Number.POSITIVE_INFINITY; }
	        var _this = _super.call(this, "tabular", name) || this;
	        _this.gridStyleInflection = gridStyleInflection;
	        _this.size = 0;
	        _this.form = new forms_1.FormGroup({});
	        _this.gridStyle = true;
	        return _this;
	    }
	    Object.defineProperty(TabularControlGroup.prototype, "enabled", {
	        get: function () {
	            return !this.steps.some(function (step) {
	                return step.hints && step.hints.editable === false;
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabularControlGroup.prototype.arrayBacked = function (entry) {
	        return (entry.control instanceof forms_1.FormArray);
	    };
	    TabularControlGroup.prototype.add = function (entry) {
	        if (!this.arrayBacked(entry)) {
	            console.error(entry.control);
	            throw new Error("Cannot add column with non-FormArray control");
	        }
	        if (!entry.hints || (typeof entry.hints.column !== "string")) {
	            return false;
	        }
	        entry.control.setValidators(validation_builder_1.ValidationBuilder.forTableColumn(entry));
	        entry.hints._group = this;
	        this.form.addControl(entry.hints.column, entry.control);
	        var size = this.sizeFor(entry);
	        if (size > this.size) {
	            this.size = size;
	        }
	        this.steps.push(entry);
	        this.autosize();
	        if (entry.hints.commentColumn) {
	            this.commentStep = entry;
	        }
	        if (this.steps.length === this.gridStyleInflection) {
	            this.gridStyle = false;
	        }
	        this.steps.sort(function (a, b) { return +a.order - +b.order; });
	        return true;
	    };
	    TabularControlGroup.prototype.autosize = function (reevaluate) {
	        var _this = this;
	        if (reevaluate === void 0) { reevaluate = false; }
	        if (reevaluate) {
	            this.size = this.steps
	                .map(function (step) {
	                return _this.sizeFor(step);
	            })
	                .reduce(function (a, b) { return Math.max(a, b); });
	        }
	        this.steps.forEach(function (step, i) {
	            while (step.control.length < _this.size) {
	                step.control.push(new forms_1.FormControl(null, validation_builder_1.ValidationBuilder.for(step)));
	            }
	        });
	    };
	    TabularControlGroup.prototype.sizeFor = function (step) {
	        var control = step.control;
	        if (!control) {
	            debugger;
	        }
	        var addNew = !step.hints || step.hints.editable !== false;
	        for (var i = control.length - 1; i >= 0; i--) {
	            if (!functions_1.inputless(control.controls[i].value)) {
	                return addNew ? (i + 2) : (i + 1);
	            }
	        }
	        return addNew ? 1 : 0;
	    };
	    TabularControlGroup.prototype.commentCount = function () {
	        return this.steps.reduce(function (prev, current) {
	            return prev + (current.comments ? current.comments.length : 0);
	        }, 0);
	    };
	    TabularControlGroup.prototype.assertRow = function (row) {
	        if (!Number.isInteger(row) || row < 0 || row >= this.size) {
	            console.error(this);
	            throw new Error(row + " is not a valid row index!");
	        }
	    };
	    TabularControlGroup.prototype.move = function (row, delta) {
	        this.assertRow(row);
	        this.assertRow(row + delta);
	        var lower = Math.min(row, row + delta);
	        this.steps.forEach(function (_a) {
	            var control = _a.control;
	            if (control.value[lower] !== control.value[lower + 1]) {
	                var swapped = functions_1.arraySwap(control.value, lower);
	                try {
	                    control.setValue(swapped);
	                    control.controls[lower].markAsDirty();
	                    control.controls[lower + 1].markAsDirty();
	                }
	                catch (e) {
	                    console.warn("swapped", swapped);
	                    console.log(control);
	                    throw e;
	                }
	            }
	        });
	    };
	    TabularControlGroup.prototype.sortByName = function (stepName) {
	        var i = this.steps.findIndex(function (s) { return s.name === stepName; });
	        if (i !== -1) {
	            this.sortBy(i);
	        }
	        else {
	            throw new Error("Could not find step with name " + stepName);
	        }
	    };
	    TabularControlGroup.prototype.sortBy = function (stepIndex) {
	        var step = this.steps[stepIndex];
	        var permutation = getSortPermutation(step);
	        this.steps.forEach(function (s) {
	            console.log(s.control.value);
	            var vals = applySortPermutation(s.control.value, permutation);
	            console.log("after sort:", vals);
	            s.control.setValue(vals);
	            s.control.controls.forEach(function (c) { return c.markAsDirty(); });
	        });
	    };
	    TabularControlGroup.prototype.remove = function (row) {
	        this.assertRow(row);
	        this.steps.forEach(function (_a) {
	            var control = _a.control;
	            return control.removeAt(row);
	        });
	        this.size--;
	    };
	    return TabularControlGroup;
	}(ControlGroup));
	exports.TabularControlGroup = TabularControlGroup;
	function getSortPermutation(host) {
	    var permutation = Array.apply(null, { length: host.value.length }).map(function (_, i) { return i; });
	    console.info(permutation);
	    permutation.sort(function (a, b) { return typed_data_1.TypedData.compareIndices(host, a, b); });
	    console.warn("PERM:", permutation);
	    return permutation;
	}
	function applySortPermutation(arr, permutation) {
	    var out = new Array(arr.length);
	    for (var i = 0; i < permutation.length; i++) {
	        out[i] = arr[permutation[i]];
	    }
	    if (arr.length > permutation.length) {
	        console.log("Array exceeds given permutation by " + (arr.length - permutation.length));
	        for (var i = permutation.length; i < arr.length; i++) {
	            out[i] = arr[i];
	        }
	    }
	    return out;
	}


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var build_flags_1 = __webpack_require__(534);
	var ControlTableModalComponent = (function () {
	    function ControlTableModalComponent(dialog) {
	        this.dialog = dialog;
	        this.rowActions = true;
	        this.showComments = false;
	    }
	    ControlTableModalComponent.prototype.ngOnInit = function () {
	        this.group = this.dialog.context.group;
	    };
	    ControlTableModalComponent.prototype.change = function (event, step) {
	        if (!step.control.value) {
	            console.warn(step.control.value);
	        }
	        step.control.patchValue(step.control.value);
	        this.dialog.context.tunnel(event, step);
	    };
	    ControlTableModalComponent.prototype.act = function (name, args) {
	        this.dialog.context.act(name, args);
	    };
	    ControlTableModalComponent = __decorate([
	        core_1.Component({
	            template: "\n<div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h3 class=\"capitalized modal-title\">\n        {{group.name}}\n    </h3>\n</div>\n\n\n<table class=\"table\">\n    <thead>\n        <th *ngFor=\"let step of group.steps\">\n            {{step.hints.column}}\n        </th>\n    </thead>\n    <tbody class=\"collapsed-statuses\">\n        <tr *repeatTo=\"group.size; let i = index\">\n            <td\n                *ngFor=\"let step of group.steps\"\n                class=\"intake-step\"\n                [class.bg-danger]=\"i >= step.control.length\">\n                <typed-field\n                    *ngIf=\"i < step.control.length\"\n                    [input]=\"step\"\n                    [control]=\"step.control.controls[i]\"\n                    [clearButton]=\"false\"\n                    [iconTray]=\"false\"\n                    [validationTray]=\"false\"\n                    (change)=\"change($event, step)\">\n                </typed-field>\n                <span *ngIf=\"i >= step.control.length\">\n                    No value at index {{i}}\n                </span>\n            </td>\n            <td *ngIf=\"rowActions && group.enabled\" class=\"btn-group\">\n                <button\n                    *ngIf=\"i !== 0\"\n                    class=\"btn btn-default\"\n                    alt=\"Move up\"\n                    [style.width]=\"(i === group.size-1) ? '79px' : 'auto'\"\n                    (click)=\"act('moveRow', [i, -1])\">\n                    <span class=\"glyphicon glyphicon-chevron-up\"></span>\n                </button>\n                <button\n                    *ngIf=\"i !== group.size-1\"\n                    class=\"btn btn-default\"\n                    alt=\"Move down\"\n                    (click)=\"act('moveRow', [i, 1])\"\n                    [style.width]=\"(i === 0) ? '79px' : 'auto'\">\n                    <span\n                        class=\"glyphicon glyphicon-chevron-down\">\n                    </span>\n                </button>\n                <button\n                    class=\"btn btn-danger\"\n                    alt=\"Remove this entry\"\n                    [disabled]=\"group.size === 1\"\n                    (click)=\"act('removeRow', [i])\">\n                    <span class=\"glyphicon glyphicon-remove\"></span>\n                </button>\n            </td>\n        </tr>\n    </tbody>\n    <tfoot *ngIf=\"showComments\">\n        <tr>\n            <td *ngFor=\"let step of group.steps\">\n                " + (build_flags_1.BuildFlags.debugMode ?
	                "<div class=\"debug-buttons\">\n                        <button\n                            type=\"button\"\n                            class=\"btn btn-default debug-only\"\n                            (click)=\"act('explain',step)\"\n                            tabindex=\"-1\">\n                            Explain\n                        </button>\n                        <button\n                            type=\"button\"\n                            class=\"btn btn-default debug-only\"\n                            (click)=\"act('details',step)\"\n                            tabindex=\"-1\">\n                            Details\n                        </button>\n                    </div>" : "") + "\n            </td>\n        </tr>\n    </tfoot>\n</table>\n\n<div class=\"modal-body\" *ngIf=\"group.form.invalid\">\n    <h3>Validation Issues</h3>\n    <group-validation\n        [group]=\"group.form\"\n        class=\"text-danger\">\n    </group-validation>\n</div>\n\n<div class=\"modal-body\">\n    <h3>Comments </h3>\n    <comment-list\n        *ngFor=\"let step of group.steps\"\n        [comments]=\"step.comments\"\n        [parent]=\"step\"\n        [showNewForm]=\"false\">\n    </comment-list>\n    <comment-list\n        *ngIf=\"group.commentStep\"\n        [comments]=\"group.commentStep.comments\"\n        [parent]=\"group.commentStep\"\n        [showComments]=\"false\">\n    </comment-list>\n    <span *ngIf=\"!group.commentStep\" class=\"text-warning\">\n        <strong>Note:</strong>\n        Comments are disabled for this table because it has no column annotated\n        as the comment \"host\". A subject matter expert must add the category\n        <code>hint-comment-column</code> to exactly 1 column.\n    </span>\n</div>\n\n\n<div class=\"modal-footer\">\n    <button\n        type=\"button\"\n        class=\"btn btn-default\"\n        (click)=\"dialog.close()\">\n        Close\n    </button>\n</div>\n    ",
	            styles: [
	                ".table {\n          width: 100%;\n          padding: 5px;\n        }\n        th {\n            padding: 4px 6px;\n            vertical-align: top;\n        }\n        th >>> p:last-child:not(:first-child) {\n            margin-bottom: 0;\n            font-weight: normal;\n        }\n        .modal-body {\n            border-top: 1px solid #EEE;\n        }\n        h3, h5 {\n            margin-top: 0;\n        }\n        group-validation >>> div {\n            margin-left: 1em;\n        }"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], ControlTableModalComponent);
	    return ControlTableModalComponent;
	}());
	exports.ControlTableModalComponent = ControlTableModalComponent;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = "<div [ngSwitch]=\"group.type\" [class]=\"group.type || 'classic'\">\n    <template ngSwitchCase=\"tabular\">\n    <template [ngIf]=\"group.gridStyle\">\n        <template [ngIf]=\"!group.enabled\">\n            <h3 class=\"capitalized\">{{group.name}}</h3>\n            <table class=\"table table-hover center-items\">\n                <thead>\n                    <th\n                        *ngFor=\"let step of group.steps\"\n                        style=\"padding: 10px\"\n                        title=\"Click for description\"\n                        [id]=\"step.id\">\n                        <span>\n                            {{step.hints.column || step.hints.displayName}}\n                        </span>\n                        <!-- include the presentation popover somehow? -->\n                    </th>\n                </thead>\n                <tbody class=\"collapsed-statuses\">\n                    <tr *repeatTo=\"group.size; let i = index\">\n                        <td\n                            *ngFor=\"let step of group.steps\"\n                            class=\"intake-step\"\n                            [class.bg-danger]=\"i >= step.control.length\"\n                            [style.width]=\"cellPercentage(step.hints.multiline)\">\n\n                            <typed-display\n                                *ngIf=\"i < step.control.length\"\n                                [input]=\"step\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t[index]=\"i\">\n                            </typed-display>\n                            <span *ngIf=\"i >= step.control.length\">\n                                No value at index {{i}}\n                            </span>\n                        </td>\n                    </tr>\n                </tbody>\n                <caption *ngIf=\"group.size === 0\">\n                    <em>No entries.</em>\n                </caption>\n            </table>\n        </template>\n        <span *ngIf=\"group.enabled\" class=\"tabular-grid\">\n            <h3 class=\"capitalized\">\n                {{group.name}}\n                <!--<button\n                    type=\"button\"\n                    class=\"btn btn-sm btn-default pull-right\"\n                    (click)=\"validateInColumn = !validateInColumn\">\n                    switch V style\n                </button>-->\n                <span class=\"btn-group pull-right nonprint\">\n                    <button\n                        type=\"button\"\n                        class=\"btn btn-sm btn-default\"\n                        (click)=\"group.gridStyle = false\">\n                        Switch to form view\n                    </button>\n                    <button\n                        type=\"button\"\n                        class=\"btn btn-sm btn-default\"\n                        (click)=\"openTable()\">\n                        Pop out\n                        <span class=\"glyphicon glyphicon-new-window\"></span>\n                    </button>\n                    <button\n                        type=\"button\"\n                        class=\"btn btn-sm btn-danger\"\n                        (click)=\"clearAll()\"\n                        [disabled]=\"group?.size < 2\">\n                        Clear all\n                        <span class=\"glyphicon glyphicon-remove\"></span>\n                    </button>\n                </span>\n            </h3>\n            <small *ngIf=\"group.enabled\">\n                New rows will appear as you add data.\n                If the table is too small, consider using the \"pop out\" or \"form\n                view\" using the buttons above.\n            </small>\n            <table class=\"grid\" [class.expanded]=\"group.steps.length > 4\">\n                <thead>\n                    <th\n                        *ngFor=\"let step of group.steps\"\n                        #head\n                        style=\"padding: 2px; vertical-align: bottom\"\n                        title=\"Click for description\"\n                        [id]=\"step.id\">\n                        <div\n                            *ngIf=\"head.open\"\n                            class=\"popover bottom\">\n                            <div class=\"arrow\"></div>\n                            <h3\n                                class=\"popover-title\"\n                                (click)=\"head.open = false\">\n                                {{step.hints.column}}\n                                <span\n                                    class=\"glyphicon glyphicon-remove pull-right\">\n                                </span>\n                            </h3>\n                            <div\n                                [innerHtml]=\"step.presentation\"\n                                class=\"popover-content\">\n                            </div>\n                        </div>\n                        <span class=\"dotted\" (click)=\"head.open = !head.open\">\n                            {{step.hints.column || step.hints.displayName}}\n                        </span>\n                    </th>\n                </thead>\n                <tbody class=\"collapsed-statuses\">\n                    <tr *repeatTo=\"group.size; let i = index\">\n                        <td\n                            *ngFor=\"let step of group.steps\"\n                            class=\"intake-step\"\n                            [class.bg-danger]=\"i >= step.control.length\"\n                            [style.width]=\"cellPercentage(step.hints.multiline)\">\n                            <typed-field\n                                *ngIf=\"i < step.control.length\"\n                                [input]=\"step\"\n                                [control]=\"step.control.controls[i]\"\n                                [clearButton]=\"false\"\n                                [iconTray]=\"false\"\n                                [validationTray]=\"false\"\n                                (change)=\"change($event, step)\">\n                            </typed-field>\n                            <span *ngIf=\"i >= step.control.length\">\n                                No value at index {{i}}\n                            </span>\n                        </td>\n                        <td \n                            *ngIf=\"rowActions && group.enabled\" \n                            class=\"btn-group row-actions\">\n                        <!--<span class=\"\">-->\n                            <button\n                                *ngIf=\"i !== 0\"\n                                class=\"btn btn-default\"\n                                alt=\"Move up\"\n                                [style.width]=\"(i === group.size-1) ? '55px' : 'auto'\"\n                                (click)=\"moveRow(i, -1)\">\n                                <span class=\"glyphicon glyphicon-chevron-up\"></span>\n                            </button>\n                            <button\n                                *ngIf=\"i !== group.size-1\"\n                                class=\"btn btn-default\"\n                                alt=\"Move down\"\n                                (click)=\"moveRow(i, 1)\"\n                                [style.width]=\"(i === 0) ? '55px' : 'auto'\">\n                                <span\n                                    class=\"glyphicon glyphicon-chevron-down\">\n                                </span>\n                            </button>\n                            <!--<button\n                                *ngIf=\"clearEnabled() && (!listActions || only())\"\n                                class=\"btn btn-default\"\n                                [style.width]=\"listActions ? '80px' : 'auto'\"\n                                (click)=\"clear(i)\">\n                                Clear\n                            </button>-->\n                            <button\n                                class=\"btn btn-danger\"\n                                alt=\"Remove this entry\"\n                                [disabled]=\"group.size === 1\"\n                                (click)=\"removeRow(i)\">\n                                <span class=\"glyphicon glyphicon-remove\"></span>\n                            </button>\n                        <!--</span>-->\n                        </td>\n                    </tr>\n                </tbody>\n                <tfoot>\n                    <tr>\n                        <td *ngFor=\"let step of group.steps\">\n                            <div\n                                *ngIf=\"step.control?.errors\"\n                                class=\"alert alert-danger\">\n                                <div *ngFor=\"let c of step.control.controls; let i = index\">\n                                    <template [ngIf]=\"c.errors\">\n                                        <label>Row {{i+1}}:</label>\n                                        <validation-messages [control]=\"c\">\n                                        </validation-messages>\n                                    </template>\n                                </div>\n                                <label>Column:</label>\n                                <validation-messages [control]=\"step.control\">\n                                </validation-messages>\n                            </div>\n                        </td>\n                    </tr>\n                </tfoot>\n                <caption *ngIf=\"group.size === 0 && !group.enabled\">\n                    <em>No entries.</em>\n                </caption>\n            </table>\n            <div [class.has-comment]=\"group.commentCount() > 0\">\n                <div class=\"menu\" #menu [class.open]=\"menu?.open\" tabindex=\"-1\">\n                    <comment-list\n                        *ngFor=\"let step of group.steps\"\n                        [comments]=\"step.comments\"\n                        [parent]=\"step\"\n                        [showNewForm]=\"false\">\n                    </comment-list>\n                    <comment-list\n                        *ngIf=\"group.commentStep\"\n                        [comments]=\"group.commentStep.comments\"\n                        [parent]=\"group.commentStep\"\n                        [showComments]=\"false\">\n                    </comment-list>\n                    <span *ngIf=\"!group.commentStep\" class=\"text-warning\">\n                        <strong>Note:</strong>\n                        Comments are disabled for this table because it has no\n                        column annotated as the comment \"host\". A subject matter\n                        expert must add the category\n                        <code>hint-comment-column</code>\n                        to exactly 1 column.\n                    </span>\n                </div>\n                <a\n                    (click)=\"menu.open = menu.open ? false : true\" class=\"menu-button comment-crumb\">\n                    <span class=\"glyphicon glyphicon-comment\"></span>\n                    <span class=\"badge\">{{group.commentCount() || 0}}</span>\n                </a>\n            </div>\n        </span>\n    </template>\n\n\n    <!-- begin COLLATED style table -->\n    <template [ngIf]=\"!group.gridStyle\">\n        <div class=\"collated\">\n        <h3 class=\"capitalized\">\n            {{group.name}}\n            <span class=\"btn-group pull-right nonprint\">\n                <button\n                    class=\"btn btn-sm btn-default\"\n                    (click)=\"group.gridStyle = true\">\n                    Switch to grid view\n                </button>\n                <button\n                    *ngIf=\"group.name === 'services'\"\n                    class=\"btn btn-sm btn-warning\"\n                    (click)=\"sort('adm-q-service-dates')\">\n                    Sort by service dates\n                </button>\n                <button\n                    type=\"button\"\n                    class=\"btn btn-sm btn-danger\"\n                    (click)=\"clearAll()\"\n                    [disabled]=\"group?.size < 2\">\n                    Clear all\n                    <span class=\"glyphicon glyphicon-remove\"></span>\n                </button>\n                <!--<button\n                    *ngIf=\"sortLabel\"\n                    class=\"btn btn-sm btn-warning\"\n                    (click)=\"sort()\">\n                    {{sortLabel}}\n                </button>-->\n            </span>\n        </h3>\n        <div [class.has-comment]=\"group.commentCount() > 0\">\n            <div class=\"menu\" #menu [class.open]=\"menu?.open\" tabindex=\"-1\">\n                <comment-list\n                    *ngFor=\"let step of group.steps\"\n                    [comments]=\"step.comments\"\n                    [parent]=\"step\"\n                    [showNewForm]=\"false\">\n                </comment-list>\n                <comment-list\n                    *ngIf=\"group.commentStep\"\n                    [comments]=\"group.commentStep.comments\"\n                    [parent]=\"group.commentStep\"\n                    [showComments]=\"false\">\n                </comment-list>\n                <span *ngIf=\"!group.commentStep\" class=\"text-warning\">\n                    <strong>Note:</strong>\n                    Comments are disabled for this table because it has no\n                    column annotated as the comment \"host\". A subject matter\n                    expert must add the category\n                    <code>hint-comment-column</code>\n                    to exactly 1 column.\n                </span>\n            </div>\n            <a\n                (click)=\"menu.open = menu.open ? false : true\" class=\"menu-button comment-crumb\">\n                <span class=\"glyphicon glyphicon-comment\"></span>\n                <span class=\"badge\">{{group.commentCount() || 0}}</span>\n            </a>\n        </div>\n        <div\n            *ngIf=\"group.size === 0 && !group.enabled\"\n            class=\"well text-center\">\n            <h4>No entries.</h4>\n        </div>\n        <div *repeatTo=\"group.size; let i = index\" class=\"well\">\n            <table>\n                <thead>\n                    <th class=\"text-center\">\n                        <h4>Entry #{{i + 1}}</h4>\n                    </th>\n                    <th\n                        *ngIf=\"rowActions && group.enabled\"\n                        class=\"text-right row-actions\">\n                        <span class=\"btn-group\">\n                            <button\n                                *ngIf=\"i !== 0\"\n                                class=\"btn btn-default\"\n                                alt=\"Move up\"\n                                [style.width]=\"(i === group.size-1) ? '79px' : 'auto'\"\n                                (click)=\"moveRow(i, -1)\">\n                                <span class=\"glyphicon glyphicon-chevron-up\"></span>\n                            </button>\n                            <button\n                                *ngIf=\"i !== group.size-1\"\n                                class=\"btn btn-default\"\n                                alt=\"Move down\"\n                                (click)=\"moveRow(i, 1)\"\n                                [style.width]=\"(i === 0) ? '79px' : 'auto'\">\n                                <span\n                                    class=\"glyphicon glyphicon-chevron-down\">\n                                </span>\n                            </button>\n                            <button\n                                class=\"btn btn-danger\"\n                                alt=\"Remove this entry\"\n                                [disabled]=\"group.size === 1\"\n                                (click)=\"removeRow(i)\">\n                                <span class=\"glyphicon glyphicon-remove\"></span>\n                            </button>\n                        </span>\n                    </th>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let step of group.steps\">\n                        <th #head title=\"Click for description\"\n                            [id]=\"i === 0 ? step.id : step.id + ':' + i\">\n                            <div\n                                *ngIf=\"head.open\"\n                                class=\"popover right\">\n                                <div class=\"arrow\"></div>\n                                <h3\n                                    class=\"popover-title\"\n                                    (click)=\"head.open = false\">\n                                    {{step.hints.column}}\n                                    <span\n                                        class=\"glyphicon glyphicon-remove pull-right\">\n                                    </span>\n                                </h3>\n                                <div\n                                    [innerHtml]=\"step.presentation\"\n                                    class=\"popover-content\">\n                                </div>\n                            </div>\n                            <span class=\"dotted\" (click)=\"head.open = !head.open\">\n                                {{step.hints.column}}\n                            </span>\n                        </th>\n                        <td\n                            class=\"intake-step\"\n                            [class.bg-danger]=\"i >= step.control.length\">\n                            <typed-field\n                                *ngIf=\"i < step.control.length\"\n                                [input]=\"step\"\n                                [control]=\"step.control.controls[i]\"\n                                [clearButton]=\"false\"\n                                [iconTray]=\"true\"\n                                [validationTray]=\"true\"\n                                (change)=\"change($event, step)\">\n                            </typed-field>\n                            <span *ngIf=\"i >= step.control.length\">\n                                No value at index {{i}}\n                            </span>\n                        </td>\n                    </tr>\n                </tbody>\n                <tfoot>\n                    <tr>\n                        <td *ngFor=\"let step of group.steps\">\n                            <div\n                                *ngIf=\"step.control?.errors\"\n                                class=\"alert alert-danger\">\n                                <div *ngFor=\"let c of step.control.controls; let i = index\">\n                                    <template [ngIf]=\"c.errors\">\n                                        <label>Row {{i+1}}:</label>\n                                        <validation-messages [control]=\"c\">\n                                        </validation-messages>\n                                    </template>\n                                </div>\n                                <label>Column:</label>\n                                <validation-messages [control]=\"step.control\">\n                                </validation-messages>\n                            </div>\n                        </td>\n                    </tr>\n                </tfoot>\n            </table>\n        </div>\n    </div>\n    </template>\n    </template> <!-- // end tabular -->\n\n\n    <template ngSwitchCase=\"clustered\">\n        <!--<div\n            *ngIf=\"step._clusterIndex === 1\"\n            class=\"category-header\">\n            {{step.hints?.category}}\n        </div>-->\n        <h3 class=\"text-danger\">\n            {{group.name || 'unnamed'}} cluster\n            <small>(unimplemented)</small>\n        </h3>\n        <ul>\n            <li *ngFor=\"let step of group.steps\">{{step.displayName}}</li>\n        </ul>\n    </template>\n\n\n    <template ngSwitchCase=\"wrapped\">\n        <div class=\"well\">\n            <control-group\n                [group]=\"asDefault()\"\n                [rowActions]=\"rowActions\"\n                (action)=\"action.emit($event)\">\n            </control-group>\n        </div>\n    </template>\n\n\n    <template ngSwitchDefault>\n        <!--<strong class=\"text-danger\">\n            ordered group - min: {{group.min}}, max {{group.max}}\n        </strong>-->\n        <div\n            *ngFor=\"let step of group.steps\"\n\t\t\t\t\t\tclass=\"intake-step\"\n\t\t\t\t\t\t[class.inline-report]=\"step.type == 'empty'\"\n            [id]=\"step.id\"\n            [class.has-comment]=\"step.comments.length > 0\"\n            [class.faded]=\"!step.isActive\"\n            [@slowRemoval]=\"!step.isActive ? 'remove' : 'keep'\">\n            <div class=\"intake-step-id\" [title]=\"step.id\">\n                {{step.displayName}}\n                <!--<strong class=\"text-primary\">\n                    [order: {{step.order}}]\n                </strong>-->\n            </div>\n            <typed-control\n                [input]=\"step\"\n                (change)=\"answer.submitAnswer(step,  $event)\"\n                (customAnswer)=\"handleCustom($event)\">\n            </typed-control>\n            <template [ngIf]=\"!step.hints?.inline\">\n                <div class=\"menu\" #menu [class.open]=\"menu?.open\" tabindex=\"-1\">\n                    <comment-list\n                        [comments]=\"step.comments\"\n                        [parent]=\"step\">\n                    </comment-list>\n                    <div *ngIf=\"debugTools\" class=\"debug-buttons\">\n                        <button\n                            type=\"button\"\n                            class=\"btn btn-default debug-only\"\n                            (click)=\"act('explain',step)\"\n                            tabindex=\"-1\">\n                            Explain\n                        </button>\n                        <button\n                            type=\"button\"\n                            class=\"btn btn-default debug-only\"\n                            (click)=\"act('details',step)\"\n                            tabindex=\"-1\">\n                            Details\n                        </button>\n                    </div>\n                </div>\n                <a\n                    (click)=\"menu.open = menu.open ? false : true\" class=\"menu-button comment-crumb\">\n                    <span class=\"glyphicon glyphicon-comment\"></span>\n                    <span class=\"badge\">{{step.comments.length || 0}}</span>\n                </a>\n            </template>\n        </div>\n    </template>\n</div>";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var CopyableLiteralComponent = (function () {
	    function CopyableLiteralComponent(alerts) {
	        this.alerts = alerts;
	    }
	    CopyableLiteralComponent.prototype.tryCopy = function () {
	        var _this = this;
	        navigator['clipboard'].writeText("" + this.value).then(function () {
	            _this.alerts.notify("Copied \"" + _this.value + "\" to your clipboard!");
	        });
	    };
	    CopyableLiteralComponent.prototype.ngOnInit = function () {
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], CopyableLiteralComponent.prototype, "value", void 0);
	    CopyableLiteralComponent = __decorate([
	        core_1.Component({
	            selector: "copyable-literal",
	            template: "\n        <pre\n            class=\"literal\"\n            (click)=\"tryCopy()\"\n            title=\"Click to copy\"\n            >{{value}}</pre>\n    ",
	            styles: ["\n        pre {\n            margin-bottom: 0px;\n        }\n        pre:active {\n            background-color: #bedefa;\n        }\n    "]
	        }),
	        __metadata("design:paramtypes", [alert_service_1.AlertService])
	    ], CopyableLiteralComponent);
	    return CopyableLiteralComponent;
	}());
	exports.CopyableLiteralComponent = CopyableLiteralComponent;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var setting_service_1 = __webpack_require__(690);
	var functions_1 = __webpack_require__(206);
	var typed_data_1 = __webpack_require__(69);
	var SortState;
	(function (SortState) {
	    SortState[SortState["Unsorted"] = -1] = "Unsorted";
	    SortState[SortState["Ascending"] = 0] = "Ascending";
	    SortState[SortState["Descending"] = 1] = "Descending";
	})(SortState = exports.SortState || (exports.SortState = {}));
	exports.REVERSE_SORT_INDICATOR = "↑";
	var DataSortingHeaderComponent = (function () {
	    function DataSortingHeaderComponent(settings) {
	        this.settings = settings;
	        this.autorun = false;
	        this.runOnChange = false;
	    }
	    Object.defineProperty(DataSortingHeaderComponent.prototype, "sorts", {
	        set: function (target) {
	            if (this._sorts !== target) {
	                this._sorts = target;
	                if (this.runOnChange) {
	                    this.trySort();
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DataSortingHeaderComponent.prototype.initiateSort = function () {
	        this.trySort();
	        if (this.storedAs) {
	            if (this.state === SortState.Descending) {
	                this.settings.set(this.storedAs, exports.REVERSE_SORT_INDICATOR + this.dot);
	            }
	            else {
	                this.settings.set(this.storedAs, this.dot);
	            }
	        }
	    };
	    DataSortingHeaderComponent.prototype.trySort = function () {
	        var state = this.state;
	        if (state === SortState.Ascending) {
	            this.sort(true);
	            this.state = SortState.Descending;
	        }
	        else {
	            this.sort();
	            this.state = SortState.Ascending;
	        }
	    };
	    Object.defineProperty(DataSortingHeaderComponent.prototype, "state", {
	        get: function () {
	            if (this._sorts._sort && this._sorts._sort.dot === this.dot) {
	                return +this._sorts._sort.state;
	            }
	            return SortState.Unsorted;
	        },
	        set: function (value) {
	            this._sorts._sort = { dot: this.dot, state: value };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DataSortingHeaderComponent.prototype.ngOnInit = function () {
	        if (!Array.isArray(this._sorts)
	            || (this._sorts.length > 0 && (typeof this._sorts[0] !== "object"))) {
	            console.error(this._sorts);
	            throw new Error("Must point 'sorts' attribute at object array!");
	        }
	        var runNow = this.autorun === true;
	        if (this.storedAs) {
	            var savedSortColumn = this.settings.getOr(this.storedAs, "");
	            console.warn("column sort for " + this.dot + " =? " + savedSortColumn + " (" + (savedSortColumn === this.dot) + " " + (savedSortColumn === exports.REVERSE_SORT_INDICATOR + this.dot) + ")");
	            if (savedSortColumn === this.dot) {
	                runNow = true;
	            }
	            if (savedSortColumn === exports.REVERSE_SORT_INDICATOR + this.dot) {
	                runNow = true;
	                this.state = SortState.Ascending;
	            }
	        }
	        if (runNow) {
	            this.trySort();
	        }
	    };
	    DataSortingHeaderComponent.prototype.access = function (host) {
	        return functions_1.dot(host, this.dot);
	    };
	    DataSortingHeaderComponent.prototype.sort = function (reverse) {
	        var _this = this;
	        if (reverse === void 0) { reverse = false; }
	        this._sorts.sort(function (a, b) {
	            var aData = _this.access(a);
	            var bData = _this.access(b);
	            if (_this.asType) {
	                aData = { value: aData, type: _this.asType };
	                bData = { value: bData, type: _this.asType };
	            }
	            else {
	                if (!typed_data_1.TypedData.hasProperties(aData)) {
	                    aData = { value: aData, type: typed_data_1.TypedData.guessType(aData) };
	                }
	                if (!typed_data_1.TypedData.hasProperties(bData)) {
	                    bData = { value: bData, type: typed_data_1.TypedData.guessType(bData) };
	                }
	            }
	            var delta = typed_data_1.TypedData.compare(aData, bData);
	            return reverse ? -delta : delta;
	        });
	        if (this.after) {
	            this.after.afterSort();
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], DataSortingHeaderComponent.prototype, "sorts", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DataSortingHeaderComponent.prototype, "dataProp", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DataSortingHeaderComponent.prototype, "dot", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DataSortingHeaderComponent.prototype, "asType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], DataSortingHeaderComponent.prototype, "after", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], DataSortingHeaderComponent.prototype, "autorun", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], DataSortingHeaderComponent.prototype, "runOnChange", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DataSortingHeaderComponent.prototype, "storedAs", void 0);
	    DataSortingHeaderComponent = __decorate([
	        core_1.Component({
	            selector: "th[sorts], td[sorts], th>span[sorts]",
	            template: "\n        <span\n            class=\"glyphicon\"\n            [class.glyphicon-chevron-up]=\"state === 1\"\n            [class.glyphicon-chevron-down]=\"state === 0\">\n        </span>\n        <span\n            (click)=\"initiateSort()\"\n            class=\"dotted\"\n            title=\"Click to change the column sorting method\">\n            <ng-content></ng-content>\n        </span>\n    ",
	            styles: [".dotted {border-bottom: 1px dotted #555;}"]
	        }),
	        __metadata("design:paramtypes", [setting_service_1.SettingService])
	    ], DataSortingHeaderComponent);
	    return DataSortingHeaderComponent;
	}());
	exports.DataSortingHeaderComponent = DataSortingHeaderComponent;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var setting_service_1 = __webpack_require__(690);
	var control_builder_1 = __webpack_require__(699);
	var typed_data_1 = __webpack_require__(69);
	var collaboration_service_1 = __webpack_require__(750);
	var intake_step_service_1 = __webpack_require__(751);
	var algorithm_service_1 = __webpack_require__(213);
	var TypedControlComponent = (function () {
	    function TypedControlComponent(controlBuilder, settings, hostElement, collaboration, intakes, algorithms) {
	        this.controlBuilder = controlBuilder;
	        this.settings = settings;
	        this.hostElement = hostElement;
	        this.collaboration = collaboration;
	        this.intakes = intakes;
	        this.algorithms = algorithms;
	        this.clearButton = true;
	        this.iconTray = true;
	        this.validationTray = true;
	        this.disableRestrictions = false;
	        this.customAnswer = new core_1.EventEmitter();
	    }
	    TypedControlComponent.prototype.ngOnInit = function () {
	        if (!this.input) {
	            throw new Error("Typed-control must have a defined 'input' attribute");
	        }
	        if (!this.input.id && !this.input.name) {
	            throw new Error("Input is expected to have either a name or an ID");
	        }
	        typed_data_1.TypedData.applyDefaults(this.input);
	        if (this.input.control) {
	            this.control = this.input.control;
	        }
	        else {
	            if (this.requiresControl(this.input.type) && !this.control) {
	                throw new Error("TypedControl must supply a control for type " + this.input.type);
	            }
	        }
	    };
	    TypedControlComponent.prototype.addSubfield = function () {
	        var value = (this.input.type === "natural number") ? 1 : null;
	        this.controlBuilder.extend(this, value);
	    };
	    TypedControlComponent.prototype.removeSubfield = function (i) {
	        this.controlBuilder.remove(this, i);
	        this.manualChange();
	    };
	    TypedControlComponent.prototype.manualChange = function () {
	        this.hostElement.nativeElement.dispatchEvent(new Event("change", { bubbles: true }));
	    };
	    TypedControlComponent.prototype.requiresControl = function (type) {
	        return !(type === "json" || type === "empty");
	    };
	    TypedControlComponent.prototype.addReminderForDate = function (event) {
	        if (this.input.type !== "date") {
	            return;
	        }
	        event.targetDate = this.control.value;
	    };
	    TypedControlComponent.prototype.changeCustom = function (e, name) {
	        this.customAnswer.emit([name, e]);
	        e.stopPropagation();
	        return false;
	    };
	    TypedControlComponent.prototype.cheaty_fcwiHouseholdEnabled = function () {
	        var householdStep = this.intakes.findNamed("q-fcwi-estimated-earned-monthly-household");
	        return !!householdStep && !!householdStep.isActive;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedControlComponent.prototype, "input", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedControlComponent.prototype, "hints", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedControlComponent.prototype, "default", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.AbstractControl)
	    ], TypedControlComponent.prototype, "control", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedControlComponent.prototype, "clearButton", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedControlComponent.prototype, "iconTray", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedControlComponent.prototype, "validationTray", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedControlComponent.prototype, "disableRestrictions", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], TypedControlComponent.prototype, "customAnswer", void 0);
	    __decorate([
	        core_1.HostListener("keydown.control.m", ["$event"]),
	        core_1.HostListener("keydown.meta.m", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], TypedControlComponent.prototype, "addReminderForDate", null);
	    TypedControlComponent = __decorate([
	        core_1.Component({
	            selector: "typed-control",
	            template: "\n  <template [ngIf]=\"!input?.hints?.specialPresentation\">\n    <template [ngIf]=\"input?.type\">\n      <div *ngIf=\"input.type !== 'boolean'\" class=\"form-group\">\n        <div\n          *ngIf=\"input.presentation\"\n          [innerHtml]=\"input.presentation\"\n          class=\"presentation\"\n          [class.renderSpacing]=\"input.hints?.inline\">\n        </div>\n\n        <!-- *** RESTRICTED [any] *** -->\n        <div *ngIf=\"input.restrictions?.length > 0\">\n          <!-- *** restricted SINGLE-[any] *** -->\n          <div *ngIf=\"input.cardinality === 1\" class=\"restricted\">\n            <typed-field\n              [input]=\"input\"\n              [control]=\"control\"\n              [clearButton]=\"clearButton\"\n              [iconTray]=\"iconTray\"\n\t\t\t\t\t\t\t[validationTray]=\"validationTray\"\n\t\t\t\t\t\t\t[disableRestrictions]=\"disableRestrictions\">\n            </typed-field>\n          </div>\n\n          <!-- *** restricted MULTI-UNIQUE-[any] *** -->\n          <div\n            *ngIf=\"input.cardinality !== 1 && !input.allowsDuplicates\"\n            class=\"restricted multi\">\n            <typed-field\n              [input]=\"input\"\n              [control]=\"control\"\n              [clearButton]=\"clearButton\"\n              [iconTray]=\"iconTray\"\n              [validationTray]=\"validationTray\">\n            </typed-field>\n          </div>\n\n        <!-- *** restricted MULTI-LIST-[any] *** -->\n          <div\n            *ngIf=\"input.cardinality !== 1 && input.allowsDuplicates\"\n            class=\"restricted multi\">\n            <div\n              *ngFor=\"let field of control.controls; let i = index\">\n              <typed-field\n                [input]=\"input\"\n                [control]=\"field\"\n                [index]=\"i\"\n                [clearButton]=\"clearButton\"\n                [iconTray]=\"iconTray\"\n                [validationTray]=\"validationTray\">\n              </typed-field>\n            </div> <!-- /input group -->\n          </div>\n        </div>\n\n        <!-- *** UNRESTRICTED [any] *** -->\n        <div\n          *ngIf=\"!(input.restrictions?.length > 0)\"\n          [ngSwitch]=\"input.type\"\n          [class]=\"input.type\">\n\n          <!-- JSON (DISPLAY ONLY atm) -->\n          <template ngSwitchCase=\"json\">\n            <!-- <typed-field\n                [input]=\"input\"\n                [control]=\"control\"\n                [clearButton]=\"false\"\n                [listActions]=\"false\"\n                [iconTray]=\"iconTray\"\n                [validationTray]=\"validationTray\">\n            </typed-field> -->\n            <prettyjson [obj]=\"input.value\"></prettyjson>\n          </template>\n\n          <!-- EMPTY -->\n          <template ngSwitchCase=\"empty\">\n            <!-- no content! -->\n          </template>\n\n          <template ngSwitchDefault>\n            <div *ngIf=\"input.cardinality === 1\" class=\"scalar\">\n              <typed-field\n                [input]=\"input\"\n                [control]=\"control\"\n                [clearButton]=\"clearButton\"\n                [iconTray]=\"iconTray\"\n                [validationTray]=\"validationTray\">\n              </typed-field>\n            </div>\n            <div\n              *ngFor=\"let field of control.controls; let i = index\"\n              class=\"vector\">\n              <typed-field\n                [input]=\"input\"\n                [control]=\"field\"\n                [index]=\"i\"\n                [listActions]=\"true\"\n                [clearButton]=\"clearButton\"\n                [iconTray]=\"iconTray\"\n                [validationTray]=\"validationTray\">\n              </typed-field>\n            </div>\n          </template>\n\n        </div>\n      </div> <!-- /form-group -->\n\n      <table *ngIf=\"input.type === 'boolean' && !input?.hints?.useSubmitWithValue\">\n        <tbody><tr>\n          <td class=\"presentation boolean-presentation\" [innerHtml]=\"input?.presentation\"></td>\n          <td class=\"boolean\">\n            <!-- *** UNRESTRICTED BOOLEAN *** -->\n            <!-- booleans are always unrestricted (and so far, arity of one) -->\n            <typed-field\n              *ngIf=\"input.cardinality === 1\"\n              [input]=\"input\"\n              [control]=\"control\"\n              [iconTray]=\"false\"\n              [clearButton]=\"false\"\n              [validationTray]=\"validationTray\">\n            </typed-field>\n\n            <!-- initial hackneyed multi-boolean -->\n            <div *ngIf=\"input.cardinality !== 1\"> <!--input.cardinality !== 1-->\n              <div\n                *ngFor=\"let field of control.controls; let i = index\">\n                <typed-field\n                  [input]=\"input\"\n                  [control]=\"field\"\n                  [index]=\"i\"\n                  [iconTray]=\"false\"\n                  listActions=\"remove\"\n                  [clearButton]=\"false\"\n                  [validationTray]=\"validationTray\">\n                </typed-field>\n              </div>\n            </div>\n          </td>\n        </tr></tbody>\n      </table>\n\n      <div *ngIf=\"input.type === 'boolean' && input?.hints?.useSubmitWithValue\">\n        <button (click)=\"manualSetAndChange(input?.hints?.useSubmitWithValue)\" [innerHtml]=\"input?.presentation || 'Submit'\" class=\"btn btn-success form-control booleanSubmit\" [disabled]=\"input?.value == input?.hints?.useSubmitWithValue\"></button>\n      </div>\n\n      <!-- cardinality control -->\n      <div class=\"size-controls\">\n        <button *ngIf=\"input.cardinality === 0 && input.allowsDuplicates && input.hints.editable !== false\"\n          type=\"button\"\n          class=\"btn btn-success match-rwidth\"\n          (click)=\"addSubfield()\">\n          Add field...\n        </button>\n      </div>\n    </template>\n    <h4 *ngIf=\"!(input?.type)\" class=\"bg-warning text-danger\">\n      Input has no type!\n    </h4>\n</template>\n<div *ngIf=\"input?.hints?.specialPresentation === 'fcwi-income-table'\" class=\"form-group special-income-section\" (change)=\"changeCustom($event, 'fcwi-income-table')\">\n\t<div><h4>About how much do you and the other people in your household make per month?</h4>\n  <p>Enter the approximate amounts in this table. Note that many programs distinguish between <em>earned</em> and <em>unearned</em> income:</p>\n  <ul>\n    <li><em>Earned income</em> is generally what you make from \"work activities\" such as wages, salary, tips, long-term disability, employer reimbursements, and your net earnings from self-employment.</li>\n    <li><em>Unearned income</em> is what you get from passive and not work sources, like social security, SSI, unemployment pay, retirement funds, gifts & inheritance, student financial aid, capital gains & loan interest, etc.</li>\n  </ul>\n  <p>If you aren't sure which category something falls into, take your best guess for now, and then be sure to mention it to the advocates or agents working with you.</p>\n</div>\n\t<table class=\"table special-income-table\">\n\t\t<tr>\n      <th></th>\n      <th>Earned (Work)</th>\n      <th>Unearned (Non-work)</th>\n    </tr>\n    <tr>\n        <th>You</th>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\" id=\"q-fcwi-estimated-earned-monthly-income\"> </td>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\" id=\"q-fcwi-estimated-unearned-monthly-income\"> </td>\n    </tr>\n    <!--<tr>\n        <th>Your spouse</th>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\"> </td>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\"> </td>\n    </tr>-->\n    <tr>\n        <th>Your dependents</th>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\" id=\"q-fcwi-estimated-earned-monthly-household\" [disabled]=\"!cheaty_fcwiHouseholdEnabled()\"> </td>\n        <td> <input autocomplete=\"off\" class=\"form-control\" placeholder=\"Enter number.\" step=\"1\" type=\"number\" min=\"1\" id=\"q-fcwi-estimated-unearned-monthly-household\" [disabled]=\"!cheaty_fcwiHouseholdEnabled()\"> </td>\n    </tr>\n  </table>\n  </div>\n",
	            styles: [
	                "fieldset {\n      position: relative;\n    }\n    .restricted.multi {\n      margin-top: 15px;\n      position: relative;\n    }\n    .minor-instruction {\n      display: block;\n      position: absolute;\n      right: 0px;\n      top: -15px;\n    }\n    .restricted select {\n      overflow-y: auto;\n    }\n    .match-rwidth {\n      width: 15%;\n      min-width: 175px;\n    }\n    .btn-success.match-rwidth {\n      /* TODO: make this semantic (add_subfield class?) */\n      /*float: right;*/\n    }\n    .size-controls {\n      width: 100%;\n      text-align: right;\n    }\n    .vector+.vector {\n      margin-top: 10px;\n    }\n    table, tr {\n      width: 100%;\n    }\n    td.presentation {\n      vertical-align: middle;\n    }\n    td.boolean {\n      width: 180px;\n      text-align: right;\n      padding-bottom: 10px;\n    }\n    .renderSpacing {\n      white-space: pre-wrap;\n    }\n    .booleanSubmit {\n      margin-bottom: 1em;\n    }\n    .special-income-section {\n      opacity: 90%;\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [control_builder_1.IntakeControlBuilder,
	            setting_service_1.SettingService,
	            core_1.ElementRef,
	            collaboration_service_1.CollaborationService,
	            intake_step_service_1.IntakeStepService,
	            algorithm_service_1.AlgorithmService])
	    ], TypedControlComponent);
	    return TypedControlComponent;
	}());
	exports.TypedControlComponent = TypedControlComponent;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var algorithm_service_1 = __webpack_require__(213);
	var intake_step_service_1 = __webpack_require__(751);
	var collaborator_1 = __webpack_require__(753);
	var alert_service_1 = __webpack_require__(689);
	var messages_1 = __webpack_require__(754);
	var collaboration_1 = __webpack_require__(592);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var chat_entry_1 = __webpack_require__(755);
	var setting_service_1 = __webpack_require__(690);
	var sounds_service_1 = __webpack_require__(756);
	var extension_signal_request_1 = __webpack_require__(597);
	var general_1 = __webpack_require__(513);
	var user_service_1 = __webpack_require__(713);
	var rules_1 = __webpack_require__(640);
	var CollaborationService = (function () {
	    function CollaborationService(messaging, alerts, algorithms, intakeSteps, settings, sounds, userSvc) {
	        var _this = this;
	        this.messaging = messaging;
	        this.alerts = alerts;
	        this.algorithms = algorithms;
	        this.intakeSteps = intakeSteps;
	        this.settings = settings;
	        this.sounds = sounds;
	        this.userSvc = userSvc;
	        this.userMap = new Map();
	        this.users = [];
	        this.userEvents = new Rx_1.Subject();
	        this.chatEnabled = true;
	        this.chatMessages = [];
	        this.chatPokes = new Rx_1.Subject();
	        this.cached_useClientExtensions = false;
	        this.myLock = -1;
	        this.myLockTable = null;
	        this.locksByUser = new Map();
	        this.lastLockCommandByUser = new Map();
	        this.locks = new Set();
	        this.tableLocks = new Set();
	        this.tableLocksByFocusedStep = new Map();
	        this.lastLocker = new Map();
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	        this.algorithms.runningObservable.subscribe(function (running) { return running ? null : _this.clear(); });
	    }
	    CollaborationService.prototype.get = function (id) {
	        return this.userMap.get(id);
	    };
	    CollaborationService.prototype.nametag = function (user) {
	        return user.name + " [" + (user.org || "unknown organization") + "]";
	    };
	    CollaborationService.prototype.clear = function () {
	        this.userMap.clear();
	        this.users = [];
	        this.chatMessages = [];
	        this.chatEnabled = true;
	    };
	    CollaborationService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(messages_1.MessageTag.BCST_ALGORITHM_USERS).subscribe(function (message) { return _this.receiveUsers(message); });
	        this.messaging.receive(messages_1.MessageTag.RSP_SAVE).subscribe(function (message) { return _this.receiveSave(message); });
	        this.messaging.receive(messages_1.MessageTag.BCST_CHAT_MESSAGE).subscribe(function (message) { return _this.receiveChat(message); });
	        this.messaging.receive(messages_1.MessageTag.BCST_EXTENSION_SIGNAL)
	            .filter(isIntakeLock).subscribe(function (msg) {
	            return _this.receiveLockCommand(msg);
	        });
	        this.messaging.receive(messages_1.MessageTag.RSP_SUBJECT_CONTEXT).subscribe(function () { return _this.clearLocks(); });
	        this.userSvc.ready.subscribe(function (ready) {
	            _this.cached_useClientExtensions = ready &&
	                _this.userSvc.self.hasRule(rules_1.Rule.USE_CLIENT_EXTENSIONS);
	        });
	    };
	    CollaborationService.prototype.receiveUsers = function (message) {
	        var changes = false;
	        changes = changes || this.departure(message.removedId);
	        changes = changes || this.arrivals(message.users);
	        this.syncMap(message.users);
	        this.userEvents.next(changes);
	    };
	    CollaborationService.prototype.getSortedUniqueArray = function () {
	        var usersWithRepeats = this.userMap.values();
	        var uniqueUsers = Array.from(usersWithRepeats)
	            .filter(function (u, i, a) { return a.indexOf(u) === i; });
	        return collaborator_1.Collaborator.sort(uniqueUsers);
	    };
	    CollaborationService.prototype.departure = function (id) {
	        if (id === null) {
	            return false;
	        }
	        if (!this.userMap.has(id)) {
	            return false;
	        }
	        var user = this.userMap.get(id);
	        var nametag = this.nametag(user);
	        this.alerts.userInfo(nametag + " has stopped editing this subject");
	        this.chatPokes.next(true);
	        this.chatMessages.push(chat_entry_1.ChatEntry.leave(user.name, user.org));
	        this.unlockByUser(id);
	        return true;
	    };
	    CollaborationService.prototype.arrivals = function (userList) {
	        var _this = this;
	        var isInitial = (this.userMap.size === 0);
	        var additions = [];
	        userList.forEach(function (user) {
	            if (user.userId.every(function (id) { return !_this.userMap.has(id); })) {
	                additions.push(user);
	                if (!isInitial) {
	                    _this.chatPokes.next(true);
	                    _this.chatMessages.push(chat_entry_1.ChatEntry.join(user.name, user.org));
	                }
	            }
	        });
	        if (additions.length === 0) {
	            return false;
	        }
	        if (isInitial) {
	            if (additions.length > 1) {
	                this.alerts.userInfo("This subject has " + additions.length + " users editing it");
	                return true;
	            }
	            return false;
	        }
	        else {
	            if (additions.length > 1) {
	                this.alerts.userInfo(additions.length + " other users have begun editing this subject");
	            }
	            else {
	                var user = additions[0];
	                var nametag = this.nametag(user);
	                this.alerts.userInfo(nametag + " has begun editing this document");
	            }
	        }
	        if (this.soundsEnabled()) {
	            this.sounds.playSound("arrive");
	        }
	        if (this.myLock !== -1) {
	            this.sendCurrentLock();
	        }
	        return true;
	    };
	    CollaborationService.prototype.soundsEnabled = function () {
	        return this.settings.get("sounds enabled") || false;
	    };
	    CollaborationService.prototype.syncMap = function (userList) {
	        var _this = this;
	        this.userMap.clear();
	        userList.forEach(function (user) {
	            user.userId.forEach(function (id) { return _this.userMap.set(id, user); });
	        });
	        this.users = this.getSortedUniqueArray();
	    };
	    CollaborationService.prototype.receiveSave = function (message) {
	        if (!this.userMap.has(message.userId)) {
	            throw new Error("Received a save event from a user not in the local user list!");
	        }
	        var user = this.userMap.get(message.userId);
	        var nametag = this.nametag(user);
	        this.alerts.notify(nametag + " saved the form!");
	        this.algorithms.running.lastExternalSave = new Date();
	    };
	    CollaborationService.prototype.disconnected = function () { };
	    CollaborationService.prototype.receiveChat = function (message) {
	        var author = this.get(message.userId);
	        if (author === undefined) {
	            throw new Error("Received chat from unknown userid: " + message.userId);
	        }
	        if (this.soundsEnabled()) {
	            this.sounds.playSound("chat");
	        }
	        this.chatPokes.next(true);
	        this.chatMessages.push(new chat_entry_1.ChatEntry(message.message, author.name, author.org));
	    };
	    CollaborationService.prototype.sendChat = function (text, pushSelf) {
	        var _this = this;
	        if (pushSelf === void 0) { pushSelf = true; }
	        return this.messaging.resultOf(new collaboration_1.PostChatMessageRequest(text)).do(function (sent) {
	            if (sent && pushSelf) {
	                _this.chatMessages.push(new chat_entry_1.ChatEntry(text, "Me"));
	            }
	        });
	    };
	    CollaborationService.prototype.userCanSendLocks = function () {
	        return this.cached_useClientExtensions;
	    };
	    CollaborationService.prototype.sendStepLock = function (id, table) {
	        var _this = this;
	        if (table === void 0) { table = null; }
	        if (!this.userCanSendLocks() || this.users.length === 0) {
	            return;
	        }
	        if (id === this.myLock) {
	            console.warn("Skipping redundant lock for id " + id);
	        }
	        else {
	            this.messaging.send(new extension_signal_request_1.ExtensionSignalRequest(new IntakeLockPayload(id, table))).subscribe(function (r) {
	                if (general_1.AcknowledgmentResponse.isOk(r)) {
	                    _this.myLock = id;
	                }
	            });
	        }
	    };
	    CollaborationService.prototype.sendCurrentLock = function () {
	        if (!this.userCanSendLocks() || this.users.length === 0) {
	            return;
	        }
	        if (this.myLock === -1) {
	            throw Error("No lock currently set... cannot resend update.");
	        }
	        this.messaging.send(new extension_signal_request_1.ExtensionSignalRequest(new IntakeLockPayload(this.myLock, this.myLockTable))).subscribe();
	    };
	    CollaborationService.prototype.sendUnlock = function () {
	        var _this = this;
	        if (!this.userCanSendLocks()) {
	            return;
	        }
	        if (this.myLock === -1) {
	            console.warn("Skipping redundant unlock ");
	        }
	        else {
	            this.messaging.send(new extension_signal_request_1.ExtensionSignalRequest(new IntakeLockPayload())).subscribe(function (r) {
	                if (general_1.AcknowledgmentResponse.isOk(r)) {
	                    _this.myLock = -1;
	                }
	            });
	        }
	    };
	    CollaborationService.prototype.unlockByUser = function (userId) {
	        var toRemove = this.locksByUser.get(userId);
	        this.locks.delete(toRemove);
	        this.locksByUser.delete(userId);
	        var removedTable = this.tableLocksByFocusedStep.get(toRemove);
	        if (removedTable !== undefined) {
	            this.tableLocks.delete(removedTable);
	            this.tableLocksByFocusedStep.delete(toRemove);
	        }
	    };
	    CollaborationService.prototype.lockByUser = function (userId, stepId, tableName) {
	        this.locksByUser.set(userId, stepId);
	        this.lastLocker.set(stepId, userId);
	        this.locks.add(stepId);
	        if (tableName) {
	            this.tableLocks.add(tableName);
	            this.tableLocksByFocusedStep.set(stepId, tableName);
	            this.lastLocker.set(tableName, userId);
	        }
	    };
	    CollaborationService.prototype.receiveLockCommand = function (msg) {
	        var lastCommandId = this.lastLockCommandByUser.get(msg.senderId) || -1;
	        if (msg.payload.commandId > lastCommandId) {
	            this.unlockByUser(msg.senderId);
	            if (msg.payload.stepId > -1) {
	                this.lockByUser(msg.senderId, msg.payload.stepId, msg.payload.stepTableName);
	            }
	            this.lastLockCommandByUser.set(msg.senderId, msg.payload.commandId);
	        }
	        else {
	            console.warn("Ignoring out-of-order lock command:", msg);
	        }
	    };
	    CollaborationService.prototype.clearLocks = function () {
	        this.myLock = -1;
	        this.myLockTable = null;
	        this.locksByUser.clear();
	        this.lastLockCommandByUser.clear();
	        this.locks.clear();
	        this.tableLocks.clear();
	        this.tableLocksByFocusedStep.clear();
	        this.lastLocker.clear();
	    };
	    CollaborationService.prototype.findUserIdByLock = function (stepId, table) {
	        if (this.lastLocker.has(stepId)) {
	            return this.get(this.lastLocker.get(stepId));
	        }
	        else if (table && this.lastLocker.has(table)) {
	            return this.get(this.lastLocker.get(table));
	        }
	        return undefined;
	    };
	    __decorate([
	        decorators_1.onDisconnect(),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], CollaborationService.prototype, "clear", null);
	    CollaborationService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService,
	            intake_step_service_1.IntakeStepService,
	            setting_service_1.SettingService,
	            sounds_service_1.SoundsService,
	            user_service_1.UserService])
	    ], CollaborationService);
	    return CollaborationService;
	}());
	exports.CollaborationService = CollaborationService;
	function isIntakeLock(msg) {
	    return msg.payload.name === INTAKE_LOCK_NAME;
	}
	var lockCommandIncrementor = 0;
	var INTAKE_LOCK_NAME = "intake-step-lock";
	var IntakeLockPayload = (function () {
	    function IntakeLockPayload(stepId, table) {
	        if (stepId === void 0) { stepId = -1; }
	        if (table === void 0) { table = null; }
	        this.stepId = stepId;
	        this.name = INTAKE_LOCK_NAME;
	        this.version = [0, 1, 1];
	        this.commandId = lockCommandIncrementor++;
	        if (table) {
	            this.stepTableName = table;
	        }
	    }
	    return IntakeLockPayload;
	}());


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var algorithms_1 = __webpack_require__(576);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var structure_1 = __webpack_require__(581);
	var algorithm_service_1 = __webpack_require__(213);
	var step_facade_1 = __webpack_require__(752);
	var IntakeStepService = (function (_super) {
	    __extends(IntakeStepService, _super);
	    function IntakeStepService(messaging, alerts, algorithms) {
	        var _this = _super.call(this, messaging, algorithms) || this;
	        _this.messaging = messaging;
	        _this.alerts = alerts;
	        _this.algorithms = algorithms;
	        return _this;
	    }
	    IntakeStepService.prototype.matchesSubtype = function (step) {
	        return (step instanceof structure_1.IntakeStep);
	    };
	    IntakeStepService.prototype.connected = function () {
	        var _this = this;
	        this.subscriptions = this.messaging.receive(general_1.MessageTag.RSP_NEXT_STEPS)
	            .flatMap(function (message) { return message.intakeSteps; })
	            .map(function (step) { return new structure_1.IntakeStep(step); })
	            .subscribe(function (step) { return _this.add(step); });
	        this.subscriptions.add(this.messaging.receive(general_1.MessageTag.UP_SUBMIT_ANSWERS)
	            .flatMap(function (message) { return message.answers; })
	            .subscribe(function (answer) { return _this.answer(answer); }));
	    };
	    IntakeStepService.prototype.disconnected = function () { };
	    IntakeStepService.prototype.all = function () {
	        this.assertRunning();
	        return this.algorithms.running.steps.intakes();
	    };
	    IntakeStepService.prototype.add = function (step) {
	        this.assertRunning();
	        this.algorithms.running.mayHaveUnexploredSteps = true;
	        this.algorithms.running.steps.define(step);
	    };
	    IntakeStepService.prototype.answer = function (answer) {
	        this.assertRunning();
	        console.log("received", answer);
	        this.algorithms.running.steps.answer(answer);
	    };
	    IntakeStepService.prototype.updates = function () {
	        this.assertRunning();
	        return this.algorithms.running.steps.updates.filter(function (update) { return ((update.matchesType(structure_1.IntakeStep))); });
	    };
	    IntakeStepService.prototype.submit = function (answers) {
	        this.assertRunning();
	        if (!Array.isArray(answers)) {
	            answers = [answers];
	        }
	        return this.messaging.send(new algorithms_1.SubmitAnswersUpstreamMessage(answers));
	    };
	    IntakeStepService.prototype.requestMore = function () {
	        var _this = this;
	        this.assertRunning();
	        var request = this.messaging.send(new algorithms_1.AdditionalStepsRequest());
	        request.subscribe(function (m) {
	            if (!m.ok) {
	                _this.algorithms.running.mayHaveUnexploredSteps = false;
	            }
	        });
	        return request;
	    };
	    IntakeStepService.prototype.deactivateAll = function () {
	        this.assertRunning();
	        this.algorithms.running.steps.intakes()
	            .forEach(function (step) { return step.isActive = false; });
	    };
	    IntakeStepService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService])
	    ], IntakeStepService);
	    return IntakeStepService;
	}(step_facade_1.StepFacade));
	exports.IntakeStepService = IntakeStepService;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var decorators_1 = __webpack_require__(517);
	var StepFacade = (function () {
	    function StepFacade(messaging, algorithms) {
	        var _this = this;
	        this.messaging = messaging;
	        this.algorithms = algorithms;
	        this.subscriptions = new Rx_1.Subscription();
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    StepFacade.prototype.disconnected = function () { };
	    StepFacade.prototype.isRunning = function () {
	        return this.algorithms.isRunning;
	    };
	    StepFacade.prototype.assertRunning = function () {
	        this.algorithms.assertRunning();
	    };
	    StepFacade.prototype.get = function (id) {
	        if (!this.isRunning()) {
	            return undefined;
	        }
	        var step = this.algorithms.running.steps.get(id);
	        return (this.matchesSubtype(step)) ? step : undefined;
	    };
	    StepFacade.prototype.findNamed = function (name) {
	        if (!this.isRunning()) {
	            return undefined;
	        }
	        var steps = this.algorithms.running.steps.filtered(function (compare) { return compare.name === name; });
	        if (steps.length !== 1) {
	            return null;
	        }
	        var step = steps[0];
	        return (this.matchesSubtype(step)) ? step : undefined;
	    };
	    StepFacade.prototype.has = function (id) {
	        if (!this.isRunning()) {
	            return false;
	        }
	        return this.matchesSubtype(this.algorithms.running.steps.get(id));
	    };
	    StepFacade.prototype.updatingSet = function () {
	        var _this = this;
	        return this.algorithms.running.steps.updates.map(function (u) { return _this.all(); });
	    };
	    __decorate([
	        decorators_1.disconnectWith("unsubscribe"),
	        __metadata("design:type", Rx_1.Subscription)
	    ], StepFacade.prototype, "subscriptions", void 0);
	    return StepFacade;
	}());
	exports.StepFacade = StepFacade;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_1 = __webpack_require__(639);
	var Collaborator = (function (_super) {
	    __extends(Collaborator, _super);
	    function Collaborator(name, userId, org) {
	        var _this = _super.call(this, name, org) || this;
	        _this.name = name;
	        _this.userId = userId;
	        _this.org = org;
	        return _this;
	    }
	    return Collaborator;
	}(user_1.User));
	exports.Collaborator = Collaborator;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	exports.Message = message_1.Message;
	var message_tag_1 = __webpack_require__(515);
	exports.MessageTag = message_tag_1.MessageTag;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChatEntry = (function () {
	    function ChatEntry(message, author, group) {
	        if (group === void 0) { group = ""; }
	        this.message = message;
	        this.author = author;
	        this.group = group;
	    }
	    ChatEntry.join = function (author, group) {
	        return Object.assign(new ChatEntry(null, author, group), { action: "joined" });
	    };
	    ChatEntry.leave = function (author, group) {
	        return Object.assign(new ChatEntry(null, author, group), { action: "left" });
	    };
	    return ChatEntry;
	}());
	exports.ChatEntry = ChatEntry;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var utilities_1 = __webpack_require__(523);
	var SoundsService = (function () {
	    function SoundsService() {
	        var _this = this;
	        this.volume = 0.3;
	        this.sampleRate = 44100;
	        this.audioFileNodes = new Map();
	        this.scale = new Scale();
	        this.activeNodes = [];
	        this.context = new AudioContext();
	        this.masterGain = this.context.createGain();
	        this.masterGain.gain.value = this.volume;
	        this.masterGain.connect(this.context.destination);
	        this.karplus = new KarplusStrongSynth(this.context);
	        setTimeout(function () { return _this.attachSounds_HACK(); }, 500);
	        this.unlockListener = function () { _this.forceAPIUnlock(); };
	        document.addEventListener("click", this.unlockListener);
	    }
	    SoundsService_1 = SoundsService;
	    SoundsService.prototype.setVolume = function (v) {
	        if (v >= 0 && v <= 1) {
	            this.volume = v;
	            this.masterGain.gain.value = v;
	        }
	    };
	    SoundsService.prototype.killNode = function (node) {
	        node.stop();
	        node.disconnect();
	        var i = this.activeNodes.indexOf(node);
	        if (i > -1) {
	            this.activeNodes.splice(i, 1);
	        }
	    };
	    SoundsService.prototype.killAll = function () {
	        this.activeNodes.forEach(function (n) {
	            n.stop();
	            n.disconnect();
	        });
	        this.activeNodes = [];
	    };
	    SoundsService.prototype.forceAPIUnlock = function () {
	        var _this = this;
	        this.context.resume().then(function () {
	            console.log("Audio context state:", _this.context.state);
	        });
	        document.removeEventListener("click", this.unlockListener);
	    };
	    SoundsService.prototype.attachSounds_HACK = function () {
	        var _this = this;
	        SoundsService_1.PreloadMedia.forEach(function (_, id) {
	            var e = document.getElementById(id);
	            if (!e) {
	                throw Error("Could not find audio element #" + id);
	            }
	            var node = _this.context.createMediaElementSource(e);
	            node.mediaElement.load();
	            node.connect(_this.masterGain);
	            _this.audioFileNodes.set(id, node);
	        });
	    };
	    SoundsService.prototype.hasSound = function (name) {
	        return this.audioFileNodes.has(name);
	    };
	    SoundsService.prototype.playSound = function (name) {
	        if (this.hasSound(name)) {
	            this.audioFileNodes.get(name).mediaElement.play();
	            console.warn(utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          attempting to play sound ", "\n          (", ")"], ["\n          attempting to play sound ", "\n          (", ")"])), name, this.audioFileNodes.get(name).mediaElement.src));
	        }
	    };
	    SoundsService.prototype.playKarplus = function (note) {
	        var f = this.scale.frequency(note);
	        var node = this.karplus.create(f);
	    };
	    SoundsService.prototype.attachAndPlay = function (node) {
	        var _this = this;
	        node.connect(this.masterGain);
	        this.activeNodes.push(node);
	        node.start();
	        node.onended = function () { return _this.killNode(node); };
	    };
	    SoundsService.prototype.quickPlay = function (note, time, shape) {
	        var _this = this;
	        if (time === void 0) { time = 0; }
	        if (shape === void 0) { shape = "sine"; }
	        var node = this.context.createOscillator();
	        node.type = shape;
	        node.frequency.value = this.scale.frequency(note);
	        this.attachAndPlay(node);
	        if (time > 0) {
	            setTimeout(function () { return _this.killNode(node); }, time);
	        }
	    };
	    SoundsService.prototype.debugTest = function () {
	        this.quickPlay("C4", 2000, "sawtooth");
	        this.quickPlay("E4", 2000, "sawtooth");
	        this.quickPlay("G4", 2000, "sawtooth");
	    };
	    var SoundsService_1;
	    SoundsService.PreloadMedia = new Map([
	        ["chat", "/static/sound/two-tone.ogg"],
	        ["arrive", "/static/sound/doorbell.ogg"]
	    ]);
	    SoundsService = SoundsService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [])
	    ], SoundsService);
	    return SoundsService;
	}());
	exports.SoundsService = SoundsService;
	var Tuning;
	(function (Tuning) {
	    Tuning[Tuning["EqualTemprament"] = 0] = "EqualTemprament";
	})(Tuning || (Tuning = {}));
	var EqualTempramentStepSize = Math.pow(2, 1 / 12);
	var Scale = (function () {
	    function Scale(aFrequency, tuning) {
	        if (aFrequency === void 0) { aFrequency = 440; }
	        if (tuning === void 0) { tuning = Tuning.EqualTemprament; }
	        this.aFrequency = aFrequency;
	        this.tuning = tuning;
	        this.defaultOctave = 4;
	    }
	    Scale.prototype.nameToMidiNumber = function (noteName) {
	        if (noteName.length === 0 || noteName.length > 3) {
	            throw Error("Note '" + noteName + "' was not between 1-3 characters");
	        }
	        var octaveRelative = Scale.KeyLetters.get(noteName[0].toLowerCase());
	        if (Scale.AccentCharacters.has(noteName[1])) {
	            octaveRelative += Scale.AccentCharacters.get(noteName[1]);
	        }
	        var octave = Number.parseInt(noteName.slice(-1), 10);
	        if (!Number.isSafeInteger(octave)) {
	            octave = this.defaultOctave;
	        }
	        return ((octave + 1) * 12) + octaveRelative;
	    };
	    Scale.prototype.midiNumberToFrequency = function (midiNumber) {
	        if (this.tuning !== Tuning.EqualTemprament) {
	            throw Error("Non equal-tempered tunings are not supported!");
	        }
	        var octaves = Math.trunc((midiNumber - 69) / 12);
	        var steps = ((midiNumber - 69) % 12) + 12;
	        return (Math.pow(2, octaves)
	            * Math.pow(EqualTempramentStepSize, steps)
	            * this.aFrequency);
	    };
	    Scale.prototype.frequency = function (noteName) {
	        return this.midiNumberToFrequency(this.nameToMidiNumber(noteName));
	    };
	    Scale.KeyLetters = new Map([
	        ["c", 0],
	        ["d", 2],
	        ["e", 4],
	        ["f", 5],
	        ["g", 7],
	        ["a", 9],
	        ["b", 11]
	    ]);
	    Scale.AccentCharacters = new Map([
	        ["♭", -1],
	        ["b", -1],
	        ["𝄫", -2],
	        ["-", -1],
	        ["♯", 1],
	        ["#", 1],
	        ["𝄪", 2],
	        ["+", 1],
	        ["♮", 0]
	    ]);
	    return Scale;
	}());
	var KarplusStrongSynth = (function () {
	    function KarplusStrongSynth(context, fadeRate) {
	        if (fadeRate === void 0) { fadeRate = 0.9; }
	        this.context = context;
	        this.fadeRate = fadeRate;
	    }
	    KarplusStrongSynth.prototype.create = function (frequency) {
	        var length = Math.floor(this.context.sampleRate / frequency);
	        var buffer = this.context.createBuffer(1, length, this.context.sampleRate);
	        var data = buffer.getChannelData(0);
	        for (var i = 0; i < length; i++) {
	            data[i] = Math.random() * 2 - 1;
	        }
	        var node = this.context.createBufferSource();
	        node.buffer = buffer;
	        return node;
	    };
	    return KarplusStrongSynth;
	}());
	function makeDistortionCurve(amount) {
	    if (amount === void 0) { amount = 20; }
	    var sampleCount = 256;
	    var curve = new Float32Array(sampleCount);
	    for (var i = 0; i < sampleCount; ++i) {
	        var x = i * 2 / sampleCount - 1;
	        curve[i] = (Math.PI + amount) * x / (Math.PI + amount * Math.abs(x));
	    }
	    return curve;
	}
	var templateObject_1;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var TypedDisplayComponent = (function () {
	    function TypedDisplayComponent() {
	    }
	    TypedDisplayComponent.prototype.specifiesSubelement = function () {
	        return Number.isInteger(this.index) && Array.isArray(this.input.value);
	    };
	    TypedDisplayComponent.prototype.arraylike = function () {
	        if (this.input.cardinality === 0 || this.input.cardinality > 1) {
	            if (this.specifiesSubelement()) {
	                return false;
	            }
	            return true;
	        }
	        return false;
	    };
	    TypedDisplayComponent.prototype.val = function () {
	        if (this.specifiesSubelement()) {
	            return this.input.value[this.index];
	        }
	        return this.input.value;
	    };
	    TypedDisplayComponent.prototype.ngOnInit = function () {
	        if (!this.input) {
	            if (!this.wrapper || this.value === undefined) {
	                throw new Error("Typed-display must have input or value-wrapper pair");
	            }
	            else {
	                this.input = Object.assign(this.wrapper, { value: this.value });
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedDisplayComponent.prototype, "input", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedDisplayComponent.prototype, "value", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedDisplayComponent.prototype, "wrapper", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], TypedDisplayComponent.prototype, "index", void 0);
	    TypedDisplayComponent = __decorate([
	        core_1.Component({
	            selector: "typed-display",
	            template: "\n    <span *ngIf=\"input?.type && input?.value !== null\" [ngSwitch]=\"input.type\">\n      <!-- NOTE: Be careful with the switch cases: the structural *-syntax has\n        been unrolled into templates to simplify the nesting of endless spans\n        as well as make the string literal comparisons easier -->\n      <template ngSwitchCase=\"date\">\n        <span *ngIf=\"!arraylike()\">\n          {{val() | utcDate}}\n        </span>\n        <span *ngIf=\"arraylike()\">\n          Non-singular dates not yet supported!\n        </span>\n      </template>\n      <template ngSwitchCase=\"datetime\">\n        <span *ngIf=\"!arraylike()\">\n          {{val() | date:'medium'}}\n        </span>\n        <span *ngIf=\"arraylike()\">\n          Non-singular datetimes not yet supported!\n        </span>\n      </template>\n      <template ngSwitchCase=\"boolean\">\n        <span *ngIf=\"!arraylike()\">\n         {{val() ? 'yes' : 'no'}}\n        </span>\n        <span *ngIf=\"arraylike()\">\n          Non-singular booleans not yet supported!\n        </span>\n      </template>\n      <template ngSwitchDefault>\n        <span *ngIf=\"!arraylike()\">\n          {{val()}}\n        </span>\n        <span *ngIf=\"arraylike()\">\n          <!-- NOTE: the parens before and after are HTML string (literals) -->\n          ({{(val() | join) || \" \"}})\n        </span>\n      </template>\n    </span>\n    <span *ngIf=\"input?.type && input?.value === null\">\n      <em>No value</em>\n    </span>\n    <h4 class=\"text-danger\" *ngIf=\"!(input?.type)\">\n      Input does not have a defined type!\n    </h4>\n",
	            styles: []
	        })
	    ], TypedDisplayComponent);
	    return TypedDisplayComponent;
	}());
	exports.TypedDisplayComponent = TypedDisplayComponent;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var functions_1 = __webpack_require__(206);
	var typed_control_component_1 = __webpack_require__(749);
	var typed_data_1 = __webpack_require__(69);
	var collaboration_service_1 = __webpack_require__(750);
	var intake_step_service_1 = __webpack_require__(751);
	var rxjs_1 = __webpack_require__(214);
	var TypedFieldComponent = (function () {
	    function TypedFieldComponent(tcc, renderer, hostRef, collaboration, intakes) {
	        this.tcc = tcc;
	        this.renderer = renderer;
	        this.hostRef = hostRef;
	        this.collaboration = collaboration;
	        this.intakes = intakes;
	        this.restrictionDisplayLimit = 8;
	        this.clearButton = true;
	        this.validationTray = true;
	        this.iconTray = true;
	        this.listActions = false;
	        this.index = 0;
	        this.disableRestrictions = false;
	        this.deprecatedValues = [];
	        this.subscriptions = new rxjs_1.Subscription();
	        if (tcc === null) {
	        }
	    }
	    TypedFieldComponent_1 = TypedFieldComponent;
	    TypedFieldComponent.prototype.clearEnabled = function () {
	        if (this.input.hints && this.input.hints.editable === false) {
	            return false;
	        }
	        return this.clearButton;
	    };
	    TypedFieldComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        typed_data_1.TypedData.applyDefaults(this.input);
	        if (this.input.restrictions.length) {
	            var val = this.input.value || this.control.value;
	            if (this.input.cardinality === 1) {
	                if (val !== null
	                    && this.input.restrictions.indexOf(val) === -1) {
	                    this.deprecatedValues = [val];
	                }
	            }
	            else {
	                if (Array.isArray(val)) {
	                    this.deprecatedValues = val.filter(function (value, index) {
	                        return _this.input.restrictions.indexOf(value) === -1
	                            && _this.input.value.indexOf(value) === index;
	                    });
	                }
	                if (this.input.allowsDuplicates) {
	                    this.restrictionDisplayLimit = 4;
	                }
	                else {
	                    this.infoMessageHTML = functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Hold <kbd>CTRL</kbd> or\n                        <kbd>CMD</kbd> to select multiple."], ["Hold <kbd>CTRL</kbd> or\n                        <kbd>CMD</kbd> to select multiple."])));
	                }
	            }
	        }
	        this.setUpDifferenceCheck();
	    };
	    TypedFieldComponent.prototype.ngOnDestroy = function () {
	        this.subscriptions.unsubscribe();
	    };
	    TypedFieldComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.contentHeight = _this.contentRef.nativeElement.offsetHeight;
	        }, 250);
	    };
	    TypedFieldComponent.prototype.setUpDifferenceCheck = function () {
	        var _this = this;
	        if (this.input.hints.highlightDifferenceWith) {
	            this.subscriptions.add(this.control.valueChanges.subscribe(function () { return _this.checkForDifferenceHighlight(); }));
	            var comparison = this.intakes.findNamed(this.input.hints.highlightDifferenceWith);
	            this.subscriptions.add(comparison.control.valueChanges.subscribe(function () { return _this.checkForDifferenceHighlight(); }));
	            this.checkForDifferenceHighlight();
	        }
	    };
	    TypedFieldComponent.prototype.checkForDifferenceHighlight = function () {
	        if (this.input.hints.highlightDifferenceWith) {
	            var comparison = this.intakes.findNamed(this.input.hints.highlightDifferenceWith);
	            if (comparison.control.value !== this.control.value) {
	                this.infoMessageHTML = functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["This answer may differ from the one in\n              ", " (", ")."], ["This answer may differ from the one in\n              ", " (", ")."])), comparison.displayName, comparison.control.value);
	            }
	            else {
	                this.infoMessageHTML = "";
	            }
	        }
	    };
	    TypedFieldComponent.prototype.integerlike = function (dt) {
	        return ["integer", "whole number", "natural number"].indexOf(dt) > -1;
	    };
	    TypedFieldComponent.prototype.knownType = function (dt) {
	        return TypedFieldComponent_1.SUPPORTED_TYPES.indexOf(dt) > -1;
	    };
	    TypedFieldComponent.prototype.minimum = function (dt) {
	        if (dt === "whole number") {
	            return 0;
	        }
	        if (dt === "natural number") {
	            return 1;
	        }
	        return null;
	    };
	    TypedFieldComponent.prototype.getIcon = function () {
	        var _this = this;
	        if (this.control.invalid) {
	            var chosen_1 = "glyphicon glyphicon-exclamation-sign";
	            TypedFieldComponent_1.ERROR_ICONS.forEach(function (icon, error) {
	                if (_this.control.hasError(error)) {
	                    chosen_1 = icon;
	                    return;
	                }
	            });
	            return chosen_1;
	        }
	        if (this.lockedByCollaborator()) {
	            return "glyphicon glyphicon-lock";
	        }
	        if (this.input.provider) {
	            return "glyphicon glyphicon-user";
	        }
	        if (this.input.hints.autofill) {
	            return "glyphicon glyphicon-paste";
	        }
	        if (this.input.searchable) {
	            return "glyphicon glyphicon-search";
	        }
	        if (this.input.hints.developer) {
	            return "glyphicon glyphicon-wrench";
	        }
	        if (this.input.restrictions.length) {
	            return ((this.input.cardinality === 1)
	                ? "glyphicon glyphicon-hand-right"
	                : "glyphicon glyphicon-list");
	        }
	        if (this.input.hints.currency) {
	            return "glyphicon glyphicon-usd";
	        }
	        return TypedFieldComponent_1.TYPE_ICONS.get(this.input.type);
	    };
	    TypedFieldComponent.prototype.lockedByCollaborator = function () {
	        var disabled = Number.isInteger(this.input.id) &&
	            (this.collaboration.locks.has(this.input.id)
	                || this.collaboration.tableLocks.has(this.input.hints.table));
	        if (this.control.disabled !== disabled) {
	            if (disabled) {
	                this.control.disable();
	            }
	            else {
	                this.control.enable();
	            }
	        }
	        return disabled;
	    };
	    TypedFieldComponent.prototype.status = function () {
	        if (this.lockedByCollaborator()) {
	            return "locked";
	        }
	        if (this.control.invalid) {
	            return "invalid";
	        }
	        if (!this.control.dirty) {
	            if (functions_1.inputless(this.control.value)) {
	                return "empty";
	            }
	            return "saved";
	        }
	        if (this.input.provider) {
	            return "received";
	        }
	        return "answered";
	    };
	    TypedFieldComponent.prototype.containerClass = function () {
	        return ((this.validationTray || this.clearEnabled() || this.iconTray)
	            ? this.status() + " input-group"
	            : this.status());
	    };
	    TypedFieldComponent.prototype.getLockersName = function () {
	        var locker = this.collaboration.findUserIdByLock(this.input.id, this.input.hints.table);
	        if (locker === undefined) {
	            return "«unknown person»";
	        }
	        return locker.name;
	    };
	    TypedFieldComponent.prototype.tooltip = function () {
	        switch (this.status()) {
	            case "invalid":
	                return "This field is invalid.";
	            case "locked":
	                return functions_1.oneline(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                  This field is currently being edited by user\n                  ", ""], ["\n                  This field is currently being edited by user\n                  ", ""])), this.getLockersName());
	            case "empty":
	                return (this.input.searchable
	                    ? "This field is used to index the record in the\n                            database.You are strongly encouraged to enter a\n                            value so that the record can be found via search."
	                    : "You can enter " + this.input.type + "s in this field");
	            case "saved":
	                return "This field has been saved.";
	            case "received":
	                return functions_1.oneline(templateObject_4 || (templateObject_4 = __makeTemplateObject(["This field was modified by\n                  ", "."], ["This field was modified by\n                  ", "."])), this.input.provider || "another user");
	            case "answered":
	                return "You entered a value since the last save.";
	        }
	    };
	    TypedFieldComponent.prototype.issueChange = function () {
	        var e = new Event("change", { bubbles: true, cancelable: true });
	        this.hostRef.nativeElement.dispatchEvent(e);
	        this.checkForDifferenceHighlight();
	    };
	    TypedFieldComponent.prototype.move = function (delta) {
	        var arr = this.input.control;
	        arr.removeAt(this.index);
	        arr.insert((this.index + delta), this.control);
	        this.issueChange();
	    };
	    TypedFieldComponent.prototype.remove = function () {
	        this.input.control.removeAt(this.index);
	        this.issueChange();
	    };
	    TypedFieldComponent.prototype.top = function () {
	        return (!(this.input.control instanceof forms_1.FormArray) || (this.index === 0));
	    };
	    TypedFieldComponent.prototype.bottom = function () {
	        return (!(this.input.control instanceof forms_1.FormArray) ||
	            (this.index === (this.input.control.length - 1)));
	    };
	    TypedFieldComponent.prototype.only = function () {
	        return (!(this.input.control instanceof forms_1.FormArray) ||
	            (this.input.control.length === 1));
	    };
	    TypedFieldComponent.prototype.clear = function () {
	        if (this.input.cardinality === 0 && !this.input.allowsDuplicates) {
	            this.control.setValue([]);
	        }
	        else {
	            this.control.setValue(null);
	        }
	        this.issueChange();
	    };
	    TypedFieldComponent.prototype.boolean = function (value) {
	        return typeof value === "boolean";
	    };
	    TypedFieldComponent.prototype.adjustBoolean = function (shift) {
	        console.log("adjusting by ", shift);
	        var V = [true, false, null];
	        var target = V.indexOf(this.control.value) + shift;
	        if (target >= 0 && target < V.length) {
	            this.control.setValue(V[target]);
	            this.issueChange();
	        }
	    };
	    TypedFieldComponent.prototype.setBoolean = function (value) {
	        this.control.setValue(value);
	        this.issueChange();
	    };
	    TypedFieldComponent.prototype.gainFocus = function () {
	        if (this.input.id) {
	            var table = this.input.hints.table;
	            this.collaboration.sendStepLock(this.input.id, table);
	        }
	    };
	    TypedFieldComponent.prototype.loseFocus = function () {
	        if (this.input.id) {
	            this.collaboration.sendUnlock();
	        }
	    };
	    var TypedFieldComponent_1;
	    TypedFieldComponent.SUPPORTED_TYPES = [
	        "boolean",
	        "string",
	        "date",
	        "float",
	        "integer",
	        "whole number",
	        "natural number",
	        "json"
	    ];
	    TypedFieldComponent.TYPE_ICONS = new Map([
	        ["integer", "number-type-icon"],
	        ["natural number", "number-type-icon"],
	        ["whole number", "number-type-icon"],
	        ["float", "number-type-icon"],
	        ["string", "glyphicon glyphicon-font"],
	        ["date", "glyphicon glyphicon-calendar"],
	        ["boolean", "glyphicon glyphicon-question-sign"]
	    ]);
	    TypedFieldComponent.ERROR_ICONS = new Map([
	        ["required", "glyphicon glyphicon-asterisk"],
	        ["integer", "number-type-icon"],
	        ["number", "number-type-icon"],
	    ]);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedFieldComponent.prototype, "input", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.FormControl)
	    ], TypedFieldComponent.prototype, "control", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedFieldComponent.prototype, "clearButton", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedFieldComponent.prototype, "validationTray", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedFieldComponent.prototype, "iconTray", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypedFieldComponent.prototype, "listActions", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], TypedFieldComponent.prototype, "index", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TypedFieldComponent.prototype, "disableRestrictions", void 0);
	    __decorate([
	        core_1.ViewChild('content'),
	        __metadata("design:type", core_1.ElementRef)
	    ], TypedFieldComponent.prototype, "contentRef", void 0);
	    TypedFieldComponent = TypedFieldComponent_1 = __decorate([
	        core_1.Component({
	            selector: "typed-field",
	            template: __webpack_require__(759),
	            styles: ["\n        .input-group {width: 100%;}\n        .boolean input {\n            display: none;\n        }\n        .input-group-btn, .input-group-btn button {\n            height: 100%;\n        }\n        .number-type-icon {\n            position: relative;\n            display: inline-block;\n            top: 1px;\n            font-family: var(--title-font), inherit;\n            font-size: 18px;\n        }\n        .number-type-icon::before {\n            content: \"#\";\n        }\n        table {\n            width: 100%;\n        }\n        tr, td {\n            padding: 0px;\n        }\n        .input-group table:last-child .form-control\n        {\n            border-top-right-radius: 4px;\n        }\n        .input-group table:last-child tr:last-child td > *\n        {\n            border-bottom-right-radius: 4px;\n        }\n        .input-group table tr.lower-tray td > *\n        {\n            border-bottom: 1px solid #CCC;\n        }\n        .input-group table:last-child tr.lower-tray > *\n        {\n            border-right: 1px solid #CCC;\n        }\n        .btn.active {\n            filter: brightness(0.8) saturate(0.5) contrast(2.5);\n        }\n    "]
	        }),
	        __param(0, core_1.Optional()),
	        __metadata("design:paramtypes", [typed_control_component_1.TypedControlComponent,
	            core_1.Renderer,
	            core_1.ElementRef,
	            collaboration_service_1.CollaborationService,
	            intake_step_service_1.IntakeStepService])
	    ], TypedFieldComponent);
	    return TypedFieldComponent;
	}());
	exports.TypedFieldComponent = TypedFieldComponent;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<div [class]=\"containerClass()\">\n    <span\n        [title]=\"tooltip()\"\n        *ngIf=\"iconTray\"\n        class=\"input-group-addon input-tray\">\n        <span [class]=\"getIcon()\"></span>\n    </span>\n\n\n    <table #content><tbody><tr><td style=\"text-align: right\">\n        <template [ngIf]=\"!input.restrictions?.length || disableRestrictions\">\n            <template [ngIf]=\"input.type === 'boolean'\">\n                <div *ngIf=\"input?.hints?.checkbox\" style=\"text-align: center\">\n                    <input\n                      type=\"checkbox\"\n                      [formControl]=\"control\"\n                      class=\"icon\"\n                      [class.nonboolean]=\"!boolean(control.value)\">\n                </div>\n                <div\n                    *ngIf=\"!input?.hints?.checkbox\"\n                    class=\"btn-group boolean\"\n                    tabindex=\"0\"\n                    (keyup.arrowleft)=\"adjustBoolean(-1)\"\n                    (keyup.arrowright)=\"adjustBoolean(1)\"\n                    (keyup.y)=\"setBoolean(true)\"\n                    (keyup.n)=\"setBoolean(false)\">\n                    <label\n                        class=\"btn btn-info focusable first-focus\"\n                        [class.active]=\"control.value === true\">\n                        <input #yes\n                            type=\"radio\"\n                            [name]=\"index ? (input.name + index) : input.name\"\n                            [value]=\"true\"\n                            [formControl]=\"control\"\n                            autocomplete=\"off\">\n                        {{trueLabel || \"yes\"}}\n                    </label>\n                    <label\n                        class=\"btn btn-info focusable\"\n                        [class.active]=\"control.value === false\">\n                        <input #no\n                            type=\"radio\"\n                            [name]=\"index ? (input.name + index) : input.name\"\n                            [value]=\"false\"\n                            [formControl]=\"control\"\n                            autocomplete=\"off\">\n                        {{falseLabel || \"no\"}}\n                    </label>\n                    <label\n                        class=\"btn btn-info focusable\"\n                        [class.active]=\"control.value === null\">\n                        <input #null\n                            type=\"radio\"\n                            [name]=\"index ? (input.name + index) : input.name\"\n                            [value]=\"null\"\n                            [formControl]=\"control\"\n                            autocomplete=\"off\">\n                        {{nullLabel || \"n/a\"}}\n                    </label>\n                    <span *ngIf=\"listActions || clearButton\">\n                        <!-- this is just a stupid way to shim the CSS... button\n                        and input groups wouldn't naturally merge across levels\n                        so this makes an empty \"inner edge\" -->\n                    </span>\n                </div>\n            </template>\n\n            <template [ngIf]=\"input.type === 'string'\">\n                <input\n                    *ngIf=\"!input.hints?.multiline\"\n                    type=\"text\"\n                    class=\"form-control focusable first-focus\"\n                    [formControl]=\"control\"\n                    placeholder=\"Enter text.\"\n                    autocomplete=\"off\"\n                    (focus)=\"gainFocus()\"\n                    (blur)=\"loseFocus()\">\n                <textarea\n                    *ngIf=\"input.hints?.multiline\"\n                    autosize\n                    [minimum]=\"54\"\n                    class=\"form-control focusable first-focus\"\n                    [formControl]=\"control\"\n                    placeholder=\"Enter text.\"\n                    autocomplete=\"off\"\n                    (focus)=\"gainFocus()\"\n                    (blur)=\"loseFocus()\"></textarea>\n            </template>\n\n            <template [ngIf]=\"input.type === 'date'\">\n                <input\n                    type=\"date\"\n                    class=\"form-control focusable first-focus\"\n                    placeholder=\"Enter date.\"\n                    autocomplete=\"off\"\n                    [formControl]=\"control\"\n                    (focus)=\"gainFocus()\"\n                    (blur)=\"loseFocus()\">\n            </template>\n\n            <template [ngIf]=\"integerlike(input.type)\">\n                <input\n                    type=\"number\"\n                    [min]=\"minimum(input.type)\"\n                    step=\"1\"\n                    class=\"form-control focusable first-focus\"\n                    [formControl]=\"control\"\n                    placeholder=\"Enter number.\"\n                    autocomplete=\"off\"\n                    (focus)=\"gainFocus()\"\n                    (blur)=\"loseFocus()\">\n            </template>\n\n            <template [ngIf]=\"input.type === 'float'\">\n                <input\n                    type=\"number\"\n                    [step]=\"input.hints?.currency ? 0.01 : 'any'\"\n                    class=\"form-control focusable first-focus\"\n                    [formControl]=\"control\"\n                    placeholder=\"Enter number.\"\n                    autocomplete=\"off\"\n                    (focus)=\"gainFocus()\"\n                    (blur)=\"loseFocus()\">\n            </template>\n\n            <template [ngIf]=\"input.type === 'json'\">\n                <!-- TODO: doesn't format correctly yet -->\n                <prettyjson [obj]=\"input.value\"></prettyjson>\n            </template>\n\n            <template [ngIf]=\"!knownType(input.type)\">\n                <input\n                    type=\"text\"\n                    clss=\"form-control focusable first-focus\"\n                    disabled\n                    value=\"No configured input for this type!\"\n                    style=\"color: red\">\n            </template>\n        </template>\n        <template [ngIf]=\"input.restrictions?.length > 0 && disableRestrictions !== true\">\n            <template\n                [ngIf]=\"input.cardinality === 1 || input.allowsDuplicates\">\n                <div\n                    #wrap\n                    class=\"form-control wrapper\"\n                    [class.focus-helper]=\"wrap.focused\">\n                    <select\n                        [formControl]=\"control\"\n                        [size]=\"input.restrictions.length > restrictionDisplayLimit\n                        ? 1 : input.restrictions.length\"\n                        class=\"focusable first-focus\"\n                        (focus)=\"gainFocus(); wrap.focused = true\"\n                        (blur)=\"loseFocus(); wrap.focused = false\">\n                        <option\n                            *ngIf=\"input.restrictions.length > restrictionDisplayLimit\"\n                            [ngValue]=\"null\">\n                        </option>\n                        <option\n                            *ngFor=\"let deprecated of deprecatedValues\"\n                            [ngValue]=\"deprecated\"\n                            disabled>\n                            {{deprecated}}\n                        </option>\n                        <option\n                            *ngFor=\"let choice of input.restrictions\"\n                            [ngValue]=\"choice\">\n                            {{choice}}\n                        </option>\n                    </select>\n                </div>\n            </template>\n\n            <template\n                [ngIf]=\"input.cardinality !== 1 && !input.allowsDuplicates\">\n                <div\n                    #wrap\n                    class=\"form-control wrapper\"\n                    [class.focus-helper]=\"wrap.focused\">\n                    <select\n                        multiple\n                        class=\"focusable first-focus\"\n                        [formControl]=\"control\"\n                        [size]=\"input.restrictions?.length\"\n                        (focus)=\"gainFocus(); wrap.focused = true\"\n                        (blur)=\"loseFocus(); wrap.focused = false\">\n                        <option\n                            *ngFor=\"let deprecated of deprecatedValues\"\n                            [ngValue]=\"deprecated\"\n                            disabled>\n                            {{deprecated}}\n                        </option>\n                        <option\n                            *ngFor=\"let choice of input.restrictions\"\n                            [ngValue]=\"choice\">\n                            {{choice}}\n                        </option>\n                    </select>\n                </div>\n            </template>\n        </template>\n    </td></tr>\n     <tr *ngIf=\"control.errors && validationTray\" class=\"lower-tray\">\n        <td class=\"validation-tray\">\n            <div class=\"message\">\n                <validation-messages [control]=\"control\"></validation-messages>\n            </div>\n        </td>\n    </tr>\n     <tr *ngIf=\"infoMessageHTML\" class=\"lower-tray\">\n        <td class=\"info-tray\">\n            <div class=\"message\" [innerHTML]=\"infoMessageHTML\"></div>\n        </td>\n    </tr>\n\n    </tbody></table>\n\n    <span *ngIf=\"listActions || clearEnabled()\" class=\"input-group-btn actions-tray\">\n        <button\n            *ngIf=\"!top() && listActions !== 'remove'\"\n            class=\"btn btn-default\"\n            alt=\"Move up\"\n            [style.width]=\"bottom() ? '80px' : 'auto'\"\n            [style.height]=\"contentHeight ? contentHeight + 'px' : '100%'\"\n            (click)=\"move(-1)\">\n            <span class=\"glyphicon glyphicon-chevron-up\"></span>\n        </button>\n        <button\n            *ngIf=\"!bottom() && listActions !== 'remove'\"\n            class=\"btn btn-default\"\n            alt=\"Move down\"\n            (click)=\"move(1)\"\n            [style.width]=\"top() ? '80px' : 'auto'\"\n            [style.height]=\"contentHeight ? contentHeight + 'px' : '100%'\">\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n        </button>\n        <button\n            *ngIf=\"clearEnabled() && (!listActions || only())\"\n            class=\"btn btn-default\"\n            [style.width]=\"listActions ? '80px' : 'auto'\"\n            [style.height]=\"contentHeight ? contentHeight + 'px' : '100%'\"\n            (click)=\"clear()\"\n            tabindex=\"-1\">\n            Clear\n        </button>\n        <button\n            *ngIf=\"listActions\"\n            class=\"btn btn-danger\"\n            alt=\"Remove this entry\"\n            [disabled]=\"only()\"\n            [style.height]=\"contentHeight ? contentHeight + 'px' : '100%'\"\n            (click)=\"remove()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </span>\n</div>";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var D3Force = __webpack_require__(761);
	var D3Scale = __webpack_require__(766);
	var functions_1 = __webpack_require__(206);
	var DEFAULT_LINK_LENGTH = 70;
	var DEFAULT_LINK_STRENGTH = 0.5;
	var DEFAULT_CHARGE_STRENGTH = -90;
	var PAN_SPEED_FACTOR = 2.0;
	var BOUNDING_FORCE_PADDING = 20;
	var BOUNDING_FORCE = 0.5;
	var REVERSED_SCALE_10 = D3Scale.schemeCategory10.map(functions_1.identity).reverse();
	var DEAD_POINT = {
	    id: -1,
	    category: "",
	    x: 0,
	    y: 0,
	    vx: 0,
	    vy: 0,
	    fx: 0,
	    fy: 0
	};
	var ForceDirectedGraphComponent = (function () {
	    function ForceDirectedGraphComponent() {
	        this.showLabels = false;
	        this.highlight = null;
	        this.selected = new core_1.EventEmitter();
	        this.expand = new core_1.EventEmitter();
	        this.simulationEmitter = new core_1.EventEmitter();
	        this.simulatedNodes = [];
	        this.simulatedEdges = [];
	        this.physics = new WeakMap();
	        this.width = 600;
	        this.height = 300;
	        this.centerX = this.width / 2;
	        this.centerY = this.height / 2;
	        this.isDragging = false;
	        this.coolingRate = 0.01;
	        this.zoomExp = 0;
	        this.zoomTransform = "";
	    }
	    Object.defineProperty(ForceDirectedGraphComponent.prototype, "graph", {
	        set: function (g) {
	            if (g) {
	                console.log(this);
	                this._graph = g;
	                this.initializeGraph();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ForceDirectedGraphComponent.prototype.color = function (input, alternate) {
	        if (alternate === void 0) { alternate = false; }
	        if (input && this.colorScale && this.colorScaleAlternate) {
	            return (alternate
	                ? this.colorScaleAlternate(input)
	                : this.colorScale(input));
	        }
	        return "black";
	    };
	    ForceDirectedGraphComponent.prototype.labelsForPath = function (edge, forPathStart) {
	        var _a = this.physical(edge), source = _a[0], target = _a[1];
	        var inverted = this.hasInvertedTextPath(source, target);
	        if (forPathStart !== inverted) {
	            return edge.labelsWithSecondaries;
	        }
	        else {
	            return edge.reverseLabelsWithSecondaries;
	        }
	    };
	    ForceDirectedGraphComponent.prototype.hasInvertedTextPath = function (source, target) {
	        return (target.x < source.x);
	    };
	    ForceDirectedGraphComponent.prototype.asPath = function (edge) {
	        var _a = this.physical(edge), source = _a[0], target = _a[1];
	        if (this.hasInvertedTextPath(source, target)) {
	            return ("M " + target.x + " " + target.y + " "
	                + ("L " + source.x + " " + source.y));
	        }
	        else {
	            return ("M " + source.x + " " + source.y + " "
	                + ("L " + target.x + " " + target.y));
	        }
	    };
	    ForceDirectedGraphComponent.prototype.linkDistance = function () {
	        return (this._graph.idealLinkLength || DEFAULT_LINK_LENGTH);
	    };
	    ForceDirectedGraphComponent.prototype.linkStrength = function () {
	        return (this._graph.linkStrength || DEFAULT_LINK_STRENGTH);
	    };
	    ForceDirectedGraphComponent.prototype.chargeStrength = function () {
	        return (this._graph.chargeStrength || DEFAULT_CHARGE_STRENGTH);
	    };
	    ForceDirectedGraphComponent.prototype.physical = function (item) {
	        if (!item) {
	            console.error("Serious graph failure: requested physics of non-object", item);
	            return DEAD_POINT;
	        }
	        if ("source" in item && "target" in item) {
	            var edge = item;
	            return [
	                this.physical(edge.source),
	                this.physical(edge.target)
	            ];
	        }
	        else if ("id" in item) {
	            var node = item;
	            var pt = this.physics.get(node);
	            if (!pt) {
	                pt = this.initPoint(node);
	                this.physics.set(node, pt);
	            }
	            return pt;
	        }
	        else {
	            console.error("Serious graph failure: requested physics of unknown object", item);
	            return DEAD_POINT;
	        }
	    };
	    ForceDirectedGraphComponent.prototype.initPoint = function (node) {
	        return {
	            id: node.id,
	            category: node.category,
	            x: this.centerX,
	            y: this.centerY,
	            vx: 0,
	            vy: 0
	        };
	    };
	    ForceDirectedGraphComponent.prototype.updateCentering = function () {
	        if (this.simulation) {
	            this.simulation.force("center", D3Force.forceCenter(this.centerX, this.centerY));
	        }
	    };
	    ForceDirectedGraphComponent.prototype.holdForInteraction = function () {
	        this.simulation.alphaTarget(0.5).restart();
	    };
	    ForceDirectedGraphComponent.prototype.finishInteraction = function () {
	        this.simulation.alphaTarget(0);
	    };
	    ForceDirectedGraphComponent.prototype.restartSim = function () {
	        this.simulation.alpha(1.0).restart();
	    };
	    ForceDirectedGraphComponent.prototype.pan = function (dx, dy) {
	        if (dx === void 0) { dx = 0; }
	        if (dy === void 0) { dy = 0; }
	        this.restartSim();
	        this.centerX += dx * PAN_SPEED_FACTOR;
	        this.centerY += dy * PAN_SPEED_FACTOR;
	        this.updateCentering();
	    };
	    ForceDirectedGraphComponent.prototype.panTo = function (x, y) {
	        this.centerX = x;
	        this.centerY = y;
	        this.updateCentering();
	    };
	    ForceDirectedGraphComponent.prototype.startDrag = function (event) {
	        this.dragStart = event;
	        this.preDragCenter = { x: this.centerX, y: this.centerY };
	        this.isDragging = true;
	        this.holdForInteraction();
	    };
	    ForceDirectedGraphComponent.prototype.endDrag = function () {
	        this.isDragging = false;
	        this.finishInteraction();
	    };
	    ForceDirectedGraphComponent.prototype.updateDrag = function (event) {
	        if (this.isDragging) {
	            this.panTo((event.x - this.dragStart.x + this.preDragCenter.x), (event.y - this.dragStart.y + this.preDragCenter.y));
	        }
	    };
	    ForceDirectedGraphComponent.prototype.initializeGraph = function () {
	        var _this = this;
	        console.log("initializing simulation");
	        this.simulatedNodes = this._graph.nodes.filter(function (n) {
	            if (n.enabled) {
	                n.simulated = true;
	                return true;
	            }
	            return false;
	        });
	        var physicalNodes = this.simulatedNodes.map(function (n) { return _this.physical(n); });
	        this.simulatedEdges = this._graph.edges.filter(function (e) {
	            if (e.enabled) {
	                e.simulated = true;
	                return true;
	            }
	            return false;
	        });
	        var physicalEdges = this.simulatedEdges.map(function (e) {
	            return ({
	                source: _this.physical(e.source),
	                target: _this.physical(e.target)
	            });
	        });
	        this.colorScale = D3Scale.scaleOrdinal(D3Scale.schemeCategory10);
	        this.colorScaleAlternate = D3Scale.scaleOrdinal(REVERSED_SCALE_10);
	        var linkingForce = D3Force.forceLink(physicalEdges)
	            .distance(function () { return _this.linkDistance(); })
	            .strength(function (link) { return _this.linkStrength(); });
	        var boundingBoxForce = function (alpha) { return physicalNodes.forEach(function (p) {
	            if (p.x > (_this.width - BOUNDING_FORCE_PADDING)) {
	                p.vx -= BOUNDING_FORCE;
	            }
	            if (p.x < (BOUNDING_FORCE_PADDING)) {
	                p.vx += BOUNDING_FORCE;
	            }
	            if (p.y > (_this.height - BOUNDING_FORCE_PADDING)) {
	                p.vy -= BOUNDING_FORCE;
	            }
	            if (p.y < (BOUNDING_FORCE_PADDING)) {
	                p.vy += BOUNDING_FORCE;
	            }
	        }); };
	        var directedness = function (a) {
	            var minDisplacement = 40;
	            var scaling = 0.2;
	            physicalEdges.forEach(function (edge) {
	                if (typeof edge.target !== "object"
	                    || typeof edge.source !== "object") {
	                    return;
	                }
	                var stretch = edge.target.x - edge.source.x - minDisplacement;
	                if (stretch < -1) {
	                    edge.source.vx += (stretch * scaling);
	                    edge.target.vx -= (stretch * scaling);
	                }
	            });
	        };
	        this.simulation = D3Force.forceSimulation(physicalNodes)
	            .force("link", linkingForce)
	            .force("charge", D3Force.forceManyBody().strength(function () { return _this.chargeStrength(); }))
	            .force("box", boundingBoxForce)
	            .alphaDecay(this.coolingRate);
	        this.pan();
	        if (this._graph.directed) {
	            this.simulation.force("hierarchy", directedness);
	        }
	        this.simulation.on("tick", function () {
	            if (_this._graph.reinitialize) {
	                _this.simulation.stop();
	                _this._graph.reinitialize = false;
	                _this.initializeGraph();
	            }
	        });
	        this.simulationEmitter.emit(this.simulation);
	    };
	    ForceDirectedGraphComponent.prototype.changeZoom = function (delta) {
	        var _a = [-1.5, 1.2], zoomMin = _a[0], zoomMax = _a[1];
	        this.zoomExp -= delta;
	        if (this.zoomExp < zoomMin) {
	            this.zoomExp = zoomMin;
	        }
	        if (this.zoomExp > zoomMax) {
	            this.zoomExp = zoomMax;
	        }
	        this.zoomTransform = "scale(" + Math.pow(2, this.zoomExp) + ")";
	    };
	    ForceDirectedGraphComponent.prototype.zoomWithKey = function (event, direction) {
	        var keyZoomScaling = 0.1;
	        this.changeZoom(direction * keyZoomScaling);
	    };
	    ForceDirectedGraphComponent.prototype.zoom = function (event) {
	        var wheelZoomScaling = 0.02;
	        this.changeZoom(event.deltaY * wheelZoomScaling);
	        event.stopPropagation();
	        event.preventDefault();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ForceDirectedGraphComponent.prototype, "showLabels", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], ForceDirectedGraphComponent.prototype, "graph", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ForceDirectedGraphComponent.prototype, "highlight", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ForceDirectedGraphComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ForceDirectedGraphComponent.prototype, "expand", void 0);
	    __decorate([
	        core_1.Output("simulation"),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ForceDirectedGraphComponent.prototype, "simulationEmitter", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ForceDirectedGraphComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ForceDirectedGraphComponent.prototype, "height", void 0);
	    __decorate([
	        core_1.HostListener("document:keydown.ArrowLeft", ["-1", "0"]),
	        core_1.HostListener("document:keydown.ArrowRight", ["1", "0"]),
	        core_1.HostListener("document:keydown.ArrowUp", ["0", "-1"]),
	        core_1.HostListener("document:keydown.ArrowDown", ["0", "1"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Number, Number]),
	        __metadata("design:returntype", void 0)
	    ], ForceDirectedGraphComponent.prototype, "pan", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ForceDirectedGraphComponent.prototype, "coolingRate", void 0);
	    __decorate([
	        core_1.HostListener("document:keydown.-", ["$event", "-1"]),
	        core_1.HostListener("document:keydown.=", ["$event", "1"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent, Number]),
	        __metadata("design:returntype", void 0)
	    ], ForceDirectedGraphComponent.prototype, "zoomWithKey", null);
	    ForceDirectedGraphComponent = __decorate([
	        core_1.Component({
	            selector: "force-directed-graph",
	            template: "\n  <!-- Note that if we don't use <svg> as the outermost tag, the angular schema\n  parser may not automatically recognize the namespace. In that case we should\n  explicitly declare the namespaces of tags, like so: <svg:line> -->\n  <svg\n    #svgCanvas\n    [attr.viewbox]=\"'0 0 ' + width + ' ' + height\"\n    [style.width]=\"width + 'px'\"\n    [style.height]=\"height + 'px'\"\n    preserveAspectRatio=\"xMidYMin meet\"\n    (wheel)=\"zoom($event)\"\n    (mousedown)=\"startDrag($event)\"\n    (mousemove)=\"updateDrag($event)\"\n    (mouseup)=\"endDrag()\"\n    (mouseleave)=\"endDrag()\">\n    <defs>\n      <marker\n        id=\"arrowhead\"\n        markerWidth=\"12\"\n        markerHeight=\"6\"\n        refX=\"24\"\n        refY=\"3\"\n        orient=\"auto\"\n        markerUnits=\"strokeWidth\">\n        <path d=\"M0,0 L0,6 L12,3 z\"></path>\n      </marker>\n    </defs>\n    <g\n      class=\"graph\"\n      [style.transform]=\"zoomTransform\">\n      <g class=\"edges\">\n        <g *ngFor=\"let edge of _graph?.edges; let i = index\">\n          <template [ngIf]=\"edge.enabled\">\n            <line\n              [class.standard]=\"!_graph?.categorizeEdges\"\n              [attr.x1]=\"physical(edge.source).x\"\n              [attr.y1]=\"physical(edge.source).y\"\n              [attr.x2]=\"physical(edge.target).x\"\n              [attr.y2]=\"physical(edge.target).y\"\n              [attr.marker-end]=\"_graph.directed ? 'url(#arrowhead)' : ''\"\n              [attr.stroke]=\"color(edge.category, true)\">\n            </line>\n            <template [ngIf]=\"edge.hasSecondaries\">\n              <line *ngFor=\"let alt of edge.secondaries; let j = index\"\n                [attr.x1]=\"physical(edge.source).x\"\n                [attr.y1]=\"physical(edge.source).y\"\n                [attr.x2]=\"physical(edge.target).x\"\n                [attr.y2]=\"physical(edge.target).y\"\n                [attr.marker-end]=\"_graph.directed ? 'url(#arrowhead)' : ''\"\n                [attr.stroke]=\"color(alt.category, true)\"\n                [attr.stroke-dasharray]=\"'5 ' + (5*j+5)\">\n              </line>\n            </template>\n            <g class=\"edgelabel\">\n              <path\n                [attr.d]=\"asPath(edge)\"\n                [id]=\"'edgepath' + i\"\n                stroke-color=\"green\">\n              </path>\n              <text\n                *ngFor=\"let startLabel of labelsForPath(edge, true); let j = index; let first = first\"\n                dx=\"16\"\n                [attr.dy]=\"-8 - (12 * j)\">\n                <textPath [attr.href]=\"'#edgepath' + i\">\n                  {{startLabel}}{{first ? \"\" : \",\"}}\n                </textPath>\n              </text>\n              <text\n                *ngFor=\"let endLabel of labelsForPath(edge, false); let j = index; let last = last\"\n                dx=\"-16\"\n                [attr.dy]=\"16 + (12 * j)\"\n                text-anchor=\"end\">\n                <textPath [attr.href]=\"'#edgepath' + i\" startOffset=\"100%\">\n                  {{endLabel}}{{last ? \"\" : \",\"}}\n                </textPath>\n              </text>\n            </g>\n          </template>\n        </g>\n      </g>\n\n      <g class=\"nodes\">\n        <g\n          *ngFor=\"let node of _graph?.nodes\"\n          [class.highlight]=\"highlight === node.id\"\n          [title]=\"node.label\"\n          (mouseenter)=\"selected.emit(node.id)\"\n          (mouseleave)=\"selected.emit(null)\"\n          (click)=\"expand.emit(node); restartSim()\">\n          <template [ngIf]=\"node.enabled\">\n            <circle\n              r=\"12\"\n              [attr.cx]=\"physical(node).x\"\n              [attr.cy]=\"physical(node).y\"\n              [attr.title]=\"node.id\"\n              [attr.stroke]=\"color ? color(node.category) : 'red'\"\n              fill=\"white\">\n            </circle>\n            <circle\n              *ngIf=\"node.alreadyExpanded === false\"\n              r=\"18\"\n              [attr.cx]=\"physical(node).x || -10\"\n              [attr.cy]=\"physical(node).y || -10\"\n              stroke=\"#999\"\n              stroke-dasharray=\"1 3\"\n              fill=\"transparent\"\n              title=\"This node may have edges that haven't been loaded\">\n            </circle>\n            <text\n              *ngIf=\"showLabels\"\n              class=\"node-label\"\n              [attr.x]=\"physical(node).x\"\n              [attr.y]=\"physical(node).y + 25\"\n              [attr.fill]=\"color ? color(node.category) : 'red'\"\n              text-anchor=\"middle\">\n              {{node.label}}\n            </text>\n            <text\n              class=\"node-id\"\n              [attr.x]=\"physical(node).x\"\n              [attr.y]=\"physical(node).y + 5\"\n              [attr.fill]=\"color ? color(node.category) : 'red'\"\n              text-anchor=\"middle\">\n              {{node.id}}\n            </text>\n          </template>\n        </g> <!-- /node -->\n      </g> <!-- /nodes -->\n    </g> <!-- /graph -->\n    <!-- this rect is a sanity test about viewbox / bounding manipulations -->\n    <rect\n      fill=\"none\"\n      stroke=\"red\"\n      stroke-dasharray=\"5,5\"\n      x=\"-2\"\n      y=\"-2\"\n      [attr.width]=\"width + 4\"\n      [attr.height]=\"height + 4\">\n    </rect>\n    <text\n      *ngIf=\"_graph?.nodes.length === 1\"\n      [attr.x]=\"width / 2\"\n      [attr.y]=\"height - 15\"\n      text-anchor=\"middle\"\n      fill=\"gray\">\n      The server could not find any explanation edges.\n    </text>\n    <text\n      [attr.x]=\"width\"\n      y=\"12\"\n      text-anchor=\"end\"\n      font-size=\"10\"\n      fill=\"gray\">\n      (Zoom with the mouse wheel or \u00B1 keys.\n        Pan with arrow keys or click-and-drag.)\n    </text>\n  </svg>\n  ",
	            styles: ["\n    svg {\n      display: block;\n      max-width: 100%;\n      margin: auto;\n      /* border: 1px solid black; */\n    }\n    .graph {\n      transform-origin: center;\n    }\n    .edges line.standard {\n      stroke: #999;\n      stroke-opacity: 0.6;\n    }\n    #arrowhead {\n      fill: #999;\n      fill-opacity: 0.6;\n    }\n    .nodes circle {\n      /* stroke: #fff; */\n      stroke-width: 2px;\n    }\n    .node-label {\n      text-shadow: 0 0 3px white;\n    }\n    .highlight circle {\n      stroke: black;\n      filter: drop-shadow(0 0 3px yellow);\n    }\n    .highlight text {\n      fill: black;\n      /* text-shadow: 0 0 2px yellow; */\n      font-weight: bold;\n    }\n    text {\n      -webkit-touch-callout: none;\n      -webkit-user-select: none;\n      -khtml-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n    }\n  "]
	        })
	    ], ForceDirectedGraphComponent);
	    return ForceDirectedGraphComponent;
	}());
	exports.ForceDirectedGraphComponent = ForceDirectedGraphComponent;


/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var D3Axis = __webpack_require__(774);
	var D3Scale = __webpack_require__(766);
	var D3Selection = __webpack_require__(775);
	var FrequencyChartComponent = (function () {
	    function FrequencyChartComponent() {
	        this.aspectRatio = 4 / 6;
	        this.margin = { top: 20, right: 20, bottom: 30, left: 40 };
	        this.useBar = false;
	        this.useScatter = false;
	        this.dataFailure = false;
	    }
	    Object.defineProperty(FrequencyChartComponent.prototype, "width", {
	        get: function () {
	            return this.outerWidth - this.margin.left - this.margin.right;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FrequencyChartComponent.prototype, "height", {
	        get: function () {
	            return this.outerHeight - this.margin.top - this.margin.bottom;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FrequencyChartComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.data.frequencies.length > 20) {
	            if (this.isNumeric(this.data.type)) {
	                this.useScatter = true;
	            }
	            else {
	                this.dataFailure = true;
	            }
	        }
	        else {
	            this.useBar = true;
	        }
	        this.resize(600);
	        this.readData();
	        setTimeout(function () { return _this.ngDoCheck(); }, 1);
	    };
	    FrequencyChartComponent.prototype.isNumeric = function (type) {
	        return ([
	            "integer", "whole number", "natural number", "float", "date"
	        ].indexOf(type) > -1);
	    };
	    FrequencyChartComponent.prototype.ngDoCheck = function () {
	        var svgRect = this.svgCanvas.nativeElement.getBoundingClientRect();
	        if (svgRect.width !== this.outerWidth) {
	            console.log("width change " + this.outerWidth + "→" + svgRect.width);
	            this.resize(svgRect.width);
	            this.readData();
	        }
	    };
	    FrequencyChartComponent.prototype.resize = function (width) {
	        if (width === 0) {
	            return;
	        }
	        this.outerWidth = width;
	        this.outerHeight = this.aspectRatio * width;
	        if (this.useScatter) {
	            this.x = D3Scale.scaleLinear().range([0, this.width]);
	        }
	        else {
	            this.x = D3Scale.scaleBand()
	                .rangeRound([0, this.width])
	                .paddingInner(0.1);
	        }
	        this.y = D3Scale.scaleLinear().range([this.height, 0]);
	    };
	    FrequencyChartComponent.prototype.readData = function () {
	        if (!this.data) {
	            return console.warn("Requested chart data read before data ready!");
	        }
	        var maxFreq = this.data.frequencies.map(function (e) { return e.frequency; }).reduce(function (a, b) { return Math.max(a, b); }, 0);
	        if (this.useScatter) {
	            var xDomain = this.data.frequencies.map(function (e) { return e.element; }).reduce(function (_a, b) {
	                var min = _a[0], max = _a[1];
	                return [Math.min(min, b), Math.max(max, b)];
	            }, [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER]);
	            this.x.domain(xDomain);
	            this.xAxisCreator = D3Axis.axisBottom(this.x);
	        }
	        else {
	            this.x.domain(this.data.frequencies.map(function (_a) {
	                var element = _a.element;
	                return element;
	            }));
	            this.xAxisCreator = D3Axis.axisBottom(this.x);
	        }
	        if (this.data.type === "date") {
	            this.xAxisCreator
	                .ticks(Math.min(this.data.frequencies.length, 7))
	                .tickFormat(function (x) { return (new Date(x)).toLocaleDateString(); });
	        }
	        this.y.domain([0, maxFreq]);
	        this.yAxisCreator = D3Axis.axisLeft(this.y)
	            .ticks(Math.min(maxFreq, 11))
	            .tickFormat(function (val) { return "" + val; });
	        this.xAxisCreator(D3Selection.select(this.xAxisElement.nativeElement));
	        this.yAxisCreator(D3Selection.select(this.yAxisElement.nativeElement));
	    };
	    FrequencyChartComponent.prototype.afterSort = function () {
	        console.log("Rereading data...");
	        this.readData();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], FrequencyChartComponent.prototype, "data", void 0);
	    __decorate([
	        core_1.ViewChild("svgCanvas"),
	        __metadata("design:type", core_1.ElementRef)
	    ], FrequencyChartComponent.prototype, "svgCanvas", void 0);
	    __decorate([
	        core_1.ViewChild("xAxis"),
	        __metadata("design:type", core_1.ElementRef)
	    ], FrequencyChartComponent.prototype, "xAxisElement", void 0);
	    __decorate([
	        core_1.ViewChild("yAxis"),
	        __metadata("design:type", core_1.ElementRef)
	    ], FrequencyChartComponent.prototype, "yAxisElement", void 0);
	    __decorate([
	        core_1.HostListener("window:resize"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], FrequencyChartComponent.prototype, "ngDoCheck", null);
	    FrequencyChartComponent = __decorate([
	        core_1.Component({
	            selector: "frequency-chart",
	            template: "\n  <!-- Note that if we don't use <svg> as the outermost tag, the angular schema\n  parser may not automatically recognize the namespace. In that case we should\n  explicitly declare the namespaces of tags, like so: <svg:line> -->\n  <svg\n    #svgCanvas\n    [attr.viewbox]=\"'0 0 ' + outerWidth + ' ' + outerHeight\"\n    [attr.height]=\"outerHeight\"\n    preserveAspectRatio=\"xMidYMid meet\">\n    <g\n      class=\"chart\"\n      [attr.transform]=\"'translate(' + margin.left + ', ' + margin.top + ')'\">\n      <g *ngIf=\"useBar\">\n        <g\n          *ngFor=\"let item of data.frequencies\"\n          class=\"bar\">\n          <rect\n            [attr.x]=\"x(item.element)\"\n            [attr.width]=\"x.bandwidth()\"\n            [attr.y]=\"y(item.frequency)\"\n            [attr.height]=\"height - y(item.frequency)\">\n          </rect>\n        </g>\n      </g>\n      <g *ngIf=\"useScatter\">\n        <g class=\"dots\">\n          <circle\n            *ngFor=\"let item of data.frequencies\"\n            class=\"dot\"\n            [attr.cx]=\"x(item.element)\"\n            [attr.cy]=\"y(item.frequency)\"\n            r=\"2\">\n          </circle>\n        </g>\n      </g>\n      <text *ngIf=\"dataFailure\" transform=\"'translate(' + this.width/2 + ',' + this.height/2 + ')\">\n        Too many entries to chart.\n      </text>\n      <g #xAxis [attr.transform]=\"'translate(0, ' + this.height + ')'\"></g>\n      <g #yAxis></g>\n    </g>\n  </svg>\n  ",
	            styles: ["\n    svg {\n      display: block;\n      margin: auto;\n      max-width: 100%;\n      width: 100%;\n      border: 1px solid black;\n    }\n    .bar rect {\n      fill: steelblue;\n      fill-opacity: 0.75;\n    }\n    circle.dot {\n      fill: steelblue;\n      fill-opacity: 0.4;\n    }\n  "]
	        })
	    ], FrequencyChartComponent);
	    return FrequencyChartComponent;
	}());
	exports.FrequencyChartComponent = FrequencyChartComponent;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ v1.0.12 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var slice = Array.prototype.slice;
	
	function identity(x) {
	  return x;
	}
	
	var top = 1,
	    right = 2,
	    bottom = 3,
	    left = 4,
	    epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function number(scale) {
	  return function(d) {
	    return +scale(d);
	  };
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return +scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = +range[0] + 0.5,
	        range1 = +range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : number)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "currentColor"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "currentColor")
	        .attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "currentColor")
	        .attr(x, k * spacing)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1)
	            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1));
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position(d)); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ v1.4.2 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	function namespace(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	}
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	function creator(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	}
	
	function none() {}
	
	function selector(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	}
	
	function selection_select(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function empty() {
	  return [];
	}
	
	function selectorAll(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	}
	
	function selection_selectAll(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	}
	
	function matcher(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	}
	
	function selection_filter(match) {
	  if (typeof match !== "function") match = matcher(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function sparse(update) {
	  return new Array(update.length);
	}
	
	function selection_enter() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	}
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	function selection_data(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	}
	
	function selection_exit() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	}
	
	function selection_join(onenter, onupdate, onexit) {
	  var enter = this.enter(), update = this, exit = this.exit();
	  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
	  if (onupdate != null) update = onupdate(update);
	  if (onexit == null) exit.remove(); else onexit(exit);
	  return enter && update ? enter.merge(update).order() : update;
	}
	
	function selection_merge(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	}
	
	function selection_order() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	}
	
	function selection_sort(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	}
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function selection_call() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	}
	
	function selection_nodes() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	}
	
	function selection_node() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	}
	
	function selection_size() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	}
	
	function selection_empty() {
	  return !this.node();
	}
	
	function selection_each(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	}
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	function selection_attr(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	}
	
	function defaultView(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	}
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	function selection_style(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	}
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	function selection_property(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	}
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	function selection_classed(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	}
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	function selection_text(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	}
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	function selection_html(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	}
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	function selection_raise() {
	  return this.each(raise);
	}
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	function selection_lower() {
	  return this.each(lower);
	}
	
	function selection_append(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	}
	
	function constantNull() {
	  return null;
	}
	
	function selection_insert(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	}
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	function selection_remove() {
	  return this.each(remove);
	}
	
	function selection_cloneShallow() {
	  var clone = this.cloneNode(false), parent = this.parentNode;
	  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
	}
	
	function selection_cloneDeep() {
	  var clone = this.cloneNode(true), parent = this.parentNode;
	  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
	}
	
	function selection_clone(deep) {
	  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
	}
	
	function selection_datum(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	}
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!("onmouseenter" in element)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	function selection_on(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	function selection_dispatch(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	}
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  join: selection_join,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  clone: selection_clone,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	function select(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	}
	
	function create(name) {
	  return select(creator(name).call(document.documentElement));
	}
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function sourceEvent() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	}
	
	function point(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	}
	
	function mouse(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	}
	
	function selectAll(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	}
	
	function touch(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	}
	
	function touches(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	}
	
	exports.clientPoint = point;
	exports.create = create;
	exports.creator = creator;
	exports.customEvent = customEvent;
	exports.local = local;
	exports.matcher = matcher;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var auth_service_1 = __webpack_require__(777);
	var PreauthAwareRouterLink = (function () {
	    function PreauthAwareRouterLink(auth) {
	        this.auth = auth;
	    }
	    PreauthAwareRouterLink.prototype.onClick = function (button, ctrlKey, metaKey) {
	        if (button !== 0 || ctrlKey || metaKey) {
	            this.metaClick();
	            return false;
	        }
	    };
	    PreauthAwareRouterLink.prototype.metaClick = function () {
	        this.auth.openPreauthedTab(this.routerLink);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], PreauthAwareRouterLink.prototype, "routerLink", void 0);
	    __decorate([
	        core_1.HostListener("click", ["$event.button", "$event.ctrlKey", "$event.metaKey"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Number, Boolean, Boolean]),
	        __metadata("design:returntype", Boolean)
	    ], PreauthAwareRouterLink.prototype, "onClick", null);
	    PreauthAwareRouterLink = __decorate([
	        core_1.Directive({ selector: "a[routerLink][preauthNewTabs]" }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService])
	    ], PreauthAwareRouterLink);
	    return PreauthAwareRouterLink;
	}());
	exports.PreauthAwareRouterLink = PreauthAwareRouterLink;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var bootstrap_1 = __webpack_require__(24);
	var Rx_1 = __webpack_require__(214);
	var alert_service_1 = __webpack_require__(689);
	var auth_1 = __webpack_require__(535);
	var credentials_1 = __webpack_require__(778);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var hasher_service_1 = __webpack_require__(717);
	var salter_service_1 = __webpack_require__(719);
	var reset_user_password_request_1 = __webpack_require__(788);
	var configuration_service_1 = __webpack_require__(512);
	var AuthState;
	(function (AuthState) {
	    AuthState[AuthState["Unauthenticated"] = 0] = "Unauthenticated";
	    AuthState[AuthState["PasswordReset"] = 1] = "PasswordReset";
	    AuthState[AuthState["EnforcedCredentialChange"] = 2] = "EnforcedCredentialChange";
	    AuthState[AuthState["Authenticated"] = 100] = "Authenticated";
	})(AuthState = exports.AuthState || (exports.AuthState = {}));
	var LOCAL_TOKEN_LIFETIME = 10 * 1000;
	var DEFAULT_POST_AUTH_TARGET = "/home";
	var DEFAULT_UNAUTHED_TARGET = "/";
	var AuthService = (function () {
	    function AuthService(messaging, router, activatedRoute, hasher, salter, alerts, modal, config) {
	        var _this = this;
	        this.messaging = messaging;
	        this.router = router;
	        this.activatedRoute = activatedRoute;
	        this.hasher = hasher;
	        this.salter = salter;
	        this.alerts = alerts;
	        this.modal = modal;
	        this.config = config;
	        this.state = AuthState.Unauthenticated;
	        this.firstConnection = true;
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	        if (config.client.type === "guest") {
	        }
	    }
	    AuthService.prototype.connected = function () {
	        var _this = this;
	        if (window.opener
	            && window.opener !== null
	            && typeof window.opener.getPreauth === "function") {
	            var request = window.opener.getPreauth();
	            if (request) {
	                this.preauthenticate(request);
	            }
	        }
	        this.messaging.receive(general_1.MessageTag.RSP_ACKNOWLEDGEMENT).subscribe(function (m) {
	            _this.inferStatusFromAck(m);
	            _this.firstConnection = false;
	        });
	        this.messaging.receive(general_1.MessageTag.DOWN_DISCONNECT).subscribe(function (m) { return _this.handleServerDrop(m); });
	    };
	    AuthService.prototype.disconnected = function () { };
	    AuthService.prototype.authSucceeded = function () {
	        this.state = AuthState.Authenticated;
	        return true;
	    };
	    AuthService.prototype.authFailed = function () {
	        this.state = AuthState.Unauthenticated;
	        return false;
	    };
	    AuthService.prototype.inferStatusFromAck = function (message, wasAuthRequest) {
	        if (message.code === general_1.ResponseCode.LoginFailure) {
	            return this.authFailed();
	        }
	        if (wasAuthRequest) {
	            if (message.ok || message.code === general_1.ResponseCode.OK) {
	                return this.authSucceeded();
	            }
	            else {
	                return this.authFailed();
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    Object.defineProperty(AuthService.prototype, "authenticated", {
	        get: function () {
	            return this.state === AuthState.Authenticated;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AuthService.prototype, "resettingPassword", {
	        get: function () {
	            return this.state === AuthState.PasswordReset;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AuthService.prototype.boot = function () {
	        this.router.navigate([DEFAULT_UNAUTHED_TARGET]);
	    };
	    AuthService.prototype.redirect = function () {
	        if (this.specialRedirectBehavior) {
	            var fn = this.specialRedirectBehavior;
	            this.specialRedirectBehavior = null;
	            return fn();
	        }
	        var target = this.redirectTo || [DEFAULT_POST_AUTH_TARGET];
	        this.redirectTo = null;
	        this.router.navigate(target);
	    };
	    AuthService.prototype.redirectIfAuthed = function () {
	        if (this.authenticated) {
	            this.redirect();
	        }
	    };
	    AuthService.prototype.openPreauthedTab = function (target) {
	        var _this = this;
	        var authedWindow = window.open("/");
	        var message = null;
	        if (!target) {
	            if (this.routeIsSessionDependent(this.activatedRoute)) {
	                target = DEFAULT_POST_AUTH_TARGET;
	                message = {
	                    message: "You have been authenticated! However, you cannot open a subject\n            context into a new tab for security reasons.",
	                    type: "warning",
	                    timeout: this.alerts.getDefaultTimeout()
	                };
	            }
	            else {
	                target = this.router.routerState.snapshot.url;
	            }
	            console.log("Assuming target of " + target);
	        }
	        this.messaging.converse(new auth_1.AuthTokenRequest())
	            .map(function (msg) { return msg.token; })
	            .catch(function (err) { return Rx_1.Observable.of(""); })
	            .subscribe(function (token) {
	            _this.createSingleUseTokenGetter({ token: token, target: target, message: message });
	        });
	    };
	    AuthService.prototype.createSingleUseTokenGetter = function (request) {
	        window.getPreauth = function () {
	            window.getPreauth = null;
	            return request;
	        };
	        setTimeout(function () { return request = null; }, LOCAL_TOKEN_LIFETIME);
	    };
	    AuthService.prototype.preauthenticate = function (request) {
	        var _this = this;
	        this.messaging.successful(new auth_1.AuthTokenLoginRequest(request.token)).subscribe(function () {
	            _this.authSucceeded();
	            _this.router.navigate([request.target]);
	            if (request.message) {
	                _this.alerts.add(request.message);
	            }
	        });
	    };
	    AuthService.prototype.alertDisconnect = function (c, soft) {
	        if (soft === void 0) { soft = false; }
	        if (soft) {
	            this.alerts.warnAndReplace(general_1.DISCONNECTION_TEXT.get(c) || general_1.DISCONNECTION_TEXT.default, "disconnect");
	        }
	        else {
	            this.alerts.errorAndReplace(general_1.DISCONNECTION_TEXT.get(c) || general_1.DISCONNECTION_TEXT.default, "disconnect");
	        }
	    };
	    AuthService.prototype.handleServerDrop = function (m) {
	        var bailMessage;
	        switch (m.code) {
	            case general_1.ResponseCode.META_AlreadyHandled:
	                return;
	            case general_1.ResponseCode.OK:
	                this.messaging.send(new auth_1.DisconnectUpstreamMessage()).subscribe();
	                this.router.navigate([DEFAULT_UNAUTHED_TARGET]);
	                this.messaging.restart();
	                return;
	            case general_1.ResponseCode.LoginFailure:
	            case general_1.ResponseCode.SystemDown:
	            case general_1.ResponseCode.Maintenance:
	                this.alertDisconnect(m.code);
	                return;
	            case general_1.ResponseCode.PermissionDenied:
	                bailMessage = "Algorithm was stopped due to permissions failure.";
	            case general_1.ResponseCode.InvalidRequest:
	            case general_1.ResponseCode.RequestExpired:
	            case general_1.ResponseCode.RequestFailed:
	            case general_1.ResponseCode.DuplicateEmail:
	            case general_1.ResponseCode.DataCorruption:
	            case general_1.ResponseCode.UnspecifiedError:
	            default:
	                this.alertDisconnect(m.code);
	                break;
	        }
	        this.messaging.restart();
	        this.bailIfNeeded(bailMessage);
	    };
	    AuthService.prototype.bailIfNeeded = function (msg) {
	        if (this.routeIsSessionDependent(this.activatedRoute)) {
	            this.alerts.add({
	                message: "Because you had a subject open during a disconnect, you may\n                  need to reload the page.",
	                type: "error",
	                actionLabel: "Reload",
	                action: function () { return window.location.reload(false); }
	            });
	        }
	    };
	    AuthService.prototype.routeIsSessionDependent = function (route) {
	        if (!(route instanceof router_1.ActivatedRoute)) {
	            return false;
	        }
	        if (route.snapshot.data.existingSessionOnly) {
	            return true;
	        }
	        if (route.firstChild) {
	            return this.routeIsSessionDependent(route.firstChild);
	        }
	        return false;
	    };
	    AuthService.prototype.changePassword = function (newPassword, oldPassword) {
	        var msg = new credentials_1.ChangePasswordRequest(this.hasher.hexOf(this.salter.salt(newPassword)), this.hasher.hexOf(this.salter.salt(oldPassword)));
	        return this.messaging.send(msg);
	    };
	    AuthService.prototype.resetPassword = function (objectId, password) {
	        var msg = new reset_user_password_request_1.ResetUserPasswordRequest(objectId, this.hasher.hexOf(this.salter.salt(password)));
	        return this.messaging.send(msg);
	    };
	    AuthService.prototype.changePrompts = function (prompts) {
	        var _this = this;
	        var pairs = prompts.map(function (_a) {
	            var question = _a.question, answer = _a.answer;
	            return {
	                prompt: question,
	                response: _this.hasher.hexOf(_this.salter.salt(answer))
	            };
	        });
	        return this.messaging.send(new credentials_1.ModifySecurityQuestionsClientResponse(pairs));
	    };
	    AuthService.prototype.requestResetEmail = function (login) {
	        return this.messaging.resultOf(new credentials_1.SendPasswordResetEmailRequest(login));
	    };
	    AuthService.prototype.resetFailure = function (failedOnToken, err) {
	        console.error(err);
	        if (failedOnToken) {
	            this.prompt.error(new Error("Your reset token was invalid or expired."));
	        }
	        else {
	            this.prompt.error(new Error("The server did not accept your answer."));
	        }
	        this.promptSub.unsubscribe();
	    };
	    AuthService.prototype.beginResetFlow = function (token) {
	        var _this = this;
	        this.prompt = new Rx_1.BehaviorSubject("Loading...");
	        this.messaging.send(new credentials_1.BeginPasswordResetRequest(token)).subscribe(function (reply) {
	            if (reply.code === general_1.ResponseCode.RequestExpired) {
	                _this.resetFailure(true);
	            }
	        }, function (err) { return _this.resetFailure(true, err); });
	        this.promptSub = this.messaging.receive(general_1.MessageTag.SREQ_CREDENTIAL_CHALLENGE).subscribe(function (msg) { return _this.prompt.next(msg.prompt); });
	        this.promptSub.add(this.messaging.receive(general_1.MessageTag.SREQ_NEW_PASSWORD).subscribe(function () {
	            _this.prompt.complete();
	            _this.promptSub.unsubscribe();
	        }));
	        return this.prompt;
	    };
	    AuthService.prototype.supplySecureAnswer = function (answer) {
	        var _this = this;
	        this.messaging.send(new credentials_1.CredentialChallengeClientResponse(this.hasher.hexOf(this.salter.salt(answer)))).subscribe({ error: function (err) { return _this.resetFailure(false, err); } });
	    };
	    AuthService.prototype.finishResetFlow = function (newPassword) {
	        var _this = this;
	        return this.messaging.successful(new credentials_1.NewPasswordClientResponse(this.hasher.hexOf(this.salter.salt(newPassword)))).do(function () { return _this.authSucceeded(); });
	    };
	    AuthService.prototype.guestLogin = function () {
	        var _this = this;
	        return this.messaging.send(new auth_1.StartGuestSessionRequest()).map(function (reply) {
	            if (general_1.AcknowledgmentResponse.isOk(reply)) {
	                _this.state = AuthState.Authenticated;
	                return true;
	            }
	            return false;
	        });
	    };
	    __decorate([
	        decorators_1.disconnectValue(AuthState.Unauthenticated),
	        __metadata("design:type", Number)
	    ], AuthService.prototype, "state", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Array)
	    ], AuthService.prototype, "redirectTo", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Function)
	    ], AuthService.prototype, "specialRedirectBehavior", void 0);
	    AuthService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            router_1.Router,
	            router_1.ActivatedRoute,
	            hasher_service_1.Hasher,
	            salter_service_1.Salter,
	            alert_service_1.AlertService,
	            bootstrap_1.Modal,
	            configuration_service_1.ConfigurationService])
	    ], AuthService);
	    return AuthService;
	}());
	exports.AuthService = AuthService;
	exports.AUTH_PROVIDERS = [
	    AuthService,
	    hasher_service_1.Hasher,
	    salter_service_1.Salter
	];


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var begin_password_reset_request_1 = __webpack_require__(779);
	exports.BeginPasswordResetRequest = begin_password_reset_request_1.BeginPasswordResetRequest;
	var change_password_request_1 = __webpack_require__(780);
	exports.ChangePasswordRequest = change_password_request_1.ChangePasswordRequest;
	var credential_challenge_client_response_1 = __webpack_require__(781);
	exports.CredentialChallengeClientResponse = credential_challenge_client_response_1.CredentialChallengeClientResponse;
	var credential_challenge_server_request_1 = __webpack_require__(782);
	exports.CredentialChallengeServerRequest = credential_challenge_server_request_1.CredentialChallengeServerRequest;
	var modify_security_questions_client_response_1 = __webpack_require__(783);
	exports.ModifySecurityQuestionsClientResponse = modify_security_questions_client_response_1.ModifySecurityQuestionsClientResponse;
	var modify_security_questions_server_request_1 = __webpack_require__(784);
	exports.ModifySecurityQuestionsServerRequest = modify_security_questions_server_request_1.ModifySecurityQuestionsServerRequest;
	var new_password_client_response_1 = __webpack_require__(785);
	exports.NewPasswordClientResponse = new_password_client_response_1.NewPasswordClientResponse;
	var new_password_server_request_1 = __webpack_require__(786);
	exports.NewPasswordServerRequest = new_password_server_request_1.NewPasswordServerRequest;
	var send_password_reset_email_request_1 = __webpack_require__(787);
	exports.SendPasswordResetEmailRequest = send_password_reset_email_request_1.SendPasswordResetEmailRequest;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var BeginPasswordResetRequest = (function (_super) {
	    __extends(BeginPasswordResetRequest, _super);
	    function BeginPasswordResetRequest(token) {
	        var _this = _super.call(this) || this;
	        _this.token = token;
	        _this.tag = message_tag_1.MessageTag.REQ_BEGIN_PASSWORD_RESET;
	        return _this;
	    }
	    BeginPasswordResetRequest.prototype.expectsReply = function () {
	        return true;
	    };
	    BeginPasswordResetRequest.tag = message_tag_1.MessageTag.REQ_BEGIN_PASSWORD_RESET;
	    return BeginPasswordResetRequest;
	}(reply_message_1.Message));
	exports.BeginPasswordResetRequest = BeginPasswordResetRequest;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ChangePasswordRequest = (function (_super) {
	    __extends(ChangePasswordRequest, _super);
	    function ChangePasswordRequest(password, currentPassword) {
	        var _this = _super.call(this) || this;
	        _this.password = password;
	        _this.currentPassword = currentPassword;
	        _this.tag = message_tag_1.MessageTag.REQ_CHANGE_PASSWORD;
	        return _this;
	    }
	    ChangePasswordRequest.tag = message_tag_1.MessageTag.REQ_CHANGE_PASSWORD;
	    return ChangePasswordRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ChangePasswordRequest = ChangePasswordRequest;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var message_tag_1 = __webpack_require__(515);
	var CredentialChallengeClientResponse = (function (_super) {
	    __extends(CredentialChallengeClientResponse, _super);
	    function CredentialChallengeClientResponse(response) {
	        var _this = _super.call(this) || this;
	        _this.response = response;
	        _this.tag = message_tag_1.MessageTag.CRSP_CREDENTIAL_CHALLENGE;
	        return _this;
	    }
	    CredentialChallengeClientResponse.prototype.expectsReply = function () {
	        return true;
	    };
	    return CredentialChallengeClientResponse;
	}(message_1.Message));
	exports.CredentialChallengeClientResponse = CredentialChallengeClientResponse;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decorators_1 = __webpack_require__(521);
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var CredentialChallengeServerRequest = (function (_super) {
	    __extends(CredentialChallengeServerRequest, _super);
	    function CredentialChallengeServerRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.SREQ_CREDENTIAL_CHALLENGE;
	        return _this;
	    }
	    CredentialChallengeServerRequest.tag = message_tag_1.MessageTag.SREQ_CREDENTIAL_CHALLENGE;
	    __decorate([
	        decorators_1.validateAs("string"),
	        __metadata("design:type", String)
	    ], CredentialChallengeServerRequest.prototype, "prompt", void 0);
	    CredentialChallengeServerRequest = __decorate([
	        decorators_1.validateFor(message_tag_1.MessageTag.SREQ_CREDENTIAL_CHALLENGE)
	    ], CredentialChallengeServerRequest);
	    return CredentialChallengeServerRequest;
	}(incoming_message_1.IncomingMessage));
	exports.CredentialChallengeServerRequest = CredentialChallengeServerRequest;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ModifySecurityQuestionsClientResponse = (function (_super) {
	    __extends(ModifySecurityQuestionsClientResponse, _super);
	    function ModifySecurityQuestionsClientResponse(prompts) {
	        var _this = _super.call(this) || this;
	        _this.prompts = prompts;
	        _this.tag = message_tag_1.MessageTag.CRSP_MODIFY_SECURITY_QUESTIONS;
	        return _this;
	    }
	    return ModifySecurityQuestionsClientResponse;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ModifySecurityQuestionsClientResponse = ModifySecurityQuestionsClientResponse;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ModifySecurityQuestionsServerRequest = (function (_super) {
	    __extends(ModifySecurityQuestionsServerRequest, _super);
	    function ModifySecurityQuestionsServerRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.SREQ_MODIFY_SECURITY_QUESTIONS;
	        return _this;
	    }
	    ModifySecurityQuestionsServerRequest.tag = message_tag_1.MessageTag.SREQ_MODIFY_SECURITY_QUESTIONS;
	    return ModifySecurityQuestionsServerRequest;
	}(incoming_message_1.IncomingMessage));
	exports.ModifySecurityQuestionsServerRequest = ModifySecurityQuestionsServerRequest;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var NewPasswordClientResponse = (function (_super) {
	    __extends(NewPasswordClientResponse, _super);
	    function NewPasswordClientResponse(password) {
	        var _this = _super.call(this) || this;
	        _this.password = password;
	        _this.tag = message_tag_1.MessageTag.CRSP_NEW_PASSWORD;
	        return _this;
	    }
	    return NewPasswordClientResponse;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.NewPasswordClientResponse = NewPasswordClientResponse;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var NewPasswordServerRequest = (function (_super) {
	    __extends(NewPasswordServerRequest, _super);
	    function NewPasswordServerRequest() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.SREQ_NEW_PASSWORD;
	        return _this;
	    }
	    NewPasswordServerRequest.tag = message_tag_1.MessageTag.SREQ_NEW_PASSWORD;
	    return NewPasswordServerRequest;
	}(incoming_message_1.IncomingMessage));
	exports.NewPasswordServerRequest = NewPasswordServerRequest;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var response_code_1 = __webpack_require__(527);
	var message_tag_1 = __webpack_require__(515);
	var SendPasswordResetEmailRequest = (function (_super) {
	    __extends(SendPasswordResetEmailRequest, _super);
	    function SendPasswordResetEmailRequest(login) {
	        var _this = _super.call(this) || this;
	        _this.login = login;
	        _this.tag = message_tag_1.MessageTag.REQ_SEND_PASSWORD_RESET_EMAIL;
	        return _this;
	    }
	    SendPasswordResetEmailRequest.prototype.verifyReply = function (reply) {
	        return (reply_message_1.Message.isA(reply, message_tag_1.MessageTag.DOWN_DISCONNECT)
	            && reply.code === response_code_1.ResponseCode.OK);
	    };
	    SendPasswordResetEmailRequest.tag = message_tag_1.MessageTag.REQ_SEND_PASSWORD_RESET_EMAIL;
	    return SendPasswordResetEmailRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SendPasswordResetEmailRequest = SendPasswordResetEmailRequest;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var ResetUserPasswordRequest = (function (_super) {
	    __extends(ResetUserPasswordRequest, _super);
	    function ResetUserPasswordRequest(objectId, password) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.password = password;
	        _this.tag = general_1.MessageTag.REQ_RESET_USER_PASSWORD;
	        return _this;
	    }
	    ResetUserPasswordRequest.tag = general_1.MessageTag.REQ_RESET_USER_PASSWORD;
	    return ResetUserPasswordRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.ResetUserPasswordRequest = ResetUserPasswordRequest;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var SpinnerComponent = (function () {
	    function SpinnerComponent() {
	        this.type = "ellipsis";
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], SpinnerComponent.prototype, "type", void 0);
	    SpinnerComponent = __decorate([
	        core_1.Component({
	            selector: "spinner",
	            template: "\n    <div *ngIf=\"type === 'ellipsis'\" class=\"loader ellipsis\">\n      <div class=\"bounce1\"></div>\n      <div class=\"bounce2\"></div>\n      <div class=\"bounce3\"></div>\n    </div>\n  "
	        })
	    ], SpinnerComponent);
	    return SpinnerComponent;
	}());
	exports.SpinnerComponent = SpinnerComponent;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var prettyjson_pipe_1 = __webpack_require__(791);
	exports.PrettyJsonPipe = prettyjson_pipe_1.PrettyJsonPipe;
	var json_pipe_1 = __webpack_require__(793);
	exports.SafeJsonPipe = json_pipe_1.SafeJsonPipe;
	var prettyjson_component_1 = __webpack_require__(794);
	exports.PrettyJsonComponent = prettyjson_component_1.PrettyJsonComponent;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var safe_util_1 = __webpack_require__(792);
	var PrettyJsonPipe = (function () {
	    function PrettyJsonPipe() {
	    }
	    PrettyJsonPipe.prototype.transform = function (obj, spaces) {
	        if (spaces === void 0) { spaces = 2; }
	        return this._syntaxHighlight(obj, safe_util_1.serializer(), spaces);
	    };
	    PrettyJsonPipe.prototype._syntaxHighlight = function (json, serializer, spacing) {
	        // Credits to the accepted answer here http://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
	        if (typeof json !== "string") {
	            json = JSON.stringify(json, serializer, spacing);
	        }
	        json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
	            var cls = "number";
	            if (/^"/.test(match)) {
	                if (/:$/.test(match)) {
	                    cls = "key";
	                }
	                else {
	                    cls = "string";
	                }
	            }
	            else if (/true|false/.test(match)) {
	                cls = "boolean";
	            }
	            else if (/null/.test(match)) {
	                cls = "null";
	            }
	            return "<span class=\"" + cls + "\">" + match + "</span>";
	        });
	    };
	    PrettyJsonPipe = __decorate([
	        core_1.Pipe({
	            name: "prettyjson",
	            pure: false
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PrettyJsonPipe);
	    return PrettyJsonPipe;
	}());
	exports.PrettyJsonPipe = PrettyJsonPipe;
	//# sourceMappingURL=prettyjson.pipe.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	"use strict";
	// Taken from github.com/isaacs/json-stringify-safe
	function serializer() {
	    var stack = [];
	    var keys = [];
	    var cycleReplacer = function (key, value) {
	        if (stack[0] === value) {
	            return "[Circular ~]";
	        }
	        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
	    };
	    return function (key, value) {
	        if (stack.length > 0) {
	            var thisPos = stack.indexOf(this);
	            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	            if (~stack.indexOf(value)) {
	                value = cycleReplacer.call(this, key, value);
	            }
	        }
	        else {
	            stack.push(value);
	        }
	        return value;
	    };
	}
	exports.serializer = serializer;
	//# sourceMappingURL=safe.util.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var safe_util_1 = __webpack_require__(792);
	var SafeJsonPipe = (function () {
	    function SafeJsonPipe() {
	    }
	    SafeJsonPipe.prototype.transform = function (obj, spaces) {
	        if (spaces === void 0) { spaces = 2; }
	        return JSON.stringify(obj, safe_util_1.serializer(), spaces);
	    };
	    SafeJsonPipe = __decorate([
	        core_1.Pipe({
	            name: "json",
	            pure: false
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SafeJsonPipe);
	    return SafeJsonPipe;
	}());
	exports.SafeJsonPipe = SafeJsonPipe;
	//# sourceMappingURL=json.pipe.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var prettyjson_pipe_1 = __webpack_require__(791);
	var PrettyJsonComponent = (function () {
	    function PrettyJsonComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PrettyJsonComponent.prototype, "obj", void 0);
	    PrettyJsonComponent = __decorate([
	        core_1.Component({
	            selector: "prettyjson",
	            pipes: [prettyjson_pipe_1.PrettyJsonPipe],
	            template: "\n    <pre [innerHtml]=\"obj | prettyjson\">\n    </pre>\n  ",
	            styles: [
	                "pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }\n    :host >>> .string { color: green; }\n    :host >>> .number { color: darkorange; }\n    :host >>> .boolean { color: blue; }\n    :host >>> .null { color: magenta; }\n    :host >>> .key { color: red; }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PrettyJsonComponent);
	    return PrettyJsonComponent;
	}());
	exports.PrettyJsonComponent = PrettyJsonComponent;
	//# sourceMappingURL=prettyjson.component.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var ArraySegmentsPipe = (function () {
	    function ArraySegmentsPipe() {
	    }
	    ArraySegmentsPipe.prototype.transform = function (value, pieces) {
	        if (pieces === void 0) { pieces = 2; }
	        if (value === null) {
	            return null;
	        }
	        if (value === undefined) {
	            return undefined;
	        }
	        if (!Array.isArray(value)) {
	            console.warn("Join pipe operating on non-array:", value);
	            return [value];
	        }
	        var length = Math.ceil(value.length / pieces);
	        var subarrays = [];
	        for (var i = 0; i < pieces; i++) {
	            subarrays[i] = value.slice(i * length, (i + 1) * length);
	        }
	        return subarrays;
	    };
	    ArraySegmentsPipe = __decorate([
	        core_1.Pipe({ name: "segments" })
	    ], ArraySegmentsPipe);
	    return ArraySegmentsPipe;
	}());
	exports.ArraySegmentsPipe = ArraySegmentsPipe;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var BytesPipe = (function () {
	    function BytesPipe() {
	    }
	    BytesPipe_1 = BytesPipe;
	    BytesPipe.prototype.format = function (value) {
	        var index = Math.min(Math.max(Math.floor(Math.log10(value) / 3), 0), BytesPipe_1.prefixes.length - 1);
	        var prefix = BytesPipe_1.prefixes[index];
	        var major = value / Math.pow(10, 3 * index);
	        return major + " " + prefix + "b";
	    };
	    BytesPipe.prototype.transform = function (value) {
	        if (typeof value === "number") {
	            return this.format(value);
	        }
	        else {
	            return value;
	        }
	    };
	    var BytesPipe_1;
	    BytesPipe.prefixes = [
	        "",
	        "k",
	        "M",
	        "G",
	        "T"
	    ];
	    BytesPipe = BytesPipe_1 = __decorate([
	        core_1.Pipe({ name: "bytes" })
	    ], BytesPipe);
	    return BytesPipe;
	}());
	exports.BytesPipe = BytesPipe;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var moment = __webpack_require__(70);
	var CalendarTimePipe = (function () {
	    function CalendarTimePipe() {
	    }
	    CalendarTimePipe.prototype.format = function (value) {
	        return value.calendar();
	    };
	    CalendarTimePipe.prototype.transform = function (value) {
	        if (value instanceof Date) {
	            return this.format(moment(value));
	        }
	        else if (typeof value === "number") {
	            return this.format(moment.utc(value));
	        }
	        else {
	            return value;
	        }
	    };
	    CalendarTimePipe = __decorate([
	        core_1.Pipe({ name: "calendarTime" })
	    ], CalendarTimePipe);
	    return CalendarTimePipe;
	}());
	exports.CalendarTimePipe = CalendarTimePipe;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var JoinPipe = (function () {
	    function JoinPipe() {
	    }
	    JoinPipe.prototype.transform = function (value, delimiter) {
	        if (delimiter === void 0) { delimiter = ", "; }
	        if (value === null) {
	            return null;
	        }
	        if (value === undefined) {
	            return undefined;
	        }
	        if (!Array.isArray(value)) {
	            console.warn("Join pipe operating on non-array:", value);
	            return "~";
	        }
	        return value.join(delimiter);
	    };
	    JoinPipe = __decorate([
	        core_1.Pipe({ name: "join", pure: false })
	    ], JoinPipe);
	    return JoinPipe;
	}());
	exports.JoinPipe = JoinPipe;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var KeysPipe = (function () {
	    function KeysPipe() {
	    }
	    KeysPipe.prototype.transform = function (obj) {
	        return Object.keys(obj);
	    };
	    KeysPipe = __decorate([
	        core_1.Pipe({
	            name: "keys"
	        })
	    ], KeysPipe);
	    return KeysPipe;
	}());
	exports.KeysPipe = KeysPipe;
	var EntriesPipe = (function () {
	    function EntriesPipe() {
	    }
	    EntriesPipe.prototype.transform = function (obj) {
	        return Object.entries(obj);
	    };
	    EntriesPipe = __decorate([
	        core_1.Pipe({
	            name: "entries"
	        })
	    ], EntriesPipe);
	    return EntriesPipe;
	}());
	exports.EntriesPipe = EntriesPipe;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var OrdinalPipe = (function () {
	    function OrdinalPipe() {
	    }
	    OrdinalPipe.prototype.transform = function (value, locale) {
	        if (locale === void 0) { locale = "en"; }
	        if (!Number.isInteger(value)) {
	            throw new Error("Ordinalization only works on integers! " + value + " given.");
	        }
	        if (locale.toLowerCase() === "en") {
	            return this.ordinalizeEnglish(value);
	        }
	        throw new Error("Non-English locales not yet supported for ordinalize!");
	    };
	    OrdinalPipe.prototype.ordinalizeEnglish = function (i) {
	        var isTeen = ((i % 100) > 10) && ((i % 100) < 20);
	        if (!isTeen) {
	            var ones = i % 10;
	            if (ones === 1) {
	                return i + "st";
	            }
	            if (ones === 2) {
	                return i + "nd";
	            }
	            if (ones === 3) {
	                return i + "rd";
	            }
	        }
	        return i + "th";
	    };
	    OrdinalPipe = __decorate([
	        core_1.Pipe({ name: "ordinal" })
	    ], OrdinalPipe);
	    return OrdinalPipe;
	}());
	exports.OrdinalPipe = OrdinalPipe;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var PercentagePipe = (function () {
	    function PercentagePipe() {
	    }
	    PercentagePipe.prototype.transform = function (value, digits) {
	        if (digits === void 0) { digits = 2; }
	        var f = Math.pow(10, digits);
	        return (Math.round(value * f * 100) / f).toString(10) + "%";
	    };
	    PercentagePipe = __decorate([
	        core_1.Pipe({ name: "percent" })
	    ], PercentagePipe);
	    return PercentagePipe;
	}());
	exports.PercentagePipe = PercentagePipe;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var PluralizationPipe = (function () {
	    function PluralizationPipe() {
	    }
	    PluralizationPipe.prototype.transform = function (value, singular, plural) {
	        if (plural === void 0) { plural = (singular + "s"); }
	        return value + " " + ((value === 1) ? singular : plural);
	    };
	    PluralizationPipe = __decorate([
	        core_1.Pipe({ name: "plural" })
	    ], PluralizationPipe);
	    return PluralizationPipe;
	}());
	exports.PluralizationPipe = PluralizationPipe;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var ReversePipe = (function () {
	    function ReversePipe(differs) {
	        this.differ = differs.find([]).create(null);
	    }
	    ReversePipe.prototype.transform = function (value) {
	        var changes = this.differ.diff(value);
	        if (changes) {
	            this.cached = Array.from(value).reverse();
	        }
	        return this.cached;
	    };
	    ReversePipe = __decorate([
	        core_1.Pipe({
	            name: "reverse",
	            pure: false
	        }),
	        __metadata("design:paramtypes", [core_1.IterableDiffers])
	    ], ReversePipe);
	    return ReversePipe;
	}());
	exports.ReversePipe = ReversePipe;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var SquashIndicesPipe = (function () {
	    function SquashIndicesPipe() {
	    }
	    SquashIndicesPipe.prototype.transform = function (value) {
	        if (!value) {
	            console.log("Squashed falsy", value);
	            return value;
	        }
	        if (!Array.isArray(value)) {
	            console.warn(value);
	            throw new Error("SquashIndicesPipe only works on arrays!");
	        }
	        var result = [];
	        value.forEach(function (v) { return result.push(v); });
	        console.log("Squashed to ", result);
	        return result;
	    };
	    SquashIndicesPipe = __decorate([
	        core_1.Pipe({ name: "squashIndices", pure: false })
	    ], SquashIndicesPipe);
	    return SquashIndicesPipe;
	}());
	exports.SquashIndicesPipe = SquashIndicesPipe;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var ThousandsPipe = (function () {
	    function ThousandsPipe() {
	    }
	    ThousandsPipe.prototype.transform = function (value) {
	        if (typeof value === "number") {
	            return value.toLocaleString();
	        }
	        else {
	            return value;
	        }
	    };
	    ThousandsPipe = __decorate([
	        core_1.Pipe({ name: "thou" })
	    ], ThousandsPipe);
	    return ThousandsPipe;
	}());
	exports.ThousandsPipe = ThousandsPipe;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var UnicodeOffsetPipe = (function () {
	    function UnicodeOffsetPipe() {
	    }
	    UnicodeOffsetPipe_1 = UnicodeOffsetPipe;
	    UnicodeOffsetPipe.offset = function (value, offset) {
	        if (offset === void 0) { offset = 0; }
	        console.log(value.split("").map(function (s) { return s.codePointAt(0) + offset; }));
	        return String.fromCodePoint.apply(null, value.split("").map(function (s) { return s.codePointAt(0) + offset; }));
	    };
	    UnicodeOffsetPipe.prototype.transform = function (value, offset) {
	        if (offset === void 0) { offset = 0; }
	        if (typeof value !== "string" || value.length === 0) {
	            return value;
	        }
	        return UnicodeOffsetPipe_1.offset(value, offset);
	    };
	    var UnicodeOffsetPipe_1;
	    UnicodeOffsetPipe = UnicodeOffsetPipe_1 = __decorate([
	        core_1.Pipe({ name: "u_offset" })
	    ], UnicodeOffsetPipe);
	    return UnicodeOffsetPipe;
	}());
	exports.UnicodeOffsetPipe = UnicodeOffsetPipe;
	var LC_ROMAN_TO_FLAG_DELTA = 0x1f1e6 - 0x61;
	var FlagifyPipe = (function () {
	    function FlagifyPipe() {
	    }
	    FlagifyPipe.prototype.transform = function (value) {
	        if (typeof value !== "string" || value.length === 0) {
	            return value;
	        }
	        return UnicodeOffsetPipe.offset(value.toLocaleLowerCase(), LC_ROMAN_TO_FLAG_DELTA);
	    };
	    FlagifyPipe = __decorate([
	        core_1.Pipe({ name: "flagify" })
	    ], FlagifyPipe);
	    return FlagifyPipe;
	}());
	exports.FlagifyPipe = FlagifyPipe;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var moment = __webpack_require__(70);
	var DEFAULT_FORMAT = "MMM D, YYYY";
	var SINCE_SPECIAL_FORMAT = 'SINCE';
	var UtcDatePipe = (function () {
	    function UtcDatePipe() {
	    }
	    UtcDatePipe.prototype.transform = function (value, format) {
	        if (format === void 0) { format = DEFAULT_FORMAT; }
	        if (format === SINCE_SPECIAL_FORMAT) {
	            return moment.utc(value).fromNow();
	        }
	        return moment.utc(value).format(format);
	    };
	    UtcDatePipe = __decorate([
	        core_1.Pipe({ name: "utcDate" })
	    ], UtcDatePipe);
	    return UtcDatePipe;
	}());
	exports.UtcDatePipe = UtcDatePipe;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(21);
	var UnsafePipe = (function () {
	    function UnsafePipe(sanitizer) {
	        this.sanitizer = sanitizer;
	    }
	    UnsafePipe.prototype.transform = function (value, delimiter) {
	        if (delimiter === void 0) { delimiter = ", "; }
	        if (value === null) {
	            return null;
	        }
	        if (value === undefined) {
	            return undefined;
	        }
	        return this.sanitizer.bypassSecurityTrustHtml(value);
	    };
	    UnsafePipe = __decorate([
	        core_1.Pipe({ name: "unsafe", pure: true }),
	        __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
	    ], UnsafePipe);
	    return UnsafePipe;
	}());
	exports.UnsafePipe = UnsafePipe;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(21);
	var router_1 = __webpack_require__(41);
	var Rx_1 = __webpack_require__(214);
	var algorithm_service_1 = __webpack_require__(213);
	var user_service_1 = __webpack_require__(713);
	var alert_service_1 = __webpack_require__(689);
	var setting_service_1 = __webpack_require__(690);
	var app_routing_1 = __webpack_require__(810);
	var download_socket_1 = __webpack_require__(687);
	var messages_1 = __webpack_require__(754);
	var aggregation_1 = __webpack_require__(565);
	var schemas_1 = __webpack_require__(646);
	var export_1 = __webpack_require__(618);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var utilities_1 = __webpack_require__(523);
	var aggregation_2 = __webpack_require__(899);
	var aggregator_1 = __webpack_require__(903);
	var data_export_1 = __webpack_require__(904);
	var exporter_1 = __webpack_require__(906);
	var toolbox_activity_1 = __webpack_require__(902);
	var ToolUIPanel;
	(function (ToolUIPanel) {
	    ToolUIPanel[ToolUIPanel["Analysis"] = 0] = "Analysis";
	    ToolUIPanel[ToolUIPanel["Export"] = 1] = "Export";
	    ToolUIPanel[ToolUIPanel["Schemas"] = 2] = "Schemas";
	})(ToolUIPanel = exports.ToolUIPanel || (exports.ToolUIPanel = {}));
	var AggregationService = (function () {
	    function AggregationService(messaging, algorithms, sanitizer, alerts, users, settings, router) {
	        var _this = this;
	        this.messaging = messaging;
	        this.algorithms = algorithms;
	        this.sanitizer = sanitizer;
	        this.alerts = alerts;
	        this.users = users;
	        this.settings = settings;
	        this.router = router;
	        this.aggregators = [];
	        this.aggregations = [];
	        this.aggregationSchemas = [];
	        this.exporters = [];
	        this.exports = [];
	        this.exportSchemas = [];
	        this.schemaCount = 0;
	        this.selectedPanel = ToolUIPanel.Analysis;
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    AggregationService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(messages_1.MessageTag.RSP_AVAILABLE_AGGREGATORS).flatMap(function (aar) { return aar.aggregators; }).subscribe(function (desc) {
	            _this.aggregators.push(aggregator_1.Aggregator.fromDescriptor(desc));
	        });
	        this.messaging.receive(messages_1.MessageTag.RSP_AVAILABLE_DATA_EXPORTS).flatMap(function (ader) { return ader.formats; }).subscribe(function (desc) {
	            _this.exporters.push(exporter_1.Exporter.fromDescriptor(desc));
	        });
	        this.messaging.receiveAnyOf([
	            messages_1.MessageTag.RSP_DATA_EXPORT_REPORT,
	            messages_1.MessageTag.RSP_AGGREGATOR_REPORT
	        ]).subscribe(function (report) {
	            var existing = (report instanceof aggregation_1.AggregatorReportResponse)
	                ? _this.aggregations.find(function (x) { return x.id === report.aggregationId; })
	                : _this.exports.find(function (x) { return x.id === report.exportId; });
	            if (existing) {
	                existing.readMessageReport(report);
	                if (!_this.router.isActive(app_routing_1.AGGREGATION_MODULE_URL, false)) {
	                    _this.alerts.add({
	                        type: "success",
	                        message: utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                                Tool <em>\"", "\"</em>\n                                has finished running"], ["\n                                Tool <em>\"", "\"</em>\n                                has finished running"])), existing.title),
	                        timeout: _this.alerts.getDefaultTimeout(),
	                        actionLabel: "View",
	                        action: function () {
	                            _this.router.navigateByUrl(app_routing_1.AGGREGATION_MODULE_URL);
	                            _this.selectedPanel =
	                                existing instanceof aggregation_2.Aggregation
	                                    ? ToolUIPanel.Analysis
	                                    : ToolUIPanel.Export;
	                        }
	                    });
	                }
	            }
	            else {
	                var id = report.exportId
	                    || report.aggregationId;
	                throw new Error("Received report for unknown task " + id);
	            }
	        });
	        this.messaging.receiveAnyOf([
	            messages_1.MessageTag.RSP_STATUS_AGGREGATOR,
	            messages_1.MessageTag.RSP_STATUS_DATA_EXPORT
	        ]).subscribe(function (status) {
	            var existing = (status instanceof aggregation_1.AggregatorStatusResponse)
	                ? _this.aggregations.find(function (x) { return x.id === status.aggregationId; })
	                : _this.exports.find(function (x) { return x.id === status.exportId; });
	            if (existing) {
	                existing.readProgress(status);
	            }
	            else {
	                var id = status.exportId
	                    || status.aggregationId;
	                throw new Error("Received status for unknown task " + id);
	            }
	        });
	        this.messaging.receive(messages_1.MessageTag.RSP_REFRESH_REPORT_SCHEMAS).subscribe(function (schemaResponse) {
	            return _this.processSchemas(schemaResponse);
	        });
	    };
	    AggregationService.prototype.disconnected = function () {
	        this.aggregators = [];
	        this.aggregations = [];
	    };
	    AggregationService.prototype.startConfiguration = function (tool, algorithmName, group) {
	        var algorithm = this.algorithms.findAlgorithm(algorithmName);
	        if (tool instanceof aggregator_1.Aggregator) {
	            this.configureAggregator(tool, algorithm, group).subscribe();
	        }
	        else if (tool instanceof exporter_1.Exporter) {
	            this.configureExporter(tool, algorithm, group).subscribe();
	        }
	        else {
	            throw new Error("Unknown tool type: " + tool);
	        }
	    };
	    AggregationService.prototype.processSchemas = function (schemaResponse) {
	        var _this = this;
	        this.exportSchemas = schemaResponse.dataExportSchemas;
	        this.aggregationSchemas = schemaResponse.aggregationSchemas;
	        this.schemaCount =
	            this.exportSchemas.length + this.aggregationSchemas.length;
	        this.users.ready.first(utilities_1.identity).subscribe(function () {
	            _this.exportSchemas.forEach(function (schema) {
	                return schema.group = _this.users.self.groups.find(function (g) { return g.id === schema.groupId; });
	            });
	            _this.aggregationSchemas.forEach(function (schema) {
	                return schema.group = _this.users.self.groups.find(function (g) { return g.id === schema.groupId; });
	            });
	        });
	        this.algorithms.ready.first(utilities_1.identity).subscribe(function () {
	            _this.exportSchemas.forEach(function (schema) {
	                return schema.algorithmObject =
	                    _this.algorithms.findAlgorithm(schema.algorithm);
	            });
	            _this.aggregationSchemas.forEach(function (schema) {
	                return schema.algorithmObject =
	                    _this.algorithms.findAlgorithm(schema.algorithm);
	            });
	        });
	    };
	    AggregationService.prototype.startFromSchema = function (schema, isExport) {
	        var configured;
	        var algorithm = this.algorithms.findAlgorithm(schema.algorithm);
	        var group = this.users.self.groups.find(function (g) { return g.id === schema.groupId; });
	        if (isExport) {
	            var exporter = this.exporters.find(function (e) {
	                return e.name === schema.format.formatName;
	            });
	            configured = this.configureExporter(exporter, algorithm, group);
	        }
	        else {
	            var aggregator = this.aggregators.find(function (a) {
	                return a.name === schema.aggregatorName;
	            });
	            configured = this.configureAggregator(aggregator, algorithm, group);
	        }
	        configured.subscribe(function (ta) {
	            console.log("start schema", ta, schema);
	            ta.readSchema(schema);
	        });
	    };
	    AggregationService.prototype.duplicateExport = function (dexport) {
	        var algorithm = this.algorithms.findAlgorithm(dexport.algorithm);
	        var group = this.users.self.groups.find(function (g) { return g.id === dexport.groupId; });
	        this.configureExporter(dexport.parent, algorithm, group).subscribe(function (newExport) { return newExport.copyFrom(dexport); });
	    };
	    AggregationService.prototype.configureAggregator = function (aggregator, algorithm, group) {
	        var _this = this;
	        return this.messaging.converse(new aggregation_1.CreateAggregatorRequest(aggregator.name, algorithm.name, algorithm.contextType, group.id)).map(function (car) {
	            var agg = aggregation_2.Aggregation.fromOptions(car, aggregator);
	            agg.algorithm = algorithm.displayName;
	            agg.group = group.name;
	            _this.aggregations.unshift(agg);
	            _this.selectedPanel = ToolUIPanel.Analysis;
	            return agg;
	        });
	    };
	    AggregationService.prototype.configureExporter = function (exporter, algorithm, group) {
	        var _this = this;
	        return this.messaging.converse(new export_1.CreateDataExportRequest(exporter.formatName, algorithm.name, algorithm.contextType, group.id)).map(function (cder) {
	            var exp = data_export_1.DataExport.fromOptions(cder, exporter);
	            exp.algorithm = algorithm.displayName;
	            exp.group = group.name;
	            exp.groupId = group.id;
	            _this.exports.unshift(exp);
	            _this.selectedPanel = ToolUIPanel.Export;
	            return exp;
	        });
	    };
	    AggregationService.prototype.run = function (task) {
	        if (task instanceof aggregation_2.Aggregation) {
	            this.runAggregation(task);
	        }
	        else if (task instanceof data_export_1.DataExport) {
	            this.runExport(task);
	        }
	        else {
	            throw new Error("Unknown toolbox activity: " + task);
	        }
	    };
	    AggregationService.prototype.runAggregation = function (aggregation) {
	        var filter;
	        try {
	            filter = aggregation.filter
	                ? aggregation.filter.marshal()
	                : null;
	        }
	        catch (err) {
	            alert("The filter you provided is incomplete or misconfigured.");
	            return;
	        }
	        this.messaging.successful(new aggregation_1.StartAggregatorRequest(aggregation.id, filter, aggregation.targetSelector.value, aggregation.isComplete)).subscribe(function () { return aggregation.markScheduled(); }, function (err) { return alert(err); });
	    };
	    AggregationService.prototype.runExport = function (dexport) {
	        var _this = this;
	        var filter;
	        try {
	            filter = dexport.filter
	                ? dexport.filter.marshal()
	                : null;
	        }
	        catch (err) {
	            alert("The filter you provided is incomplete or misconfigured.");
	            return;
	        }
	        console.groupCollapsed("Verbose export debugging " + dexport.id);
	        this.messaging.converse(new export_1.StartDataExportRequest(dexport.id, filter, dexport.columns, dexport.headersControl.value, dexport.delimiterControl.value, dexport.excelDatesControl.value, dexport.dropCollFilterEmptiesControl.value)).subscribe(function (ser) {
	            dexport.markScheduled();
	            dexport.downloadCredentials =
	                { token: ser.urlId, secret: ser.token };
	            _this.downloadExport(dexport);
	        }, function (err) { return alert(err); });
	    };
	    AggregationService.prototype.downloadExport = function (dexport) {
	        var _this = this;
	        if (!dexport.downloadCredentials) {
	            throw new Error("Export does not yet have download credentials");
	        }
	        Rx_1.Observable.zip(this.messaging.downloadFile(dexport.downloadCredentials.token, dexport.downloadCredentials.secret, dexport.parent.mimeType), this.messaging.receive(messages_1.MessageTag.RSP_DATA_EXPORT_REPORT).filter(function (message) {
	            return message.exportId === dexport.id;
	        }))
	            .flatMap(function (_a) {
	            var file = _a[0], derr = _a[1];
	            return file.verify(derr.bytesSent, derr.checksumUnsigned).map(function (v) { return [file, v]; });
	        }).subscribe(function (_a) {
	            var file = _a[0], verified = _a[1];
	            console.groupEnd();
	            if (verified) {
	                dexport.downloadFile = file;
	                if (_this.settings.get("experimental CSV fix") === true) {
	                    file.addBOM();
	                    dexport.expectedFilesize += download_socket_1.SocketFile.BOMByteLength;
	                }
	                _this.generateFileURLs(dexport);
	            }
	            else {
	                dexport.downloadFile = file;
	                _this.alerts.error(utilities_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    The file sent by the server failed validation\n                    and could not be downloaded."], ["\n                    The file sent by the server failed validation\n                    and could not be downloaded."]))));
	            }
	        });
	    };
	    AggregationService.prototype.generateFileURLs = function (task) {
	        task.downloadURL = task.downloadFile.generateUrl();
	        task.downloadSafeURL = this.sanitizer.bypassSecurityTrustUrl(task.downloadURL);
	    };
	    AggregationService.prototype.cancel = function (activity) {
	        this.messaging.successful(activity.requestFor("cancel")).subscribe(function () { return activity.state = toolbox_activity_1.ActivityState.Aborted; });
	    };
	    AggregationService.prototype.pause = function (activity) {
	        if (activity.state !== toolbox_activity_1.ActivityState.Running) {
	            console.error(activity);
	            throw new Error("Can only pause a running activity!");
	        }
	        this.messaging.successful(activity.requestFor("pause")).subscribe(function () { return activity.state = toolbox_activity_1.ActivityState.Paused; });
	    };
	    AggregationService.prototype.resume = function (activity) {
	        if (activity.state !== toolbox_activity_1.ActivityState.Paused) {
	            console.error(activity);
	            throw new Error("Can only resume a paused activity!");
	        }
	        this.messaging.successful(activity.requestFor("resume")).subscribe(function () { return activity.state = toolbox_activity_1.ActivityState.Running; });
	    };
	    AggregationService.prototype.release = function (activity) {
	        var _this = this;
	        if (activity instanceof aggregation_2.Aggregation) {
	            this.messaging.successful(new aggregation_1.DeleteAggregatorRequest(activity.id)).subscribe(function () {
	                activity.state = toolbox_activity_1.ActivityState.Released;
	                utilities_1.arrayRemove(_this.aggregations, activity);
	            });
	        }
	        else {
	            console.warn("[WARNING] No impl for telling server to release export agent");
	            utilities_1.arrayRemove(this.exports, activity);
	            URL.revokeObjectURL(activity.downloadURL);
	        }
	    };
	    AggregationService.prototype.requestProgress = function (activity) {
	        this.messaging.converse(activity.requestFor("status")).subscribe(function (asr) {
	            activity.readProgress(asr);
	        });
	    };
	    AggregationService.prototype.saveSchema = function (activity, name, groupVisible) {
	        var _this = this;
	        if (groupVisible === void 0) { groupVisible = false; }
	        if (activity instanceof data_export_1.DataExport) {
	            return this.messaging.converse(new schemas_1.SaveDataExportSchemaRequest(activity.id, name, groupVisible, activity.filenameControl.value)).flatMap(function () { return _this.messaging.successful(new schemas_1.RefreshReportSchemasRequest()); });
	        }
	        else {
	            return this.messaging.converse(new schemas_1.SaveAggregrationSchemaRequest(activity.id, name, groupVisible)).flatMap(function () { return _this.messaging.successful(new schemas_1.RefreshReportSchemasRequest()); });
	        }
	    };
	    AggregationService.prototype.deleteSchema = function (schema, isExport) {
	        var _this = this;
	        var msg = isExport
	            ? new schemas_1.DeleteDataExportSchemaRequest(schema.schemaId)
	            : new schemas_1.DeleteAggregationSchemaRequest(schema.schemaId);
	        this.messaging.converse(msg).subscribe(function (result) {
	            if (result.ok) {
	                utilities_1.arrayRemove((isExport
	                    ? _this.exportSchemas
	                    : _this.aggregationSchemas), schema);
	            }
	            else {
	                var addl = result.reason || "unknown reason";
	                _this.alerts.error("Could not remove template: " + addl);
	            }
	        });
	    };
	    AggregationService.prototype.toggleSchemaVisibility = function (schema, isExport) {
	        var msg = isExport
	            ? new schemas_1.ChangeDataExportSchemaVisibility(schema.schemaId, !schema.isGroupPublic)
	            : new schemas_1.ChangeAggregationSchemaVisibility(schema.schemaId, !schema.isGroupPublic);
	        this.messaging.converse(msg).subscribe(function () { return schema.isGroupPublic = !schema.isGroupPublic; });
	    };
	    AggregationService.prototype.renameSchema = function (schema, newName) {
	        throw new Error("Not yet implemented");
	    };
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "aggregators", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "aggregations", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "aggregationSchemas", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "exporters", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "exports", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], AggregationService.prototype, "exportSchemas", void 0);
	    __decorate([
	        decorators_1.disconnectValue(0),
	        __metadata("design:type", Number)
	    ], AggregationService.prototype, "schemaCount", void 0);
	    __decorate([
	        decorators_1.disconnectValue(ToolUIPanel.Analysis),
	        __metadata("design:type", Number)
	    ], AggregationService.prototype, "selectedPanel", void 0);
	    AggregationService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            algorithm_service_1.AlgorithmService,
	            platform_browser_1.DomSanitizer,
	            alert_service_1.AlertService,
	            user_service_1.UserService,
	            setting_service_1.SettingService,
	            router_1.Router])
	    ], AggregationService);
	    return AggregationService;
	}());
	exports.AggregationService = AggregationService;
	var templateObject_1, templateObject_2;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(41);
	var forgot_password_component_1 = __webpack_require__(811);
	var login_component_1 = __webpack_require__(812);
	var logout_component_1 = __webpack_require__(817);
	var rules_1 = __webpack_require__(640);
	var empty_component_1 = __webpack_require__(818);
	var page_not_found_component_1 = __webpack_require__(819);
	var welcome_component_1 = __webpack_require__(820);
	var welcome_guest_component_1 = __webpack_require__(831);
	var settings_component_1 = __webpack_require__(832);
	var sandbox_component_1 = __webpack_require__(833);
	var intake_form_component_1 = __webpack_require__(838);
	var first_check_v1_flow_component_1 = __webpack_require__(852);
	var permalink_component_1 = __webpack_require__(853);
	var subject_summary_component_1 = __webpack_require__(854);
	var subject_search_component_1 = __webpack_require__(865);
	var guarded_componentless_route_workaround_component_1 = __webpack_require__(869);
	var home_component_1 = __webpack_require__(870);
	var admin_zone_guard_1 = __webpack_require__(871);
	var algorithm_running_guard_1 = __webpack_require__(872);
	var auth_guard_1 = __webpack_require__(873);
	var debug_mode_guard_1 = __webpack_require__(874);
	var guests_only_guard_1 = __webpack_require__(875);
	var rule_restricted_guard_1 = __webpack_require__(876);
	var subject_loaded_guard_1 = __webpack_require__(877);
	var lists_browser_component_1 = __webpack_require__(878);
	var shared_worklist_component_1 = __webpack_require__(880);
	var shared_worklist_guard_1 = __webpack_require__(883);
	var intake_custom_component_1 = __webpack_require__(884);
	var feature_test_rig_component_1 = __webpack_require__(885);
	exports.AGGREGATION_MODULE_URL = "tools";
	exports.MANAGEMENT_MODULE_URL = "manage";
	var appRoutes = [
	    {
	        path: "",
	        pathMatch: "full",
	        component: welcome_component_1.WelcomeComponent
	    },
	    {
	        path: "guest",
	        pathMatch: "full",
	        component: welcome_guest_component_1.WelcomeGuestComponent
	    },
	    {
	        path: "login",
	        component: login_component_1.LoginComponent,
	        canActivate: [guests_only_guard_1.GuestsOnlyGuard]
	    },
	    {
	        path: "logout",
	        component: logout_component_1.LogoutComponent
	    },
	    {
	        path: "empty",
	        component: empty_component_1.EmptyComponent
	    },
	    {
	        path: "subject/:id",
	        canActivate: [auth_guard_1.AuthGuard, subject_loaded_guard_1.SubjectLoadedGuard],
	        data: { post_auth_redirect: "home", existingSessionOnly: true },
	        resolve: { subject: subject_loaded_guard_1.SubjectLoadedGuard },
	        children: [
	            {
	                path: "",
	                pathMatch: "full",
	                component: subject_summary_component_1.SubjectSummaryComponent
	            },
	            {
	                path: "custom",
	                component: intake_custom_component_1.CustomIntakeComponent,
	            },
	            {
	                path: ":algorithm",
	                component: intake_form_component_1.IntakeFormComponent,
	                canActivate: [algorithm_running_guard_1.AlgorithmRunningGuard],
	                canDeactivate: [algorithm_running_guard_1.AlgorithmRunningGuard]
	            }
	        ]
	    },
	    {
	        path: "lists",
	        pathMatch: "full",
	        component: lists_browser_component_1.WorklistBrowserComponent,
	        canActivate: [auth_guard_1.AuthGuard]
	    },
	    {
	        path: "lists/byGroup/:groupId/:objectId",
	        canActivate: [auth_guard_1.AuthGuard, shared_worklist_guard_1.SharedWorklistGuard],
	        data: { post_auth_redirect: "lists" },
	        resolve: { list: shared_worklist_guard_1.SharedWorklistGuard },
	        component: shared_worklist_component_1.SharedWorklistComponent,
	    },
	    {
	        path: "x/hcb/:case_id",
	        canActivate: [auth_guard_1.AuthGuard],
	        component: permalink_component_1.PermalinkComponent
	    },
	    {
	        path: "home",
	        component: home_component_1.HomeComponent,
	        canActivate: [auth_guard_1.AuthGuard]
	    },
	    {
	        path: "search",
	        component: subject_search_component_1.SubjectSearchComponent,
	        canActivate: [auth_guard_1.AuthGuard, rule_restricted_guard_1.RuleRestrictedGuard],
	        data: { rules: [rules_1.Rule.SEARCH_SUBJECT] }
	    },
	    {
	        path: "settings",
	        component: settings_component_1.SettingsComponent,
	        canActivate: [auth_guard_1.AuthGuard]
	    },
	    {
	        path: exports.AGGREGATION_MODULE_URL,
	        loadChildren: function () { return new Promise(function (resolve) { !/* require.ensure */(function (require) { resolve(__webpack_require__(40)['AggregationModule']); }(__webpack_require__)); }); },
	        canLoad: [auth_guard_1.AuthGuard, rule_restricted_guard_1.RuleRestrictedGuard],
	        data: {
	            rules: [rules_1.Rule.RUN_AGGREGATOR, rules_1.Rule.RUN_DATA_EXPORT],
	            post_auth_redirect: exports.AGGREGATION_MODULE_URL
	        }
	    },
	    {
	        path: exports.MANAGEMENT_MODULE_URL,
	        loadChildren: function () { return new Promise(function (resolve) { !/* require.ensure */(function (require) { resolve(__webpack_require__(887)['ManagementModule']); }(__webpack_require__)); }); },
	        canLoad: [auth_guard_1.AuthGuard, rule_restricted_guard_1.RuleRestrictedGuard],
	        data: {
	            rules: [rules_1.Rule.VIEW_GROUP_USERS],
	            post_auth_redirect: exports.MANAGEMENT_MODULE_URL
	        }
	    },
	    {
	        path: "admin",
	        loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(1, function (require) { resolve(__webpack_require__(892)['AdminPanelModule']); }); }); },
	        canLoad: [admin_zone_guard_1.AdminZoneGuard, auth_guard_1.AuthGuard, rule_restricted_guard_1.RuleRestrictedGuard],
	        data: { post_auth_redirect: "admin", rules: [rules_1.Rule.ADMINISTER_SYSTEM] }
	    },
	    {
	        path: "sandbox",
	        component: sandbox_component_1.SandboxComponent,
	        canActivate: [debug_mode_guard_1.DebugModeGuard]
	    },
	    {
	        path: "test-rig",
	        component: feature_test_rig_component_1.FeatureTestRigComponent,
	        canActivate: []
	    },
	    {
	        path: "forgot-password",
	        component: forgot_password_component_1.ForgotPasswordComponent,
	        canActivate: [guests_only_guard_1.GuestsOnlyGuard]
	    },
	    {
	        path: "**",
	        component: page_not_found_component_1.PageNotFoundComponent
	    }
	];
	exports.APPLICATION_GUARDS = [
	    admin_zone_guard_1.AdminZoneGuard,
	    auth_guard_1.AuthGuard,
	    guests_only_guard_1.GuestsOnlyGuard,
	    algorithm_running_guard_1.AlgorithmRunningGuard,
	    subject_loaded_guard_1.SubjectLoadedGuard,
	    shared_worklist_guard_1.SharedWorklistGuard,
	    debug_mode_guard_1.DebugModeGuard,
	    rule_restricted_guard_1.RuleRestrictedGuard
	];
	exports.APP_ROUTING_COMPONENTS = [
	    welcome_component_1.WelcomeComponent,
	    welcome_guest_component_1.WelcomeGuestComponent,
	    empty_component_1.EmptyComponent,
	    feature_test_rig_component_1.FeatureTestRigComponent,
	    first_check_v1_flow_component_1.FirstCheckCustomFlowComponent,
	    forgot_password_component_1.ForgotPasswordComponent,
	    guarded_componentless_route_workaround_component_1.GuardedComponentlessRouteWorkaroundComponent,
	    home_component_1.HomeComponent,
	    intake_form_component_1.IntakeFormComponent,
	    intake_custom_component_1.CustomIntakeComponent,
	    login_component_1.LoginComponent,
	    logout_component_1.LogoutComponent,
	    page_not_found_component_1.PageNotFoundComponent,
	    permalink_component_1.PermalinkComponent,
	    sandbox_component_1.SandboxComponent,
	    settings_component_1.SettingsComponent,
	    shared_worklist_component_1.SharedWorklistComponent,
	    subject_search_component_1.SubjectSearchComponent,
	    subject_summary_component_1.SubjectSummaryComponent,
	    lists_browser_component_1.WorklistBrowserComponent
	];
	exports.ROOT_ROUTING = router_1.RouterModule.forRoot(appRoutes);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Zxcvbn) {"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var router_1 = __webpack_require__(41);
	__webpack_require__(702);
	var alert_service_1 = __webpack_require__(689);
	var configuration_service_1 = __webpack_require__(512);
	var messaging_service_1 = __webpack_require__(533);
	var functions_1 = __webpack_require__(206);
	var validators_1 = __webpack_require__(701);
	var auth_service_1 = __webpack_require__(777);
	var ResetState;
	(function (ResetState) {
	    ResetState[ResetState["Failed"] = -1] = "Failed";
	    ResetState[ResetState["Start"] = 0] = "Start";
	    ResetState[ResetState["EmailSent"] = 1] = "EmailSent";
	    ResetState[ResetState["EnterToken"] = 2] = "EnterToken";
	    ResetState[ResetState["SecurePrompts"] = 3] = "SecurePrompts";
	    ResetState[ResetState["ResetForm"] = 4] = "ResetForm";
	    ResetState[ResetState["Complete"] = 5] = "Complete";
	})(ResetState || (ResetState = {}));
	var ForgotPasswordComponent = (function () {
	    function ForgotPasswordComponent(auth, alerts, messaging, route, config) {
	        var _this = this;
	        this.auth = auth;
	        this.alerts = alerts;
	        this.messaging = messaging;
	        this.route = route;
	        this.config = config;
	        route.params.subscribe(function (params) { return _this.start(params); });
	    }
	    ForgotPasswordComponent.prototype.hasToken = function (params) {
	        return ("token" in params) && (typeof params.token === "string");
	    };
	    ForgotPasswordComponent.prototype.start = function (params) {
	        var _this = this;
	        this.form = new forms_1.FormGroup({});
	        this.login = new forms_1.FormControl("", forms_1.Validators.required);
	        this.promptAnswer = new forms_1.FormControl("", forms_1.Validators.required);
	        this.password = new forms_1.FormControl("", forms_1.Validators.required);
	        this.passwordDuplicate =
	            new forms_1.FormControl("", validators_1.CustomValidators.equalsTo(this.password));
	        this.password.valueChanges.debounceTime(200).subscribe(function (pw) {
	            _this.strengthAnalysis = Zxcvbn(pw);
	        });
	        if (this.hasToken(params)) {
	            this.state = ResetState.EnterToken;
	            this.token = new forms_1.FormControl(params.token, forms_1.Validators.required);
	            this.messaging.ready.first(functions_1.identity).subscribe(function () { return _this.beginReset(); });
	        }
	        else {
	            this.state = ResetState.Start;
	            this.token = new forms_1.FormControl("", forms_1.Validators.required);
	        }
	    };
	    ForgotPasswordComponent.prototype.advance = function () {
	        switch (this.state) {
	            case ResetState.Start:
	                return this.requestEmail();
	            case ResetState.EnterToken:
	                return this.beginReset();
	            case ResetState.SecurePrompts:
	                return this.submitAnswer();
	            case ResetState.ResetForm:
	                return this.finishReset();
	            default:
	                console.error(this);
	                throw new Error("Illegal state for form submission (" + this.state + ")");
	        }
	    };
	    ForgotPasswordComponent.prototype.requestEmail = function () {
	        var _this = this;
	        var email = this.login.value;
	        this.auth.requestResetEmail(email).subscribe(function () {
	            _this.alerts.notify("An email will be sent to " + email + " shortly with a\n                            link to reset your password!");
	            _this.state = ResetState.EmailSent;
	        });
	    };
	    ForgotPasswordComponent.prototype.beginReset = function () {
	        var _this = this;
	        this.auth.beginResetFlow(this.token.value).subscribe(function (prompt) {
	            _this.state = ResetState.SecurePrompts;
	            _this.securePrompt = prompt;
	            _this.promptAnswer.reset();
	            _this.promptAnswer.enable();
	        }, function (error) {
	            _this.state = ResetState.Failed;
	            _this.alerts.error(error.message);
	            _this.auth.boot();
	        }, function () { return _this.state = ResetState.ResetForm; });
	    };
	    ForgotPasswordComponent.prototype.submitAnswer = function () {
	        if (!this.promptAnswer.valid) {
	            return;
	        }
	        this.auth.supplySecureAnswer(this.promptAnswer.value);
	        this.promptAnswer.disable();
	    };
	    ForgotPasswordComponent.prototype.finishReset = function () {
	        var _this = this;
	        if (!this.password.valid || !this.passwordDuplicate.valid) {
	            return;
	        }
	        if (this.strengthAnalysis.guesses_log10
	            < this.config.protocol.minimumPasswordMagnitude) {
	            alert(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Your password is not strong enough.\n\t\t\t\t\t\t\t\t(Consider using a sequence of four or more random words.)"], ["Your password is not strong enough.\n\t\t\t\t\t\t\t\t(Consider using a sequence of four or more random words.)"]))));
	            return;
	        }
	        this.auth.finishResetFlow(this.password.value).subscribe(function () { return _this.auth.redirectIfAuthed(); }, function (error) {
	            console.error("Reset error:", error);
	            _this.alerts.error("Could not reset your password!");
	        });
	    };
	    ForgotPasswordComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\">\n  <div id=\"loginContainer\" class=\"well center-block\">\n    <form [formGroup]=\"form\" (submit)=\"advance()\">\n      <template [ngIf]=\"state === " + ResetState.Start + "\">\n        <p>\n          If you've lost or forgotten your password, you can reset it here.\n          Enter the email you use to login and we'll send you a link to get\n          started.\n        </p>\n        <div class=\"form-group\">\n          <label>Enter your email:</label>\n          <input\n\t\t\ttype=\"text\"\n\t\t\tautocomplete=\"email\"\n            [formControl]=\"login\"\n            autofocus\n            class=\"form-control\"\n            placeholder=\"somebody@example.com\">\n        </div>\n        <div class=\"form-group\">\n          <input\n            type=\"submit\"\n            class=\"btn btn-info form-control\"\n            value=\"Request Password Reset\">\n        </div>\n        <div class=\"text-center\">\n          <a class=\"text-info\" (click)=\"state = " + ResetState.EnterToken + "\">\n            If you already have your reset token, click here.\n          </a>\n        </div>\n      </template>\n\n      <template [ngIf]=\"state === " + ResetState.EnterToken + "\">\n        <div class=\"form-group\">\n          <label>Enter the token sent to your email:</label>\n          <input\n            type=\"text\"\n            [formControl]=\"token\"\n            autofocus\n            class=\"form-control\"\n            placeholder=\"Token...\">\n        </div>\n        <div class=\"form-group\">\n          <input\n            type=\"submit\"\n            class=\"btn btn-default form-control\"\n            value=\"Submit Token\">\n        </div>\n      </template>\n\n      <template [ngIf]=\"state === " + ResetState.EmailSent + "\">\n        <p>\n          If the login you entered corresponds to a registered user in the\n          system, you will receive an email in the next 5 minutes with a link to\n          reset your password.\n        </p>\n      </template>\n\n      <template [ngIf]=\"state === " + ResetState.SecurePrompts + "\">\n        <p>\n          Please answer your security questions.\n        </p>\n        <div class=\"form-group\">\n          <label>{{securePrompt || \"Loading...\"}}</label>\n          <input\n            type=\"text\"\n            [formControl]=\"promptAnswer\"\n            autofocus\n            class=\"form-control\"\n            placeholder=\"Answer...\">\n        </div>\n        <div class=\"form-group\">\n          <input\n            type=\"submit\"\n            class=\"btn btn-default form-control\"\n            value=\"Submit Answer\">\n        </div>\n      </template>\n\n      <template [ngIf]=\"state === " + ResetState.ResetForm + "\">\n        <p>\n          You have correctly answered your security questions. Please enter a\n          new password below.\n        </p>\n        <div class=\"form-group\">\n          <label>Password:</label>\n          <input\n\t\t\ttype=\"password\"\n\t\t\tautocomplete=\"new-password\"\n            [formControl]=\"password\"\n            autofocus\n            class=\"form-control\">\n        </div>\n        <div class=\"form-group\">\n          <password-strength-analysis\n            [results]=\"strengthAnalysis\"\n            [minMagnitude]=\"config.protocol.minimumPasswordMagnitude\">\n          </password-strength-analysis>\n        </div>\n        <div class=\"form-group\">\n          <label>Repeat Password:</label>\n          <input\n            type=\"password\"\n            [formControl]=\"passwordDuplicate\"\n            class=\"form-control\">\n        </div>\n        <div class=\"form-group\">\n          <input\n            type=\"submit\"\n            class=\"btn btn-default form-control\"\n            value=\"Reset Your Password\">\n        </div>\n      </template>\n    </form>\n  </div>\n  </div>\n  ",
	            styles: [
	                "#loginContainer { width: 400px; max-width: 90%;}"
	            ],
	        }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService,
	            alert_service_1.AlertService,
	            messaging_service_1.MessagingService,
	            router_1.ActivatedRoute,
	            configuration_service_1.ConfigurationService])
	    ], ForgotPasswordComponent);
	    return ForgotPasswordComponent;
	}());
	exports.ForgotPasswordComponent = ForgotPasswordComponent;
	var templateObject_1;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(702)))

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var alert_service_1 = __webpack_require__(689);
	var utilities_1 = __webpack_require__(523);
	var auth_service_1 = __webpack_require__(777);
	var credentials_1 = __webpack_require__(813);
	var login_service_1 = __webpack_require__(814);
	var LoginComponent = (function () {
	    function LoginComponent(auth, alerts, login) {
	        this.auth = auth;
	        this.alerts = alerts;
	        this.login = login;
	        this.presentAccessWarning = false;
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.constructForm();
	        this.presentAccessWarning = (!!this.auth.redirectTo);
	    };
	    LoginComponent.prototype.ngOnDestroy = function () {
	    };
	    LoginComponent.prototype.constructForm = function () {
	        this.form = new forms_1.FormGroup({
	            username: new forms_1.FormControl(null, forms_1.Validators.required),
	            password: new forms_1.FormControl(null, forms_1.Validators.required)
	        });
	    };
	    LoginComponent.prototype.attemptLogIn = function () {
	        var _this = this;
	        var credentials = new credentials_1.PasswordCredentials(this.auth.hasher, this.auth.salter);
	        credentials.username = this.form.get("username").value;
	        credentials.password = this.form.get("password").value;
	        try {
	            this.login.attempt(credentials).subscribe(function (authenticated) { return _this.failedPrevious = !authenticated; }, function (error) { return console.error(error); }, function () { return _this.auth.redirectIfAuthed(); });
	        }
	        catch (e) {
	            this.alerts.error("Could not log in -- connection has closed. (You may need to reload.)");
	            console.error(e);
	        }
	        return false;
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: "login",
	            template: "\n  <div class=\"container\">\n  <div id=\"loginContainer\" class=\"well center-block\">\n  <form (ngSubmit)=\"attemptLogIn($event)\" [formGroup]=\"form\">\n    <div *ngIf=\"presentAccessWarning\" class=\"text-center text-danger\">\n      <em>You must be logged in to access that page!</em>\n    </div>\n    <div *ngIf=\"failedPrevious\" class=\"text-center text-warning\">\n      Your username and/or password are incorrect. Please try again.\n    </div>\n    <div *ngIf=\"!login.ready\" class=\"text-center text-info\" @slowAttach>\n      You are either not connected to the server, or the server is already\n      processing your login attempt. If this message does not go away shortly,\n      please reload and try again...\n    </div>\n    <div class=\"form-group\">\n      <label>Username</label>\n      <input\n\t\ttype=\"text\"\n\t\tautocomplete=\"username\"\n        formControlName=\"username\"\n        autofocus\n        class=\"form-control\"\n        placeholder=\"Username...\">\n    </div>\n    <div class=\"form-group\">\n      <label>Password</label>\n      <input\n\t\ttype=\"password\"\n\t\tautocomplete=\"current-password\"\n        formControlName=\"password\"\n        class=\"form-control\"\n        placeholder=\"Password...\">\n    </div>\n    <div class=\"form-group\">\n      <input\n        type=\"submit\"\n        class=\"btn btn-primary form-control\"\n        value=\"Login\"\n        [disabled]=\"!login.ready\">\n    </div>\n    <div class=\"text-center\">\n      <a class=\"text-warning\" routerLink=\"/forgot-password\">\n        Reset / change your password\n      </a>\n    </div>\n  </form>\n  </div>\n  </div>\n  ",
	            styles: [
	                "#loginContainer { width: 400px; max-width: 90%;}",
	                "a {text-decoration: underline;}"
	            ],
	            animations: [utilities_1.SLOW_ATTACH, utilities_1.SLOW_REMOVAL]
	        }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService,
	            alert_service_1.AlertService,
	            login_service_1.LoginService])
	    ], LoginComponent);
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Credentials = (function () {
	    function Credentials(hasher, salter) {
	        this.hasher = hasher;
	        this.salter = salter;
	    }
	    Credentials.prototype.hash = function (content) {
	        return this.hasher.hexOf(content);
	    };
	    Credentials.prototype.salt = function (content) {
	        return this.salter.salt(content);
	    };
	    return Credentials;
	}());
	exports.Credentials = Credentials;
	var PasswordCredentials = (function (_super) {
	    __extends(PasswordCredentials, _super);
	    function PasswordCredentials() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(PasswordCredentials.prototype, "password", {
	        get: function () {
	            return "";
	        },
	        set: function (newPassword) {
	            this._password = newPassword;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PasswordCredentials.prototype, "hashedPassword", {
	        get: function () {
	            return this.hash(this.salt(this._password));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return PasswordCredentials;
	}(Credentials));
	exports.PasswordCredentials = PasswordCredentials;
	var SecurityQuestionCredentials = (function (_super) {
	    __extends(SecurityQuestionCredentials, _super);
	    function SecurityQuestionCredentials() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return SecurityQuestionCredentials;
	}(Credentials));
	exports.SecurityQuestionCredentials = SecurityQuestionCredentials;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var bootstrap_1 = __webpack_require__(24);
	var Rx_1 = __webpack_require__(214);
	var auth_1 = __webpack_require__(535);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var utilities_1 = __webpack_require__(523);
	var auth_service_1 = __webpack_require__(777);
	var change_password_modal_component_1 = __webpack_require__(815);
	var change_secure_prompts_modal_component_1 = __webpack_require__(816);
	var LoginService = (function () {
	    function LoginService(messaging, auth, modal) {
	        var _this = this;
	        this.messaging = messaging;
	        this.auth = auth;
	        this.modal = modal;
	        this.ready = false;
	        messaging.ready.subscribe(function (msgStatus) { return _this.ready = msgStatus; });
	    }
	    LoginService.prototype.attempt = function (credentials) {
	        var _this = this;
	        if (!this.ready) {
	            alert("The credential service was not ready for you to login.");
	            return Rx_1.Observable.of(false);
	        }
	        this.ready = false;
	        return this.messaging.send(new auth_1.LoginRequest(credentials.username, credentials.hashedPassword)).flatMap(function (m) {
	            if (general_1.Message.isA(m, general_1.MessageTag.SREQ_NEW_PASSWORD)) {
	                return _this.handleServerPasswordChangeRequest(m);
	            }
	            return Rx_1.Observable.of(m);
	        }).flatMap(function (m) {
	            if (m && general_1.Message.isA(m, general_1.MessageTag.SREQ_MODIFY_SECURITY_QUESTIONS)) {
	                return _this.handleServerPromptChangeRequest(m);
	            }
	            return Rx_1.Observable.of(m);
	        }).flatMap(function (m) {
	            if (m && general_1.Message.isA(m, general_1.MessageTag.RSP_ACKNOWLEDGEMENT)) {
	                return [
	                    _this.auth.inferStatusFromAck(m, true)
	                ];
	            }
	            console.error("unknown auth response", m);
	            return [false];
	        }).do(function (authResult) {
	            return ((authResult === false)
	                ? _this.messaging.restart(true, true)
	                : null);
	        }, function (err) { return console.error("Login error", err); }, function () { return _this.ready = true; });
	    };
	    LoginService.prototype.handleServerPasswordChangeRequest = function (m) {
	        this.auth.state = auth_service_1.AuthState.EnforcedCredentialChange;
	        return utilities_1.ModalHelpers.observeCustom(this.modal, change_password_modal_component_1.ChangePasswordModalComponent, { size: "sm", enforced: true });
	    };
	    LoginService.prototype.handleServerPromptChangeRequest = function (m) {
	        this.auth.state = auth_service_1.AuthState.EnforcedCredentialChange;
	        return utilities_1.ModalHelpers.observeCustom(this.modal, change_secure_prompts_modal_component_1.ChangeSecurePromptsModalComponent, { minimumPrompts: m.required, enforced: true });
	    };
	    LoginService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            auth_service_1.AuthService,
	            bootstrap_1.Modal])
	    ], LoginService);
	    return LoginService;
	}());
	exports.LoginService = LoginService;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Zxcvbn) {"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var configuration_service_1 = __webpack_require__(512);
	var functions_1 = __webpack_require__(206);
	var validators_1 = __webpack_require__(701);
	var auth_service_1 = __webpack_require__(777);
	var ChangePasswordModalComponent = (function () {
	    function ChangePasswordModalComponent(dialog, auth, config) {
	        this.dialog = dialog;
	        this.auth = auth;
	        this.config = config;
	        this.enforced = dialog.context.enforced || false;
	    }
	    ChangePasswordModalComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.oldPassword = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newPassword = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newPasswordDuplicate = new forms_1.FormControl("", [forms_1.Validators.required, validators_1.CustomValidators.equalsTo(this.newPassword)]);
	        this.form = new forms_1.FormGroup({
	            oldPassword: this.oldPassword,
	            newPassword: this.newPassword,
	            newPasswordDuplicate: this.newPasswordDuplicate
	        });
	        this.newPassword.valueChanges.debounceTime(200).subscribe(function (pw) {
	            _this.strengthAnalysis = Zxcvbn(pw);
	        });
	    };
	    ChangePasswordModalComponent.prototype.submit = function () {
	        var _this = this;
	        if (!this.form.valid) {
	            if (this.newPasswordDuplicate.errors.equalsTo) {
	                alert("Your passwords do not match!");
	                return;
	            }
	            console.warn("Encountered errors:", validators_1.childErrors(this.form));
	            return alert("There are errors with the form!");
	        }
	        if (this.strengthAnalysis.guesses_log10
	            < this.config.protocol.minimumPasswordMagnitude) {
	            alert(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Your password is not strong enough.\n                (Consider using a sequence of four or more random words.)"], ["Your password is not strong enough.\n                (Consider using a sequence of four or more random words.)"]))));
	            return;
	        }
	        this.auth.changePassword(this.newPassword.value, this.oldPassword.value)
	            .subscribe(function (result) {
	            if (result.ok !== false) {
	                _this.dialog.close(result);
	            }
	        });
	    };
	    ChangePasswordModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Change Password\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <p *ngIf=\"enforced\" class=\"text-info\">\n      The application requires you to change your password before continuing.\n    </p>\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n      <div class=\"form-group\">\n        <label>Current Password</label>\n        <input type=\"password\" class=\"form-control\" [formControl]=\"oldPassword\">\n      </div>\n      <div class=\"form-group\">\n        <label>New Password</label>\n        <input type=\"password\" class=\"form-control\" [formControl]=\"newPassword\">\n      </div>\n      <div class=\"form-group\">\n        <password-strength-analysis\n          [results]=\"strengthAnalysis\"\n          [minMagnitude]=\"config.protocol.minimumPasswordMagnitude\">\n        </password-strength-analysis>\n      </div>\n      <div class=\"form-group\">\n        <label>Repeat New Password</label>\n        <input\n          type=\"password\"\n          class=\"form-control\"\n          [formControl]=\"newPasswordDuplicate\">\n      </div>\n    </form>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      *ngIf=\"!enforced\"\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"submit()\">\n      Submit\n    </button>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            auth_service_1.AuthService,
	            configuration_service_1.ConfigurationService])
	    ], ChangePasswordModalComponent);
	    return ChangePasswordModalComponent;
	}());
	exports.ChangePasswordModalComponent = ChangePasswordModalComponent;
	var templateObject_1;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(702)))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var validators_1 = __webpack_require__(701);
	var auth_service_1 = __webpack_require__(777);
	var user_service_1 = __webpack_require__(713);
	var ChangeSecurePromptsModalComponent = (function () {
	    function ChangeSecurePromptsModalComponent(dialog, auth, user) {
	        this.dialog = dialog;
	        this.auth = auth;
	        this.user = user;
	        this.minimumPrompts = 1;
	        this.enforced = false;
	    }
	    ChangeSecurePromptsModalComponent.prototype.ngOnInit = function () {
	        this.minimumPrompts = (this.dialog.context.minimumPrompts
	            || this.user.self.minumumSecurePrompts);
	        this.enforced = !!this.dialog.context.enforced;
	        this.prompts = new forms_1.FormArray([]);
	        for (var i = 0; i < this.minimumPrompts; i++) {
	            this.addPrompt();
	        }
	        this.form = new forms_1.FormGroup({
	            prompts: this.prompts
	        });
	    };
	    ChangeSecurePromptsModalComponent.prototype.addPrompt = function () {
	        this.prompts.push(new forms_1.FormGroup({
	            question: new forms_1.FormControl(null, forms_1.Validators.required),
	            answer: new forms_1.FormControl(null, forms_1.Validators.required)
	        }));
	    };
	    ChangeSecurePromptsModalComponent.prototype.submit = function () {
	        var _this = this;
	        if (!this.form.valid) {
	            if (this.prompts.controls.some(function (prompt) { return prompt.getError("required", ["question"])
	                || prompt.getError("required", ["answer"]); })) {
	                return alert("You must fill out all of the prompt fields!");
	            }
	            console.warn("Encountered errors:", validators_1.childErrors(this.form));
	            return alert("There are errors with the form.");
	        }
	        this.auth.changePrompts(this.prompts.value).subscribe(function (result) {
	            if (result.ok !== false) {
	                _this.dialog.close(result);
	            }
	            else {
	                alert("Your prompts could not be changed.");
	                _this.dialog.dismiss();
	            }
	        });
	    };
	    ChangeSecurePromptsModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Change Secure Prompts\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <p *ngIf=\"enforced\" class=\"text-info\">\n      The application requires you to change your secure prompts before\n      continuing.\n    </p>\n    <p>\n      Secure prompts are question and answer pairs the system may use to verify\n      your identity, for example, when resetting your password. You are\n      encouraged to treat these fields as additional passwords in the sense that\n      they should not be guessable. They are also stored in the same manner as\n      passwords, meaning it is <em>impossible</em> for staff to look them up and\n      see the values you have entered.\n    </p>\n    <p>\n      You must enter at least <strong>{{minimumPrompts}}</strong> prompt pairs\n      because that is the minimum security requirement of at least one of your\n      zones. However you may enter more, if you prefer your account to have\n      greater security.\n    </p>\n    <form [formGroup]=\"form\" (submit)=\"submit()\" class=\"untyped-statuses\">\n      <div *ngFor=\"let prompt of prompts.controls; let i = index\" class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>{{i+1 | ordinal}} Prompt</label>\n          <input\n            type=\"text\"\n            class=\"form-control\"\n            [formControl]=\"prompt.get('question')\">\n        </div>\n        <div class=\"col-sm-6\">\n          <label>{{i+1 | ordinal}} Answer</label>\n          <input\n            type=\"text\"\n            class=\"form-control\"\n            [formControl]=\"prompt.get('answer')\">\n        </div>\n      </div>\n      <br>\n      <button\n        type=\"button\"\n        class=\"btn btn-default form-control\"\n        (click)=\"addPrompt()\">\n        Add a {{prompts.length + 1 | ordinal}} Prompt\n      </button>\n    </form>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      *ngIf=\"!enforced\"\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"submit()\">\n      Submit\n    </button>\n  </div>\n  ",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            auth_service_1.AuthService,
	            user_service_1.UserService])
	    ], ChangeSecurePromptsModalComponent);
	    return ChangeSecurePromptsModalComponent;
	}());
	exports.ChangeSecurePromptsModalComponent = ChangeSecurePromptsModalComponent;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var messaging_service_1 = __webpack_require__(533);
	var LogoutComponent = (function () {
	    function LogoutComponent(messaging) {
	        this.messaging = messaging;
	    }
	    LogoutComponent.prototype.ngOnInit = function () {
	        this.messaging.restart(true, true);
	    };
	    LogoutComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\">\n  <div id=\"loginContainer\" class=\"well center-block\">\n    <h2 class=\"text-center\">You are now logged out.</h2>\n  </div>\n  </div>\n  ",
	            styles: ["#loginContainer { width: 400px; max-width: 90%;}"]
	        }),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService])
	    ], LogoutComponent);
	    return LogoutComponent;
	}());
	exports.LogoutComponent = LogoutComponent;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var EmptyComponent = (function () {
	    function EmptyComponent(router) {
	        console.info("Constructed empty component");
	    }
	    EmptyComponent = __decorate([
	        core_1.Component({
	            selector: "empty",
	            template: "<!-- empty component -->"
	        }),
	        __metadata("design:paramtypes", [router_1.Router])
	    ], EmptyComponent);
	    return EmptyComponent;
	}());
	exports.EmptyComponent = EmptyComponent;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var PageNotFoundComponent = (function () {
	    function PageNotFoundComponent(route) {
	    }
	    PageNotFoundComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\">\n  <div id=\"blockNotification\" class=\"well center-block\">\n    <h2 class=\"text-center\">The page could not be found!</h2>\n  </div>\n  </div>\n  ",
	            styles: ["#blockNotification { width: 400px; max-width: 90%;}"]
	        }),
	        __metadata("design:paramtypes", [router_1.ActivatedRoute])
	    ], PageNotFoundComponent);
	    return PageNotFoundComponent;
	}());
	exports.PageNotFoundComponent = PageNotFoundComponent;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var algorithm_service_1 = __webpack_require__(213);
	var subject_service_1 = __webpack_require__(821);
	var auth_service_1 = __webpack_require__(777);
	var credentials_1 = __webpack_require__(813);
	var login_service_1 = __webpack_require__(814);
	var alert_service_1 = __webpack_require__(689);
	var branding_service_1 = __webpack_require__(830);
	var WelcomeComponent = (function () {
	    function WelcomeComponent(auth, login, alerts, branding, subjects, algorithms) {
	        this.auth = auth;
	        this.login = login;
	        this.alerts = alerts;
	        this.branding = branding;
	        this.subjects = subjects;
	        this.algorithms = algorithms;
	        this.loginUsername = new forms_1.FormControl();
	        this.loginPassword = new forms_1.FormControl();
	        this.loginForm = new forms_1.FormGroup({
	            username: this.loginUsername,
	            password: this.loginPassword
	        });
	    }
	    WelcomeComponent.prototype.attemptLogIn = function () {
	        var _this = this;
	        var credentials = new credentials_1.PasswordCredentials(this.auth.hasher, this.auth.salter);
	        credentials.username = this.loginUsername.value;
	        credentials.password = this.loginPassword.value;
	        try {
	            this.login.attempt(credentials).subscribe(function (authenticated) {
	                if (!authenticated) {
	                    _this.alerts.warnAndReplace("Your username and/or password are incorrect. Please try again.", "credential failure");
	                }
	                else {
	                }
	            }, function (error) { return console.error(error); }, function () { return _this.auth.redirectIfAuthed(); });
	        }
	        catch (e) {
	            this.alerts.error("Could not log in -- connection has closed. (You may need to reload.)");
	            console.error(e);
	        }
	        return false;
	    };
	    WelcomeComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"inset-background welcome-mat\">\n    <div class=\"container\">\n      <table class=\"splash center-block\">\n      <tr>\n          <td rowspan=\"2\">\n            <img src=\"zone/images/splash_logo.png\" class=\"logo\">\n          </td>\n          <td class=\"title-box\">\n            <h4 class=\"pretitle\">{{branding.strings.splash_pretitle}}</h4>\n            <h1 class=\"title\">\n              {{branding.strings.splash_title}}\n              <span\n                *ngIf=\"branding.flags.has('use_title_trademark')\"\n                class=\"title-tm\">\n                \u2122\uFE0F\n              </span>\n            </h1>\n          </td>\n        </tr>\n        <tr>\n          <td class=\"explanation\">\n            <p>\n              {{branding.strings.splash_tagline}}\n            </p>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n  <!-- Your free interactive guide to the confusing world of health care benefits coverage. -->\n\n  <!--<p>\n    This site provides recommendations based on information you provide. You can answer as much or as little as you prefer, however the tool can make better suggestions if you fill it out accurately and completely. (We do not collect your name, phone, address, or other identifying information unless you specifically request additional help.)\n  </p>\n  <p>\n    This application runs in your web browser over the internet, with no download required. If your connection is interrupted you may have to start over. To get started, simply click below!\n  </p> -->\n  <div class=\"container loginForm\">\n    <form [formGroup]=\"loginForm\" *ngIf=\"!auth.authenticated\">\n      <div class=\"row\">\n        <div class=\"col-sm-3 col-sm-offset-2 form-group\">\n          <label>Username:</label>\n          <input\n            autofocus\n      type=\"text\"\n      autocomplete=\"username\"\n            class=\"form-control\"\n            formControlName=\"username\">\n        </div>\n        <div class=\"col-sm-3 form-group\">\n          <label>Password:</label>\n          <input\n      type=\"password\"\n      autocomplete=\"current-password\"\n            class=\"form-control\"\n            formControlName=\"password\">\n        </div>\n        <div class=\"col-sm-2 form-group\">\n          <button\n            class=\"btn btn-primary form-control align-with-labels\"\n            (click)=\"attemptLogIn()\"\n            [disabled]=\"!login.ready\">\n            Login\n          </button>\n        </div>\n      </div>\n      <div class=\"text-center\">\n        <a class=\"text-warning\" routerLink=\"/forgot-password\">\n          Reset your password\n        </a>\n      </div>\n    </form>\n    <div class=\"text-center\" *ngIf=\"auth.authenticated\">\n      <h3 class=\"info row text-center\">\n        You are already logged in!\n      </h3>\n      <a class=\"btn btn-success\" routerLink=\"/home\"><span class=\"glyphicon glyphicon-home\"></span> Go to Your Home Page</a>\n    </div>\n  </div>\n\n  <div class=\"inset-background\">\n    <div class=\"container\">\n      <table class=\"grant-info center-block\">\n        <tr>\n          <td *ngIf=\"!branding.strings.splash_footer\">\n            <p>\n              Advocus is a product of My Coverage Plan,\n              a subsidiary of ABC for Health, Inc.\n            </p>\n            <p>\n              My Coverage Plan was made possible in part by grant number\n              <cite>5R43MD005810-02</cite> from the National Institute on\n              Minority Health and Health Disparities.\n            </p>\n          </td>\n          <td *ngIf=\"branding.strings.splash_footer\">\n            <p>\n              {{branding.strings.splash_footer}}\n            </p>\n            <p>\n              {{branding.strings.splash_footer_continued}}\n            </p>\n          </td>\n          <td>\n            <img src=\"zone/images/mcp_logo.png\" class=\"logo mcp\">\n          </td>\n          <td>\n            <img src=\"zone/images/abc_logo.png\" class=\"logo abc\">\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n  ",
	            styles: [""]
	        }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService,
	            login_service_1.LoginService,
	            alert_service_1.AlertService,
	            branding_service_1.BrandingService,
	            subject_service_1.SubjectService,
	            algorithm_service_1.AlgorithmService])
	    ], WelcomeComponent);
	    return WelcomeComponent;
	}());
	exports.WelcomeComponent = WelcomeComponent;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var bootstrap_1 = __webpack_require__(24);
	var auth_service_1 = __webpack_require__(777);
	var Rx_1 = __webpack_require__(214);
	var algorithm_service_1 = __webpack_require__(213);
	var user_service_1 = __webpack_require__(713);
	var messages_1 = __webpack_require__(754);
	var context_management_1 = __webpack_require__(604);
	var subjects_1 = __webpack_require__(660);
	var messaging_service_1 = __webpack_require__(533);
	var decorators_1 = __webpack_require__(517);
	var utilities_1 = __webpack_require__(523);
	var relation_graph_1 = __webpack_require__(822);
	var relationship_1 = __webpack_require__(826);
	var select_groups_modal_component_1 = __webpack_require__(827);
	var subject_1 = __webpack_require__(828);
	var subject_selector_modal_component_1 = __webpack_require__(829);
	var configuration_service_1 = __webpack_require__(512);
	var INSTANT_NAV_ALGOS = ["a-first-check-wi"];
	var SubjectService = (function () {
	    function SubjectService(messaging, algorithms, router, modal, users, auth, config) {
	        var _this = this;
	        this.messaging = messaging;
	        this.algorithms = algorithms;
	        this.router = router;
	        this.modal = modal;
	        this.users = users;
	        this.auth = auth;
	        this.config = config;
	        this.CHEATY_NO_REDIRECT_ADMINS = [];
	        this.relationshipTypes = [];
	        this.roles = [];
	        this.resolver = (function (name) { return _this.algorithms.findAlgorithm(name); });
	        this.subjects = [];
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    SubjectService_1 = SubjectService;
	    SubjectService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(messages_1.MessageTag.RSP_CFG_RELATIONSHIPS).subscribe(function (rcr) {
	            return _this.readRelationshipConfig(rcr);
	        });
	        this.messaging.receive(messages_1.MessageTag.RSP_SUBJECT_CONTEXT_RELATIONSHIPS)
	            .subscribe(function (scrr) {
	            return _this.readRelationships(scrr);
	        });
	        this.messaging.receive(messages_1.MessageTag.RSP_CFG_ZONE)
	            .subscribe(function (msg) {
	            if (Array.isArray(msg.algorithms) &&
	                msg.algorithms.length === 1 &&
	                (INSTANT_NAV_ALGOS.indexOf(msg.algorithms[0].name) >= 0
	                    || _this.config.client.type === "guest")) {
	                setTimeout(function () {
	                    if (_this.CHEATY_NO_REDIRECT_ADMINS.indexOf(_this.users.self.login) === -1) {
	                        _this.launchNew(_this.algorithms.findAlgorithm(msg.algorithms[0].name));
	                    }
	                }, 100);
	            }
	        });
	    };
	    SubjectService.prototype.disconnected = function () { };
	    SubjectService.prototype.readRelationshipConfig = function (rcr) {
	        var _this = this;
	        this.roles = rcr.roles;
	        this.roleMap = new Map(this.roles.map(function (role) { return [role.name, role]; }));
	        this.relationshipTypes = rcr.relationships.map(function (rtd) { return ({
	            name: rtd.name,
	            displayName: rtd.displayName,
	            sourceType: rtd.sourceType,
	            targetType: rtd.targetType,
	            sourceRoles: rtd.sourceRoles.map(function (sRole) {
	                return ({
	                    role: _this.roleMap.get(sRole.role),
	                    partners: sRole.partners.map(function (name) { return _this.roleMap.get(name); })
	                });
	            }),
	            targetRoles: rtd.targetRoles.map(function (tRole) {
	                return ({
	                    role: _this.roleMap.get(tRole.role),
	                    partners: tRole.partners.map(function (name) { return _this.roleMap.get(name); })
	                });
	            })
	        }); });
	    };
	    SubjectService.prototype.readRelationships = function (scrr) {
	        var _this = this;
	        var subject = this.byServerId(scrr.subjectId);
	        if (!subject) {
	            console.error("Received relationship data for unknown subject!", scrr);
	        }
	        else {
	            subject.relationships = scrr.relationships.map(function (rd) {
	                return new relationship_1.Relationship(rd, _this.relationshipTypes, _this.roles, subject);
	            });
	        }
	    };
	    Object.defineProperty(SubjectService.prototype, "loaded", {
	        get: function () {
	            return this.subjects.filter(function (s) { return s.loaded; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SubjectService.prototype.byServerId = function (id) {
	        var matching = this.subjects.filter(function (s) { return s.id === id; });
	        if (matching.length === 0) {
	            return null;
	        }
	        if (matching.length === 1) {
	            return matching[0];
	        }
	        console.error("Found multiple subjects with ID " + id, matching);
	        throw new Error("Multiple local subjects have server ID " + id);
	    };
	    SubjectService.prototype.getGroupIds = function () {
	        var _this = this;
	        if (this.users.self.groups.length === 1) {
	            return Rx_1.Observable.of(this.users.self.groupIds());
	        }
	        else if (this.users.self.guest || this.users.self.groups.length === 0) {
	            return Rx_1.Observable.of([]);
	        }
	        else {
	            if (SubjectService_1.FORCE_BYPASS_MODAL) {
	                return Rx_1.Observable.of([this.users.self.groupIds()[0]]);
	            }
	            return utilities_1.ModalHelpers.observeResult(utilities_1.ModalHelpers.openCustom(this.modal, select_groups_modal_component_1.SelectGroupsModalComponent, {
	                availableGroups: this.users.self.groups,
	                initialSelection: this.lastGroupVisibilitySelection
	            })).do(function (groupIds) {
	                if (Array.isArray(groupIds)) {
	                    _this.lastGroupVisibilitySelection = groupIds;
	                }
	            });
	        }
	    };
	    SubjectService.prototype.freshReference = function (type, groupIds) {
	        return {
	            id: -1,
	            host: this,
	            type: "new",
	            request: new context_management_1.CreateSubjectContextRequest(type, groupIds),
	            priority: 0
	        };
	    };
	    SubjectService.prototype.duplicateReference = function (type, groupIds) {
	        return {
	            id: -1,
	            host: this,
	            type: "new",
	            request: new context_management_1.CreateSubjectContextRequest(type, groupIds, true),
	            priority: 0
	        };
	    };
	    SubjectService.prototype.fresh = function (initial) {
	        var _this = this;
	        var type = initial.contextType;
	        return this.getGroupIds().map(function (groupIds) {
	            var s = _this.fromReference(_this.freshReference(type, groupIds));
	            s.newlyCreated = true;
	            s.initialAlgorithmTarget = initial;
	            return s;
	        });
	    };
	    SubjectService.prototype.duplicate = function (initial) {
	        var _this = this;
	        var type = initial.contextType;
	        return this.getGroupIds().map(function (groupIds) {
	            var s = _this.fromReference(_this.duplicateReference(type, groupIds));
	            s.newlyCreated = true;
	            s.initialAlgorithmTarget = initial;
	            return s;
	        });
	    };
	    SubjectService.prototype.fromReference = function (ref) {
	        return new subject_1.Subject(this.messaging, this.resolver, ref);
	    };
	    SubjectService.prototype.openReference = function (ref) {
	        return this.open(this.fromReference(ref));
	    };
	    SubjectService.prototype.add = function (subject) {
	        var objectExists = this.subjects.indexOf(subject) > -1;
	        if (objectExists) {
	            console.error("This exact subject already exists in the list.", this);
	            throw new Error("Exact subject already exists in the list!");
	        }
	        var idExists = this.byServerId(subject.id) !== null;
	        if (idExists) {
	            console.error("Subject with ID exists in the list.", this, subject);
	            throw new Error("Service already has subject with that id!");
	        }
	        this.subjects.push(subject);
	    };
	    SubjectService.prototype.load = function (subject) {
	        var _this = this;
	        return subject.load().map(function (scr) {
	            var existing = _this.byServerId(scr.objectId);
	            if (existing) {
	                subject.identifiers.forEach(function (sr) { return existing.addRef(sr); });
	                existing.lastRefType = subject.lastRefType;
	                if (subject.localCreated > existing.localCreated && subject.summary) {
	                    existing.summary = subject.summary;
	                }
	                existing.readSubjectResult(scr);
	                existing.initialAlgorithmTarget = subject.initialAlgorithmTarget;
	                subject.cloneOf = existing;
	                return existing;
	            }
	            else {
	                subject.readSubjectResult(scr);
	                _this.add(subject);
	                return subject;
	            }
	        }).defaultIfEmpty(subject);
	    };
	    SubjectService.prototype.open = function (subject, navigate) {
	        var _this = this;
	        if (navigate === void 0) { navigate = true; }
	        return this.load(subject).do(function (s) {
	            if (navigate) {
	                var alg = s.initialAlgorithmTarget;
	                if (alg) {
	                    s.initialAlgorithmTarget = null;
	                    _this.algorithms.open(alg, s);
	                }
	                else {
	                    _this.router.navigate(_this.summaryRoute(s));
	                }
	            }
	        });
	    };
	    SubjectService.prototype.launchNew = function (algorithm) {
	        var _this = this;
	        this.fresh(algorithm).flatMap(function (s) { return _this.open(s); }).subscribe();
	    };
	    SubjectService.prototype.launchDuplicate = function (algorithm) {
	        var _this = this;
	        this.duplicate(algorithm).flatMap(function (s) { return _this.open(s); }).subscribe();
	    };
	    SubjectService.prototype.summaryRoute = function (subject) {
	        return ["subject", subject.id];
	    };
	    SubjectService.prototype.recentSubjectsDialog = function () {
	        var _this = this;
	        this.selectViaDialog("Recent Subjects", "recent", null, "Open", "md")
	            .subscribe(function (s) {
	            if (s instanceof subject_1.Subject) {
	                _this.open(s, true).subscribe();
	            }
	        });
	    };
	    SubjectService.prototype.selectViaDialog = function (title, mode, onlyOfType, actionLabel, modalSize) {
	        if (mode === void 0) { mode = "recent"; }
	        return utilities_1.ModalHelpers.observeResult(utilities_1.ModalHelpers.openCustom(this.modal, subject_selector_modal_component_1.SubjectSelectorModalComponent, {
	            size: modalSize || "lg",
	            list: this.subjects,
	            onlyOfType: onlyOfType,
	            mode: mode,
	            title: title,
	            actionLabel: actionLabel,
	            dialogClass: "modal-dialog modal-full"
	        }));
	    };
	    SubjectService.prototype.startRelationshipGraph = function (subject) {
	        var _this = this;
	        return this.messaging.send(new subjects_1.RelationGraphRequest(subject.id)).map(function (rgr) { return _this.buildGraph(rgr); });
	    };
	    SubjectService.prototype.addPossibleEdge = function (graph, mre) {
	        var samePair = graph.edges.find(function (edge) {
	            return (edge.source.id === mre.source && edge.target.id === mre.target);
	        });
	        if (samePair) {
	            if (samePair.label !== mre.sourceRole
	                || samePair.reverseLabel !== mre.targetRole) {
	                samePair.addSecondary(mre);
	            }
	        }
	        else {
	            graph.addEdgeByIds(mre.source, mre.target, function (a, b) { return new relation_graph_1.RelationEdge(a, b, mre); });
	        }
	    };
	    SubjectService.prototype.buildGraph = function (rgr) {
	        var _this = this;
	        var g = new relation_graph_1.RelationGraph(rgr.nodes.map(function (mrn) {
	            var node = new relation_graph_1.RelationNode(mrn);
	            if (mrn.nodeId === 0) {
	                node.alreadyExpanded = true;
	            }
	            return node;
	        }), []);
	        rgr.edges.forEach(function (mre) { return _this.addPossibleEdge(g, mre); });
	        g.objectId = rgr.objectId;
	        g.expand = function (node) { return _this.expandGraph(g, node); };
	        return g;
	    };
	    SubjectService.prototype.openRelationGraphNode = function (graph, node) {
	        var relative = this.fromReference({
	            id: node.id,
	            host: graph,
	            type: "graphRelative",
	            request: new subjects_1.RelationGraphSubjectContextRequest(graph.objectId, node.id),
	            priority: 10
	        });
	        this.open(relative, true).subscribe();
	    };
	    SubjectService.prototype.mergeGraphExpansion = function (graph, exp) {
	        var _this = this;
	        exp.nodes.forEach(function (mrn) {
	            if (graph.nodes.find(function (node) { return node.id === mrn.nodeId; })) {
	            }
	            else {
	                graph.addNode(new relation_graph_1.RelationNode(mrn));
	            }
	        });
	        exp.edges.forEach(function (mre) {
	            _this.addPossibleEdge(graph, mre);
	        });
	        graph.reinitialize = true;
	        return graph;
	    };
	    SubjectService.prototype.expandGraph = function (graph, target, depth) {
	        var _this = this;
	        if (depth === void 0) { depth = 1; }
	        this.messaging.converse(new subjects_1.RelationGraphExpansionRequest(graph.objectId, target.id, depth)).subscribe(function (rgr) {
	            target.alreadyExpanded = true;
	            _this.mergeGraphExpansion(graph, rgr);
	        });
	    };
	    var SubjectService_1;
	    SubjectService.FORCE_BYPASS_MODAL = true;
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Map)
	    ], SubjectService.prototype, "roleMap", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], SubjectService.prototype, "relationshipTypes", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], SubjectService.prototype, "roles", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], SubjectService.prototype, "subjects", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], SubjectService.prototype, "lastGroupVisibilitySelection", void 0);
	    SubjectService = SubjectService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            algorithm_service_1.AlgorithmService,
	            router_1.Router,
	            bootstrap_1.Modal,
	            user_service_1.UserService,
	            auth_service_1.AuthService,
	            configuration_service_1.ConfigurationService])
	    ], SubjectService);
	    return SubjectService;
	}());
	exports.SubjectService = SubjectService;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var graph_1 = __webpack_require__(823);
	var RelationGraph = (function (_super) {
	    __extends(RelationGraph, _super);
	    function RelationGraph() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.directed = false;
	        _this.idealLinkLength = 180;
	        _this.linkStrength = 0.4;
	        _this.chargeStrength = -500;
	        _this.categorizeEdges = true;
	        return _this;
	    }
	    return RelationGraph;
	}(graph_1.Graph));
	exports.RelationGraph = RelationGraph;
	var RelationEdge = (function (_super) {
	    __extends(RelationEdge, _super);
	    function RelationEdge(source, target, msg) {
	        var _this = _super.call(this, source, target) || this;
	        _this.hasSecondaries = false;
	        _this.secondaries = [];
	        _this.label = msg.sourceRole;
	        _this.reverseLabel = msg.targetRole;
	        _this.category = msg.relationshipType;
	        return _this;
	    }
	    RelationEdge.prototype.addSecondary = function (msg) {
	        this.hasSecondaries = true;
	        var existing = this.secondaries.find(function (s) {
	            return (s.label === msg.sourceRole
	                && s.reverseLabel === msg.targetRole);
	        });
	        if (!existing) {
	            this.secondaries.push({
	                label: msg.sourceRole,
	                reverseLabel: msg.targetRole,
	                category: msg.relationshipType,
	                enabled: true
	            });
	        }
	    };
	    RelationEdge.prototype.swapWithSecondary = function (i) {
	        var newSecondary = {
	            label: this.label,
	            reverseLabel: this.reverseLabel,
	            category: this.category,
	            enabled: this.enabled
	        };
	        Object.assign(this, this.secondaries[i]);
	        this.secondaries[i] = newSecondary;
	    };
	    RelationEdge.prototype.enableAll = function () {
	        this.enabled = true;
	        this.secondaries.forEach(function (sr) { return sr.enabled = true; });
	    };
	    RelationEdge.prototype.filterByRole = function (roleName) {
	        var _this = this;
	        if (this.label !== roleName && this.reverseLabel !== roleName) {
	            this.enabled = false;
	        }
	        this.secondaries.forEach(function (sr, i) {
	            if (sr.label === roleName
	                || sr.reverseLabel === roleName) {
	                if (sr.enabled && !_this.enabled) {
	                    _this.swapWithSecondary(i);
	                }
	            }
	            else {
	                sr.enabled = false;
	            }
	        });
	        return this.enabled;
	    };
	    RelationEdge.prototype.filterByType = function (typeName) {
	        var _this = this;
	        if (this.category !== typeName) {
	            this.enabled = false;
	        }
	        this.secondaries.forEach(function (sr, i) {
	            if (sr.category === typeName) {
	                if (sr.enabled && !_this.enabled) {
	                    _this.swapWithSecondary(i);
	                }
	            }
	            else {
	                sr.enabled = false;
	            }
	        });
	        return this.enabled;
	    };
	    return RelationEdge;
	}(graph_1.GraphEdge));
	exports.RelationEdge = RelationEdge;
	var RelationNode = (function (_super) {
	    __extends(RelationNode, _super);
	    function RelationNode(mn) {
	        var _this = _super.call(this, mn.nodeId, mn.summary.contextType) || this;
	        _this.alreadyExpanded = false;
	        _this.summary = mn.summary.summary;
	        return _this;
	    }
	    return RelationNode;
	}(graph_1.GraphNode));
	exports.RelationNode = RelationNode;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(824);
	exports.GraphNode = node_1.GraphNode;
	var edge_1 = __webpack_require__(825);
	exports.GraphEdge = edge_1.GraphEdge;
	var Graph = (function () {
	    function Graph(nodes, edges) {
	        if (nodes === void 0) { nodes = []; }
	        if (edges === void 0) { edges = []; }
	        var _this = this;
	        this.nodes = nodes;
	        this.edges = edges;
	        this.knownNodeCategories = [];
	        this.reinitialize = false;
	        this.byId = new Map();
	        nodes.forEach(function (node) {
	            _this.byId.set(node.id, node);
	            _this.addNodeCategory(node);
	        });
	    }
	    Graph.prototype.addNodeCategory = function (node) {
	        if (node.category && this.knownNodeCategories.indexOf(node.category) === -1) {
	            this.knownNodeCategories.push(node.category);
	        }
	    };
	    Graph.prototype.addNode = function (node) {
	        this.nodes.push(node);
	        this.byId.set(node.id, node);
	        this.addNodeCategory(node);
	    };
	    Graph.prototype.addEdgeByIds = function (sourceId, targetId, builder) {
	        if (sourceId === targetId && !this.allowsSelfEdges) {
	            console.error(sourceId, targetId);
	            throw new Error("This graph does not support self-edges!");
	        }
	        var source = this.byId.get(sourceId);
	        var target = this.byId.get(targetId);
	        if (source === undefined || target === undefined) {
	            console.error(sourceId, targetId);
	            throw new Error("Could not find all nodes for edge!");
	        }
	        var edge = builder(source, target);
	        if (edge) {
	            this.edges.push(edge);
	        }
	        return edge;
	    };
	    Graph.sourcedAt = function (edge, node) {
	        return edge.source === node;
	    };
	    Graph.targets = function (edge, node) {
	        return edge.target === node;
	    };
	    Graph.topologicalCompatator = function (edges) {
	        return function (a, b) {
	            var relative = 0;
	            for (var _i = 0, edges_1 = edges; _i < edges_1.length; _i++) {
	                var edge = edges_1[_i];
	                if (Graph.sourcedAt(edge, a)) {
	                    if (Graph.targets(edge, b)) {
	                        return -1000;
	                    }
	                    relative--;
	                }
	                if (Graph.sourcedAt(edge, b)) {
	                    if (Graph.targets(edge, a)) {
	                        return 1000;
	                    }
	                    relative++;
	                }
	            }
	            return relative;
	        };
	    };
	    return Graph;
	}());
	exports.Graph = Graph;


/***/ }),
/* 824 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var GraphNode = (function () {
	    function GraphNode(id, category) {
	        if (category === void 0) { category = "none"; }
	        this.id = id;
	        this.category = category;
	        this.simulated = false;
	        this.enabled = true;
	    }
	    return GraphNode;
	}());
	exports.GraphNode = GraphNode;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var GraphEdge = (function () {
	    function GraphEdge(source, target) {
	        this.enabled = true;
	        this.simulated = false;
	        this.hasSecondaries = false;
	        this.secondaries = [];
	        this.source = source;
	        this.target = target;
	    }
	    Object.defineProperty(GraphEdge.prototype, "labelsWithSecondaries", {
	        get: function () {
	            if (this.hasSecondaries) {
	                return ([this.label].concat(this.secondaries.map(function (s) { return s.label; })));
	            }
	            else {
	                return [this.label];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GraphEdge.prototype, "reverseLabelsWithSecondaries", {
	        get: function () {
	            if (this.hasSecondaries) {
	                return ([this.reverseLabel].concat(this.secondaries.map(function (s) { return s.reverseLabel; })));
	            }
	            else {
	                return [this.reverseLabel];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GraphEdge;
	}());
	exports.GraphEdge = GraphEdge;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var subjects_1 = __webpack_require__(660);
	var Relationship = (function () {
	    function Relationship(data, types, roles, source) {
	        if (types === void 0) { types = []; }
	        if (roles === void 0) { roles = []; }
	        this.id = data.id;
	        this.targetSummary = data.targetSummary;
	        this.source = source;
	        this.type = types.find(function (rt) { return rt.name === data.relationshipType; });
	        this.sourceRole = roles.find(function (role) { return role.name === data.sourceRole; });
	        this.targetRole = roles.find(function (role) { return role.name === data.targetRole; });
	    }
	    Object.defineProperty(Relationship.prototype, "isOrientedWithDefinition", {
	        get: function () {
	            return (this.source.type === this.type.sourceType);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Relationship.prototype.buildRef = function () {
	        return {
	            id: this.id,
	            host: this,
	            type: "relationship",
	            request: new subjects_1.RelationshipPartnerRequest(this.source.id, this.id),
	            priority: 20
	        };
	    };
	    Relationship.prototype.startEditing = function () {
	        var _this = this;
	        this.editing = true;
	        this.sourceRoleEdit = new forms_1.FormControl(null, forms_1.Validators.required);
	        this.targetRoleEdit = new forms_1.FormControl(null, forms_1.Validators.required);
	        this.sourceRoleEdit.valueChanges.subscribe(function (newRole) {
	            var partnerOpts = _this.getAvailablePartnerRoles();
	            if (!_this.targetRoleEdit.value && partnerOpts.length === 1) {
	                _this.targetRoleEdit.setValue(partnerOpts[0]);
	            }
	        });
	        this.targetRoleEdit.valueChanges.subscribe(function (newRole) {
	            var selfOpts = _this.getAvailableRoles();
	            if (!_this.sourceRoleEdit.value && selfOpts.length === 1) {
	                _this.sourceRoleEdit.setValue(selfOpts[0]);
	            }
	        });
	        var initialSelfOpts = this.getAvailableRoles();
	        if (initialSelfOpts.length === 1) {
	            this.sourceRoleEdit.setValue(initialSelfOpts[0]);
	        }
	    };
	    Relationship.prototype.cancelEditing = function () {
	        this.sourceRoleEdit = null;
	        this.targetRoleEdit = null;
	        this.editing = false;
	    };
	    Object.defineProperty(Relationship.prototype, "editsValid", {
	        get: function () {
	            return (this.sourceRoleEdit && this.sourceRoleEdit.valid
	                && this.targetRoleEdit && this.targetRoleEdit.valid);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Relationship.prototype.getAvailableRoles = function () {
	        if (this.targetRoleEdit && this.targetRoleEdit.value) {
	            var partnerSelection_1 = this.targetRoleEdit.value;
	            if (this.isOrientedWithDefinition) {
	                return this.type.sourceRoles.find(function (r) { return r.role.name === partnerSelection_1.name; }).partners;
	            }
	            else {
	                return this.type.targetRoles.find(function (r) { return r.role.name === partnerSelection_1.name; }).partners;
	            }
	        }
	        if (this.isOrientedWithDefinition) {
	            return this.type.sourceRoles.map(function (role) { return role.role; });
	        }
	        else {
	            return this.type.targetRoles.map(function (role) { return role.role; });
	        }
	    };
	    Relationship.prototype.getAvailablePartnerRoles = function () {
	        if (this.sourceRoleEdit && this.sourceRoleEdit.value) {
	            var mySelection_1 = this.sourceRoleEdit.value;
	            if (this.isOrientedWithDefinition) {
	                return this.type.sourceRoles.find(function (r) { return r.role.name === mySelection_1.name; }).partners;
	            }
	            else {
	                return this.type.targetRoles.find(function (r) { return r.role.name === mySelection_1.name; }).partners;
	            }
	        }
	        if (this.isOrientedWithDefinition) {
	            return this.type.targetRoles.map(function (role) { return role.role; });
	        }
	        else {
	            return this.type.sourceRoles.map(function (role) { return role.role; });
	        }
	    };
	    return Relationship;
	}());
	exports.Relationship = Relationship;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var validators_1 = __webpack_require__(701);
	var SelectGroupsModalComponent = (function () {
	    function SelectGroupsModalComponent(dialog) {
	        this.dialog = dialog;
	    }
	    SelectGroupsModalComponent.prototype.ngOnInit = function () {
	        this.availableGroups = this.dialog.context.availableGroups;
	        this.selectedGroups = new forms_1.FormControl(this.dialog.context.initialSelection || [], [forms_1.Validators.required, validators_1.CustomValidators.arrayMin(1)]);
	    };
	    SelectGroupsModalComponent.prototype.submit = function () {
	        if (!this.selectedGroups.valid) {
	            console.warn("Encountered errors:", this.selectedGroups.errors);
	            return;
	        }
	        this.dialog.close(this.selectedGroups.value);
	    };
	    SelectGroupsModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      New Subject Visibility\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label>Select groups for the new entry:</label>\n      <select\n        class=\"form-control\"\n        [formControl]=\"selectedGroups\"\n        [size]=\"availableGroups.length\"\n        multiple>\n        <option\n          *ngFor=\"let group of availableGroups\"\n          [ngValue]=\"group.id\">\n          {{group.name}}\n        </option>\n      </select>\n\n    </div>\n    <p>\n      Groups determine who will be able to see, search, and modify this record.\n    </p>\n    <p>\n      You can select multiple groups by dragging or by holding <kbd>CTRL</kbd>\n      or <kbd>CMD</kbd> and clicking. You must select at least one group for\n      this subject.\n    </p>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-success\"\n      (click)=\"submit()\"\n      [disabled]=\"selectedGroups.invalid\">\n      Create Subject\n    </button>\n  </div>\n  "
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], SelectGroupsModalComponent);
	    return SelectGroupsModalComponent;
	}());
	exports.SelectGroupsModalComponent = SelectGroupsModalComponent;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rx_1 = __webpack_require__(214);
	var context_management_1 = __webpack_require__(604);
	var subjects_1 = __webpack_require__(660);
	var functions_1 = __webpack_require__(206);
	var subject_context_type_1 = __webpack_require__(569);
	var Subject = (function () {
	    function Subject(sender, algorithmResolver, ref) {
	        this.sender = sender;
	        this.algorithmResolver = algorithmResolver;
	        this.identifiers = [];
	        this.loaded = false;
	        this.running = false;
	        this.id = null;
	        this.localId = Subject.nextLocalId++;
	        this.localCreated = new Date();
	        this.lastLocalActionTime = new Date();
	        this.lastLocalActionDescription = "loaded";
	        this.newlyCreated = false;
	        this.groups = [];
	        this.comments = [];
	        this.relationships = [];
	        if (ref) {
	            this.identifiers = [ref];
	        }
	    }
	    Subject.prototype.assertTypeDefined = function () {
	        if (!this.type) {
	            console.error("Subject had no type when type was required!", this);
	            throw new Error("Subject had no type when type was required!");
	        }
	    };
	    Subject.prototype.load = function () {
	        if (this.loaded) {
	            console.warn("Requested load of already loaded subject", this);
	            return Rx_1.Observable.empty();
	        }
	        var identifier = this.findPreferredReference();
	        if (identifier) {
	            return this.loadVia(identifier);
	        }
	        else {
	            console.error("Could not find appropriate ID for subject", this);
	            throw new Error("Subject not loadable - no valid ID");
	        }
	    };
	    Subject.prototype.loadVia = function (identifier) {
	        this.lastRefType = identifier.type;
	        if (identifier.summaryURL) {
	            this.lastRefURL = identifier.summaryURL;
	        }
	        else {
	            this.lastRefURL = null;
	        }
	        return this.sender.converse(identifier.request);
	    };
	    Subject.prototype.release = function () {
	        var _this = this;
	        if (!this.loaded) {
	            console.error("Requested release of non-loaded subject", this);
	            throw new Error("Cannot release non-loaded subject!");
	        }
	        return this.sender.successful(new context_management_1.ReleaseObjectRequest(this.id)).do(function () {
	            _this.loaded = false;
	            _this.id = null;
	        });
	    };
	    Subject.prototype.findPreferredReference = function () {
	        return this.identifiers.slice(-1)[0];
	    };
	    Subject.prototype.findRef = function (kind) {
	        return this.identifiers.find(function (sr) { return sr.type === kind; });
	    };
	    Subject.prototype.removeRef = function (ref) {
	        functions_1.arrayRemove(this.identifiers, ref);
	    };
	    Subject.prototype.addRef = function (ref, overwrite) {
	        if (overwrite === void 0) { overwrite = true; }
	        var existing = this.identifiers.findIndex(function (sr) {
	            return (sr.type === ref.type && sr.host === ref.host);
	        });
	        if ((existing !== -1) && overwrite) {
	            this.identifiers[existing] = ref;
	        }
	        else {
	            this.identifiers.push(ref);
	        }
	        this.lastIdentifier = ref;
	    };
	    Subject.prototype.readSubjectResult = function (scr) {
	        var _this = this;
	        this.loaded = true;
	        this.id = scr.objectId;
	        this.type = scr.contextType;
	        this.incomingWatchId = scr.watchId;
	        this.created = new Date(scr.created);
	        this.availableAlgorithms = scr.algorithms.map(function (name) { return _this.algorithmResolver(name); });
	        this.summary = scr.summary.summary;
	        return true;
	    };
	    Subject.prototype.removeRelationship = function (rel) {
	        if (this.relationships.indexOf(rel) === -1) {
	            throw new Error("Subject does not contain rel slated for delete!");
	        }
	        return this.sender.resultOf(new subjects_1.DeleteSubjectContextRelationshipRequest(this.id, rel.id));
	    };
	    Subject.prototype.relateTo = function (partner, type, sourceRole, targetRole) {
	        if (!partner.loaded || !this.loaded) {
	            console.error(this, partner);
	            throw new Error("Both subjects must be loaded to relate the two");
	        }
	        return this.sender.resultOf(new subjects_1.AddSubjectContextRelationshipRequest(type.name, this.id, sourceRole.name, partner.id, targetRole.name), true);
	    };
	    Subject.prototype.updateRelation = function (relationshipId, sourceRole, targetRole) {
	        return this.sender.resultOf(new subjects_1.ModifySubjectContextRelationshipRequest(this.id, relationshipId, sourceRole.name, targetRole.name), true);
	    };
	    Subject.prototype.getSummaryColumn = function (name) {
	        if (!this.summary) {
	            return null;
	        }
	        return this.summary.find(function (o) { return o && o.name === name; });
	    };
	    Subject.getSummaryOn = function (name, summary) {
	        if (!Array.isArray(summary)) {
	            return null;
	        }
	        return summary.find(function (o) { return o && o.name === name; });
	    };
	    Object.defineProperty(Subject.prototype, "readableTitle", {
	        get: function () {
	            return Subject.readableTitleFor(this.summary, this.type);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Subject.readableTitleFor = function (summary, sct) {
	        if (Array.isArray(summary)) {
	            if (sct === subject_context_type_1.KnownSubjectContextTypes.Healthcare) {
	                return (Subject.getSummaryOn("first name", summary).value
	                    + " "
	                    + Subject.getSummaryOn("last name", summary).value);
	            }
	            else if (sct === subject_context_type_1.KnownSubjectContextTypes.IssueReport) {
	                return Subject.getSummaryOn("IR issue title", summary).value;
	            }
	            return "Unknown " + sct;
	        }
	        return "Empty summary";
	    };
	    Object.defineProperty(Subject.prototype, "abbreviatedTitle", {
	        get: function () {
	            return Subject.abbreviatedTitleFor(this.summary, this.type);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Subject.abbreviatedTitleFor = function (summary, sct) {
	        if (Array.isArray(summary)) {
	            if (sct === subject_context_type_1.KnownSubjectContextTypes.Healthcare) {
	                var result = ((Subject.getSummaryOn("last name", summary).value
	                    || "").substring(0, 3).toLocaleUpperCase()
	                    + "," +
	                    (Subject.getSummaryOn("first name", summary).value
	                        || "").substring(0, 3).toLocaleUpperCase());
	                if (result === ",") {
	                    return "«new entry»";
	                }
	                else {
	                    return result;
	                }
	            }
	            else if (sct === subject_context_type_1.KnownSubjectContextTypes.IssueReport) {
	                return Subject.getSummaryOn("IR issue title", summary).value;
	            }
	            return "Unknown " + sct;
	        }
	        return "Empty summary";
	    };
	    Subject.prototype.sameAs = function (compare) {
	        return ((this === compare)
	            || this.id === compare.id
	            || this.cloneOf === compare
	            || compare.cloneOf === this);
	    };
	    Subject.prototype.touch = function (description) {
	        this.lastLocalActionTime = new Date();
	        this.lastLocalActionDescription = description || "unknown";
	    };
	    Subject.nextLocalId = 0;
	    return Subject;
	}());
	exports.Subject = Subject;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var user_service_1 = __webpack_require__(713);
	var SubjectSelectorModalComponent = (function () {
	    function SubjectSelectorModalComponent(dialog, users) {
	        this.dialog = dialog;
	        this.users = users;
	        this.provideAction = false;
	        this.showNonLoaded = true;
	        this.subjects = dialog.context.list;
	        if (dialog.context.actionLabel) {
	            this.provideAction = true;
	            this.actionLabel = dialog.context.actionLabel;
	        }
	        if (dialog.context.showNonLoaded !== undefined) {
	            this.showNonLoaded = dialog.context.showNonLoaded;
	        }
	    }
	    SubjectSelectorModalComponent.prototype.select = function (subject) {
	        if (subject) {
	            this.dialog.close(subject);
	        }
	        else {
	            this.dialog.dismiss();
	        }
	    };
	    SubjectSelectorModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      {{dialog.context.title || \"Subjects\"}}\n    </h4>\n  </div>\n\n  <table\n    *ngIf=\"dialog.context.mode === 'recent'\"\n    class=\"table center-items\" width=\"100%\">\n    <thead>\n      <tr>\n        <th>\n          Type\n        </th>\n        <th>\n          Name\n        </th>\n        <th>\n          Status\n        </th>\n        <th>\n          Last Action*\n        </th>\n        <th *ngIf=\"users.debugMode\">\n          IDs\n        </th>\n        <th *ngIf=\"provideAction\"><!-- empty --></th>\n      </tr>\n    </thead>\n\n    <tbody>\n      <tr *ngIf=\"!subjects?.length\">\n        <td colspan=\"10\">\n          <h3 class=\"text-center\">No recent subjects!</h3>\n        <td>\n      </tr>\n      <tr *ngFor=\"let subj of subjects\">\n        <td>\n          {{subj.type}}\n        </td>\n        <td>\n          {{subj.readableTitle}}\n        </td>\n        <td>\n          <span *ngIf=\"!subj.loaded\">Known</span>\n          <span *ngIf=\"subj.loaded && !subj.running\" class=\"text-primary\">\n            Loaded\n          </span>\n          <span *ngIf=\"subj.loaded && subj.running\" class=\"text-success\">\n            Running\n          </span>\n        </td>\n        <td>\n          {{subj.lastLocalActionDescription}}\n          at\n          {{subj.lastLocalActionTime | date}}\n        </td>\n        <td *ngIf=\"users.debugMode\">\n          <em>Server:</em> {{subj.id}}\n          <br>\n          <em>Local:</em> {{subj.localId}}\n        </td>\n        <td *ngIf=\"provideAction\">\n          <button class=\"btn btn-primary p100\" (click)=\"dialog.close(subj)\">\n            {{actionLabel}}\n          </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <watchlist\n    *ngIf=\"dialog.context.mode === 'watchlist'\"\n    [showTitle]=\"false\"\n    [asSelector]=\"true\"\n    [enforcedType]=\"dialog.context.onlyOfType\"\n    (selection)=\"select($event)\">\n  </watchlist>\n\n  <div *ngIf=\"dialog.context.mode === 'search'\" class=\"modal-body\" #search>\n    <div class=\"btn-group\" style=\"margin: auto\">\n      <a\n        class=\"btn btn-default\"\n        [class.active]=\"!search.showResults\"\n        (click)=\"search.showResults = false\">\n        Query\n      </a>\n      <a\n        class=\"btn btn-default\"\n        [class.active]=\"search.showResults\"\n        (click)=\"search.showResults = true\">\n        Results\n      </a>\n    </div>\n    <div *ngIf=\"!search.showResults\">\n      <search-panel\n        [enforcedType]=\"dialog.context.onlyOfType\"\n        [unwrap]=\"true\"\n        (onSubmit)=\"search.showResults = true\">\n      </search-panel>\n    </div>\n    <div *ngIf=\"search.showResults\">\n      <search-results-table [asSelector]=\"true\" (selection)=\"select($event)\">\n      </search-results-table>\n    </div>\n  </div>\n\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      OK\n    </button>\n  </div>\n  "
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            user_service_1.UserService])
	    ], SubjectSelectorModalComponent);
	    return SubjectSelectorModalComponent;
	}());
	exports.SubjectSelectorModalComponent = SubjectSelectorModalComponent;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(66);
	var platform_browser_1 = __webpack_require__(21);
	var algorithm_service_1 = __webpack_require__(213);
	var setting_service_1 = __webpack_require__(690);
	var Rx_1 = __webpack_require__(214);
	var BrandingService = (function () {
	    function BrandingService(http, title, algorithms, settings) {
	        var _this = this;
	        this.http = http;
	        this.title = title;
	        this.algorithms = algorithms;
	        this.settings = settings;
	        this.strings = {};
	        this.flags = new Set();
	        this.done = new Rx_1.BehaviorSubject(false);
	        this.defaultTitle = "Advocus";
	        this.http.request("/zone/brand_strings.json").subscribe(function (response) {
	            var loaded = response.json();
	            for (var _i = 0, _a = Object.keys(loaded); _i < _a.length; _i++) {
	                var key = _a[_i];
	                if (key === BrandingService_1.FLAGS_LABEL) {
	                    if (!Array.isArray(loaded[key])) {
	                        console.error(key, loaded);
	                        throw new Error("FLAGS values was not an array " + loaded[key]);
	                    }
	                    loaded[key].forEach(function (item) { return _this.flags.add("" + item); });
	                }
	                else {
	                    if (typeof loaded[key] !== "string") {
	                        console.error(key, loaded);
	                        throw new Error("Found non-string value in map: " + loaded[key]);
	                    }
	                    _this.strings[key] = loaded[key];
	                }
	            }
	            _this.done.next(true);
	        });
	        if (this.settings.getOr("use dynamic titles", false)) {
	            this.algorithms.runningObservable.subscribe(function (ra) {
	                if (ra) {
	                    _this.setTitle("Advocus: " + ra.subject.abbreviatedTitle);
	                }
	                else {
	                    _this.resetTitle();
	                }
	            });
	        }
	    }
	    BrandingService_1 = BrandingService;
	    BrandingService.prototype.setTitle = function (newTitle) {
	        this.title.setTitle(newTitle);
	    };
	    BrandingService.prototype.resetTitle = function () {
	        this.title.setTitle(this.defaultTitle);
	    };
	    var BrandingService_1;
	    BrandingService.FLAGS_LABEL = "FLAGS";
	    BrandingService = BrandingService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            platform_browser_1.Title,
	            algorithm_service_1.AlgorithmService,
	            setting_service_1.SettingService])
	    ], BrandingService);
	    return BrandingService;
	}());
	exports.BrandingService = BrandingService;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var auth_service_1 = __webpack_require__(777);
	var login_service_1 = __webpack_require__(814);
	var alert_service_1 = __webpack_require__(689);
	var branding_service_1 = __webpack_require__(830);
	var router_1 = __webpack_require__(41);
	var subject_service_1 = __webpack_require__(821);
	var algorithm_service_1 = __webpack_require__(213);
	var WelcomeGuestComponent = (function () {
	    function WelcomeGuestComponent(auth, login, alerts, branding, router, subjects, algorithms) {
	        this.auth = auth;
	        this.login = login;
	        this.alerts = alerts;
	        this.branding = branding;
	        this.router = router;
	        this.subjects = subjects;
	        this.algorithms = algorithms;
	    }
	    WelcomeGuestComponent.prototype.attemptGuestLogIn = function () {
	        var _this = this;
	        this.auth.guestLogin().subscribe(function (success) {
	            if (success) {
	                var alg = _this.algorithms.findAlgorithm("a-tlc");
	                console.warn(alg);
	                if (alg) {
	                    _this.subjects.launchNew(alg);
	                }
	            }
	            else {
	                _this.alerts.warnAndReplace("Your username and/or password are incorrect. Please try again.", "credential failure");
	            }
	        });
	        return false;
	    };
	    WelcomeGuestComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"inset-background welcome-mat\">\n    <div class=\"container\">\n      <table class=\"splash center-block\">\n        <tr>\n          <td rowspan=\"2\">\n            <img src=\"zone/images/splash_logo.png\" class=\"logo\">\n          </td>\n          <td class=\"title-box\">\n            <h4 class=\"pretitle\">{{branding.strings.splash_pretitle}}</h4>\n            <h1 class=\"title\">\n              {{branding.strings.splash_title}}\n              <span\n                *ngIf=\"branding.flags.has('use_title_trademark')\"\n                class=\"title-tm\">\n                \u2122\uFE0F\n              </span>\n            </h1>\n          </td>\n        </tr>\n        <tr>\n          <td class=\"explanation\">\n            <p>\n              {{branding.strings.splash_tagline}}\n            </p>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"container loginForm\">\n    <div *ngIf=\"!auth.authenticated\" class=\"row\">\n      <div class=\"col-sm-6 col-sm-offset-3 form-group\">\n        <button\n          class=\"btn btn-primary form-control align-with-labels\"\n          (click)=\"attemptGuestLogIn()\"\n          [disabled]=\"!login.ready\">\n          Start Guest Session\n        </button>\n      </div>\n    </div>\n    <h3 class=\"info row text-center\" *ngIf=\"auth.authenticated\">\n      You have already started your session!\n    </h3>\n  </div>\n\n  <div class=\"inset-background\">\n    <div class=\"container\">\n      <table class=\"grant-info center-block\">\n        <tr>\n          <td>\n            <p>\n              Advocus is a product of My Coverage Plan,\n              a subsidiary of ABC for Health, Inc.\n            </p>\n            <p>\n              My Coverage Plan was made possible in part by grant number\n              <cite>5R43MD005810-02</cite> from the National Institute on\n              Minority Health and Health Disparities.\n            </p>\n          </td>\n          <td>\n            <img src=\"zone/images/mcp_logo.png\" class=\"logo mcp\">\n          </td>\n          <td>\n            <img src=\"zone/images/abc_logo.png\" class=\"logo abc\">\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n  ",
	            styles: [""]
	        }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService,
	            login_service_1.LoginService,
	            alert_service_1.AlertService,
	            branding_service_1.BrandingService,
	            router_1.Router,
	            subject_service_1.SubjectService,
	            algorithm_service_1.AlgorithmService])
	    ], WelcomeGuestComponent);
	    return WelcomeGuestComponent;
	}());
	exports.WelcomeGuestComponent = WelcomeGuestComponent;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var setting_service_1 = __webpack_require__(690);
	var SettingsComponent = (function () {
	    function SettingsComponent(settingService) {
	        this.settingService = settingService;
	        this.settings = [];
	        this.form = new forms_1.FormGroup({});
	    }
	    SettingsComponent.prototype.keyInputFor = function (s) {
	        return {
	            type: s.keyType,
	            hints: s.keyHints,
	            value: null
	        };
	    };
	    SettingsComponent.prototype.extend = function (s) {
	        s.control.push(new forms_1.FormArray([
	            new forms_1.FormControl(), new forms_1.FormControl()
	        ]));
	        this.propagateMapChangeToSettings(s);
	    };
	    SettingsComponent.prototype.shrink = function (s, i) {
	        if (s.control.length > i) {
	            s.control.removeAt(i);
	        }
	        this.propagateMapChangeToSettings(s);
	    };
	    SettingsComponent.prototype.propagateMapChangeToSettings = function (s) {
	        console.warn("propagating: " + s.name);
	        this.settingService.set(s.name, s.control.value);
	    };
	    SettingsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.settings = this.settingService.visible();
	        this.settings.forEach(function (setting) {
	            if (_this.settingService.isMapSetting(setting)) {
	                var controls_1 = [];
	                if (Array.isArray(setting.value)) {
	                    setting.value.forEach(function (_a) {
	                        var key = _a[0], value = _a[1];
	                        controls_1.push(new forms_1.FormArray([
	                            new forms_1.FormControl(key),
	                            new forms_1.FormControl(value)
	                        ]));
	                    });
	                }
	                setting.control = new forms_1.FormArray(controls_1);
	                console.warn(setting.control);
	            }
	            else {
	                setting.control = new forms_1.FormControl(setting.value);
	                setting.control.valueChanges.subscribe(function (change) { return _this.settingService.set(setting.name, change); });
	                if (setting.disabled) {
	                    setting.control.disable();
	                }
	            }
	            _this.form.addControl(setting.name, setting.control);
	        });
	    };
	    SettingsComponent.prototype.ngOnDestroy = function () {
	        this.settings.forEach(function (setting) { return delete setting.control; });
	    };
	    SettingsComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"container\">\n      <div class=\"well center-block\">\n        <h2>Settings</h2>\n        <p>\n          These settings only affect this computer. Their values will be saved\n          immediately after you change them, however <em>some of them may\n          require you to reload or restart the application to take effect</em>.\n        </p>\n        <div class=\"row\">\n          <div\n            *ngFor=\"let setting of settings\"\n            class=\"col-sm-12 form-group\">\n            <label class=\"capitalized\">\n              <span *ngIf=\"setting.keyType\" class=\"glyphicon glyphicon-list\"></span>\n              {{setting.name}}\n            </label>\n            <span *ngIf=\"setting.debugOnly\" class=\"text-info\">\n              (debug only)\n            </span>\n            <!-- regular settings -->\n            <typed-control *ngIf=\"!setting.keyType\" [input]=\"setting\"></typed-control>\n            <!-- map settings -->\n            <div *ngIf=\"setting.keyType\">\n              <p [innerHtml]=\"setting.presentationUnsafe || setting.presentation\"></p>\n              <table>\n                <tbody>\n                <tr *ngFor=\"let pair of setting.value; let i = index\">\n                  <td width=\"30%\">\n                    <typed-field\n                      [input]=\"keyInputFor(setting)\"\n                      [control]=\"setting.control.controls[i].controls[0]\"\n                      [clearButton]=\"false\"\n                      [iconTray]=\"false\"\n                      [validationTray]=\"false\"\n                      (change)=\"propagateMapChangeToSettings(setting)\">\n                    </typed-field>\n                  </td>\n                  <td width=\"65%\">\n                    <typed-field\n                      [input]=\"setting\"\n                      [control]=\"setting.control.controls[i].controls[1]\"\n                      [clearButton]=\"false\"\n                      [iconTray]=\"false\"\n                      [validationTray]=\"false\"\n                      (change)=\"propagateMapChangeToSettings(setting)\">\n                    </typed-field>\n                  </td>\n                  <td width=\"5%\" style=\"text-align: center\">\n                    <span\n                      class=\"glyphicon glyphicon-remove text-danger\"\n                      title=\"Remove this entry\"\n                      (click)=\"shrink(setting, i)\">\n                    </span>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <button class=\"btn btn-primary form-control\" (click)=\"extend(setting)\">\n                      Add Entry\n                    </button>\n                  </td>\n                </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  ",
	            styles: [
	                ".well.center-block {max-width: 600px;}",
	                ".well h2 {margin-top: 0;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [setting_service_1.SettingService])
	    ], SettingsComponent);
	    return SettingsComponent;
	}());
	exports.SettingsComponent = SettingsComponent;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var router_1 = __webpack_require__(41);
	var search_service_1 = __webpack_require__(834);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var sounds_service_1 = __webpack_require__(756);
	var auth_service_1 = __webpack_require__(777);
	var interpolation_1 = __webpack_require__(585);
	var SandboxComponent = (function () {
	    function SandboxComponent(router, search, messaging, subjects, sounds, auth) {
	        this.messaging = messaging;
	        this.subjects = subjects;
	        this.sounds = sounds;
	        this.auth = auth;
	        this.x = 7;
	        this.genericDisplay = "";
	        this.pingResult = "";
	        this.terpVars = [
	            {
	                name: "dogNames",
	                type: "string",
	                cardinality: 0,
	                collectionType: "list",
	                value: ["Fido", "Rufus", "Poncho"]
	            },
	            {
	                name: "dogBreeds",
	                type: "string",
	                cardinality: 0,
	                collectionType: "list",
	                value: ["Pekingese", "Golden", "Pitoodle"]
	            },
	            {
	                name: "dogCounts",
	                type: "whole number",
	                cardinality: 0,
	                collectionType: "list",
	                value: [0, 2, 5]
	            }
	        ];
	    }
	    SandboxComponent.prototype.rando = function () {
	        var r = Math.floor(Math.random() * 10) + 5;
	        if (r === this.x) {
	            r--;
	        }
	        this.x = r;
	    };
	    SandboxComponent.prototype.send = function () {
	        var _this = this;
	        this.auth.guestLogin().subscribe(function (_) {
	            _this.pingResult = "" + _;
	            _this.auth.redirect();
	        });
	    };
	    SandboxComponent.prototype.boop = function () {
	        this.sounds.playSound("chat");
	    };
	    SandboxComponent.prototype.ngOnInit = function () {
	        this.control = new forms_1.FormControl([]);
	        this.genericDisplay = interpolation_1.interpolateString("${dogNames|zip,${dogBreeds}} | ${dogCounts}", this.terpVars.slice(0));
	    };
	    SandboxComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\" style=\"border: 2px yellow solid;\">\n  <iframe src=\"http://localhost:4200/\" style=\"border: 2px green solid;\" width=\"1400\" height=\"700\"></iframe>\n  </div>\n\n  <div class=\"container\">\n    <div class=\"well\">\n      List: {{control.value | json}}\n    </div>\n    <ul>\n      <li>\n        <button class=\"btn btn-default\">Default</button>\n      </li>\n      <li>\n        <button class=\"btn btn-primary\">Standard / navigational action </button>\n      </li>\n      <li>\n        <button class=\"btn btn-success\">Save / confirmation action</button>\n      </li>\n      <li>\n        <button class=\"btn btn-warning\">Ignore / caution action</button>\n      </li>\n      <li>\n        <button class=\"btn btn-danger\">Destructive / dangerous action</button>\n      </li>\n      <li>\n        <button class=\"btn btn-info\">Special / informative action</button>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"container\">\n    <h3>\n      Messaging Tests\n      <!-- <button class=\"btn btn-sm btn-warning\" (click)=\"send()\" [disabled]=\"subjects.subjects.length == 0\">\n        Send Remove for s0 (\n          {{subjects.subjects[0]?.readableTitle}}\n          <em *ngIf=\"subjects.subjects.length == 0\">none</em>\n        )\n      </button> -->\n      <button class=\"btn btn-sm btn-warning\" (click)=\"send()\">Guestify</button>\n      <input type=\"text\" class=\"form-control\" [value]=\"pingResult\">\n    </h3>\n    <h3>\n      repeatTo test\n      <button class=\"btn btn-sm btn-info\" (click)=\"rando()\">Randomize</button>\n      </h3>\n    <ol>\n      <li *repeatTo=\"x; let i = index\">\n        i = {{i}}\n      </li>\n    </ol>\n  </div>\n\n  <div class=\"container\">\n    <h3>Synth Tests</h3>\n    <p>\n          <button class=\"btn btn-success\" (click)=\"boop()\">Play!</button>\n    </p>\n  </div>\n\n  <div class=\"container\">\n          <h3>Interp Test</h3>\n          <code>{{genericDisplay}}</code>\n  </div>\n  ",
	            styles: ["li {margin-top: 10px;} .btn {width: 240px;}"],
	            animations: []
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            search_service_1.SearchService,
	            messaging_service_1.MessagingService,
	            subject_service_1.SubjectService,
	            sounds_service_1.SoundsService,
	            auth_service_1.AuthService])
	    ], SandboxComponent);
	    return SandboxComponent;
	}());
	exports.SandboxComponent = SandboxComponent;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var alert_service_1 = __webpack_require__(689);
	var typed_data_1 = __webpack_require__(69);
	var general_1 = __webpack_require__(513);
	var search_1 = __webpack_require__(654);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var decorators_1 = __webpack_require__(517);
	var functions_1 = __webpack_require__(206);
	var ring_buffer_1 = __webpack_require__(693);
	var search_node_1 = __webpack_require__(835);
	var modal_service_1 = __webpack_require__(837);
	var storage_service_1 = __webpack_require__(691);
	var operators_1 = __webpack_require__(836);
	var ADDL_COUNT_RESOLUTION = 10;
	var SearchService = (function () {
	    function SearchService(messaging, alerts, subjects, storage, modals) {
	        var _this = this;
	        this.messaging = messaging;
	        this.alerts = alerts;
	        this.subjects = subjects;
	        this.storage = storage;
	        this.modals = modals;
	        this.rootByType = new Map();
	        this.availableTypes = [];
	        this.running = false;
	        this.results = null;
	        this.resultContextType = null;
	        this.moreResultsAvailable = false;
	        this.queryTime = null;
	        this.resultTime = null;
	        this.lastResultOpened = null;
	        this.recentSearches = new ring_buffer_1.RingBuffer(5);
	        this.savedSearches = [];
	        this.ready = new Rx_1.BehaviorSubject(false);
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    SearchService_1 = SearchService;
	    Object.defineProperty(SearchService.prototype, "executionSeconds", {
	        get: function () {
	            return (+this.resultTime - +this.queryTime) / 1000;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchService.prototype, "resultCountLabel", {
	        get: function () {
	            if (!Array.isArray(this.results) || this.running) {
	                console.error("UI requested result count label when results unavailable");
	                return "\u3008in progress\u3009";
	            }
	            if (this.moreResultsAvailable) {
	                return functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                more than ", "\n                records (", " loaded)"], ["\n                more than ", "\n                records (", " loaded)"])), this.queryFetchSize, this.results.length);
	            }
	            else {
	                return functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                ", "\n                record", ""], ["\n                ", "\n                record", ""])), this.results.length, this.results.length === 1 ? "" : "s");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SearchService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(general_1.MessageTag.RSP_SUBJECT_CONTEXT_SEARCH_TREE)
	            .subscribe(function (message) {
	            _this.rootByType.clear();
	            _this.availableTypes = [];
	            message.searchTrees.forEach(function (treeType) {
	                var root = search_node_1.SearchRoot.fromMessage(treeType.tree);
	                _this.rootByType.set(treeType.contextType, root);
	                _this.availableTypes.push(treeType.contextType);
	            });
	            _this.queryFetchSize = message.queryFetchSize;
	            _this.ready.next(true);
	        });
	        this.savedSearches = this.storage.getWrappedValue(SearchService_1.SavedSearchStorageKey, [], SearchService_1.SavedSearchExtractor);
	    };
	    SearchService.SavedSearchExtractor = function (saveds) {
	        return saveds.map(function (s) {
	            s.terms.forEach(function (t) {
	                if (t.serializedMagicSource) {
	                    var op = operators_1.MAGIC_OPS_BY_NAME.get(t.serializedMagicSource[0]);
	                    if (!op) {
	                        console.error("Couldn't find op for name " + t.serializedMagicSource[0]);
	                        return;
	                    }
	                    t.magicSource = [
	                        op,
	                        typed_data_1.TypedData.deserialize({
	                            value: t.serializedMagicSource[1],
	                            type: op.argumentType
	                        })
	                    ];
	                }
	            });
	            return s;
	        });
	    };
	    SearchService.SavedSearchCompressor = function (saveds) {
	        return saveds.map(function (s) {
	            s.terms.forEach(function (t) {
	                if (t.magicSource) {
	                    t.serializedMagicSource = [
	                        t.magicSource[0].name,
	                        typed_data_1.TypedData.serialize({
	                            value: t.magicSource[1],
	                            type: t.magicSource[0].argumentType
	                        })
	                    ];
	                    t.magicSource = undefined;
	                }
	            });
	            return s;
	        });
	    };
	    SearchService.prototype.saveSearch = function () {
	        var _this = this;
	        if (this.recentSearches.size() === 0) {
	            return alert("No recent searches to save!");
	        }
	        var last = this.recentSearches.last();
	        this.modals.stringPrompt({
	            title: "Template name",
	            body: "Enter a name to save as this search template's title",
	            placeholder: "My search"
	        }).subscribe(function (name) {
	            var saved = {
	                name: name,
	                type: last[0],
	                terms: last[1]
	            };
	            _this.savedSearches.push(saved);
	            _this.saveSaveds();
	        });
	    };
	    SearchService.prototype.deleteSaved = function (index) {
	        if (!(index in this.savedSearches)) {
	            return alert("Could not find saved search with index " + index);
	        }
	        this.savedSearches.splice(index, 1);
	        this.saveSaveds();
	    };
	    SearchService.prototype.runSaved = function (index) {
	        var saved = this.savedSearches[index];
	        if (saved) {
	            var remagickedQuery = saved.terms.map(function (t) {
	                if (t.magicSource) {
	                    return t.magicSource[0].transform(t.name, t.magicSource[1]);
	                }
	                return t;
	            });
	            this.runQuery(saved.type, remagickedQuery);
	        }
	        else {
	            throw new Error("Could not find recent search with index " + index);
	        }
	    };
	    SearchService.prototype.saveSaveds = function () {
	        console.log("Setting saved", this.savedSearches);
	        this.storage.setWrapped(SearchService_1.SavedSearchStorageKey, this.savedSearches, SearchService_1.SavedSearchCompressor);
	    };
	    SearchService.prototype.disconnected = function () { };
	    SearchService.prototype.getRoot = function (type) {
	        if (this.rootByType.has(type)) {
	            return this.rootByType.get(type);
	        }
	        return search_node_1.SearchRoot.EMPTY;
	    };
	    SearchService.prototype.runQuery = function (type, terms, previousResultCount) {
	        var _this = this;
	        if (previousResultCount === void 0) { previousResultCount = -1; }
	        var cachedTerms = terms.map(function (term) {
	            if (term.value instanceof Date) {
	                return Object.assign({}, term, { value: new Date(term.value) });
	            }
	            else {
	                return Object.assign({}, term);
	            }
	        });
	        var node = this.getRoot(type);
	        var partitionCount = 0;
	        terms.forEach(function (t) {
	            node = node.retrieve([t.name]);
	            if (!node) {
	                console.error(terms, _this.rootByType);
	                throw new Error("Query did not match search tree structure");
	            }
	            if (node instanceof search_node_1.PartitionNode) {
	                partitionCount++;
	            }
	            t.value = typed_data_1.TypedData.serializeValueBy(t.value, node);
	        });
	        this.queryTime = new Date();
	        this.lastResultOpened = null;
	        this.running = true;
	        this.messaging.converse(new search_1.SubjectContextSearchRequest(type, terms.slice(0, partitionCount), terms.slice(partitionCount)), function (error) {
	            if (error.code === general_1.ResponseCode.MissingData) {
	                _this.alerts.warn(functions_1.oneline(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                        The search encountered a data integrity issue and could\n                        not run. This issue has automatically been logged by\n                        the server.\n                    "], ["\n                        The search encountered a data integrity issue and could\n                        not run. This issue has automatically been logged by\n                        the server.\n                    "]))));
	            }
	            else {
	                _this.alerts.warn(functions_1.oneline(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                        Your search query could not run. (", ") This\n                        is likely due to a problem with the application.\n                    "], ["\n                        Your search query could not run. (", ") This\n                        is likely due to a problem with the application.\n                    "])), error.reason));
	            }
	        }).subscribe(function (msg) {
	            _this.results = msg.resultSet;
	            _this.resultContextType = type;
	            _this.resultTime = new Date();
	            _this.running = false;
	            _this.moreResultsAvailable = msg.canGetMoreData;
	            if (msg.resultSet.length === previousResultCount) {
	                console.info("Query received same number of results as last run");
	            }
	            else {
	                _this.recentSearches.add([
	                    type,
	                    cachedTerms,
	                    msg.resultSet.length,
	                    _this.resultTime,
	                    msg.canGetMoreData
	                ]);
	            }
	        });
	    };
	    SearchService.prototype.runRecentQuery = function (index) {
	        var recent = this.recentSearches.list()[index];
	        if (recent) {
	            var type = recent[0], query = recent[1], count = recent[2], _ = recent[3];
	            var remagickedQuery = query.map(function (t) {
	                if (t.magicSource) {
	                    return t.magicSource[0].transform(t.name, t.magicSource[1]);
	                }
	                return t;
	            });
	            this.runQuery(type, remagickedQuery, count);
	        }
	        else {
	            throw new Error("Could not find recent search with index " + index);
	        }
	    };
	    SearchService.prototype.clearRecents = function () {
	        this.recentSearches.clear();
	    };
	    SearchService.prototype.clearResults = function () {
	        this.results = null;
	        this.resultTime = null;
	        this.moreResultsAvailable = false;
	        this.lastResultOpened = null;
	    };
	    SearchService.prototype.requestMoreResults = function () {
	        var _this = this;
	        if (this.moreResultsAvailable === true) {
	            var requestStart_1 = new Date();
	            this.messaging.converse(new search_1.AdditionalSearchResultsRequest()).subscribe(function (msg) {
	                msg.resultSet.forEach(function (r) { return _this.results.push(r); });
	                _this.moreResultsAvailable = msg.canGetMoreData;
	                _this.queryTime = requestStart_1;
	                _this.resultTime = new Date();
	            });
	        }
	        else {
	            return console.error("No additional results available!");
	        }
	    };
	    SearchService.prototype.getRef = function (result) {
	        return {
	            id: result.recordId,
	            host: this,
	            type: "search",
	            request: new search_1.SubjectContextSearchResultRequest(result.recordId),
	            priority: 50
	        };
	    };
	    SearchService.prototype.open = function (result, navigate, target) {
	        if (navigate === void 0) { navigate = true; }
	        this.lastResultOpened = result;
	        var subject = this.subjects.fromReference(this.getRef(result));
	        if (target) {
	            subject.initialAlgorithmTarget = target;
	        }
	        return this.subjects.open(subject, navigate);
	    };
	    SearchService.prototype.getIdentifierForType = function (sct) {
	        if (sct === "healthcare benefits") {
	            return SearchService_1.HCB_EXTERNAL_ID_FIELD;
	        }
	        throw new Error("Can only load healthcare benefits records using external IDs!");
	    };
	    SearchService.prototype.buildQueryForExternal = function (sct, idStepName, id) {
	        var root = this.rootByType.get(sct);
	        functions_1.assert(root !== undefined, "Could not find root for SCT");
	        var target = root.retrieve([idStepName]);
	        functions_1.assert(target !== null, "Could not retrieve node for external identifier");
	        functions_1.assert(target.canSearchHere(), "Cannot search at external ID node");
	        return {
	            name: idStepName,
	            operator: "=",
	            value: id
	        };
	    };
	    SearchService.prototype.getByExternalID = function (typeString, idString) {
	        var _this = this;
	        this.ready.first(function (r) { return r; }).subscribe(function () {
	            var term = _this.buildQueryForExternal(typeString, _this.getIdentifierForType(typeString), idString);
	            _this.messaging.converse(new search_1.SubjectContextSearchRequest(typeString, [term], []), function (error) {
	                _this.alerts.warn(functions_1.oneline(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                        The server could not locate a record for that ID."], ["\n                        The server could not locate a record for that ID."]))));
	            }).subscribe(function (msg) {
	                if (msg.resultSet.length === 0) {
	                    _this.alerts.warn(functions_1.oneline(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                        The server could not locate a record for that ID."], ["\n                        The server could not locate a record for that ID."]))));
	                }
	                else if (msg.resultSet.length > 1) {
	                    _this.alerts.warn(functions_1.oneline(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                        The server found multiple records with that ID."], ["\n                        The server found multiple records with that ID."]))));
	                }
	                else {
	                    var result = msg.resultSet[0];
	                    _this.open(result, true).subscribe();
	                }
	            });
	        });
	    };
	    SearchService.prototype.vendorABC_navigateToHCBRecord = function (id) {
	        this.getByExternalID("healthcare benefits", id);
	    };
	    var SearchService_1;
	    SearchService.SavedSearchStorageKey = "saved_searches";
	    SearchService.HCB_EXTERNAL_ID_FIELD = "case identifier";
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Map)
	    ], SearchService.prototype, "rootByType", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], SearchService.prototype, "availableTypes", void 0);
	    __decorate([
	        decorators_1.disconnectValue(false),
	        __metadata("design:type", Boolean)
	    ], SearchService.prototype, "running", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Array)
	    ], SearchService.prototype, "results", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", String)
	    ], SearchService.prototype, "resultContextType", void 0);
	    __decorate([
	        decorators_1.disconnectValue(false),
	        __metadata("design:type", Boolean)
	    ], SearchService.prototype, "moreResultsAvailable", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Date)
	    ], SearchService.prototype, "queryTime", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Date)
	    ], SearchService.prototype, "resultTime", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Object)
	    ], SearchService.prototype, "lastResultOpened", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Number)
	    ], SearchService.prototype, "queryFetchSize", void 0);
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", ring_buffer_1.RingBuffer)
	    ], SearchService.prototype, "recentSearches", void 0);
	    __decorate([
	        decorators_1.disconnectWith("next", false),
	        __metadata("design:type", Rx_1.BehaviorSubject)
	    ], SearchService.prototype, "ready", void 0);
	    SearchService = SearchService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            subject_service_1.SubjectService,
	            storage_service_1.StorageService,
	            modal_service_1.ModalService])
	    ], SearchService);
	    return SearchService;
	}());
	exports.SearchService = SearchService;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var operators_1 = __webpack_require__(836);
	var SearchNode = (function () {
	    function SearchNode(name, data) {
	        var _this = this;
	        this.name = name;
	        this.parent = null;
	        this.children = [];
	        this.displayName = "";
	        this.operators = [];
	        this.createsValidSearch = false;
	        this.type = "string";
	        this.cardinality = 1;
	        this.value = null;
	        if (data) {
	            this.type = data.type;
	            this.restrictions = data.restrictions || [];
	            this.displayName = data.displayName || "";
	            this.operators = (data.validOperators || []).filter(function (op) { return operators_1.Operator.supports(op, data); });
	            var addlMagicOps = operators_1.MAGIC_FOR.get(data.type) || [];
	            addlMagicOps.forEach(function (a) { return _this.operators.push(a); });
	            this.createsValidSearch = data.createsValidSearch;
	        }
	    }
	    SearchNode.prototype.retrieve = function (path) {
	        if (path.length === 0) {
	            return this;
	        }
	        var child = this.children.find(function (node) {
	            return node.name === path[0];
	        });
	        if (child instanceof SearchNode) {
	            return child.retrieve(path.slice(1));
	        }
	        return null;
	    };
	    SearchNode.prototype.addChild = function (child) {
	        child.parent = this;
	        this.children.push(child);
	    };
	    Object.defineProperty(SearchNode.prototype, "filters", {
	        get: function () {
	            return this.children.filter(function (n) { return n instanceof FilterNode; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchNode.prototype, "paritions", {
	        get: function () {
	            return this.children.filter(function (n) { return n instanceof PartitionNode; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SearchNode.prototype.canSearchHere = function () {
	        return this.createsValidSearch;
	    };
	    SearchNode.prototype.generateFlatOptions = function (ancestors) {
	        var result = [];
	        var toHere = ancestors.slice(0).concat([this]);
	        if (this.canSearchHere()) {
	            result.push(toHere);
	        }
	        this.children.sort(compareNodeNames).forEach(function (n) {
	            result = result.concat(n.generateFlatOptions(toHere));
	        });
	        return result;
	    };
	    return SearchNode;
	}());
	exports.SearchNode = SearchNode;
	function compareNodeNames(a, b) {
	    return a.name.localeCompare(b.name);
	}
	var FIXED_NAMES = new Map([
	    ["name short3x3", -50],
	    ["last name", -25],
	    ["first name", -20]
	]);
	function nameValue(name) {
	    var lc = name.toLocaleLowerCase();
	    if (FIXED_NAMES.has(lc)) {
	        return FIXED_NAMES.get(lc);
	    }
	    if (lc.indexOf("ir ") === 0) {
	        return 10;
	    }
	    return 0;
	}
	var SearchRoot = (function (_super) {
	    __extends(SearchRoot, _super);
	    function SearchRoot() {
	        return _super.call(this, "\u00ABroot\u00BB", null) || this;
	    }
	    SearchRoot.fromMessage = function (msgNode) {
	        var root = new SearchRoot();
	        msgNode.forEach(function (n) {
	            return root.addChild(PartitionNode.fromMessage(n));
	        });
	        root.children.sort(function (a, b) {
	            return nameValue(a.name) - nameValue(b.name);
	        });
	        return root;
	    };
	    SearchRoot.EMPTY = new SearchRoot();
	    return SearchRoot;
	}(SearchNode));
	exports.SearchRoot = SearchRoot;
	var PartitionNode = (function (_super) {
	    __extends(PartitionNode, _super);
	    function PartitionNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PartitionNode.fromMessage = function (msgNode) {
	        var node = new PartitionNode(msgNode.name, msgNode);
	        msgNode.keys.filterKeys.forEach(function (n) {
	            return node.addChild(FilterNode.fromMessage(n));
	        });
	        msgNode.keys.searchKeys.forEach(function (n) {
	            return node.addChild(PartitionNode.fromMessage(n));
	        });
	        return node;
	    };
	    return PartitionNode;
	}(SearchNode));
	exports.PartitionNode = PartitionNode;
	var FilterNode = (function (_super) {
	    __extends(FilterNode, _super);
	    function FilterNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FilterNode.fromMessage = function (msgNode) {
	        var node = new FilterNode(msgNode.name, msgNode);
	        msgNode.keys.filterKeys.forEach(function (n) {
	            return node.addChild(FilterNode.fromMessage(n));
	        });
	        return node;
	    };
	    return FilterNode;
	}(SearchNode));
	exports.FilterNode = FilterNode;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(70);
	function isInequality(op) {
	    return [">", "<", "≥", "≤"].indexOf(op) > -1;
	}
	exports.isInequality = isInequality;
	var DATE_OP_NAMES = new Map([
	    ["=", "on"],
	    [">", "after"],
	    ["≥", "on or after"],
	    ["<", "before"],
	    ["≤", "before or on"]
	]);
	var STRING_OP_NAMES = new Map([
	    ["=", "is exactly"],
	    [">", "alphabetically after"],
	    ["<", "alphabetically before"]
	]);
	var OPERATOR_LABELS = new Map();
	OPERATOR_LABELS.set("date", DATE_OP_NAMES);
	OPERATOR_LABELS.set("string", STRING_OP_NAMES);
	var Operator = (function () {
	    function Operator() {
	    }
	    Operator.supports = function (op, data) {
	        if (op === Operator.EQUALS) {
	            return true;
	        }
	        if (isInequality(op) &&
	            (!data.restrictions || data.restrictions.length === 0)) {
	            return true;
	        }
	        return false;
	    };
	    Operator.labelFor = function (op, data) {
	        if (op instanceof MagicOperator) {
	            return op.label;
	        }
	        var interimMap = OPERATOR_LABELS.get(data.type);
	        if (interimMap && interimMap.has(op)) {
	            return interimMap.get(op);
	        }
	        return op;
	    };
	    Operator.EQUALS = "=";
	    Operator.GREATER_THAN = ">";
	    Operator.LESS_THAN = "<";
	    Operator.GREATER_THAN_OR_EQUAL = "≥";
	    Operator.LESS_THAN_OR_EQUAL = "≤";
	    Operator.IN = "in";
	    return Operator;
	}());
	exports.Operator = Operator;
	var MagicOperator = (function (_super) {
	    __extends(MagicOperator, _super);
	    function MagicOperator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return MagicOperator;
	}(Operator));
	exports.MagicOperator = MagicOperator;
	var PastXDays = (function (_super) {
	    __extends(PastXDays, _super);
	    function PastXDays() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "pastXdays";
	        _this.label = "past X calendar days";
	        _this.filterType = "date";
	        _this.argumentType = "whole number";
	        return _this;
	    }
	    PastXDays.prototype.transform = function (name, days) {
	        return {
	            name: name,
	            operator: "≥",
	            value: this.daysAgo(days),
	            magicSource: [this, days]
	        };
	    };
	    PastXDays.prototype.daysAgo = function (x) {
	        if (!Number.isSafeInteger(x)) {
	            throw new Error("PastXDays received non-integer argument!");
	        }
	        return moment().subtract(x, "days").utc().startOf("day").toDate();
	    };
	    PastXDays.SoleInstance = new PastXDays();
	    return PastXDays;
	}(MagicOperator));
	exports.PastXDays = PastXDays;
	exports.MAGIC_FOR = new Map([
	    ["date", [PastXDays.SoleInstance]]
	]);
	exports.MAGIC_OPS_BY_NAME = new Map([
	    [PastXDays.name, PastXDays.SoleInstance]
	]);


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var Rx_1 = __webpack_require__(214);
	var ModalService = (function () {
	    function ModalService(modalProvider) {
	        this.modalProvider = modalProvider;
	    }
	    ModalService.prototype.open = function (componentClass, configuration) {
	        if (configuration === void 0) { configuration = {}; }
	        return this.modalProvider.open(componentClass, angular2_modal_1.overlayConfigFactory(configuration, bootstrap_1.BSModalContext));
	    };
	    ModalService.prototype.display = function (componentClass, configuration) {
	        if (configuration === void 0) { configuration = {}; }
	        var promise = this.open(componentClass, configuration).then(function (dr) { return dr.close.bind(dr); });
	        return Rx_1.Observable.fromPromise(promise);
	    };
	    ModalService.prototype.observe = function (componentClass, configuration) {
	        var _this = this;
	        if (configuration === void 0) { configuration = {}; }
	        return Rx_1.Observable.create(function (o) {
	            _this.open(componentClass, configuration).then(function (dialog) {
	                dialog.result.then(function (result) {
	                    o.next(result);
	                    o.complete();
	                }, function () {
	                    if ("dismissValue" in configuration) {
	                        o.next(configuration.dismissValue);
	                    }
	                    o.complete();
	                });
	            });
	        });
	    };
	    ModalService.prototype.buildConfirmation = function (context) {
	        var d = this.modalProvider.confirm()
	            .title(context.title)
	            .body(context.body);
	        if (context.yesLabel) {
	            d.okBtn(context.yesLabel);
	        }
	        if (context.cancelLabel) {
	            d.cancelBtn(context.cancelLabel);
	        }
	        if (context.noLabel) {
	            d.addButton("btn btn-warning", context.noLabel, function (cmp) { return cmp.dialog.close(false); });
	        }
	        return d.open();
	    };
	    ModalService.prototype.confirm = function (context) {
	        var _this = this;
	        return Rx_1.Observable.create(function (o) {
	            var modalPromise = _this.buildConfirmation(context);
	            modalPromise.then(function (dialog) {
	                dialog.result.then(function (result) {
	                    o.next(result);
	                    o.complete();
	                }, function () {
	                    if ("dismissValue" in context) {
	                        o.next(context.dismissValue);
	                    }
	                    o.complete();
	                });
	            });
	        });
	    };
	    ModalService.prototype.alert = function (msg) {
	        var context = (typeof msg === "string")
	            ? { title: "Warning", body: msg }
	            : msg;
	        this.modalProvider.alert().body(context.body).title(context.title).open();
	    };
	    ModalService.prototype.stringPrompt = function (context) {
	        var _this = this;
	        return Rx_1.Observable.create(function (o) {
	            var modalPromise = _this.modalProvider.prompt()
	                .title(context.title)
	                .body(context.body)
	                .placeholder(context.placeholder)
	                .defaultValue(context.initialValue || "")
	                .open();
	            modalPromise.then(function (dialog) {
	                dialog.result.then(function (result) {
	                    if (context.acceptEmptyResult === true ||
	                        (typeof result === "string" && result.length > 0)) {
	                        o.next(result);
	                    }
	                    o.complete();
	                }, function () {
	                    o.complete();
	                });
	            });
	        });
	    };
	    ModalService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [bootstrap_1.Modal])
	    ], ModalService);
	    return ModalService;
	}());
	exports.ModalService = ModalService;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var router_1 = __webpack_require__(41);
	var Rx_1 = __webpack_require__(214);
	var user_service_1 = __webpack_require__(713);
	var alert_service_1 = __webpack_require__(689);
	var context_management_1 = __webpack_require__(604);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var chat_panel_component_1 = __webpack_require__(839);
	var comment_service_1 = __webpack_require__(212);
	var export_modal_component_1 = __webpack_require__(840);
	var referral_modal_component_1 = __webpack_require__(841);
	var algorithm_service_1 = __webpack_require__(213);
	var intake_step_service_1 = __webpack_require__(751);
	var watchlist_service_1 = __webpack_require__(842);
	var setting_service_1 = __webpack_require__(690);
	var report_step_service_1 = __webpack_require__(849);
	var search_service_1 = __webpack_require__(834);
	var modal_service_1 = __webpack_require__(837);
	var add_reminder_modal_component_1 = __webpack_require__(851);
	var SAVE_NEEDED_MODAL = function (dirties, commentChanges) { return ({
	    title: "Save subject data?",
	    yesLabel: "Save & Continue",
	    noLabel: "Stay",
	    cancelLabel: "Leave anyway",
	    body: "\n    <p>\n      It looks like you may have entered data since the last save. (This could\n      include changes you have made to comments.)\n    </p>\n    <p>\n      If you leave this page, unsaved data will be lost.\n      Would you like to save?\n    </p>\n    <hr>\n    <label>\n    These values appear to be different from the last database version:\n    </label>\n    <ul>\n    " + dirties.map(function (_a) {
	        var name = _a[0];
	        return "<li>" + name + "</li>";
	    }).join("\n") + "\n    " + (commentChanges ? "<li><em>(1 or more comments)</em></li>" : "") + "\n    </ul>"
	}); };
	var BROWSER_SAVE_NEEDED_MESSAGE = "\n  It looks like you may have entered data since the last save. (This could\n  include changes you have made to comments.)\n\n  Are you sure you want to leave?\n";
	var REQUIRED_STEPS_MODAL = {
	    title: "Required steps not complete",
	    body: "You must fill out all of the required steps before saving!"
	};
	var LEAVING_UNSAVABLE_MODAL = {
	    title: "Required steps not complete",
	    body: "If you leave, this subject will not be saved. (You cannot save\n        until you enter all of the required steps.)",
	    yesLabel: "Stay & edit",
	    cancelLabel: "Leave anyway",
	    dismissValue: false
	};
	var MAG_ICON = "<span class=\"glyphicon glyphicon-search\"><span>";
	var RETRIEVABILITY_MODAL = {
	    title: "Subject would not be retrievable!",
	    body: "Since you haven't completed enough of the search index steps\n        (marked with a <kbd>" + MAG_ICON + "</kbd>), this record would not be\n        retrievable through all searches. Would you like to save anyway?"
	};
	var INCOMPLETE_COMMENTS_MODAL = {
	    title: "Unsubmitted comment changes",
	    body: "Some of your comments hadn't yet been sent to the server when you\n        tried to leave. To ensure they were successfully submitted, it may be\n        necessary to wait a moment and save again.\n        <br><br>\n        <em>\n        (If you see this message repeatedly, please report it as an issue.)\n        </em>",
	    yesLabel: "Stay & edit",
	    cancelLabel: "Leave anyway",
	    dismissValue: false
	};
	var IntakeFormComponent = (function () {
	    function IntakeFormComponent(router, route, messaging, subjects, intakeSteps, reportSteps, comments, alerts, modals, watchlist, algorithms, users, element, settings, search) {
	        this.router = router;
	        this.route = route;
	        this.messaging = messaging;
	        this.subjects = subjects;
	        this.intakeSteps = intakeSteps;
	        this.reportSteps = reportSteps;
	        this.comments = comments;
	        this.alerts = alerts;
	        this.modals = modals;
	        this.watchlist = watchlist;
	        this.algorithms = algorithms;
	        this.users = users;
	        this.element = element;
	        this.settings = settings;
	        this.search = search;
	        this.useSidebar = false;
	        this.useReturnHome = true;
	        this.useFCWIButtons_DEBUG = false;
	        this.objectId = -1;
	        this.sidebarOpen = false;
	        this.paramNavSub = new Rx_1.Subscription();
	        this.paramNavWindow = 1000;
	        this.algSwitcher = new forms_1.FormControl();
	        this.saveRequested = false;
	        this.saveRequestTime = -1;
	        this.scrollUpdating = false;
	        this.actionSelection = new forms_1.FormControl(null);
	    }
	    IntakeFormComponent.prototype.ngOnInit = function () {
	        this.algorithms.lock(this);
	        this.algorithm = this.algorithms.running;
	        this.title =
	            this.algorithm.displayName || "Intake Form";
	        this.form = new forms_1.FormGroup({});
	        console.log("▼▼▼▼▼ form initialized ▼▼▼▼▼▼");
	        window.intake = this.form;
	        console.info(" (available as window.intake) ");
	        this.objectId = this.algorithms.running.subject.id;
	        this.resummarizeIfWatched();
	        this.algSwitcher.reset();
	        window.scrollTo(0, 0);
	        this.useSidebar =
	            ["a-tlc", "a-first-check-wi"].indexOf(this.algorithm.name) < 0;
	        this.useReturnHome =
	            ["a-tlc"].indexOf(this.algorithm.name) >= 0;
	        this.useFCWIButtons_DEBUG =
	            "a-first-check-wi" === this.algorithm.name;
	    };
	    IntakeFormComponent.prototype.ngOnDestroy = function () {
	        console.log("▲▲▲▲▲ form destroyed ▲▲▲▲▲");
	    };
	    IntakeFormComponent.prototype.canLeave = function () {
	        return this.canAbandonSubject();
	    };
	    IntakeFormComponent.prototype.canAbandonSubject = function () {
	        var _this = this;
	        if (this.form.dirty || this.comments.changesSinceSave) {
	            if (!this.requiredStepsComplete()) {
	                this.modals.confirm(LEAVING_UNSAVABLE_MODAL).map(function (stay) { return !stay; });
	            }
	            var dirties = Object.entries(this.form.controls).filter(function (_a) {
	                var name = _a[0], ctrl = _a[1];
	                return ctrl.dirty;
	            });
	            return this.modals.confirm(SAVE_NEEDED_MODAL(dirties, this.comments.changesSinceSave)).flatMap(function (saveCommand) {
	                return saveCommand
	                    ? _this.saveSubject()
	                    : Rx_1.Observable.of(false);
	            }).defaultIfEmpty(true);
	        }
	        if (this.comments.hasUnsubmittedContent()) {
	            this.modals.confirm(INCOMPLETE_COMMENTS_MODAL)
	                .map(function (stay) { return !stay; });
	        }
	        console.info("leaving SC: no dirty content, so no save");
	        return Rx_1.Observable.of(true);
	    };
	    IntakeFormComponent.prototype.requiredStepsComplete = function () {
	        return true;
	    };
	    IntakeFormComponent.prototype.trySaveSubject = function (depart) {
	        var _this = this;
	        if (depart === void 0) { depart = false; }
	        if (!this.requiredStepsComplete()) {
	            this.modals.alert(REQUIRED_STEPS_MODAL);
	            return Rx_1.Observable.empty();
	        }
	        this.saveRequested = true;
	        this.saveRequestTime = Date.now();
	        var saveResult = this.saveSubject();
	        saveResult.subscribe(function (saved) {
	            if (saved) {
	                _this.form.markAsPristine();
	                _this.comments.resetChangeFlag();
	                _this.alerts.success("The record has been saved.");
	                _this.saveRequested = false;
	                if (depart) {
	                    _this.router.navigate(["/home"]);
	                }
	            }
	        });
	        return saveResult;
	    };
	    IntakeFormComponent.prototype.saveSubject = function (force) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        return this.algorithm.save(force).flatMap(function (code) {
	            if (code === general_1.ResponseCode.OK) {
	                var ref = _this.algorithm.subject.findRef("watch");
	                if (!ref) {
	                    var autoWatch = _this.settings.get("subscribe after save");
	                    if (autoWatch) {
	                        _this.watchlist.watchRunningSubject().subscribe();
	                    }
	                }
	                else {
	                    _this.resummarize(ref.id);
	                }
	                return [true];
	            }
	            else if (code === general_1.ResponseCode.Irretrievable) {
	                _this.modals.confirm(RETRIEVABILITY_MODAL)
	                    .flatMap(function (saveHard) {
	                    if (saveHard) {
	                        return _this.saveSubject(true);
	                    }
	                    return [false];
	                });
	            }
	            else {
	                _this.alerts.warn("The subject could not be saved: " + general_1.GENERIC_REASON_TEXT.get(code));
	                return [false];
	            }
	        });
	    };
	    IntakeFormComponent.prototype.tryDuplicate = function () {
	        this.subjects.launchDuplicate(this.algorithm.algorithm);
	    };
	    IntakeFormComponent.prototype.resummarize = function (watchId) {
	        this.watchlist.resummarize({ watchId: watchId }).subscribe();
	    };
	    IntakeFormComponent.prototype.resummarizeIfWatched = function () {
	        var ref = this.algorithm.subject.findRef("watch");
	        if (ref) {
	            this.resummarize(ref.id);
	        }
	    };
	    IntakeFormComponent.prototype.unload = function (event) {
	        if ((this.form.dirty || this.comments.changesSinceSave)) {
	            event.returnValue = BROWSER_SAVE_NEEDED_MESSAGE;
	            return;
	        }
	    };
	    IntakeFormComponent.prototype.scroll = function (event) {
	        var _this = this;
	        if (!this.scrollUpdating && this.useSidebar) {
	            var headerHeight = Math.max(0, 52 - window.scrollY);
	            var stickyTop = headerHeight + "px";
	            var stickyHeight = "calc(100vh - " + headerHeight + "px)";
	            if (this.sidebarRef.nativeElement.style.top !== stickyHeight) {
	                this.scrollUpdating = true;
	                this.sidebarRef.nativeElement.style.top = stickyTop;
	                this.sidebarRef.nativeElement.style.height = stickyHeight;
	                window.requestAnimationFrame(function () { return _this.scrollUpdating = false; });
	            }
	        }
	    };
	    IntakeFormComponent.prototype.save = function () {
	        throw new Error("UNIMPLEMENTED - PARTIAL INTERFACE COMPLIANCES");
	    };
	    IntakeFormComponent.prototype.showLinkedReminderModal = function () {
	        var _this = this;
	        this.modals.observe(add_reminder_modal_component_1.AddReminderModalComponent, { size: "md", hasImpliedLink: true }).subscribe(function (r) {
	            if (r) {
	                _this.watchlist.addReminder(r.summary, r.triggerTime, r.linkedRecord ? _this.objectId : undefined).subscribe();
	            }
	        });
	    };
	    IntakeFormComponent.prototype.advancedAction = function (e) {
	        switch (e.target.value) {
	            case "refer":
	                this.openReferralModal();
	                break;
	            case "export":
	                this.openExportModal();
	                break;
	            case "import":
	                this.openImportModal();
	                break;
	            default:
	                console.error("Unknown action from target", e.target);
	        }
	        e.target.value = null;
	    };
	    IntakeFormComponent.prototype.openReferralModal = function () {
	        var _this = this;
	        this.modals.observe(referral_modal_component_1.ReferralModalComponent)
	            .flatMap(function (referralMsg) {
	            if (!referralMsg) {
	                return [false];
	            }
	            return _this.messaging.resultOf(new context_management_1.ReferSubjectContextRequest(_this.algorithm.subject.id, referralMsg));
	        }).subscribe(function (referred) {
	            if (referred) {
	                _this.alerts.success("The subject has been referred!");
	            }
	        });
	    };
	    IntakeFormComponent.prototype.openExportModal = function () {
	        this.modals.display(export_modal_component_1.ExportModalComponent, {
	            steps: this.intakeSteps.all(),
	            algorithm: this.algorithm.name,
	            type: this.algorithm.subject.type
	        });
	    };
	    IntakeFormComponent.prototype.openImportModal = function () {
	        alert("Error: you don't have permission to perform that action!");
	    };
	    IntakeFormComponent.prototype.saveFromKeyPress = function (ev) {
	        var _this = this;
	        if (document.activeElement instanceof HTMLElement) {
	            document.activeElement.blur();
	            requestAnimationFrame(function () { return _this.trySaveSubject(); });
	        }
	        else {
	            this.trySaveSubject();
	        }
	        ev.preventDefault();
	    };
	    IntakeFormComponent.prototype.focusChat = function () {
	        this.chatRef.externalFocalize();
	    };
	    IntakeFormComponent.prototype.scrollToTop = function () {
	        document.scrollingElement.scrollTo({ top: 0 });
	    };
	    IntakeFormComponent.prototype.switchToAlg = function () {
	        if (this.algSwitcher.value) {
	            this.algorithms.open(this.algSwitcher.value, this.algorithm.subject);
	        }
	    };
	    IntakeFormComponent.prototype.openNextSearchResult = function () {
	        if (this.algorithm && this.algorithm.subject) {
	            var searchRef_1 = this.algorithm.subject.findRef("search");
	            var i = this.search.results.findIndex(function (r) { return r.recordId === searchRef_1.id; });
	            if (i > -1) {
	                if (i === this.search.results.length - 1) {
	                    return alert("You are already at the last search result.");
	                }
	                var target = this.algorithms.defaultForOpen(this.algorithm.subject.type);
	                this.search.open(this.search.results[i + 1], true, target).subscribe();
	                return;
	            }
	        }
	        alert("Could not find the next search result!" +
	            "DEVELOPMENT: Check the result identifier set-up.");
	    };
	    IntakeFormComponent.prototype.substitutionMacro = function (e) {
	        if (e.key === ">") {
	            if (document.activeElement instanceof HTMLTextAreaElement) {
	                var pos = document.activeElement.selectionStart;
	                var str = document.activeElement.value;
	                console.error("[" + pos + "] " + str);
	                console.error(/[^ ]*>/.exec(str.substr(0, pos)));
	            }
	        }
	    };
	    IntakeFormComponent.prototype.printPage = function () {
	        console.log(window);
	        window.print();
	    };
	    __decorate([
	        core_1.HostListener("window:beforeunload", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [BeforeUnloadEvent]),
	        __metadata("design:returntype", void 0)
	    ], IntakeFormComponent.prototype, "unload", null);
	    __decorate([
	        core_1.ViewChild("sidebar"),
	        __metadata("design:type", core_1.ElementRef)
	    ], IntakeFormComponent.prototype, "sidebarRef", void 0);
	    __decorate([
	        core_1.HostListener("document:keydown.control.s", ["$event"]),
	        core_1.HostListener("document:keydown.meta.s", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], IntakeFormComponent.prototype, "saveFromKeyPress", null);
	    __decorate([
	        core_1.ViewChild(chat_panel_component_1.ChatPanelComponent),
	        __metadata("design:type", chat_panel_component_1.ChatPanelComponent)
	    ], IntakeFormComponent.prototype, "chatRef", void 0);
	    __decorate([
	        core_1.HostListener("document:keydown.control.Enter"),
	        core_1.HostListener("document:keydown.meta.Enter"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], IntakeFormComponent.prototype, "focusChat", null);
	    IntakeFormComponent = __decorate([
	        core_1.Component({
	            selector: "coverage-form",
	            template: "\n    <div class=\"form-flow\" [class.fullwidth]=\"!useSidebar\">\n    <div class=\"row\">\n      <div\n      [class.col-sm-8]=\"useSidebar\"\n      [class.defocus]=\"sidebarOpen\"\n      class=\"question-column\">\n        <!-- header -->\n        <!-- <span class=\"debug-only\">lastRefURL: {{algorithm?.subject?.lastRefURL}}</span> -->\n        <a\n          *ngIf=\"algorithm?.subject?.newlyCreated !== true && !algorithm?.subject?.lastRefURL\"\n          class=\"nonprint\"\n          [routerLink]=\"['/subject', objectId]\">\n          &lt; back to summary\n        </a>\n        <a\n          *ngIf=\"algorithm?.subject?.newlyCreated !== true && algorithm?.subject?.lastRefURL\"\n          class=\"nonprint\"\n          [routerLink]=\"algorithm?.subject?.lastRefURL\">\n          &lt; back to worklist\n        </a>\n        <a\n          *ngIf=\"algorithm?.subject?.lastRefType == 'search'\"\n          class=\"pull-right text-warning\"\n          (click)=\"openNextSearchResult()\">\n          open next search result &gt;\n        </a>\n        <!-- <span class=\"badge\" style=\"opacity: 40%\">{{algorithm?.subject?.lastRefType}}</span> -->\n        <h2\n          class=\"intake-header\"\n          [class.has-comment]=\"algorithm?.subject?.comments.length > 0\">\n          {{title}}\n          <small\n            class=\"subject-timestamp\"\n            [title]=\"algorithm?.subject?.created | date : 'medium'\">\n            created {{algorithm?.subject?.created | date}}\n          </small>\n\n          <!-- comment list opener -->\n          <a\n            (click)=\"menu.open = menu.open ? false : true\" class=\"menu-button comment-crumb\">\n            <span class=\"glyphicon glyphicon-comment\"></span>\n            <span class=\"badge\">\n              {{algorithm?.subject?.comments.length || 0}}\n            </span>\n          </a>\n        </h2>\n\n        <!-- comments directly on the subject context itself -->\n        <div class=\"menu\" #menu [class.open]=\"menu?.open\">\n            <comment-list\n              [comments]=\"algorithm?.subject?.comments\"\n              [parent]=\"algorithm?.subject\">\n            </comment-list>\n        </div>\n\n        <quick-links></quick-links>\n\n        <!-- the actual intake step list (the form body) -->\n        <intake-step-list [form]=\"form\" (keyup)=\"substitutionMacro($event)\" [ngClass]=\"algorithm?.name || 'a-NONE'\"></intake-step-list>\n\n        <div class=\"end-buttons w100\">\n          <div [class.col-sm-6]=\"useReturnHome\" [class.col-sm-4]=\"useFCWIButtons_DEBUG\">\n            <button\n              (click)=\"scrollToTop()\"\n              class=\"form-control btn btn-default\">\n              <span class=\"glyphicon glyphicon-arrow-up\"></span>\n              Return to Top\n            </button>\n          </div>\n          <div *ngIf=\"useReturnHome\" class=\"col-sm-6\">\n            <button\n              (click)=\"trySaveSubject(true)\"\n              class=\"form-control btn btn-success\">\n              <span class=\"glyphicon glyphicon-floppy-disk\"></span>\n              Submit Form and Return Home\n            </button>\n          </div>\n          <div *ngIf=\"useFCWIButtons_DEBUG\" class=\"col-sm-4\">\n            <button\n              (click)=\"printPage()\"\n              class=\"form-control btn btn-primary\">\n              <span class=\"glyphicon glyphicon-print\"></span>\n              Print Your Results\n            </button>\n          </div>\n          <div *ngIf=\"useFCWIButtons_DEBUG\" class=\"col-sm-4\">\n            <a\n              href=\"https://forms.gle/KdxGVAvUuhTvCxj8A\"\n              title=\"This will open a survey about your experience with FirstCheck WI\"\n              target=\"_blank\"\n              class=\"form-control btn btn-warning\">\n              <span class=\"glyphicon glyphicon glyphicon-list-alt\"></span>\n              Take Survey\n            </a>\n          </div>\n        </div>\n      </div>\n\n      <div *ngIf=\"sidebarOpen\" class=\"backdrop\" (click)=\"sidebarOpen = false\">\n      </div>\n      <!-- SIDEBAR CONTENT -->\n      <div *ngIf=\"useSidebar\" class=\"details-bar\" [class.in]=\"sidebarOpen\">\n        <button\n          class=\"btn btn-default toggle visible-xs-inline-block nonprint\"\n          (click)=\"sidebarOpen = !sidebarOpen\">\n          {{ sidebarOpen ? \"Close Actions\" : \"Actions Menu\" }}\n        </button>\n        <div class=\"contents\">\n          <div class=\"row\">\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <button\n              (click)=\"trySaveSubject()\"\n              class=\"btn btn-success \"\n              [disabled]=\"saveRequested\">\n              <span class=\"glyphicon glyphicon-floppy-disk pull-left\"></span>\n              Save <!-- TODO: progress indication -->\n            </button>\n          </div>\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <button\n              (click)=\"tryDuplicate()\"\n              class=\"btn btn-default \"\n              [disabled]=\"false\">\n              <span class=\"glyphicon glyphicon-duplicate pull-left\"></span>\n              Duplicate\n            </button>\n          </div>\n          </div>\n          <div class=\"row\">\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <watch-button\n              [subject]=\"algorithm?.subject\"\n              [disabled]=\"algorithm?.subject?.newlyCreated\">\n            </watch-button>\n          </div>\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <button\n              (click)=\"showLinkedReminderModal()\"\n              class=\"btn btn-default\"\n              [disabled]=\"false\">\n              <span class=\"glyphicon glyphicon-calendar pull-left\"></span>\n              Reminder...\n            </button>\n          </div>\n          </div>\n          <div class=\"row\">\n          <!-- <div class=\"quick-action-button\">\n            <select\n              class=\"form-control\"\n              [formControl]=\"actionSelection\"\n              (change)=\"advancedAction($event)\">\n              <option [ngValue]=\"null\" disabled>\u2014 Advanced Actions \u2014</option>\n              <option\n                [disabled]=\"algorithm?.subject?.newlyCreated\"\n                value=\"refer\">\n                Refer to {{algorithms.referralOrganization}}...\n              </option>\n              <option disabled>\n                Change Group Visibility...\n              </option>\n              <option disabled>\n                Request Deletion...\n              </option>\n              <option value=\"export\">\n                Export to File...\n              </option>\n              <option value=\"import\">\n                Import from File...\n              </option>\n            </select>\n          </div> -->\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <button\n              class=\"btn btn-danger \"\n              [disabled]=\"true\">\n              <span class=\"glyphicon glyphicon-trash pull-left\"></span>\n              Request Deletion\n            </button>\n          </div>\n          <div class=\"quick-action-button col-xs-12 col-md-6\">\n            <select\n              class=\"form-control\"\n              [formControl]=\"algSwitcher\"\n              (change)=\"switchToAlg()\">\n              <option [ngValue]=\"null\" disabled>Switch view...</option>\n              <option\n                *ngFor=\"let alg of algorithms.bySCType(algorithm.algorithm.contextType)\"\n                [disabled]=\"alg == algorithm.algorithm\"\n                [ngValue]=\"alg\">\n                {{alg.displayName}}\n              </option>\n            </select>\n          </div>\n          </div>\n          <collaborator-panel\n            openOnChanges=\"true\"\n            startOpen=\"false\">\n          </collaborator-panel>\n          <chat-panel #chat></chat-panel>\n          <report-panel></report-panel>\n          <relationship-panel [subject]=\"algorithm.subject\">\n          </relationship-panel>\n        </div>\n      </div>\n    </div> <!-- / .row -->\n    </div> <!-- / .form-flow -->\n",
	            styles: [
	                ".form-flow {\n      /* padding-left: 8%; */\n      max-width: 1500px;\n      margin: auto 30px;\n    }\n    /deep/ .a-first-check-wi .form-flow {\n      max-width: 800px;\n      /* padding-left: 0%; */\n      margin: auto;\n    }",
	                ".question-column { padding-left: 50px; }",
	                ".details-bar {\n      position: sticky;\n      z-index: 10;\n      /* right: 5px; */\n      top: 52px;\n      /* will-change: top; */\n      padding-top: 20px;\n      /* width: 29.7%; */\n      height: calc(100vh - 52px);\n        /* 95vh = a rough approximation for most cases */\n      overflow-y: auto; /* TODO: scrollbar ends look weird without \"caps\" */\n      overflow-x: hidden;\n    }\n    .details-bar .btn {\n      width: 100%;\n      margin-bottom: 20px;\n    }\n    @media screen and (max-width: 768px)\n    {\n      .details-bar {\n        right: 10px;\n        width: 300px;\n        overflow-y: hidden;\n        max-width: 100%;\n      }\n      .details-bar:not(.in) {\n        max-height: 55px;\n      }\n      .details-bar .contents  {\n        display: none;\n      }\n      .details-bar.in .contents {\n        display: block;\n      }\n    }\n    .defocus {\n      filter: blur(5px);\n    }\n    .backdrop {\n      position: absolute;\n      top: -15px;\n      left: 0;\n      width: 100%;\n      height: 120%;\n      background: rgba(0,0,0,0.2);\n    }",
	                "\n    .intake-header {\n      position: relative;\n      margin-top: 5px;\n    }\n    .subject-timestamp {\n      position: absolute;\n      bottom: 0px;\n      right: 0px;\n    }\n    .menu-button {\n      display: block;\n      position: absolute;\n      font-size: 18px;\n      left: -40px;\n      top: 0px;\n      width: 20px;\n      height: 100%;\n      text-align: center;\n      opacity: 0;\n      transition: opacity 0.4s;\n    }\n    .intake-header.has-comment .glyphicon-comment {\n      color: #3c763d; /* text-success color TODO: non-magic ref? */\n    }\n    .intake-header:hover .menu-button,\n    .intake-header.has-comment .menu-button {\n      opacity: 1;\n    }\n    .menu {\n      max-height: 0px;\n      opacity: 0;\n      overflow-y: hidden;\n      transition: max-height 0.8s, opacity 0.8s;\n      padding-left: 1em;\n      border-left: 1px solid gray;\n    }\n    .menu.open {\n      max-height: 1600px;\n      opacity: 1;\n\t}\n\t.end-buttons {\n\t\tmargin-top: 2em;\n  }\n  .end-buttons \n  .quick-action-button {\n    display: inline-block;\n    width: 49%;\n    vertical-align: top;\n  }\n  .quick-action-button select {\n    margin-bottom: 20px;\n  }\n  .btn .glyphicon {\n    line-height: 20px;\n  }\n  "
	            ],
	            providers: []
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            router_1.ActivatedRoute,
	            messaging_service_1.MessagingService,
	            subject_service_1.SubjectService,
	            intake_step_service_1.IntakeStepService,
	            report_step_service_1.ReportStepService,
	            comment_service_1.CommentService,
	            alert_service_1.AlertService,
	            modal_service_1.ModalService,
	            watchlist_service_1.WatchlistService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService,
	            core_1.ElementRef,
	            setting_service_1.SettingService,
	            search_service_1.SearchService])
	    ], IntakeFormComponent);
	    return IntakeFormComponent;
	}());
	exports.IntakeFormComponent = IntakeFormComponent;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var collaboration_service_1 = __webpack_require__(750);
	var ChatPanelComponent = (function () {
	    function ChatPanelComponent(collaboration) {
	        this.collaboration = collaboration;
	        this.openOnChanges = false;
	        this.panelOpen = this.startOpen || false;
	        this.scrollDelay = 100;
	        this.newChat = new forms_1.FormControl("", forms_1.Validators.required);
	        this.form = new forms_1.FormGroup({ newChat: this.newChat });
	        this.readCount = 0;
	    }
	    Object.defineProperty(ChatPanelComponent.prototype, "unreadCount", {
	        get: function () {
	            return Math.max(0, this.collaboration.chatMessages.length - this.readCount);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ChatPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.collaboration.chatPokes.delay(this.scrollDelay).subscribe(function () { return _this.scrollToBottom(); });
	    };
	    ChatPanelComponent.prototype.sendChat = function () {
	        var _this = this;
	        if (this.newChat.valid) {
	            this.updateReadCount();
	            var chat = this.newChat.value;
	            this.collaboration.sendChat(chat).subscribe(function (sent) {
	                _this.updateReadCount();
	                setTimeout(function () { return _this.scrollToBottom(); }, _this.scrollDelay);
	                if (sent) {
	                    _this.newChat.reset("");
	                }
	                else {
	                    throw new Error("Could not send chat!");
	                }
	            });
	        }
	        else {
	            console.warn("Attempted to send empty chat!");
	        }
	    };
	    ChatPanelComponent.prototype.updateReadCount = function () {
	        this.readCount = this.collaboration.chatMessages.length;
	    };
	    ChatPanelComponent.prototype.scrollToBottom = function () {
	        this.chatWindowRef.nativeElement.scrollTop =
	            this.chatWindowRef.nativeElement.scrollHeight;
	    };
	    ChatPanelComponent.prototype.externalFocalize = function () {
	        var _this = this;
	        this.panelOpen = true;
	        setTimeout(function () { return _this.chatInput.nativeElement.focus(); }, 100);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ChatPanelComponent.prototype, "startOpen", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ChatPanelComponent.prototype, "openOnChanges", void 0);
	    __decorate([
	        core_1.ViewChild("chatWindow"),
	        __metadata("design:type", core_1.ElementRef)
	    ], ChatPanelComponent.prototype, "chatWindowRef", void 0);
	    __decorate([
	        core_1.ViewChild("chatInput"),
	        __metadata("design:type", core_1.ElementRef)
	    ], ChatPanelComponent.prototype, "chatInput", void 0);
	    ChatPanelComponent = __decorate([
	        core_1.Component({
	            selector: "chat-panel",
	            template: "\n  <div\n    class=\"panel panel-default fade\"\n    [class.in]=\"!hideWhenEmpty || users.length\"\n    (click)=\"updateReadCount()\">\n    <div class=\"panel-heading\" (click)=\"panelOpen = !panelOpen\">\n      <h3 class=\"panel-title\">\n        Chat\n        <span class=\"badge\">{{unreadCount || 0}} unread</span>\n      </h3>\n    </div>\n    <div class=\"panel-body collapse\" [class.in]=\"panelOpen\">\n      <div class=\"chat-window\" #chatWindow>\n        <p *ngFor=\"let chat of collaboration.chatMessages\" class=\"report\">\n          <strong>\n            {{chat.author}}\n            {{chat.group ? \"[\" + chat.group + \"]\" : \"\"}}\n            {{chat.action ? chat.action + \".\" : \":\"}}\n          </strong>\n          {{chat.message}}\n        </p>\n        <em\n          *ngIf=\"collaboration.chatMessages.length === 0\"\n          class=\"notification\">\n          No chats since you joined the session.\n        </em>\n        <em *ngIf=\"!collaboration.chatEnabled\" class=\"notification\">\n          Chat is unavailable.\n        </em>\n      </div>\n    </div>\n    <form [formGroup]=\"form\" class=\"collapse\" [class.in]=\"panelOpen\">\n      <div class=\"input-group new-chat\">\n        <input\n          #chatInput\n          type=\"text\"\n          class=\"form-control\"\n          formControlName=\"newChat\"\n          placeholder=\"Message...\">\n        <span class=\"input-group-btn\">\n          <button\n            class=\"btn btn-primary\"\n            (click)=\"sendChat()\">\n            Send\n          </button>\n        </span>\n      </div>\n    </form>\n  </div>\n",
	            styles: [
	                "\n    .panel-body {\n      padding: 0;\n    }\n    .chat-window {\n      height: 250px;\n      overflow-y: scroll;\n      position: relative;\n    }\n    .chat-window p {\n      padding-left: 5px;\n      padding-right: 2px;\n    }\n    .chat-window .notification {\n      text-align: center;\n      width: 100%;\n      position: absolute;\n      top: 120px;\n    }\n    form {\n      margin-left: -1px;\n      margin-right: -1px;\n    }\n    .new-chat input {\n      border-top-left-radius: 0;\n    }\n    .new-chat .btn {\n      border-top-right-radius: 0;\n    }\n    "
	            ]
	        }),
	        __metadata("design:paramtypes", [collaboration_service_1.CollaborationService])
	    ], ChatPanelComponent);
	    return ChatPanelComponent;
	}());
	exports.ChatPanelComponent = ChatPanelComponent;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var platform_browser_1 = __webpack_require__(21);
	var EXPORT_VERSION = 2;
	var JSON_HEADER = "data:text/json;charset=utf-8,";
	var ExportModalComponent = (function () {
	    function ExportModalComponent(dialog, sanitizer) {
	        this.dialog = dialog;
	        this.sanitizer = sanitizer;
	    }
	    ExportModalComponent.prototype.ngOnInit = function () {
	        var stepOutput = {};
	        var stepCount = 0;
	        this.dialog.context.steps.forEach(function (step) {
	            stepOutput[step.name] = step.value;
	            stepCount++;
	        });
	        var json = JSON.stringify({
	            version: EXPORT_VERSION,
	            type: this.dialog.context.type,
	            algorithm: this.dialog.context.algorithm,
	            stepCount: stepCount,
	            steps: stepOutput
	        });
	        this.data = this.sanitizer.bypassSecurityTrustUrl(JSON_HEADER + encodeURIComponent(json));
	    };
	    ExportModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Export Subject Data to File\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <h3 class=\"debug-only\">Caution!</h3>\n    <p>\n      This feature is currently <u>experimental</u> and should only be used in\n      case of emergency. The format used in these files is not yet stable, so\n      files you create now may not successfully import in the future!\n    </p>\n    <p>\n      <em>In addition,</em> these files contain unencrypted personal information\n      that can be easily read by humans. Treat the data with care (never send\n      them over the internet or leave them on an unlocked device) and fully\n      delete them as soon as you are done with them!\n    </p>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <a\n      type=\"button\"\n      class=\"btn btn-warning\"\n      [href]=\"data\"\n      download=\"export.json\">\n      Download\n    </a>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            platform_browser_1.DomSanitizer])
	    ], ExportModalComponent);
	    return ExportModalComponent;
	}());
	exports.ExportModalComponent = ExportModalComponent;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var ReferralModalComponent = (function () {
	    function ReferralModalComponent(dialog) {
	        this.dialog = dialog;
	    }
	    ReferralModalComponent.prototype.ngOnInit = function () {
	        this.note = new forms_1.FormControl("", forms_1.Validators.required);
	        this.form = new forms_1.FormGroup({ note: this.note });
	    };
	    ReferralModalComponent.prototype.submit = function () {
	        if (!this.note.valid) {
	            console.error("Validation error:", this.note.errors);
	            return;
	        }
	        this.dialog.close(this.note.value);
	    };
	    ReferralModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Refer Subject\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n      <div class=\"form-group\">\n        <label>\n          Enter a note or brief description for the receiving organization:\n        </label>\n        <textarea\n          autosize\n          [minimum]=\"54\"\n          class=\"form-control\"\n          [formControl]=\"note\">\n        </textarea>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"submit()\">\n      Submit\n    </button>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], ReferralModalComponent);
	    return ReferralModalComponent;
	}());
	exports.ReferralModalComponent = ReferralModalComponent;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var Rx_1 = __webpack_require__(214);
	var algorithm_service_1 = __webpack_require__(213);
	var alert_service_1 = __webpack_require__(689);
	var message_tag_1 = __webpack_require__(515);
	var reminders_1 = __webpack_require__(642);
	var watchlists_1 = __webpack_require__(671);
	var messaging_service_1 = __webpack_require__(533);
	var subject_1 = __webpack_require__(828);
	var subject_service_1 = __webpack_require__(821);
	var decorators_1 = __webpack_require__(517);
	var create_shared_worklist_request_1 = __webpack_require__(843);
	var group_worklists_request_1 = __webpack_require__(844);
	var shared_worklist_request_1 = __webpack_require__(845);
	var watchlist_entry_1 = __webpack_require__(846);
	var utilities_1 = __webpack_require__(523);
	var general_1 = __webpack_require__(513);
	var edit_shared_worklist_request_1 = __webpack_require__(847);
	var reminder_linked_item_request_1 = __webpack_require__(848);
	var WATCH_REFERENCE_TYPE = "watch";
	var WATCH_REFERENCE_PRIORITY = 10;
	var REMINDER_REFERENCE_TYPE = "reminder";
	var REMINDER_REFERENCE_PRIORITY = 2;
	var WatchlistService = (function () {
	    function WatchlistService(messaging, alerts, algorithms, subjects) {
	        var _this = this;
	        this.messaging = messaging;
	        this.alerts = alerts;
	        this.algorithms = algorithms;
	        this.subjects = subjects;
	        this.personalEntriesById = new Map();
	        this.sharedEntriesByIds = new Map();
	        this.hasLoadedSharedLists = new Set();
	        this.sharedListsByGroup = new Map();
	        this.objectIdToGroupId = new Map();
	        this.entryTables = [];
	        this.sharedEntryTables = new Map();
	        this.seenWorklistSCTypes = [];
	        this.reminders = [];
	        this.hasPersonalList = new Rx_1.BehaviorSubject(false);
	        this.knownColumns = [];
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	    }
	    WatchlistService.prototype.activePersonalCount = function () {
	        var count = 0;
	        var iter = this.personalEntriesById.values();
	        var next = iter.next();
	        while (!next.done) {
	            if (next.value.alert) {
	                count++;
	            }
	            next = iter.next();
	        }
	        return count;
	    };
	    WatchlistService.prototype.activeReminderCount = function () {
	        return this.reminders.filter(function (r) { return r.alert; }).length;
	    };
	    WatchlistService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(message_tag_1.MessageTag.RSP_WATCHLIST).subscribe(function (msg) {
	            if (msg.isShared === true) {
	                var groupId_1 = msg.groupId;
	                if (!Number.isSafeInteger(groupId_1)) {
	                    console.error("Shared worklist does not have groupId", msg);
	                    return;
	                }
	                Array.from(_this.sharedEntriesByIds.keys()).forEach(function (k) {
	                    if (k.startsWith(groupId_1 + "~")) {
	                        _this.sharedEntriesByIds.delete(k);
	                    }
	                });
	                _this.sharedEntryTables.set(groupId_1, []);
	                msg.worklist.forEach(function (entry) {
	                    return _this.readSharedWatchlistEntry(entry, groupId_1);
	                });
	            }
	            else {
	                _this.personalWorklistObjectId = msg.objectId;
	                _this.personalEntriesById.clear();
	                _this.entryTables = [];
	                msg.worklist.forEach(function (entry) {
	                    return _this.readWatchlistEntry(entry);
	                });
	                _this.generateNoteControls();
	                _this.hasPersonalList.next(true);
	            }
	        });
	        this.messaging.receive(message_tag_1.MessageTag.RSP_WATCHLIST_ITEM_UPDATED).subscribe(function (msg) {
	            if (msg.objectId !== _this.personalWorklistObjectId) {
	                if (_this.objectIdToGroupId.has(msg.objectId)) {
	                    var groupId = _this.objectIdToGroupId.get(msg.objectId);
	                    var groupLists = _this.sharedListsByGroup.get(msg.groupId) || [];
	                    var list = groupLists.find(function (l) { return l.objectId === msg.objectId; });
	                    var existingEntry = _this.sharedEntriesByIds.get(_this.getMergedId(groupId, msg.watchId));
	                    if (existingEntry === undefined) {
	                        _this.readSharedWatchlistEntry(msg, groupId);
	                    }
	                    else {
	                        _this.readWatchlistUpdate(existingEntry, msg);
	                    }
	                    return;
	                }
	                throw new Error("Received an update to a non-matching watchlist!");
	            }
	            else {
	                var existingEntry = _this.personalEntriesById.get(msg.watchId);
	                if (existingEntry === undefined) {
	                    _this.readWatchlistEntry(msg);
	                }
	                else {
	                    _this.readWatchlistUpdate(existingEntry, msg);
	                }
	                _this.generateNoteControls(msg.watchId);
	            }
	        });
	        this.messaging.receive(message_tag_1.MessageTag.RSP_STOP_WATCHING).subscribe(function (msg) {
	            var isPersonal = msg.objectId === _this.personalWorklistObjectId;
	            var target;
	            var groupId;
	            if (isPersonal) {
	                target = _this.personalEntriesById.get(msg.watchId);
	                _this.personalEntriesById.delete(msg.watchId);
	            }
	            else {
	                groupId = _this.objectIdToGroupId.get(msg.objectId);
	                var pairId = _this.getMergedId(groupId, msg.watchId);
	                target = _this.sharedEntriesByIds.get(pairId);
	                _this.sharedEntriesByIds.delete(pairId);
	            }
	            if (target === undefined) {
	                throw new Error("Cannot remove entry " + msg.watchId + ": not found");
	            }
	            var tableIndex = _this.seenWorklistSCTypes.indexOf(target.contextType);
	            var entryTable = isPersonal ? _this.entryTables[tableIndex] :
	                _this.sharedEntryTables.get(groupId)[tableIndex];
	            utilities_1.arrayRemove(entryTable.entries, target);
	            var unwatchedSubject = _this.subjects.subjects.find(function (s) { return s.incomingWatchId === msg.watchId; });
	            if (unwatchedSubject) {
	                unwatchedSubject.incomingWatchId = null;
	                var i = unwatchedSubject.identifiers.findIndex(function (sr) { return sr.type === "watch"; });
	                if (i > -1) {
	                    unwatchedSubject.identifiers.splice(i, 1);
	                }
	            }
	        });
	        this.messaging.receive(message_tag_1.MessageTag.RSP_REMINDERS).subscribe(function (msg) {
	            _this.reminderListObjectId = msg.objectId;
	            msg.notificationList.filter(function (r) { return r.alert; })
	                .forEach(function (r) {
	                var matching = _this.reminders.find(function (cmp) { return cmp.notificationId === r.notificationId; });
	                if (matching && !matching.alert) {
	                    _this.alerts.notify("Reminder: \"" + r.summary + "\"");
	                }
	            });
	            msg.notificationList.sort(function (a, b) {
	                return a.triggerTime.valueOf() - b.triggerTime.valueOf();
	            });
	            _this.reminders = msg.notificationList.map(function (r) {
	                r.triggerTime = new Date(r.triggerTime);
	                return r;
	            });
	        });
	        this.messaging.receive(message_tag_1.MessageTag.RSP_GROUP_WORKLISTS).subscribe(function (msg) {
	            if (_this.sharedListsByGroup.has(msg.groupId)) {
	                console.warn("Duplicate GroupWorklistsResponse, overwriting");
	                var listsWithEntries = _this.sharedListsByGroup.get(msg.groupId)
	                    .filter(function (list) {
	                    return Array.isArray(list.worklist) && list.worklist.length > 0;
	                });
	            }
	            else {
	                _this.sharedListsByGroup.set(msg.groupId, msg.sharedWorklists.map(function (l) { return (__assign({}, l, { loading: true })); }));
	                _this.hasLoadedSharedLists.add(msg.groupId);
	                msg.sharedWorklists.forEach(function (l) {
	                    return _this.objectIdToGroupId.set(l.objectId, msg.groupId);
	                });
	            }
	        });
	    };
	    WatchlistService.prototype.readWatchlistEntry = function (entry) {
	        var _this = this;
	        this.personalEntriesById.set(entry.watchId, entry);
	        var tableIndex = this.seenWorklistSCTypes.indexOf(entry.contextType);
	        if (tableIndex === -1) {
	            tableIndex = this.seenWorklistSCTypes.length;
	            this.seenWorklistSCTypes.push(entry.contextType);
	            entry.summary.forEach(function (t) { return _this.knownColumns.push(t.displayName); });
	        }
	        if (this.entryTables[tableIndex]
	            && Array.isArray(this.entryTables[tableIndex].entries)) {
	            this.entryTables[tableIndex].entries.push(entry);
	        }
	        else {
	            this.entryTables[tableIndex] = watchlist_entry_1.WatchlistEntry.startTable(entry);
	        }
	    };
	    WatchlistService.prototype.getMergedId = function (groupId, watchId) {
	        return groupId + "~" + watchId;
	    };
	    WatchlistService.prototype.readSharedWatchlistEntry = function (entry, groupId) {
	        var _this = this;
	        this.sharedEntriesByIds.set(this.getMergedId(groupId, entry.watchId), entry);
	        var tableIndex = this.seenWorklistSCTypes.indexOf(entry.contextType);
	        if (tableIndex === -1) {
	            tableIndex = this.seenWorklistSCTypes.length;
	            this.seenWorklistSCTypes.push(entry.contextType);
	            entry.summary.forEach(function (t) { return _this.knownColumns.push(t.displayName); });
	        }
	        var entryTable = utilities_1.getOrInit(this.sharedEntryTables, groupId, []);
	        if (entryTable[tableIndex]
	            && Array.isArray(entryTable[tableIndex].entries)) {
	            entryTable[tableIndex].entries.push(entry);
	        }
	        else {
	            entryTable[tableIndex] = watchlist_entry_1.WatchlistEntry.startTable(entry);
	        }
	    };
	    WatchlistService.prototype.readWatchlistUpdate = function (old, updated) {
	        if (!old.alert && updated.alert) {
	            this.alerts.notify("Another user has made changes to one of your subscribed items!\n        (The entry will be highlighted in your work list.)");
	        }
	        Object.assign(old, updated);
	    };
	    WatchlistService.prototype.generateNoteControls = function (targetId) {
	        if (!Number.isInteger(targetId)) {
	            this.personalEntriesById.forEach(function (entry) {
	                if (!entry.control) {
	                    entry.control = new forms_1.FormControl(entry.note);
	                }
	            });
	        }
	        else {
	            var entry = this.personalEntriesById.get(targetId);
	            if (!entry.control) {
	                entry.control = new forms_1.FormControl(entry.note);
	            }
	        }
	    };
	    WatchlistService.prototype.disconnected = function () { };
	    WatchlistService.prototype.watchRunningSubject = function (notify) {
	        if (notify === void 0) { notify = true; }
	        this.algorithms.assertRunning();
	        var subject = this.algorithms.running.subject;
	        return this.watchSubject(subject, notify);
	    };
	    WatchlistService.prototype.watchSubject = function (subject, notify) {
	        var _this = this;
	        if (notify === void 0) { notify = true; }
	        if (this.personalWorklistObjectId !== null) {
	            return this.messaging.resultOf(new watchlists_1.WatchSubjectContextRequest(this.personalWorklistObjectId, subject.id))
	                .flatMap(function (watched) {
	                if (watched) {
	                    if (notify) {
	                        _this.alerts.success("The subject was added to your personal work list!");
	                    }
	                    return _this.messaging.nextOfType(message_tag_1.MessageTag.RSP_WATCHLIST_ITEM_UPDATED).map(function (msg) { return msg.watchId; }).do(function (watchId) {
	                        subject.addRef(_this.createRef(watchId));
	                        subject.incomingWatchId = watchId;
	                    });
	                }
	                if (notify) {
	                    _this.alerts.warn("The subject could not be added to your personal work list.");
	                }
	                return [-1];
	            });
	        }
	        else {
	            console.error("WatchlistService does not have server ID for watchlist object", this);
	            this.alerts.error("Could not add subject; no work list found!");
	            return Rx_1.Observable.throw("WatchlistService does not have server ID for watchlist object");
	        }
	    };
	    WatchlistService.prototype.watchShared = function (subject, list, notify) {
	        var _this = this;
	        if (notify === void 0) { notify = true; }
	        if (list !== null && Number.isSafeInteger(list.objectId)) {
	            var request = void 0;
	            if (Number.isSafeInteger(subject.id)) {
	                request = new watchlists_1.WatchSubjectContextRequest(list.objectId, subject.id);
	            }
	            else {
	                var ref = subject.identifiers.find(function (i) { return i.type === "watch" && i.parentId === list.objectId; });
	                if (ref) {
	                    request = new watchlists_1.WatchSubjectContextRequest(list.objectId, ref.id, ref.parentId);
	                }
	                else {
	                    console.error("Can't find appropiriate referent for ");
	                }
	            }
	            return this.messaging.send(request).flatMap(function (ar) {
	                if (ar.ok) {
	                    if (notify) {
	                        var groupId_2 = _this.objectIdToGroupId.get(list.objectId);
	                        _this.alerts.add({
	                            message: "The subject was added to list '" + list.title + "'!",
	                            type: "success",
	                            timeout: "default",
	                            actionLabel: "View List",
	                            action: function (r) {
	                                r.navigate(["/lists/byGroup", groupId_2, list.objectId]);
	                            }
	                        });
	                    }
	                    return _this.messaging.nextOfType(message_tag_1.MessageTag.RSP_WATCHLIST_ITEM_UPDATED).map(function (msg) { return msg.watchId; }).do(function (watchId) {
	                    });
	                }
	                else {
	                    if (notify) {
	                        if (ar.code === general_1.ResponseCode.InvalidRequest) {
	                            _this.alerts.notify("The subject is already on the selected list.");
	                        }
	                        else {
	                            _this.alerts.warn("The subject could not be added to the shared list.");
	                        }
	                    }
	                    return [-1];
	                }
	            });
	        }
	        else {
	            console.error("WatchlistService does not have server ID for watchlist object", this);
	            this.alerts.error("Could not add subject; no work list found!");
	            return Rx_1.Observable.throw("WatchlistService does not have server ID for watchlist object");
	        }
	    };
	    WatchlistService.prototype.createRef = function (watchId, listObjectId) {
	        var ref = {
	            id: watchId,
	            host: this,
	            type: WATCH_REFERENCE_TYPE,
	            priority: WATCH_REFERENCE_PRIORITY,
	            request: null
	        };
	        if (listObjectId === undefined) {
	            ref.request = new watchlists_1.WatchlistItemRequest(watchId, this.personalWorklistObjectId);
	        }
	        else {
	            ref.request = new watchlists_1.WatchlistItemRequest(watchId, listObjectId);
	            ref.parentId = listObjectId;
	            ref.summaryURL = "/lists/byGroup/" + this.objectIdToGroupId.get(listObjectId) + "/" + listObjectId;
	        }
	        return ref;
	    };
	    WatchlistService.prototype.unwatch = function (entry, notify, force, objectId) {
	        var _this = this;
	        if (notify === void 0) { notify = true; }
	        if (force === void 0) { force = false; }
	        if (objectId === void 0) { objectId = this.personalWorklistObjectId; }
	        var textType = (objectId === this.personalWorklistObjectId ?
	            "your personal worklist" : "the shared worklist");
	        if (entry instanceof subject_1.Subject) {
	            debugger;
	            var ref_1 = entry.findRef("watch");
	            if (!ref_1) {
	            }
	            return this.messaging.resultOf(new watchlists_1.StopWatchingRequest(objectId, ref_1.id, force)).do(function (unwatched) {
	                if (unwatched) {
	                    entry.removeRef(ref_1);
	                    entry.incomingWatchId = null;
	                    if (notify) {
	                        _this.alerts.notify("The subject has been removed from " + textType + "!");
	                    }
	                }
	            });
	        }
	        return this.messaging.resultOf(new watchlists_1.StopWatchingRequest(objectId, entry.watchId)).do(function (unwatched) {
	            if (unwatched && notify) {
	                _this.alerts.notify("The subject has been removed from " + textType);
	            }
	        });
	    };
	    WatchlistService.prototype.clearAlert = function (entry, objectId) {
	        if (objectId === void 0) { objectId = this.personalWorklistObjectId; }
	        return this.messaging.resultOf(new watchlists_1.AcknowledgeWatchlistAlertRequest(objectId, entry.watchId));
	    };
	    WatchlistService.prototype.resummarize = function (entry, objectId) {
	        if (objectId === void 0) { objectId = this.personalWorklistObjectId; }
	        return this.messaging.resultOf(new watchlists_1.RefreshWatchlistItemRequest(objectId, entry.watchId));
	    };
	    WatchlistService.prototype.findSharedEntry = function (entry, objectId) {
	        var shared = objectId !== this.personalWorklistObjectId;
	        if (shared) {
	            try {
	                var groupId = this.objectIdToGroupId.get(objectId);
	                var lists = this.sharedListsByGroup.get(groupId);
	                var list = lists.find(function (l) { return l.objectId === objectId; });
	                var foundEntry = list.worklist.find(function (e) { return e.watchId === entry.watchId; });
	                return foundEntry;
	            }
	            catch (e) {
	                return null;
	            }
	        }
	        else {
	            return this.personalEntriesById.get(entry.watchId);
	        }
	    };
	    WatchlistService.prototype.editNote = function (entry, note, categories, objectId) {
	        if (categories === void 0) { categories = []; }
	        if (objectId === void 0) { objectId = this.personalWorklistObjectId; }
	        return this.messaging.resultOf(new watchlists_1.EditWatchlistItemRequest(objectId, entry.watchId, note, categories, entry.emailNotifyOnUpdate)).do(function (success) {
	            if (success) {
	                entry.note = note;
	            }
	        });
	    };
	    WatchlistService.prototype.editSharedList = function (objectId, changes) {
	        return this.messaging.resultOf(new edit_shared_worklist_request_1.EditSharedWorklistRequest(objectId, changes.title, changes.description));
	    };
	    WatchlistService.prototype.changeNotificationSetting = function (entry, notify, objectId) {
	        if (objectId === void 0) { objectId = this.personalWorklistObjectId; }
	        return this.messaging.resultOf(new watchlists_1.EditWatchlistItemRequest(objectId, entry.watchId, entry.note, entry.categories, notify));
	    };
	    WatchlistService.prototype.addReminder = function (summary, triggerTime, linkedId) {
	        if (this.reminderListObjectId !== null) {
	            return this.messaging.resultOf(new reminders_1.AddReminderRequest(this.reminderListObjectId, summary, triggerTime.valueOf(), linkedId));
	        }
	        else {
	            console.error("WatchlistService does not have server ID for reminder list", this);
	            this.alerts.error("Could not add reminder; no reminder list found!");
	        }
	    };
	    WatchlistService.prototype.removeReminder = function (id) {
	        return this.messaging.resultOf(new reminders_1.DeleteReminderRequest(this.reminderListObjectId, id));
	    };
	    WatchlistService.prototype.openReminderLinkedRecord = function (reminder, target) {
	        var subject = this.subjects.fromReference(this.createReminderRef(reminder.notificationId));
	        if (!target) {
	            target = this.algorithms.defaultForOpen(reminder.linkedType);
	            subject.initialAlgorithmTarget = target;
	        }
	        return this.subjects.open(subject, true);
	    };
	    WatchlistService.prototype.createReminderRef = function (reminderId) {
	        var ref = {
	            id: reminderId,
	            host: this,
	            type: REMINDER_REFERENCE_TYPE,
	            priority: REMINDER_REFERENCE_PRIORITY,
	            request: new reminder_linked_item_request_1.ReminderLinkedItemRequest(this.reminderListObjectId, reminderId)
	        };
	        return ref;
	    };
	    Object.defineProperty(WatchlistService.prototype, "hasAlerts", {
	        get: function () {
	            return (this.reminders.some(function (r) { return r.alert; })
	                || Array.from(this.personalEntriesById.values())
	                    .some(function (e) { return e.alert; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WatchlistService.prototype, "alertCount", {
	        get: function () {
	            var count = this.reminders.filter(function (r) { return r.alert; }).length;
	            this.personalEntriesById.forEach(function (e) {
	                if (e.alert) {
	                    count++;
	                }
	            });
	            return count;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WatchlistService.prototype.open = function (entry, navigate, target) {
	        if (navigate === void 0) { navigate = true; }
	        var subject = this.subjects.fromReference(this.createRef(entry.watchId));
	        if (target) {
	            subject.initialAlgorithmTarget = target;
	        }
	        return this.subjects.open(subject, navigate);
	    };
	    WatchlistService.prototype.openShared = function (entry, groupId, navigate, target) {
	        if (navigate === void 0) { navigate = true; }
	        var subject = this.subjects.fromReference(this.createRef(entry.watchId, groupId));
	        if (target) {
	            subject.initialAlgorithmTarget = target;
	        }
	        return this.subjects.open(subject, navigate);
	    };
	    WatchlistService.prototype.requestListsForGroup = function (group) {
	        var _this = this;
	        var id = (typeof group === 'object') ? group.id : group;
	        return this.messaging.converse(new group_worklists_request_1.GroupWorklistsRequest(id), function (error) {
	            console.error("Error retrieving worklist for group " + id + "\n", error);
	        }).map(function (rsp) {
	            _this.sharedListsByGroup.set(rsp.groupId, rsp.sharedWorklists);
	            _this.hasLoadedSharedLists.add(rsp.groupId);
	            rsp.sharedWorklists.forEach(function (l) {
	                return _this.objectIdToGroupId.set(l.objectId, rsp.groupId);
	            });
	            return rsp.sharedWorklists;
	        });
	    };
	    WatchlistService.prototype.requestListsForAll = function (groups) {
	        var _this = this;
	        return Rx_1.Observable.zip.apply(Rx_1.Observable, groups.map(function (g) { return _this.requestListsForGroup(g.id); }));
	    };
	    WatchlistService.prototype.addListToGroup = function (gid, list, annotateAsLoaded) {
	        if (annotateAsLoaded === void 0) { annotateAsLoaded = false; }
	        if (annotateAsLoaded) {
	            list.loading = false;
	            list.loadTime = Date.now();
	        }
	        var existingForGroup = this.sharedListsByGroup.get(gid) || [];
	        var i = existingForGroup.findIndex(function (l) { return l.objectId === list.objectId; });
	        existingForGroup[i > -1 ? i : existingForGroup.length] = list;
	        return list;
	    };
	    WatchlistService.prototype.loadSharedList = function (gid, opaqueId) {
	        var _this = this;
	        return this.messaging.converse(new shared_worklist_request_1.SharedWorklistRequest(gid, opaqueId)).map(function (reply) {
	            return _this.addListToGroup(gid, reply, true);
	        });
	    };
	    WatchlistService.prototype.createSharedList = function (config) {
	        var _this = this;
	        return this.messaging.converse(new create_shared_worklist_request_1.CreateSharedWorklistRequest(config.groupId, config.title, config.description, config.stableUrl)).map(function (rsp) {
	            return _this.addListToGroup(config.groupId, rsp, true);
	        });
	    };
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Map)
	    ], WatchlistService.prototype, "personalEntriesById", void 0);
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Map)
	    ], WatchlistService.prototype, "sharedEntriesByIds", void 0);
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Set)
	    ], WatchlistService.prototype, "hasLoadedSharedLists", void 0);
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Map)
	    ], WatchlistService.prototype, "sharedListsByGroup", void 0);
	    __decorate([
	        decorators_1.disconnectWith("clear"),
	        __metadata("design:type", Map)
	    ], WatchlistService.prototype, "objectIdToGroupId", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], WatchlistService.prototype, "entryTables", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], WatchlistService.prototype, "seenWorklistSCTypes", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], WatchlistService.prototype, "reminders", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Number)
	    ], WatchlistService.prototype, "personalWorklistObjectId", void 0);
	    __decorate([
	        decorators_1.disconnectWith("next", false),
	        __metadata("design:type", Rx_1.BehaviorSubject)
	    ], WatchlistService.prototype, "hasPersonalList", void 0);
	    __decorate([
	        decorators_1.disconnectValue(null),
	        __metadata("design:type", Number)
	    ], WatchlistService.prototype, "reminderListObjectId", void 0);
	    __decorate([
	        decorators_1.disconnectEmpty(),
	        __metadata("design:type", Array)
	    ], WatchlistService.prototype, "knownColumns", void 0);
	    WatchlistService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService,
	            subject_service_1.SubjectService])
	    ], WatchlistService);
	    return WatchlistService;
	}());
	exports.WatchlistService = WatchlistService;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var CreateSharedWorklistRequest = (function (_super) {
	    __extends(CreateSharedWorklistRequest, _super);
	    function CreateSharedWorklistRequest(groupId, title, description, stablePath) {
	        var _this = _super.call(this) || this;
	        _this.groupId = groupId;
	        _this.title = title;
	        _this.description = description;
	        _this.stablePath = stablePath;
	        _this.tag = message_tag_1.MessageTag.REQ_CREATE_SHARED_WORKLIST;
	        return _this;
	    }
	    CreateSharedWorklistRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_WATCHLIST);
	    };
	    CreateSharedWorklistRequest.tag = message_tag_1.MessageTag.REQ_CREATE_SHARED_WORKLIST;
	    return CreateSharedWorklistRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.CreateSharedWorklistRequest = CreateSharedWorklistRequest;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var GroupWorklistsRequest = (function (_super) {
	    __extends(GroupWorklistsRequest, _super);
	    function GroupWorklistsRequest(groupId) {
	        var _this = _super.call(this) || this;
	        _this.groupId = groupId;
	        _this.tag = message_tag_1.MessageTag.REQ_GROUP_WORKLISTS;
	        return _this;
	    }
	    GroupWorklistsRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_GROUP_WORKLISTS);
	    };
	    GroupWorklistsRequest.tag = message_tag_1.MessageTag.REQ_GROUP_WORKLISTS;
	    return GroupWorklistsRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.GroupWorklistsRequest = GroupWorklistsRequest;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var general_1 = __webpack_require__(513);
	var message_tag_1 = __webpack_require__(515);
	var SharedWorklistRequest = (function (_super) {
	    __extends(SharedWorklistRequest, _super);
	    function SharedWorklistRequest(groupId, opaqueId, stablePath) {
	        var _this = _super.call(this) || this;
	        _this.groupId = groupId;
	        _this.opaqueId = opaqueId;
	        _this.stablePath = stablePath;
	        _this.tag = message_tag_1.MessageTag.REQ_SHARED_WORKLIST;
	        return _this;
	    }
	    SharedWorklistRequest.prototype.verifyReply = function (reply) {
	        return general_1.Message.isA(reply, message_tag_1.MessageTag.RSP_WATCHLIST);
	    };
	    SharedWorklistRequest.tag = message_tag_1.MessageTag.REQ_SHARED_WORKLIST;
	    return SharedWorklistRequest;
	}(general_1.ReplyVerifyingMessage));
	exports.SharedWorklistRequest = SharedWorklistRequest;


/***/ }),
/* 846 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var WatchlistEntry = (function () {
	    function WatchlistEntry() {
	    }
	    WatchlistEntry.startTable = function (entry) {
	        return {
	            columns: entry.summary.map(function (col) { return col.displayName; }),
	            contextType: entry.contextType,
	            entries: [entry]
	        };
	    };
	    return WatchlistEntry;
	}());
	exports.WatchlistEntry = WatchlistEntry;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var EditSharedWorklistRequest = (function (_super) {
	    __extends(EditSharedWorklistRequest, _super);
	    function EditSharedWorklistRequest(objectId, title, description, stablePath) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.title = title;
	        _this.description = description;
	        _this.stablePath = stablePath;
	        _this.tag = message_tag_1.MessageTag.REQ_EDIT_SHARED_WORKLIST;
	        return _this;
	    }
	    EditSharedWorklistRequest.tag = message_tag_1.MessageTag.REQ_EDIT_SHARED_WORKLIST;
	    return EditSharedWorklistRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.EditSharedWorklistRequest = EditSharedWorklistRequest;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ReminderLinkedItemRequest = (function (_super) {
	    __extends(ReminderLinkedItemRequest, _super);
	    function ReminderLinkedItemRequest(objectId, reminderId) {
	        var _this = _super.call(this) || this;
	        _this.objectId = objectId;
	        _this.reminderId = reminderId;
	        _this.tag = message_tag_1.MessageTag.REQ_REMINDER_LINKED_ITEM;
	        return _this;
	    }
	    ReminderLinkedItemRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUBJECT_CONTEXT);
	    };
	    ReminderLinkedItemRequest.tag = message_tag_1.MessageTag.REQ_REMINDER_LINKED_ITEM;
	    return ReminderLinkedItemRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ReminderLinkedItemRequest = ReminderLinkedItemRequest;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var structure_1 = __webpack_require__(581);
	var algorithm_service_1 = __webpack_require__(213);
	var step_update_1 = __webpack_require__(697);
	var transformer_service_1 = __webpack_require__(698);
	var step_facade_1 = __webpack_require__(752);
	var alert_service_1 = __webpack_require__(689);
	var messages_1 = __webpack_require__(754);
	var messaging_service_1 = __webpack_require__(533);
	var report_details_modal_component_1 = __webpack_require__(850);
	var modal_service_1 = __webpack_require__(837);
	var DEACTIVATION_SETTLED_TIME = 2000;
	var NOTIFICATION_AGGLUTINATION_TIME = 1000;
	var ReportStepService = (function (_super) {
	    __extends(ReportStepService, _super);
	    function ReportStepService(messaging, alerts, algorithms, transformer, modals) {
	        var _this = _super.call(this, messaging, algorithms) || this;
	        _this.messaging = messaging;
	        _this.alerts = alerts;
	        _this.algorithms = algorithms;
	        _this.transformer = transformer;
	        _this.modals = modals;
	        _this.lastActive = new Map();
	        _this.lastGlobalDeactivate = 0;
	        _this.lastReportNotification = 0;
	        _this.lastReportCount = 0;
	        return _this;
	    }
	    ReportStepService.prototype.matchesSubtype = function (step) {
	        return (step instanceof structure_1.ReportStep);
	    };
	    ReportStepService.prototype.all = function () {
	        if (!this.isRunning()) {
	            return [];
	        }
	        return this.algorithms.running.steps.reports();
	    };
	    ReportStepService.prototype.active = function () {
	        return this.all().filter(function (step) { return step.isActive; });
	    };
	    ReportStepService.prototype.updates = function () {
	        this.assertRunning();
	        return this.algorithms.running.steps.updates.filter(function (update) { return update.matchesType(structure_1.ReportStep); });
	    };
	    ReportStepService.prototype.connected = function () {
	        var _this = this;
	        this.subscriptions = this.messaging.receive(messages_1.MessageTag.RSP_NEXT_STEPS)
	            .flatMap(function (m) { return m.reportSteps; })
	            .map(function (s) {
	            s = new structure_1.ReportStep(s);
	            _this.transformer.run(s, true);
	            return s;
	        })
	            .filter(function (s) { return s.hints.visible !== false; })
	            .subscribe(function (step) {
	            var previous = _this.algorithms.running.steps.get(step.id);
	            if (step.isActive) {
	                var lastActive = _this.lastActive.get(step.id) || _this.lastGlobalDeactivate;
	                if (step.id === 90) {
	                    console.warn(Date.now());
	                    console.warn(lastActive);
	                    console.warn(Date.now() - lastActive);
	                }
	                if ((!previous ||
	                    (!previous.isActive &&
	                        (Date.now() - lastActive) > DEACTIVATION_SETTLED_TIME))) {
	                    if (!_this.algorithms.running.recentlyLaunched) {
	                        if ((Date.now() - _this.lastReportNotification) <
	                            NOTIFICATION_AGGLUTINATION_TIME) {
	                            _this.lastReportCount++;
	                            _this.alerts.addAndReplace("We have found " + _this.lastReportCount + " new recommendations!", "notification", "new report");
	                        }
	                        else {
	                            _this.lastReportNotification = Date.now();
	                            _this.lastReportCount = 1;
	                            _this.alerts.addAndReplace("We found a recommendation for you! (\"" + step.displayName + "\")", "notification", "new report");
	                        }
	                    }
	                    if (step.hints.alert === true) {
	                        _this.modals.display(report_details_modal_component_1.ReportDetailsModalComponent, {
	                            selected: step,
	                            explanation: Rx_1.Observable.empty(),
	                            important: true
	                        });
	                    }
	                }
	            }
	            else if (previous && previous.isActive) {
	                _this.lastActive.set(step.id, Date.now());
	            }
	            _this.algorithms.running.steps.define(step);
	        });
	        this.subscriptions.add(this.algorithms.smoothUpdates.filter(function (update) { return update instanceof step_update_1.GlobalDeactivation; }).subscribe(function () {
	            _this.lastGlobalDeactivate = Date.now();
	            console.log("global deactivate", _this.lastGlobalDeactivate);
	        }));
	    };
	    ReportStepService.prototype.disconnected = function () { };
	    ReportStepService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService,
	            transformer_service_1.TransformerService,
	            modal_service_1.ModalService])
	    ], ReportStepService);
	    return ReportStepService;
	}(step_facade_1.StepFacade));
	exports.ReportStepService = ReportStepService;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var graph_1 = __webpack_require__(823);
	var ReportContext = (function (_super) {
	    __extends(ReportContext, _super);
	    function ReportContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ReportContext;
	}(bootstrap_1.BSModalContext));
	exports.ReportContext = ReportContext;
	var ReportDetailsModalComponent = (function () {
	    function ReportDetailsModalComponent(dialog) {
	        var _this = this;
	        this.dialog = dialog;
	        this.important = false;
	        this.highlight = null;
	        this.selected = dialog.context.selected;
	        dialog.context.explanation.subscribe(function (g) {
	            _this.explanation = g;
	            g.nodes.sort(graph_1.Graph.topologicalCompatator(g.edges));
	        });
	        if (dialog.context.important === true) {
	            this.important = true;
	        }
	    }
	    ReportDetailsModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      {{selected.displayName}}\n    </h4>\n  </div>\n\n  <div *ngIf=\"important\" class=\"modal-body\">\n    <em class=\"text-warning\">This report was marked as important:</em>\n  </div>\n\n  <table>\n    <tr>\n      <td><badge *ngIf=\"selected\" [report]=\"selected\"></badge></td>\n      <td [innerHtml]=\"selected.presentation\"></td>\n    </tr>\n  </table>\n\n  <table *ngIf=\"explanation\" class=\"table fit-to-modal\">\n    <caption>\n      Below are the intake steps leading to this determination\n    </caption>\n    <thead>\n      <th>ID</th>\n      <th>Name</th>\n      <th>Value</th>\n    </thead>\n    <tbody>\n      <tr\n        *ngFor=\"let node of explanation?.nodes\"\n        [class.highlight]=\"highlight == node.id\"\n        (mouseenter)=\"highlight = node.id\"\n        (mouseleave)=\"highlight = null\">\n        <td>{{node.id}}</td>\n        <td>{{node.step.displayName || \"unknown\"}}</td>\n        <td>\n          <typed-display\n            *ngIf=\"node.category === 'IntakeStep'\"\n            [input]=\"node.step\"></typed-display>\n          <em *ngIf=\"node.category === 'ComputationStep'\">\n            (server computation)\n\t\t  </em>\n\t\t\t<em *ngIf=\"node.category === 'InterpolationStep'\">\n\t\t\t\t(local calculation)\n\t\t\t</em>\n          <em *ngIf=\"node.category === 'ReportStep'\">\n            (this report)\n          </em>\n        </td>\n      </tr>\n      <tr *ngIf=\"explanation?.nodes?.length === 0\">\n        <td colspan=\"3\" class=\"text-center text-danger\">\n          No predecessors found.\n        </td>\n      </tr>\n      <tr *ngIf=\"!explanation\">\n        <td colspan=\"3\" class=\"text-center\">\n          <spinner></spinner>\n        </td>\n      </tr>\n      <!--<tr\n        [class.highlight]=\"highlight == selected.id\"\n        (mouseenter)=\"highlight = selected.id\"\n        (mouseleave)=\"highlight = null\">\n        <td>{{selected?.id}}</td>\n        <td>{{selected?.name}}</td>\n        <td>[this report]</td>\n      </tr>-->\n    </tbody>\n  </table>\n\n  <force-directed-graph\n    *ngIf=\"explanation\"\n    [graph]=\"explanation\"\n    [highlight]=\"highlight\"\n    (selected)=\"highlight = $event\">\n  </force-directed-graph>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      OK\n    </button>\n  </div>\n  ",
	            styles: ["\n    table {\n      width: 100%;\n    }\n    badge {\n      margin: 15px;\n    }\n    /deep/ table td div p:last-child {\n      margin-bottom: 0;\n    }\n    table .special-message td {\n      text-align: center;\n    }\n    table caption {\n      text-align: center;\n      font-style: italic;\n    }\n    .fit-to-modal td:first-child, .fit-to-modal th:first-child {\n      padding-left: 30px;\n    }\n    .fit-to-modal td:last-child, .fit-to-modal th:last-child {\n      padding-right: 30px;\n    }\n    .table.fit-to-modal {\n      margin-bottom: 0;\n    }\n    .table tbody {border-bottom: 1px solid #ddd;}\n    .table tr.highlight {background-color: lightyellow;}\n    "]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], ReportDetailsModalComponent);
	    return ReportDetailsModalComponent;
	}());
	exports.ReportDetailsModalComponent = ReportDetailsModalComponent;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var AddReminderModalComponent = (function () {
	    function AddReminderModalComponent(dialog) {
	        this.dialog = dialog;
	        this.summary = new forms_1.FormControl("", forms_1.Validators.required);
	        this.linkRecord = new forms_1.FormControl(!!this.dialog.context.hasImpliedLink);
	        this.triggerTime = new forms_1.FormControl(null, forms_1.Validators.required);
	        if (dialog.context.initialDate) {
	            this.triggerTime.setValue(dialog.context.initialDate);
	        }
	    }
	    AddReminderModalComponent.prototype.add = function () {
	        if (this.triggerTime.invalid) {
	            this.errorMessage = "You must enter a date to create a reminder!";
	            return;
	        }
	        if (this.summary.invalid) {
	            this.errorMessage =
	                "You must enter a memo/label to create a reminder!";
	            return;
	        }
	        var result = {
	            summary: this.summary.value,
	            triggerTime: this.triggerTime.value,
	            linkedRecord: this.linkRecord.value
	        };
	        this.dialog.close(result);
	    };
	    AddReminderModalComponent = __decorate([
	        core_1.Component({
	            template: "\n<div class=\"modal-header\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\t(click)=\"dialog.dismiss()\"\n\t\taria-label=\"Close\">\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n\t<h4 class=\"modal-title\">\n\t\tAdd Reminder\n\t</h4>\n</div>\n<div class=\"modal-body\">\n\t<div class=\"form-group\">\n\t\t<label>Trigger time</label>\n\t\t<input\n\t\t\ttype=\"datetime-local\"\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"triggerTime\">\n\t</div>\n\t<div class=\"form-group\">\n\t\t<label>Reminder memo</label>\n\t\t<input\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"summary\"\n\t\t\tplaceholder=\"To-do, note, or other message...\">\n\t</div>\n\t<div class=\"checkbox\" *ngIf=\"dialog.context.hasImpliedLink\">\n    <label>\n      <input type=\"checkbox\" [formControl]=\"linkRecord\">\n\t\t\t&nbsp; Link to the current record?\n    </label>\n\t\t<p>This creates a connection between the reminder and the record so that it can be opened later.</p>\n  </div>\n\n\t<p *ngIf=\"errorMessage\" class=\"text-danger\">{{errorMessage}}</p>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t(click)=\"add()\">\n\t\tAdd\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-default\"\n\t\t(click)=\"dialog.dismiss()\">\n\t\tCancel\n\t</button>\n</div>\n\n  ",
	            styles: [".checkbox label {font-weight: bold;}"]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], AddReminderModalComponent);
	    return AddReminderModalComponent;
	}());
	exports.AddReminderModalComponent = AddReminderModalComponent;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var FirstCheckCustomFlowComponent = (function () {
	    function FirstCheckCustomFlowComponent() {
	        this.flowName = "first-check-v1";
	    }
	    FirstCheckCustomFlowComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div>CUSTOM FLOW GOES HERE</div>\n",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [])
	    ], FirstCheckCustomFlowComponent);
	    return FirstCheckCustomFlowComponent;
	}());
	exports.FirstCheckCustomFlowComponent = FirstCheckCustomFlowComponent;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var search_service_1 = __webpack_require__(834);
	var PermalinkComponent = (function () {
	    function PermalinkComponent(route, search) {
	        this.route = route;
	        this.search = search;
	    }
	    PermalinkComponent.prototype.ngOnInit = function () {
	        var caseId = this.route.snapshot.params.case_id;
	        if (!caseId) {
	            console.error("Cannot load empty case ID:", caseId, this.route.snapshot.params);
	            return;
	        }
	        this.search.vendorABC_navigateToHCBRecord(caseId);
	    };
	    PermalinkComponent = __decorate([
	        core_1.Component({
	            template: "<!-- permalink component -->"
	        }),
	        __metadata("design:paramtypes", [router_1.ActivatedRoute, search_service_1.SearchService])
	    ], PermalinkComponent);
	    return PermalinkComponent;
	}());
	exports.PermalinkComponent = PermalinkComponent;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var algorithm_service_1 = __webpack_require__(213);
	var user_service_1 = __webpack_require__(713);
	var debug_service_1 = __webpack_require__(855);
	var subject_1 = __webpack_require__(828);
	var SubjectSummaryComponent = (function () {
	    function SubjectSummaryComponent(algorithms, router, route, users, debug) {
	        this.algorithms = algorithms;
	        this.router = router;
	        this.route = route;
	        this.users = users;
	        this.debug = debug;
	        this.subject = null;
	    }
	    SubjectSummaryComponent.prototype.colorCycle = function (i) {
	        return [
	            "btn-info",
	            "btn-warning",
	            "btn-danger",
	            "btn-success",
	            "btn-default"
	        ][i % 5];
	    };
	    SubjectSummaryComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.route.data.subscribe(function (data) {
	            if (data.subject instanceof subject_1.Subject) {
	                _this.subject = data.subject;
	            }
	        });
	    };
	    SubjectSummaryComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\">\n    <h3>\n      Subject Summary\n      <small class=\"capitalized\">[ {{subject?.type}} ]</small>\n    </h3>\n    <div class=\"row\">\n      <div class=\"col-sm-7\">\n        <div class=\"well\">\n          <em>\n            NOTE: If you've edited this subject this session, the summary may\n            have fallen out of date.\n          </em>\n          <table class=\"table\">\n            <tr>\n              <th class=\"text-right\">Created at:</th>\n              <td>{{subject?.created | date:\"medium\"}}</td>\n            </tr>\n            <tr *ngFor=\"let datum of subject?.summary\">\n              <th class=\"capitalized text-right\">\n                {{datum.displayName || datum.name}}:\n              </th>\n              <td>\n                <typed-display [input]=\"datum\"></typed-display>\n              </td>\n            </tr>\n          </table>\n\n          <h4>Available Algorithms</h4>\n          <table class=\"table center-items\">\n            <tr *ngFor=\"let alg of subject?.availableAlgorithms; let i = index\">\n              <td>\n                <button\n                  class=\"btn boxier p100\"\n                  [ngClass]=\"colorCycle(i)\"\n                  (click)=\"algorithms.open(alg, subject)\">\n                  {{alg.displayName}}\n                </button>\n              </td>\n              <td>\n                <span *ngIf=\"!alg.supportsIntake\" class=\"badge\">read-only</span>\n                <p *ngIf=\"alg.description\" [innerHtml]=\"alg.description\"></p>\n                <em *ngIf=\"!alg.description\">No description available.</em>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n\n      <!-- SIDEBAR -->\n      <div class=\"col-sm-5\">\n        <button\n          *ngIf=\"users.debugMode && !debug.startupSubjectTarget\"\n          class=\"btn btn-default debug-only form-control\"\n          (click)=\"debug.setStartupTarget(subject)\">\n          \u00ABset as debug startup target\u00BB\n        </button>\n        <button\n          *ngIf=\"users.debugMode && debug.startupSubjectTarget\"\n          class=\"btn btn-default debug-only form-control\"\n          (click)=\"debug.clearStartupTarget()\">\n          \u00ABremove current startup subject target\u00BB\n        </button>\n\n        <watch-button [subject]=\"subject\"></watch-button>\n        <relationship-panel [subject]=\"subject\" [panelOpen]=\"true\">\n        </relationship-panel>\n      </div>\n    </div>\n  ",
	            styles: [
	                ".boxier {padding-top: 1em; padding-bottom: 1em; height: 3.5em;}",
	                ".btn.debug-only {margin-bottom: 20px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [algorithm_service_1.AlgorithmService,
	            router_1.Router,
	            router_1.ActivatedRoute,
	            user_service_1.UserService,
	            debug_service_1.DebugService])
	    ], SubjectSummaryComponent);
	    return SubjectSummaryComponent;
	}());
	exports.SubjectSummaryComponent = SubjectSummaryComponent;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var algorithm_step_service_1 = __webpack_require__(856);
	var alert_service_1 = __webpack_require__(689);
	var admin_1 = __webpack_require__(548);
	var debug_1 = __webpack_require__(613);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var storage_service_1 = __webpack_require__(691);
	var watchlist_service_1 = __webpack_require__(842);
	var LogLevel;
	(function (LogLevel) {
	    LogLevel[LogLevel["Silent"] = 0] = "Silent";
	    LogLevel[LogLevel["Normal"] = 1] = "Normal";
	    LogLevel[LogLevel["Interrupt"] = 2] = "Interrupt";
	})(LogLevel || (LogLevel = {}));
	var DebugService = (function () {
	    function DebugService(messaging, route, alerts, steps, watchlist, storage, subjects) {
	        var _this = this;
	        this.messaging = messaging;
	        this.route = route;
	        this.alerts = alerts;
	        this.steps = steps;
	        this.watchlist = watchlist;
	        this.storage = storage;
	        this.subjects = subjects;
	        this.messages = [];
	        this.level = LogLevel.Normal;
	        this.startupSubjectTarget = this.storage.getWrappedValue(DebugService_1.SSTKey);
	        this.messaging.ready.subscribe(function (on) { return on ? _this.connected() : _this.disconnected(); });
	        this.watchlist.hasPersonalList.subscribe(function (watchlistLoaded) {
	            return watchlistLoaded ? _this.loadStartupTarget() : null;
	        });
	    }
	    DebugService_1 = DebugService;
	    DebugService.prototype.connected = function () {
	        var _this = this;
	        this.messaging.receive(general_1.MessageTag.DBG_DOWN_LOG).subscribe(function (m) { return _this.handleDebugMessage(m); });
	        this.messaging.receive(general_1.MessageTag.DOWN_NOTIFY).subscribe(function (m) {
	            return _this.presentNotification(m.message, m.level);
	        });
	        this.messaging.receive(general_1.MessageTag.BCST_ANNOUNCEMENT).subscribe(function (m) { return _this.presentNotification(m.message); });
	        this.messaging.receive(general_1.MessageTag.RSP_CFG_QUARANTINE).subscribe(function (m) {
	            if (m.lockPending) {
	                _this.presentCountdown(admin_1.QuarantineConfigurationResponse.StandardMessage, m.secondsTillLock);
	            }
	            else {
	                _this.cancelCountdown();
	            }
	        });
	        this.messaging.receive(general_1.MessageTag.RSP_SHUTDOWN).subscribe(function (m) {
	            if (m.shutdownPending) {
	                _this.presentCountdown(admin_1.ShutdownResponse.StandardMessage, m.secondsTillShutdown);
	            }
	            else {
	                _this.cancelCountdown();
	            }
	        });
	    };
	    DebugService.prototype.disconnected = function () {
	    };
	    DebugService.prototype.handleDebugMessage = function (message) {
	        this.messages.push(message.content);
	        if (message.content.badAnswer) {
	            this.badAnswer(message.content.badAnswer);
	        }
	        if (this.level === LogLevel.Interrupt) {
	            return alert(JSON.stringify(message.content));
	        }
	        if (this.level === LogLevel.Normal) {
	            return console.log("[PresentDebugMessage]:", message.content);
	        }
	    };
	    DebugService.prototype.presentNotification = function (message, level) {
	        if (level === void 0) { level = admin_1.NotificationLevel.Info; }
	        switch (level) {
	            case admin_1.NotificationLevel.Error:
	                return this.alerts.add({ message: message, type: "error" });
	            case admin_1.NotificationLevel.Urgent:
	                return this.alerts.add({ message: message, type: "warning" });
	            default:
	                return this.alerts.add({ message: message, type: "notification" });
	        }
	    };
	    DebugService.prototype.presentCountdown = function (message, seconds) {
	        this.cancelCountdown();
	        this.countdownAlert = { message: message, type: "countdown", timeout: seconds * 1000 };
	        this.alerts.add(this.countdownAlert);
	    };
	    DebugService.prototype.cancelCountdown = function () {
	        if (this.countdownAlert) {
	            this.alerts.remove(this.countdownAlert);
	        }
	    };
	    DebugService.prototype.badAnswer = function (answer) {
	        if (answer && Number.isInteger(answer.id) && this.steps.has(answer.id)) {
	            var stepName = this.steps.get(answer.id).name;
	            this.alerts.error("The server indicated your answer for <tt>" + stepName + "</tt> was invalid");
	        }
	        else {
	            this.alerts.error("The server indicated your answer was invalid");
	        }
	    };
	    DebugService.prototype.mock = function (message) {
	        if (!this.messaging.mockInput) {
	            throw new Error("Mock input not available on MessagingService!");
	        }
	        this.messaging.mockInput.receive(message);
	    };
	    DebugService.prototype.breakpoint = function () {
	        this.messaging.send(new debug_1.DebugBreakpointUpstreamMessage()).subscribe();
	    };
	    DebugService.prototype.loadStartupTarget = function () {
	        var _this = this;
	        if (this.startupSubjectTarget) {
	            if (this.startupSubjectTarget.type === "watchlist") {
	                this.watchlist.open(this.watchlist.personalEntriesById.get(this.startupSubjectTarget.id)).subscribe(function () { return _this.alerts.success("Redirecting to debug startup target"); });
	            }
	            else {
	                throw new Error("Unknown startup target type \"" + this.startupSubjectTarget.type + "\"");
	            }
	        }
	        else {
	            return;
	        }
	    };
	    DebugService.prototype.setStartupTarget = function (subject) {
	        if (subject.incomingWatchId) {
	            this.startupSubjectTarget = {
	                type: "watchlist",
	                id: subject.incomingWatchId
	            };
	            this.storage.setWrapped(DebugService_1.SSTKey, this.startupSubjectTarget);
	        }
	        else {
	            alert("Can only set debug-startup for subjects on your watchlist");
	        }
	    };
	    DebugService.prototype.clearStartupTarget = function () {
	        this.startupSubjectTarget = null;
	        this.storage.setWrapped(DebugService_1.SSTKey, null);
	    };
	    var DebugService_1;
	    DebugService.SSTKey = "debug:startupTarget";
	    DebugService = DebugService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            router_1.ActivatedRoute,
	            alert_service_1.AlertService,
	            algorithm_step_service_1.AlgorithmStepService,
	            watchlist_service_1.WatchlistService,
	            storage_service_1.StorageService,
	            subject_service_1.SubjectService])
	    ], DebugService);
	    return DebugService;
	}());
	exports.DebugService = DebugService;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var messages_1 = __webpack_require__(754);
	var algorithms_1 = __webpack_require__(576);
	var graphs_1 = __webpack_require__(857);
	var messaging_service_1 = __webpack_require__(533);
	var step_facade_1 = __webpack_require__(752);
	var alert_service_1 = __webpack_require__(689);
	var algorithm_service_1 = __webpack_require__(213);
	var AlgorithmStepService = (function (_super) {
	    __extends(AlgorithmStepService, _super);
	    function AlgorithmStepService(messaging, algorithms, alerts) {
	        var _this = _super.call(this, messaging, algorithms) || this;
	        _this.messaging = messaging;
	        _this.algorithms = algorithms;
	        _this.alerts = alerts;
	        return _this;
	    }
	    AlgorithmStepService_1 = AlgorithmStepService;
	    AlgorithmStepService.prototype.matchesSubtype = function (step) {
	        return true;
	    };
	    AlgorithmStepService.prototype.connected = function () {
	        var _this = this;
	        this.subscriptions.add(this.messaging.receive(messages_1.MessageTag.BCST_RESTART_ALGORITHM)
	            .subscribe(function (msg) {
	            if (msg.maybeLostData) {
	                _this.alerts.error(AlgorithmStepService_1.BadDataResetMessage);
	            }
	            _this.assertRunning();
	            _this.algorithms.running.steps.deactivateAll();
	            console.warn("Deactivated all steps");
	        }));
	    };
	    AlgorithmStepService.prototype.disconnected = function () { };
	    AlgorithmStepService.prototype.all = function () {
	        this.assertRunning();
	        return this.algorithms.running.steps.all();
	    };
	    AlgorithmStepService.prototype.get = function (id) {
	        this.assertRunning();
	        return this.algorithms.running.steps.get(id);
	    };
	    AlgorithmStepService.prototype.deactivateAll = function () {
	        this.assertRunning();
	        this.algorithms.running.steps.all()
	            .forEach(function (step) { return step.isActive = false; });
	    };
	    AlgorithmStepService.prototype.requestDefinitions = function (ids) {
	        var _this = this;
	        return this.messaging.send(new graphs_1.StepDefinitionsRequest(ids)).map(function (nsm) {
	            var steps = algorithms_1.NextStepsResponse.InstantiateSteps(nsm);
	            if (_this.isRunning()) {
	                steps.forEach(function (step) {
	                    return _this.algorithms.running.steps.define(step);
	                });
	            }
	            return steps;
	        });
	    };
	    var AlgorithmStepService_1;
	    AlgorithmStepService.BadDataResetMessage = "A user provided a bad or malformed response. In order to protect data\n    integrity, the algorithm has been reset to its last saved state. If you\n    were making changes, please inspect for data loss.";
	    AlgorithmStepService = AlgorithmStepService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            algorithm_service_1.AlgorithmService,
	            alert_service_1.AlertService])
	    ], AlgorithmStepService);
	    return AlgorithmStepService;
	}(step_facade_1.StepFacade));
	exports.AlgorithmStepService = AlgorithmStepService;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var explanation_request_1 = __webpack_require__(858);
	exports.ExplanationRequest = explanation_request_1.ExplanationRequest;
	var explanation_response_1 = __webpack_require__(859);
	exports.ExplanationResponse = explanation_response_1.ExplanationResponse;
	var predecessor_steps_request_1 = __webpack_require__(860);
	exports.PredecessorStepsRequest = predecessor_steps_request_1.PredecessorStepsRequest;
	var predecessor_steps_response_1 = __webpack_require__(861);
	exports.PredecessorStepsResponse = predecessor_steps_response_1.PredecessorStepsResponse;
	var step_definitions_request_1 = __webpack_require__(862);
	exports.StepDefinitionsRequest = step_definitions_request_1.StepDefinitionsRequest;
	var successor_steps_request_1 = __webpack_require__(863);
	exports.SuccessorStepRequest = successor_steps_request_1.SuccessorStepRequest;
	var successor_steps_response_1 = __webpack_require__(864);
	exports.SuccessorStepsMessage = successor_steps_response_1.SuccessorStepsMessage;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var message_1 = __webpack_require__(516);
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var ExplanationRequest = (function (_super) {
	    __extends(ExplanationRequest, _super);
	    function ExplanationRequest(stepId, extendedGraph) {
	        if (extendedGraph === void 0) { extendedGraph = false; }
	        var _this = _super.call(this) || this;
	        _this.stepId = stepId;
	        _this.extendedGraph = extendedGraph;
	        _this.tag = message_tag_1.MessageTag.REQ_EXPLANATION;
	        return _this;
	    }
	    ExplanationRequest.prototype.verifyReply = function (reply) {
	        return message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_EXPLANATION);
	    };
	    ExplanationRequest.tag = message_tag_1.MessageTag.REQ_EXPLANATION;
	    return ExplanationRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.ExplanationRequest = ExplanationRequest;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var ExplanationResponse = (function (_super) {
	    __extends(ExplanationResponse, _super);
	    function ExplanationResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_EXPLANATION;
	        return _this;
	    }
	    return ExplanationResponse;
	}(incoming_message_1.IncomingMessage));
	exports.ExplanationResponse = ExplanationResponse;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var PredecessorStepsRequest = (function (_super) {
	    __extends(PredecessorStepsRequest, _super);
	    function PredecessorStepsRequest(ids) {
	        var _this = _super.call(this) || this;
	        _this.ids = ids;
	        _this.tag = message_tag_1.MessageTag.REQ_PREDECESSOR_STEPS;
	        return _this;
	    }
	    PredecessorStepsRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_PREDECESSOR_STEPS);
	    };
	    PredecessorStepsRequest.tag = message_tag_1.MessageTag.REQ_PREDECESSOR_STEPS;
	    return PredecessorStepsRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.PredecessorStepsRequest = PredecessorStepsRequest;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var PredecessorStepsResponse = (function (_super) {
	    __extends(PredecessorStepsResponse, _super);
	    function PredecessorStepsResponse() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_PREDECESSOR_STEPS;
	        return _this;
	    }
	    return PredecessorStepsResponse;
	}(incoming_message_1.IncomingMessage));
	exports.PredecessorStepsResponse = PredecessorStepsResponse;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var StepDefinitionsRequest = (function (_super) {
	    __extends(StepDefinitionsRequest, _super);
	    function StepDefinitionsRequest(ids) {
	        var _this = _super.call(this) || this;
	        _this.ids = ids;
	        _this.tag = message_tag_1.MessageTag.REQ_STEP_DEFINITIONS;
	        return _this;
	    }
	    StepDefinitionsRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_NEXT_STEPS);
	    };
	    StepDefinitionsRequest.tag = message_tag_1.MessageTag.REQ_STEP_DEFINITIONS;
	    return StepDefinitionsRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.StepDefinitionsRequest = StepDefinitionsRequest;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var reply_message_1 = __webpack_require__(529);
	var message_tag_1 = __webpack_require__(515);
	var SuccessorStepRequest = (function (_super) {
	    __extends(SuccessorStepRequest, _super);
	    function SuccessorStepRequest(ids) {
	        var _this = _super.call(this) || this;
	        _this.ids = ids;
	        _this.tag = message_tag_1.MessageTag.REQ_SUCCESSOR_STEPS;
	        return _this;
	    }
	    SuccessorStepRequest.prototype.verifyReply = function (reply) {
	        return reply_message_1.Message.isA(reply, message_tag_1.MessageTag.RSP_SUCCESSOR_STEPS);
	    };
	    SuccessorStepRequest.tag = message_tag_1.MessageTag.REQ_SUCCESSOR_STEPS;
	    return SuccessorStepRequest;
	}(reply_message_1.ReplyVerifyingMessage));
	exports.SuccessorStepRequest = SuccessorStepRequest;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_message_1 = __webpack_require__(522);
	var message_tag_1 = __webpack_require__(515);
	var SuccessorStepsMessage = (function (_super) {
	    __extends(SuccessorStepsMessage, _super);
	    function SuccessorStepsMessage() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.tag = message_tag_1.MessageTag.RSP_SUCCESSOR_STEPS;
	        return _this;
	    }
	    return SuccessorStepsMessage;
	}(incoming_message_1.IncomingMessage));
	exports.SuccessorStepsMessage = SuccessorStepsMessage;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var search_panel_component_1 = __webpack_require__(866);
	var search_panel_alternative_component_1 = __webpack_require__(867);
	var search_results_table_component_1 = __webpack_require__(868);
	var setting_service_1 = __webpack_require__(690);
	exports.SEARCH_COMPONENTS = [
	    search_panel_component_1.SearchPanelComponent,
	    search_panel_alternative_component_1.SearchPanelAlternativeComponent,
	    search_results_table_component_1.SearchResultsTableComponent
	];
	var SubjectSearchComponent = (function () {
	    function SubjectSearchComponent(settings) {
	        this.useExperimental = false;
	    }
	    SubjectSearchComponent.prototype.ngOnInit = function () {
	    };
	    SubjectSearchComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-sm-4\">\n          <h2>Search</h2>\n          <!-- TODO: Instructions here? -->\n          <search-panel></search-panel>\n          <!-- alt here -->\n        </div> <!-- /col -->\n        <div class=\"col-sm-8\">\n          <search-results-table></search-results-table>\n        </div> <!-- /col -->\n      </div> <!-- /row -->\n\n      <div class=\"row\">\n        <!-- search footer? -->\n      </div> <!-- /row -->\n    </div> <!-- /container -->\n"
	        }),
	        __metadata("design:paramtypes", [setting_service_1.SettingService])
	    ], SubjectSearchComponent);
	    return SubjectSearchComponent;
	}());
	exports.SubjectSearchComponent = SubjectSearchComponent;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var alert_service_1 = __webpack_require__(689);
	var functions_1 = __webpack_require__(206);
	var operators_1 = __webpack_require__(836);
	var search_node_1 = __webpack_require__(835);
	var search_service_1 = __webpack_require__(834);
	var ANIMATION_SPEED_IN = 300;
	var ANIMATION_SPEED_OUT = 300;
	var SearchPanelComponent = (function () {
	    function SearchPanelComponent(search, alert) {
	        this.search = search;
	        this.alert = alert;
	        this.answered = [];
	        this.partitions = [];
	        this.filters = [];
	        this.path = [];
	        this.canSearch = false;
	        this.allowsFreeTextOverride = new Set(["case handler"]);
	        this.unwrap = false;
	        this.onSubmit = new core_1.EventEmitter();
	        this.usingTerminalOperator = false;
	    }
	    SearchPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.form = new forms_1.FormGroup({});
	        this.opChoices = new forms_1.FormGroup({});
	        this.contextType = new forms_1.FormControl();
	        this.contextType.valueChanges.subscribe(function () {
	            _this.clear();
	        });
	        this.search.ready.subscribe(function (ready) {
	            if (ready) {
	                _this.contextType.setValue(_this.search.availableTypes[0]);
	            }
	        });
	    };
	    SearchPanelComponent.prototype.clear = function () {
	        this.truncateTo(0);
	    };
	    SearchPanelComponent.prototype.truncateTo = function (i) {
	        if (i < this.path.length) {
	            this.usingTerminalOperator = false;
	        }
	        this.path = this.path.slice(0, i);
	        while (this.answered.length > i) {
	            var removed = this.answered.pop();
	            var control = this.form.get(removed.name);
	            control.enable();
	            control.reset();
	        }
	        this.retrieveSearchFields();
	    };
	    SearchPanelComponent.prototype.retrieveSearchFields = function () {
	        var root = this.search.getRoot(this.getType());
	        var parent = root.retrieve(this.path);
	        if (!parent) {
	            console.error(this.path, root);
	            throw new Error("Provided search path is not valid");
	        }
	        this.canSearch = parent.canSearchHere();
	        this.partitions = parent.paritions;
	        this.filters = parent.filters;
	        this.generateControls();
	    };
	    SearchPanelComponent.prototype.generateControls = function () {
	        var _this = this;
	        this.partitions.forEach(function (node) { return _this.addControl(node); });
	        this.filters.forEach(function (node) { return _this.addControl(node); });
	        setTimeout(function () { return _this.focusFirst(); }, 100);
	    };
	    SearchPanelComponent.prototype.focusFirst = function () {
	        var n = (this.partitions.length > 0) ? "partition0" : "filter0";
	        var el = document.querySelector("#" + n + " .focusable");
	        if (el) {
	            el.focus();
	        }
	    };
	    SearchPanelComponent.prototype.addControl = function (node) {
	        if (!this.form.contains(node.name)) {
	            this.form.addControl(node.name, new forms_1.FormControl());
	        }
	        if (!this.opChoices.contains(node.name)) {
	            this.opChoices.addControl(node.name, new forms_1.FormControl(node.operators[0]));
	        }
	        else if (node instanceof search_node_1.PartitionNode) {
	            this.opChoices.get(node.name).setValue(operators_1.Operator.EQUALS);
	        }
	    };
	    SearchPanelComponent.prototype.supply = function (node, trySubmit) {
	        if (trySubmit === void 0) { trySubmit = false; }
	        if (functions_1.empty(this.form.get(node.name).value)) {
	            return;
	        }
	        var opField = this.opChoices.get(node.name);
	        if (opField && functions_1.valueless(opField.value)) {
	            console.info(opField);
	            return;
	        }
	        if (this.path.indexOf(node.name) > -1) {
	            return;
	        }
	        this.path.push(node.name);
	        this.answered.push(node);
	        var control = this.form.get(node.name);
	        control.disable();
	        if (opField && operators_1.isInequality(opField.value)) {
	            this.usingTerminalOperator = true;
	            this.partitions = [];
	            this.filters = [];
	        }
	        else {
	            this.retrieveSearchFields();
	        }
	        if (trySubmit && node.canSearchHere()) {
	            console.log("Attempting submit");
	            this.submit();
	        }
	    };
	    SearchPanelComponent.prototype.getType = function () {
	        return this.enforcedType || this.contextType.value;
	    };
	    SearchPanelComponent.prototype.submit = function () {
	        var _this = this;
	        var terms = this.path.map(function (name) {
	            var opField = _this.opChoices.get(name);
	            if (opField) {
	                if (opField.value instanceof operators_1.MagicOperator) {
	                    return opField.value.transform(name, _this.form.get(name).value);
	                }
	                return {
	                    name: name,
	                    operator: opField.value,
	                    value: _this.form.get(name).value
	                };
	            }
	            else {
	                return {
	                    name: name,
	                    operator: operators_1.Operator.EQUALS,
	                    value: _this.form.get(name).value
	                };
	            }
	        });
	        this.onSubmit.emit([this.getType(), terms]);
	        this.search.runQuery(this.getType(), terms);
	    };
	    SearchPanelComponent.prototype.substituteMagic = function (filter) {
	        var op = this.opChoices.get(filter.name);
	        if (op && op.value instanceof operators_1.MagicOperator) {
	            return {
	                name: filter.name + "-" + op.value.name,
	                type: op.value.argumentType,
	                cardinality: 1,
	                value: null,
	                restrictions: [],
	                hints: {}
	            };
	        }
	        return filter;
	    };
	    SearchPanelComponent.prototype.hasOpValue = function (node) {
	        return (!!this.opChoices.get(node.name));
	    };
	    SearchPanelComponent.prototype.operatorLabel = function (node, op) {
	        if (!op) {
	            if (!this.opChoices.get(node.name)) {
	                throw Error("Could not find operator selection for " + node.name);
	            }
	            op = this.opChoices.get(node.name).value;
	        }
	        return operators_1.Operator.labelFor(op, node);
	    };
	    SearchPanelComponent.prototype.runRecentQuery = function (i) {
	        this.search.runRecentQuery(this.search.recentSearches.size() - i - 1);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], SearchPanelComponent.prototype, "enforcedType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SearchPanelComponent.prototype, "unwrap", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], SearchPanelComponent.prototype, "onSubmit", void 0);
	    SearchPanelComponent = __decorate([
	        core_1.Component({
	            selector: "search-panel",
	            template: "\n    <div [class.well]=\"!unwrap\">\n      <div *ngIf=\"!enforcedType\" class=\"form-group well-top\">\n        <select [formControl]=\"contextType\" class=\"form-control\">\n          <option\n            *ngFor=\"let type of search.availableTypes\"\n            class=\"uppercase\">\n            {{type}}\n          </option>\n        </select>\n        <hr>\n      </div>\n\n      <template [ngIf]=\"answered.length > 0\">\n        <h4>Query</h4>\n      </template>\n      <div\n        *ngFor=\"let field of answered; let i = index\"\n        class=\"row fieldEntry\"\n        @fadeInOut>\n        <div class=\"col-xs-12\">\n          <label>\n            {{field.displayName | uppercase}}\n            <em *ngIf=\"hasOpValue(field)\">\n              {{operatorLabel(field)}}\n            </em>\n          </label>\n          <a class=\"pull-right text-danger\" (click)=\"truncateTo(i)\">Remove</a>\n          <typed-control\n            [input]=\"substituteMagic(field)\"\n            [control]=\"form.get(field.name)\"\n            [clearButton]=\"false\">\n          </typed-control>\n        </div>\n      </div>\n\n      <template [ngIf]=\"partitions.length > 0\">\n        <hr *ngIf=\"answered.length > 0\"/>\n        <h4>Search Terms</h4>\n      </template>\n      <div\n        *ngFor=\"let partition of partitions; let i = index\"\n        class=\"row fieldEntry searchTerm\"\n        @fadeInOut>\n        <div class=\"col-xs-12\" #term>\n          <label>\n            {{partition.displayName | uppercase}}\n            <div\n              *ngIf=\"allowsFreeTextOverride.has(partition.name)\"\n              class=\"pull-right\">\n              <button\n                class=\"btn btn-default btn-xs\"\n                (click)=\"term.forceFreeText = !term.forceFreeText\">\n                Toggle free text\n              </button>\n            </div>\n          </label>\n          <typed-control\n            [id]=\"'partition' + i\"\n            [input]=\"partition\"\n            [control]=\"form.get(partition.name)\"\n            [clearButton]=\"false\"\n            [disableRestrictions]=\"term.forceFreeText\"\n            (change)=\"supply(partition)\"\n            (keydown.enter)=\"supply(partition, true)\">\n          </typed-control>\n        </div>\n      </div>\n\n      <template [ngIf]=\"filters.length > 0\">\n        <hr/>\n        <h4>Filters</h4>\n      </template>\n      <div\n        *ngFor=\"let filter of filters; let i = index\"\n        class=\"row fieldEntry\"\n        @fadeInOut>\n        <div class=\"col-xs-12\">\n          <table width=\"100%\">\n            <tr>\n              <th>\n                {{filter.displayName | uppercase}}\n              </th>\n              <td>\n                <select\n                  *ngIf=\"filter.operators?.length > 1\"\n                  class=\"form-control input-sm\"\n                  [formControl]=\"opChoices.get(filter.name)\">\n                  <option\n                    *ngFor=\"let op of filter.operators\"\n                    [ngValue]=\"op\">\n                    {{operatorLabel(filter, op)}}\n                  </option>\n                </select>\n              </td>\n            </tr>\n          </table>\n          <typed-control\n            [id]=\"'filter' + i\"\n            [input]=\"substituteMagic(filter)\"\n            [control]=\"form.get(filter.name)\"\n            [clearButton]=\"false\"\n            (change)=\"supply(filter)\"\n            (keydown.enter)=\"supply(filter, true)\">\n          </typed-control>\n        </div>\n      </div>\n\n      <table *ngIf=\"usingTerminalOperator\" class=\"table center-items text-info\">\n        <tr>\n          <td>\n            <h1><span class=\"glyphicon glyphicon-info-sign\"></span></h1>\n          </td>\n          <td>\n            Tip: you can only add an \"inexact\" selection (such as greater than,\n            less than, before, or after) as the last item in your search. If\n            you wish to add other \"exact\" selections, please add them first.\n          </td>\n        </tr>\n      </table>\n\n      <div class=\"row\">\n        <div class=\"col-xs-6 form-group\">\n          <button\n            class=\"btn btn-default\"\n            (click)=\"clear()\">\n            Clear Query\n          </button>\n        </div>\n        <div class=\"col-xs-6 form-group\">\n          <button\n            type=\"submit\"\n            class=\"btn btn-primary\"\n            (click)=\"submit()\"\n            [disabled]=\"!canSearch\">\n            Search\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <h2>\n      Saved Searches\n      <button\n        class=\"btn-sm btn-success pull-right\"\n        [disabled]=\"!search.resultTime\"\n        (click)=\"search.saveSearch()\">\n        Save Last Query\n      </button>\n    </h2>\n    <em *ngIf=\"search.savedSearches.length === 0\">\n      No saved searches found on this device.\n    </em>\n    <div *ngFor=\"let saved of search.savedSearches; let i = index\" class=\"well\">\n      <table class=\"table table-sm\">\n        <tr class=\"text-info\">\n          <td>\n            <button\n              class=\"btn btn-primary btn-xs\"\n              (click)=\"search.runSaved(i)\">\n              <span class=\"glyphicon glyphicon-search\"></span> Run\n            </button>\n          </td>\n          <td>\n            <button\n              class=\"btn btn-danger btn-xs\"\n              (click)=\"search.deleteSaved(i)\">\n              <span class=\"glyphicon glyphicon-times\"></span> Remove\n            </button>\n          </td>\n          <th>\n            {{saved.name}}\n          </th>\n        <tr>\n          <th>type</th>\n          <td>=</td>\n          <td>{{saved.type}}</td>\n        </tr>\n        <tr *ngFor=\"let term of saved.terms\">\n          <th>{{term.name}}</th>\n          <td>{{term.magicSource ? \"\u225B\" : term.operator}}</td>\n          <td *ngIf=\"term.magicSource\">\n              {{term.magicSource[0]?.label}}\n              ({{term.magicSource[1]}})\n          </td>\n          <td *ngIf=\"!term.magicSource\">\n            <span *ngIf=\"term?.value?.setTime\">\n              <!-- poor man's Date duck-typing TODO: replace -->\n              {{term.value | utcDate}}\n            </span>\n            <span *ngIf=\"!term?.value?.setTime\">{{term.value | json}}</span>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <h2 *ngIf=\"search.recentSearches.size() > 0\">\n      Recent Queries\n      <button\n        class=\"btn-sm btn-default pull-right\"\n        (click)=\"search.clearRecents()\">\n        Clear\n      </button>\n    </h2>\n    <div\n      *ngFor=\"let recent of search.recentSearches | reverse; let i = index\"\n      class=\"well\">\n      <table class=\"table table-sm\">\n        <tr class=\"text-info\">\n          <td>\n            <button\n              class=\"btn btn-primary btn-xs\"\n              (click)=\"runRecentQuery(i)\">\n              <span class=\"glyphicon glyphicon-search\"></span> Re-Run\n            </button>\n          </td>\n          <td></td>\n          <th>\n            {{recent[4] ? \"More than\" : \"\"}}\n            {{recent[2] | plural:\"result\"}}\n            <span class=\"pull-right\">{{recent[3] | date:\"mediumTime\"}}</span>\n          </th>\n        <tr>\n          <th>type</th>\n          <td>=</td>\n          <td>{{recent[0]}}</td>\n        </tr>\n        <tr *ngFor=\"let term of recent[1]\">\n          <th>{{term.name}}</th>\n          <td>{{term.magicSource ? \"\u225B\" : term.operator}}</td>\n          <td *ngIf=\"term.magicSource\">\n              {{term.magicSource[0]?.label}}\n              ({{term.magicSource[1]}})\n          </td>\n          <td *ngIf=\"!term.magicSource\">\n            <span *ngIf=\"term?.value?.setTime\">\n              <!-- poor man's Date duck-typing TODO: replace -->\n              {{term.value | utcDate}}\n            </span>\n            <span *ngIf=\"!term?.value?.setTime\">{{term.value | json}}</span>\n          </td>\n        </tr>\n      </table>\n    </div>\n",
	            styles: [
	                ".fieldEntry {\n      overflow: hidden;\n    }\n    .searchTerm label {\n      width: 100%;\n    }\n    .fieldEntry >>> .form-group {\n      margin-top: 0px;\n    }\n    .well {\n      padding: 5px 19px;\n    }\n    h4 {\n      font-style: italic;\n    }\n    .form-group > button {\n      width: 100%;\n    }\n    .well-top {\n      margin: auto -14px;\n    }\n    td>.btn:only-child {\n      width: 100%;\n    }"
	            ],
	            animations: [
	                core_1.trigger("fadeInOut", [])
	            ]
	        }),
	        __metadata("design:paramtypes", [search_service_1.SearchService,
	            alert_service_1.AlertService])
	    ], SearchPanelComponent);
	    return SearchPanelComponent;
	}());
	exports.SearchPanelComponent = SearchPanelComponent;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var alert_service_1 = __webpack_require__(689);
	var functions_1 = __webpack_require__(206);
	var operators_1 = __webpack_require__(836);
	var search_node_1 = __webpack_require__(835);
	var search_service_1 = __webpack_require__(834);
	var ANIMATION_SPEED_IN = 300;
	var ANIMATION_SPEED_OUT = 300;
	var SearchPanelAlternativeComponent = (function () {
	    function SearchPanelAlternativeComponent(search, alert) {
	        this.search = search;
	        this.alert = alert;
	        this.partitions = [];
	        this.filters = [];
	        this.path = [];
	        this.canSearch = false;
	        this.allowsFreeTextOverride = new Set(["case handler"]);
	        this.unwrap = false;
	        this.onSubmit = new core_1.EventEmitter();
	        this.usingTerminalOperator = false;
	        this.opts = [];
	    }
	    SearchPanelAlternativeComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.form = new forms_1.FormGroup({});
	        this.opChoices = new forms_1.FormGroup({});
	        this.currentIndex = new forms_1.FormControl();
	        this.currentIndex.valueChanges.subscribe(function () {
	            _this.clear();
	        });
	        this.search.ready.subscribe(function (ready) {
	            if (ready) {
	                _this.opts =
	                    _this.search.rootByType.get(_this.search.availableTypes[0]).generateFlatOptions([]);
	                _this.currentIndex.setValue(_this.opts[0]);
	            }
	        });
	    };
	    SearchPanelAlternativeComponent.prototype.displayIndex = function (index) {
	        return index.map(function (n) {
	            return (n instanceof search_node_1.SearchRoot) ? "(healthcare benefits)" : n.name;
	        }).join(" > ");
	    };
	    SearchPanelAlternativeComponent.prototype.clear = function () {
	        this.canSearch = false;
	        this.partitions = [];
	        this.filters = [];
	        this.path = [];
	        this.generateControls();
	    };
	    SearchPanelAlternativeComponent.prototype.generateControls = function () {
	        var _this = this;
	        var index = this.currentIndex.value;
	        if (Array.isArray(index)) {
	            index.forEach(function (node) {
	                if (node instanceof search_node_1.PartitionNode) {
	                    _this.partitions.push(node);
	                    _this.addControl(node);
	                }
	                else if (node instanceof search_node_1.FilterNode) {
	                    _this.filters.push(node);
	                    _this.addControl(node);
	                }
	            });
	        }
	        setTimeout(function () { return _this.focusFirst(); }, 100);
	    };
	    SearchPanelAlternativeComponent.prototype.focusFirst = function () {
	        var n = (this.partitions.length > 0) ? "partition0" : "filter0";
	        var el = document.querySelector("#" + n + " .focusable");
	        if (el) {
	            el.focus();
	        }
	    };
	    SearchPanelAlternativeComponent.prototype.addControl = function (node) {
	        if (!this.form.contains(node.name)) {
	            this.form.addControl(node.name, new forms_1.FormControl());
	        }
	        if (!this.opChoices.contains(node.name)) {
	            this.opChoices.addControl(node.name, new forms_1.FormControl(node.operators[0]));
	        }
	        else if (node instanceof search_node_1.PartitionNode) {
	            this.opChoices.get(node.name).setValue(operators_1.Operator.EQUALS);
	        }
	    };
	    SearchPanelAlternativeComponent.prototype.supply = function (node, trySubmit) {
	        if (trySubmit === void 0) { trySubmit = false; }
	        if (functions_1.empty(this.form.get(node.name).value)) {
	            return;
	        }
	        var opField = this.opChoices.get(node.name);
	        if (opField && functions_1.valueless(opField.value)) {
	            console.info(opField);
	            return;
	        }
	        if (this.path.indexOf(node.name) > -1) {
	            return;
	        }
	        this.path.push(node.name);
	        this.canSearch = this.allFilled();
	        if (trySubmit && this.canSearch) {
	            console.log("Attempting submit");
	            this.submit();
	        }
	    };
	    SearchPanelAlternativeComponent.prototype.allFilled = function () {
	        this.path.length = this.partitions.length + this.filters.length;
	        return true;
	    };
	    SearchPanelAlternativeComponent.prototype.getType = function () {
	        return this.enforcedType || this.currentIndex.value;
	    };
	    SearchPanelAlternativeComponent.prototype.submit = function () {
	        var _this = this;
	        var terms = this.path.map(function (name) {
	            var opField = _this.opChoices.get(name);
	            if (opField) {
	                if (opField.value instanceof operators_1.MagicOperator) {
	                    return opField.value.transform(name, _this.form.get(name).value);
	                }
	                return {
	                    name: name,
	                    operator: opField.value,
	                    value: _this.form.get(name).value
	                };
	            }
	            else {
	                return {
	                    name: name,
	                    operator: operators_1.Operator.EQUALS,
	                    value: _this.form.get(name).value
	                };
	            }
	        });
	        this.onSubmit.emit([this.getType(), terms]);
	        this.search.runQuery(this.getType(), terms);
	    };
	    SearchPanelAlternativeComponent.prototype.substituteMagic = function (filter) {
	        var op = this.opChoices.get(filter.name);
	        if (op && op.value instanceof operators_1.MagicOperator) {
	            return {
	                name: filter.name + "-" + op.value.name,
	                type: op.value.argumentType,
	                cardinality: 1,
	                value: null,
	                restrictions: [],
	                hints: {}
	            };
	        }
	        return filter;
	    };
	    SearchPanelAlternativeComponent.prototype.hasOpValue = function (node) {
	        return (!!this.opChoices.get(node.name));
	    };
	    SearchPanelAlternativeComponent.prototype.operatorLabel = function (node, op) {
	        if (!op) {
	            if (!this.opChoices.get(node.name)) {
	                throw Error("Could not find operator selection for " + node.name);
	            }
	            op = this.opChoices.get(node.name).value;
	        }
	        return operators_1.Operator.labelFor(op, node);
	    };
	    SearchPanelAlternativeComponent.prototype.runRecentQuery = function (i) {
	        this.search.runRecentQuery(this.search.recentSearches.size() - i - 1);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], SearchPanelAlternativeComponent.prototype, "enforcedType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SearchPanelAlternativeComponent.prototype, "unwrap", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], SearchPanelAlternativeComponent.prototype, "onSubmit", void 0);
	    SearchPanelAlternativeComponent = __decorate([
	        core_1.Component({
	            selector: "search-panel-alternative",
	            template: "\n    <div [class.well]=\"!unwrap\">\n      <div *ngIf=\"!enforcedType\" class=\"form-group well-top\">\n        <select [formControl]=\"currentIndex\" class=\"form-control\">\n          <option\n            *ngFor=\"let opt of opts\"\n            class=\"uppercase\"\n            [ngValue]=\"opt\">\n            {{displayIndex(opt)}}\n          </option>\n        </select>\n        <hr>\n      </div>\n\n      <p class=\"debug-only\"><em>\n        This is a preview of an experimental interface. It is expected to have\n        bugs or other oddities. Please only use this for testing and feedback.\n      </em></p>\n\n      <template [ngIf]=\"partitions.length > 0\">\n        <h4>Search Terms</h4>\n      </template>\n      <div\n        *ngFor=\"let partition of partitions; let i = index\"\n        class=\"row fieldEntry searchTerm\"\n        @fadeInOut>\n        <div class=\"col-xs-12\" #term>\n          <label>\n            {{partition.displayName | uppercase}}\n            <div\n              *ngIf=\"allowsFreeTextOverride.has(partition.name)\"\n              class=\"pull-right\">\n              <button\n                class=\"btn btn-default btn-xs\"\n                (click)=\"term.forceFreeText = !term.forceFreeText\">\n                Toggle free text\n              </button>\n            </div>\n          </label>\n          <typed-control\n            [id]=\"'partition' + i\"\n            [input]=\"partition\"\n            [control]=\"form.get(partition.name)\"\n            [clearButton]=\"false\"\n            [disableRestrictions]=\"term.forceFreeText\"\n            (change)=\"supply(partition)\"\n            (keydown.enter)=\"supply(partition, true)\">\n          </typed-control>\n        </div>\n      </div>\n\n      <template [ngIf]=\"filters.length > 0\">\n        <hr/>\n        <h4>Filters</h4>\n      </template>\n      <div\n        *ngFor=\"let filter of filters; let i = index\"\n        class=\"row fieldEntry\"\n        @fadeInOut>\n        <div class=\"col-xs-12\">\n          <table width=\"100%\">\n            <tr>\n              <th>\n                {{filter.displayName | uppercase}}\n              </th>\n              <td>\n                <select\n                  *ngIf=\"filter.operators?.length > 1\"\n                  class=\"form-control input-sm\"\n                  [formControl]=\"opChoices.get(filter.name)\">\n                  <option\n                    *ngFor=\"let op of filter.operators\"\n                    [ngValue]=\"op\">\n                    {{operatorLabel(filter, op)}}\n                  </option>\n                </select>\n              </td>\n            </tr>\n          </table>\n          <typed-control\n            [id]=\"'filter' + i\"\n            [input]=\"substituteMagic(filter)\"\n            [control]=\"form.get(filter.name)\"\n            [clearButton]=\"false\"\n            (change)=\"supply(filter)\"\n            (keydown.enter)=\"supply(filter, true)\">\n          </typed-control>\n        </div>\n      </div>\n\n      <table *ngIf=\"usingTerminalOperator\" class=\"table center-items text-info\">\n        <tr>\n          <td>\n            <h1><span class=\"glyphicon glyphicon-info-sign\"></span></h1>\n          </td>\n          <td>\n            Tip: you can only add an \"inexact\" selection (such as greater than,\n            less than, before, or after) as the last item in your search. If\n            you wish to add other \"exact\" selections, please add them first.\n          </td>\n        </tr>\n      </table>\n\n      <div class=\"row\">\n        <div class=\"col-xs-6 form-group\">\n          <button\n            class=\"btn btn-default\"\n            (click)=\"clear()\">\n            Clear Query\n          </button>\n        </div>\n        <div class=\"col-xs-6 form-group\">\n          <button\n            type=\"submit\"\n            class=\"btn btn-primary\"\n            (click)=\"submit()\"\n            [disabled]=\"!canSearch\">\n            Search\n          </button>\n        </div>\n      </div>\n    </div>\n\n",
	            styles: [
	                ".fieldEntry {\n      overflow: hidden;\n    }\n    .searchTerm label {\n      width: 100%;\n    }\n    .fieldEntry >>> .form-group {\n      margin-top: 0px;\n    }\n    .well {\n      padding: 5px 19px;\n    }\n    h4 {\n      font-style: italic;\n    }\n    .form-group > button {\n      width: 100%;\n    }\n    .well-top {\n      margin: auto -14px;\n    }\n    td>.btn:only-child {\n      width: 100%;\n    }"
	            ],
	            animations: [
	                core_1.trigger("fadeInOut", [])
	            ]
	        }),
	        __metadata("design:paramtypes", [search_service_1.SearchService,
	            alert_service_1.AlertService])
	    ], SearchPanelAlternativeComponent);
	    return SearchPanelAlternativeComponent;
	}());
	exports.SearchPanelAlternativeComponent = SearchPanelAlternativeComponent;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var algorithm_service_1 = __webpack_require__(213);
	var alert_service_1 = __webpack_require__(689);
	var search_service_1 = __webpack_require__(834);
	var SearchResultsTableComponent = (function () {
	    function SearchResultsTableComponent(search, alert, algorithms) {
	        this.search = search;
	        this.alert = alert;
	        this.algorithms = algorithms;
	        this.instantThreshold = 0.05;
	        this.asSelector = false;
	        this.showTitle = true;
	        this.selection = new core_1.EventEmitter();
	    }
	    SearchResultsTableComponent.prototype.clearResults = function () {
	        this.search.clearResults();
	    };
	    SearchResultsTableComponent.prototype.open = function (result, target) {
	        var _this = this;
	        this.search.open(result, !this.asSelector, target).subscribe(function (subject) { return _this.selection.emit(subject); });
	    };
	    SearchResultsTableComponent.prototype.openDefault = function (result) {
	        var target = this.algorithms.defaultForOpen(this.search.resultContextType);
	        this.open(result, target);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SearchResultsTableComponent.prototype, "asSelector", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SearchResultsTableComponent.prototype, "showTitle", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], SearchResultsTableComponent.prototype, "selection", void 0);
	    SearchResultsTableComponent = __decorate([
	        core_1.Component({
	            selector: "search-results-table",
	            template: "\n    <h3 *ngIf=\"showTitle\">\n      Search Results\n    </h3>\n    <p *ngIf=\"!search.running && search.resultTime\">\n      The query found\n      {{search.resultCountLabel}}.\n      The last request\n      <span *ngIf=\"search.executionSeconds > instantThreshold\">\n        took\n        <span [class.text-danger]=\"search.executionSeconds > 1\">\n          {{search.executionSeconds}}\n        </span>\n        seconds\n      </span>\n      <span *ngIf=\"search.executionSeconds < instantThreshold\">\n        was instantaneous\n      </span>\n      and finished at\n      {{search.resultTime | date:\"mediumTime\"}}.\n    </p>\n    <!--<em *ngIf=\"search.lastResultOpened !== null\">\n      The last result you opened is highlighted. (It may be on another page.)\n    </em>-->\n    <table *ngIf=\"!search.running\" class=\"table table-striped table-responsive\">\n      <thead *ngIf=\"search.results?.length > 0\">\n        <tr>\n          <!--<th>Record ID</th>-->\n          <th\n            *ngFor=\"let column of search.results[0]?.columns; let i = index\"\n            [sorts]=\"search.results\"\n            [dot]=\"'columns.' + i\"\n            class=\"capitalized\">\n            {{column.name}}\n          </th>\n          <th>\n            <button\n              class=\"btn btn-default\"\n              (click)=\"clearResults()\">\n              Clear results\n            </button>\n          </th>\n        </tr>\n      </thead>\n      <tbody *ngIf=\"search.results\">\n        <tr\n          *ngFor=\"let result of (search.results | paginate)\"\n          [class.bg-warning]=\"result === search.lastResultOpened\">\n          <!--<th>{{result.recordId}}</th>-->\n          <td *ngFor=\"let data of result.columns\">\n            <typed-display [input]=\"data\"></typed-display>\n          </td>\n          <td>\n            <!-- link needs generalization if page used for other searches -->\n            <button\n              *ngIf=\"result.recordId === null\"\n              class=\"btn btn-primary form-control\"\n              disabled\n              title=\"You do not have permission to view this data\"\n              (click)=\"alert('You do not have permission to view this data')\">\n              Open\n            </button>\n            <a\n              *ngIf=\"result.recordId !== null && asSelector\"\n              class=\"btn btn-primary form-control\"\n              (click)=\"open(result)\">\n              Open\n\t\t\t</a>\n\t\t\t<div\n\t\t\t\t#openOptions\n\t\t\t\t*ngIf=\"result.recordId !== null && !asSelector\"\n\t\t\t\tclass=\"btn-group\"\n\t\t\t\t[class.open]=\"openOptions.open\"\n\t\t\t\t(mouseleave)=\"openOptions.open = false\">\n\t\t\t\t<a \n\t\t\t\t\tclass=\"btn btn-primary\"\n\t\t\t\t\t(click)=\"openDefault(result)\">\n\t\t\t\t\t<span class=\"hidden-sm hidden-xs\">Open</span>\n\t\t\t\t\t<span\n\t\t\t\t\tclass=\"hidden-md hidden-lg glyphicon glyphicon-folder-open\">\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-primary dropdown-toggle\"\n\t\t\t\t\tdata-toggle=\"dropdown\"\n\t\t\t\t\taria-haspopup=\"true\"\n\t\t\t\t\t[attr.aria-expanded]=\"!!openOptions.open\"\n\t\t\t\t\t(click)=\"openOptions.open = !openOptions.open\">\n\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t</button>\n        <ul class=\"dropdown-menu right-edge\">\n          <li>\n            <a (click)=\"open(result, null)\">\n              Summary Page\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n\t\t\t\t\t<li *ngFor=\"let alg of algorithms.bySCType(search.resultContextType)\">\n\t\t\t\t\t\t<a (click)=\"open(result, alg)\">\n\t\t\t\t\t\t\t{{alg.displayName}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n          </td>\n        </tr>\n        <tr *ngIf=\"search.moreResultsAvailable && (search.results | onPage : -1)\">\n          <td colspan=\"100\" class=\"text-center\">\n            <button\n              class=\"btn btn-default\"\n              (click)=\"search.requestMoreResults()\">\n              Request more results...\n            </button>\n        </tr>\n      </tbody>\n      <caption\n        *ngIf=\"search.results && search.results.length === 0\">\n        No results\n      </caption>\n      <caption *ngIf=\"!search.results\">\n        You haven't searched yet.\n      </caption>\n    </table>\n    <spinner *ngIf=\"search.running\"></spinner>\n    <pager\n      *ngIf=\"search.results?.length\"\n      [array]=\"search.results\"\n      [jumpButtons]=\"true\">\n    </pager>\n",
	            styles: [
	                "caption {\n      caption-side: bottom;\n      text-align: center;\n      font-size: 2em;\n      font-style: italic;\n      padding: 0.5em;\n    }\n    table.table>tbody>tr>td {\n      vertical-align: middle;\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [search_service_1.SearchService,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService])
	    ], SearchResultsTableComponent);
	    return SearchResultsTableComponent;
	}());
	exports.SearchResultsTableComponent = SearchResultsTableComponent;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var GuardedComponentlessRouteWorkaroundComponent = (function () {
	    function GuardedComponentlessRouteWorkaroundComponent() {
	    }
	    GuardedComponentlessRouteWorkaroundComponent = __decorate([
	        core_1.Component({
	            template: "<router-outlet></router-outlet>"
	        })
	    ], GuardedComponentlessRouteWorkaroundComponent);
	    return GuardedComponentlessRouteWorkaroundComponent;
	}());
	exports.GuardedComponentlessRouteWorkaroundComponent = GuardedComponentlessRouteWorkaroundComponent;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var algorithm_service_1 = __webpack_require__(213);
	var configuration_service_1 = __webpack_require__(512);
	var subject_service_1 = __webpack_require__(821);
	var HomeComponent = (function () {
	    function HomeComponent(config, subjects, algorithms) {
	        this.config = config;
	        this.subjects = subjects;
	        this.algorithms = algorithms;
	    }
	    HomeComponent.prototype.startDefault = function () {
	        this.subjects.launchNew(this.algorithms.createable[0]);
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"container\">\n      <div class=\"row\"><div class=\"col-sm-12\">\n        <announcements></announcements>\n      </div></div>\n      <div class=\"row\">\n        <div [className]=\"config.client.type === 'guest' ? 'col-sm-6' : 'col-sm-4'\">\n          <user-profile></user-profile>\n        </div>\n\n        <div *ngIf=\"config.client.type !== 'guest'\" class=\"col-sm-8\">\n          <reminder-list [showHeaders]=\"false\"></reminder-list>\n        </div>\n\n        <div *ngIf=\"config.client.type !== 'guest'\" class=\"col-sm-12\">\n          <watchlist></watchlist>\n        </div>\n\n        <div *ngIf=\"config.client.type === 'guest'\" class=\"col-sm-6\" style=\"display: flex; flex-direction: column; min-height: 350px;justify-content: center;\">\n          <div class=\"well\">\n            <h4>Looking for the form?</h4>\n            <p>You can access the intake form by clicking the \"Restart\" button in the navigation bar, or use the one below.</p>\n            <button class=\"w100 btn btn-success\" (click)=\"startDefault()\">\n              Start New intake\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n",
	            styles: [""]
	        }),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService,
	            subject_service_1.SubjectService,
	            algorithm_service_1.AlgorithmService])
	    ], HomeComponent);
	    return HomeComponent;
	}());
	exports.HomeComponent = HomeComponent;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var algorithm_service_1 = __webpack_require__(213);
	var AdminZoneGuard = (function () {
	    function AdminZoneGuard(algorithms) {
	        this.algorithms = algorithms;
	    }
	    AdminZoneGuard.prototype.run = function () {
	        return this.algorithms.zoneIsAdmin;
	    };
	    AdminZoneGuard.prototype.canActivate = function () {
	        return this.run();
	    };
	    AdminZoneGuard.prototype.canLoad = function () {
	        return this.run();
	    };
	    AdminZoneGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [algorithm_service_1.AlgorithmService])
	    ], AdminZoneGuard);
	    return AdminZoneGuard;
	}());
	exports.AdminZoneGuard = AdminZoneGuard;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var algorithm_service_1 = __webpack_require__(213);
	var alert_service_1 = __webpack_require__(689);
	var AlgorithmRunningGuard = (function () {
	    function AlgorithmRunningGuard(router, alerts, algorithms) {
	        this.router = router;
	        this.alerts = alerts;
	        this.algorithms = algorithms;
	    }
	    AlgorithmRunningGuard.prototype.hasParamAlgorithm = function (rt) {
	        return ("algorithm" in rt.params);
	    };
	    AlgorithmRunningGuard.prototype.canActivate = function (route) {
	        if (this.algorithms.isRunning
	            && this.hasParamAlgorithm(route)
	            && this.algorithms.running.algorithm.name === route.params.algorithm) {
	            this.algorithmAtLastActivate = this.algorithms.running;
	            document.body.className = this.algorithms.running.name || "";
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    AlgorithmRunningGuard.prototype.canDeactivate = function (component) {
	        var _this = this;
	        return (this.algorithms.release(this.algorithmAtLastActivate)
	            .defaultIfEmpty(true)
	            .do(function () {
	            _this.algorithmAtLastActivate = null;
	            document.body.className = "a-none";
	        }));
	    };
	    AlgorithmRunningGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router,
	            alert_service_1.AlertService,
	            algorithm_service_1.AlgorithmService])
	    ], AlgorithmRunningGuard);
	    return AlgorithmRunningGuard;
	}());
	exports.AlgorithmRunningGuard = AlgorithmRunningGuard;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var auth_service_1 = __webpack_require__(777);
	var AuthGuard = (function () {
	    function AuthGuard(router, auth) {
	        this.router = router;
	        this.auth = auth;
	    }
	    AuthGuard.prototype.hasRedirectTarget = function (data) {
	        return (data && typeof data.post_auth_redirect === "string");
	    };
	    AuthGuard.prototype.run = function (data, url) {
	        if (this.auth.authenticated) {
	            return true;
	        }
	        if (this.hasRedirectTarget(data)) {
	            this.auth.redirectTo = [data.post_auth_redirect];
	        }
	        else {
	            this.auth.redirectTo = [url];
	        }
	        console.log("redir to", this.auth.redirectTo);
	        this.router.navigate(["/login"]);
	        return false;
	    };
	    AuthGuard.prototype.canActivate = function (route, state) {
	        return this.run(route.data, state.url);
	    };
	    AuthGuard.prototype.canLoad = function (route) {
	        return this.run(route.data, "/home");
	    };
	    AuthGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router, auth_service_1.AuthService])
	    ], AuthGuard);
	    return AuthGuard;
	}());
	exports.AuthGuard = AuthGuard;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var build_flags_1 = __webpack_require__(534);
	var DebugModeGuard = (function () {
	    function DebugModeGuard() {
	    }
	    DebugModeGuard.prototype.canActivate = function () {
	        return build_flags_1.BuildFlags.debugMode;
	    };
	    DebugModeGuard = __decorate([
	        core_1.Injectable()
	    ], DebugModeGuard);
	    return DebugModeGuard;
	}());
	exports.DebugModeGuard = DebugModeGuard;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var auth_service_1 = __webpack_require__(777);
	var GuestsOnlyGuard = (function () {
	    function GuestsOnlyGuard(auth) {
	        this.auth = auth;
	    }
	    GuestsOnlyGuard.prototype.canActivate = function (route, state) {
	        return !this.auth.authenticated;
	    };
	    GuestsOnlyGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [auth_service_1.AuthService])
	    ], GuestsOnlyGuard);
	    return GuestsOnlyGuard;
	}());
	exports.GuestsOnlyGuard = GuestsOnlyGuard;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var user_service_1 = __webpack_require__(713);
	var functions_1 = __webpack_require__(206);
	var RuleRestrictedGuard = (function () {
	    function RuleRestrictedGuard(users) {
	        this.users = users;
	    }
	    RuleRestrictedGuard.prototype.run = function (data) {
	        var _this = this;
	        if (!Array.isArray(data.rules)) {
	            console.error(data);
	            throw new Error("Guard requires route data to contain 'rules' list");
	        }
	        return this.users.ready.first(functions_1.identity).map(function () { return functions_1.arrayIntersects(data.rules, _this.users.self.aggregateRules); });
	    };
	    RuleRestrictedGuard.prototype.canActivate = function (route, state) {
	        return this.run(route.data);
	    };
	    RuleRestrictedGuard.prototype.canLoad = function (route) {
	        return this.run(route.data);
	    };
	    RuleRestrictedGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [user_service_1.UserService])
	    ], RuleRestrictedGuard);
	    return RuleRestrictedGuard;
	}());
	exports.RuleRestrictedGuard = RuleRestrictedGuard;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var subject_service_1 = __webpack_require__(821);
	var watchlist_service_1 = __webpack_require__(842);
	var SubjectLoadedGuard = (function () {
	    function SubjectLoadedGuard(subjects, watchlist, alerts) {
	        this.subjects = subjects;
	        this.watchlist = watchlist;
	        this.alerts = alerts;
	    }
	    SubjectLoadedGuard.prototype.hasParamId = function (rt) {
	        return ("id" in rt.params);
	    };
	    SubjectLoadedGuard.prototype.canActivate = function (route) {
	        if (this.hasParamId(route)) {
	            var subj = this.subjects.byServerId(+route.params.id);
	            if (subj && subj.loaded) {
	                return true;
	            }
	            else {
	                this.alerts.error("Could not find a loaded subject " + route.params.id);
	                return false;
	            }
	        }
	        else {
	            this.alerts.error("Cannot open subject—ID missing or unreadable");
	            return false;
	        }
	    };
	    SubjectLoadedGuard.prototype.resolve = function (route) {
	        if (!this.hasParamId(route)) {
	            throw new Error("ID parameter missing in resolve guard.");
	        }
	        return this.subjects.byServerId(+route.params.id);
	    };
	    SubjectLoadedGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [subject_service_1.SubjectService,
	            watchlist_service_1.WatchlistService,
	            alert_service_1.AlertService])
	    ], SubjectLoadedGuard);
	    return SubjectLoadedGuard;
	}());
	exports.SubjectLoadedGuard = SubjectLoadedGuard;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var user_service_1 = __webpack_require__(713);
	var watchlist_service_1 = __webpack_require__(842);
	var forms_1 = __webpack_require__(64);
	var rxjs_1 = __webpack_require__(214);
	var modal_service_1 = __webpack_require__(837);
	var create_shared_list_modal_component_1 = __webpack_require__(879);
	var utilities_1 = __webpack_require__(523);
	var rules_1 = __webpack_require__(640);
	var WorklistBrowserComponent = (function () {
	    function WorklistBrowserComponent(worklists, router, route, users, modal) {
	        this.worklists = worklists;
	        this.router = router;
	        this.route = route;
	        this.users = users;
	        this.modal = modal;
	        this.groupControl = new forms_1.FormControl(undefined);
	        this.loadedForGroup = false;
	        this.currentLists = [];
	        this.newListOpen = false;
	        this.jsonify = utilities_1.jsonify;
	        this.batchSubscription = new rxjs_1.Subscription();
	        if (this.users.self.sharedListGroups[0]) {
	            this.groupControl.setValue(this.users.self.sharedListGroups[0].id);
	        }
	    }
	    WorklistBrowserComponent.prototype.loadFor = function (gid, force) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        if (this.worklists.sharedListsByGroup.has(gid) && !force) {
	            this.loadedForGroup = true;
	            this.currentLists = this.worklists.sharedListsByGroup.get(gid);
	        }
	        else {
	            this.loadedForGroup = false;
	            this.worklists.requestListsForGroup(gid).subscribe(function (_) {
	                _this.loadedForGroup = true;
	                _this.currentLists = _this.worklists.sharedListsByGroup.get(gid);
	            });
	        }
	    };
	    WorklistBrowserComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.batchSubscription.add(this.groupControl.valueChanges.subscribe(function (gid) {
	            _this.loadFor(gid);
	        }));
	        if (Number.isSafeInteger(this.groupControl.value)) {
	            this.loadFor(this.groupControl.value);
	        }
	        else if (this.groupControl.value === undefined
	            && this.users.self.sharedListGroups[0]) {
	            this.groupControl.setValue(this.users.self.sharedListGroups[0].id);
	        }
	        else {
	            console.warn("Current group id (" + this.groupControl.value + ") is not valid, suppressing auto-request until new value provided");
	        }
	    };
	    WorklistBrowserComponent.prototype.ngOnDestroy = function () {
	        this.batchSubscription.unsubscribe();
	    };
	    WorklistBrowserComponent.prototype.openList = function (listId) {
	        var _this = this;
	        if (!Number.isSafeInteger(listId)) {
	            return console.error("Cannot request a list without opaque ID, got: " + listId);
	        }
	        this.worklists.loadSharedList(this.groupControl.value, listId)
	            .subscribe(function (list) { return _this.router.navigate(["lists/byGroup", _this.groupControl.value, listId]); });
	    };
	    WorklistBrowserComponent.prototype.createViaDialog = function () {
	        var _this = this;
	        this.modal.observe(create_shared_list_modal_component_1.CreateSharedListModalComponent, { size: "md", groupId: this.groupControl.value }).subscribe(function (r) {
	            if (r) {
	                _this.worklists.createSharedList(r).subscribe(function (rsp) {
	                });
	            }
	        });
	    };
	    WorklistBrowserComponent.prototype.canCreateShared = function () {
	        var _this = this;
	        return this.users.self.sharedListGroups.some(function (g) { return g.id === _this.groupControl.value && g.rules.includes(rules_1.Rule.CREATE_SHARED_WORKLIST); });
	    };
	    WorklistBrowserComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"container\">\n\t\t<!-- <div *ngIf=\"users.debugMode\" class=\"jumbotron\">\n\t\t\tKnown List Opaque IDs\n\t\t\t<ul>\n\t\t\t\t<li>obj:{{jsonify(worklists.personalWorklistObjectId)}} \u2192 PERSONAL</li>\n\t\t\t\t<li *ngFor=\"let pair of worklists.objectIdToGroupId.entries()\">obj:{{pair[0]}} \u2192 grp:{{pair[1]}}</li>\n\t\t\t</ul>\n\t\t</div> -->\n    <h3>\n      Available Worklists <span class=\"badge\">{{currentLists.length}}</span>\n\t\t\t<small class=\"form-inline pull-right\">\n\t\t\t\t<label for=\"group\">in group:</label>\n\t\t\t\t<select id=\"group\" class=\"form-control\" [formControl]=\"groupControl\" [disabled]=\"users.self.sharedListGroups.length <= 1\">\n\t\t\t\t\t<option\n\t\t\t\t\t\t*ngFor=\"let gp of users.self.sharedListGroups\"\n\t\t\t\t\t\t[ngValue]=\"gp.id\"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ gp.name }}\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t\t<span\n\t\t\t\t\tclass=\"badge\"\n\t\t\t\t\ttitle=\"This is the number of groups you can access lists for\"\n\t\t\t\t\tstyle=\"position: relative; left: -12px; top: -16px;\">\n\t\t\t\t\t{{ users.self.sharedListGroups.length }}\n\t\t\t\t</span>\n\t\t\t</small>\n    </h3>\n\t\t<table class=\"table\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Visibility</th>\n\t\t\t\t\t<th [sorts]=\"currentLists\" asType=\"string\" dot=\"title\" [runOnChange]=\"true\">Title</th>\n\t\t\t\t\t<th [sorts]=\"currentLists\" asType=\"string\" dot=\"description\">Description</th>\n\t\t\t\t\t<th [sorts]=\"currentLists\" dot=\"created\">Created</th>\n\t\t\t\t\t<th>Actions</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t\t<tbody *ngIf=\"!loadedForGroup\">\n\t\t\t\t\t<tr >\n\t\t\t\t\t\t<td colspan=\"5\">\n\t\t\t\t\t\t\t<h4 class=\"text-info text-center\">Loading...</h4>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t\t<tbody *ngIf=\"loadedForGroup\">\n\t\t\t\t\t<tr *ngFor=\"let list of currentLists\">\n\t\t\t\t\t\t<td><span class=\"badge\" title=\"A 'group-public' worklist is potentially visible to all users in the selected group.\">group-public</span></td>\n\t\t\t\t\t\t<td>{{ list.title }}</td>\n\t\t\t\t\t\t<td>{{ list.description }}</td>\n\t\t\t\t\t\t<td>{{ list.created | utcDate : \"MMM D, YYYY [at] h:mma\" }}\n\t\t\t\t\t\t\t<!-- <span style=\"opacity: 0.5\">{{list.created}}</span> -->\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td style=\"padding: 2px\">\n\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\tclass=\"btn btn-primary w100\"\n\t\t\t\t\t\t\t\t(click)=\"openList(list.objectId)\">\n\t\t\t\t\t\t\t\tOpen List\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr *ngIf=\"currentLists.length < 1\">\n\t\t\t\t\t\t<td colspan=\"5\">\n\t\t\t\t\t\t\t<h4 class=\"text-muted text-center\">This group has no lists yet!</h4>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<!-- <tr *ngIf=\"currentLists.length < 1\">\n\t\t\t\t\t\t<td colspan=\"5\" class=\"text-center\">\n\t\t\t\t\t\t\t<button class=\"btn btn-success\" style=\"padding: auto 2em\" (click)=\"createViaDialog()\">\n\t\t\t\t\t\t\t\tCreate New Shared List\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr> -->\n\t\t\t\t</tbody>\n\t\t</table>\n\t\t<div class=\"text-center\" style=\"margin-top: 2em auto;\">\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-success\" \n\t\t\t\t[attr.disabled]=\"canCreateShared() ? null : ''\"\n\t\t\t\t(click)=\"createViaDialog()\">\n\t\t\t\tCreate New Shared Worklist...\n\t\t\t</button>\n\t\t</div>\n\t</div>\n  ",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService,
	            router_1.Router,
	            router_1.ActivatedRoute,
	            user_service_1.UserService,
	            modal_service_1.ModalService])
	    ], WorklistBrowserComponent);
	    return WorklistBrowserComponent;
	}());
	exports.WorklistBrowserComponent = WorklistBrowserComponent;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var watchlist_service_1 = __webpack_require__(842);
	var user_service_1 = __webpack_require__(713);
	var CreateSharedListModalComponent = (function () {
	    function CreateSharedListModalComponent(dialog, user, watchlists) {
	        this.dialog = dialog;
	        this.user = user;
	        this.watchlists = watchlists;
	        this.forEdit = false;
	        this.title = new forms_1.FormControl("", forms_1.Validators.required);
	        this.description = new forms_1.FormControl("", forms_1.Validators.required);
	        this.stableUrl = new forms_1.FormControl({ value: "", disabled: true });
	        this.form = new forms_1.FormGroup({
	            title: this.title,
	            description: this.description,
	            stableUrl: this.stableUrl
	        });
	        this.group = this.user.self.groups.find(function (g) { return g.id == dialog.context.groupId; });
	        if (!this.group) {
	            console.error("Could not find group with id " + dialog.context.groupId);
	            dialog.bailOut();
	        }
	        if (dialog.context.forEdit) {
	            this.forEdit = true;
	        }
	        if (dialog.context.initialValues) {
	            this.title.setValue(dialog.context.initialValues.title);
	            this.description.setValue(dialog.context.initialValues.description);
	            this.stableUrl.setValue(dialog.context.initialValues.stableUrl);
	        }
	    }
	    CreateSharedListModalComponent.prototype.add = function () {
	        var result = __assign({}, this.form.value, { groupId: this.group.id });
	        this.dialog.close(result);
	    };
	    CreateSharedListModalComponent = __decorate([
	        core_1.Component({
	            template: "\n<div class=\"modal-header\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\t(click)=\"dialog.dismiss()\"\n\t\taria-label=\"Close\">\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n\t<h4 class=\"modal-title\">\n\t\t{{forEdit ? 'Edit' : 'Create'}} Shared Work List\n\t</h4>\n</div>\n<div class=\"modal-body\">\n\t<p *ngIf=\"!forEdit\">\n\t\tCreating within security group: \n\t\t<span class=\"badge\" style=\"vertical-align: baseline\">\n\t\t\t{{ group.name }} (#{{group.id}})\n\t\t</span>\n\t</p>\n\t<div class=\"form-group\">\n\t\t<label>Title</label>\n\t\t<input\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\tplaceholder=\"A short name to identify the list\"\n\t\t\t[formControl]=\"title\">\n\t</div>\n\t<div class=\"form-group\">\n\t\t<label>Description</label>\n\t\t<textarea\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"description\"\n\t\t\tplaceholder=\"A longer explanation of the list's purpose...\">\n\t\t</textarea>\n\t</div>\n\t<div class=\"form-group\">\n\t\t<label>Stable URL <em>[optional]</em></label>\n\t\t<input\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\tplaceholder=\"/my-path\"\n\t\t\t[formControl]=\"stableUrl\">\n\t</div>\n\t<p *ngIf=\"errorMessage\" class=\"text-danger\">{{errorMessage}}</p>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t(click)=\"add()\">\n\t\t{{forEdit ? 'Save' : 'Create'}}\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-default\"\n\t\t(click)=\"dialog.dismiss()\">\n\t\tCancel\n\t</button>\n</div>\n\n  "
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            user_service_1.UserService,
	            watchlist_service_1.WatchlistService])
	    ], CreateSharedListModalComponent);
	    return CreateSharedListModalComponent;
	}());
	exports.CreateSharedListModalComponent = CreateSharedListModalComponent;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var user_service_1 = __webpack_require__(713);
	var rules_1 = __webpack_require__(640);
	var modal_service_1 = __webpack_require__(837);
	var setting_service_1 = __webpack_require__(690);
	var algorithm_service_1 = __webpack_require__(213);
	var watchlist_component_1 = __webpack_require__(881);
	var watchlist_service_1 = __webpack_require__(842);
	var subject_service_1 = __webpack_require__(821);
	var alert_service_1 = __webpack_require__(689);
	var create_shared_list_modal_component_1 = __webpack_require__(879);
	var SharedWorklistComponent = (function () {
	    function SharedWorklistComponent(watchlist, algorithms, userSvc, settings, subjects, modals, router, route, alerts) {
	        this.watchlist = watchlist;
	        this.algorithms = algorithms;
	        this.userSvc = userSvc;
	        this.settings = settings;
	        this.subjects = subjects;
	        this.modals = modals;
	        this.router = router;
	        this.route = route;
	        this.alerts = alerts;
	        this.showTitle = true;
	        this.asSelector = false;
	        this.selection = new core_1.EventEmitter();
	        this.ignoredColumns = this.getIgnored();
	        this.FOLDER_SORT = "categories.0";
	        this.list = null;
	        this.groupId = null;
	        this.entryTables = [];
	    }
	    SharedWorklistComponent.prototype.getIgnored = function () {
	        var s = this.settings.get("ignored worklist columns") || "";
	        if (s === "") {
	            return new Set();
	        }
	        return new Set(s.split(","));
	    };
	    SharedWorklistComponent.prototype.openConfigModal = function () {
	        alert("Config not available for shared lists");
	        return;
	    };
	    SharedWorklistComponent.prototype.notesHidden = function () {
	        return false;
	        return this.ignoredColumns.has(watchlist_component_1.WatchlistComponent.NotesColumnLabel);
	    };
	    SharedWorklistComponent.prototype.notificationsHidden = function () {
	        return this.ignoredColumns.has(watchlist_component_1.WatchlistComponent.NotificationColumnLabel);
	    };
	    SharedWorklistComponent.prototype.foldersHidden = function () {
	        return this.ignoredColumns.has(watchlist_component_1.WatchlistComponent.FolderColumnLabel);
	    };
	    SharedWorklistComponent.prototype.folderMode = function (table) {
	        var sorting = table.entries;
	        return sorting._sort && sorting._sort.dot === this.FOLDER_SORT;
	    };
	    SharedWorklistComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.route.data.subscribe(function (data) {
	            if (data.list) {
	                _this.list = data.list;
	                _this.groupId = +_this.route.snapshot.params.groupId;
	                _this.entryTables = _this.watchlist.sharedEntryTables.get(_this.groupId);
	            }
	        });
	    };
	    SharedWorklistComponent.prototype.unwatch = function (entry) {
	        var _this = this;
	        if (!this.canEdit())
	            return;
	        this.watchlist.unwatch(entry, true, false, this.list.objectId).subscribe(function (result) {
	            if (!result) {
	                _this.modals.confirm({
	                    title: "Unsubscribe failed",
	                    body: "The server failed to remove this record from the shared list.\n                  It could be that this is because the record has been deleted\n                  or migrated. Do you want to attempt to forcefully clean up\n                  remaining subscription data?",
	                    yesLabel: "Forcefully Remove",
	                    cancelLabel: "Nevermind",
	                    dismissValue: false
	                }).subscribe(function (retry) {
	                    if (retry) {
	                        _this.watchlist.unwatch(entry, true, true, _this.list.objectId).subscribe();
	                    }
	                });
	            }
	        });
	    };
	    SharedWorklistComponent.prototype.canEdit = function () {
	        var group = this.userSvc.self.groupById(this.groupId);
	        if (!group) {
	            console.error("Can't find group ID " + this.groupId);
	            return false;
	        }
	        return group.rules.includes(rules_1.Rule.CREATE_SHARED_WORKLIST);
	    };
	    SharedWorklistComponent.prototype.editList = function () {
	        var _this = this;
	        if (!this.canEdit()) {
	            return alert("You do not have permission to edit shared worklists!");
	        }
	        this.modals.observe(create_shared_list_modal_component_1.CreateSharedListModalComponent, {
	            size: "md",
	            groupId: this.groupId,
	            forEdit: true,
	            initialValues: {
	                title: this.list.title,
	                description: this.list.description,
	                stableUrl: ""
	            }
	        }).subscribe(function (r) {
	            var updates = {
	                title: r.title,
	                description: r.description,
	                stableUrl: r.stableUrl
	            };
	            _this.watchlist.editSharedList(_this.list.objectId, updates).subscribe(function (success) {
	                if (success) {
	                    _this.list.title = updates.title;
	                    _this.list.description = updates.description;
	                }
	            });
	        });
	    };
	    SharedWorklistComponent.prototype.showEditDialog = function (entry) {
	        var _this = this;
	        this.modals.stringPrompt({
	            title: "Edit note",
	            body: "Enter a new note:",
	            placeholder: "Context for the worklist entry",
	            acceptEmptyResult: true,
	            initialValue: entry.note
	        }).subscribe(function (noteString) {
	            _this.watchlist.editNote(entry, noteString, entry.categories, _this.list.objectId).subscribe(function (success) { return console.log("Work list item note updated!"); });
	        });
	    };
	    SharedWorklistComponent.prototype.changeNotificationSetting = function (entry) {
	        console.error("Notifications not yet supported for shared lists");
	        return;
	    };
	    SharedWorklistComponent.prototype.open = function (entry, target) {
	        var _this = this;
	        this.watchlist.openShared(entry, this.list.objectId, !this.asSelector, target).subscribe(function (subject) { return _this.selection.emit(subject); });
	    };
	    SharedWorklistComponent.prototype.openDefault = function (entry) {
	        var target = this.algorithms.defaultForOpen(entry.contextType);
	        this.open(entry, target);
	    };
	    SharedWorklistComponent.prototype.moveCopyPersonal = function (entry, isMove) {
	        var _this = this;
	        if (isMove === void 0) { isMove = false; }
	        return this.alerts.warn("You do not have permission to move or copy list entries");
	        this.watchlist.watchSubject(this.subjects.fromReference(this.watchlist.createRef(entry.watchId, this.list.objectId))).subscribe(function (newWatchId) {
	            if (isMove) {
	                _this.watchlist.unwatch(entry, true, false, _this.list.objectId);
	            }
	            else {
	            }
	        });
	    };
	    SharedWorklistComponent.prototype.dismiss = function (entry) {
	        this.alerts.warn("You cannot dismiss alerts for shared worklist entries");
	        return;
	    };
	    SharedWorklistComponent.DRAG_ITEM_TYPE = "application/vnd.mcp-workitem";
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], SharedWorklistComponent.prototype, "enforcedType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SharedWorklistComponent.prototype, "showTitle", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SharedWorklistComponent.prototype, "asSelector", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], SharedWorklistComponent.prototype, "selection", void 0);
	    SharedWorklistComponent = __decorate([
	        core_1.Component({
	            selector: "shared-worklist",
	            template: "\n  <div class=\"container\" *ngIf=\"list !== null\">\n    <div class=\"row\">\n      <div class=\"col-sm-2\">\n        <button class=\"btn btn-primary\" routerLink=\"/lists\">\n          \u2190 Back to List Browser\n        </button>\n      </div>\n      <div class=\"col-sm-8 jumbotron\">\n        This is a shared list with visibility <span class=\"badge\">group-public</span>, meaning anyone else in your security group (<u>ABC for Health</u>) with permission to see shared lists can access it. Note that, unlike your personal worklist, this:\n        <ul>\n          <li>does not update automatically while on the page</li>\n          <li>does not yet support notifications for entry changes</li>\n          <li>may have issues with sorting and folders</li>\n        </ul>\n        Please report any issues and suggestions to MCP.\n      </div>\n    </div>\n    <h2 *ngIf=\"showTitle\">\n      <span class=\"text-muted\">List:</span>\n      {{list.title}}\n      <span class=\"badge\">{{list.worklist.length}}</span>\n      <div class=\"btn btn-sm btn-default pull-right\" (click)=\"editList()\" [class.disabled]=\"!canEdit()\">\n        Edit Details\n      </div>\n    </h2>\n    <p *ngIf=\"list.description\">\n      {{list.description}}\n      <em *ngIf=\"!list.description\">None provided.</em>\n    </p>\n    <div *ngFor=\"let tab of entryTables\">\n    <table\n      *ngIf=\"!enforcedType || tab.contextType === enforcedType\"\n      class=\"table table-responsive\">\n      <caption\n        *ngIf=\"entryTables.length > 1\"\n        class=\"type capitalized\">\n        {{tab.contextType}}\n      </caption>\n      <thead>\n        <tr>\n          <th\n            *ngFor=\"let column of tab.columns; let i = index\"\n            [sorts]=\"tab.entries\"\n            [dot]=\"'summary.' + i\"\n            storedAs=\"worklistSorting\"\n            [class.capitalized]=\"true\"\n            [class.hidden]=\"ignoredColumns.has(column)\">\n            {{column}}\n          </th>\n          <!-- <th\n            [sorts]=\"tab.entries\"\n            dot=\"lastObserved\"\n            storedAs=\"worklistSorting\"\n            asType=\"integer\">\n            Last Viewed\n          </th> -->\n          <th\n            [class.hidden]=\"notesHidden()\"\n            [sorts]=\"tab.entries\"\n            asType=\"string\"\n            dot=\"note\"\n            storedAs=\"worklistSorting\">\n            Notes\n            <div class=\"subtitle\">(shared by all users)</div>\n          </th>\n          <!-- <th [class.hidden]=\"notificationsHidden()\">\n            Notify via\n            <div class=\"subtitle\">click to change</div>\n          </th> -->\n          <th colspan=\"1\" class=\"text-center\">\n            Actions\n            <!-- <button\n              class=\"btn btn-sm btn-default\"\n              (click)=\"openConfigModal()\">\n              Configure Columns...\n            </button> -->\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <template\n          ngFor\n          let-entry\n          [ngForOf]=\"(tab.entries | paginate)\">\n          <!-- (dragover)=\"allowDrag($event); folder.highlight = true\"\n          (dragenter)=\"allowDrag($event); folder.highlight = true\"\n          (dragleave)=\"folder.highlight = false\"\n          (drop)=\"dropItem($event, entry.categories[0], tab); folder.highlight = false\" -->\n        <tr\n          #folder\n          *ngIf=\"folderMode(tab) && firstOfFolder(entry, tab)\"\n          class=\"item-category\"\n          [class.drag-target]=\"folder.highlight\"\n          [class.droppable]=\"folder.highlight\"\n          [class.info]=\"entry.categories[0]\"\n          [class.warning]=\"!entry.categories[0]\">\n          <td>\n            <span class=\"glyphicon glyphicon-folder-open\"></span>\n          </td>\n          <td colspan=\"20\">\n            {{entry.categories[0] || 'Unsorted'}}\n          </td>\n        </tr>\n        <tr [class.bg-warning]=\"entry.alert\">\n          <td\n            *ngFor=\"let data of entry.summary\"\n            [class.hidden]=\"ignoredColumns.has(data.displayName)\">\n            <typed-display [input]=\"data\"></typed-display>\n          </td>\n          <!-- <td\n            [title]=\"entry.alert ? 'Changes since you last viewed' : ''\">\n            <div [class.emph]=\"entry.alert\">\n              {{entry.lastObserved | utcDate}}\n            </div>\n            <a\n              class=\"btn btn-xs btn-warning\"\n              *ngIf=\"entry.alert\"\n              (click)=\"dismiss(entry)\">\n              mark as read\n            </a>\n          </td> -->\n          <td #noteCell [class.hidden]=\"notesHidden()\">\n            <div>\n              {{entry.note || \"n/a\"}}\n              <a class=\"glyphicon glyphicon-pencil pull-right\" (click)=\"showEditDialog(entry)\"></a>\n            </div>\n          </td>\n          <!-- <td\n            (click)=\"changeNotificationSetting(entry)\"\n            [class.hidden]=\"notificationsHidden()\">\n            <span *ngIf=\"entry.emailNotifyOnUpdate\">\n              <span class=\"glyphicon glyphicon-envelope\"></span>\n              <code>email</code>\n            </span>\n            <span *ngIf=\"!entry.emailNotifyOnUpdate\">\n              <span class=\"glyphicon glyphicon-volume-off\"></span>\n              <code>none</code>\n            </span>\n          </td> -->\n          <td class=\"text-center action-cell\">\n            <div role=\"group\">\n              <button\n                *ngIf=\"entry.watchId === null\"\n                class=\"btn btn-sm btn-primary\"\n                title=\"You do not have permission to view this data\"\n                disabled>\n                {{asSelector ? \"Use\" : \"Open\"}}\n              </button>\n              <a\n                *ngIf=\"entry.watchId !== null && asSelector\"\n                class=\"btn btn-sm btn-primary\"\n\t\t\t\t(click)=\"open(entry)\">\n                <span class=\"hidden-sm hidden-xs\">Use</span>\n                <span\n                  class=\"hidden-md hidden-lg glyphicon glyphicon-folder-open\">\n                </span>\n\t\t\t        </a>\n              <div\n                #openOptions\n                *ngIf=\"entry.watchId !== null && !asSelector\"\n                class=\"btn-group\"\n                [class.open]=\"openOptions.open\"\n                (mouseleave)=\"openOptions.open = false\">\n                <a\n                  class=\"btn btn-sm btn-primary\"\n                  (click)=\"openDefault(entry)\">\n                  <span class=\"hidden-sm hidden-xs\">Open</span>\n                  <span\n                  class=\"hidden-md hidden-lg glyphicon glyphicon-folder-open\">\n                  </span>\n                </a>\n                <button\n                  type=\"button\"\n                  class=\"btn btn-sm btn-primary dropdown-toggle\"\n                  data-toggle=\"dropdown\"\n                  aria-haspopup=\"true\"\n                  [attr.aria-expanded]=\"!!openOptions.open\"\n                  (click)=\"openOptions.open = !openOptions.open\">\n                  <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu right-edge\">\n                  <li>\n                    <a (click)=\"open(entry, null)\">\n                      Summary Page\n                    </a>\n                  </li>\n                  <li role=\"separator\" class=\"divider\"></li>\n                  <li *ngFor=\"let alg of algorithms.bySCType(tab.contextType)\">\n                    <a (click)=\"open(entry, alg)\">\n                      {{alg.displayName}}\n                    </a>\n                  </li>\n                </ul>\n              </div>\n              <div\n                #actionOptions\n                *ngIf=\"entry.watchId !== null && !asSelector && canEdit()\"\n                class=\"btn-group\"\n                [class.open]=\"actionOptions.open\"\n                (mouseleave)=\"actionOptions.open = false\">\n                <a\n                  class=\"btn btn-sm btn-default dropdown-toggle\"\n                  data-toggle=\"dropdown\"\n                  aria-haspopup=\"true\"\n                  [attr.aria-expanded]=\"!!actionOptions.open\"\n                  (click)=\"actionOptions.open = !actionOptions.open\">\n                  <span class=\"hidden-sm hidden-xs\">Other...</span>\n                  <span class=\"caret\"></span>\n                </a>\n                <ul class=\"dropdown-menu right-edge\">\n                  <li [class.disabled]=\"!canEdit()\">\n                    <a (click)=\"unwatch(entry)\">\n                      Remove entry\n                    </a>\n                  </li>\n                  <li class=\"disabled\">\n                    <a (click)=\"moveCopyPersonal(entry, true)\">\n                      Move to personal list\n                    </a>\n                  </li>\n                  <li class=\"disabled\">\n                    <a (click)=\"moveCopyPersonal(entry, false)\">\n                      Copy to personal list\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </td>\n        </tr>\n        </template>\n      </tbody>\n      <caption>\n        <pager [array]=\"tab.entries\" [asNeeded]=\"true\"></pager>\n      </caption>\n    </table>\n    </div>\n    <h4 class=\"text-center\" *ngIf=\"entryTables.length === 0\">\n      This list is empty!\n    </h4>\n</div>\n",
	            styles: ["\n    caption {\n      caption-side: bottom;\n      font-size: 1.7em;\n      font-style: italic;\n      padding: 0.5em;\n    }\n    caption.empty {\n      text-align: center;\n    }\n    caption.type {\n      caption-side: top;\n      margin: 0 20px;\n      text-align: left;\n    }\n    .faded, .grabber {\n      color: #DDDDDD;\n    }\n    table.table>tbody>tr>td {\n      vertical-align: middle;\n    }\n    .form-control.focus-only {\n      border: 1px transparent;\n      box-shadow: none;\n    }\n    .form-control.focus-only:focus, .form-control.focus-only:hover  {\n      border: 1px solid #ccc;\n    }\n    .hidden {\n      display: none;\n    }\n    textarea {\n      resize: none;\n    }\n    .focus-text {\n      white-space: pre-line;\n      border: 1px solid transparent;\n      border-radius: 5px;\n      padding: 5px;\n      min-height: 34px;\n      width: 100%;\n    }\n    .focus-text:hover {\n      border: 1px solid #ccc;\n    }\n    th .subtitle {\n      font-size: 80%;\n      font-weight: normal;\n    }\n    .btn-group {\n      overflow-y: none;\n\t}\n\t.action-cell {\n\t\tmin-width: 96px;\n  }\n  .item-category {\n    font-style: italic;\n  }\n  .item-category.unsorted {\n    color: gray;\n  }\n  .droppable {\n    cursor: copy;\n  }\n  .grabbable {\n    cursor: grab;\n  }\n  .drag-target {\n    font-weight: bold;\n  }\n  .badge.primary {\n    background: #1D3559;\n    border-color: lighten(#1D3559, 10%);\n  }\n  "]
	        }),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService,
	            setting_service_1.SettingService,
	            subject_service_1.SubjectService,
	            modal_service_1.ModalService,
	            router_1.Router,
	            router_1.ActivatedRoute,
	            alert_service_1.AlertService])
	    ], SharedWorklistComponent);
	    return SharedWorklistComponent;
	}());
	exports.SharedWorklistComponent = SharedWorklistComponent;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var algorithm_service_1 = __webpack_require__(213);
	var utilities_1 = __webpack_require__(523);
	var setting_service_1 = __webpack_require__(690);
	var subject_1 = __webpack_require__(828);
	var watchlist_service_1 = __webpack_require__(842);
	var worklist_config_modal_component_1 = __webpack_require__(882);
	var modal_service_1 = __webpack_require__(837);
	var user_service_1 = __webpack_require__(713);
	var rules_1 = __webpack_require__(640);
	var router_1 = __webpack_require__(41);
	var WatchlistComponent = (function () {
	    function WatchlistComponent(watchlist, algorithms, userSvc, settings, modals, router) {
	        this.watchlist = watchlist;
	        this.algorithms = algorithms;
	        this.userSvc = userSvc;
	        this.settings = settings;
	        this.modals = modals;
	        this.router = router;
	        this.showTitle = true;
	        this.asSelector = false;
	        this.selection = new core_1.EventEmitter();
	        this.ignoredColumns = this.getIgnored();
	        this.FOLDER_SORT = "categories.0";
	    }
	    WatchlistComponent_1 = WatchlistComponent;
	    WatchlistComponent.prototype.getIgnored = function () {
	        var s = this.settings.get("ignored worklist columns") || "";
	        if (s === "") {
	            return new Set();
	        }
	        return new Set(s.split(","));
	    };
	    WatchlistComponent.prototype.openConfigModal = function () {
	        var _this = this;
	        var columns = [
	            WatchlistComponent_1.NotesColumnLabel,
	            WatchlistComponent_1.NotificationColumnLabel
	        ].concat(this.watchlist.knownColumns);
	        this.modals.observe(worklist_config_modal_component_1.WorklistConfigModalComponent, {
	            columns: columns,
	            hidden: Array.from(this.ignoredColumns)
	        }).subscribe(function (result) {
	            if (Array.isArray(result)) {
	                _this.ignoredColumns = new Set(result);
	                _this.settings.set("ignored worklist columns", result.join(","));
	            }
	            else {
	                console.warn("Got unexpected non-array from modal result:", result);
	            }
	        });
	    };
	    WatchlistComponent.prototype.notesHidden = function () {
	        return this.ignoredColumns.has(WatchlistComponent_1.NotesColumnLabel);
	    };
	    WatchlistComponent.prototype.notificationsHidden = function () {
	        return this.ignoredColumns.has(WatchlistComponent_1.NotificationColumnLabel);
	    };
	    WatchlistComponent.prototype.foldersHidden = function () {
	        return this.ignoredColumns.has(WatchlistComponent_1.FolderColumnLabel);
	    };
	    WatchlistComponent.prototype.folderMode = function (table) {
	        var sorting = table.entries;
	        return sorting._sort && sorting._sort.dot === this.FOLDER_SORT;
	    };
	    WatchlistComponent.prototype.unwatch = function (entry) {
	        var _this = this;
	        this.watchlist.unwatch(entry).subscribe(function (result) {
	            if (!result) {
	                _this.modals.confirm({
	                    title: "Unsubscribe failed",
	                    body: "The server failed to unsubscribe you from the record. It\n                  could be that this is because the record has been deleted\n                  or migrated. Do you want to attempt to forcefully clean up\n                  remaining subscription data?",
	                    yesLabel: "Forcefully Remove",
	                    cancelLabel: "Nevermind",
	                    dismissValue: false
	                }).subscribe(function (retry) {
	                    if (retry) {
	                        _this.watchlist.unwatch(entry, true, true).subscribe();
	                    }
	                });
	            }
	        });
	    };
	    WatchlistComponent.prototype.saveNote = function (entry, notecell) {
	        this.watchlist.editNote(entry, entry.control.value).subscribe(function (success) { return notecell.editing = !success; });
	    };
	    WatchlistComponent.prototype.toggle = function (notecell, t, b) {
	        notecell.editing = !notecell.editing;
	    };
	    WatchlistComponent.prototype.changeNotificationSetting = function (entry) {
	        this.watchlist.changeNotificationSetting(entry, !entry.emailNotifyOnUpdate)
	            .subscribe(function (success) {
	            return entry.emailNotifyOnUpdate = (entry.emailNotifyOnUpdate !== success);
	        });
	    };
	    WatchlistComponent.prototype.open = function (entry, target) {
	        var _this = this;
	        this.watchlist.open(entry, !this.asSelector, target).subscribe(function (subject) { return _this.selection.emit(subject); });
	    };
	    WatchlistComponent.prototype.openDefault = function (entry) {
	        var target = this.algorithms.defaultForOpen(entry.contextType);
	        this.open(entry, target);
	    };
	    WatchlistComponent.prototype.dismiss = function (entry) {
	        this.watchlist.clearAlert(entry).subscribe();
	    };
	    WatchlistComponent.prototype.startDrag = function (event, id) {
	        event.dataTransfer.setData(WatchlistComponent_1.DRAG_ITEM_TYPE, "" + id);
	        event.dataTransfer.effectAllowed = "move";
	    };
	    WatchlistComponent.prototype.allowDrag = function (event, toFlag) {
	        if (toFlag) {
	            toFlag.highlight = true;
	        }
	        if (event.dataTransfer.types.indexOf(WatchlistComponent_1.DRAG_ITEM_TYPE) > -1) {
	            event.dataTransfer.effectAllowed = "move";
	            event.preventDefault();
	            return false;
	        }
	        return true;
	    };
	    WatchlistComponent.prototype.dropItem = function (event, folder, table) {
	        var _this = this;
	        var id = Number.parseInt(event.dataTransfer.getData(WatchlistComponent_1.DRAG_ITEM_TYPE), 10);
	        var entry = this.watchlist.personalEntriesById.get(id);
	        this.watchlist.editNote(entry, entry.note, (folder ? [folder] : [])).subscribe(function (ok) {
	            if (ok) {
	                entry.categories = [folder];
	                _this.moveToFrontOfFolder(entry, table);
	            }
	        });
	    };
	    WatchlistComponent.prototype.moveToFrontOfFolder = function (entry, table) {
	        var _a;
	        var source = table.entries.findIndex(utilities_1.hardEquals(entry));
	        if (source === -1) {
	            return console.warn("ID " + entry.watchId + " not found in table " + table.contextType);
	        }
	        var target = table.entries.findIndex(function (e) {
	            return e.categories && e.categories[0] === entry.categories[0] && e !== entry;
	        });
	        (_a = table.entries).splice.apply(_a, [target, 0].concat(table.entries.splice(source, 1)));
	    };
	    WatchlistComponent.prototype.assignFolder = function (entry) {
	        var _this = this;
	        this.modals.stringPrompt({
	            title: "Assign a folder",
	            body: utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        Choose a folder for\n        ", ".\n        (By entering a new name, you will create a new folder.)"], ["\n        Choose a folder for\n        ", ".\n        (By entering a new name, you will create a new folder.)"])), subject_1.Subject.readableTitleFor(entry.summary, entry.contextType)),
	            placeholder: "Leave empty to unassign",
	            acceptEmptyResult: true
	        }).subscribe(function (label) {
	            _this.watchlist.editNote(entry, entry.note, (label ? [label] : [])).subscribe(function (ok) {
	                if (ok) {
	                    entry.categories = [label];
	                }
	            });
	        });
	    };
	    WatchlistComponent.prototype.firstOfFolder = function (entry, table) {
	        var i = table.entries.findIndex(function (x) { return x === entry; });
	        if (i === -1) {
	            console.error("Cannot find entry in table:", entry);
	            return false;
	        }
	        if (i === 0) {
	            return true;
	        }
	        var prev = table.entries[i - 1];
	        return entry.categories[0] !== prev.categories[0];
	    };
	    WatchlistComponent.prototype.canViewShared = function () {
	        return this.userSvc.self.hasRule(rules_1.Rule.VIEW_SHARED_WORKLIST);
	    };
	    WatchlistComponent.prototype.viewShared = function () {
	        if (!this.canViewShared()) {
	            this.modals.alert("You do not have permission to view shared worklists!");
	        }
	        else {
	            this.router.navigate(['lists']);
	        }
	    };
	    var WatchlistComponent_1;
	    WatchlistComponent.NotesColumnLabel = "(notes)";
	    WatchlistComponent.NotificationColumnLabel = "(notify via)";
	    WatchlistComponent.FolderColumnLabel = "(folder)";
	    WatchlistComponent.DRAG_ITEM_TYPE = "application/vnd.mcp-workitem";
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], WatchlistComponent.prototype, "enforcedType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], WatchlistComponent.prototype, "showTitle", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], WatchlistComponent.prototype, "asSelector", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], WatchlistComponent.prototype, "selection", void 0);
	    WatchlistComponent = WatchlistComponent_1 = __decorate([
	        core_1.Component({
	            selector: "watchlist",
	            template: "\n    <h2 *ngIf=\"showTitle\">\n      Work List\n      <span class=\"badge warning\">{{watchlist.activePersonalCount()}} unread</span>\n      <span class=\"badge\">{{watchlist.personalEntriesById.size - watchlist.activePersonalCount()}} read</span>\n      <div class=\"pull-right btn btn-primary\" [class.disabled]=\"!canViewShared()\" (click)=\"viewShared()\">\n        Browse Shared Lists...\n      </div>\n    </h2>\n    <div *ngFor=\"let tab of watchlist.entryTables\">\n    <table\n      *ngIf=\"!enforcedType || tab.contextType === enforcedType\"\n      class=\"table table-responsive\">\n      <caption\n        *ngIf=\"watchlist.entryTables.length > 1\"\n        class=\"type capitalized\">\n        {{tab.contextType}}\n      </caption>\n      <thead>\n        <tr>\n          <th\n            class=\"grabber\"\n            [sorts]=\"tab.entries\"\n            [dot]=\"FOLDER_SORT\"\n            storedAs=\"worklistSorting\"\n            asType=\"string\"\n            [class.hidden]=\"foldersHidden()\">\n            <span class=\"glyphicon glyphicon-tag\"></span>\n          </th>\n          <th\n            *ngFor=\"let column of tab.columns; let i = index\"\n            [sorts]=\"tab.entries\"\n            [dot]=\"'summary.' + i\"\n            storedAs=\"worklistSorting\"\n            [class.capitalized]=\"true\"\n            [class.hidden]=\"ignoredColumns.has(column)\">\n            {{column}}\n          </th>\n          <th\n            [sorts]=\"tab.entries\"\n            dot=\"lastObserved\"\n            storedAs=\"worklistSorting\"\n            asType=\"integer\">\n            Last Viewed\n          </th>\n          <th [class.hidden]=\"notesHidden()\">\n            Notes\n            <div class=\"subtitle\">click to edit</div>\n          </th>\n          <th [class.hidden]=\"notificationsHidden()\">\n            Notify via\n            <div class=\"subtitle\">click to change</div>\n          </th>\n          <th colspan=\"1\" class=\"text-center\">\n            <button\n              class=\"btn btn-sm btn-default\"\n              (click)=\"openConfigModal()\">\n              Configure Columns...\n            </button>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <template\n          ngFor\n          let-entry\n          [ngForOf]=\"(tab.entries | paginate)\">\n        <tr\n          #folder\n          *ngIf=\"folderMode(tab) && firstOfFolder(entry, tab)\"\n          class=\"item-category\"\n          (dragover)=\"allowDrag($event); folder.highlight = true\"\n          (dragenter)=\"allowDrag($event); folder.highlight = true\"\n          (dragleave)=\"folder.highlight = false\"\n          (drop)=\"dropItem($event, entry.categories[0], tab); folder.highlight = false\"\n          [class.drag-target]=\"folder.highlight\"\n          [class.droppable]=\"folder.highlight\"\n          [class.info]=\"entry.categories[0]\"\n          [class.warning]=\"!entry.categories[0]\">\n          <td>\n            <span class=\"glyphicon glyphicon-folder-open\"></span>\n          </td>\n          <td colspan=\"20\">\n            {{entry.categories[0] || 'Unsorted'}}\n          </td>\n        </tr>\n        <tr [class.bg-warning]=\"entry.alert\">\n          <td\n            *ngIf=\"folderMode(tab) && !foldersHidden()\"\n            class=\"grabber grabbable\"\n            draggable=\"true\"\n            (dragstart)=\"startDrag($event, entry.watchId)\">\n            <span class=\"glyphicon glyphicon-resize-vertical\"></span>\n          </td>\n          <td\n            *ngIf=\"!folderMode(tab) && !foldersHidden()\"\n            (click)=\"assignFolder(entry)\">\n            <span class=\"badge\" [class.primary]=\"entry.categories[0]\">\n              {{entry.categories[0] || \"unsorted\"}}\n            </span>\n          </td>\n          <td\n            *ngFor=\"let data of entry.summary\"\n            [class.hidden]=\"ignoredColumns.has(data.displayName)\">\n            <typed-display [input]=\"data\"></typed-display>\n          </td>\n          <td\n            [title]=\"entry.alert ? 'Changes since you last viewed' : ''\">\n            <div [class.emph]=\"entry.alert\">\n              {{entry.lastObserved | utcDate}}\n            </div>\n            <a\n              class=\"btn btn-xs btn-warning\"\n              *ngIf=\"entry.alert\"\n              (click)=\"dismiss(entry)\">\n              mark as read\n            </a>\n          </td>\n          <td #noteCell [class.hidden]=\"notesHidden()\">\n            <div\n              *ngIf=\"!noteCell.editing\"\n              class=\"focus-text\"\n              (click)=\"toggle(noteCell, text, button)\"\n              >{{entry.note || \"n/a\"}}</div>\n            <div [class.hidden]=\"!noteCell.editing\" class=\"input-group\">\n              <textarea\n                autosize\n                [formControl]=\"entry.control\"\n                class=\"form-control\">\n              </textarea>\n              <div class=\"input-group-btn\">\n                <button class=\"btn btn-info\"\n                  #button\n                  (click)=\"saveNote(entry, noteCell)\">\n                  Save\n                </button>\n              </div>\n            </div>\n          </td>\n          <td\n            (click)=\"changeNotificationSetting(entry)\"\n            [class.hidden]=\"notificationsHidden()\">\n            <span *ngIf=\"entry.emailNotifyOnUpdate\">\n              <span class=\"glyphicon glyphicon-envelope\"></span>\n              <code>email</code>\n            </span>\n            <span *ngIf=\"!entry.emailNotifyOnUpdate\">\n              <span class=\"glyphicon glyphicon-volume-off\"></span>\n              <code>none</code>\n            </span>\n          <td class=\"text-center action-cell\">\n            <div role=\"group\">\n              <button\n                *ngIf=\"entry.watchId === null\"\n                class=\"btn btn-sm btn-primary\"\n                title=\"You do not have permission to view this data\"\n                disabled>\n                {{asSelector ? \"Use\" : \"Open\"}}\n              </button>\n              <a\n                *ngIf=\"entry.watchId !== null && asSelector\"\n                class=\"btn btn-sm btn-primary\"\n\t\t\t\t(click)=\"open(entry)\">\n                <span class=\"hidden-sm hidden-xs\">Use</span>\n                <span\n                  class=\"hidden-md hidden-lg glyphicon glyphicon-folder-open\">\n                </span>\n\t\t\t        </a>\n              <div\n                #openOptions\n                *ngIf=\"entry.watchId !== null && !asSelector\"\n                class=\"btn-group\"\n                [class.open]=\"openOptions.open\"\n                (mouseleave)=\"openOptions.open = false\">\n                <a\n                  class=\"btn btn-sm btn-primary\"\n                  (click)=\"openDefault(entry)\">\n                  <span class=\"hidden-sm hidden-xs\">Open</span>\n                  <span\n                  class=\"hidden-md hidden-lg glyphicon glyphicon-folder-open\">\n                  </span>\n                </a>\n                <button\n                  type=\"button\"\n                  class=\"btn btn-sm btn-primary dropdown-toggle\"\n                  data-toggle=\"dropdown\"\n                  aria-haspopup=\"true\"\n                  [attr.aria-expanded]=\"!!openOptions.open\"\n                  (click)=\"openOptions.open = !openOptions.open\">\n                  <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu right-edge\">\n                  <li>\n                    <a (click)=\"open(entry, null)\">\n                      Summary Page\n                    </a>\n                  </li>\n                  <li role=\"separator\" class=\"divider\"></li>\n                  <li *ngFor=\"let alg of algorithms.bySCType(tab.contextType)\">\n                    <a (click)=\"open(entry, alg)\">\n                      {{alg.displayName}}\n                    </a>\n                  </li>\n                </ul>\n              </div>\n              <a\n                class=\"btn btn-sm btn-danger\"\n                (click)=\"unwatch(entry)\">\n                <span class=\"hidden-sm hidden-xs\">Remove</span>\n                <span class=\"hidden-md hidden-lg glyphicon glyphicon-remove\">\n                </span>\n              </a>\n            </div>\n          </td>\n        </tr>\n        </template>\n      </tbody>\n      <caption>\n        <pager [array]=\"tab.entries\" [asNeeded]=\"true\"></pager>\n      </caption>\n    </table>\n    </div>\n    <h4 class=\"text-center\" *ngIf=\"watchlist.entryTables.length === 0\">\n      Your work list is empty!\n    </h4>\n",
	            styles: ["\n    caption {\n      caption-side: bottom;\n      font-size: 1.7em;\n      font-style: italic;\n      padding: 0.5em;\n    }\n    caption.empty {\n      text-align: center;\n    }\n    caption.type {\n      caption-side: top;\n      margin: 0 20px;\n      text-align: left;\n    }\n    .faded, .grabber {\n      color: #DDDDDD;\n    }\n    table.table>tbody>tr>td {\n      vertical-align: middle;\n    }\n    .form-control.focus-only {\n      border: 1px transparent;\n      box-shadow: none;\n    }\n    .form-control.focus-only:focus, .form-control.focus-only:hover  {\n      border: 1px solid #ccc;\n    }\n    .hidden {\n      display: none;\n    }\n    textarea {\n      resize: none;\n    }\n    .focus-text {\n      white-space: pre-line;\n      border: 1px solid transparent;\n      border-radius: 5px;\n      padding: 5px;\n      min-height: 34px;\n      width: 100%;\n    }\n    .focus-text:hover {\n      border: 1px solid #ccc;\n    }\n    th .subtitle {\n      font-size: 80%;\n      font-weight: normal;\n    }\n    .btn-group {\n      overflow-y: none;\n\t}\n\t.action-cell {\n\t\tmin-width: 96px;\n  }\n  .item-category {\n    font-style: italic;\n  }\n  .item-category.unsorted {\n    color: gray;\n  }\n  .droppable {\n    cursor: copy;\n  }\n  .grabbable {\n    cursor: grab;\n  }\n  .drag-target {\n    font-weight: bold;\n  }\n  .badge.primary {\n    background: #1D3559;\n    border-color: lighten(#1D3559, 10%);\n  }\n  "]
	        }),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService,
	            setting_service_1.SettingService,
	            modal_service_1.ModalService,
	            router_1.Router])
	    ], WatchlistComponent);
	    return WatchlistComponent;
	}());
	exports.WatchlistComponent = WatchlistComponent;
	var templateObject_1;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var IMPORT_VERSION = 2;
	var WorklistConfigModalComponent = (function () {
	    function WorklistConfigModalComponent(dialog) {
	        this.dialog = dialog;
	        this.hidden = new forms_1.FormControl([]);
	    }
	    WorklistConfigModalComponent.prototype.ngOnInit = function () {
	        if (Array.isArray(this.dialog.context.hidden)) {
	            this.hidden.setValue(this.dialog.context.hidden);
	        }
	    };
	    WorklistConfigModalComponent.prototype.submit = function () {
	        this.dialog.close(this.hidden.value);
	    };
	    WorklistConfigModalComponent.prototype.clear = function () {
	        this.dialog.close([]);
	    };
	    WorklistConfigModalComponent.prototype.tryAnswering = function (answers) {
	    };
	    WorklistConfigModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Configure Worklist Display\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <!-- <h3 class=\"debug-only\">Caution!</h3> -->\n    <p>\n      You can hide columns by selecting them in the box below.\n    </p>\n    <p>\n      Note that this setting is saved on your machine. If you log in from\n      another computer or clear your browser's data, it will not be maintained.\n    </p>\n    <div class=\"form-group\">\n      <label>\n        Hidden Columns\n        <small>Use <kbd>Ctrl</kbd> or <kbd>Cmd</kbd> to select multiple.</small>\n      </label>\n      <select multiple class=\"form-control\" [formControl]=\"hidden\" size=\"16\">\n        <option *ngFor=\"let col of dialog.context.columns\" [ngValue]=\"col\">\n          {{col}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      Cancel\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-danger\"\n      (click)=\"clear()\">\n      Clear\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-warning\"\n      (click)=\"submit()\">\n      Save\n    </button>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], WorklistConfigModalComponent);
	    return WorklistConfigModalComponent;
	}());
	exports.WorklistConfigModalComponent = WorklistConfigModalComponent;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var watchlist_service_1 = __webpack_require__(842);
	var SharedWorklistGuard = (function () {
	    function SharedWorklistGuard(watchlist, alerts) {
	        this.watchlist = watchlist;
	        this.alerts = alerts;
	        console.log("SharedWorklistGuard args", Array.from(arguments));
	    }
	    SharedWorklistGuard_1 = SharedWorklistGuard;
	    SharedWorklistGuard.prototype.hasIdPair = function (rt) {
	        return ("groupId" in rt.params) && ("objectId" in rt.params);
	    };
	    SharedWorklistGuard.prototype.canActivate = function (route) {
	        if (this.hasIdPair(route)) {
	            var lists = this.watchlist.sharedListsByGroup.get(+route.params.groupId);
	            if (lists) {
	                var found = (lists.find(function (l) { return l.objectId === +route.params.objectId; }) !== null);
	                if (!found) {
	                    this.alerts.error("Could not find worklist " + route.params.objectId + " in the " + lists.length + " lists for group");
	                    return false;
	                }
	                return true;
	            }
	            else {
	                this.alerts.error("Could not find worklists for group " + route.params.groupId);
	                return false;
	            }
	        }
	        else {
	            this.alerts.error("Cannot open worklist " + route.params.groupId + ":" + route.params.objectId);
	            return false;
	        }
	    };
	    SharedWorklistGuard.prototype.resolve = function (route) {
	        if (!this.hasIdPair(route)) {
	            throw new Error("ID parameter missing in resolve guard.");
	        }
	        var groupLists = this.watchlist.sharedListsByGroup.get(+route.params.groupId);
	        var possiblyLoaded = groupLists && groupLists.find(function (l) { return l.objectId === +route.params.objectId; });
	        if (!possiblyLoaded) {
	            throw new Error("Lists not present in worklist service (resolve guard).");
	        }
	        if (possiblyLoaded.loading === false
	            && possiblyLoaded.loadTime > Date.now() - SharedWorklistGuard_1.RELOAD_AGE) {
	            return possiblyLoaded;
	        }
	        else {
	            return this.watchlist.loadSharedList(+route.params.groupId, +route.params.objectId);
	        }
	    };
	    var SharedWorklistGuard_1;
	    SharedWorklistGuard.RELOAD_AGE = 5 * 60 * 60 * 1000;
	    SharedWorklistGuard = SharedWorklistGuard_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService,
	            alert_service_1.AlertService])
	    ], SharedWorklistGuard);
	    return SharedWorklistGuard;
	}());
	exports.SharedWorklistGuard = SharedWorklistGuard;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var Rx_1 = __webpack_require__(214);
	var user_service_1 = __webpack_require__(713);
	var alert_service_1 = __webpack_require__(689);
	var context_management_1 = __webpack_require__(604);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var comment_service_1 = __webpack_require__(212);
	var algorithm_service_1 = __webpack_require__(213);
	var intake_step_service_1 = __webpack_require__(751);
	var watchlist_service_1 = __webpack_require__(842);
	var setting_service_1 = __webpack_require__(690);
	var report_step_service_1 = __webpack_require__(849);
	var search_service_1 = __webpack_require__(834);
	var modal_service_1 = __webpack_require__(837);
	var add_reminder_modal_component_1 = __webpack_require__(851);
	var build_flags_1 = __webpack_require__(534);
	var platform_browser_1 = __webpack_require__(21);
	var comment_1 = __webpack_require__(209);
	var ALLOWED_PROFILE_NAMES = ["firstcheck"];
	var KNOWN_PROFILES = {
	    firstcheck: {
	        name: "firstcheck",
	        flavors: ["fc"],
	        minimumVersion: 0,
	        algorithms: ["a-administration"],
	        mappingFunction: function () { return null; }
	    }
	};
	var BROWSER_SAVE_NEEDED_MESSAGE = "\n  It looks like you may have entered data since the last save. (This could\n  include changes you have made to comments.)\n\n  Are you sure you want to leave?\n";
	var REQUIRED_STEPS_MODAL = {
	    title: "Required steps not complete",
	    body: "You must fill out all of the required steps before saving!"
	};
	var MAG_ICON = "<span class=\"glyphicon glyphicon-search\"><span>";
	var RETRIEVABILITY_MODAL = {
	    title: "Subject would not be retrievable!",
	    body: "Since you haven't completed enough of the search index steps\n        (marked with a <kbd>" + MAG_ICON + "</kbd>), this record would not be\n        retrievable through all searches. Would you like to save anyway?"
	};
	var ORG_FLOW_URL = new Map([
	    ["CRC-West", "/static/custom-flows/crcwest/"]
	]);
	var DEFAULT_URL = "/static/custom-flows/fcwifc/";
	var CustomIntakeComponent = (function () {
	    function CustomIntakeComponent(router, route, messaging, subjects, intakeSteps, reportSteps, comments, alerts, modals, watchlist, algorithms, users, element, settings, search, sanitizer) {
	        var _this = this;
	        this.router = router;
	        this.route = route;
	        this.messaging = messaging;
	        this.subjects = subjects;
	        this.intakeSteps = intakeSteps;
	        this.reportSteps = reportSteps;
	        this.comments = comments;
	        this.alerts = alerts;
	        this.modals = modals;
	        this.watchlist = watchlist;
	        this.algorithms = algorithms;
	        this.users = users;
	        this.element = element;
	        this.settings = settings;
	        this.search = search;
	        this.sanitizer = sanitizer;
	        this.unsafeURLBasis = this.users.self.groups.map(function (g) { return ORG_FLOW_URL.get(g.name); }).find(function (x) { return !!x; }) || DEFAULT_URL;
	        this.formTemplateURL = this.sanitizer.bypassSecurityTrustResourceUrl(build_flags_1.BuildFlags.useProductionHostValues ? this.unsafeURLBasis : "http://localhost:4200");
	        this.objectId = -1;
	        this.paramNavSub = new Rx_1.Subscription();
	        this.paramNavWindow = 1000;
	        this.saveRequested = false;
	        this.saveRequestTime = -1;
	        this.outgoingId = -1;
	        this.incomingAppInfo = { name: "N/A" };
	        this.route.params.subscribe(function (params) {
	            if (_this.objectId === undefined || _this.objectId < 0) {
	                return;
	            }
	            _this.sendPM({ _: "restart" });
	        });
	    }
	    CustomIntakeComponent.prototype.lockable = function () { return true; };
	    CustomIntakeComponent.prototype.ngOnInit = function () {
	        this.algorithm = this.algorithms.running;
	        this.title =
	            this.algorithm.displayName || "Intake Form";
	        this.alerts.suppressedLevels.add("notification");
	        this.alerts.suppressedLevels.add("user");
	        this.alerts.suppressedLevels.add("success");
	        this.objectId = this.algorithms.running.subject.id;
	        window.scrollTo(0, 0);
	        console.log(this.users.self.groups.map(function (g) { return g.name; }).join(", ") + " ... " + this.unsafeURLBasis);
	    };
	    CustomIntakeComponent.prototype.ngOnDestroy = function () {
	    };
	    CustomIntakeComponent.prototype.canLeave = function () {
	        return Rx_1.Observable.of(true);
	    };
	    CustomIntakeComponent.prototype.requiredStepsComplete = function () {
	        return true;
	    };
	    CustomIntakeComponent.prototype.saveSubject = function (force) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        return this.algorithm.save(force).flatMap(function (code) {
	            if (code === general_1.ResponseCode.OK) {
	                return [true];
	            }
	            else if (code === general_1.ResponseCode.Irretrievable) {
	                return [false];
	                _this.modals.confirm(RETRIEVABILITY_MODAL)
	                    .flatMap(function (saveHard) {
	                    if (saveHard) {
	                        return _this.saveSubject(true);
	                    }
	                    return [false];
	                });
	            }
	            else {
	                _this.alerts.warn("The subject could not be saved: " + general_1.GENERIC_REASON_TEXT.get(code));
	                return [false];
	            }
	        });
	    };
	    CustomIntakeComponent.prototype.resummarize = function (watchId) {
	        this.watchlist.resummarize({ watchId: watchId }).subscribe();
	    };
	    CustomIntakeComponent.prototype.resummarizeIfWatched = function () {
	        var ref = this.algorithm.subject.findRef("watch");
	        if (ref) {
	            this.resummarize(ref.id);
	        }
	    };
	    CustomIntakeComponent.prototype.unload = function (event) {
	        if (false) {
	            event.returnValue = BROWSER_SAVE_NEEDED_MESSAGE;
	            return;
	        }
	    };
	    CustomIntakeComponent.prototype.save = function () {
	        throw new Error("UNIMPLEMENTED - PARTIAL INTERFACE COMPLIANCES");
	    };
	    CustomIntakeComponent.prototype.showLinkedReminderModal = function () {
	        var _this = this;
	        this.modals.observe(add_reminder_modal_component_1.AddReminderModalComponent, { size: "md", hasImpliedLink: true }).subscribe(function (r) {
	            if (r) {
	                _this.watchlist.addReminder(r.summary, r.triggerTime, r.linkedRecord ? _this.objectId : undefined).subscribe();
	            }
	        });
	    };
	    CustomIntakeComponent.prototype.submitFromChild = function (rawAnswers, comments) {
	        var _this = this;
	        var stepAnswers = rawAnswers.map(function (_a) {
	            var key = _a[0], value = _a[1];
	            var step = _this.intakeSteps.findNamed(key);
	            if (!step) {
	                console.warn("Couldn't find step named \"" + key + "\", skipping");
	                return null;
	            }
	            if ((step.cardinality === 1) === Array.isArray(value)) {
	                debugger;
	                console.error("Cardinality mismatch, " + step.name + " expected " + (step.cardinality === 1 ? "scalar" : "array") + " value, got " + value);
	            }
	            switch (step.type) {
	                case "date":
	                    if (step.cardinality !== 1) {
	                        console.error("Lists of dates not yet convertible");
	                        return null;
	                    }
	                    if (Number.isSafeInteger(value)) {
	                        step.value = new Date(value);
	                    }
	                    else {
	                        return null;
	                    }
	                    break;
	                case "integer":
	                case "natural number":
	                case "whole number":
	                    if (!Number.isSafeInteger(value)) {
	                        console.error("Integer-like step got a non-integer value, skipping!\n  " + step.name + " = " + value);
	                        return null;
	                    }
	                default:
	                    step.value = value;
	            }
	            return step.completedIntakeStep();
	        }).filter(function (i) { return i; });
	        try {
	            var j = JSON.stringify(stepAnswers);
	        }
	        catch (err) {
	            console.error(err);
	        }
	        var o = this.intakeSteps.submit(stepAnswers).map(function (m) { return !!m.ok; });
	        o.subscribe();
	        var allObs = [o];
	        comments.forEach(function (_a) {
	            var stepKey = _a[0], commentText = _a[1];
	            return allObs.push(_this.comments.addForStep(_this.intakeSteps.findNamed(stepKey).id, commentText, comment_1.Visibility.Public));
	        });
	        return Rx_1.Observable.forkJoin.apply(Rx_1.Observable, allObs);
	    };
	    CustomIntakeComponent.prototype.scrollToTop = function () {
	        document.scrollingElement.scrollTo({ top: 0 });
	    };
	    CustomIntakeComponent.prototype.printPage = function () {
	        console.log(window);
	        window.print();
	    };
	    CustomIntakeComponent.prototype.sendPM = function (m) {
	        if (!('__' in m)) {
	            m.__ = this.outgoingId--;
	        }
	        if (!this.intakeFrame || !this.intakeFrame.nativeElement || this.intakeFrame.nativeElement.tagName !== "IFRAME") {
	            console.error("Cannot find frame element!");
	            return;
	        }
	        var frameWindow = this.intakeFrame.nativeElement.contentWindow;
	        frameWindow.postMessage(m, build_flags_1.BuildFlags.useProductionHostValues ? location.origin : "http://localhost:4200");
	    };
	    CustomIntakeComponent.prototype.sendAck = function (incoming) {
	        this.sendPM({ _: "ACK", __: incoming.__ });
	    };
	    CustomIntakeComponent.prototype.sendFail = function (incoming) {
	        this.sendPM({ _: "FAIL", __: incoming.__ });
	    };
	    CustomIntakeComponent.prototype.pmRecordStart = function (e) {
	        this.incomingAppInfo = e.appInfo;
	        if (!ALLOWED_PROFILE_NAMES.includes(e.appInfo.name)) {
	            console.error("Could not find profile for custom intake " + e.appInfo.name);
	            return this.sendFail(e);
	        }
	        var profile = KNOWN_PROFILES[e.appInfo.name];
	        if (profile.minimumVersion > e.appInfo.version
	            || !profile.flavors.includes(e.appInfo.flavor)) {
	            console.error("Custom intake " + e.appInfo.name + " does not support flavor+version " + e.appInfo.flavor + "v" + e.appInfo.version + " (needs [" + profile.flavors.join(",") + "], \u2265v" + profile.minimumVersion + ")");
	            return this.sendFail(e);
	        }
	        if (!profile.algorithms.includes(this.algorithm.name)) {
	            console.error("Profile " + profile.name + " is not compatible with algorithm " + this.algorithm.name + "!");
	            return this.sendFail(e);
	        }
	        console.info("Found matching profile, acknowledging");
	        this.appProfile = profile;
	        this.sendAck(e);
	    };
	    CustomIntakeComponent.prototype.incomingPMListener = function (e) {
	        var _this = this;
	        if (build_flags_1.BuildFlags.useProductionHostValues ?
	            (e.origin === location.origin) :
	            (e.origin === "http://localhost:4200")) {
	            if (!e.data || typeof e.data !== 'object' || typeof e.data._ !== 'string') {
	                console.error("Received non-object msg, or msg without a _ type", e.data);
	                return;
	            }
	            console.info("Attempting to handle " + e.data._ + "...", e.data);
	            switch (e.data._) {
	                case "init":
	                    this.pmRecordStart(e.data);
	                    return;
	                case "log":
	                    var verb = (["info", "log", "warn", "error"].includes(e.data.level))
	                        ? e.data.level : "log";
	                    console[verb]("Child application requested logging:", e.data.message);
	                    return;
	                case "submitAnswers":
	                    this.submitFromChild(e.data.answers || [], e.data.comments || []).flatMap(function (successes) {
	                        debugger;
	                        if (successes.every(function (s) { return s; })) {
	                            return _this.saveSubject(true);
	                        }
	                        return [false];
	                    }).flatMap(function (saved) {
	                        debugger;
	                        if (saved) {
	                            return _this.messaging.resultOf(new context_management_1.ReferSubjectContextRequest(_this.algorithm.subject.id, "Automated FCWI referral at " + (new Date()).toLocaleString()));
	                        }
	                        return [saved];
	                    }).subscribe(function (success) {
	                        debugger;
	                        if (success) {
	                            _this.sendAck(e.data);
	                        }
	                        else {
	                            _this.sendFail(e.data);
	                        }
	                    }, function (err) {
	                        _this.sendFail(e.data);
	                    });
	                    return;
	                case "restart":
	                    this.subjects.launchNew(this.algorithm.algorithm);
	                    return;
	                default:
	                    console.warn("Unhandled PM type " + e.data._ + ", ignoring", e.data);
	                    this.sendFail(e.data);
	            }
	        }
	        else {
	            console.error("Rejecting insecure message from " + e.origin, e);
	        }
	    };
	    __decorate([
	        core_1.ViewChild('intakeFrame'),
	        __metadata("design:type", core_1.ElementRef)
	    ], CustomIntakeComponent.prototype, "intakeFrame", void 0);
	    __decorate([
	        core_1.HostListener("window:beforeunload", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [BeforeUnloadEvent]),
	        __metadata("design:returntype", void 0)
	    ], CustomIntakeComponent.prototype, "unload", null);
	    __decorate([
	        core_1.HostListener("window:message", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [MessageEvent]),
	        __metadata("design:returntype", void 0)
	    ], CustomIntakeComponent.prototype, "incomingPMListener", null);
	    CustomIntakeComponent = __decorate([
	        core_1.Component({
	            selector: "coverage-form",
	            template: "\n    <iframe style=\"height: max(calc(100vh - 163px), 800px); width: 100vw; border: none;\" [src]=\"formTemplateURL\" #intakeFrame></iframe>\n",
	            styles: [],
	            providers: []
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            router_1.ActivatedRoute,
	            messaging_service_1.MessagingService,
	            subject_service_1.SubjectService,
	            intake_step_service_1.IntakeStepService,
	            report_step_service_1.ReportStepService,
	            comment_service_1.CommentService,
	            alert_service_1.AlertService,
	            modal_service_1.ModalService,
	            watchlist_service_1.WatchlistService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService,
	            core_1.ElementRef,
	            setting_service_1.SettingService,
	            search_service_1.SearchService,
	            platform_browser_1.DomSanitizer])
	    ], CustomIntakeComponent);
	    return CustomIntakeComponent;
	}());
	exports.CustomIntakeComponent = CustomIntakeComponent;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var search_service_1 = __webpack_require__(834);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var sounds_service_1 = __webpack_require__(756);
	var auth_service_1 = __webpack_require__(777);
	var support_service_1 = __webpack_require__(886);
	var http_1 = __webpack_require__(66);
	var alert_service_1 = __webpack_require__(689);
	var login_service_1 = __webpack_require__(814);
	var configuration_service_1 = __webpack_require__(512);
	var user_service_1 = __webpack_require__(713);
	var algorithm_service_1 = __webpack_require__(213);
	var console_interceptor_1 = __webpack_require__(722);
	var TestStatus;
	(function (TestStatus) {
	    TestStatus[TestStatus["Failed"] = -1] = "Failed";
	    TestStatus[TestStatus["Unstarted"] = 0] = "Unstarted";
	    TestStatus[TestStatus["InProgress"] = 1] = "InProgress";
	    TestStatus[TestStatus["Partial"] = 2] = "Partial";
	    TestStatus[TestStatus["Success"] = 3] = "Success";
	})(TestStatus || (TestStatus = {}));
	var FeatureTestRigComponent = (function () {
	    function FeatureTestRigComponent(router, search, messaging, subjects, sounds, auth, support, http, alerts, login, config, user, alg) {
	        this.search = search;
	        this.messaging = messaging;
	        this.subjects = subjects;
	        this.sounds = sounds;
	        this.auth = auth;
	        this.support = support;
	        this.http = http;
	        this.alerts = alerts;
	        this.login = login;
	        this.config = config;
	        this.user = user;
	        this.alg = alg;
	        this.unreadyServices = new Set([]);
	        this.readyServices = new Set([]);
	        this.tests = [
	            {
	                title: "Javascript Baseline",
	                status: TestStatus.Success,
	                resultsText: "Javascript is available and functioning.",
	            },
	            {
	                title: "Browser Support",
	                status: this.support.browserSupportLevel > support_service_1.SupportLevel.Known
	                    ? TestStatus.Partial
	                    : TestStatus.Success,
	                resultsText: this.support.browserSupportLevel === support_service_1.SupportLevel.UnsupportedAgent
	                    ? "This is not a well-supported browser agent."
	                    : this.support.browserSupportLevel > support_service_1.SupportLevel.Known
	                        ? "This version of Chrome may not support critical features."
	                        : "This version of Chrome is well-supported.",
	                resultsObject: this.support.browser,
	            },
	            {
	                title: "Resource Retrieval",
	                status: TestStatus.Unstarted,
	                resultsText: "Running...",
	                resultsObject: {},
	            },
	            {
	                title: "Primary Websocket",
	                status: TestStatus.Unstarted,
	                resultsText: "Waiting for socket service; if this message lasts more than 2 seconds, it's a failure",
	                resultsObject: {
	                    state: this.messaging.state,
	                },
	            },
	            {
	                title: "Protocol Test",
	                status: location.protocol === "https:" ? TestStatus.Success : TestStatus.Failed,
	                resultsText: location.protocol === "https:"
	                    ? "Plausible TLS connection (unconfirmable without server)"
	                    : "Wrong protocol used!",
	                resultsObject: location.protocol === "https:"
	                    ? undefined
	                    : {
	                        protocol: location.protocol,
	                        host: location.host,
	                        href: location.href,
	                    },
	            },
	            {
	                title: "Service Readiness",
	                status: TestStatus.Unstarted,
	                resultsText: "",
	            },
	            {
	                title: "Found Errors",
	                status: TestStatus.InProgress,
	                resultsText: "Awaiting log quiescence...",
	            },
	        ];
	    }
	    FeatureTestRigComponent.prototype.updateReadinessTest = function () {
	        var total = this.readyServices.size + this.unreadyServices.size;
	        this.tests[5] = __assign({}, this.tests[5], { status: this.unreadyServices.size === 0
	                ? TestStatus.Success
	                : this.readyServices.size > 1
	                    ? TestStatus.Partial
	                    : TestStatus.Failed, resultsText: this.readyServices.size + "/" + total + " services ready", resultsObject: {
	                unready: Array.from(this.unreadyServices),
	                ready: Array.from(this.readyServices),
	            } });
	    };
	    FeatureTestRigComponent.prototype.markReadiness = function (serviceName) {
	        var _this = this;
	        return function (ready) {
	            if (ready) {
	                _this.unreadyServices.delete(serviceName);
	                _this.readyServices.add(serviceName);
	            }
	            else {
	                _this.readyServices.delete(serviceName);
	                _this.unreadyServices.add(serviceName);
	            }
	            _this.updateReadinessTest();
	        };
	    };
	    FeatureTestRigComponent.prototype.promptByStatus = function (title, status) {
	        switch (status) {
	            case TestStatus.Failed:
	                return title + ": FAILED";
	            case TestStatus.Unstarted:
	                return "Run " + title;
	            case TestStatus.InProgress:
	                return title + ": in progress...";
	            case TestStatus.Partial:
	                return title + ": partial success!";
	            case TestStatus.Success:
	                return title + ": success!";
	            default:
	                return title + ": unknown status " + status;
	        }
	    };
	    FeatureTestRigComponent.prototype.fetchTest = function () {
	        var _this = this;
	        this.tests[2].status = TestStatus.InProgress;
	        var started = Date.now();
	        var sub = this.http
	            .get("/static/config/settings.json")
	            .subscribe(function (res) {
	            if (res.ok) {
	                _this.tests[2].status = TestStatus.Success;
	                _this.tests[2].resultsText = "Retrieved local config JSON";
	                _this.tests[2].resultsObject = {
	                    status: res.status,
	                    cType: res.headers.get("content-type"),
	                    pby: res.headers.get("x-powered-by"),
	                    elapsed: Date.now() - started,
	                };
	            }
	            else {
	                _this.tests[2].status = TestStatus.Failed;
	                _this.tests[2].resultsText = "Error during JSON retrieval";
	                _this.tests[2].resultsObject = {
	                    status: res.status,
	                    headers: res.headers.toJSON(),
	                    body: res.toString(),
	                    elapsed: Date.now() - started,
	                };
	            }
	        });
	        var maxTime = 2000;
	        setTimeout(function () {
	            if (sub.closed) {
	                return;
	            }
	            else {
	                sub.unsubscribe();
	                _this.tests[2].status = TestStatus.Failed;
	                _this.tests[2].resultsText = "Fetch took longer than " + maxTime / 1000 + "s to complete, assuming failed!";
	            }
	        }, maxTime);
	    };
	    FeatureTestRigComponent.prototype.runTest = function (_a) {
	        var run = _a.run;
	        if (run && typeof run === "function") {
	            run();
	        }
	    };
	    FeatureTestRigComponent.prototype.listErrors = function () {
	        var errors = console_interceptor_1.CONSOLE_HISTORY.filter(function (_a) {
	            var e = _a[0], n = _a[1], c = _a[2];
	            return e === "error";
	        });
	        if (errors.length > 0) {
	            this.tests[6].status = TestStatus.Partial;
	            this.tests[6].resultsText = errors.length + " errors in log";
	            this.tests[6].resultsObject = errors;
	        }
	    };
	    FeatureTestRigComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.messaging.ready.subscribe(function (r) {
	            console.warn("Messaging readiness update: " + r);
	            if (r) {
	                _this.tests[3] = __assign({}, _this.tests[3], { status: TestStatus.Success, resultsText: "Websockets connected to server", resultsObject: {
	                        pingStats: _this.messaging.pingStats(),
	                    } });
	            }
	            else {
	                _this.tests[3] = __assign({}, _this.tests[3], { status: TestStatus.InProgress, resultsText: "Websockets attempting to connect", resultsObject: {
	                        status: _this.messaging.state,
	                        recentTimes: _this.messaging.recentLog.list(),
	                        pingStats: _this.messaging.pingStats(),
	                        retries: [_this.messaging.retryCount, _this.messaging.restartCount],
	                    } });
	            }
	        });
	        var RESTARTS_TIL_FAILURE = 1;
	        setInterval(function () {
	            if (_this.messaging.state === messaging_service_1.MessagingState.Dead ||
	                _this.messaging.retryCount >= RESTARTS_TIL_FAILURE) {
	                _this.tests[3] = __assign({}, _this.tests[3], { status: TestStatus.Failed, resultsText: "Websocket had dropped connection", resultsObject: {
	                        status: _this.messaging.state,
	                        recentTimes: _this.messaging.recentLog.list(),
	                        pingStats: _this.messaging.pingStats(),
	                        retries: [_this.messaging.retryCount, _this.messaging.restartCount],
	                    } });
	            }
	        }, 1900);
	        this.alerts.mute();
	        this.messaging.ready.subscribe(this.markReadiness("messaging"));
	        this.config.ready.subscribe(this.markReadiness("configuration"));
	        this.user.ready.subscribe(this.markReadiness("users"));
	        this.alg.ready.subscribe(this.markReadiness("algorithms"));
	        this.search.ready.subscribe(this.markReadiness("search"));
	        this.fetchTest();
	        setTimeout(function () { return _this.listErrors(); }, 2000);
	    };
	    FeatureTestRigComponent.prototype.print = function () {
	        window.print();
	    };
	    FeatureTestRigComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"container\">\n      <div class=\"well\">\n        <p>\n          This is the Advocus compatibility test page. You can use this page,\n          with assistance from My Coverage Plan staff, to help diagnose issues\n          with your organization's ability to access Advocus.\n        </p>\n        <p>\n          First, wait a few seconds for any incomplete tests to run. Then either\n          <a (click)=\"print()\">print this page to PDF</a>, take screenshots of\n          the entire page (often <kbd>Win</kbd>+<kbd>S</kbd> on Windows or\n          <kbd>Cmd</kbd>+<kbd>Shift</kbd>+<kbd>3</kbd> on Mac), or copy\n          <u>all</u> of the results text below and send it to MCP.\n        </p>\n      </div>\n      <ul>\n        <li *ngFor=\"let test of tests\">\n          <button\n            class=\"btn\"\n            [class.btn-primary]=\"test.status === 0 || test.status === 1\"\n            [class.btn-danger]=\"test.status < 0\"\n            [class.btn-warning]=\"test.status === 2\"\n            [class.btn-success]=\"test.status === 3\"\n            [class.btn-disabled]=\"test.status >= 1\"\n            [disabled]=\"test.status >= 1\"\n            (click)=\"runTest(test)\"\n          >\n            {{ promptByStatus(test.title, test.status) + \"\" }}\n          </button>\n          {{ test.resultsText }}\n          <pre *ngIf=\"test.resultsObject\">{{ test.resultsObject | json }}</pre>\n        </li>\n      </ul>\n    </div>\n  ",
	            styles: [
	                "\n      li {\n        margin-top: 10px;\n      }\n      .btn {\n        width: 240px;\n      }\n    ",
	            ],
	            animations: [],
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            search_service_1.SearchService,
	            messaging_service_1.MessagingService,
	            subject_service_1.SubjectService,
	            sounds_service_1.SoundsService,
	            auth_service_1.AuthService,
	            support_service_1.SupportService,
	            http_1.Http,
	            alert_service_1.AlertService,
	            login_service_1.LoginService,
	            configuration_service_1.ConfigurationService,
	            user_service_1.UserService,
	            algorithm_service_1.AlgorithmService])
	    ], FeatureTestRigComponent);
	    return FeatureTestRigComponent;
	}());
	exports.FeatureTestRigComponent = FeatureTestRigComponent;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var SupportLevel;
	(function (SupportLevel) {
	    SupportLevel[SupportLevel["Known"] = 0] = "Known";
	    SupportLevel[SupportLevel["Likely"] = 1] = "Likely";
	    SupportLevel[SupportLevel["UnsupportedAgent"] = 3] = "UnsupportedAgent";
	    SupportLevel[SupportLevel["UnsupportedVersion"] = 4] = "UnsupportedVersion";
	})(SupportLevel = exports.SupportLevel || (exports.SupportLevel = {}));
	var SemVer = (function () {
	    function SemVer(original) {
	        var _a;
	        this.original = original;
	        _a = original.match(/(\d*)\.(\d*)\.(\d*)/).map(function (group) { return Number.parseInt(group, 10); }), this.major = _a[1], this.minor = _a[2], this.patch = _a[3];
	    }
	    return SemVer;
	}());
	exports.SemVer = SemVer;
	var BAD_BROWSER_MESSAGE = "At this time, Advocus only officially supports the Chrome browser. Since you are using another browser, you may encounter unforeseen problems.";
	var UNTESTED_VERSION_MESSAGE = "Your browser version is over 1 year old. While we do not anticipate any functionality issues, please consider upgrading for the best support.";
	var TOO_OLD_VERSION_MESSAGE = "Your browser version is over 2 years old. We cannot currently guarantee support before Chrome 46 and you may hit unforeseen problem.";
	var CHROME_FULL_SUPPORT_MIN = 54;
	var CHROME_LIKELY_SUPPORT_MIN = 46;
	var SupportService = (function () {
	    function SupportService(alerts) {
	        this.alerts = alerts;
	        this.browser = this.categorizeUACheaply(navigator.userAgent);
	        this.browserSupportLevel = this.determineBrowserSupport();
	    }
	    SupportService.prototype.checkBrowser = function () {
	        switch (this.browserSupportLevel) {
	            case SupportLevel.UnsupportedAgent:
	                return this.alerts.error(BAD_BROWSER_MESSAGE);
	            case SupportLevel.Likely:
	                return this.alerts.warn(UNTESTED_VERSION_MESSAGE);
	            case SupportLevel.UnsupportedVersion:
	                return this.alerts.error(TOO_OLD_VERSION_MESSAGE);
	        }
	    };
	    SupportService.prototype.determineBrowserSupport = function () {
	        if (this.browser.type !== "chrome") {
	            return SupportLevel.UnsupportedAgent;
	        }
	        if (Number.parseFloat(this.browser.version) < CHROME_LIKELY_SUPPORT_MIN) {
	            return SupportLevel.UnsupportedVersion;
	        }
	        if (Number.parseFloat(this.browser.version) < CHROME_FULL_SUPPORT_MIN) {
	            return SupportLevel.Likely;
	        }
	        return SupportLevel.Known;
	    };
	    SupportService.prototype.categorizeUACheaply = function (agentString) {
	        var isMobile = agentString.indexOf("Mobi") > -1;
	        var chrome = agentString.match(/Chrom(?:e|ium)\/(\S*)/);
	        if (chrome && chrome.length === 2) {
	            return {
	                agentString: agentString,
	                type: "chrome",
	                isMobile: isMobile,
	                version: chrome[1]
	            };
	        }
	        else {
	            return {
	                agentString: agentString,
	                type: "other",
	                isMobile: isMobile,
	                version: "uknown"
	            };
	        }
	    };
	    SupportService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [alert_service_1.AlertService])
	    ], SupportService);
	    return SupportService;
	}());
	exports.SupportService = SupportService;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var shared_module_1 = __webpack_require__(63);
	var management_panel_component_1 = __webpack_require__(888);
	var reset_password_modal_component_1 = __webpack_require__(889);
	var modal_service_1 = __webpack_require__(837);
	var remove_user_group_modal_component_1 = __webpack_require__(891);
	var MANAGEMENT_ROUTING = router_1.RouterModule.forChild([{ path: "", component: management_panel_component_1.ManagementPanelComponent }]);
	var ManagementModule = (function () {
	    function ManagementModule() {
	    }
	    ManagementModule_1 = ManagementModule;
	    ManagementModule.forRoot = function () {
	        return {
	            ngModule: ManagementModule_1,
	        };
	    };
	    var ManagementModule_1;
	    ManagementModule = ManagementModule_1 = __decorate([
	        core_1.NgModule({
	            imports: [shared_module_1.SharedModule, MANAGEMENT_ROUTING],
	            declarations: [
	                management_panel_component_1.ManagementPanelComponent,
	                reset_password_modal_component_1.ResetPasswordModalComponent,
	                remove_user_group_modal_component_1.RemoveUserGroupModalComponent
	            ],
	            entryComponents: [reset_password_modal_component_1.ResetPasswordModalComponent, remove_user_group_modal_component_1.RemoveUserGroupModalComponent],
	            exports: [],
	            providers: [modal_service_1.ModalService]
	        })
	    ], ManagementModule);
	    return ManagementModule;
	}());
	exports.ManagementModule = ManagementModule;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var user_service_1 = __webpack_require__(713);
	var auth_service_1 = __webpack_require__(777);
	var alert_service_1 = __webpack_require__(689);
	var modal_service_1 = __webpack_require__(837);
	var rules_1 = __webpack_require__(640);
	var reset_password_modal_component_1 = __webpack_require__(889);
	var constants_1 = __webpack_require__(890);
	var remove_user_group_modal_component_1 = __webpack_require__(891);
	var ManagementPanelComponent = (function () {
	    function ManagementPanelComponent(users, auth, modals, alerts) {
	        this.users = users;
	        this.auth = auth;
	        this.modals = modals;
	        this.alerts = alerts;
	        this.groupControl = new forms_1.FormControl();
	        this.addNewUser = false;
	        this.addUserToGroup = false;
	        this.roleTemplates = constants_1.roleTemplates;
	        this.newName = new forms_1.FormControl();
	        this.newPhone = new forms_1.FormControl();
	        this.newCountry = new forms_1.FormControl();
	        this.newLanguage = new forms_1.FormControl();
	        this.userDetails = new forms_1.FormArray([
	            this.newName,
	            this.newPhone,
	            this.newCountry,
	            this.newLanguage,
	        ]);
	        this.newUserLogin = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserPassword = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserName = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserPhone = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserCountryCode = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserLanguageCode = new forms_1.FormControl("", forms_1.Validators.required);
	        this.newUserZoneRules = new forms_1.FormArray([]);
	        this.newUserGroupRules = new forms_1.FormArray([]);
	        this.roleTemplate = new forms_1.FormControl(constants_1.CUSTOM);
	        this.newUserForm = new forms_1.FormGroup({
	            login: this.newUserLogin,
	            password: this.newUserPassword,
	            name: this.newUserName,
	            phone: this.newUserPhone,
	            countryCode: this.newUserCountryCode,
	            languageCode: this.newUserLanguageCode,
	            roleTemplate: this.roleTemplate,
	            zoneRules: this.newUserZoneRules,
	            groupRules: this.newUserGroupRules,
	        });
	        this.addToGroup = new forms_1.FormControl();
	        this.addToGroupRules = new forms_1.FormArray([]);
	        this.addToGroupForm = new forms_1.FormGroup({
	            groups: this.addToGroup,
	            groupRules: this.newUserGroupRules,
	        });
	    }
	    ManagementPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.groupControl.valueChanges.subscribe(function (g) {
	            _this.refreshGroup(g);
	        });
	        this.roleTemplate.valueChanges.subscribe(function (roleTemplate) {
	            if (roleTemplate && roleTemplate.name !== "Custom") {
	                var groupRules_1 = _this.newUserForm.get("groupRules");
	                _this.group.rules.forEach(function (rule, index) {
	                    if (roleTemplate.groupRules.includes(rule)) {
	                        groupRules_1.at(index).setValue(true);
	                    }
	                    else {
	                        groupRules_1.at(index).setValue(false);
	                    }
	                });
	                var zoneRules_1 = _this.newUserForm.get("zoneRules");
	                _this.users.self.rules.forEach(function (rule, index) {
	                    if (roleTemplate.zoneRules.includes(rule)) {
	                        zoneRules_1.at(index).setValue(true);
	                    }
	                    else {
	                        zoneRules_1.at(index).setValue(false);
	                    }
	                });
	            }
	        });
	        if (this.users.self.managedGroups.length > 0) {
	            this.groupControl.setValue(this.users.self.managedGroups[0]);
	        }
	    };
	    ManagementPanelComponent.prototype.refreshGroup = function (group) {
	        var _this = this;
	        this.selectedUser = null;
	        this.users.getGroupUsers(group).subscribe(function (group) {
	            _this.group = group;
	            _this.addUserToGroup = false;
	            _this.addToGroupForm.reset();
	            _this.newUserForm.get("roleTemplate").setValue(constants_1.CUSTOM);
	            _this.newUserForm.setControl("zoneRules", new forms_1.FormArray([]));
	            _this.users.self.rules.forEach(function () {
	                _this.newUserForm.get("zoneRules").push(new forms_1.FormControl(false));
	            });
	            _this.newUserForm.setControl("groupRules", new forms_1.FormArray([]));
	            group.rules.forEach(function () {
	                _this.newUserForm.get("groupRules").push(new forms_1.FormControl(false));
	                _this.addToGroupForm.get("groupRules").push(new forms_1.FormControl(false));
	            });
	        });
	    };
	    ManagementPanelComponent.prototype.open = function (user) {
	        var _this = this;
	        this.selectedUser = user;
	        this.users.requestUserDetails(user).subscribe(function () {
	            _this.addUserToGroup = false;
	            _this.addToGroupForm.reset();
	            _this.newName.reset(user.name);
	            _this.newPhone.reset(user.phone);
	            _this.newCountry.reset(user.countryCodeID);
	            _this.newLanguage.reset(user.languageCodeID);
	        });
	    };
	    ManagementPanelComponent.prototype.toggleUserActiveness = function () {
	        var _this = this;
	        var changeUser = this.selectedUser;
	        this.users
	            .requestUserActiveStatusChange(this.group, changeUser, !changeUser.isActive)
	            .subscribe(function (response) {
	            _this.open(changeUser);
	            _this.alerts.success("User status saved successfully");
	        }, function (error) { });
	    };
	    ManagementPanelComponent.prototype.saveUserDetails = function () {
	        var _this = this;
	        var changeUser = this.selectedUser;
	        var o = changeUser.isSelf
	            ? this.users.requestUserEditRequest(this.newName.value, this.newPhone.value, this.newCountry.value, this.newLanguage.value)
	            : this.users.requestOtherUserEditRequest(changeUser.objectId, this.newName.value, this.newPhone.value, this.newCountry.value, this.newLanguage.value);
	        o.subscribe(function (response) {
	            _this.open(changeUser);
	            _this.alerts.success("User details saved successfully");
	        }, function (error) { });
	        this.userDetails.markAsPristine();
	    };
	    ManagementPanelComponent.prototype.requestPasswordReset = function () {
	        var _this = this;
	        this.modals
	            .observe(reset_password_modal_component_1.ResetPasswordModalComponent, {
	            objectId: this.selectedUser.objectId,
	        })
	            .subscribe(function (saved) {
	            return saved
	                ? _this.alerts.success("User password reset successfully")
	                : _this.alerts.error("User password reset unsuccessful");
	        });
	    };
	    ManagementPanelComponent.prototype.getRuleName = function (rule) {
	        return rules_1.RULE_NAMES.get(rule) || rules_1.Rule[rule] + " (" + rule + ")";
	    };
	    ManagementPanelComponent.prototype.toggleNewUser = function () {
	        this.addNewUser = !this.addNewUser;
	    };
	    ManagementPanelComponent.prototype.onNewUserSubmit = function () {
	        var _this = this;
	        var o = this.users.requestUserCreate(this.newUserForm.get("login").value, this.newUserForm.get("password").value, this.newUserForm.get("name").value, this.newUserForm.get("phone").value, Number(this.newUserForm.get("countryCode").value), Number(this.newUserForm.get("languageCode").value), this.group, this.group.rules.filter(function (_rule, index) {
	            return _this.newUserForm.get("groupRules").value[index] === true;
	        }), this.users.self.rules.filter(function (_rule, index) {
	            return _this.newUserForm.get("zoneRules").value[index] === true;
	        }));
	        o.subscribe(function (response) {
	            _this.newUserForm.reset();
	            _this.addNewUser = false;
	            _this.refreshGroup(_this.group);
	            _this.alerts.success("User created successfully");
	        }, function (error) { return _this.alerts.error("Failed to create user"); });
	    };
	    ManagementPanelComponent.prototype.getGroupsToAdd = function () {
	        var managingGroups = this.users.self.managedGroups;
	        var selectedUserGroup = this.selectedUser.groups;
	        return managingGroups.filter(function (managingGroup) {
	            return !selectedUserGroup.find(function (userGroup) { return userGroup.id === managingGroup.id; });
	        });
	    };
	    ManagementPanelComponent.prototype.onAddUserToOtherGroupSubmit = function () {
	        var _this = this;
	        var selectedUserGroupRules = this.selectedUser.groups.find(function (group) { return group.id === _this.group.id; }).rules;
	        var o = this.users.requestAddUserToGroupRequest(this.selectedUser.objectId, this.addToGroupForm.get("groups").value, selectedUserGroupRules);
	        o.subscribe(function (response) {
	            _this.addToGroupForm.reset();
	            _this.addUserToGroup = false;
	            _this.alerts.success("User added to group successfully");
	        }, function (error) { return _this.alerts.error("Failed to add user to group"); });
	    };
	    ManagementPanelComponent.prototype.removeUserFromGroup = function () {
	        var _this = this;
	        this.modals
	            .observe(remove_user_group_modal_component_1.RemoveUserGroupModalComponent, {
	            objectId: this.selectedUser.objectId,
	            groupId: this.group.id,
	        })
	            .subscribe(function (saved) {
	            _this.refreshGroup(_this.group);
	            saved
	                ? _this.alerts.success("User removed from group successfully")
	                : _this.alerts.error("Failed to remove user from group");
	        });
	    };
	    ManagementPanelComponent.prototype.addUsertoOtherGroup = function () {
	        this.addUserToGroup = !this.addUserToGroup;
	    };
	    ManagementPanelComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-sm-4\">\n          <h1>Management Tools</h1>\n        </div>\n        <div class=\"col-sm-8\">\n          <div class=\"form-group\">\n            <label>Select group to manage:</label>\n            <div class=\"row\">\n              <div class=\"col-sm-7 include-badge\">\n                <select class=\"form-control\" [formControl]=\"groupControl\">\n                  <option\n                    *ngFor=\"let gp of users.self.managedGroups\"\n                    [ngValue]=\"gp\"\n                  >\n                    {{ gp.name }}\n                  </option>\n                </select>\n                <span class=\"badge\">{{ users.self.managedGroups.length }}</span>\n              </div>\n              <div class=\"col-sm-4\">\n                <button (click)=\"toggleNewUser()\" class=\"btn btn-primary\">\n                  Add a new user\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div *ngIf=\"addNewUser\" class=\"row\">\n        <div class=\"col-sm-2\"></div>\n        <div class=\"col-sm-8\">\n          <h4>New User Details</h4>\n          <caption class=\"col-sm-8\">\n            Create a new user in\n            <em>{{ group.name }}</em>\n          </caption>\n          <form\n            [formGroup]=\"newUserForm\"\n            (ngSubmit)=\"onNewUserSubmit()\"\n            ngNativeValidate\n          >\n            <table class=\"table\">\n              <tbody>\n                <tr>\n                  <th>Login</th>\n                  <td colspan=\"2\">\n                    <input\n                      type=\"text\"\n                      formControlName=\"login\"\n                      class=\"form-control\"\n                      required\n                    />\n                  </td>\n                </tr>\n                <tr>\n                  <th>Password</th>\n                  <td colspan=\"2\">\n                    <input\n                      type=\"password\"\n                      formControlName=\"password\"\n                      class=\"form-control\"\n                      required\n                    />\n                  </td>\n                </tr>\n                <tr>\n                  <th>Name</th>\n                  <td colspan=\"2\">\n                    <input\n                      type=\"text\"\n                      formControlName=\"name\"\n                      class=\"form-control\"\n                      required\n                    />\n                  </td>\n                </tr>\n                <tr>\n                  <th>Phone</th>\n                  <td colspan=\"2\">\n                    <input\n                      type=\"text\"\n                      formControlName=\"phone\"\n                      class=\"form-control\"\n                    />\n                  </td>\n                </tr>\n                <tr>\n                  <th>Locale</th>\n                  <td>\n                    <select\n                      formControlName=\"countryCode\"\n                      class=\"form-control\"\n                      required\n                    >\n                      <option\n                        *ngFor=\"\n                          let country of users.countryCodes;\n                          let i = index\n                        \"\n                        [value]=\"i\"\n                      >\n                        {{ country }}\n                      </option>\n                    </select>\n                  </td>\n                  <td>\n                    <select\n                      formControlName=\"languageCode\"\n                      class=\"form-control\"\n                      required\n                    >\n                      <option\n                        *ngFor=\"let lang of users.languageCodes; let i = index\"\n                        [value]=\"i\"\n                      >\n                        {{ lang }}\n                      </option>\n                    </select>\n                  </td>\n                </tr>\n              </tbody>\n              <tbody>\n                <tr>\n                  <th>Rules</th>\n                  <td colspan=\"2\">\n                    <select formControlName=\"roleTemplate\" class=\"form-control\">\n                      <option\n                        *ngFor=\"let roleTemplate of roleTemplates\"\n                        [ngValue]=\"roleTemplate\"\n                      >\n                        {{ roleTemplate.name }}\n                      </option>\n                    </select>\n                  </td>\n                </tr>\n                <tr>\n                  <td formArrayName=\"groupRules\">\n                    <p>Group Rules</p>\n                    <div\n                      *ngFor=\"let option of this.group?.rules; let i = index\"\n                    >\n                      <input\n                        type=\"checkbox\"\n                        [formControlName]=\"i\"\n                        [attr.disabled]=\"\n                          roleTemplate &&\n                          roleTemplate.value &&\n                          roleTemplate.value.name !== 'Custom'\n                            ? ''\n                            : null\n                        \"\n                      />&nbsp;{{ this.getRuleName(option) }}\n                    </div>\n                  </td>\n                  <td formArrayName=\"zoneRules\">\n                    <p>System Rules</p>\n                    <div\n                      *ngFor=\"\n                        let option of this.users.self.rules;\n                        let i = index\n                      \"\n                    >\n                      <input\n                        type=\"checkbox\"\n                        [formControlName]=\"i\"\n                        [attr.disabled]=\"\n                          roleTemplate &&\n                          roleTemplate.value &&\n                          roleTemplate.value.name !== 'Custom'\n                            ? ''\n                            : null\n                        \"\n                      />&nbsp;{{ this.getRuleName(option) }}\n                    </div>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n            <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\n          </form>\n        </div>\n        <div class=\"col-sm-2\"></div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <table class=\"table striped\">\n            <caption>\n              Users in\n              <em>{{ groupControl.value?.name }}</em>\n            </caption>\n            <tr>\n              <th class=\"debug-only text-center\">ID</th>\n              <th>Login</th>\n              <th>Name</th>\n              <th>Organization</th>\n              <th>Active</th>\n              <th>Actions</th>\n            </tr>\n            <tbody *ngIf=\"group\">\n              <ng-container *ngFor=\"let user of group.users\">\n                <tr [ngClass]=\"{ 'selected-user-row': user.isSelf }\">\n                  <td class=\"text-center\">{{ user.managementId }}</td>\n                  <td>{{ user.login }}</td>\n                  <td>{{ user.name }}</td>\n                  <td>{{ user.org }}</td>\n                  <td>n/a</td>\n                  <td>\n                    <button class=\"btn btn-info\" (click)=\"open(user)\">\n                      Open\n                    </button>\n                  </td>\n                </tr>\n                <tr\n                  *ngIf=\"\n                    selectedUser &&\n                    user.managementId === selectedUser.managementId\n                  \"\n                >\n                  <td colspan=\"5\">\n                    <div class=\"well details\">\n                      <h4>User Details</h4>\n                      <table\n                        *ngIf=\"selectedUser.loadedManagementDetails\"\n                        class=\"table\"\n                      >\n                        <tbody>\n                          <tr>\n                            <th>Name</th>\n                            <td>\n                              {{ selectedUser.name }}\n                              <em\n                                *ngIf=\"selectedUser.isSelf\"\n                                class=\"text-success text-right\"\n                              >\n                                (This is you.)\n                              </em>\n                            </td>\n                            <td colspan=\"2\">\n                              <input\n                                type=\"text\"\n                                [formControl]=\"newName\"\n                                class=\"form-control\"\n                                disabled\n                              />\n                            </td>\n                          </tr>\n                          <tr>\n                            <th>Phone</th>\n                            <td>\n                              <!--<span class=\"glyphicon glyphicon-phone-alt\"></span>-->\n                              <a [href]=\"'tel:' + selectedUser.phone\">\n                                {{ selectedUser.phone }}\n                              </a>\n                            </td>\n                            <td colspan=\"2\">\n                              <input\n                                type=\"text\"\n                                [formControl]=\"newPhone\"\n                                class=\"form-control\"\n                              />\n                            </td>\n                          </tr>\n                          <tr>\n                            <th>Locale</th>\n                            <td>\n                              <kbd> {{ selectedUser.countryCode }} </kbd\n                              >&mdash;<kbd>\n                                {{ selectedUser.languageCode }}\n                              </kbd>\n                            </td>\n                            <td>\n                              <select\n                                [formControl]=\"newCountry\"\n                                class=\"form-control\"\n                              >\n                                <option\n                                  *ngFor=\"\n                                    let country of users.countryCodes;\n                                    let i = index\n                                  \"\n                                  [value]=\"i\"\n                                >\n                                  {{ country }}\n                                </option>\n                              </select>\n                            </td>\n                            <td>\n                              <select\n                                [formControl]=\"newLanguage\"\n                                class=\"form-control\"\n                              >\n                                <option\n                                  *ngFor=\"\n                                    let lang of users.languageCodes;\n                                    let i = index\n                                  \"\n                                  [value]=\"i\"\n                                >\n                                  {{ lang }}\n                                </option>\n                              </select>\n                            </td>\n                          </tr>\n                          <tr>\n                            <td colspan=\"2\"></td>\n                            <td colspan=\"2\">\n                              <button\n                                class=\"btn btn-success p100\"\n                                (click)=\"saveUserDetails()\"\n                                [disabled]=\"userDetails.pristine\"\n                              >\n                                Save Changes Above\n                              </button>\n                            </td>\n                          </tr>\n                        </tbody>\n                        <tbody>\n                          <tr>\n                            <th>Credentials</th>\n                            <td>\n                              <!--<span class=\"glyphicon glyphicon-envelope\"></span>-->\n                              <a [href]=\"'mailto:' + selectedUser.login\">\n                                {{ selectedUser.login }}\n                              </a>\n                            </td>\n                            <td colspan=\"2\">\n                              <button\n                                class=\"btn btn-primary p100\"\n                                (click)=\"requestPasswordReset()\"\n                              >\n                                Reset Password...\n                              </button>\n                            </td>\n                          </tr>\n                        </tbody>\n                        <tbody>\n                          <tr>\n                            <th>Status</th>\n                            <td>\n                              <span\n                                [class.text-success]=\"selectedUser.isActive\"\n                                [class.text-danger]=\"!selectedUser.isActive\"\n                              >\n                                {{\n                                  selectedUser.isActive ? \"Active\" : \"INACTIVE\"\n                                }}\n                              </span>\n                            </td>\n                            <td colspan=\"2\">\n                              <button\n                                class=\"btn btn-primary p100\"\n                                (click)=\"toggleUserActiveness()\"\n                              >\n                                Toggle Status\n                              </button>\n                            </td>\n                          </tr>\n                        </tbody>\n                        <tbody>\n                          <tr>\n                            <td colspan=\"1\">\n                              <button\n                                class=\"btn btn-danger p100\"\n                                (click)=\"removeUserFromGroup()\"\n                              >\n                                Remove from this Group\n                              </button>\n                            </td>\n                            <td colspan=\"1\">\n                              <button\n                                class=\"btn btn-success p100\"\n                                (click)=\"addUsertoOtherGroup()\"\n                                [disabled]=\"getGroupsToAdd().length === 0\"\n                              >\n                                Add to Other Group\n                              </button>\n                            </td>\n                            <td *ngIf=\"addUserToGroup\">\n                              <form\n                                [formGroup]=\"addToGroupForm\"\n                                (ngSubmit)=\"onAddUserToOtherGroupSubmit()\"\n                                ngNativeValidate\n                              >\n                                <select\n                                  class=\"form-control\"\n                                  formControlName=\"groups\"\n                                  required\n                                >\n                                  <option\n                                    *ngFor=\"let gp of getGroupsToAdd()\"\n                                    [ngValue]=\"gp\"\n                                  >\n                                    {{ gp.name }}\n                                  </option>\n                                </select>\n                                <button type=\"submit\" class=\"btn btn-primary\">\n                                  Add\n                                </button>\n                              </form>\n                            </td>\n                          </tr>\n                        </tbody>\n                      </table>\n                      <p\n                        *ngIf=\"!selectedUser.loadedManagementDetails\"\n                        class=\"text-danger\"\n                      >\n                        No details received.\n                      </p>\n                    </div>\n                  </td>\n                </tr>\n              </ng-container>\n            </tbody>\n            <tr *ngIf=\"!group\">\n              <td colspan=\"3\" class=\"text-center\">\n                <h3>No group selected</h3>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  ",
	            styles: [
	                "\n      .details tbody + tbody > tr {\n        border-top: rgb(30, 30, 30);\n      }\n      .details td,\n      .details th {\n        vertical-align: middle;\n      }\n      button[type=\"submit\"] {\n        float: right;\n      }\n      .include-badge {\n        position: relative;\n      }\n      .badge {\n        position: absolute;\n        top: -20%;\n        left: 0;\n      }\n      .selected-user-row {\n        background-color: lightblue;\n      }\n    ",
	            ],
	        }),
	        __metadata("design:paramtypes", [user_service_1.UserService,
	            auth_service_1.AuthService,
	            modal_service_1.ModalService,
	            alert_service_1.AlertService])
	    ], ManagementPanelComponent);
	    return ManagementPanelComponent;
	}());
	exports.ManagementPanelComponent = ManagementPanelComponent;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var auth_service_1 = __webpack_require__(777);
	var ResetPasswordModalComponent = (function () {
	    function ResetPasswordModalComponent(dialog, auth) {
	        this.dialog = dialog;
	        this.auth = auth;
	        this.objectId = dialog.context.objectId;
	    }
	    ResetPasswordModalComponent.prototype.ngOnInit = function () {
	        this.newPassword = new forms_1.FormControl("", forms_1.Validators.required);
	        this.form = new forms_1.FormGroup({
	            newPassword: this.newPassword
	        });
	    };
	    ResetPasswordModalComponent.prototype.submit = function () {
	        var _this = this;
	        this.auth.resetPassword(this.objectId, this.newPassword.value).subscribe(function (result) {
	            _this.dialog.close(result.ok);
	        });
	    };
	    ResetPasswordModalComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"modal-header\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        (click)=\"dialog.dismiss()\"\n        aria-label=\"Close\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n      <h4 class=\"modal-title\">\n        Change Password\n      </h4>\n    </div>\n    <div class=\"modal-body\">\n      <form [formGroup]=\"form\" (submit)=\"submit()\">\n        <div class=\"form-group\">\n          <label>New Password</label>\n          <input type=\"password\" class=\"form-control\" [formControl]=\"newPassword\">\n        </div>\n      </form>\n    </div>\n  \n    <div class=\"modal-footer\">\n      <button\n        type=\"button\"\n        class=\"btn btn-default\"\n        (click)=\"dialog.dismiss()\">\n        Cancel\n      </button>\n      <button\n        type=\"button\"\n        class=\"btn btn-primary\"\n        (click)=\"submit()\">\n        Submit\n      </button>\n    </div>\n    ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            auth_service_1.AuthService])
	    ], ResetPasswordModalComponent);
	    return ResetPasswordModalComponent;
	}());
	exports.ResetPasswordModalComponent = ResetPasswordModalComponent;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rules_1 = __webpack_require__(640);
	exports.CUSTOM = {
	    name: "Custom",
	    zoneRules: [],
	    groupRules: [],
	};
	exports.HEALTH_BENEFITS_ADVOCATE = {
	    name: "ABC - Health Benefits Advocate",
	    zoneRules: [rules_1.Rule.CHAT, rules_1.Rule.SET_REMINDER, rules_1.Rule.USE_CLIENT_EXTENSIONS],
	    groupRules: [
	        rules_1.Rule.LOAD_ALGORITHM,
	        rules_1.Rule.POPULATE_SUBJECT,
	        rules_1.Rule.VIEW_SUBJECT,
	        rules_1.Rule.VIEW_COMMENT,
	        rules_1.Rule.COMMENT,
	        rules_1.Rule.SUBSCRIBE_SUBJECT,
	        rules_1.Rule.SEARCH_SUBJECT,
	        rules_1.Rule.EXPLAIN_SUBJECT,
	    ],
	};
	exports.REPORT_RUNNER = {
	    name: "ABC - Report Runner",
	    zoneRules: [rules_1.Rule.CHAT, rules_1.Rule.SET_REMINDER, rules_1.Rule.USE_CLIENT_EXTENSIONS],
	    groupRules: [
	        rules_1.Rule.LOAD_ALGORITHM,
	        rules_1.Rule.POPULATE_SUBJECT,
	        rules_1.Rule.VIEW_SUBJECT,
	        rules_1.Rule.VIEW_COMMENT,
	        rules_1.Rule.COMMENT,
	        rules_1.Rule.SUBSCRIBE_SUBJECT,
	        rules_1.Rule.SEARCH_SUBJECT,
	        rules_1.Rule.EXPLAIN_SUBJECT,
	        rules_1.Rule.CREATE_AGGREGATOR,
	        rules_1.Rule.RUN_AGGREGATOR,
	        rules_1.Rule.RUN_DATA_EXPORT,
	        rules_1.Rule.CREATE_DATA_EXPORT
	    ],
	};
	exports.roleTemplates = [exports.HEALTH_BENEFITS_ADVOCATE, exports.REPORT_RUNNER, exports.CUSTOM];


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var user_service_1 = __webpack_require__(713);
	var RemoveUserGroupModalComponent = (function () {
	    function RemoveUserGroupModalComponent(dialog, users) {
	        this.dialog = dialog;
	        this.users = users;
	        this.objectId = dialog.context.objectId;
	        this.groupId = dialog.context.groupId;
	    }
	    RemoveUserGroupModalComponent.prototype.submit = function () {
	        var _this = this;
	        this.users
	            .requestRemoveUserGroupsRequest(this.objectId, [this.groupId])
	            .subscribe(function (result) {
	            _this.dialog.close(result.ok);
	        });
	    };
	    RemoveUserGroupModalComponent = __decorate([
	        core_1.Component({
	            template: "\n    <div class=\"modal-header\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        (click)=\"dialog.dismiss()\"\n        aria-label=\"Close\"\n      >\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n      <h4 class=\"modal-title\">Are you sure</h4>\n    </div>\n    <div class=\"modal-body\">\n        <span>This may be the user's only group in Advocus; removing it will effectively deny the user all access to the system.</span>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-default\" (click)=\"dialog.dismiss()\">\n        Cancel\n      </button>\n      <button type=\"button\" class=\"btn btn-danger\" (click)=\"submit()\">\n        Remove\n      </button>\n    </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}",
	            ],
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            user_service_1.UserService])
	    ], RemoveUserGroupModalComponent);
	    return RemoveUserGroupModalComponent;
	}());
	exports.RemoveUserGroupModalComponent = RemoveUserGroupModalComponent;


/***/ }),
/* 892 */,
/* 893 */,
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var collaboration_service_1 = __webpack_require__(750);
	var AdminChatModalComponent = (function () {
	    function AdminChatModalComponent(dialog, collaboration) {
	        this.dialog = dialog;
	        this.collaboration = collaboration;
	        this.newChat = new forms_1.FormControl("");
	        this.form = new forms_1.FormGroup({ newChat: this.newChat });
	    }
	    AdminChatModalComponent.prototype.sendChat = function () {
	        var _this = this;
	        var chat = this.newChat.value;
	        if (chat !== null && chat.length > 0) {
	            this.collaboration.sendChat(chat, false).subscribe(function (sent) {
	                if (sent) {
	                    _this.form.reset();
	                }
	                else {
	                    alert("Could not send chat message!");
	                }
	            });
	        }
	    };
	    AdminChatModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Administrative Chat\n      <span class=\"badge\">\n        {{collaboration.users.length}} users\n      </span>\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <p *ngFor=\"let chat of collaboration.chatMessages\" class=\"report\">\n      <strong>\n        {{chat.author}}\n        {{chat.group ? \"[\" + chat.group + \"]\" : \"\"}}\n        {{chat.action ? chat.action + \".\" : \":\"}}\n      </strong>\n      {{chat.message}}\n    </p>\n    <em\n      *ngIf=\"collaboration.chatMessages.length === 0\"\n      class=\"notification\">\n      No chats since you joined the session.\n    </em>\n    <em *ngIf=\"!collaboration.chatEnabled\" class=\"notification\">\n      Chat is unavailable.\n    </em>\n  </div>\n\n  <div class=\"modal-footer\">\n    <form [formGroup]=\"form\">\n      <div class=\"input-group new-chat\">\n        <input\n          #chatInput\n          type=\"text\"\n          class=\"form-control\"\n          [formControl]=\"newChat\"\n          placeholder=\"Message...\">\n        <span class=\"input-group-btn\">\n          <button\n            class=\"btn btn-primary\"\n            (click)=\"sendChat()\">\n            Send\n          </button>\n        </span>\n      </div>\n    </form>\n  </div>\n  ",
	            styles: [".modal-body + .modal-body { border-top: 1px solid #ddd; }"]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            collaboration_service_1.CollaborationService])
	    ], AdminChatModalComponent);
	    return AdminChatModalComponent;
	}());
	exports.AdminChatModalComponent = AdminChatModalComponent;


/***/ }),
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var aggregation_1 = __webpack_require__(565);
	var assertions_1 = __webpack_require__(207);
	var filter_node_1 = __webpack_require__(900);
	var toolbox_activity_1 = __webpack_require__(902);
	var Aggregation = (function (_super) {
	    __extends(Aggregation, _super);
	    function Aggregation(id, filterOptions, targetVariableOptions, parent) {
	        if (filterOptions === void 0) { filterOptions = []; }
	        if (targetVariableOptions === void 0) { targetVariableOptions = []; }
	        var _this = _super.call(this) || this;
	        _this.id = id;
	        _this.filterOptions = filterOptions;
	        _this.targetVariableOptions = targetVariableOptions;
	        _this.parent = parent;
	        _this.requiresStateVariable = false;
	        _this.standardResults = [];
	        _this.frequencyResults = [];
	        _this.contextResults = [];
	        _this.noResults = false;
	        _this.targetSelector = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.configurationControls = [_this.targetSelector];
	        _this.title = _this.parent.name + " " + ++_this.parent.childCounter;
	        _this.requiresStateVariable = parent.requiresStateVariable;
	        _this.targetVariableOptions.sort(function (a, b) {
	            return (a.displayName || "").localeCompare(b.displayName);
	        });
	        return _this;
	    }
	    Aggregation.prototype.clearResults = function () {
	        this.standardResults = [];
	        this.frequencyResults = [];
	        this.contextResults = [];
	    };
	    Aggregation.fromOptions = function (rsp, parent) {
	        return new Aggregation(rsp.aggregationId, rsp.filterOptions, rsp.targetVariableOptions, parent);
	    };
	    Aggregation.prototype.readSchema = function (schema) {
	        this.targetSelector.setValue(schema.targetVariable);
	        console.log("target variable", schema.targetVariable);
	        if (schema.filter.nodeType === "operator") {
	            this.filter = filter_node_1.OperatorNode.fromSchema(schema.filter, this.filterOptions, true);
	        }
	        else {
	        }
	    };
	    Aggregation.prototype.readMessageReport = function (arm) {
	        var _this = this;
	        this.readCompletion(arm);
	        if (arm.results.length === 0) {
	            this.noResults = true;
	        }
	        else {
	            arm.results.forEach(function (result) {
	                if (result.type === "frequency") {
	                    _this.frequencyResults.push(result);
	                }
	                else if (result.type === "subject context") {
	                    var contextHolder = result;
	                    if (result.cardinality === 1) {
	                        contextHolder.columns =
	                            contextHolder.value
	                                .summary.map(function (d) { return d.name; });
	                        if (Number.isInteger(contextHolder.itemId)) {
	                            contextHolder.openLink = [
	                                "/subject/agg/",
	                                _this.id,
	                                contextHolder.itemId
	                            ];
	                        }
	                    }
	                    else if (contextHolder.value.length) {
	                        contextHolder.columns =
	                            contextHolder.value[0]
	                                .summary.map(function (d) { return d.name; });
	                    }
	                    else {
	                        contextHolder.columns = [];
	                    }
	                    _this.contextResults.push(result);
	                }
	                else {
	                    _this.standardResults.push(result);
	                }
	            });
	        }
	    };
	    Aggregation.prototype.requestFor = function (action) {
	        switch (action) {
	            case "cancel":
	                return new aggregation_1.CancelAggregationRequest(this.id);
	            case "pause":
	                return new aggregation_1.PauseAggregatorRequest(this.id);
	            case "resume":
	                return new aggregation_1.ResumeAggregatorRequest(this.id);
	            case "status":
	                return new aggregation_1.AggregatorStatusRequest(this.id);
	            default:
	                throw new Error("Unsupported activity request: " + action);
	        }
	    };
	    Aggregation.prototype.buildReportRef = function (r, itemId) {
	        assertions_1.assertIndexInto(r, this.contextResults);
	        var result = this.contextResults[r];
	        return {
	            id: itemId,
	            host: result,
	            type: "aggregation",
	            request: new aggregation_1.AggregationSubjectContextRequest(this.id, itemId),
	            priority: 30
	        };
	    };
	    return Aggregation;
	}(toolbox_activity_1.ToolboxActivity));
	exports.Aggregation = Aggregation;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var data_types_1 = __webpack_require__(208);
	var typed_data_1 = __webpack_require__(69);
	var functions_1 = __webpack_require__(206);
	var operators_1 = __webpack_require__(901);
	var NUMBER_TYPES_BY_NARROWNESS = [
	    "whole number",
	    "natural number",
	    "integer",
	    "float"
	];
	function widensTo(type, widening) {
	    if (type === widening) {
	        return true;
	    }
	    var narrowness = NUMBER_TYPES_BY_NARROWNESS.indexOf(type);
	    if (narrowness > -1) {
	        return (narrowness < NUMBER_TYPES_BY_NARROWNESS.indexOf(widening));
	    }
	    return false;
	}
	function withSubs(types) {
	    if (!types) {
	        return types;
	    }
	    types.forEach(function (type) {
	        var narrowness = NUMBER_TYPES_BY_NARROWNESS.indexOf(type);
	        for (narrowness; narrowness > -1; narrowness--) {
	            types.add(NUMBER_TYPES_BY_NARROWNESS[narrowness]);
	        }
	    });
	    return types;
	}
	function withSupers(types) {
	    if (!types) {
	        return types;
	    }
	    types.forEach(function (type) {
	        var narrowness = NUMBER_TYPES_BY_NARROWNESS.indexOf(type);
	        if (narrowness > -1) {
	            NUMBER_TYPES_BY_NARROWNESS.slice(narrowness + 1).forEach(function (wider) { return types.add(wider); });
	        }
	    });
	    return types;
	}
	var FilterNode = (function () {
	    function FilterNode() {
	        this.parent = null;
	        this.depth = 0;
	        this.parentAccepts = new Set();
	        this.allowedVariables = [];
	    }
	    FilterNode.prototype.revert = function (host) {
	        if (this.parent) {
	            this.parent.addChild(this.idWithinParent, new UndefinedNode());
	        }
	        else if (host) {
	            throw new Error("Unsupported!");
	        }
	    };
	    return FilterNode;
	}());
	exports.FilterNode = FilterNode;
	var ConstantNode = (function (_super) {
	    __extends(ConstantNode, _super);
	    function ConstantNode() {
	        var _this = _super.call(this) || this;
	        _this.nodeType = "value";
	        _this.name = "filter node";
	        _this.cardinality = 1;
	        _this.collectionType = "none";
	        _this.type = null;
	        _this.allowedTypes = new Set(data_types_1.SERVER_TYPES);
	        _this.restrictions = null;
	        _this.createValueControl(false);
	        _this.typeControl = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.typeControl.valueChanges.subscribe(function (newType) {
	            _this.value = null;
	            _this.type = newType;
	            _this.parent.childReturnChange(_this, _this.idWithinParent);
	        });
	        return _this;
	    }
	    ConstantNode.prototype.createValueControl = function (asArray) {
	        var _this = this;
	        if (asArray) {
	            this.valueControl = new forms_1.FormArray([], forms_1.Validators.required);
	        }
	        else {
	            this.valueControl = new forms_1.FormControl(null, forms_1.Validators.required);
	        }
	        this.valueControl.valueChanges.subscribe(function (val) { return _this.value = val; });
	    };
	    ConstantNode.prototype.returnTypes = function () {
	        if (this.type) {
	            return new Set([this.type]);
	        }
	        else {
	            return this.allowedTypes;
	        }
	    };
	    ConstantNode.prototype.marshal = function () {
	        if (this.typeControl.invalid || this.valueControl.invalid) {
	            throw new Error("Missing value in constant node");
	        }
	        return {
	            nodeType: "constant",
	            cardinality: this.cardinality,
	            collectionType: this.cardinality === 0 ? "list" : "none",
	            type: this.type,
	            value: typed_data_1.TypedData.serialize(Object.assign({}, this))
	        };
	    };
	    ConstantNode.prototype.toReadable = function () {
	        return "<em>" + typed_data_1.TypedData.toString(this, this.value) + "</em>";
	    };
	    ConstantNode.prototype.parentExpectationChange = function (expected, cardinality) {
	        var _this = this;
	        this.parentAccepts = expected;
	        this.allowedTypes = new Set(data_types_1.SERVER_TYPES.filter(function (t) { return _this.parentAccepts.has(t); }));
	        if (!this.parentAccepts.has(this.type)) {
	            this.valueControl.reset();
	            if (this.parentAccepts.size === 1) {
	                this.type = this.parentAccepts.values().next().value;
	                this.typeControl.setValue(this.type, { emitEvent: false });
	            }
	            else {
	                this.type = null;
	                this.typeControl.reset(null, { emitEvent: false });
	            }
	        }
	        if (this.parent && this.parent.childValueRestrictions) {
	            this.restrictions = this.parent.childValueRestrictions;
	        }
	        else {
	            this.restrictions = [];
	        }
	        if (cardinality !== this.cardinality) {
	            this.cardinality = Number.isInteger(cardinality) ? cardinality : 1;
	            this.createValueControl(cardinality !== 1);
	        }
	        if (this.allowedTypes.size === 1) {
	            this.typeControl.disable();
	        }
	        else {
	            this.typeControl.enable();
	        }
	        return this.returnTypes();
	    };
	    ConstantNode.prototype.disable = function () {
	        this.valueControl.disable();
	        this.typeControl.disable({ emitEvent: false });
	    };
	    ConstantNode.fromSchema = function (filter, variableList) {
	        var n = new ConstantNode();
	        n.cardinality = filter.cardinality;
	        n.collectionType = filter.collectionType;
	        return n;
	    };
	    ConstantNode.prototype.applySchemaFilter = function (filter) {
	        this.type = filter.type;
	        this.typeControl.setValue(this.type, { emitEvent: false });
	        this.valueControl.setValue(typed_data_1.TypedData.deserialize(filter));
	    };
	    return ConstantNode;
	}(FilterNode));
	exports.ConstantNode = ConstantNode;
	var VariableNode = (function (_super) {
	    __extends(VariableNode, _super);
	    function VariableNode() {
	        var _this = _super.call(this) || this;
	        _this.nodeType = "variable";
	        _this.filteredVariables = [];
	        _this.variableControl = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.variableControl.valueChanges.subscribe(function (varName) {
	            if (varName) {
	                _this.variable = _this.allowedVariables.find(function (varObj) { return varObj.name === varName; });
	                if (!_this.variable) {
	                    throw new Error("Could not find variable " + varName);
	                }
	                if (_this.variable.restrictions) {
	                    _this.parent.childValueRestrictions =
	                        _this.variable.restrictions;
	                }
	            }
	            else {
	                _this.variable = null;
	                _this.parent.childValueRestrictions = null;
	            }
	            _this.parent.childReturnChange(_this, _this.idWithinParent);
	        });
	        return _this;
	    }
	    VariableNode.prototype.returnTypes = function () {
	        if (!this.variable) {
	            return new Set(this.filteredVariables.map(function (td) { return td.type; }));
	        }
	        else {
	            return new Set([this.variable.type]);
	        }
	    };
	    VariableNode.prototype.parentExpectationChange = function (expected, cardinality) {
	        var _this = this;
	        this.parentAccepts = expected;
	        this.filteredVariables = this.allowedVariables.filter(function (td) {
	            return _this.parentAccepts.has(td.type)
	                && (!Number.isInteger(cardinality)
	                    || td.cardinality === cardinality);
	        });
	        if (this.variable
	            && this.filteredVariables.indexOf(this.variable) === -1) {
	            if (this.filteredVariables.length === 1) {
	                this.variableControl.setValue(this.filteredVariables[0]);
	            }
	            else {
	                this.variableControl.reset();
	            }
	        }
	        return this.returnTypes();
	    };
	    VariableNode.prototype.marshal = function () {
	        if (this.variableControl.invalid) {
	            throw new Error("Missing value in variable node");
	        }
	        if (!this.variable) {
	            console.error(this);
	            throw new Error("Undefined variable in node");
	        }
	        return {
	            nodeType: "variable",
	            variable: this.variable.name
	        };
	    };
	    VariableNode.prototype.toReadable = function () {
	        if (this.variable) {
	            return "<kbd>" + this.variable.name + "</kbd>";
	        }
	        else {
	            return "<kbd>(UNSET)</kbd>";
	        }
	    };
	    VariableNode.prototype.disable = function () {
	        this.variableControl.disable({ emitEvent: false });
	    };
	    VariableNode.fromSchema = function () {
	        return new VariableNode();
	    };
	    VariableNode.prototype.applySchemaFilter = function (filter, variableList) {
	        this.variableControl.setValue(filter.variable);
	    };
	    return VariableNode;
	}(FilterNode));
	exports.VariableNode = VariableNode;
	var UndefinedNode = (function (_super) {
	    __extends(UndefinedNode, _super);
	    function UndefinedNode() {
	        var _this = _super.call(this) || this;
	        _this.nodeType = null;
	        _this.typeControl = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.allowsOperators = true;
	        _this.typeControl.valueChanges.subscribe(function (val) {
	            if (val) {
	                _this.changeType(val);
	            }
	        });
	        return _this;
	    }
	    UndefinedNode.prototype.marshal = function () {
	        throw new Error("Cannot marshal undefined filter node!");
	    };
	    UndefinedNode.prototype.toReadable = function () {
	        return "???";
	    };
	    UndefinedNode.prototype.returnTypes = function () {
	        return null;
	    };
	    UndefinedNode.prototype.disable = function () {
	        this.typeControl.disable();
	    };
	    UndefinedNode.prototype.parentExpectationChange = function (expected) {
	        this.parentAccepts = expected;
	        this.allowsOperators = (!this.parent || !this.parent.childValueRestrictions);
	        return null;
	    };
	    UndefinedNode.prototype.changeType = function (newType) {
	        var node;
	        switch (newType) {
	            case "variable":
	                node = new VariableNode();
	                break;
	            case "value":
	                node = new ConstantNode();
	                break;
	            case "expression":
	                node = new OperatorNode(operators_1.Operators.get("is"));
	                break;
	            default:
	                throw new Error("Disallowed node type!");
	        }
	        this.parent.addChild(this.idWithinParent, node);
	    };
	    UndefinedNode.prototype.applySchemaFilter = function () {
	        throw new Error("Can't apply schema to undefined node!");
	    };
	    return UndefinedNode;
	}(FilterNode));
	exports.UndefinedNode = UndefinedNode;
	var OperatorNode = (function (_super) {
	    __extends(OperatorNode, _super);
	    function OperatorNode(op, operands, root, allowedVariables) {
	        if (op === void 0) { op = OperatorNode.DefaultOp; }
	        if (root === void 0) { root = false; }
	        if (allowedVariables === void 0) { allowedVariables = []; }
	        var _this = _super.call(this) || this;
	        _this.root = root;
	        _this.allowedVariables = allowedVariables;
	        _this.nodeType = "expression";
	        _this.operands = [];
	        _this.availableOperators = operators_1.Operators.All;
	        _this.expects = {
	            self: null,
	            left: null,
	            right: null
	        };
	        _this.returns = {
	            self: null,
	            left: null,
	            right: null
	        };
	        _this.signatures = {
	            self: [],
	            left: [],
	            right: []
	        };
	        _this._childValueRestrictions = null;
	        _this.cardinalities = { left: null, right: null, self: null };
	        _this.setOperator(op);
	        if (root) {
	            _this.parentExpectationChange(OperatorNode.RootExpectations);
	        }
	        _this.operatorControl = new forms_1.FormControl(_this.operator.name, forms_1.Validators.required);
	        _this.operatorControl.valueChanges.subscribe(function (opName) {
	            _this.setOperator(operators_1.Operators.get(opName));
	        });
	        if (operands) {
	            operands.forEach(function (o, i) {
	                _this.addChild(i, o);
	            });
	        }
	        return _this;
	    }
	    Object.defineProperty(OperatorNode.prototype, "childValueRestrictions", {
	        get: function () {
	            return this._childValueRestrictions;
	        },
	        set: function (restrictions) {
	            this._childValueRestrictions = restrictions;
	            if (this.right instanceof ConstantNode) {
	                this.right.restrictions = this._childValueRestrictions;
	            }
	            else if (this.right && restrictions !== null) {
	                this.addChild(1, new ConstantNode());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OperatorNode.prototype.addChild = function (i, node) {
	        var prevNode = this.operands[i];
	        if (prevNode) {
	            prevNode.parent = null;
	        }
	        this.operands[i] = node;
	        node.parent = this;
	        node.idWithinParent = i;
	        node.allowedVariables = this.allowedVariables;
	        this.depth = node.depth + 1;
	        if (i === 0) {
	            this.determineLeftExpectations(true);
	        }
	        else {
	            this.determineRightExpectations(true);
	        }
	    };
	    OperatorNode.prototype.determineOperators = function () {
	        var _this = this;
	        if (this.expects.self) {
	            if (!this.expects.self.size) {
	                this.availableOperators = [];
	                console.error(this);
	                throw new Error("Operator has empty expectations!");
	            }
	            this.availableOperators = operators_1.Operators.All.filter(function (op) { return (op.signature.some(function (sig) {
	                return _this.expects.self.has(sig.returns);
	            })
	                && (op.accepts(_this))); });
	        }
	        else {
	            this.availableOperators = Array.from(operators_1.Operators.All);
	        }
	        if (this.availableOperators.indexOf(this.operator) === -1) {
	            return this.setOperator();
	        }
	        return false;
	    };
	    OperatorNode.prototype.setOperator = function (op) {
	        if (!op) {
	            op = OperatorNode.DefaultOp;
	        }
	        if (this.operator !== op) {
	            this.operator = op;
	            this.constrainByOperator();
	            return true;
	        }
	    };
	    OperatorNode.prototype.constrainByOperator = function () {
	        var _this = this;
	        if (this.expects.self) {
	            this.signatures.self = this.operator.signature.filter(function (sig) {
	                return _this.expects.self.has(sig.returns);
	            });
	        }
	        else {
	            this.signatures.self = this.operator.signature.map(function (x) { return x; });
	        }
	        this.determineLeftExpectations();
	    };
	    OperatorNode.prototype.determineLeftExpectations = function (force) {
	        if (force === void 0) { force = false; }
	        if (!this.left) {
	            return this.addChild(0, new UndefinedNode());
	        }
	        var oldExpects = this.expects.left;
	        this.expects.left = new Set(this.signatures.self.map(function (sig) { return sig.left; }));
	        var oldCard = this.cardinalities.left;
	        this.cardinalities.left =
	            this.operator.collectionArguments.left ? 0 : 1;
	        var changed = !functions_1.setEquals(oldExpects, this.expects.left)
	            || oldCard !== this.cardinalities.left;
	        if (force || changed) {
	            this.returns.left =
	                this.left.parentExpectationChange(this.expects.left, this.cardinalities.left);
	            if (this.returns.left && this.returns.left.size === 0) {
	                return this.addChild(0, new UndefinedNode());
	            }
	        }
	        this.constrainByLeft();
	    };
	    OperatorNode.prototype.constrainByLeft = function () {
	        var _this = this;
	        if (this.returns.left) {
	            this.signatures.left = this.signatures.self.filter(function (sig) { return _this.returns.left.has(sig.left); });
	        }
	        else {
	            this.signatures.left = this.signatures.self.map(function (x) { return x; });
	        }
	        this.determineRightExpectations();
	    };
	    OperatorNode.prototype.determineRightExpectations = function (force) {
	        if (force === void 0) { force = false; }
	        if (!this.operator.isUnary()) {
	            if (this.operator.isBinary() && !this.right) {
	                return this.addChild(1, new UndefinedNode());
	            }
	            if (this.right) {
	                var oldExpects = this.expects.right;
	                this.expects.right = new Set(this.signatures.left.map(function (sig) { return sig.right; }));
	                var oldCard = this.cardinalities.right;
	                this.cardinalities.right =
	                    this.operator.collectionArguments.right ? 0 : 1;
	                var changed = !functions_1.setEquals(oldExpects, this.expects.right)
	                    || oldCard !== this.cardinalities.right;
	                if (force || changed) {
	                    this.returns.right =
	                        this.right.parentExpectationChange(this.expects.right, this.cardinalities.right);
	                    if (this.returns.right && this.returns.right.size === 0) {
	                        return this.addChild(1, new UndefinedNode());
	                    }
	                }
	            }
	        }
	        else {
	            while (this.right) {
	                var removed = this.operands.pop();
	                removed.parent = null;
	                removed.idWithinParent = null;
	            }
	            this.expects.right = null;
	            this.cardinalities.right = null;
	        }
	        this.constrainByRight();
	    };
	    OperatorNode.prototype.constrainByRight = function () {
	        var _this = this;
	        if (this.returns.right) {
	            this.signatures.right = this.signatures.left.filter(function (sig) {
	                return _this.returns.right.has(sig.right);
	            });
	        }
	        else {
	            this.signatures.right = this.signatures.left.map(function (x) { return x; });
	        }
	        this.determineReturns();
	    };
	    OperatorNode.prototype.determineReturns = function () {
	        this.returns.self = new Set(this.signatures.right.map(function (sig) { return sig.returns; }));
	    };
	    OperatorNode.prototype.parentExpectationChange = function (expects, cardinality) {
	        if (!functions_1.setEquals(expects, this.expects.self)
	            || cardinality !== this.cardinalities.self) {
	            this.expects.self = expects;
	            this.cardinalities.self = cardinality;
	            if (!this.determineOperators()) {
	                this.constrainByOperator();
	            }
	        }
	        return this.returns.self;
	    };
	    OperatorNode.prototype.childReturnChange = function (child, childIndex) {
	        if (childIndex === 0) {
	            this.returns.left = this.left.returnTypes();
	            this.constrainByLeft();
	        }
	        else {
	            this.returns.right = this.right.returnTypes();
	            this.constrainByRight();
	        }
	    };
	    Object.defineProperty(OperatorNode.prototype, "left", {
	        get: function () {
	            return this.operands[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OperatorNode.prototype, "right", {
	        get: function () {
	            if (this.operands.length !== 2) {
	                return null;
	            }
	            else {
	                return this.operands[1];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OperatorNode.prototype.returnTypes = function () {
	        return this.returns.self;
	    };
	    OperatorNode.prototype.marshal = function () {
	        if (this.operatorControl.invalid) {
	            throw new Error("Missing value in operator node");
	        }
	        if (this.operator.name === "is") {
	            return this.left.marshal();
	        }
	        if (this.operator.name === "all of") {
	            if (this.operands.length === 1) {
	                return this.left.marshal();
	            }
	            else if (this.operands.length === 2) {
	                return ({
	                    nodeType: "operator",
	                    operator: operators_1.Operators.get("and").protocolName,
	                    operands: this.operands.map(function (fn) { return fn.marshal(); })
	                });
	            }
	            else {
	                var andOp = operators_1.Operators.get("and").protocolName;
	                var args = this.operands.map(function (o) { return o.marshal(); });
	                while (args.length > 1) {
	                    for (var i = 0; i < args.length - 1; i++) {
	                        args.splice(i, 2, {
	                            nodeType: "operator",
	                            operator: andOp,
	                            operands: [args[i], args[i + 1]]
	                        });
	                    }
	                }
	                return args[0];
	            }
	        }
	        else {
	            return ({
	                nodeType: "operator",
	                operator: this.operator.protocolName,
	                operands: this.operands.map(function (fn) { return fn.marshal(); })
	            });
	        }
	    };
	    OperatorNode.prototype.toReadable = function () {
	        if (this.operator.isBinary()) {
	            return "(" + this.operator.label(this.left, [this.right]) + ")";
	        }
	        else if (this.operator.isVariableArity()) {
	            return "(" + this.operator.label(this.left, this.operands.slice(1)) + ")";
	        }
	        else {
	            return "(<em>" + this.operator.label(this.left) + "</em>)";
	        }
	    };
	    OperatorNode.prototype.disable = function () {
	        this.operatorControl.disable({ emitEvent: false });
	        this.operands.forEach(function (node) { return node.disable(); });
	    };
	    OperatorNode.isValidSimpleClause = function (filter) {
	        return (filter.nodeType === "operator"
	            && filter.operands
	            && filter.operands[1]
	            && filter.operands[1].nodeType === "constant"
	            && filter.operands[0]
	            && (filter.operands[0].nodeType === "variable"
	                || filter.operands[0].nodeType === "argument"));
	    };
	    OperatorNode.simpleFromSchema = function (filter, variableList, isRoot, contextVariable) {
	        if (isRoot === void 0) { isRoot = false; }
	        var clauses = [];
	        if (OperatorNode.isValidSimpleClause(filter)) {
	            clauses = [OperatorNode.fromSchema(filter, variableList, false, contextVariable)];
	        }
	        else {
	            var and = operators_1.Operators.get("and").protocolName;
	            var identity = function (_) { return _; };
	            var toProcess = [filter];
	            while (toProcess.length > 0) {
	                var current = toProcess.shift();
	                if (current.nodeType !== "operator") {
	                    console.error(current);
	                    throw new Error("Found nonoperator node in supposed simple filter");
	                }
	                if (current.operator === and) {
	                    toProcess.splice.apply(toProcess, [0, 0].concat(current.operands));
	                }
	                else {
	                    if (OperatorNode.isValidSimpleClause(current)) {
	                        clauses.push(OperatorNode.fromSchema(current, variableList, false, contextVariable));
	                    }
	                    else {
	                        console.error(current);
	                        throw new Error("Found an invalid leaf clause for simple filter");
	                    }
	                }
	            }
	        }
	        return new OperatorNode(operators_1.Operators.get("all of"), clauses, true, variableList);
	    };
	    OperatorNode.fromSchema = function (filter, variableList, isRoot, contextVariable, attemptSimpleSynthesis) {
	        if (isRoot === void 0) { isRoot = false; }
	        if (attemptSimpleSynthesis === void 0) { attemptSimpleSynthesis = false; }
	        if (attemptSimpleSynthesis) {
	            try {
	                return OperatorNode.simpleFromSchema(filter, variableList, isRoot, contextVariable);
	            }
	            catch (err) {
	                console.log("Attempted to parse as simple filter, received error:");
	                console.warn(err);
	            }
	        }
	        var children = filter.operands.map(function (child) {
	            switch (child.nodeType) {
	                case "operator":
	                    return OperatorNode.fromSchema(child, variableList, false, contextVariable);
	                case "variable":
	                    return VariableNode.fromSchema();
	                case "constant":
	                    return ConstantNode.fromSchema(child, variableList);
	                case "argument":
	                    return ArgumentNode.fromSchema(contextVariable);
	                default:
	                    throw new Error("Cannot demarshal unknown filter node types");
	            }
	        });
	        var n = new OperatorNode(operators_1.Operators.getByProtocol(filter.operator), children, isRoot, variableList);
	        children.forEach(function (c, i) {
	            return c.applySchemaFilter(filter.operands[i], variableList);
	        });
	        return n;
	    };
	    OperatorNode.prototype.applySchemaFilter = function () {
	    };
	    OperatorNode.BasicEquality = function (vars, root) {
	        var eqNode = new OperatorNode(operators_1.Operators.get("equals"), [], root, vars);
	        eqNode.addChild(0, new VariableNode());
	        eqNode.addChild(1, new ConstantNode());
	        return eqNode;
	    };
	    OperatorNode.DefaultOp = operators_1.Operators.get("is");
	    OperatorNode.RootExpectations = new Set(["boolean"]);
	    return OperatorNode;
	}(FilterNode));
	exports.OperatorNode = OperatorNode;
	var ArgumentNode = (function (_super) {
	    __extends(ArgumentNode, _super);
	    function ArgumentNode(variable) {
	        var _this = _super.call(this) || this;
	        _this.variable = variable;
	        _this.nodeType = "argument";
	        return _this;
	    }
	    ArgumentNode.prototype.marshal = function () {
	        return { nodeType: "argument" };
	    };
	    ArgumentNode.prototype.toReadable = function () {
	        return "<kbd>this entry of " + this.variable.displayName + "</kbd>";
	    };
	    ArgumentNode.prototype.returnTypes = function () {
	        return new Set([this.variable.type]);
	    };
	    ArgumentNode.prototype.parentExpectationChange = function (expected, cardinality) {
	        if (this.variable.restrictions) {
	            this.parent.childValueRestrictions =
	                this.variable.restrictions;
	        }
	        return this.returnTypes();
	    };
	    ArgumentNode.prototype.disable = function () {
	    };
	    ArgumentNode.prototype.applySchemaFilter = function () {
	    };
	    ArgumentNode.fromSchema = function (variable) {
	        return new ArgumentNode(variable);
	    };
	    return ArgumentNode;
	}(FilterNode));
	exports.ArgumentNode = ArgumentNode;


/***/ }),
/* 901 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	function single(inTypes, outType) {
	    return inTypes.map(function (inType) { return ({
	        left: inType,
	        returns: outType || inType
	    }); });
	}
	function mirror(inTypes, outType) {
	    return inTypes.map(function (inType) { return ({
	        left: inType,
	        right: inType,
	        returns: outType || inType
	    }); });
	}
	var Operator = (function () {
	    function Operator() {
	        this.userSelectable = true;
	    }
	    Operator.prototype.label = function (left, right) {
	        if (this.isBinary()) {
	            return left.toReadable() + " " + this.symbol + " " + right[0].toReadable();
	        }
	        else {
	            return this.symbol + " " + left.toReadable();
	        }
	    };
	    Operator.prototype.isBinary = function () {
	        return this.cardinality === 2;
	    };
	    Operator.prototype.isUnary = function () {
	        return this.cardinality === 1;
	    };
	    Operator.prototype.isVariableArity = function () {
	        return this.cardinality === 0;
	    };
	    Operator.prototype.accepts = function (host) {
	        return true;
	    };
	    Operator.ALL_TYPES = [
	        "boolean", "string", "float", "integer", "whole number",
	        "natural number", "date"
	    ];
	    Operator.NUMERIC_TYPES = [
	        "float", "integer", "whole number", "natural number"
	    ];
	    Operator.ORDERED_TYPES = [
	        "string", "float", "integer", "whole number",
	        "natural number", "date"
	    ];
	    return Operator;
	}());
	exports.Operator = Operator;
	var SingletonOperator = (function (_super) {
	    __extends(SingletonOperator, _super);
	    function SingletonOperator() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.collectionArguments = { left: false, right: false };
	        return _this;
	    }
	    return SingletonOperator;
	}(Operator));
	exports.SingletonOperator = SingletonOperator;
	var LogicalOperator = (function (_super) {
	    __extends(LogicalOperator, _super);
	    function LogicalOperator() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.signature = mirror(["boolean"]);
	        return _this;
	    }
	    LogicalOperator.prototype.label = function (left, right) {
	        return left.toReadable() + " " + this.name + " " + right[0].toReadable();
	    };
	    return LogicalOperator;
	}(SingletonOperator));
	exports.LogicalOperator = LogicalOperator;
	var And = (function (_super) {
	    __extends(And, _super);
	    function And() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "and";
	        _this.symbol = "∧";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.cardinality = 2;
	        return _this;
	    }
	    return And;
	}(LogicalOperator));
	exports.And = And;
	var ClientOnlyMultiAnd = (function (_super) {
	    __extends(ClientOnlyMultiAnd, _super);
	    function ClientOnlyMultiAnd() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "all of";
	        _this.symbol = "all of";
	        _this.userSelectable = false;
	        _this.cardinality = 0;
	        _this.signature = mirror(["boolean"]);
	        return _this;
	    }
	    ClientOnlyMultiAnd.prototype.label = function (left, right) {
	        var rest = (right && right.length > 0)
	            ? ", " + right.map(function (r) { return r.toReadable(); }).join(", ")
	            : "";
	        return "all of [" + left.toReadable() + rest + "]";
	    };
	    Object.defineProperty(ClientOnlyMultiAnd.prototype, "protocolName", {
	        get: function () {
	            throw new Error("Marshalling error: the 'all of' op is client-only!");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ClientOnlyMultiAnd.prototype.accepts = function (node) {
	        return node.root;
	    };
	    return ClientOnlyMultiAnd;
	}(SingletonOperator));
	exports.ClientOnlyMultiAnd = ClientOnlyMultiAnd;
	var Or = (function (_super) {
	    __extends(Or, _super);
	    function Or() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "or";
	        _this.symbol = "∨";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.cardinality = 2;
	        return _this;
	    }
	    return Or;
	}(LogicalOperator));
	exports.Or = Or;
	var Not = (function (_super) {
	    __extends(Not, _super);
	    function Not() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "not";
	        _this.symbol = "¬";
	        _this.protocolName = _this.symbol + "_";
	        _this.cardinality = 1;
	        return _this;
	    }
	    Not.prototype.label = function (left) {
	        return "<strong>" + this.name + "</strong> " + left.toReadable();
	    };
	    return Not;
	}(LogicalOperator));
	exports.Not = Not;
	var Answered = (function (_super) {
	    __extends(Answered, _super);
	    function Answered() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "is answered";
	        _this.symbol = "∃";
	        _this.protocolName = "_" + _this.name;
	        _this.signature = single(Operator.ALL_TYPES, "boolean");
	        _this.cardinality = 1;
	        return _this;
	    }
	    Answered.prototype.accepts = function (host) {
	        if (host.operands.length === 1) {
	            return (host.operands[0].nodeType === "variable");
	        }
	        else {
	            return true;
	        }
	    };
	    return Answered;
	}(SingletonOperator));
	exports.Answered = Answered;
	var Unanswered = (function (_super) {
	    __extends(Unanswered, _super);
	    function Unanswered() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "is not answered";
	        _this.symbol = "∄";
	        _this.protocolName = "_" + _this.name;
	        _this.signature = single(Operator.ALL_TYPES, "boolean");
	        _this.cardinality = 1;
	        return _this;
	    }
	    Unanswered.prototype.accepts = function (host) {
	        if (host.operands.length === 1) {
	            return (host.operands[0].nodeType === "variable");
	        }
	        else {
	            return true;
	        }
	    };
	    return Unanswered;
	}(SingletonOperator));
	exports.Unanswered = Unanswered;
	var Is = (function (_super) {
	    __extends(Is, _super);
	    function Is() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "is";
	        _this.symbol = "is";
	        _this.cardinality = 1;
	        _this.userSelectable = false;
	        _this.signature = single(Operator.ALL_TYPES);
	        return _this;
	    }
	    Object.defineProperty(Is.prototype, "protocolName", {
	        get: function () {
	            throw new Error("Marshalling error: the 'is' operator is client-only!");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Is;
	}(SingletonOperator));
	exports.Is = Is;
	var EqualityOperator = (function (_super) {
	    __extends(EqualityOperator, _super);
	    function EqualityOperator() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cardinality = 2;
	        _this.typeSpecificNames = new Map();
	        return _this;
	    }
	    return EqualityOperator;
	}(SingletonOperator));
	exports.EqualityOperator = EqualityOperator;
	var Equals = (function (_super) {
	    __extends(Equals, _super);
	    function Equals() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "equals";
	        _this.symbol = "=";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(Operator.ALL_TYPES, "boolean");
	        return _this;
	    }
	    return Equals;
	}(EqualityOperator));
	exports.Equals = Equals;
	var NotEquals = (function (_super) {
	    __extends(NotEquals, _super);
	    function NotEquals() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "not equals";
	        _this.symbol = "≠";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(Operator.ALL_TYPES, "boolean");
	        return _this;
	    }
	    return NotEquals;
	}(EqualityOperator));
	exports.NotEquals = NotEquals;
	var LessThan = (function (_super) {
	    __extends(LessThan, _super);
	    function LessThan() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "less than";
	        _this.symbol = "<";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.typeSpecificNames = new Map([
	            ["string", "alphabetically before"],
	            ["date", "before"]
	        ]);
	        _this.signature = mirror(Operator.ORDERED_TYPES, "boolean");
	        return _this;
	    }
	    return LessThan;
	}(EqualityOperator));
	exports.LessThan = LessThan;
	var LessThanOrEqual = (function (_super) {
	    __extends(LessThanOrEqual, _super);
	    function LessThanOrEqual() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "less than or equal";
	        _this.symbol = "≤";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.typeSpecificNames = new Map([
	            ["string", "matches or alphabetically before"],
	            ["date", "before or on"]
	        ]);
	        _this.signature = mirror(Operator.ORDERED_TYPES, "boolean");
	        return _this;
	    }
	    return LessThanOrEqual;
	}(EqualityOperator));
	exports.LessThanOrEqual = LessThanOrEqual;
	var GreaterThan = (function (_super) {
	    __extends(GreaterThan, _super);
	    function GreaterThan() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "greater than";
	        _this.symbol = ">";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.typeSpecificNames = new Map([
	            ["string", "alphabetically after"],
	            ["date", "after"]
	        ]);
	        _this.signature = mirror(Operator.ORDERED_TYPES, "boolean");
	        return _this;
	    }
	    return GreaterThan;
	}(EqualityOperator));
	exports.GreaterThan = GreaterThan;
	var GreaterThanOrEqual = (function (_super) {
	    __extends(GreaterThanOrEqual, _super);
	    function GreaterThanOrEqual() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "greater than or equal";
	        _this.symbol = "≥";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.typeSpecificNames = new Map([
	            ["string", "matches or alphabetically after"],
	            ["date", "on or after"]
	        ]);
	        _this.signature = mirror(Operator.ORDERED_TYPES, "boolean");
	        return _this;
	    }
	    return GreaterThanOrEqual;
	}(EqualityOperator));
	exports.GreaterThanOrEqual = GreaterThanOrEqual;
	var SizeOf = (function (_super) {
	    __extends(SizeOf, _super);
	    function SizeOf() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "size of";
	        _this.symbol = "size of";
	        _this.protocolName = _this.symbol + "_";
	        _this.cardinality = 1;
	        _this.signature = single(Operator.ALL_TYPES, "whole number");
	        _this.collectionArguments = { left: true };
	        return _this;
	    }
	    return SizeOf;
	}(Operator));
	exports.SizeOf = SizeOf;
	var Contains = (function (_super) {
	    __extends(Contains, _super);
	    function Contains() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "contains";
	        _this.symbol = "∋";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.cardinality = 2;
	        _this.signature = mirror(Operator.ALL_TYPES, "boolean");
	        _this.collectionArguments = { left: true, right: false };
	        return _this;
	    }
	    return Contains;
	}(Operator));
	exports.Contains = Contains;
	var ElementOf = (function (_super) {
	    __extends(ElementOf, _super);
	    function ElementOf() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "element of";
	        _this.symbol = "∈";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.cardinality = 2;
	        _this.signature = mirror(Operator.ALL_TYPES, "boolean");
	        _this.collectionArguments = { left: false, right: true };
	        return _this;
	    }
	    return ElementOf;
	}(Operator));
	exports.ElementOf = ElementOf;
	var Substring = (function (_super) {
	    __extends(Substring, _super);
	    function Substring() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "contains text";
	        _this.symbol = "has substring";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.cardinality = 2;
	        _this.signature = [{ left: "string", right: "string", returns: "boolean" }];
	        return _this;
	    }
	    return Substring;
	}(SingletonOperator));
	exports.Substring = Substring;
	var ArithmaticOperator = (function (_super) {
	    __extends(ArithmaticOperator, _super);
	    function ArithmaticOperator() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cardinality = 2;
	        _this.signature = mirror(Operator.NUMERIC_TYPES);
	        return _this;
	    }
	    return ArithmaticOperator;
	}(SingletonOperator));
	exports.ArithmaticOperator = ArithmaticOperator;
	var Add = (function (_super) {
	    __extends(Add, _super);
	    function Add() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "add";
	        _this.symbol = "+";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(Operator.NUMERIC_TYPES).concat({ left: "date", right: "integer", returns: "date" });
	        return _this;
	    }
	    return Add;
	}(ArithmaticOperator));
	exports.Add = Add;
	var Subtract = (function (_super) {
	    __extends(Subtract, _super);
	    function Subtract() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "subtract";
	        _this.symbol = "-";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(Operator.NUMERIC_TYPES).concat({ left: "date", right: "integer", returns: "date" });
	        return _this;
	    }
	    return Subtract;
	}(ArithmaticOperator));
	exports.Subtract = Subtract;
	var Multiply = (function (_super) {
	    __extends(Multiply, _super);
	    function Multiply() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "multiply";
	        _this.symbol = "×";
	        _this.protocolName = "_" + _this.symbol + "_";
	        return _this;
	    }
	    return Multiply;
	}(ArithmaticOperator));
	exports.Multiply = Multiply;
	var Divide = (function (_super) {
	    __extends(Divide, _super);
	    function Divide() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "divide";
	        _this.symbol = "÷";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(Operator.NUMERIC_TYPES, "float");
	        return _this;
	    }
	    return Divide;
	}(ArithmaticOperator));
	exports.Divide = Divide;
	var Negation = (function (_super) {
	    __extends(Negation, _super);
	    function Negation() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "negation";
	        _this.symbol = "⁻";
	        _this.protocolName = _this.symbol + "_";
	        _this.cardinality = 1;
	        _this.signature = [
	            { left: "float", returns: "float" },
	            { left: "integer", returns: "integer" },
	            { left: "whole number", returns: "integer" },
	            { left: "natural number", returns: "integer" }
	        ];
	        return _this;
	    }
	    return Negation;
	}(SingletonOperator));
	exports.Negation = Negation;
	var AbsoluteValue = (function (_super) {
	    __extends(AbsoluteValue, _super);
	    function AbsoluteValue() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "absolute value";
	        _this.symbol = "abs";
	        _this.protocolName = "|_|";
	        _this.cardinality = 1;
	        _this.signature = single(Operator.NUMERIC_TYPES);
	        return _this;
	    }
	    AbsoluteValue.prototype.label = function (left) {
	        return "|" + left.toReadable() + "|";
	    };
	    return AbsoluteValue;
	}(SingletonOperator));
	exports.AbsoluteValue = AbsoluteValue;
	var Modulus = (function (_super) {
	    __extends(Modulus, _super);
	    function Modulus() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.name = "modulus";
	        _this.symbol = "mod";
	        _this.protocolName = "_" + _this.symbol + "_";
	        _this.signature = mirror(["integer", "natural number", "whole number"]);
	        return _this;
	    }
	    return Modulus;
	}(ArithmaticOperator));
	exports.Modulus = Modulus;
	var Operators = (function () {
	    function Operators() {
	    }
	    Operators.get = function (name) {
	        return Operators.All.find(function (op) { return op.name === name; });
	    };
	    Operators.getByProtocol = function (protocolName) {
	        return Operators.All.find(function (op) {
	            return (op.name !== "is" && op.protocolName === protocolName);
	        });
	    };
	    Operators.byReturn = function (type) {
	        return Operators.All.filter(function (op) { return op.signature.some(function (sig) { return sig.returns === type; }); });
	    };
	    Operators.All = [
	        new And(),
	        new Or(),
	        new Not(),
	        new Is(),
	        new Equals(),
	        new NotEquals(),
	        new LessThan(),
	        new LessThanOrEqual(),
	        new GreaterThan(),
	        new GreaterThanOrEqual(),
	        new SizeOf(),
	        new Contains(),
	        new ElementOf(),
	        new Substring(),
	        new Add(),
	        new Subtract(),
	        new Multiply(),
	        new Divide(),
	        new Negation(),
	        new Modulus(),
	        new AbsoluteValue(),
	        new Answered(),
	        new Unanswered(),
	        new ClientOnlyMultiAnd()
	    ];
	    return Operators;
	}());
	exports.Operators = Operators;
	exports.INEQUALITIES = Operators.All.filter(function (op) { return op instanceof EqualityOperator; });


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var filter_node_1 = __webpack_require__(900);
	var operators_1 = __webpack_require__(901);
	var ActivityState;
	(function (ActivityState) {
	    ActivityState[ActivityState["Configuration"] = 0] = "Configuration";
	    ActivityState[ActivityState["Scheduled"] = 1] = "Scheduled";
	    ActivityState[ActivityState["Running"] = 2] = "Running";
	    ActivityState[ActivityState["Complete"] = 3] = "Complete";
	    ActivityState[ActivityState["Paused"] = 4] = "Paused";
	    ActivityState[ActivityState["Aborted"] = 5] = "Aborted";
	    ActivityState[ActivityState["Released"] = 6] = "Released";
	})(ActivityState = exports.ActivityState || (exports.ActivityState = {}));
	var ACTIVITY_STATE_NAMES = new Map([
	    [ActivityState.Configuration, "Configuration"],
	    [ActivityState.Scheduled, "Scheduled"],
	    [ActivityState.Running, "Running"],
	    [ActivityState.Complete, "Complete"],
	    [ActivityState.Paused, "Paused"],
	    [ActivityState.Aborted, "Aborted"]
	]);
	var ToolboxActivity = (function () {
	    function ToolboxActivity() {
	        this.title = "Unknown";
	        this.configurationControls = [];
	        this.state = ActivityState.Configuration;
	        this.filter = null;
	        this.filterOptions = [];
	    }
	    Object.defineProperty(ToolboxActivity.prototype, "readableState", {
	        get: function () {
	            return ACTIVITY_STATE_NAMES.get(this.state);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolboxActivity.prototype, "isScheduled", {
	        get: function () {
	            return this.state === ActivityState.Scheduled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolboxActivity.prototype, "isStarted", {
	        get: function () {
	            return this.state > ActivityState.Configuration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolboxActivity.prototype, "isRunning", {
	        get: function () {
	            return this.state === ActivityState.Running;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolboxActivity.prototype, "isPaused", {
	        get: function () {
	            return this.state === ActivityState.Paused;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolboxActivity.prototype, "isComplete", {
	        get: function () {
	            return this.state === ActivityState.Complete;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ToolboxActivity.prototype.clearProgress = function () {
	        this.population = 1;
	        this.remaining = 1;
	        this.populationIsEstimated = true;
	        this.viable = 0;
	        this.unanswered = 0;
	        this.processed = 0;
	        this.rejected = 0;
	        this.unknownCount = 0;
	        this.serverStart = null;
	        this.serverEnd = null;
	        this.serverSeconds = 0;
	        this.localStart = null;
	        this.localEnd = null;
	        this.localSeconds = 0;
	    };
	    ToolboxActivity.prototype.markScheduled = function () {
	        this.clearProgress();
	        this.clearResults();
	        this.configurationControls.forEach(function (control) { return control.disable(); });
	        if (this.filter) {
	            this.filterString = this.filter.toReadable();
	        }
	        this.markStarted();
	    };
	    ToolboxActivity.prototype.markStarted = function () {
	        this.state = ActivityState.Running;
	        this.localStart = new Date();
	    };
	    ToolboxActivity.prototype.estimatePopulation = function () {
	        return Math.max((this.processed + this.rejected + this.unanswered)
	            * this.scalingFactor(), 1);
	    };
	    ToolboxActivity.prototype.scalingFactor = function () {
	        if (this.localSeconds) {
	            return (1 /
	                (1 - Math.min(Math.exp(ToolboxActivity.EXP_SCALE * this.localSeconds), 0.8)));
	        }
	        else {
	            return 2.0;
	        }
	    };
	    ToolboxActivity.prototype.readProgress = function (progress) {
	        this.processed = progress.processed;
	        this.rejected = progress.rejected;
	        this.viable = progress.viable;
	        if ("unanswered" in progress) {
	            this.unanswered = progress.unanswered;
	        }
	        if (this.localStart) {
	            this.localSeconds = (Date.now() - this.localStart.valueOf()) / 1000;
	        }
	        if ("population" in progress) {
	            this.populationIsEstimated = false;
	            this.population = progress.population;
	        }
	        else {
	            this.population = this.estimatePopulation();
	        }
	        this.remaining = this.population
	            - (this.processed + this.rejected + this.unanswered);
	    };
	    ToolboxActivity.prototype.readCompletion = function (progress) {
	        this.state = ActivityState.Complete;
	        this.processed = progress.processed;
	        this.rejected = progress.rejected + progress.emptyRejectedCount;
	        this.viable = progress.viable;
	        if ((this.processed + this.rejected) !== this.viable) {
	            this.unknownCount = this.viable - (this.processed + this.rejected);
	            console.error("At task end, viable did not equal processed + rejected", this.unknownCount);
	        }
	        if ("unanswered" in progress) {
	            this.unanswered = progress.unanswered;
	        }
	        this.populationIsEstimated = false;
	        if ("population" in progress) {
	            this.population = progress.population;
	        }
	        else {
	            this.population = this.viable + this.unanswered;
	        }
	        this.remaining = 0;
	        this.serverStart = new Date(progress.start);
	        this.serverEnd = new Date(progress.ended);
	        this.serverSeconds = progress.duration / 1000;
	        this.localEnd = new Date();
	        this.localSeconds =
	            (this.localEnd.valueOf() - this.localStart.valueOf()) / 1000;
	    };
	    ToolboxActivity.prototype.clearFilter = function () {
	        this.filter = null;
	    };
	    ToolboxActivity.prototype.initDefaultFilter = function (options) {
	        var isSimple = (options && options.type === "simple");
	        var eqNode = filter_node_1.OperatorNode.BasicEquality(this.filterOptions, !isSimple);
	        if (isSimple) {
	            this.filter = new filter_node_1.OperatorNode(operators_1.Operators.get("all of"), [], true, this.filterOptions);
	            this.filter.addChild(0, eqNode);
	        }
	        else {
	            this.filter = eqNode;
	        }
	    };
	    ToolboxActivity.EXP_SCALE = -0.333;
	    return ToolboxActivity;
	}());
	exports.ToolboxActivity = ToolboxActivity;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AggregatorResponseType;
	(function (AggregatorResponseType) {
	    AggregatorResponseType[AggregatorResponseType["Standard"] = 0] = "Standard";
	    AggregatorResponseType[AggregatorResponseType["Frequency"] = 1] = "Frequency";
	    AggregatorResponseType[AggregatorResponseType["SubjectContext"] = 2] = "SubjectContext";
	})(AggregatorResponseType = exports.AggregatorResponseType || (exports.AggregatorResponseType = {}));
	var Aggregator = (function () {
	    function Aggregator(name, description, requiresStateVariable, responseType) {
	        if (requiresStateVariable === void 0) { requiresStateVariable = false; }
	        if (responseType === void 0) { responseType = AggregatorResponseType.Standard; }
	        this.name = name;
	        this.description = description;
	        this.requiresStateVariable = requiresStateVariable;
	        this.responseType = responseType;
	        this.restrictedByAlgorithm = false;
	        this.algorithms = [];
	        this.childCounter = 0;
	    }
	    Object.defineProperty(Aggregator.prototype, "providesSubjectContext", {
	        get: function () {
	            return this.responseType === AggregatorResponseType.SubjectContext;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Aggregator.prototype, "isFrequency", {
	        get: function () {
	            return this.responseType === AggregatorResponseType.Frequency;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Aggregator.prototype, "reportMessageTag", {
	        get: function () {
	            return this.responseType + 82;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Aggregator.fromDescriptor = function (descriptor) {
	        var aggregator = new Aggregator(descriptor.name, descriptor.description, descriptor.requiresStateVariable);
	        if (descriptor.isFrequency) {
	            aggregator.responseType = AggregatorResponseType.Frequency;
	        }
	        if (descriptor.providesSubjectContext) {
	            if (descriptor.isFrequency) {
	                throw new Error("Descriptor indicated aggregator responds with both frequency and subject context report types!");
	            }
	            aggregator.responseType = AggregatorResponseType.SubjectContext;
	        }
	        if (descriptor.algorithms) {
	            aggregator.restrictedByAlgorithm = true;
	            aggregator.algorithms = descriptor.algorithms;
	        }
	        return aggregator;
	    };
	    return Aggregator;
	}());
	exports.Aggregator = Aggregator;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(64);
	var typed_data_1 = __webpack_require__(69);
	var export_1 = __webpack_require__(618);
	var filter_node_1 = __webpack_require__(900);
	var summarization_1 = __webpack_require__(905);
	var toolbox_activity_1 = __webpack_require__(902);
	var DataExport = (function (_super) {
	    __extends(DataExport, _super);
	    function DataExport(id, filterOptions, columnOptions, tableOptions, parent) {
	        if (filterOptions === void 0) { filterOptions = []; }
	        if (columnOptions === void 0) { columnOptions = []; }
	        if (tableOptions === void 0) { tableOptions = []; }
	        var _this = _super.call(this) || this;
	        _this.id = id;
	        _this.filterOptions = filterOptions;
	        _this.columnOptions = columnOptions;
	        _this.tableOptions = tableOptions;
	        _this.parent = parent;
	        _this.columnSelection = [];
	        _this.columns = [];
	        _this.customDelimiter = _this.parent.collectionDelimiter || ",";
	        _this.useHeaders = true;
	        _this.headersControl = new forms_1.FormControl(true);
	        _this.excelDatesControl = new forms_1.FormControl(true);
	        _this.dropCollFilterEmptiesControl = new forms_1.FormControl(true);
	        _this.delimiterControl = new forms_1.FormControl({
	            value: _this.customDelimiter,
	            disabled: false
	        }, forms_1.Validators.required);
	        _this.membershipControl = new forms_1.FormArray([]);
	        _this.bomControl = new forms_1.FormControl(false);
	        _this.labelControl = new forms_1.FormControl({ value: "", disabled: true });
	        _this.configurationControls = [
	            _this.membershipControl,
	            _this.delimiterControl,
	            _this.headersControl,
	            _this.excelDatesControl,
	            _this.dropCollFilterEmptiesControl,
	            _this.labelControl
	        ];
	        _this.filenameControl = new forms_1.FormControl(_this.parent.defaultFilename());
	        _this.title =
	            _this.parent.displayName + " " + ++_this.parent.childCounter;
	        tableOptions.forEach(function (table) {
	            table.members.forEach(function (varName) {
	                var match = _this.columnOptions.find(function (target) { return target.name === varName; });
	                match.table = table.table;
	                match.membershipClass = "text-info";
	            });
	        });
	        _this.columnOptions.forEach(function (variable) {
	            if (variable.cardinality !== 1 && !variable.table) {
	                var tableName_1;
	                if (tableOptions.some(function (table) { return table.members.some(function (member) {
	                    if (member === variable.name) {
	                        tableName_1 = table.table;
	                        return true;
	                    }
	                    return false;
	                }); })) {
	                    variable.table = tableName_1;
	                }
	                variable.membershipClass = "text-info";
	            }
	        });
	        return _this;
	    }
	    DataExport.prototype.readSchema = function (schema) {
	        var _this = this;
	        this.columns = schema.columns;
	        this.columnSelection = schema.columns.map(function (tcd) {
	            var out = Object.assign({}, tcd.baseType, { summarization: summarization_1.SummarizationByName.get(tcd.summarization) }, { name: tcd.name }, { displayName: tcd.columnName });
	            if (tcd.filter) {
	                out.filter = filter_node_1.OperatorNode.simpleFromSchema(tcd.filter, _this.filterOptions, true, out);
	            }
	            return out;
	        });
	        this.headersControl.setValue(schema.useHeaders);
	        this.delimiterControl.setValue(schema.format.collectionDelimiter);
	        if (schema.filter.nodeType === "operator") {
	            this.filter = filter_node_1.OperatorNode.fromSchema(schema.filter, this.filterOptions, true, null, true);
	        }
	        else {
	        }
	        if (schema.exportFilename !== "") {
	            this.filenameControl.setValue(schema.exportFilename);
	        }
	        if (Number.isSafeInteger(schema.childCounter)) {
	            schema.childCounter++;
	        }
	        else {
	            schema.childCounter = 1;
	        }
	        this.title = schema.schemaName + " " + schema.childCounter;
	    };
	    DataExport.prototype.copyFrom = function (other) {
	        this.columns = other.columns.map(function (x) { return Object.assign({}, x); });
	        this.columnSelection = other.columnSelection.map(function (cs) {
	            var out = Object.assign({}, cs);
	            if ("summarization" in out) {
	                out.summarization =
	                    Object.assign({}, cs.summarization);
	            }
	            return out;
	        });
	        this.headersControl.setValue(other.useHeaders);
	        this.delimiterControl.setValue(other.delimiterControl.value);
	        this.filter = filter_node_1.OperatorNode.fromSchema(other.filter.marshal(), this.filterOptions, true, null, true);
	        this.filenameControl.setValue(other.filenameControl.value);
	    };
	    DataExport.prototype.getDownloadName = function () {
	        var given = this.filenameControl.value;
	        if (!given) {
	            return "untitled";
	        }
	        return given.replace("[DATE]", typed_data_1.TypedData.dateToInput(new Date()));
	    };
	    DataExport.fromOptions = function (rsp, parent) {
	        return new DataExport(rsp.exportId, rsp.filterOptions, rsp.targetVariableOptions, rsp.tables, parent);
	    };
	    DataExport.prototype.clearResults = function () {
	        this.downloadCredentials = null;
	        this.downloadFile = null;
	        this.downloadURL = null;
	        this.downloadSafeURL = null;
	        this.checksum = null;
	        this.checksumHex = null;
	        this.expectedFilesize = null;
	    };
	    DataExport.prototype.readMessageReport = function (derr) {
	        this.readCompletion(derr);
	        this.checksum = derr.checksumUnsigned;
	        this.checksumHex = "0x" + derr.checksumUnsigned.toString(16);
	        this.expectedFilesize = derr.bytesSent;
	    };
	    DataExport.prototype.requestFor = function (action) {
	        switch (action) {
	            case "cancel":
	                return new export_1.CancelDataExportRequest(this.id);
	            case "pause":
	                return new export_1.PauseDataExportRequest(this.id);
	            case "resume":
	                return new export_1.ResumeDataExportRequest(this.id);
	            case "status":
	                return new export_1.DataExportStatusRequest(this.id);
	            default:
	                throw new Error("Unsupported activity request: " + action);
	        }
	    };
	    return DataExport;
	}(toolbox_activity_1.ToolboxActivity));
	exports.DataExport = DataExport;


/***/ }),
/* 905 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var COUNT = { name: "count", displayName: "count", numericalOnly: false };
	var SUM = { name: "sum", displayName: "sum", numericalOnly: true };
	var AVERAGE = { name: "average", displayName: "average", numericalOnly: true };
	var INLINE = { name: "inline", displayName: "inline list", numericalOnly: false };
	exports.NonDefaultSummarizations = [
	    COUNT,
	    SUM,
	    AVERAGE,
	    INLINE
	];
	exports.DefaultSummarization = {
	    name: "none",
	    displayName: "values",
	    numericalOnly: false
	};
	exports.SummarizationByName = new Map([
	    ["count", COUNT],
	    ["sum", SUM],
	    ["average", AVERAGE],
	    ["inline", INLINE],
	    ["none", exports.DefaultSummarization]
	]);


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var functions_1 = __webpack_require__(206);
	var Exporter = (function () {
	    function Exporter(name, displayName, description) {
	        this.name = name;
	        this.displayName = displayName;
	        this.description = description;
	        this.childCounter = 0;
	        this.mimeType = "text/plain";
	        this.allowsInlining = false;
	        this.collectionDelimiter = null;
	        this.customizableCollectionDelimiter = false;
	        this.useRecordRepetition = false;
	        this.fileExtension = "";
	    }
	    Exporter.prototype.defaultFilename = function () {
	        return "" + Exporter.DefaultName + this.fileExtension;
	    };
	    Object.defineProperty(Exporter.prototype, "formatName", {
	        get: function () {
	            return this.name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Exporter.fromDescriptor = function (descriptor) {
	        var exporter = new Exporter(descriptor.formatName, descriptor.displayName, descriptor.description);
	        functions_1.assignOnly(exporter, descriptor, [
	            "allowsInlining",
	            "collectionDelimiter",
	            "customizableCollectionDelimiter",
	            "mimeType",
	            "useRecordRepetition",
	            "fileExtension"
	        ]);
	        return exporter;
	    };
	    Exporter.DefaultName = "export";
	    return Exporter;
	}());
	exports.Exporter = Exporter;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var subject_service_1 = __webpack_require__(821);
	var aggregation_1 = __webpack_require__(899);
	var aggregation_service_1 = __webpack_require__(809);
	var toolbox_task_component_1 = __webpack_require__(908);
	var modal_service_1 = __webpack_require__(837);
	var AggregationTaskComponent = (function (_super) {
	    __extends(AggregationTaskComponent, _super);
	    function AggregationTaskComponent(service, modals, subjects) {
	        var _this = _super.call(this, service, modals) || this;
	        _this.service = service;
	        _this.modals = modals;
	        _this.subjects = subjects;
	        return _this;
	    }
	    AggregationTaskComponent.prototype.run = function () {
	        if (this.task.requiresStateVariable
	            && this.task.targetSelector.invalid) {
	            return alert("You must select a target state variable!");
	        }
	        if (this.task.isComplete) {
	            this.task.clearProgress();
	        }
	        this.service.run(this.task);
	    };
	    AggregationTaskComponent.prototype.openResultSubject = function (r, i) {
	        this.subjects.openReference(this.task.buildReportRef(r, i)).subscribe();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", aggregation_1.Aggregation)
	    ], AggregationTaskComponent.prototype, "task", void 0);
	    AggregationTaskComponent = __decorate([
	        core_1.Component({
	            selector: "aggregation-task",
	            template: "\n<div\n    #panel\n    class=\"panel panel-default\">\n    <div class=\"panel-heading\" (click)=\"panel.closed = !panel.closed\">\n        <h3 class=\"panel-title\">\n            <span\n                class=\"glyphicon\"\n                [class.glyphicon-expand]=\"panel.closed\"\n                [class.glyphicon-collapse-down]=\"!panel.closed\">\n            </span>\n            <a\n                title=\"Rename this query...\"\n                (click)=\"$event.stopPropagation(); renameTask()\">\n                {{task.title}}</a>\n            <!--<small>({{task.readableState}})</small>-->\n            <small>\n                (algorithm:\n                <span class=\"text-success\">{{task.algorithm}}</span>,\n                group:\n                <span class=\"text-info\">{{task.group}}</span>)\n            </small>\n            <button\n                type=\"button\"\n                class=\"btn btn-xs btn-danger pull-right\"\n                (click)=\"release()\">\n                Remove\n            </button>\n        </h3>\n    </div>\n    <div class=\"panel-body collapse\" [class.in]=\"!panel.closed\">\n        <h4>Options</h4>\n        <div class=\"row form-group\">\n            <div class=\"col-sm-4\">\n                <label>Algorithm:</label>\n                <div class=\"form-control\" disabled>\n                    {{task.algorithm}}\n                </div>\n            </div>\n            <div class=\"col-sm-4\">\n                <label>Group:</label>\n                <div class=\"form-control\" disabled>\n                    {{task.group}}\n                </div>\n            </div>\n            <div\n                *ngIf=\"task.targetVariableOptions.length > 0\"\n                class=\"col-sm-4\">\n                <label>Target State Variable</label>\n                <select\n                    class=\"form-control\"\n                    [formControl]=\"task.targetSelector\">\n                    <option\n                        *ngFor=\"let variable of task.targetVariableOptions\"\n                        [value]=\"variable.name\">\n                        {{variable.displayName}}\n                    </option>\n                </select>\n            </div>\n        </div>\n        <div\n            *ngIf=\"!(task.isStarted && task.filter === null)\"\n            class=\"form-group\">\n            <label>\n                Filter\n            </label>\n            <span class=\"btn-group\">\n                <button\n                    *ngIf=\"!task.isStarted\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-default\"\n                    (click)=\"resetFilter(true)\"\n                    [disabled]=\"task.isStarted\">\n                    {{task.filter === null ? \"Add (Simple)\" : \"Reset (Simple)\"}}\n                </button>\n                <button\n                    *ngIf=\"!task.isStarted\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-info\"\n                    (click)=\"resetFilter()\"\n                    [disabled]=\"task.isStarted\">\n                    {{task.filter === null ? \"Add (Advanced)\" : \"Reset (Advanced)\"}}\n                </button>\n                <button\n                    *ngIf=\"!task.isStarted && task.filter !== null\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-danger\"\n                    (click)=\"removeFilter()\"\n                    [disabled]=\"task.isStarted\">\n                    Remove\n                </button>\n            </span>\n            <filter-node\n                *ngIf=\"task.filter !== null && !task.isStarted && !simpleFilter\"\n                [node]=\"task.filter\"\n                [variables]=\"task.filterOptions\"\n                [root]=\"true\">\n            </filter-node>\n            <simple-filter-node\n                *ngIf=\"task.filter !== null && !task.isStarted && simpleFilter\"\n                [node]=\"task.filter\"\n                [variables]=\"task.filterOptions\">\n            </simple-filter-node>\n            <div\n                style=\"margin-left: 2em\"\n                *ngIf=\"task.filterString\"\n                [innerHtml]=\"task.filterString\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-3\">\n                <button\n                    class=\"btn btn-success p100\"\n                    (click)=\"run()\"\n                    [disabled]=\"task.isStarted && !task.isComplete\">\n                    <span\n                        class=\"glyphicon\"\n                        [class.glyphicon-play]=\"!task.isComplete\"\n                        [class.glyphicon-repeat]=\"task.isComplete\">\n                    </span>\n                    {{ task.isComplete ? \"Re-run\" : \"Run\" }}\n                </button>\n            </div>\n            <div class=\"col-md-3\">\n                <button\n                    *ngIf=\"!task.isPaused\"\n                    class=\"btn btn-info p100\"\n                    (click)=\"pause(true)\"\n                    [disabled]=\"!task.isRunning\">\n                    <span class=\"glyphicon glyphicon-pause\"></span>\n                    Pause\n                </button>\n                <button\n                    *ngIf=\"task.isPaused\"\n                    class=\"btn btn-info p100\"\n                    (click)=\"pause(false)\">\n                    <span class=\"glyphicon glyphicon-step-forward\"></span>\n                    Resume\n                </button>\n            </div>\n            <div class=\"col-md-3\">\n                <button\n                    class=\"btn btn-danger p100\"\n                    (click)=\"cancel()\"\n                    [disabled]=\"!(task.isRunning || task.isPaused)\">\n                    <span class=\"glyphicon glyphicon-remove\"></span>\n                    Cancel\n                </button>\n            </div>\n            <!--<button\n                class=\"btn btn-default\"\n                (click)=\"getProgress()\"\n                [disabled]=\"task.isComplete || !task.isStarted\">\n                <span class=\"glyphicon glyphicon-tasks\"></span>\n                Request Progress\n            </button>-->\n            <div class=\"col-md-3\">\n                <button\n                    class=\"btn btn-default p100\"\n                    (click)=\"saveSchema()\"\n                    [disabled]=\"!task.isComplete\">\n                    <span class=\"glyphicon glyphicon-pushpin\"></span>\n                    Save as Template\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <div\n        *ngIf=\"task.isStarted\"\n        class=\"panel-body collapse\"\n        [class.in]=\"!panel.closed\">\n        <task-progress [task]=\"task\"></task-progress>\n    </div>\n\n    <div\n        *ngIf=\"task.isComplete\"\n        class=\"panel-body collapse reports\"\n        [class.in]=\"!panel.closed\">\n        <h3>Results</h3>\n\n        <!-- no results sent -->\n        <h4 *ngIf=\"task.noResults\" class=\"text-center text-danger\">\n            No Results\n        </h4>\n\n        <!-- \"standard\" (valued) results -->\n        <table\n            *ngIf=\"task.standardResults.length\"\n            class=\"table\"\n            [class.single-result]=\"task.standardResults.length === 1\">\n            <thead>\n                <th *ngFor=\"let result of task.standardResults\">\n                    {{result.displayName}}\n                </th>\n            </thead>\n            <tbody><tr>\n                <td *ngFor=\"let result of task.standardResults\">\n                    <typed-display [input]=\"result\"></typed-display>\n                </td>\n            </tr></tbody>\n        </table>\n\n        <!-- frequency results -->\n        <div\n            *ngFor=\"let freq of task.frequencyResults\"\n            class=\"row frequency-report\">\n        <div class=\"col-md-4\">\n            <table class=\"table\">\n                <thead>\n                    <tr>\n                        <th\n                            [sorts]=\"freq.value.frequencies\"\n                            dot=\"element\"\n                            [asType]=\"freq.value.type\"\n                            [after]=\"chart\"\n                            [autorun]=\"true\">\n                            Element\n                        </th>\n                        <th\n                            [sorts]=\"freq.value.frequencies\"\n                            dot=\"frequency\"\n                            asType=\"natural number\"\n                            [after]=\"chart\">\n                            Frequency\n                        </th>\n                    </tr>\n                </thead>\n                <tr *ngFor=\"let entry of (freq.value.frequencies | slice:0:12)\">\n                    <td>\n                        <typed-display\n                            [value]=\"entry.element\"\n                            [wrapper]=\"{type: freq.value.type, cardinality: freq.value.cardinality}\">\n                        </typed-display>\n                    </td>\n                    <td>\n                        {{entry.frequency}}\n                    </td>\n                </tr>\n                <tr *ngIf=\"freq.value.frequencies.length > 12\">\n                    <td colspan=\"2\" class=\"text-warning\">\n                        <em>\n                            Truncated\n                            {{freq.value.frequencies.length - 20}}\n                            entries...\n                        </em>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div class=\"col-md-8\">\n            <frequency-chart\n                #chart\n                [data]=\"freq.value\">\n            </frequency-chart>\n        </div>\n        </div>\n\n        <!-- context results -->\n        <div\n            *ngFor=\"let result of task.contextResults; let r = index\"\n            class=\"context-result\">\n            <h4>{{result.displayName}}</h4>\n            <table class=\"table\">\n                <thead>\n                    <th\n                        *ngFor=\"let column of result.columns; let i = index\">\n                        {{column}}\n                    </th>\n                    <th>\n                        Actions\n                    </th>\n                </thead>\n                <tbody *ngIf=\"result.cardinality === 1\">\n                    <tr>\n                        <td *ngFor=\"let data of result.value.summary\">\n                            <typed-display [input]=\"data\">\n                            </typed-display>\n                        </td>\n                        <td>\n                            <a\n                                type=\"button\"\n                                class=\"btn btn-success btn-xs\"\n                                (click)=\"openResultSubject(r, result.itemId)\">\n                                Open\n                            </a>\n                        </td>\n                    </tr>\n                </tbody>\n                <tbody *ngIf=\"result.cardinality !== 1\">\n                    <tr *ngFor=\"let context of result.value\">\n                        <td *ngFor=\"let data of context.summary\">\n                            <typed-display [input]=\"data\">\n                            </typed-display>\n                        </td>\n                        <td>\n<!-- These are disabled until we revisit higher cardinality context results -->\n                            <button\n                                type=\"button\"\n                                class=\"btn btn-success btn-xs\"\n                                disabled\n                                title=\"Higher cardinality open is unavailable\">\n                                Open\n                            </button>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n    ",
	            styles: [
	                "\n        .single-result th, .single-result td {\n            font-size: 1.6em;\n        }\n        .panel-body + .panel-body {\n            border-top: 1px solid #ddd;\n        }\n        .panel h3, .panel h4 {\n            margin-top: 0;\n        }\n        .frequency-report table {\n            padding: 10px;\n            margin: auto;\n        }\n        .reports td, .reports th {\n            text-align: center;\n        }\n        .context-result th, .context-result h4 {\n            text-transform: capitalize;\n        }\n        /*\n        .progress-bar {\n            min-width: 70px;\n        }\n        .progress-bar + .progress-bar {\n            max-width: calc(100% - 70px);\n        } */\n        "
	            ]
	        }),
	        __metadata("design:paramtypes", [aggregation_service_1.AggregationService,
	            modal_service_1.ModalService,
	            subject_service_1.SubjectService])
	    ], AggregationTaskComponent);
	    return AggregationTaskComponent;
	}(toolbox_task_component_1.ToolboxTaskComponent));
	exports.AggregationTaskComponent = AggregationTaskComponent;


/***/ }),
/* 908 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ToolboxTaskComponent = (function () {
	    function ToolboxTaskComponent(service, modals) {
	        this.service = service;
	        this.modals = modals;
	        this.simpleFilter = false;
	    }
	    ToolboxTaskComponent.prototype.run = function () {
	        this.service.run(this.task);
	    };
	    ToolboxTaskComponent.prototype.pause = function (halt) {
	        if (halt === void 0) { halt = true; }
	        if (halt) {
	            this.service.pause(this.task);
	        }
	        else {
	            this.service.resume(this.task);
	        }
	    };
	    ToolboxTaskComponent.prototype.cancel = function () {
	        this.service.cancel(this.task);
	    };
	    ToolboxTaskComponent.prototype.getProgress = function () {
	        this.service.requestProgress(this.task);
	    };
	    ToolboxTaskComponent.prototype.release = function () {
	        this.service.release(this.task);
	    };
	    ToolboxTaskComponent.prototype.resetFilter = function (simple) {
	        if (simple === void 0) { simple = false; }
	        this.simpleFilter = simple;
	        this.task.initDefaultFilter({ type: (simple ? "simple" : "advanced") });
	    };
	    ToolboxTaskComponent.prototype.removeFilter = function () {
	        this.task.clearFilter();
	    };
	    ToolboxTaskComponent.prototype.renameTask = function () {
	        var _this = this;
	        this.modals.stringPrompt({
	            title: "Rename analysis task",
	            body: "Provide a new name for the task \"" + this.task.title + "\":",
	            placeholder: "Analysis Task"
	        }).subscribe(function (name) {
	            _this.task.title = name;
	        });
	        return false;
	    };
	    ToolboxTaskComponent.prototype.saveSchema = function () {
	        var _this = this;
	        this.modals.stringPrompt({
	            title: "Template Name",
	            body: "Enter the name you wish to save the template under:",
	            placeholder: "Untitled template"
	        }).flatMap(function (name) { return _this.service.saveSchema(_this.task, name); }).subscribe(function () { return alert("Save successful"); });
	    };
	    return ToolboxTaskComponent;
	}());
	exports.ToolboxTaskComponent = ToolboxTaskComponent;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var bootstrap_1 = __webpack_require__(24);
	var aggregation_service_1 = __webpack_require__(809);
	var AggregationComponent = (function () {
	    function AggregationComponent(service, modal) {
	        this.service = service;
	        this.modal = modal;
	    }
	    AggregationComponent.prototype.startFromSchema = function (schema, isExport) {
	        this.service.startFromSchema(schema, isExport);
	    };
	    AggregationComponent.prototype.deleteSchema = function (schema, isExport) {
	        this.service.deleteSchema(schema, isExport);
	    };
	    AggregationComponent.prototype.changeVisibility = function (schema, isExport) {
	        if (!schema.isOwner) {
	            return;
	        }
	        this.service.toggleSchemaVisibility(schema, isExport);
	    };
	    AggregationComponent = __decorate([
	        core_1.Component({
	            template: "\n<div class=\"container\" #agg>\n    <div [class.col-sm-4]=\"!agg.hideTools\" [class.col-sm-2]=\"agg.hideTools\">\n\t\t\t\t<h2 (click)=\"agg.hideTools = !agg.hideTools\">\n\t\t\t\t\t\tToolbox\n\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\tclass=\"glyphicon\"\n\t\t\t\t\t\t\t\t[class.glyphicon-collapse-down]=\"!agg.hideTools\"\n\t\t\t\t\t\t\t\t[class.glyphicon-collapse-up]=\"agg.hideTools\">\n\t\t\t\t\t\t</span>\n\t\t\t\t</h2>\n\t\t\t\t<div class=\"well\">\n\t\t\t\t\t\t<em *ngIf=\"agg.hideTools\">(Hidden)</em>\n            <aggregator-list class=\"collapse\" [class.in]=\"!agg.hideTools\"></aggregator-list>\n        </div>\n    </div>\n\n    <!-- OPTIONS & RESULTS -->\n    <div [class.col-sm-8]=\"!agg.hideTools\" [class.col-sm-10]=\"agg.hideTools\">\n        <ul class=\"nav nav-pills\" role=\"tablist\">\n            <li role=\"presentation\" [class.active]=\"service.selectedPanel == 0\">\n                <a (click)=\"service.selectedPanel = 0\">\n                    <!--<span class=\"glyphicon glyphicon-signal\"></span>-->\n                    Analysis Tasks\n                    <span class=\"badge\">\n                        {{service.aggregations.length}}\n                    </span>\n                </a>\n            </li>\n            <li role=\"presentation\" [class.active]=\"service.selectedPanel == 1\">\n                <a (click)=\"service.selectedPanel = 1\">\n                    <!--<span class=\"glyphicon glyphicon-export\"></span>-->\n                    Data Export Tasks\n                    <span class=\"badge\">\n                        {{service.exports.length}}\n                    </span>\n                </a>\n            </li>\n            <li role=\"presentation\" [class.active]=\"service.selectedPanel == 2\">\n                <a (click)=\"service.selectedPanel = 2\">\n                    Saved Templates\n                    <span class=\"badge\">\n                        {{service.schemaCount}}\n                    </span>\n                </a>\n            </li>\n        </ul>\n\n        <div *ngIf=\"service.selectedPanel === 0\">\n            <h3 *ngIf=\"!service.aggregations.length\">No current queries!</h3>\n            <aggregation-task\n                *ngFor=\"let task of service.aggregations\"\n                [task]=\"task\">\n            </aggregation-task>\n        </div>\n        <div *ngIf=\"service.selectedPanel === 1\">\n            <h3 *ngIf=\"!service.exports.length\">No current queries!</h3>\n            <export-task\n                *ngFor=\"let task of service.exports\"\n                [task]=\"task\">\n            </export-task>\n        </div>\n        <div *ngIf=\"service.selectedPanel === 2\">\n            <p>\n                You can create a template for a tool by running that tool with\n                your desired settings, and then selecting\n                <kbd>Save as Template</kbd>\n                from the tool's action bar.\n            </p>\n\n            <h3>\n                Analysis Templates\n                <span class=\"badge\">{{service.aggregationSchemas.length}}</span>\n            </h3>\n            <table class=\"table p100\">\n            <thead>\n                <th\n                    [sorts]=\"service.aggregationSchemas\"\n                    dot=\"schemaName\"\n                    asType=\"string\"\n                    [autorun]=\"true\">\n                    Name\n                </th>\n                <th\n                    [sorts]=\"service.aggregationSchemas\"\n                    dot=\"aggregatorName\"\n                    asType=\"string\">\n                    Type\n                </th>\n                <th\n                    [sorts]=\"service.aggregationSchemas\"\n                    dot=\"algorithm\"\n                    asType=\"string\">\n                    Algorithm\n                </th>\n                <th\n                    [sorts]=\"service.aggregationSchemas\"\n                    dot=\"groupId\"\n                    asType=\"integer\">\n                    Group\n                </th>\n                <th\n                    [sorts]=\"service.aggregationSchemas\"\n                    dot=\"isGroupPublic\"\n                    asType=\"boolean\">\n                    Visibility\n                </th>\n                <th></th>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let schema of service.aggregationSchemas\">\n                <th>{{schema.schemaName}}</th>\n                <td>{{schema.aggregatorName}}</td>\n                <td>{{schema.algorithmObject?.displayName}}</td>\n                <td>{{schema.group?.name}}</td>\n                <td (click)=\"changeVisibility(schema, false)\">\n                    <span [class.dotted]=\"schema.isOwner\">\n                        <span\n                            class=\"glyphicon\"\n                            [class.glyphicon-eye-open]=\"schema.isGroupPublic\"\n                            [class.glyphicon-eye-close]=\"!schema.isGroupPublic\">\n                        </span>\n                        {{schema.isGroupPublic ? \"group\" : \"only me\"}}\n                    </span>\n                </td>\n                <td class=\"btn-group\">\n                    <button\n                        class=\"btn btn-xs btn-primary\"\n                        (click)=\"startFromSchema(schema, false)\">\n                        <span class=\"glyphicon glyphicon-wrench\"></span>\n                        Open\n                    </button>\n                    <button\n                        class=\"btn btn-xs btn-danger\"\n                        (click)=\"deleteSchema(schema, false)\"\n                        [disabled]=\"!schema.isOwner\">\n                        <span class=\"glyphicon glyphicon-remove\"></span>\n                        Delete\n                    </button>\n                </td>\n            </tr>\n            <tr *ngIf=\"!service.aggregationSchemas.length\">\n                <td class=\"text-center\" colspan=\"6\">\n                    <h4>No templates found</h4>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n            <!-- <prettyjson [obj]=\"schema\"></prettyjson> -->\n\n            <h3>\n                Data Export Templates\n                <span class=\"badge\">{{service.exportSchemas.length}}</span>\n            </h3>\n            <table class=\"table p100\">\n                <thead>\n                    <th>\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"schemaName\"\n                            asType=\"string\"\n                            [autorun]=\"true\">\n                            Name\n                        </span>\n                        /\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"format.displayName\"\n                            asType=\"string\">\n                            Type\n                        </span>\n                    </th>\n                    <th>\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"creator\"\n                            asType=\"string\">\n                            Creator\n                        </span>\n                        /\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"algorithm\"\n                            asType=\"string\">\n                            Algorithm\n                        </span>\n                    </th>\n                    <th>\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"groupId\"\n                            asType=\"integer\">\n                            Group\n                        </span>\n                        /\n                        <span\n                            [sorts]=\"service.exportSchemas\"\n                            storedAs=\"exportTemplateSorting\"\n                            dot=\"isGroupPublic\"\n                            asType=\"boolean\">\n                            Visibility\n                        </span>\n                    </th>\n                    <th></th>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let schema of service.exportSchemas\">\n                        <td>\n                            <strong>{{schema.schemaName}}</strong>\n                            <br>\n                            {{schema.format.displayName}}\n                        </td>\n                        <td>\n                            {{schema.creator}}\n                            <br>\n                            {{schema.algorithmObject?.displayName}}\n                        </td>\n                        <td>\n                            {{schema.group?.name}}\n                            <br>\n                            <div (click)=\"changeVisibility(schema, true)\">\n                                <span [class.dotted]=\"schema.isOwner\">\n                                    <span\n                                        class=\"glyphicon\"\n                                        [class.glyphicon-eye-open]=\"schema.isGroupPublic\"\n                                        [class.glyphicon-eye-close]=\"!schema.isGroupPublic\">\n                                    </span>\n                                    {{schema.isGroupPublic ? \"group\" : \"only me\"}}\n                                </span>\n                            </div>\n                        </td>\n                        <td class=\"btn-group\">\n                            <button\n                                class=\"btn btn-primary\"\n                                (click)=\"startFromSchema(schema, true, false)\">\n                                <span class=\"glyphicon glyphicon-wrench\"></span>\n                                Open\n                            </button>\n                            <button\n                                class=\"btn btn-danger\"\n                                (click)=\"deleteSchema(schema, true)\"\n                                [disabled]=\"!schema.isOwner\">\n                                <span class=\"glyphicon glyphicon-remove\"></span>\n                                Delete\n                            </button>\n                        </td>\n                    </tr>\n                </tbody>\n                <tr *ngIf=\"!service.exportSchemas.length\">\n                    <td class=\"text-center\" colspan=\"6\">\n                        <h4>No templates found</h4>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</div>\n  ",
	            styles: [
	                ".nav-pills {\n          padding-top: 0.75em;\n          padding-bottom: 0.7em;\n      }"
	            ]
	        }),
	        __metadata("design:paramtypes", [aggregation_service_1.AggregationService,
	            bootstrap_1.Modal])
	    ], AggregationComponent);
	    return AggregationComponent;
	}());
	exports.AggregationComponent = AggregationComponent;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var algorithm_service_1 = __webpack_require__(213);
	var user_service_1 = __webpack_require__(713);
	var rules_1 = __webpack_require__(640);
	var aggregation_service_1 = __webpack_require__(809);
	var AggregatorListComponent = (function () {
	    function AggregatorListComponent(service, algorithms, user) {
	        this.service = service;
	        this.algorithms = algorithms;
	        this.user = user;
	        this.toolSelector = new forms_1.FormControl();
	        this.aggRule = rules_1.Rule.RUN_AGGREGATOR;
	        this.expRule = rules_1.Rule.RUN_DATA_EXPORT;
	        this.exportsDisabled = false;
	        this.aggsDisabled = false;
	    }
	    AggregatorListComponent.prototype.toolCount = function () {
	        return (2
	            + (this.service.aggregators.length || 1)
	            + (this.service.exporters.length || 1));
	    };
	    AggregatorListComponent.prototype.permissionTooltip = function (group) {
	        if (!group.allows(this.expRule)) {
	            return ("You do not have permission to run data exports on this group");
	        }
	        else if (!group.allows(this.aggRule)) {
	            return ("You do not have permission to run aggregators on this group");
	        }
	        else {
	            return "You can run all tools on this group";
	        }
	    };
	    AggregatorListComponent.prototype.evaluatePermissions = function (group) {
	        if (group) {
	            this.aggsDisabled = !group.allows(this.aggRule);
	            this.exportsDisabled = !group.allows(this.expRule);
	        }
	        else {
	            this.aggsDisabled = true;
	            this.exportsDisabled = true;
	        }
	        this.toolSelector.reset();
	    };
	    AggregatorListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.algorithmSelector = new forms_1.FormControl((this.algorithms.all[0] || { name: null }).name, forms_1.Validators.required);
	        this.groupSelector = new forms_1.FormControl(this.user.self.groups.find(function (g) { return g.allows([_this.aggRule, _this.expRule], true); }), forms_1.Validators.required);
	        if (!this.groupSelector.value) {
	            console.warn("Could not find any groups with tools permissions");
	        }
	        this.evaluatePermissions(this.groupSelector.value);
	        this.groupSelector.valueChanges.subscribe(function (g) { return _this.evaluatePermissions(g); });
	        this.form = new forms_1.FormGroup({
	            algorithm: this.algorithmSelector,
	            group: this.groupSelector
	        });
	    };
	    AggregatorListComponent.prototype.start = function (tool) {
	        if (this.form.invalid) {
	            return alert("You must select an algorithm and group first!");
	        }
	        this.service.startConfiguration(tool, this.algorithmSelector.value, this.groupSelector.value);
	        window.scrollTo(0, 0);
	    };
	    AggregatorListComponent = __decorate([
	        core_1.Component({
	            selector: "aggregator-list",
	            template: "\n        <div class=\"form-group\">\n            <label>Algorithm</label>\n            <select\n                [formControl]=\"algorithmSelector\"\n                class=\"form-control\"\n                [size]=\"algorithms.all?.length || 1\">\n                <option\n                    *ngFor=\"let algorithm of algorithms.all\"\n                    [value]=\"algorithm.name\">\n                    {{algorithm.displayName}}\n                </option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label>Group</label>\n            <select\n                [formControl]=\"groupSelector\"\n                class=\"form-control\"\n                [size]=\"(user.self?.groups?.length || 1)\">\n                <template\n                    ngFor\n                    let-group\n                    [ngForOf]=\"user.self?.groups\">\n                    <option\n                        *ngIf=\"group.allows(aggRule) || group.allows(expRule)\"\n                        [ngValue]=\"group\"\n                        [title]=\"permissionTooltip(group)\">\n                        {{group.name}}\n                        {{!group.allows(aggRule) ? \"(no analyses)\" : \"\"}}\n                        {{!group.allows(expRule) ? \"(no data exports)\" : \"\"}}\n                    </option>\n                    <option\n                        *ngIf=\"!group.allows(aggRule) && !group.allows(expRule)\"\n                        title=\"You don't have permission to run any tools on this group.\"\n                        disabled>\n                        {{group.name}} (no tools available)\n                    </option>\n                </template>\n            </select>\n        </div>\n        <div class=\"form-group\" #selector>\n            <label>Tool</label>\n            <select class=\"tools form-control\" [size]=\"toolCount()\" [formControl]=\"toolSelector\">\n                <option disabled class=\"text-center\">\n                    Analysis\n                </option>\n                <option *ngIf=\"!service.aggregators.length\" disabled default>\n                    \u00ABno tools available\u00BB\n                </option>\n                <option\n                    *ngFor=\"let aggregator of service.aggregators\"\n                    (click)=\"selector.target = aggregator\"\n                    (dblclick)=\"start(aggregator)\"\n                    [disabled]=\"aggsDisabled\">\n                    {{aggregator.name}}\n                </option>\n                <option disabled class=\"text-center\">\n                    Export\n                </option>\n                <option *ngIf=\"!service.exporters.length\" disabled>\n                \u00ABno tools available\u00BB\n                </option>\n                <option\n                    *ngFor=\"let exporter of service.exporters\"\n                    (click)=\"selector.target = exporter\"\n                    (dblclick)=\"start(exporter)\"\n                    [disabled]=\"exportsDisabled\">\n                    {{exporter.displayName}}\n                </option>\n            </select>\n            <br>\n            <div class=\"description\">\n                <button\n                    role=\"button\"\n                    class=\"btn btn-xs btn-primary pull-right\"\n                    (click)=\"start(selector.target)\"\n                    [disabled]=\"!selector.target\">\n                    Create query\n                    <span class=\"glyphicon glyphicon-chevron-right\"></span>\n                </button>\n                <template [ngIf]=\"selector.target\">\n                    <label>\n                        {{selector.target.displayName || selector.target.name}}\n                    </label>\n                    <p>{{selector.target.description}}</p>\n                </template>\n                <em *ngIf=\"!selector.target\">\n                    Select a tool to view description.\n                </em>\n            </div>\n        </div>\n    ",
	            styles: [
	                ".tools option[disabled] {\n            background-color: #f0f0f0;\n        }\n        .description {\n            min-height: 200px;\n        }"
	            ]
	        }),
	        __metadata("design:paramtypes", [aggregation_service_1.AggregationService,
	            algorithm_service_1.AlgorithmService,
	            user_service_1.UserService])
	    ], AggregatorListComponent);
	    return AggregatorListComponent;
	}());
	exports.AggregatorListComponent = AggregatorListComponent;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var bootstrap_1 = __webpack_require__(24);
	var data_types_1 = __webpack_require__(208);
	var membership_input_component_1 = __webpack_require__(737);
	var utilities_1 = __webpack_require__(523);
	var functions_1 = __webpack_require__(206);
	var summarization_1 = __webpack_require__(905);
	var advanced_column_selection_modal_component_1 = __webpack_require__(912);
	var ColumnSelectionInputComponent = (function (_super) {
	    __extends(ColumnSelectionInputComponent, _super);
	    function ColumnSelectionInputComponent(modal) {
	        var _this = _super.call(this) || this;
	        _this.modal = modal;
	        _this.summarizations = summarization_1.NonDefaultSummarizations;
	        _this.maxIterators = Number.MAX_SAFE_INTEGER;
	        _this._target = [];
	        _this.uniqueIterators = new Set();
	        _this.summarization = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.summarizationDefault = summarization_1.DefaultSummarization;
	        _this.columnTitle = new forms_1.FormControl(null, forms_1.Validators.required);
	        _this.disabled = false;
	        _this.min = 10;
	        _this.selectedOption.valueChanges.subscribe(function (val) {
	            if (val === null) {
	                return _this.summarization.reset({ value: null, disabled: true });
	            }
	            else {
	                if (_this.defaultEnabled()) {
	                    _this.summarization.reset({ value: _this.summarizationDefault, disabled: false });
	                }
	                else {
	                    _this.summarization.reset({ value: null, disabled: false });
	                }
	            }
	        });
	        _this.summarization.valueChanges.subscribe(function () { return _this.resetTitle(); });
	        return _this;
	    }
	    Object.defineProperty(ColumnSelectionInputComponent.prototype, "target", {
	        get: function () {
	            return this._target;
	        },
	        set: function (columns) {
	            var _this = this;
	            if (columns) {
	                if (this._target && this._target.length > 0) {
	                    this.reset();
	                }
	                columns.forEach(function (v) {
	                    if (v.cardinality !== 1) {
	                        if (v.summarization !== _this.summarizationDefault) {
	                            _this.addIterator(v);
	                            v.membershipClass = "text-success";
	                        }
	                        else {
	                            v.membershipClass = "text-info";
	                        }
	                    }
	                });
	            }
	            this._target = columns;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ColumnSelectionInputComponent.prototype.resetTitle = function () {
	        var field = this.selectedOption.value;
	        if (field === null) {
	            this.columnTitle.reset("");
	        }
	        else {
	            var summarization = this.summarization.value;
	            if (summarization) {
	                this.columnTitle.reset(summarization + " of " + field);
	            }
	            else {
	                this.columnTitle.reset("" + field);
	            }
	        }
	    };
	    Object.defineProperty(ColumnSelectionInputComponent.prototype, "controlArray", {
	        set: function (c) {
	            var _this = this;
	            if (c instanceof forms_1.AbstractControl) {
	                if (this.sub) {
	                    this.sub.unsubscribe();
	                }
	                this.syncEnabledness(c);
	                this.sub = c.statusChanges.subscribe(function (v) { return _this.syncEnabledness(c); });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ColumnSelectionInputComponent.prototype.syncEnabledness = function (c) {
	        this.disabled = c.disabled;
	        if (c.disabled) {
	            this.summarization.disable();
	            this.selectedOption.disable();
	            this.selectedTarget.disable();
	        }
	        else {
	            this.summarization.enable();
	            this.selectedOption.enable();
	            this.selectedTarget.enable();
	        }
	    };
	    ColumnSelectionInputComponent.prototype.summarizationEnabled = function (numericalOnly) {
	        if (this.selectedOption.value) {
	            if (this.selectedOption.value.cardinality === 1) {
	                return false;
	            }
	            else {
	                return !numericalOnly || data_types_1.NumberTypes.has(this.selectedOption.value.type);
	            }
	        }
	        else {
	            return true;
	        }
	    };
	    ColumnSelectionInputComponent.prototype.defaultEnabled = function (selection) {
	        selection = selection || this.selectedOption.value;
	        if (selection) {
	            if (selection.cardinality === 1) {
	                return true;
	            }
	            else {
	                return ((this.uniqueIterators.has(this.iteratorFor(selection)))
	                    || (this.uniqueIterators.size < this.maxIterators));
	            }
	        }
	        else {
	            return true;
	        }
	    };
	    ColumnSelectionInputComponent.prototype.iteratorFor = function (item) {
	        if (item.table) {
	            return item.table;
	        }
	        else {
	            return "\u00AB" + item.name + "\u00BB";
	        }
	    };
	    ColumnSelectionInputComponent.prototype.reset = function () {
	        this.uniqueIterators.clear();
	        return _super.prototype.reset.call(this);
	    };
	    ColumnSelectionInputComponent.prototype.verifyAdd = function () {
	        var item = this.selectedOption.value;
	        if (item === null) {
	            return;
	        }
	        var i = this.options.indexOf(item);
	        if (i === -1) {
	            throw new Error("Could not find item in options: " + item);
	        }
	        if (this.summarization.invalid) {
	            alert(functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\t\tYou must select a summarization method for this field.\n\t\t\t\t(This may be due to selecting a list or table field and being\n\t\t\t\tbeyond your iterator limit.)"], ["\n\t\t\t\tYou must select a summarization method for this field.\n\t\t\t\t(This may be due to selecting a list or table field and being\n\t\t\t\tbeyond your iterator limit.)"]))));
	            return;
	        }
	        return item;
	    };
	    ColumnSelectionInputComponent.prototype.add = function (custom) {
	        var item = this.verifyAdd();
	        if (!item) {
	            return;
	        }
	        var summarization = this.summarization.value;
	        var addlProps = Object.assign({}, custom);
	        var matching = this.target.find(function (match) { return (match.name === item.name
	            && match.summarization === summarization); });
	        if (matching) {
	            return alert(functions_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\t\tYou already have <em>", "</em> as a column\n\t\t\t\twith summarization <code>", "</code>."], ["\n\t\t\t\tYou already have <em>", "</em> as a column\n\t\t\t\twith summarization <code>", "</code>."])), item.name, summarization.displayName));
	        }
	        if (summarization === this.summarizationDefault) {
	            if (item.cardinality !== 1) {
	                this.addIterator(item);
	            }
	        }
	        else {
	            addlProps.displayName = addlProps.displayName
	                || summarization.displayName + " of " + item.displayName;
	            addlProps.membershipClass = "text-success";
	        }
	        this.target.push(Object.assign({}, item, { summarization: summarization }, addlProps));
	        this.selectedOption.reset();
	        this.change.emit(this.target);
	    };
	    ColumnSelectionInputComponent.prototype.addAdvanced = function () {
	        var _this = this;
	        var variable = this.verifyAdd();
	        if (!variable) {
	            return;
	        }
	        utilities_1.ModalHelpers.observeCustom(this.modal, advanced_column_selection_modal_component_1.AdvancedColumnSelectionModalComponent, { size: "lg", variable: variable, filterVariables: this._source }).subscribe(function (custom) { return custom ? _this.add(custom) : null; });
	    };
	    ColumnSelectionInputComponent.prototype.edit = function () {
	        var _this = this;
	        var item = this.selectedTarget.value;
	        if (item === null) {
	            return;
	        }
	        utilities_1.ModalHelpers.observeCustom(this.modal, advanced_column_selection_modal_component_1.AdvancedColumnSelectionModalComponent, { size: "lg", variable: item, filterVariables: this._source }).subscribe(function (custom) {
	            if (custom) {
	                var i = _this.target.indexOf(item);
	                _this.target.splice(i, 1, Object.assign({}, item, custom));
	            }
	        });
	    };
	    ColumnSelectionInputComponent.prototype.addIterator = function (item) {
	        item.iterator = this.iteratorFor(item);
	        this.uniqueIterators.add(item.iterator);
	    };
	    ColumnSelectionInputComponent.prototype.removeIterator = function (item) {
	        if (!item.iterator) {
	            return;
	        }
	        if (!this.target.some(function (cmp) {
	            return cmp !== item && cmp.iterator === item.iterator;
	        })) {
	            this.uniqueIterators.delete(item.iterator);
	        }
	    };
	    ColumnSelectionInputComponent.prototype.remove = function () {
	        var item = this.selectedTarget.value;
	        if (item === null) {
	            return;
	        }
	        var i = this.target.indexOf(item);
	        if (i === -1) {
	            throw new Error("Could not find item in options: " + item);
	        }
	        this.removeIterator(item);
	        this.target.splice(i, 1);
	        this.selectedTarget.reset();
	        this.change.emit(this.target);
	    };
	    ColumnSelectionInputComponent.prototype.addAll = function () {
	        var _this = this;
	        this.options.forEach(function (opt) {
	            if (_this.defaultEnabled(opt)
	                && _this.target.find(function (match) {
	                    return (match.name === opt.name
	                        && match.summarization === summarization_1.DefaultSummarization);
	                }) === undefined) {
	                _this.target.push(Object.assign({}, opt, { summarization: summarization_1.DefaultSummarization }));
	                if (opt.cardinality !== 1) {
	                    _this.addIterator(opt);
	                }
	            }
	        });
	        this.selectedOption.reset();
	        this.change.emit(this.target);
	    };
	    ColumnSelectionInputComponent.prototype.move = function (delta) {
	        var item = this.selectedTarget.value;
	        if (!item) {
	            return;
	        }
	        var index = this.target.indexOf(item);
	        var finalPos = index + delta;
	        try {
	            functions_1.arraySwap(this.target, index, index + delta);
	            this.change.emit(this.target);
	        }
	        catch (err) {
	            return;
	        }
	    };
	    ColumnSelectionInputComponent.prototype.startDrag = function (e) {
	        console.log("Drag started:", e);
	    };
	    ColumnSelectionInputComponent.prototype.dragOver = function (e) {
	        console.log("Drag started:", e);
	    };
	    ColumnSelectionInputComponent.prototype.drop = function (e) {
	        console.log("Drag started:", e);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ColumnSelectionInputComponent.prototype, "maxIterators", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], ColumnSelectionInputComponent.prototype, "target", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.AbstractControl),
	        __metadata("design:paramtypes", [forms_1.AbstractControl])
	    ], ColumnSelectionInputComponent.prototype, "controlArray", null);
	    ColumnSelectionInputComponent = __decorate([
	        core_1.Component({
	            selector: "column-selection-input",
	            template: "\n<div class=\"row\">\n\t<div class=\"col-sm-5\">\n\t\t<label>\n\t\t\tAvailable columns\n\t\t\t<span class=\"badge\">{{options.length}}</span>\n\t\t</label>\n\t\t<select\n\t\t\t[size]=\"size()\"\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"selectedOption\"\n\t\t\t(keyup.enter)=\"add()\">\n\t\t\t<option *ngIf=\"!options?.length\" disabled>\n\t\t\t\t(empty)\n\t\t\t</option>\n\t\t\t<option\n\t\t\t\t*ngFor=\"let item of options\"\n\t\t\t\t[ngValue]=\"item\"\n\t\t\t\t[class]=\"item.membershipClass || ''\"\n\t\t\t\t[disabled]=\"item.membershipDisabled || false\"\n\t\t\t\t(dblclick)=\"add()\">\n\t\t\t\t{{item.displayName}}\n\t\t\t</option>\n\t\t</select>\n\t</div>\n\t<div class=\"col-sm-2 button-col\">\n\t\t<div class=\"form-group\">\n\t\t\t<label>Summarization</label>\n\t\t\t<select\n\t\t\t\t#available\n\t\t\t\tclass=\"form-control darker-disables\"\n\t\t\t\t[size]=\"summarizations.length + 1\"\n\t\t\t\t[formControl]=\"summarization\"\n\t\t\t\t(keyup.enter)=\"add()\">\n\t\t\t\t<option\n\t\t\t\t\t[disabled]=\"!defaultEnabled()\"\n\t\t\t\t\t(dblclick)=\"add()\"\n\t\t\t\t\t[ngValue]=\"summarizationDefault\">\n\t\t\t\t\t{{summarizationDefault.displayName}}\n\t\t\t\t</option>\n\t\t\t\t<option\n\t\t\t\t\t*ngFor=\"let s of summarizations\"\n\t\t\t\t\t[disabled]=\"!summarizationEnabled(s.numericalOnly)\"\n\t\t\t\t\t(dblclick)=\"add()\"\n\t\t\t\t\t[ngValue]=\"s\">\n\t\t\t\t\t{{s.displayName}}\n\t\t\t\t</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<table class=\"left-brace\">\n\t\t\t<tr>\n\t\t\t\t<td rowspan=\"3\" class=\"brace\">\n\t\t\t\t\t&#123;\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t\t(click)=\"add()\"\n\t\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\t\tAdd Column\n\t\t\t\t\t</button>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t(click)=\"addAdvanced()\"\n\t\t\t\t\t[disabled]=\"disabled\"\n\t\t\t\t\ttitle=\"Add with a custom name and/or a column filter...\">\n\t\t\t\t\tAdd Advanced...\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-warning\"\n\t\t\t\t\t(click)=\"addAll()\"\n\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\tAdd All\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t</table>\n\t\t<table class=\"right-brace\">\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t\t(click)=\"remove()\"\n\t\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\t\tRemove Column\n\t\t\t\t\t</button>\n\t\t\t\t</td>\n\t\t\t\t<td rowspan=\"5\" class=\"brace\">\n\t\t\t\t\t&#125;\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t(click)=\"edit()\"\n\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\tEdit...\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t(click)=\"move(-1)\"\n\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\tMove Up\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-default\"\n\t\t\t\t\t(click)=\"move(1)\"\n\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\tMove Down\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t\t<tr><td>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn-xs btn-danger\"\n\t\t\t\t\t(click)=\"reset()\"\n\t\t\t\t\t[disabled]=\"disabled\">\n\t\t\t\t\tReset\n\t\t\t\t</button>\n\t\t\t</td></tr>\n\t\t</table>\n\t\t<div class=\"iterator-list\">\n\t\t\t<label>\n\t\t\t\tRepetitions\n\t\t\t\t<span class=\"badge\">{{uniqueIterators.size}}</span>\n\t\t\t</label>\n\t\t\t<ul>\n\t\t\t\t<li *ngFor=\"let it of uniqueIterators\">\n\t\t\t\t\t{{it}}\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\t<div class=\"col-sm-5\">\n\t\t<label>\n\t\t\tSelected columns\n\t\t\t<span class=\"badge\">{{target.length}}</span>\n\t\t</label>\n\t\t<select\n\t\t\t#selected\n\t\t\t[size]=\"size()\"\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"selectedTarget\"\n\t\t\t(keyup.enter)=\"add()\"\n\t\t\t(keyup.delete)=\"remove()\"\n\t\t\t(keyup.backspace)=\"remove()\"\n\t\t\tdraggable=\"true\"\n\t\t\t(dragstart)=\"startDrag($event)\">\n\t\t\t<option *ngIf=\"!target?.length\" disabled>\n\t\t\t\t(empty)\n\t\t\t</option>\n\t\t\t<option\n\t\t\t\t*ngFor=\"let item of target\"\n\t\t\t\t[ngValue]=\"item\"\n\t\t\t\t[class]=\"item.membershipClass\"\n\t\t\t\t[disabled]=\"item.membershipDisabled\"\n\t\t\t\t(dblclick)=\"edit()\"\n\t\t\t\t(click)=\"$event.preventDefault()\"\n\t\t\t\tdraggable=\"true\"\n\t\t\t\t(dragstart)=\"startDrag($event)\"\n\t\t\t\t(dragover)=\"dragOver($event)\"\n\t\t\t\t(drop)=\"drop($event)\">\n\t\t\t\t{{item.displayName}}{{item.filter ? \" [filtered]\" : \"\"}}\n\t\t\t</option>\n\t\t</select>\n\t</div>\n</div>\n\t",
	            styles: ["\n\t\t.button-col {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t\t.button-col .form-group:first-of-type {\n\t\t\tmargin-top: 0;\n\t\t}\n\t\t.button-col button, .button-col table {\n\t\t\twidth: 100%;\n\t\t}\n\t\tselect.darker-disables option[disabled] {\n\t\t\tbackground: #eee;\n\t\t}\n\t\toption.special1 {\n\t\t\tfont-style: italic;\n\t\t\tcolor: var(--color-blue);\n\t\t}\n\t\toption.special2 {\n\t\t\tfont-style: italic;\n\t\t\tcolor: var(--color-green);\n\t\t}\n\t\t.iterator-list {\n\t\t\tmargin-top: 1.5em;\n\t\t}\n\t\t.iterator-list ul {\n\t\t\tpadding-left: 10px;\n\t\t}\n\t\ttd.brace {\n\t\t\tfont-size: 4.5em;\n\t\t\tline-height: 1.0;\n\t\t}\n\t\t.left-brace {\n\t\t\tmargin-left: -6px;\n\t\t}\n\t\t.right-brace {\n\t\t\tmargin-left: 6px;\n\t\t}\n\t\t.left-brace + .right-brace {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t\t.left-brace:hover .brace, .right-brace:hover .brace {\n\t\t\tcolor: #777;\n\t\t}\n\t"]
	        }),
	        __metadata("design:paramtypes", [bootstrap_1.Modal])
	    ], ColumnSelectionInputComponent);
	    return ColumnSelectionInputComponent;
	}(membership_input_component_1.MembershipInputComponent));
	exports.ColumnSelectionInputComponent = ColumnSelectionInputComponent;
	var templateObject_1, templateObject_2;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var filter_node_1 = __webpack_require__(900);
	var operators_1 = __webpack_require__(901);
	var AdvancedColumnSelectionModalComponent = (function () {
	    function AdvancedColumnSelectionModalComponent(dialog) {
	        this.dialog = dialog;
	        this.filter = null;
	        this.variable = dialog.context.variable;
	        this.filterVariables = dialog.context.filterVariables;
	        this.label = new forms_1.FormControl(this.variable.displayName);
	        if (this.variable.filter) {
	            this.filter = this.variable.filter;
	        }
	    }
	    AdvancedColumnSelectionModalComponent.prototype.submit = function () {
	        var out = {};
	        if (this.label.value) {
	            out.displayName = this.label.value;
	        }
	        if (this.filter) {
	            out.filter = this.filter;
	        }
	        this.dialog.close(out);
	    };
	    AdvancedColumnSelectionModalComponent.prototype.resetFilter = function () {
	        var opNode = new filter_node_1.OperatorNode(operators_1.Operators.get("all of"), [], true, this.filterVariables);
	        var eqNode = new filter_node_1.OperatorNode(operators_1.Operators.get("equals"), [], false, this.filterVariables);
	        opNode.addChild(0, eqNode);
	        eqNode.addChild(0, new filter_node_1.ArgumentNode(this.variable));
	        this.filter = opNode;
	    };
	    AdvancedColumnSelectionModalComponent = __decorate([
	        core_1.Component({
	            template: "\n<div class=\"modal-header\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\t(click)=\"dialog.dismiss()\"\n\t\taria-label=\"Close\">\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n\t<h3 class=\"capitalized modal-title\">\n\t\t\tAdvanced Column Creator\n\t</h3>\n</div>\n\n<div class=\"modal-body\">\n\t<div class=\"form-group\">\n\t\t<label>Custom column label</label>\n\t\t<input\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\t[formControl]=\"label\">\n\t</div>\n\t<div *ngIf=\"variable.cardinality === 1\">\n\t\t<label>Filter</label>\n\t\t<p>\n\t\t\t<em>\n\t\t\t\t(Collection filters can only be attached to columns whose values are\n\t\t\t\tlists or sets.)\n\t\t\t</em>\n\t\t</p>\n\t</div>\n\t<div *ngIf=\"variable.cardinality !== 1\">\n\t\t<label>\n\t\t\tFilter\n\t\t\t<span class=\"btn-group\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-default btn-xs\"\n\t\t\t\t\t(click)=\"resetFilter()\">\n\t\t\t\t\t{{filter === null ? \"Create Filter\" : \"Reset Filter\"}}\n\t\t\t\t</button>\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-danger btn-xs\"\n\t\t\t\t\t(click)=\"filter = null\"\n\t\t\t\t\t[disabled]=\"filter === null\">\n\t\t\t\t\tRemove Filter\n\t\t\t\t</button>\n\t\t\t</span>\n\t\t</label>\n\t\t<simple-filter-node\n\t\t\t*ngIf=\"filter !== null\"\n\t\t\t[node]=\"filter\"\n\t\t\t[variables]=\"filterVariables\"\n\t\t\t[skipText]=\"true\"\n\t\t\t[forCollection]=\"variable\">\n\t\t</simple-filter-node>\n\t\t<p *ngIf=\"filter === null\"><em>No filter.</em></p>\n\t</div>\n</div>\n\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-default\"\n\t\t(click)=\"dialog.dismiss()\">\n\t\tCancel\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t(click)=\"submit()\">\n\t\tOK\n\t</button>\n</div>\n\t",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], AdvancedColumnSelectionModalComponent);
	    return AdvancedColumnSelectionModalComponent;
	}());
	exports.AdvancedColumnSelectionModalComponent = AdvancedColumnSelectionModalComponent;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var user_service_1 = __webpack_require__(713);
	var aggregation_service_1 = __webpack_require__(809);
	var data_export_1 = __webpack_require__(904);
	var toolbox_task_component_1 = __webpack_require__(908);
	var filter_node_1 = __webpack_require__(900);
	var operators_1 = __webpack_require__(901);
	var modal_service_1 = __webpack_require__(837);
	var DataExportTaskComponent = (function (_super) {
	    __extends(DataExportTaskComponent, _super);
	    function DataExportTaskComponent(service, modals, users) {
	        var _this = _super.call(this, service, modals) || this;
	        _this.service = service;
	        _this.modals = modals;
	        _this.users = users;
	        return _this;
	    }
	    Object.defineProperty(DataExportTaskComponent.prototype, "simpleFilter", {
	        get: function () {
	            return (this.task
	                && this.task.filter
	                && this.task.filter instanceof filter_node_1.OperatorNode
	                && this.task.filter.operator instanceof operators_1.ClientOnlyMultiAnd);
	        },
	        set: function (_) { },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DataExportTaskComponent.prototype, "maxIterators", {
	        get: function () {
	            return ((this.task.parent.allowsInlining
	                || !this.task.parent.useRecordRepetition)
	                ? Number.MAX_SAFE_INTEGER : 1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DataExportTaskComponent.prototype.processColumns = function () {
	        console.log(this.task.columns);
	        this.task.columns = this.task.columnSelection.map(function (v) { return Object.assign({
	            name: v.name,
	            columnName: (v.displayName || ""),
	            summarization: (v.summarization ? v.summarization.name : "none")
	        }, v.filter ? {
	            filterTree: v.filter.marshal()
	        } : {}); });
	    };
	    DataExportTaskComponent.prototype.run = function () {
	        if (this.task.columnSelection.length === 0) {
	            return alert("You must add at least one column to your export");
	        }
	        if (this.task.parent.customizableCollectionDelimiter
	            && this.task.delimiterControl.invalid) {
	            return alert("You must provide a value for the list delimiter");
	        }
	        this.processColumns();
	        if (this.task.isComplete) {
	            this.task.clearProgress();
	        }
	        this.service.run(this.task);
	    };
	    DataExportTaskComponent.prototype.duplicate = function () {
	        this.service.duplicateExport(this.task);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", data_export_1.DataExport)
	    ], DataExportTaskComponent.prototype, "task", void 0);
	    DataExportTaskComponent = __decorate([
	        core_1.Component({
	            selector: "export-task",
	            template: "\n<div\n    #panel\n    class=\"panel panel-default\">\n    <div class=\"panel-heading\" (click)=\"panel.closed = !panel.closed\">\n        <h3 class=\"panel-title\">\n            <span\n                class=\"glyphicon\"\n                [class.glyphicon-expand]=\"panel.closed\"\n                [class.glyphicon-collapse-down]=\"!panel.closed\">\n            </span>\n            <a\n                title=\"Rename this query...\"\n                (click)=\"$event.stopPropagation(); renameTask()\">\n                {{task.title}}\n            </a>\n            <small>\n                (algorithm:\n                <span class=\"text-success\">{{task.algorithm}}</span>,\n                group:\n                <span class=\"text-info\">{{task.group}}</span>)\n            </small>\n            <button\n                type=\"button\"\n                class=\"btn btn-xs btn-danger pull-right\"\n                (click)=\"release()\">\n                Remove\n            </button>\n        </h3>\n    </div>\n    <div class=\"panel-body collapse\" [class.in]=\"!panel.closed\">\n        <h4>Options</h4>\n        <div *ngIf=\"true || !task.isStarted\" class=\"form-group\">\n            <template [ngIf]=\"!task.isStarted\">\n            <p>\n                Use the boxes below to add columns to your exported\n                dataset. Only the variables you select will be shown in the\n                final data.\n            </p>\n            <p>\n                When adding a variable whose value is a list or part of a\n                table, you must select a <em>summarization method</em>. By\n                selecting <code>none</code>, the members of that list or\n                table will be repeated, either within a single cell using\n                a text delimiter, or in duplicate rows. (This export type will\n                do the {{ task.parent.allowsInlining ? \"former\" : \"latter\"}}.)\n                The other values will cause the export to run that calculation\n                over all members of the list. As such, the <code>sum</code> and\n                <code>average</code> summarizations can only be used on numeric\n                data.\n            </p>\n            </template>\n            <column-selection-input\n                [source]=\"task.columnOptions\"\n                [target]=\"task.columnSelection\"\n                [optionsSorted]=\"true\"\n                [maxIterators]=\"maxIterators\"\n                [controlArray]=\"task.membershipControl\">\n            </column-selection-input>\n        </div>\n        <div *ngIf=\"false && task.isStarted\" class=\"form-group\">\n            <label>\n                Columns\n                <span class=\"badge\">{{task.columns.length}}</span>\n            </label>\n            <div class=\"row\">\n                <div\n                    *ngFor=\"let cols of task.columns | segments:4\"\n                    class=\"col-sm-3\">\n                    <ul>\n                        <li *ngFor=\"let col of cols\">\n                            {{col.columnName || col.name}}\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Column settings:</label>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'headers' + task.id\"\n                                [value]=\"true\"\n                                [formControl]=\"task.headersControl\"\n                                checked>\n                            Use column headers\n                        </label>\n                    </div>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'headers' + task.id\"\n                                [value]=\"false\"\n                                [formControl]=\"task.headersControl\">\n                            No headers (start with data)\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Timestamp format:</label>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'date' + task.id\"\n                                [value]=\"true\"\n                                [formControl]=\"task.excelDatesControl\"\n                                checked>\n                            Date only (Excel-compliant)\n                        </label>\n                    </div>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'date' + task.id\"\n                                [value]=\"false\"\n                                [formControl]=\"task.excelDatesControl\">\n                            Full ISO-8601 timestamp\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Collection filter behavior:</label>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'collFilterBehavior' + task.id\"\n                                [value]=\"true\"\n                                [formControl]=\"task.dropCollFilterEmptiesControl\"\n                                checked>\n                            Remove records that have no matching collection entries \n                        </label>\n                    </div>\n                    <div class=\"radio\">\n                        <label>\n                            <input\n                                type=\"radio\"\n                                [name]=\"'collFilterBehavior' + task.id\"\n                                [value]=\"false\"\n                                [formControl]=\"task.dropCollFilterEmptiesControl\">\n                            Keep all records (collection filters will only remove sub-entries)\n                        </label>\n                    </div>\n                </div>\n            </div>\n\n            <!-- at col-4, this is the start of the 2nd row -->\n            <div\n                *ngIf=\"task.parent?.customizableCollectionDelimiter || true\"\n                class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Custom delimiter:</label>\n                    <input\n                        type=\"text\"\n                        class=\"form-control\"\n                        [formControl]=\"task.delimiterControl\">\n                </div>\n            </div>\n            <div class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Execution note (optional):</label>\n                    <input\n                        type=\"text\"\n                        class=\"form-control\"\n                        [formControl]=\"task.labelControl\">\n                </div>\n            </div>\n            <div class=\"col-sm-4\">\n                <div class=\"form-group\">\n                    <label>Target:</label>\n                    <div class=\"form-control\" disabled>\n                        {{task.algorithm}} on {{task.group}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div\n            *ngIf=\"!(task.isStarted && task.filter === null)\"\n            class=\"form-group\">\n            <label class=\"h3\">\n                Filter\n            </label>\n            <span class=\"btn-group\">\n                <button\n                    *ngIf=\"!task.isStarted\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-default\"\n                    (click)=\"resetFilter(true)\"\n                    [disabled]=\"task.isStarted\">\n                    {{task.filter === null ? \"Create\" :\n                        (simpleFilter ? \"Reset\" : \"Reset in simple mode\")}}\n                </button>\n                <button\n                    *ngIf=\"!task.isStarted\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-info\"\n                    (click)=\"resetFilter()\"\n                    [disabled]=\"task.isStarted\">\n                    {{task.filter === null ? \"Create Advanced\" :\n                        (simpleFilter ? \"Reset in advanced mode\" : \"Reset\")}}\n                </button>\n                <button\n                    *ngIf=\"!task.isStarted && task.filter !== null\"\n                    type=\"button\"\n                    class=\"btn btn-xs btn-danger\"\n                    (click)=\"removeFilter()\"\n                    [disabled]=\"task.isStarted\">\n                    Remove\n                </button>\n            </span>\n            <filter-node\n                *ngIf=\"task.filter !== null && !task.isStarted && !simpleFilter\"\n                [node]=\"task.filter\"\n                [variables]=\"task.filterOptions\"\n                [root]=\"true\">\n            </filter-node>\n            <simple-filter-node\n                *ngIf=\"task.filter !== null && !task.isStarted && simpleFilter\"\n                [node]=\"task.filter\"\n                [variables]=\"task.filterOptions\">\n            </simple-filter-node>\n            <div\n                style=\"margin-left: 2em\"\n                *ngIf=\"task.filterString\"\n                [innerHtml]=\"task.filterString\">\n            </div>\n        </div>\n        \n        <!-- ACTIONS BAR -->\n        <div class=\"row\">\n            <div class=\"col-sm-4\">\n                <button\n                    class=\"btn btn-success p100\"\n                    (click)=\"run()\"\n                    [disabled]=\"task.isStarted && !task.isComplete\">\n                    <span\n                        class=\"glyphicon\"\n                        [class.glyphicon-play]=\"!task.isComplete\"\n                        [class.glyphicon-repeat]=\"task.isComplete\">\n                    </span>\n                    {{ task.isComplete ? \"Re-run\" : \"Run\" }}\n                </button>\n            </div>\n            <div class=\"col-sm-4\">\n                <button\n                    *ngIf=\"!task.isPaused\"\n                    class=\"btn btn-info p100\"\n                    (click)=\"pause(true)\"\n                    [disabled]=\"!task.isRunning\">\n                    <span class=\"glyphicon glyphicon-pause\"></span>\n                    Pause\n                </button>\n                <button\n                    *ngIf=\"task.isPaused\"\n                    class=\"btn btn-info p100\"\n                    (click)=\"pause(false)\">\n                    <span class=\"glyphicon glyphicon-step-forward\"></span>\n                    Resume\n                </button>\n            </div>\n            <div class=\"col-sm-4\">\n                <button\n                    class=\"btn btn-danger p100\"\n                    (click)=\"cancel()\"\n                    [disabled]=\"!(task.isRunning || task.isPaused)\">\n                    <span class=\"glyphicon glyphicon-remove\"></span>\n                    Cancel\n                </button>\n            </div>\n            <!--<button\n                class=\"btn btn-default\"\n                (click)=\"getProgress()\"\n                [disabled]=\"task.isComplete || !task.isStarted\">\n                <span class=\"glyphicon glyphicon-tasks\"></span>\n                Request Progress\n            </button>-->\n            <div class=\"col-sm-6\">\n                <button\n                    class=\"btn btn-default p100\"\n                    (click)=\"saveSchema()\"\n                    [disabled]=\"!task.isComplete\">\n                    <span class=\"glyphicon glyphicon-pushpin\"></span>\n                    Save as Template\n                </button>\n            </div>\n            <div class=\"col-sm-6\">\n                <button\n                    class=\"btn btn-default p100\"\n                    (click)=\"duplicate()\"\n                    [disabled]=\"false\">\n                    <span class=\"glyphicon glyphicon-copy\"></span>\n                    Duplicate\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <div\n        *ngIf=\"task.isStarted\"\n        class=\"panel-body collapse\"\n        [class.in]=\"!panel.closed\">\n        <task-progress [task]=\"task\"></task-progress>\n    </div>\n\n    <div\n        *ngIf=\"task.isComplete\"\n        class=\"panel-body collapse reports\"\n        [class.in]=\"!panel.closed\">\n        <h3>Results</h3>\n        <div class=\"row\">\n            <template [ngIf]=\"task.downloadFile\">\n                <div class=\"col-md-3 col-sm-6\">\n                    <label>File MIME type</label>\n                    <p>{{task.downloadFile.type}}</p>\n                </div>\n                <div class=\"col-md-3 col-sm-6\">\n                    <label>File bytes</label>\n                    <p>{{task.downloadFile.file.size | bytes}}</p>\n                    <p\n                        *ngIf=\"users.debugMode && (task.downloadFile.file.size !== task.expectedFilesize)\"\n                        class=\"debug-only text-danger\">\n                        {{task.expectedFilesize | bytes}} expected\n                    </p>\n                </div>\n                <div *ngIf=\"users.debugMode\" class=\"col-md-3 col-sm-6 debug-only\">\n                    <label>Buffer count</label>\n                    <p>\n                        {{task.downloadFile.bufferCount}}\n                        <span\n                            [class.text-danger]=\"task.downloadFile.emptyCount\">\n                            (+{{task.downloadFile.emptyCount}} empty)\n                        </span>\n                    </p>\n                </div>\n                <div *ngIf=\"users.debugMode\" class=\"col-md-3 col-sm-6 debug-only\">\n                    <label>File checksum</label>\n                    <p>{{task.checksumHex}}</p>\n                </div>\n            </template>\n            <template [ngIf]=\"task.downloadURL\">\n                <div class=\"col-sm-6\">\n                    <label>Filename:</label>\n                    <input\n                        type=\"text\"\n                        class=\"form-control\"\n                        [formControl]=\"task.filenameControl\">\n                </div>\n                <div class=\"col-sm-6\">\n                    <a\n                        class=\"btn btn-success p100 align-with-labels\"\n                        [href]=\"task.downloadSafeURL\"\n                        [download]=\"task.getDownloadName()\"\n                        [class.disabled]=\"task.filenameControl.invalid\">\n                        <span class=\"glyphicon glyphicon-save\"></span>\n                        Download Export File\n                    </a>\n                </div>\n            </template>\n        </div>\n    </div>\n</div>\n    ",
	            styles: [
	                "\n        .single-result th, .single-result td {\n            font-size: 1.6em;\n        }\n        .panel-body + .panel-body {\n            border-top: 1px solid #ddd;\n        }\n        .panel h3, .panel h4 {\n            margin-top: 0;\n        }\n        .frequency-report table {\n            padding: 10px;\n            margin: auto;\n        }\n        .reports td, .reports th {\n            text-align: center;\n        }\n        .context-result th, .context-result h4 {\n            text-transform: capitalize;\n        }\n        .btn-group {\n            vertical-align: text-bottom;\n        }\n        "
	            ]
	        }),
	        __metadata("design:paramtypes", [aggregation_service_1.AggregationService,
	            modal_service_1.ModalService,
	            user_service_1.UserService])
	    ], DataExportTaskComponent);
	    return DataExportTaskComponent;
	}(toolbox_task_component_1.ToolboxTaskComponent));
	exports.DataExportTaskComponent = DataExportTaskComponent;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var filter_node_1 = __webpack_require__(900);
	var FilterNodeComponent = (function () {
	    function FilterNodeComponent() {
	    }
	    FilterNodeComponent.prototype.isOperator = function (node) {
	        return node.nodeType === "expression";
	    };
	    FilterNodeComponent.prototype.opNames = function () {
	        return this.node.availableOperators.map(function (op) { return op.name; });
	    };
	    FilterNodeComponent.prototype.signatures = function () {
	        var _this = this;
	        if (!this.isOperator(this.node)) {
	            throw new Error("Cannot compute signatures for non-op nodes");
	        }
	        if (this.node.operator.isBinary()) {
	            return this.node.operator.signature.filter(function (sig) {
	                if (_this.node.operands[0]) {
	                }
	            });
	        }
	        else {
	            throw new Error("UNIMPLEMENTED CASE");
	        }
	    };
	    FilterNodeComponent.prototype.isFinalOperator = function () {
	        if (!this.isOperator(this.node)) {
	            return false;
	        }
	        return this.node.operands.every(function (node) { return !(node instanceof filter_node_1.OperatorNode); });
	    };
	    FilterNodeComponent.prototype.af = function (ob) {
	        if (!ob) {
	            return null;
	        }
	        else {
	            return Array.from(ob);
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], FilterNodeComponent.prototype, "root", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", filter_node_1.FilterNode)
	    ], FilterNodeComponent.prototype, "node", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], FilterNodeComponent.prototype, "returns", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], FilterNodeComponent.prototype, "variables", void 0);
	    FilterNodeComponent = __decorate([
	        core_1.Component({
	            selector: "filter-node",
	            template: "\n<div [class]=\"'group group' + node.depth + (isFinalOperator() ? ' final' : '')\">\n<template [ngIf]=\"node && isOperator(node)\">\n    <!-- horizontal operator -->\n    <table class=\"operator\" *ngIf=\"isFinalOperator()\">\n        <!--<tr>\n            <td colspan=\"3\">\n                {{node.depth}}\n            </td>\n        </tr>-->\n        <tr>\n            <td *ngIf=\"node.operands.length !== 2\">\n                <div>\n                    <label>Expression</label>\n                    <button\n                        [disabled]=\"!node.parent\"\n                        type=\"button\"\n                        class=\"btn btn-xs btn-warning pull-right\"\n                        (click)=\"node.revert()\">\n                        change type\n                    </button>\n                </div>\n                <select\n                    [formControl]=\"node.operatorControl\"\n                    class=\"form-control operatorControl\">\n                    <option disabled [ngValue]=\"null\">\n                        -- Select operator --\n                    </option>\n                    <option\n                        *ngFor=\"let op of node.availableOperators\"\n                        [value]=\"op.name\"\n                        [disabled]=\"!op.userSelectable\">\n                        {{op.name}}\n                    </option>\n                </select>\n            </td>\n            <td *ngIf=\"node.operands.length > 0\">\n                <filter-node [node]=\"node.operands[0]\">\n                </filter-node>\n            </td>\n            <td *ngIf=\"node.operands.length === 2\">\n                <div>\n                    <label>Expression</label>\n                    <button\n                        [disabled]=\"!node.parent\"\n                        type=\"button\"\n                        class=\"btn btn-xs btn-warning pull-right\"\n                        (click)=\"node.revert()\">\n                        change type\n                    </button>\n                </div>\n                <select\n                    [formControl]=\"node.operatorControl\"\n                    class=\"form-control operatorControl\">\n                    <option disabled [ngValue]=\"null\">\n                        -- Select operator --\n                    </option>\n                    <option\n                        *ngFor=\"let op of node.availableOperators\"\n                        [value]=\"op.name\"\n                        [disabled]=\"!op.userSelectable\">\n                        {{op.name}}\n                    </option>\n                </select>\n            </td>\n            <td *ngFor=\"let operand of node.operands | slice:1\">\n                <filter-node [node]=\"operand\">\n                </filter-node>\n            </td>\n    </table>\n    <table class=\"operator\" *ngIf=\"!isFinalOperator()\">\n        <!--<tr>\n            <td rowspan=\"3\">\n                {{node.depth}}\n            </td>\n        </tr>-->\n        <tr *ngIf=\"node.operands.length !== 2\">\n            <td>\n                <div>\n                    <label>Expression</label>\n                    <button\n                        [disabled]=\"!node.parent\"\n                        type=\"button\"\n                        class=\"btn btn-xs btn-warning pull-right\"\n                        (click)=\"node.revert()\">\n                        change type\n                    </button>\n                </div>\n                <select\n                    [formControl]=\"node.operatorControl\"\n                    class=\"form-control operatorControl\">\n                    <option disabled [ngValue]=\"null\">\n                        -- Select operator --\n                    </option>\n                    <option\n                        *ngFor=\"let op of node.availableOperators\"\n                        [value]=\"op.name\"\n                        [disabled]=\"!op.userSelectable\">\n                        {{op.name}}\n                    </option>\n                </select>\n            </td>\n        </tr>\n        <tr>\n            <td *ngIf=\"node.operands.length > 0\">\n                <filter-node [node]=\"node.operands[0]\">\n                </filter-node>\n            </td>\n        </tr>\n        <tr *ngIf=\"node.operands.length === 2\">\n            <td>\n                <div>\n                    <label>Expression</label>\n                    <button\n                        [disabled]=\"!node.parent\"\n                        type=\"button\"\n                        class=\"btn btn-xs btn-warning pull-right\"\n                        (click)=\"node.revert()\">\n                        change type\n                    </button>\n                </div>\n                <select\n                    [formControl]=\"node.operatorControl\"\n                    class=\"form-control operatorControl\">\n                    <option disabled [ngValue]=\"null\">\n                        -- Select operator --\n                    </option>\n                    <option\n                        *ngFor=\"let op of node.availableOperators\"\n                        [value]=\"op.name\"\n                        [disabled]=\"!op.userSelectable\">\n                        {{op.name}}\n                    </option>\n                </select>\n            </td>\n        </tr>\n        <tr *ngFor=\"let operand of node.operands | slice:1\">\n            <td>\n                <filter-node [node]=\"operand\">\n                </filter-node>\n            </td>\n        </tr>\n    </table>\n</template>\n\n<div *ngIf=\"node?.nodeType === 'variable'\" class=\"state-variable\">\n    <div>\n        <label>Variable</label>\n        <button\n            type=\"button\"\n            class=\"btn btn-xs btn-warning pull-right\"\n            (click)=\"node.revert()\">\n            change type\n        </button>\n    </div>\n    <select\n        [formControl]=\"node.variableControl\"\n        class=\"form-control\">\n        <option disabled [ngValue]=\"null\">-- Select variable --</option>\n        <option *ngFor=\"let sv of node.filteredVariables\" [value]=\"sv.name\">\n            {{sv.displayName || sv.name}}\n        </option>\n    </select>\n</div>\n\n<table *ngIf=\"node?.nodeType === 'value'\" class=\"constant\">\n    <tr>\n        <td colspan=\"2\">\n            <label>Value</label>\n            <button\n                type=\"button\"\n                class=\"btn btn-xs btn-warning pull-right\"\n                (click)=\"node.revert()\"\n                [disabled]=\"node.parent?._childValueRestrictions\">\n                change type\n            </button>\n        </td>\n    </tr>\n    <tr>\n        <td>\n            <div class=\"form-group\">\n                <select\n                    class=\"form-control constTypeSelector\"\n                    [formControl]=\"node.typeControl\">\n                    <option [ngValue]=\"null\">\n                        -- Select a type --\n                    </option>\n                    <option\n                        *ngFor=\"let type of node.allowedTypes\"\n                        [value]=\"type\">\n                        {{type}}\n                    </option>\n                </select>\n            </div>\n        </td>\n        <td *ngIf=\"node.type\">\n            <typed-control\n                [input]=\"node\"\n                [control]=\"node.valueControl\"\n                [iconTray]=\"false\"\n                [clearButton]=\"false\"\n                [validationTray]=\"false\">\n            </typed-control>\n        </td>\n    </tr>\n</table>\n\n<div *ngIf=\"node !== null && node.nodeType === null\" class=\"undefined\">\n    <div>\n        <label class=\"text-danger\">New node</label>\n        <button\n            type=\"button\"\n            class=\"btn btn-xs btn-warning pull-right\"\n            disabled>\n            change type\n        </button>\n    </div>\n    <select class=\"form-control\" [formControl]=\"node.typeControl\">\n        <option [ngValue]=\"null\" disabled>-- select new node type --</option>\n        <option>variable</option>\n        <option>value</option>\n        <option>expression</option>\n    </select>\n</div>\n\n<div *ngIf=\"!node\">\n\t<em class=\"text-danger\">No filter node found.</em>\n</div>\n</div>\n    ",
	            styles: ["\n        table {\n            width: 100%;\n        }\n        table td {\n            /* border: 1px solid #ccc; */\n            padding: 2px 5px;\n        }\n        .constant {\n            margin-top: 13px;\n        }\n        table.constant td {\n            padding: 0px;\n        }\n        .group1 {\n            border-left: 2px solid black;\n        }\n        .final {\n            border-right: 2px solid black;\n        }\n        .group2 {\n            border-left: 2px solid blue;\n        }\n        .group3 {\n            border-left: 2px solid green;\n        }\n        .group {\n            border-radius: 5px;\n            padding-left: 5px;\n        }\n        .operatorControl {\n            font-style: italic;\n            color: var(--color-green)\n        }\n        .revert {\n            width: 100%;\n        }\n    "]
	        })
	    ], FilterNodeComponent);
	    return FilterNodeComponent;
	}());
	exports.FilterNodeComponent = FilterNodeComponent;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var filter_node_1 = __webpack_require__(900);
	var operators_1 = __webpack_require__(901);
	var SimpleFilterNodeComponent = (function () {
	    function SimpleFilterNodeComponent() {
	        this.skipText = false;
	        this.readablesCache = new WeakMap();
	        this.validRootOperators = new Set([
	            operators_1.Operators.get("all of")
	        ]);
	    }
	    SimpleFilterNodeComponent.prototype.readableFor = function (node) {
	        if (!this.readablesCache.has(node)) {
	            this.readablesCache.set(node, node.toReadable());
	        }
	        return this.readablesCache.get(node);
	    };
	    SimpleFilterNodeComponent.prototype.isValidRoot = function (node) {
	        return (node.nodeType === "expression"
	            && this.validRootOperators.has(node.operator));
	    };
	    SimpleFilterNodeComponent.prototype.isValidClause = function (node) {
	        if ((node.nodeType === "expression" && node.operator)
	            && (node.left &&
	                (node.left.nodeType === "variable"
	                    || (this.forCollection && node.left.nodeType === "argument")))) {
	            if (node.operator.isBinary() && node.right) {
	                if (node.right.nodeType !== "value") {
	                    node.addChild(1, new filter_node_1.ConstantNode());
	                }
	                return true;
	            }
	            return node.operator.isUnary();
	        }
	    };
	    SimpleFilterNodeComponent.prototype.addClause = function () {
	        if (!this.isValidRoot(this.node)) {
	            throw new Error("Cannot add clause when root is not simple filter!");
	        }
	        if (this.forCollection) {
	            var eqNode = filter_node_1.OperatorNode.BasicEquality(this.node.allowedVariables, false);
	            eqNode.addChild(0, new filter_node_1.ArgumentNode(this.forCollection));
	            this.node.addChild(this.node.operands.length, eqNode);
	        }
	        else {
	            this.node.addChild(this.node.operands.length, filter_node_1.OperatorNode.BasicEquality(this.node.allowedVariables, false));
	        }
	    };
	    SimpleFilterNodeComponent.prototype.revertToVariable = function (clause) {
	        clause.addChild(0, new filter_node_1.VariableNode());
	    };
	    SimpleFilterNodeComponent.prototype.opNames = function () {
	        return this.node.availableOperators.map(function (op) { return op.name; });
	    };
	    SimpleFilterNodeComponent.prototype.af = function (ob) {
	        if (!ob) {
	            return null;
	        }
	        else {
	            return Array.from(ob);
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", filter_node_1.FilterNode)
	    ], SimpleFilterNodeComponent.prototype, "node", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], SimpleFilterNodeComponent.prototype, "variables", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], SimpleFilterNodeComponent.prototype, "skipText", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], SimpleFilterNodeComponent.prototype, "forCollection", void 0);
	    SimpleFilterNodeComponent = __decorate([
	        core_1.Component({
	            selector: "simple-filter-node",
	            template: "\n<div>\n<template [ngIf]=\"isValidRoot(node)\">\n    <!-- TODO: selector for alternative values -->\n    <p class=\"intro\" *ngIf=\"!skipText\">\n        In <em>simple</em> mode, the filter is constructed out of a number of\n        \"subfilters\" limited to the format <code>variable operator value</code>.\n        All of the subfilters must be true for the record to be a match (as if\n        each expression were linked with an <kbd>and</kbd>). For more\n        complicated expressions such as <kbd>or</kbd> conditions and arithmetic,\n        you must use <em>advanced</em> mode.\n    </p>\n    <table>\n        <thead>\n            <th></th>\n            <th>Variable</th>\n            <th>Operator</th>\n            <th>Value</th>\n        </thead>\n        <tbody>\n            <tr *ngFor=\"let clause of node.operands; let i = index\">\n\t\t\t\t\t\t\t\t<td>{{i + 1}}</td>\n                <template [ngIf]=\"isValidClause(clause)\">\n                    <td *ngIf=\"clause.left.nodeType == 'variable'\">\n                        <select\n                            [formControl]=\"clause.left.variableControl\"\n                            class=\"form-control\">\n                            <option disabled [ngValue]=\"null\">\n                                -- Select variable --\n                            </option>\n                            <option\n                                *ngFor=\"let sv of clause.left.filteredVariables\"\n                                [value]=\"sv.name\">\n                                {{sv.displayName || sv.name}}\n                            </option>\n                        </select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td *ngIf=\"clause.left.nodeType == 'argument'\">\n\t\t\t\t\t\t\t\t\t\t\t<em>\n\t\t\t\t\t\t\t\t\t\t\t\t(item of \n\t\t\t\t\t\t\t\t\t\t\t\t<kbd>{{this.forCollection.displayName}}</kbd>\n\t\t\t\t\t\t\t\t\t\t\t\tlist)\n\t\t\t\t\t\t\t\t\t\t\t</em>\n\t\t\t\t\t\t\t\t\t\t\t<!--<button\n\t\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-default btn-xs\"\n\t\t\t\t\t\t\t\t\t\t\t\t(click)=\"revertToVariable(clause)\">\n\t\t\t\t\t\t\t\t\t\t\t\tRevert to variable\n\t\t\t\t\t\t\t\t\t\t\t</button>-->\n\t\t\t\t\t\t\t\t\t\t</td>\n                    <td>\n                        <select\n                            [formControl]=\"clause.operatorControl\"\n                            class=\"form-control operatorControl\">\n                            <option disabled [ngValue]=\"null\">\n                                -- Select operator --\n                            </option>\n                            <option\n                                *ngFor=\"let op of clause.availableOperators\"\n                                [value]=\"op.name\"\n                                [disabled]=\"!op.userSelectable\">\n                                {{op.name}}\n                            </option>\n                        </select>\n                    </td>\n                    <td>\n                        <typed-control\n                            *ngIf=\"clause.right && clause.right.type\"\n                            [input]=\"clause.right\"\n                            [control]=\"clause.right.valueControl\"\n                            class=\"constantControl\"\n                            [iconTray]=\"false\"\n                            [clearButton]=\"false\"\n                            [validationTray]=\"false\">\n                        </typed-control>\n                        <input\n                            *ngIf=\"clause.right && !clause.right.type\"\n                            type=\"text\"\n                            class=\"form-control\"\n                            disabled>\n                        <em *ngIf=\"!clause.right\">N/A</em>\n                    </td>\n                </template>\n                <td colspan=\"3\" *ngIf=\"!isValidClause(clause)\">\n                    <p class=\"text-danger\">\n                        (this node cannot be used with the simple editor)\n                    </p>\n                    <p [innerHTML]=\"readableFor(clause)\"></p>\n                </td>\n            </tr>\n            <tr>\n                <td>{{node.operands.length + 1}}</td>\n                <td colspan=\"3\">\n                    <button\n                        class=\"btn btn-default p100\"\n                        (click)=\"addClause()\">\n                        Add Sub-filter\n                    </button>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</template>\n\n<div *ngIf=\"!isValidRoot(node)\" class=\"text-danger\">\n    <p class=\"text-danger\">(this node cannot be used with the simple editor)</p>\n    <p [innerHTML]=\"readableFor(node)\"></p>\n</div>\n\n</div>\n    ",
	            styles: ["\n        .intro {margin-top: 10px;}\n        table {\n            width: 100%;\n        }\n        table td {\n            /* border: 1px solid #ccc; */\n            padding: 2px 5px;\n        }\n        .constant {\n            margin-top: 13px;\n        }\n        table.constant td {\n            padding: 0px;\n        }\n        .operatorControl {\n            font-style: italic;\n            color: var(--color-green)\n        }\n        .constantControl >>> .form-group {\n            margin-bottom: 0px;\n        }\n        .revert {\n            width: 100%;\n        }\n    "]
	        })
	    ], SimpleFilterNodeComponent);
	    return SimpleFilterNodeComponent;
	}());
	exports.SimpleFilterNodeComponent = SimpleFilterNodeComponent;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var toolbox_activity_1 = __webpack_require__(902);
	var TaskProgressComponent = (function () {
	    function TaskProgressComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", toolbox_activity_1.ToolboxActivity)
	    ], TaskProgressComponent.prototype, "task", void 0);
	    TaskProgressComponent = __decorate([
	        core_1.Component({
	            selector: "task-progress",
	            template: "\n<h3>Progress</h3>\n<div class=\"progress\">\n    <div\n        *ngIf=\"task.isScheduled\"\n        class=\"progress-bar progress-bar-striped active\"\n        style=\"width: 100%\">\n        <span>evaluating...</span>\n    </div>\n    <div\n        *ngIf=\"task.isComplete && task.population === 0\"\n        class=\"progress-bar progress-bar-disabled\"\n        style=\"width: 100%\">\n        <span>The group-algorithm pair you selected had no records.</span>\n    </div>\n\n    <div\n        class=\"progress-bar progress-bar-danger\"\n        [style.width]=\"100*task.unanswered/task.population + '%'\"\n        title=\"Records where one of the target variables was unanswered or empty.\">\n        <span *ngIf=\"task.unanswered > 0\">{{task.unanswered | thou}} unanswered</span>\n    </div>\n    <div\n        class=\"progress-bar progress-bar-warning\"\n        [style.width]=\"100*task.rejected/task.population + '%'\"\n        title=\"Records that were rejected by the provided filter(s).\">\n        <span *ngIf=\"task.rejected > 0\">{{task.rejected | thou}} rejected</span>\n    </div>\n    <div\n        class=\"progress-bar progress-bar-success\"\n        [style.width]=\"100*task.processed/task.population + '%'\"\n        title=\"Records that the analysis tool has evaluated.\">\n        <span *ngIf=\"task.processed > 0\">{{task.processed | thou}} processed</span>\n    </div>\n    <div\n        class=\"progress-bar progress-bar-info\"\n        [style.width]=\"100*task.unknownCount/task.population + '%'\"\n        title=\"Records that the results do not account for.\">\n        <span *ngIf=\"task.unknownCount > 0\">{{task.unknownCount | thou}} unknown</span>\n    </div>\n\n\n    <div\n        class=\"progress-bar progress-bar-striped active\"\n        [style.width]=\"100*task.remaining/task.population + '%'\"\n        title=\"Records that the tool has not yet reached.\">\n        <span *ngIf=\"task.remaining > 0\">\n            {{task.populationIsEstimated ? \"???\" : (task.remaining | thou)}} remaining\n        </span>\n    </div>\n</div>\n<div class=\"row\" *ngIf=\"task.isComplete\">\n    <div class=\"col-sm-5\">\n        <label>Filtering</label>\n        <p *ngIf=\"task.unanswered > 0\">\n            {{task.viable | thou}}/{{task.population | thou}}\n            ({{(task.viable) / task.population | percent}})\n            viable\n        </p>\n        <p *ngIf=\"task.unanswered === 0\">\n            All records were viable.\n        </p>\n        <p *ngIf=\"task.filter\">\n            {{task.processed | thou}}/{{task.viable | thou}}\n            ({{(task.processed / task.viable) | percent}})\n            matched filter\n        </p>\n        <p *ngIf=\"!task.filter\">\n            No filter; used all {{task.processed | thou}} entries\n        </p>\n    </div>\n    <div class=\"col-sm-3\">\n        <label>Timing</label>\n        <p>{{task.serverStart | date:\"h:mm:ss a\"}} started</p>\n        <p>{{task.serverEnd | date:\"h:mm:ss a\"}} finished</p>\n    </div>\n    <div class=\"col-sm-4\">\n        <label>Duration</label>\n        <p title=\"The amount of time the tool was actively running. This does not include pauses or scheduling delays.\">\n            {{task.serverSeconds}} seconds executing\n        </p>\n        <p>\n            {{task.localSeconds}} seconds \"round-trip\"\n        </p>\n    </div>\n</div>"
	        })
	    ], TaskProgressComponent);
	    return TaskProgressComponent;
	}());
	exports.TaskProgressComponent = TaskProgressComponent;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var algorithm_step_service_1 = __webpack_require__(856);
	var algorithm_service_1 = __webpack_require__(213);
	var intake_step_service_1 = __webpack_require__(751);
	var report_step_service_1 = __webpack_require__(849);
	var user_service_1 = __webpack_require__(713);
	var login_service_1 = __webpack_require__(814);
	var debug_service_1 = __webpack_require__(855);
	var graph_service_1 = __webpack_require__(918);
	var collaboration_service_1 = __webpack_require__(750);
	var comment_service_1 = __webpack_require__(212);
	var search_service_1 = __webpack_require__(834);
	var messaging_service_1 = __webpack_require__(533);
	var protocol_version_service_1 = __webpack_require__(694);
	var watchlist_service_1 = __webpack_require__(842);
	var MESSAGE_SERVICES = [
	    algorithm_service_1.AlgorithmService,
	    algorithm_step_service_1.AlgorithmStepService,
	    collaboration_service_1.CollaborationService,
	    comment_service_1.CommentService,
	    debug_service_1.DebugService,
	    graph_service_1.GraphService,
	    intake_step_service_1.IntakeStepService,
	    login_service_1.LoginService,
	    messaging_service_1.MessagingService,
	    protocol_version_service_1.ProtocolVersionService,
	    report_step_service_1.ReportStepService,
	    search_service_1.SearchService,
	    user_service_1.UserService,
	    watchlist_service_1.WatchlistService
	];
	var platform_browser_1 = __webpack_require__(21);
	var transformer_service_1 = __webpack_require__(698);
	var alert_service_1 = __webpack_require__(689);
	var branding_service_1 = __webpack_require__(830);
	var modal_service_1 = __webpack_require__(837);
	var print_service_1 = __webpack_require__(920);
	var configuration_service_1 = __webpack_require__(512);
	var setting_service_1 = __webpack_require__(690);
	var navigation_history_service_1 = __webpack_require__(724);
	var support_service_1 = __webpack_require__(886);
	var badge_service_1 = __webpack_require__(921);
	var subject_service_1 = __webpack_require__(821);
	var sounds_service_1 = __webpack_require__(756);
	var storage_service_1 = __webpack_require__(691);
	var modals_1 = __webpack_require__(526);
	var configuration_service_2 = __webpack_require__(512);
	var global_error_handler_1 = __webpack_require__(723);
	var launch_dependencies_1 = __webpack_require__(923);
	var GENERIC_SERVICES = [
	    alert_service_1.AlertService,
	    badge_service_1.BadgeService,
	    branding_service_1.BrandingService,
	    configuration_service_1.ConfigurationService,
	    global_error_handler_1.CUSTOM_ERROR_HANDLER,
	    launch_dependencies_1.LAUNCH_DEPENDENCY_PROVIDER,
	    modal_service_1.ModalService,
	    navigation_history_service_1.NavigationHistoryService,
	    print_service_1.PrintService,
	    setting_service_1.SettingService,
	    sounds_service_1.SoundsService,
	    transformer_service_1.STEP_TRANSFORMER_LIST,
	    storage_service_1.StorageService,
	    subject_service_1.SubjectService,
	    support_service_1.SupportService,
	    transformer_service_1.TransformerService,
	    platform_browser_1.Title,
	    modals_1.UseModalsForBrowserAlerts
	];
	var change_password_modal_component_1 = __webpack_require__(815);
	var change_secure_prompts_modal_component_1 = __webpack_require__(816);
	var user_profile_component_1 = __webpack_require__(924);
	var password_strength_analysis_component_1 = __webpack_require__(925);
	var alert_list_component_1 = __webpack_require__(926);
	var announcement_component_1 = __webpack_require__(927);
	var changelog_modal_component_1 = __webpack_require__(928);
	var control_table_modal_component_1 = __webpack_require__(745);
	var shortcut_help_modal_component_1 = __webpack_require__(930);
	var iframe_modal_dialog_component_1 = __webpack_require__(931);
	var navigation_bar_component_1 = __webpack_require__(932);
	var explanation_modal_component_1 = __webpack_require__(935);
	var json_modal_component_1 = __webpack_require__(936);
	var mock_receiver_modal_component_1 = __webpack_require__(933);
	var raw_sender_modal_component_1 = __webpack_require__(934);
	var badge_component_1 = __webpack_require__(937);
	var chat_panel_component_1 = __webpack_require__(839);
	var collaborator_panel_component_1 = __webpack_require__(938);
	var export_modal_component_1 = __webpack_require__(840);
	var intake_step_list_component_1 = __webpack_require__(939);
	var jump_to_step_modal_component_1 = __webpack_require__(940);
	var quick_link_component_1 = __webpack_require__(941);
	var referral_modal_component_1 = __webpack_require__(841);
	var report_details_modal_component_1 = __webpack_require__(850);
	var report_panel_component_1 = __webpack_require__(942);
	var relation_graph_modal_component_1 = __webpack_require__(943);
	var relationship_panel_component_1 = __webpack_require__(944);
	var select_groups_modal_component_1 = __webpack_require__(827);
	var subject_selector_modal_component_1 = __webpack_require__(829);
	var add_reminder_modal_component_1 = __webpack_require__(851);
	var create_shared_list_modal_component_1 = __webpack_require__(879);
	var reminder_list_component_1 = __webpack_require__(945);
	var watch_button_component_1 = __webpack_require__(946);
	var watchlist_component_1 = __webpack_require__(881);
	var worklist_config_modal_component_1 = __webpack_require__(882);
	var subject_search_component_1 = __webpack_require__(865);
	var MODALS = [
	    add_reminder_modal_component_1.AddReminderModalComponent,
	    changelog_modal_component_1.ChangelogModalComponent,
	    change_password_modal_component_1.ChangePasswordModalComponent,
	    change_secure_prompts_modal_component_1.ChangeSecurePromptsModalComponent,
	    control_table_modal_component_1.ControlTableModalComponent,
	    create_shared_list_modal_component_1.CreateSharedListModalComponent,
	    explanation_modal_component_1.ExplanationModalComponent,
	    export_modal_component_1.ExportModalComponent,
	    shortcut_help_modal_component_1.ShortcutHelpModalComponent,
	    iframe_modal_dialog_component_1.IframeModalComponent,
	    json_modal_component_1.JsonModalComponent,
	    jump_to_step_modal_component_1.JumpToStepModalComponent,
	    mock_receiver_modal_component_1.MockReceiverModalComponent,
	    quick_link_component_1.QuickLinkComponent,
	    raw_sender_modal_component_1.RawSenderModalComponent,
	    referral_modal_component_1.ReferralModalComponent,
	    relation_graph_modal_component_1.RelationGraphModalComponent,
	    report_details_modal_component_1.ReportDetailsModalComponent,
	    select_groups_modal_component_1.SelectGroupsModalComponent,
	    subject_selector_modal_component_1.SubjectSelectorModalComponent,
	    worklist_config_modal_component_1.WorklistConfigModalComponent
	];
	var PAGE_ELEMENTS = [
	    alert_list_component_1.AlertListComponent,
	    announcement_component_1.AnnouncementComponent,
	    navigation_bar_component_1.NavigationBarComponent,
	    intake_step_list_component_1.IntakeStepListComponent,
	    relationship_panel_component_1.RelationshipPanelComponent,
	    report_panel_component_1.ReportPanelComponent,
	    badge_component_1.BadgeComponent,
	    chat_panel_component_1.ChatPanelComponent,
	    collaborator_panel_component_1.CollaboratorPanelComponent,
	    watch_button_component_1.WatchButtonComponent,
	    watchlist_component_1.WatchlistComponent,
	    reminder_list_component_1.ReminderListComponent,
	    user_profile_component_1.UserProfileComponent,
	    password_strength_analysis_component_1.PasswordStrengthAnalysisComponent
	];
	var router_1 = __webpack_require__(41);
	var auth_service_1 = __webpack_require__(777);
	var app_routing_1 = __webpack_require__(810);
	var shared_module_1 = __webpack_require__(63);
	var CoreModule = (function () {
	    function CoreModule() {
	    }
	    CoreModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                app_routing_1.ROOT_ROUTING
	            ],
	            declarations: [
	                MODALS,
	                PAGE_ELEMENTS,
	                subject_search_component_1.SEARCH_COMPONENTS,
	                app_routing_1.APP_ROUTING_COMPONENTS
	            ],
	            entryComponents: [MODALS],
	            providers: [
	                global_error_handler_1.CUSTOM_ERROR_HANDLER,
	                MESSAGE_SERVICES,
	                GENERIC_SERVICES,
	                configuration_service_2.CONFIG_INITIALIZER,
	                launch_dependencies_1.LAUNCH_DEPENDENCY_PROVIDER,
	                app_routing_1.APPLICATION_GUARDS,
	                auth_service_1.AUTH_PROVIDERS
	            ],
	            exports: [MODALS, PAGE_ELEMENTS, subject_search_component_1.SEARCH_COMPONENTS, router_1.RouterModule],
	        })
	    ], CoreModule);
	    return CoreModule;
	}());
	exports.CoreModule = CoreModule;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var algorithm_step_service_1 = __webpack_require__(856);
	var structure_1 = __webpack_require__(581);
	var graphs_1 = __webpack_require__(857);
	var messaging_service_1 = __webpack_require__(533);
	var explanation_graph_1 = __webpack_require__(919);
	var graph_1 = __webpack_require__(823);
	var GraphService = (function () {
	    function GraphService(messaging, steps) {
	        this.messaging = messaging;
	        this.steps = steps;
	    }
	    GraphService.prototype.explainStep = function (step) {
	        var _this = this;
	        return this.messaging.converse(new graphs_1.ExplanationRequest(step.id, true))
	            .flatMap(function (msg) { return _this.fromMessage(msg); });
	    };
	    GraphService.prototype.nodeFromStep = function (step) {
	        var node = new explanation_graph_1.ExplanationNode(step.id);
	        node.step = step;
	        node.label = step.displayName;
	        if (step instanceof structure_1.IntakeStep) {
	            node.category = "IntakeStep";
	            return node;
	        }
	        if (step instanceof structure_1.ReportStep) {
	            node.category = "ReportStep";
	            return node;
	        }
	        if (step instanceof structure_1.ComputationStep) {
	            node.category = "ComputationStep";
	            return node;
	        }
	        console.error("Algorithm step is not a known step type:", step);
	        throw new Error("Algorithm step is not a known step type!");
	    };
	    GraphService.prototype.fromMessage = function (msg) {
	        var _this = this;
	        var nodeIds = new Set([msg.explanation]);
	        msg.edges.forEach(function (edge) {
	            nodeIds.add(edge.source);
	            nodeIds.add(edge.target);
	        });
	        var nodes = [];
	        var unknownNodes = [];
	        nodeIds.forEach(function (id) {
	            var step = _this.steps.get(id);
	            if (!step) {
	                return unknownNodes.push(id);
	            }
	            else {
	                nodes.push(_this.nodeFromStep(step));
	            }
	        });
	        var edgesAwaitingNodes = [];
	        var edges = [];
	        msg.edges.forEach(function (edge) {
	            if (unknownNodes.indexOf(edge.source) > -1
	                || unknownNodes.indexOf(edge.target) > -1) {
	                edgesAwaitingNodes.push(edge);
	            }
	            else {
	                var source = nodes.find(function (n) { return n.id === edge.source; });
	                var target = nodes.find(function (n) { return n.id === edge.target; });
	                if (!source || !target) {
	                    throw new Error("Claimed node ID was known, but could not resolve");
	                }
	                edges.push(new graph_1.GraphEdge(source, target));
	            }
	        });
	        if (unknownNodes.length > 0) {
	            return this.steps.requestDefinitions(unknownNodes)
	                .map(function (steps) {
	                steps.forEach(function (step) { return nodes.push(_this.nodeFromStep(step)); });
	                edgesAwaitingNodes.forEach(function (edge) {
	                    var source = nodes.find(function (n) { return n.id === edge.source; });
	                    var target = nodes.find(function (n) { return n.id === edge.target; });
	                    if (!source || !target) {
	                        console.warn("Could not find node for edge!", edge);
	                        throw new Error("Could not resolve node after dfn request!");
	                    }
	                    edges.push(new graph_1.GraphEdge(source, target));
	                });
	                return new explanation_graph_1.ExplanationGraph(nodes, edges);
	            });
	        }
	        else {
	            return Rx_1.Observable.of(new explanation_graph_1.ExplanationGraph(nodes, edges));
	        }
	    };
	    GraphService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            algorithm_step_service_1.AlgorithmStepService])
	    ], GraphService);
	    return GraphService;
	}());
	exports.GraphService = GraphService;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var graph_1 = __webpack_require__(823);
	var ExplanationGraph = (function (_super) {
	    __extends(ExplanationGraph, _super);
	    function ExplanationGraph() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.directed = true;
	        return _this;
	    }
	    return ExplanationGraph;
	}(graph_1.Graph));
	exports.ExplanationGraph = ExplanationGraph;
	var ExplanationNode = (function (_super) {
	    __extends(ExplanationNode, _super);
	    function ExplanationNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ExplanationNode;
	}(graph_1.GraphNode));
	exports.ExplanationNode = ExplanationNode;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var Rx_1 = __webpack_require__(214);
	var PrintService = (function () {
	    function PrintService() {
	        var _this = this;
	        this.printEvents = new Rx_1.Subject();
	        var mediaQueryList = window.matchMedia("print");
	        mediaQueryList.addListener(function (mql) {
	            if (mql.matches) {
	                _this.printEvents.next(mql);
	            }
	        });
	    }
	    PrintService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [])
	    ], PrintService);
	    return PrintService;
	}());
	exports.PrintService = PrintService;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var configuration_service_1 = __webpack_require__(512);
	var badge_1 = __webpack_require__(922);
	var BadgeService = (function () {
	    function BadgeService(config) {
	        var _this = this;
	        this.config = config;
	        this.badges = new Map();
	        this.overlays = new Map();
	        this.config.reports.overlays.forEach(function (o) {
	            return _this.overlays.set(o.name, o.image);
	        });
	        this.config.reports.badges.forEach(function (b) {
	            var badge = new badge_1.Badge(b.report, _this.config.reports.root + b.image, b.overlay, _this.overlays.get(b.overlay));
	            _this.badges.set(badge.name, badge);
	        });
	    }
	    BadgeService.prototype.get = function (name) {
	        if (this.badges.has(name)) {
	            return this.badges.get(name);
	        }
	        return badge_1.Badge.UNKNOWN;
	    };
	    BadgeService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [configuration_service_1.ConfigurationService])
	    ], BadgeService);
	    return BadgeService;
	}());
	exports.BadgeService = BadgeService;


/***/ }),
/* 922 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Badge = (function () {
	    function Badge(name, url, overlay, overlayUrl, knownType) {
	        if (overlay === void 0) { overlay = null; }
	        if (overlayUrl === void 0) { overlayUrl = null; }
	        if (knownType === void 0) { knownType = true; }
	        this.name = name;
	        this.url = url;
	        this.overlay = overlay;
	        this.overlayUrl = overlayUrl;
	        this.knownType = knownType;
	    }
	    Badge.UNKNOWN = new Badge("", "", null, null, false);
	    return Badge;
	}());
	exports.Badge = Badge;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var aggregation_service_1 = __webpack_require__(809);
	var alert_service_1 = __webpack_require__(689);
	var debug_service_1 = __webpack_require__(855);
	var navigation_history_service_1 = __webpack_require__(724);
	var collaboration_service_1 = __webpack_require__(750);
	var search_service_1 = __webpack_require__(834);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var modals_1 = __webpack_require__(526);
	var watchlist_service_1 = __webpack_require__(842);
	__webpack_require__(722);
	;
	function init() {
	    return null;
	}
	exports.init = init;
	exports.LAUNCH_DEPENDENCIES = new core_1.OpaqueToken("LD");
	exports.LAUNCH_DEPENDENCY_PROVIDER = {
	    provide: exports.LAUNCH_DEPENDENCIES,
	    useFactory: init,
	    deps: [
	        aggregation_service_1.AggregationService,
	        alert_service_1.AlertService,
	        collaboration_service_1.CollaborationService,
	        debug_service_1.DebugService,
	        messaging_service_1.MessagingService,
	        navigation_history_service_1.NavigationHistoryService,
	        search_service_1.SearchService,
	        subject_service_1.SubjectService,
	        modals_1.UseModalsForBrowserAlerts,
	        watchlist_service_1.WatchlistService
	    ]
	};


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var bootstrap_1 = __webpack_require__(24);
	var alert_service_1 = __webpack_require__(689);
	var utilities_1 = __webpack_require__(523);
	var change_password_modal_component_1 = __webpack_require__(815);
	var change_secure_prompts_modal_component_1 = __webpack_require__(816);
	var rules_1 = __webpack_require__(640);
	var user_service_1 = __webpack_require__(713);
	var modal_service_1 = __webpack_require__(837);
	var UserProfileComponent = (function () {
	    function UserProfileComponent(users, DEP_modal, modals, alerts) {
	        this.users = users;
	        this.DEP_modal = DEP_modal;
	        this.modals = modals;
	        this.alerts = alerts;
	    }
	    UserProfileComponent.prototype.openPasswordModal = function () {
	        var _this = this;
	        this.modals.observe(change_password_modal_component_1.ChangePasswordModalComponent, { size: "sm" }).subscribe(function (saved) {
	            return saved
	                ? _this.alerts.success("Your password has been changed!")
	                : null;
	        });
	    };
	    UserProfileComponent.prototype.openPromptsModal = function () {
	        var _this = this;
	        utilities_1.ModalHelpers.observeCustom(this.DEP_modal, change_secure_prompts_modal_component_1.ChangeSecurePromptsModalComponent, { size: "lg" }).subscribe(function (saved) {
	            return saved
	                ? _this.alerts.success("Your secure prompts have been changed!")
	                : null;
	        });
	    };
	    UserProfileComponent.prototype.openHammurabiDocs = function () {
	        var HAMMURABI_DOCS_URL = "static/docs/Core/Hammurabi/index.html";
	        window.open(HAMMURABI_DOCS_URL);
	    };
	    UserProfileComponent.prototype.ruleName = function (rule) {
	        return rules_1.RULE_NAMES.get(rule) || rules_1.Rule[rule] + " (" + rule + ")";
	    };
	    UserProfileComponent.prototype.killSessions = function () {
	        var _this = this;
	        var count = this.users.otherSessions.length;
	        this.modals.confirm({
	            title: "Kill active sessions",
	            body: utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Are you sure you want to force your other active\n          sessions to disconnect?"], ["Are you sure you want to force your other active\n          sessions to disconnect?"])))
	        }).flatMap(function () { return _this.users.killAllSessions(false); })
	            .subscribe(function (m) {
	            if (m.ok) {
	                _this.modals.alert(utilities_1.oneline(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              Successfully ended ", " session(s). You will need to\n              reload and log in again on the affected device(s)."], ["\n              Successfully ended ", " session(s). You will need to\n              reload and log in again on the affected device(s)."])), count));
	            }
	        });
	    };
	    UserProfileComponent = __decorate([
	        core_1.Component({
	            selector: "user-profile",
	            template: "\n<h2>User Profile</h2>\n<table class=\"table table-striped center-items\" *ngIf=\"users.self\">\n    <tbody>\n        <tr>\n            <th>Name</th>\n            <td>\n                <p>\n                    {{users.self.name}}\n                    <span\n                        *ngIf=\"users.self.dev\"\n                        class=\"glyphicon glyphicon-sunglasses\">\n                    </span>\n                </p>\n            </td>\n            </tr>\n        <tr>\n            <th>Organization</th>\n            <td><p>{{users.self.org}}</p></td>\n        </tr>\n        <tr>\n            <th>Groups</th>\n            <td>\n                <div *ngFor=\"let group of users.self.groups\">\n                    {{group.name}}\n                    <div *ngIf=\"users.debugMode\" class=\"debug-only\">\n                        <span class=\"badge\">id #{{group.id}}</span>\n                        <strong\n                            *ngIf=\"group.isPrimary\"\n                            class=\"\">\n                            primary group\n                        </strong>\n                        <span\n                            *ngIf=\"!group.isPrimary && group.primaryGroup\"\n                            class=\"\">\n                            primary = {{group.primaryGroup.name}}\n                            ({{group.primaryGroupId}})\n                        </span>\n                        <p>\n                            <em>rules:</em>\n                            [<span *ngFor=\"let rule of group.rules; let l = last\">\n                                {{ruleName(rule)}}{{l ? \"\" : \",\"}}\n                            </span>]\n                        </p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        <tr *ngIf=\"users.otherSessions.length > 0\">\n            <th>Sessions</th>\n            <td>\n              <p *ngFor=\"let session of users.otherSessions; let last = last\">\n                  <em>last used</em>\n                  {{session.connectedSince | calendarTime}}\n                  <br>\n                  <em>from</em>\n                  {{users.getIPCommonName(session.client)}}\n                  {{session.client}}\n                  <br>\n                  <em>via zone</em>\n                  <a [href]=\"session.zone\">{{session.zoneTitle}}</a>\n              </p>\n              <button\n                class=\"btn btn-danger\"\n                (click)=\"killSessions()\">\n                End Other Sessions\n              </button>\n            </td>\n        </tr>\n        <tr *ngIf=\"users.debugMode\" class=\"debug-only\">\n            <th>System Rules</th>\n            <td>\n                <ul>\n                    <li *ngFor=\"let rule of users.self.rules\">\n                        {{ruleName(rule)}}\n                    </li>\n                </ul>\n            </td>\n        </tr>\n        <tr *ngIf=\"users.debugMode\" class=\"debug-only\">\n            <th>Zones</th>\n            <td>\n                <p *ngFor=\"let zone of users.self.zones\">\n                    <label>\n                        {{zone.title}}\n                        <span class=\"badge\">\n                            #{{zone.zoneId}}\n                        </span>\n                    </label>\n                    <br>\n                    {{zone.organizationName}}\n                    <br>\n                    <a [href]=\"zone.url\">\n                        {{zone.url}}\n                    </a>\n                </p>\n            </td>\n        </tr>\n        <tr>\n            <th>Account</th>\n            <td>\n                <button\n                    type=\"button\"\n                    class=\"btn btn-default form-control\"\n                    (click)=\"openPasswordModal()\">\n                    Change Password\n                </button>\n                <button\n                    type=\"button\"\n                    class=\"btn btn-default form-control\"\n                    (click)=\"openPromptsModal()\">\n                    Change Secure Prompts\n                </button>\n            </td>\n        </tr>\n        <tr *ngIf=\"users.self.algorithmDev\"> <!-- TODO: other cases here -->\n            <th>Role-Specific Actions</th>\n            <td>\n                <button\n                    *ngIf=\"users.self.algorithmDev\"\n                    type=\"button\"\n                    class=\"btn btn-default form-control\"\n                    (click)=\"openHammurabiDocs()\">\n                    View Hammurabi Docs\n                </button>\n            </td>\n        </tr>\n        <tr *ngIf=\"users.debugMode && users.debugActions\">\n            <th>Dev-only Actions</th>\n            <td class=\"text-center\">\n                <kbd>(None available)</kbd>\n            </td>\n        </tr>\n    </tbody>\n</table>\n"
	        }),
	        __metadata("design:paramtypes", [user_service_1.UserService,
	            bootstrap_1.Modal,
	            modal_service_1.ModalService,
	            alert_service_1.AlertService])
	    ], UserProfileComponent);
	    return UserProfileComponent;
	}());
	exports.UserProfileComponent = UserProfileComponent;
	var templateObject_1, templateObject_2;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	__webpack_require__(702);
	var functions_1 = __webpack_require__(206);
	var PROGRESS_SUCCESS = 0.66;
	var CRACK_TIME_KEY = "offline_slow_hashing_1e4_per_second";
	var PasswordStrengthAnalysisComponent = (function () {
	    function PasswordStrengthAnalysisComponent() {
	        this.attackDefinition = functions_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        A criticial situation where attackers have compromised the database and\n        have "], ["\n        A criticial situation where attackers have compromised the database and\n        have "])));
	    }
	    Object.defineProperty(PasswordStrengthAnalysisComponent.prototype, "control", {
	        set: function (ctrl) {
	            throw new Error("Not yet supported!");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PasswordStrengthAnalysisComponent.prototype, "barWidth", {
	        get: function () {
	            return (Math.min(this.guessMagnitude / this.minMagnitude * PROGRESS_SUCCESS * 100, 100) + "%");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PasswordStrengthAnalysisComponent.prototype, "guessMagnitude", {
	        get: function () {
	            return this.results ? Math.floor(this.results.guesses_log10) : 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PasswordStrengthAnalysisComponent.prototype, "readableTimeEstimate", {
	        get: function () {
	            return (this.results
	                ? this.results.crack_times_display[CRACK_TIME_KEY]
	                : "no time");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], PasswordStrengthAnalysisComponent.prototype, "minMagnitude", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], PasswordStrengthAnalysisComponent.prototype, "results", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.FormControl),
	        __metadata("design:paramtypes", [forms_1.FormControl])
	    ], PasswordStrengthAnalysisComponent.prototype, "control", null);
	    PasswordStrengthAnalysisComponent = __decorate([
	        core_1.Component({
	            selector: "password-strength-analysis",
	            template: "\n        <div class=\"progress\">\n          <div\n            class=\"progress-bar\"\n            [class.progress-bar-warning]=\"guessMagnitude < minMagnitude\"\n            [class.progress-bar-success]=\"guessMagnitude >= minMagnitude\"\n            role=\"progressbar\"\n            [attr.aria-valuenow]=\"guessMagnitude\"\n            style=\"min-width: 2em\"\n            aria-valuemin=\"0\"\n            aria-valuemax=\"16\"\n            [style.width]=\"barWidth\">\n            {{guessMagnitude}}\n          </div>\n        </div>\n        <p>\n          An estimate of your password's strength is shown above. The server\n          requires a minimum strength of\n          <strong>{{minMagnitude}}</strong>,\n          indicating that your password would need at least\n          <strong>10<sup>{{minMagnitude}}</sup></strong>\n          guesses to break (on average).\n        </p>\n        <p>\n          Under a typical\n          <dfn [title]=\"attackDefinition\">\n            offline attack scenario\n          </dfn>\n          this password would take\n          {{readableTimeEstimate}}\n          to crack.\n        </p>\n        "
	        })
	    ], PasswordStrengthAnalysisComponent);
	    return PasswordStrengthAnalysisComponent;
	}());
	exports.PasswordStrengthAnalysisComponent = PasswordStrengthAnalysisComponent;
	var templateObject_1;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var alert_service_1 = __webpack_require__(689);
	var router_1 = __webpack_require__(41);
	var AlertListComponent = (function () {
	    function AlertListComponent(alertService, router) {
	        this.alertService = alertService;
	        this.router = router;
	    }
	    AlertListComponent.prototype.act = function (alert) {
	        if (!alert.action) {
	            throw new Error("Alert has no action defined!");
	        }
	        alert.action(this.router);
	        this.alertService.remove(alert);
	    };
	    AlertListComponent = __decorate([
	        core_1.Component({
	            selector: "alert-list",
	            template: "\n  <div *ngFor=\"let alert of alertService.alerts\">\n    <!-- ALERT alert -->\n    <div\n      *ngIf=\"!alert.suppressed && alert.type === 'error'\"\n      (click)=\"alertService.cancelTimeout(alert)\"\n      class=\"alert fade alert-dismissable alert-danger\"\n      [class.in]=\"alert.show\"\n      role=\"alert\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"close\"\n        (click)=\"alertService.remove(alert)\">\n        <span aria-hidden=\"true\">x</span>\n      </button>\n      <span\n        class=\"glyphicon glyphicon-exclamation-sign\"\n        aria-hidden=\"true\">\n      </span>\n      <span class=\"sr-only\">\n        Error:\n      </span>\n      <span class=\"text\" [innerHtml]=\"alert.message\"></span>\n      <button\n        *ngIf=\"alert.action\"\n        class=\"btn btn-xs btn-danger\"\n        (click)=\"act(alert)\">\n        {{alert.actionLabel || \"OK\"}}\n      </button>\n    </div>\n\n    <!-- WARNING alert -->\n    <div\n      *ngIf=\"!alert.suppressed && alert.type === 'warning'\"\n      (click)=\"alertService.cancelTimeout(alert)\"\n      class=\"alert fade alert-dismissable alert-warning\"\n      [class.in]=\"alert.show\"\n      role=\"alert\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"close\"\n        (click)=\"alertService.remove(alert)\">\n        <span aria-hidden=\"true\">x</span>\n      </button>\n      <span\n        class=\"glyphicon glyphicon-flag\"\n        aria-hidden=\"true\">\n      </span>\n      <span class=\"sr-only\">\n        Warning:\n      </span>\n      <span class=\"text\" [innerHtml]=\"alert.message\"></span>\n      <button\n        *ngIf=\"alert.action\"\n        class=\"btn btn-xs btn-warning\"\n        (click)=\"act(alert)\">\n        {{alert.actionLabel || \"OK\"}}\n      </button>\n    </div>\n\n    <!-- NOTIFICATION alert / USER alert -->\n    <div\n      *ngIf=\"!alert.suppressed && (alert.type === 'notification' || alert.type === 'user')\"\n      (click)=\"alertService.cancelTimeout(alert)\"\n      class=\"alert fade alert-dismissable alert-info\"\n      [class.in]=\"alert.show\"\n      role=\"alert\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"close\"\n        (click)=\"alertService.remove(alert)\">\n        <span aria-hidden=\"true\">x</span>\n      </button>\n      <span\n        class=\"glyphicon\"\n        [class.glyphicon-info-sign]=\"alert.type === 'notification'\"\n        [class.glyphicon-user]=\"alert.type === 'user'\"\n        aria-hidden=\"true\">\n      </span>\n      <span class=\"sr-only\">\n        Information:\n      </span>\n      <span class=\"text\" [innerHtml]=\"alert.message\"></span>\n      <button\n        *ngIf=\"alert.action\"\n        class=\"btn btn-xs btn-info\"\n        (click)=\"act(alert)\">\n        {{alert.actionLabel || \"OK\"}}\n      </button>\n    </div>\n\n    <!-- SUCCESS alert -->\n    <div\n      *ngIf=\"!alert.suppressed && alert.type === 'success'\"\n      (click)=\"alertService.cancelTimeout(alert)\"\n      class=\"alert fade alert-dismissable alert-success\"\n      [class.in]=\"alert.show\"\n      role=\"alert\">\n      <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"close\"\n        (click)=\"alertService.remove(alert)\">\n        <span aria-hidden=\"true\">x</span>\n      </button>\n      <span\n        class=\"glyphicon glyphicon-ok\"\n        aria-hidden=\"true\">\n      </span>\n      <span class=\"sr-only\">\n        Success:\n      </span>\n      <span class=\"text\" [innerHtml]=\"alert.message\"></span>\n      <button\n        *ngIf=\"alert.action\"\n        class=\"btn btn-xs btn-success\"\n        (click)=\"act(alert)\">\n        {{alert.actionLabel || \"OK\"}}\n      </button>\n    </div>\n\n\n    <!-- COUNTDOWN alert -->\n    <div\n      *ngIf=\"!alert.suppressed && alert.type === 'countdown'\"\n      class=\"alert fade alert-warning\"\n      [class.in]=\"alert.show\"\n      role=\"alert\">\n      <span\n        class=\"glyphicon glyphicon-time\"\n        aria-hidden=\"true\">\n      </span>\n      <span class=\"sr-only\">\n        Notification:\n      </span>\n      <strong>\n        <countdown [seconds]=\"alert.timeout / 1000\"></countdown>\n      </strong>\n      <span class=\"text\" [innerHtml]=\"alert.message\"></span>\n      <button\n        *ngIf=\"alert.action\"\n        class=\"btn btn-xs btn-warning\"\n        (click)=\"act(alert)\">\n        {{alert.actionLabel || \"OK\"}}\n      </button>\n    </div>\n  </div>\n  ",
	            styles: [
	                ":host {pointer-events: none;}",
	                ".alert {\n      display: inline-block;\n      margin-bottom: 10px;\n      pointer-events: all;\n    }\n    .alert .text {\n      margin-right: 10px;\n    }\n    countdown {\n      padding-right: 10px;\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [alert_service_1.AlertService, router_1.Router])
	    ], AlertListComponent);
	    return AlertListComponent;
	}());
	exports.AlertListComponent = AlertListComponent;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var bootstrap_1 = __webpack_require__(24);
	var utilities_1 = __webpack_require__(523);
	var alert_service_1 = __webpack_require__(689);
	var changelog_modal_component_1 = __webpack_require__(928);
	var AnnouncementComponent = (function () {
	    function AnnouncementComponent(modal, alerts) {
	        var _this = this;
	        this.modal = modal;
	        this.alerts = alerts;
	        this.unauthed = false;
	        this.alerts.announcementsLoaded.subscribe(function (loaded) {
	            if (_this.alerts.userAnnouncements.length > 0) {
	                _this.current = _this.alerts.userAnnouncements[0];
	            }
	        });
	    }
	    AnnouncementComponent.prototype.openChangelog = function () {
	        utilities_1.ModalHelpers.openCustom(this.modal, changelog_modal_component_1.ChangelogModalComponent, { size: "lg", title: "Changelog" });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], AnnouncementComponent.prototype, "unauthed", void 0);
	    AnnouncementComponent = __decorate([
	        core_1.Component({
	            selector: "announcements",
	            template: "\n    <div\n      *ngIf=\"current\"\n      class=\"alert\"\n      [class.alert-info]=\"current.style === 'info'\"\n      [class.alert-success]=\"current.style === 'success'\"\n      [class.alert-warning]=\"current.style === 'warning'\"\n      [class.alert-danger]=\"current.style === 'danger'\">\n      <span class=\"oneline-ellipsis\">\n        <strong>{{current.title}}:</strong>\n        <span [innerHtml]=\"current.content\"></span>\n      </span>\n      <a class=\"alert-link pull-right\" (click)=\"openChangelog()\">\n        View Changelog\n      </a>\n    </div>\n  ",
	            styles: [
	                ".alert-link {\n      /* to global css */\n      text-decoration: underline;\n    }\n    .alert {\n      height: 50px;\n    }\n    .alert span {\n      width: calc(100% - 125px);\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [bootstrap_1.Modal, alert_service_1.AlertService])
	    ], AnnouncementComponent);
	    return AnnouncementComponent;
	}());
	exports.AnnouncementComponent = AnnouncementComponent;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(66);
	var angular2_modal_1 = __webpack_require__(25);
	var changelog_1 = __webpack_require__(929);
	var ChangelogModalComponent = (function () {
	    function ChangelogModalComponent(dialog, http) {
	        this.dialog = dialog;
	        this.http = http;
	        this.categoryOptions = ["core", "rules"];
	        this.changesByVersion = new Map();
	        this.versions = [];
	        this.load();
	    }
	    ChangelogModalComponent.prototype.matches = function (cat) {
	        return this.category === null || this.category === cat;
	    };
	    ChangelogModalComponent.prototype.load = function () {
	        var _this = this;
	        this.changesByVersion.clear();
	        this.versionsWithoutAnnotations = new Set();
	        this.category = null;
	        this.http.get("/zone/documents/changelog.json").subscribe(function (r) {
	            var changelog = r.json();
	            changelog.changes.forEach(function (change) {
	                var version = changelog_1.semverString(change.version);
	                _this.versionsWithoutAnnotations.add(version);
	                if (!_this.changesByVersion.has(version)) {
	                    _this.changesByVersion.set(version, [change]);
	                }
	                else {
	                    _this.changesByVersion.get(version).push(change);
	                }
	            });
	            _this.versions = changelog.versions.map(function (v) {
	                var vName = changelog_1.semverString(v.version);
	                _this.versionsWithoutAnnotations.delete(vName);
	                return {
	                    label: v.displayName || vName,
	                    date: new Date(v.date),
	                    description: v.description || "",
	                    changes: _this.changesByVersion.get(vName) || []
	                };
	            });
	            _this.versionsWithoutAnnotations.forEach(function (vName) {
	                _this.versions.push({
	                    label: "Unassigned [" + vName + "]",
	                    date: new Date(0),
	                    description: "No description available!",
	                    changes: _this.changesByVersion.get(vName)
	                });
	            });
	        });
	    };
	    ChangelogModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Advocus Changelog\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      This page shows recent changes to Advocus. For older changes, visit the <a href=\"/zone/documents/changelog_archive.html\" target=\"_blank\">archive <span class=\"glyphicon glyphicon-share\"></span></a>.\n    </p>\n    <label>Filter:</label>\n    <button class=\"btn\" [class.btn-primary]=\"category === null\" [class.btn-default]=\"category !== null\" (click)=\"category = null\">All</button>\n    <button *ngFor=\"let cat of categoryOptions\" class=\"btn\" [class.btn-primary]=\"category === cat\" [class.btn-default]=\"category !== cat\" (click)=\"category = cat\">{{cat}}</button>\n    <hr />\n    <div *ngFor=\"let version of versions\">\n      <h3>\n        {{version.label}}\n        <small class=\"date\">{{version.date | date}}</small>\n      </h3>\n      <p *ngIf=\"version.description\">\n        <em>{{version.description}}</em>\n      </p>\n      <ul>\n        <template ngFor let-change [ngForOf]=\"version.changes\">\n          <li *ngIf=\"matches(change.category)\">\n            <kbd [class]=\"change.category\">\n              {{change.category}}\n            </kbd>\n            {{change.description}}\n            <kbd class=\"tag\" *ngFor=\"let tag of change.tags\">{{tag}}</kbd>\n          </li>\n        </template>\n      </ul>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.close()\">\n      Close\n    </button>\n  </div>\n  ",
	            styles: [
	                "\n    .tag {\n      opacity: 0.5;\n    }\n    .date {\n      float: right;\n    }\n    kbd.core {\n      color: darkgoldenrod;\n    }\n    kbd.rules {\n      color: darkblue;\n    }\n    "
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            http_1.Http])
	    ], ChangelogModalComponent);
	    return ChangelogModalComponent;
	}());
	exports.ChangelogModalComponent = ChangelogModalComponent;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function semverString(v) {
	    validateSemver(v);
	    return v[0] + "." + v[1] + "." + v[2];
	}
	exports.semverString = semverString;
	function validateSemver(v) {
	    if (!Array.isArray(v)) {
	        throw new Error("SemVer is not an array");
	    }
	    if (v.length !== 3) {
	        throw new Error("SemVer does not have 3 values");
	    }
	    if (v.some(function (val) { return !Number.isInteger(val) || val < 0; })) {
	        throw new Error("SemVer contains nonpositive/noninteger values");
	    }
	}
	exports.validateSemver = validateSemver;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var ShortcutHelpModalComponent = (function () {
	    function ShortcutHelpModalComponent(dialog) {
	        this.dialog = dialog;
	    }
	    ShortcutHelpModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Keyboard Shortcuts\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      Mac OSX users may replace <kbd>Ctrl</kbd> with <kbd>Cmd</kbd> below.\n    </p>\n    <ul>\n      <li><kbd>F1</kbd>|<kbd>Ctrl+/</kbd> Show this help</li>\n      <li><kbd>Ctrl+H</kbd> Go Home</li>\n      <li><kbd>Ctrl+M</kbd> Add Reminder</li>\n      <li><kbd>Ctrl+I</kbd> New Intake</li>\n      <li>\n        On intake form:\n        <ul>\n          <li><kbd>Ctrl+S</kbd> Save Intake</li>\n          <li><kbd>Ctrl+J</kbd> Jump to Step...</li>\n          <li><kbd>Ctrl+Enter</kbd> Open Chat</li>\n        </ul>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.dismiss()\">\n      OK\n    </button>\n  </div>\n  "
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], ShortcutHelpModalComponent);
	    return ShortcutHelpModalComponent;
	}());
	exports.ShortcutHelpModalComponent = ShortcutHelpModalComponent;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(21);
	var angular2_modal_1 = __webpack_require__(25);
	var IframeModalComponent = (function () {
	    function IframeModalComponent(dialog, sanitizer) {
	        this.dialog = dialog;
	        this.sanitizer = sanitizer;
	        this.title = dialog.context.title;
	        this.url = sanitizer.bypassSecurityTrustResourceUrl(dialog.context.url);
	    }
	    IframeModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      {{title}}\n    </h4>\n  </div>\n  <div class=\"modal-body\">\n    <iframe [name]=\"title\" [src]=\"url\" match-height></iframe>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-default\"\n      (click)=\"dialog.close()\">\n      Close\n    </button>\n  </div>\n  ",
	            styles: [
	                "iframe {\n      width: 100%;\n      min-height: 350px;\n      border: none;\n    }\n    .modal-body {\n      padding 0px;\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            platform_browser_1.DomSanitizer])
	    ], IframeModalComponent);
	    return IframeModalComponent;
	}());
	exports.IframeModalComponent = IframeModalComponent;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(41);
	var algorithm_service_1 = __webpack_require__(213);
	var auth_service_1 = __webpack_require__(777);
	var user_service_1 = __webpack_require__(713);
	var shortcut_help_modal_component_1 = __webpack_require__(930);
	var debug_service_1 = __webpack_require__(855);
	var messaging_service_1 = __webpack_require__(533);
	var subject_service_1 = __webpack_require__(821);
	var watchlist_service_1 = __webpack_require__(842);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var mock_receiver_modal_component_1 = __webpack_require__(933);
	var raw_sender_modal_component_1 = __webpack_require__(934);
	var utilities_1 = __webpack_require__(523);
	var extension_signal_request_1 = __webpack_require__(597);
	var rules_1 = __webpack_require__(640);
	var configuration_service_1 = __webpack_require__(512);
	var iframe_modal_dialog_component_1 = __webpack_require__(931);
	var modal_service_1 = __webpack_require__(837);
	var branding_service_1 = __webpack_require__(830);
	var NavigationBarComponent = (function () {
	    function NavigationBarComponent(auth, algorithms, subjects, messaging, modal, modals, debug, watchlist, users, router, config, branding) {
	        var _this = this;
	        this.auth = auth;
	        this.algorithms = algorithms;
	        this.subjects = subjects;
	        this.messaging = messaging;
	        this.modal = modal;
	        this.modals = modals;
	        this.debug = debug;
	        this.watchlist = watchlist;
	        this.users = users;
	        this.router = router;
	        this.config = config;
	        this.branding = branding;
	        this.features = {
	            search: false,
	            createSubject: false,
	            tools: false,
	            management: false
	        };
	        this.hideAll = false;
	        this.helpOpen = false;
	        if (this.algorithms.zoneIsAdmin) {
	            this.auth.redirectTo = ["admin"];
	        }
	        this.users.ready.subscribe(function (ready) {
	            if (ready) {
	                _this.extractFeatures();
	            }
	            else {
	                _this.clearFeatures();
	            }
	        });
	    }
	    NavigationBarComponent.prototype.clearFeatures = function () {
	        this.features.search = false;
	    };
	    NavigationBarComponent.prototype.extractFeatures = function () {
	        if (this.config.client.type === "guest") {
	            this.features = {
	                search: false,
	                createSubject: this.users.self.hasRule(rules_1.Rule.POPULATE_SUBJECT),
	                tools: false,
	                management: false
	            };
	            this.hideAll = true;
	        }
	        else {
	            this.features = {
	                search: this.users.self.hasRule(rules_1.Rule.SEARCH_SUBJECT),
	                createSubject: this.users.self.hasRule(rules_1.Rule.POPULATE_SUBJECT),
	                tools: this.users.self.isAggregationUser(),
	                management: this.users.self.isManagementUser()
	            };
	        }
	    };
	    NavigationBarComponent.prototype.getLabel = function (section, def) {
	        var k = "nav_" + section;
	        if (k in this.branding.strings) {
	            return this.branding.strings[k];
	        }
	        if (def) {
	            return def;
	        }
	        else {
	            return section;
	        }
	    };
	    NavigationBarComponent.prototype.openHelpModal = function (ev) {
	        var _this = this;
	        if (!this.helpOpen) {
	            this.helpOpen = true;
	            utilities_1.ModalHelpers.observeCustom(this.modal, shortcut_help_modal_component_1.ShortcutHelpModalComponent, {}).subscribe(function () {
	                _this.helpOpen = false;
	            });
	        }
	        ev.preventDefault();
	    };
	    NavigationBarComponent.prototype.debugOpenSender = function (ev) {
	        if (this.users.debugMode) {
	            this.modal.open(raw_sender_modal_component_1.RawSenderModalComponent, angular2_modal_1.overlayConfigFactory({ size: "lg" }, bootstrap_1.BSModalContext));
	            ev.preventDefault();
	        }
	    };
	    NavigationBarComponent.prototype.debugOpenMocker = function (ev) {
	        if (this.users.debugMode) {
	            this.modal.open(mock_receiver_modal_component_1.MockReceiverModalComponent, angular2_modal_1.overlayConfigFactory({ size: "lg" }, bootstrap_1.BSModalContext));
	            ev.preventDefault();
	        }
	    };
	    NavigationBarComponent.prototype.toggleHideAll = function (ev) {
	        if (this.hideAll) {
	            this.hideAll = false;
	            this.features.tools = true;
	        }
	    };
	    NavigationBarComponent.prototype.debugWSRestart = function () {
	        this.messaging.restart();
	    };
	    NavigationBarComponent.prototype.debugRecents = function () {
	        console.table(this.messaging.recentLog.list());
	    };
	    NavigationBarComponent.prototype.debugServerBreak = function () {
	        this.debug.breakpoint();
	    };
	    NavigationBarComponent.prototype.debugRemoveDeveloper = function () {
	        this.users.undebug();
	    };
	    NavigationBarComponent.prototype.debugMiscTest = function () {
	        var payload = {
	            name: "debug",
	            version: [0, 0, 0]
	        };
	        this.messaging.send(new extension_signal_request_1.ExtensionSignalRequest(payload)).subscribe();
	    };
	    NavigationBarComponent.prototype.openNewAuthedTab = function (event) {
	        event.preventDefault();
	        this.auth.openPreauthedTab();
	        return false;
	    };
	    NavigationBarComponent.prototype.navigateHome = function () {
	        this.router.navigate(["/home"]);
	    };
	    NavigationBarComponent.prototype.newIntake = function () {
	        this.router.navigate(["/subject/new"]);
	    };
	    NavigationBarComponent.prototype.recentsDialog = function () {
	        this.subjects.recentSubjectsDialog();
	    };
	    NavigationBarComponent.prototype.showContactPage = function (event) {
	        this.modals.display(iframe_modal_dialog_component_1.IframeModalComponent, { url: "/zone/documents/faq.html", title: "Frequently Asked Questions", size: 'lg' });
	    };
	    __decorate([
	        core_1.HostListener("document:keyup.f1", ["$event"]),
	        core_1.HostListener("document:keyup.control./", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "openHelpModal", null);
	    __decorate([
	        core_1.HostListener("document:keyup.f2", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "debugOpenSender", null);
	    __decorate([
	        core_1.HostListener("document:keyup.f3", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "debugOpenMocker", null);
	    __decorate([
	        core_1.HostListener("document:keyup.f4", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "toggleHideAll", null);
	    __decorate([
	        core_1.HostListener("document:keydown.control.h"),
	        core_1.HostListener("document:keydown.meta.h"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "navigateHome", null);
	    __decorate([
	        core_1.HostListener("document:keydown.control.i"),
	        core_1.HostListener("document:keydown.meta.i"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "newIntake", null);
	    __decorate([
	        core_1.HostListener("document:keydown.control.b"),
	        core_1.HostListener("document:keydown.meta.b"),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], NavigationBarComponent.prototype, "recentsDialog", null);
	    NavigationBarComponent = __decorate([
	        core_1.Component({
	            selector: "navbar",
	            template: "\n  <nav #responsiveMenu class=\"navbar navbar-default navbar-fixed-top\">\n  <div class=\"container-fluid\">\n    <div class=\"navbar-header\">\n      <!-- include mobile toggle here one day -->\n      <a class=\"navbar-brand\" [routerLink]=\"auth.authenticated ? '/home' : '/'\">\n        <img src=\"/zone/images/nav_banner.png\">\n      </a>\n      <button\n        type=\"button\"\n        title=\"Open menu\"\n        class=\"navbar-toggle collapsed\"\n        (click)=\"responsiveMenu.open = !responsiveMenu.open\">\n        <span class=\"glyphicon glyphicon-th-list\"></span>\n      </button>\n    </div>\n\n    <!-- this group would be hidden on small screens -->\n    <div\n      class=\"collapse navbar-collapse\"\n      [class.in]=\"responsiveMenu.open\"\n      (click)=\"responsiveMenu.open = false\">\n\n      <ul *ngIf=\"auth.authenticated\" class=\"nav navbar-nav\">\n\n      <template [ngIf]=\"!algorithms.zoneIsAdmin\">\n      <!-- HOME -->\n        <li *ngIf=\"!hideAll\" routerLinkActive=\"active\">\n          <a routerLink=\"/home\" preauthNewTabs class=\"capitalized\">\n            {{getLabel('home')}}\n            <span *ngIf=\"watchlist.hasAlerts\" class=\"badge alert-count\">\n              {{watchlist.alertCount}}\n            </span>\n          </a>\n        </li>\n\n        <!-- SEARCH -->\n        <li\n          *ngIf=\"features.search\"\n          title=\"Search\" routerLinkActive=\"active\">\n          <a routerLink=\"/search\" preauthNewTabs class=\"capitalized\">\n          {{getLabel('search')}}\n          </a>\n        </li>\n\n        <!-- NEW INTAKE -->\n        <li\n          *ngIf=\"features.createSubject && algorithms?.createable?.length && (true || users.debugMode)\"\n          class=\"dropdown\">\n          <a\n            *ngIf=\"algorithms.createable.length === 1\"\n            (click)=\"subjects.launchNew(algorithms.createable[0])\"\n            [title]=\"algorithms.createable[0].displayName\"\n            class=\"capitalized\">\n            {{getLabel('new', \"New Intake\")}}\n          </a>\n          <template [ngIf]=\"algorithms.createable.length > 1\">\n            <a (click)=\"$event.stopPropagation()\" class=\"capitalized\">\n              {{getLabel('new', 'New Intake')}}\n              <span class=\"caret\"></span>\n            </a>\n            <ul class=\"dropdown-menu\">\n              <li\n                *ngFor=\"let alg of algorithms.createable\"\n                routerLinkActive=\"active\">\n                <a (click)=\"subjects.launchNew(alg)\">\n                  {{alg.displayName}}\n                </a>\n              </li>\n            </ul>\n          </template>\n        </li>\n\n        <!-- AGGREGATION -->\n        <li\n          *ngIf=\"features.tools\"\n          title=\"Tools\"\n          routerLinkActive=\"active\">\n          <a routerLink=\"/tools\" preauthNewTabs class=\"capitalized\">\n            {{getLabel('tools')}}\n          </a>\n        </li>\n\n        <!-- MANAGEMENT -->\n        <li\n          *ngIf=\"features.management\"\n          title=\"Manage\"\n          routerLinkActive=\"active\">\n          <a routerLink=\"/manage\" preauthNewTabs class=\"capitalized\">\n            {{getLabel('manage')}}\n          </a>\n        </li>\n      </template>\n\n        <!-- ADMIN PANEL -->\n        <li\n          *ngIf=\"algorithms.zoneIsAdmin\"\n          title=\"Admin Panel\"\n          routerLinkActive=\"active\">\n          <a routerLink=\"/admin\" preauthNewTabs class=\"capitalized\">\n            {{getLabel('admin', 'Admin Panel')}}\n          </a>\n        </li>\n\n        <!-- DEBUG -->\n        <li\n          *ngIf=\"users.debugMode\"\n          title=\"Debug menu\"\n          class=\"dropdown debug-only\">\n          <a (click)=\"$event.stopPropagation()\">\n            <span class=\"hidden-sm capitalized\">\n              {{getLabel('debug')}}\n            </span>\n            <span class=\"glyphicon glyphicon-wrench visible-sm-inline-block\">\n            </span>\n            <span class=\"caret\"></span>\n          </a>\n          <ul class=\"dropdown-menu\">\n            <li><a (click)=\"debugOpenSender()\">\n              Raw Sender\n              <kbd class=\"pull-right\">F2</kbd>\n            </a></li>\n            <li><a (click)=\"debugOpenMocker()\">\n              Mock Receiver\n              <kbd class=\"pull-right\">F3</kbd>\n            </a></li>\n            <li><a routerLink=\"sandbox\">Sandbox Test Page</a></li>\n            <li role=\"separator\" class=\"divider\"></li>\n            <li>\n              <a (click)=\"debugRemoveDeveloper()\">\n                Remove user dev status\n              </a>\n            </li>\n            <li><a (click)=\"debugWSRestart()\">Force websocket restart</a></li>\n            <li>\n              <a (click)=\"debugRecents()\">\n                Dump recent messages to console\n              </a>\n            </li>\n            <li>\n              <a (click)=\"debugServerBreak()\">\n                Trigger server breakpoint\n              </a>\n            </li>\n            <li>\n              <a (click)=\"subjects.recentSubjectsDialog()\">\n                Known Subjects\n              </a>\n            </li>\n            <li>\n              <a\n                title=\"Debug action\"\n                (click)=\"debugMiscTest()\">\n                <span class=\"glyphicon glyphicon-star\"></span> Curr. Test Rig\n              </a>\n            </li>\n          </ul>\n        </li>\n\n        <li *ngIf=\"!hideAll\" class=\"hidden-xs\">\n          <a\n            title=\"Open this in a new tab\"\n            (click)=\"openNewAuthedTab($event)\">\n            <span class=\"glyphicon glyphicon-new-window\"></span>\n          </a>\n        </li>\n      </ul>\n      <!-- end of main (left-side) links -->\n\n\n      <!-- Login/logout links, which are pushed to the right -->\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li\n          *ngIf=\"algorithms.issueReporting && !hideAll\"\n          title=\"Report issues\"\n          [class.dropdown]=\"algorithms.issueReporters.length > 1\">\n          <a\n            *ngIf=\"algorithms.issueReporters.length === 1\"\n            (click)=\"subjects.launchNew(algorithms.issueReporters[0])\">\n            <span class=\"hidden-sm\">Report Issues</span>\n            <span class=\"glyphicon glyphicon-fire visible-sm-inline-block\">\n            </span>\n          </a>\n          <template [ngIf]=\"algorithms.issueReporters.length > 1\">\n            <a>\n              <span class=\"hidden-sm\">Report Issues</span>\n              <span class=\"glyphicon glyphicon-fire visible-sm-inline-block\">\n              </span>\n              <span class=\"caret\"></span>\n            </a>\n            <ul class=\"dropdown-menu\">\n              <li\n                *ngFor=\"let ir of algorithms.issueReporters\"\n                routerLinkActive=\"active\">\n                <a (click)=\"subjects.launchNew(ir)\">\n                  {{ir.displayName}}\n                </a>\n              </li>\n            </ul>\n          </template>\n        </li>\n        <li *ngIf=\"auth.authenticated && !hideAll\" routerLinkActive=\"active\">\n          <a routerLink=\"/settings\">\n            <span class=\"hidden-sm capitalized\">{{getLabel('settings')}}</span>\n            <span class=\"glyphicon glyphicon-cog visible-sm-inline-block\">\n            </span>\n          </a>\n        </li>\n        <li *ngIf=\"config.client.type === 'guest'\">\n          <a (click)=\"showContactPage()\">\n            <!-- <span class=\"glyphicon glyphicon-info-sign\"></span> -->\n            Help / FAQ\n          </a>\n        </li>\n        <li *ngIf=\"!auth.authenticated\" title=\"Login\" routerLinkActive=\"active\">\n          <a routerLink=\"/login\">\n            <span class=\"hidden-sm\">Login</span>\n            <span class=\"glyphicon glyphicon-log-in visible-sm-inline-block\">\n            </span>\n          </a>\n        </li>\n        <li *ngIf=\"auth.authenticated\" title=\"Logout\" routerLinkActive=\"active\">\n          <a routerLink=\"/logout\">\n            <span class=\"hidden-sm\">Logout</span>\n            <span class=\"glyphicon glyphicon-log-out visible-sm-inline-block\">\n            </span>\n          </a>\n        </li>\n      </ul>\n    </div><!-- /.navbar-collapse -->\n  </div><!-- /.container-fluid -->\n</nav>\n  ",
	            styles: [
	                ".alert-count {background-color: #f0ad4e;}",
	                ".navbar-default .navbar-nav>li.text-warning>a {color: #8a6d3b;}",
	                ".nav>li:hover {background: rgb(253,253,253);}",
	                "\n    .dropdown:hover .dropdown-menu {display: block;}\n    "
	            ]
	        }),
	        __metadata("design:paramtypes", [auth_service_1.AuthService,
	            algorithm_service_1.AlgorithmService,
	            subject_service_1.SubjectService,
	            messaging_service_1.MessagingService,
	            bootstrap_1.Modal,
	            modal_service_1.ModalService,
	            debug_service_1.DebugService,
	            watchlist_service_1.WatchlistService,
	            user_service_1.UserService,
	            router_1.Router,
	            configuration_service_1.ConfigurationService,
	            branding_service_1.BrandingService])
	    ], NavigationBarComponent);
	    return NavigationBarComponent;
	}());
	exports.NavigationBarComponent = NavigationBarComponent;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var auth_service_1 = __webpack_require__(777);
	var composite_connection_1 = __webpack_require__(682);
	var messaging_service_1 = __webpack_require__(533);
	var incoming_message_map_1 = __webpack_require__(547);
	var utilities_1 = __webpack_require__(523);
	var angular2_modal_1 = __webpack_require__(25);
	var DEFAULT_MESSAGE = "{\n\"tag\": 1\n}";
	var MockReceiverModalComponent = (function () {
	    function MockReceiverModalComponent(messaging, auth, dialog) {
	        this.messaging = messaging;
	        this.auth = auth;
	        this.dialog = dialog;
	        this.mockIdAllocator = -10000;
	        this.rawMessage = new forms_1.FormControl(DEFAULT_MESSAGE);
	        this.form = new forms_1.FormGroup({ rawMessage: this.rawMessage });
	    }
	    MockReceiverModalComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.messaging.ready.subscribe(function (ready) {
	            _this.ready = ready;
	            _this.spigot = _this.messaging.connection;
	        });
	    };
	    MockReceiverModalComponent.prototype.tryReceive = function () {
	        var message = this.rawMessage.value;
	        try {
	            var objectForm = JSON.parse(message);
	            if (typeof objectForm !== "object") {
	                throw new Error("Outermost level of message must be object!");
	            }
	            if (!this.isTagged(objectForm)) {
	                throw new Error("Message must have a (numeric) 'tag' property!");
	            }
	            this.receive(objectForm);
	        }
	        catch (e) {
	            console.error(e);
	            alert("Could not parse your message content! See console for details.");
	        }
	    };
	    MockReceiverModalComponent.prototype.receive = function (message) {
	        message[composite_connection_1.SYM_SKIP_SIPHON] = true;
	        if (message.id === undefined) {
	            message.id = this.mockIdAllocator--;
	        }
	        this.messaging.mockInput.receive(message);
	    };
	    MockReceiverModalComponent.prototype.passThrough = function (toResume) {
	        utilities_1.arrayRemove(this.spigot.siphoned, toResume);
	        this.receive(toResume);
	    };
	    MockReceiverModalComponent.prototype.modify = function (toModify) {
	        utilities_1.arrayRemove(this.spigot.siphoned, toModify);
	        this.rawMessage.setValue(JSON.stringify(toModify));
	    };
	    MockReceiverModalComponent.prototype.isTagged = function (m) {
	        return typeof m === "object" && "tag" in m && typeof m.tag === "number";
	    };
	    MockReceiverModalComponent.prototype.nameForTag = function (tag) {
	        var msgClass = incoming_message_map_1.INCOMING_MESSAGE_MAP.get(tag);
	        if (msgClass) {
	            return "" + msgClass.name;
	        }
	        return "Unknown [tag: " + tag + "]";
	    };
	    MockReceiverModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Mock receiver tool &emsp;\n      <span class=\"badge\">\n        {{ready ? \"connected\" : \"DISCONNECTED\"}}\n        &mdash;\n        {{auth.authenticated ? \"logged in\" : \"GUEST\"}}\n      </span>\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <form [formGroup]=\"form\">\n      <div>\n        <label>Enter message JSON: (ID will automatically be assigned)</label>\n        <button\n          id=\"sendButton\"\n          class=\"btn btn-primary pull-right\"\n          (click)=\"tryReceive()\"\n          [disabled]=\"!ready\">\n          Parse &amp; \"Receive\"\n        </button>\n      </div>\n\n      <textarea\n        class=\"form-control\"\n        rows=\"8\"\n        formControlName=\"rawMessage\">\n      </textarea>\n      <br>\n    </form>\n  </div>\n\n  <div class=\"modal-body\">\n    <h4>\n      Incoming Message Interceptor\n      <button\n        type=\"button\"\n        class=\"btn btn-sm\"\n        [class.btn-danger]=\"spigot.siphoning\"\n        [class.btn-success]=\"!spigot.siphoning\"\n        [disabled]=\"!spigot\"\n        (click)=\"spigot.toggle(); dialog.close()\">\n        {{spigot.siphoning ? \"Stop\" : \"Start\"}} Intercepting\n      </button>\n    </h4>\n\n    <div\n      *ngFor=\"let msg of spigot.siphoned\"\n      class=\"panel panel-default\">\n      <div class=\"panel-heading\" (click)=\"panel.open = !panel.open\">\n        <h3 class=\"panel-title\">\n          <!--<span\n            class=\"glyphicon\"\n            [class.glyphicon-expand]=\"!panel.open\"\n            [class.glyphicon-collapse-down]=\"panel.open\">\n          </span>-->\n          <span\n            class=\"badge\"\n            [class.success]=\"msg.id > 0\">\n            {{msg.id}}\n          </span>\n          {{nameForTag(msg.tag)}}\n          <span class=\"btn-group pull-right\">\n            <button\n              type=\"button\"\n              class=\"btn btn-xs btn-info\"\n              (click)=\"passThrough(msg)\">\n              Pass Through\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn btn-xs btn-default\"\n              (click)=\"modify(msg)\">\n              Modify\n            </button>\n          </span>\n        </h3>\n      </div>\n      <div #panel class=\"panel-body collapse\" [class.in]=\"panel.open\">\n        <prettyjson [obj]=\"msg\"></prettyjson>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      Close\n    </button>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}",
	                ".modal-body + .modal-body { border-top: 1px solid #ddd; }"
	            ]
	        }),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            auth_service_1.AuthService,
	            angular2_modal_1.DialogRef])
	    ], MockReceiverModalComponent);
	    return MockReceiverModalComponent;
	}());
	exports.MockReceiverModalComponent = MockReceiverModalComponent;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var auth_service_1 = __webpack_require__(777);
	var general_1 = __webpack_require__(513);
	var messaging_service_1 = __webpack_require__(533);
	var incoming_message_map_1 = __webpack_require__(547);
	var storage_service_1 = __webpack_require__(691);
	var DEFAULT_MESSAGE = "{\n\"tag\": 1\n}";
	var RawSenderModalComponent = (function () {
	    function RawSenderModalComponent(messaging, auth, storage, dialog) {
	        this.messaging = messaging;
	        this.auth = auth;
	        this.storage = storage;
	        this.dialog = dialog;
	        this.msgClasses = Array.from(incoming_message_map_1.OUTGOING_MESSAGE_MAP.values());
	        this.tagSelector = new forms_1.FormControl();
	        this.request = null;
	        this.response = null;
	        this.savedMessages = [];
	    }
	    RawSenderModalComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.messaging.ready.subscribe(function (ready) { return _this.ready = ready; });
	        this.form = new forms_1.FormGroup({
	            rawMessage: new forms_1.FormControl(DEFAULT_MESSAGE),
	            messageSaveName: new forms_1.FormControl(),
	            messageLoadName: new forms_1.FormControl()
	        });
	        this.updateSavedMessages();
	        this.tagSelector.valueChanges.subscribe(function (tag) {
	            return _this.form.get("rawMessage").setValue("{\n\t\"tag\": " + tag + "\n}");
	        });
	    };
	    RawSenderModalComponent.prototype.trySend = function () {
	        var message = this.form.get("rawMessage").value;
	        try {
	            var objectForm = JSON.parse(message);
	            if (typeof objectForm !== "object") {
	                throw new Error("Outermost level of message must be object!");
	            }
	            if (!this.isTagged(objectForm)) {
	                throw new Error("Message must have a (numeric) 'tag' property!");
	            }
	            this.send(this.castToMessage(objectForm));
	        }
	        catch (e) {
	            console.error(e);
	            alert("Could not parse your message content! See console for details.");
	        }
	    };
	    RawSenderModalComponent.prototype.send = function (message) {
	        var _this = this;
	        this.response = null;
	        this.request = message;
	        this.messaging.send(message).subscribe(function (reply) { return _this.response = reply; }, function (err) { return _this.response = { META: "Server encountered an error" }; });
	    };
	    RawSenderModalComponent.prototype.isTagged = function (m) {
	        return typeof m === "object" && "tag" in m && typeof m.tag === "number";
	    };
	    RawSenderModalComponent.prototype.castToMessage = function (protoMessage) {
	        var msg = new general_1.ReplyVerifyingMessage();
	        Object.assign(msg, { id: this.messaging.idAllocator++ }, protoMessage);
	        msg.meta.allowUnboundedReplies = true;
	        return msg;
	    };
	    RawSenderModalComponent.prototype.updateSavedMessages = function (added, removed) {
	        var _this = this;
	        if (added === void 0) { added = []; }
	        if (removed === void 0) { removed = []; }
	        this.loadMessageList();
	        added.forEach(function (msg) {
	            var i = _this.savedMessages.findIndex(function (compare) { return msg.name === compare.name; });
	            if (i < 0) {
	                _this.savedMessages.push(msg);
	            }
	            else {
	                _this.savedMessages[i] = msg;
	            }
	        });
	        if (removed.length !== 0) {
	            throw new Error("Deletion is not yet implemented");
	        }
	        this.saveMessageList();
	    };
	    RawSenderModalComponent.prototype.loadMessageList = function () {
	        var list = this.storage.get("raw-messages");
	        this.savedMessages = [];
	        if (list && typeof list === "object") {
	            for (var name_1 in list) {
	                if (list.hasOwnProperty(name_1)) {
	                    this.savedMessages.push({ name: name_1, message: list[name_1] });
	                }
	            }
	        }
	        if (this.savedMessages.length > 0) {
	            this.form.get("messageLoadName").setValue(this.savedMessages[0].name);
	        }
	        else {
	            this.form.get("messageLoadName").reset();
	        }
	    };
	    RawSenderModalComponent.prototype.saveMessageList = function () {
	        var list = this.savedMessages.reduce(function (prev, curr) {
	            prev[curr.name] = curr.message;
	            return prev;
	        }, {});
	        this.storage.set("raw-messages", list);
	    };
	    RawSenderModalComponent.prototype.saveMessage = function () {
	        var msgName = this.form.get("messageSaveName").value;
	        var msgContent = this.form.get("rawMessage").value;
	        this.updateSavedMessages([{ name: msgName, message: msgContent }]);
	    };
	    RawSenderModalComponent.prototype.loadMessage = function () {
	        var name = this.form.get("messageLoadName").value;
	        var target = this.savedMessages.find(function (compare) { return compare.name === name; });
	        if (!target) {
	            throw new Error("Could not find message '" + name + "' in storage");
	        }
	        this.form.get("rawMessage").setValue(target.message);
	        this.form.get("messageSaveName").setValue(target.name);
	    };
	    RawSenderModalComponent.prototype.eraseAllSaved = function () {
	        this.storage.remove("raw-messages");
	        this.savedMessages = [];
	    };
	    RawSenderModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Raw message tool &emsp;\n      <span class=\"badge\">\n        {{ready ? \"connected\" : \"DISCONNECTED\"}}\n        &mdash;\n        {{auth.authenticated ? \"logged in\" : \"GUEST\"}}\n      </span>\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <form [formGroup]=\"form\">\n      <div>\n        <label>Enter message JSON: (ID will automatically be assigned)</label>\n        <button\n          id=\"sendButton\"\n          class=\"btn btn-primary pull-right\"\n          (click)=\"trySend()\"\n          [disabled]=\"!ready\">\n          Parse &amp; Send\n        </button>\n      </div>\n\n      <textarea\n        class=\"form-control\"\n        rows=\"8\"\n        formControlName=\"rawMessage\">\n      </textarea>\n      <br><!-- #lazy #this-is-the-debug-menu #quit-harshing-my-mellow -->\n\n      <div class=\"col-sm-3\">\n        <div class=\"form-group\">\n          <label>Create from tag type:</label>\n          <select\n            class=\"form-control\"\n            [formControl]=\"tagSelector\">\n            <option *ngFor=\"let msg of msgClasses\" [value]=\"msg.tag\">\n              {{msg.name}}\n            </option>\n          </select>\n        </div>\n      </div>\n\n      <!-- save to local storage -->\n      <div class=\"col-sm-3\">\n        <div class=\"form-group\">\n          <label>Save message locally as:</label>\n          <div class=\"input-group\">\n            <input\n              type=\"text\"\n              class=\"form-control\"\n              formControlName=\"messageSaveName\">\n            <span class=\"input-group-btn\">\n              <button\n                class=\"btn btn-default\"\n                (click)=\"saveMessage()\">\n                Save\n              </button>\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <!-- load from local storage -->\n      <div class=\"col-sm-3\">\n        <div class=\"form-group\">\n          <label>Load message:</label>\n          <div class=\"input-group\">\n            <select class=\"form-control\" formControlName=\"messageLoadName\">\n              <option *ngFor=\"let loadable of savedMessages\">\n                {{loadable.name}}\n              </option>\n            </select>\n            <span class=\"input-group-btn\">\n              <button\n                class=\"btn btn-default\"\n                (click)=\"loadMessage()\">\n                Load\n              </button>\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-sm-3\">\n        <div class=\"form-group\">\n          <button\n            class=\"form-control btn btn-warning align-with-labels\"\n            (click)=\"eraseAllSaved()\">\n            Erase All\n          </button>\n        </div>\n      </div>\n\n      <div>\n        Response should appear below. \"Nonconversational\" messages will not,\n        but if they aren't being received by a service, they should\n        appear in the console.\n      </div>\n    </form>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-sm-6\">\n        <label>Request</label>\n        <prettyjson [obj]=\"request\"></prettyjson>\n      </div>\n      <div class=\"col-sm-6\">\n        <label>Response</label>\n        <prettyjson [obj]=\"response\"></prettyjson>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      Close\n    </button>\n  </div>\n  ",
	            styles: [
	                "/deep/ prettyjson pre {outline: none !important;}",
	                "/deep/ #sendButton {position: relative; top: -8px;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            auth_service_1.AuthService,
	            storage_service_1.StorageService,
	            angular2_modal_1.DialogRef])
	    ], RawSenderModalComponent);
	    return RawSenderModalComponent;
	}());
	exports.RawSenderModalComponent = RawSenderModalComponent;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var ExplanationContext = (function (_super) {
	    __extends(ExplanationContext, _super);
	    function ExplanationContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return ExplanationContext;
	}(bootstrap_1.BSModalContext));
	exports.ExplanationContext = ExplanationContext;
	var ExplanationModalComponent = (function () {
	    function ExplanationModalComponent(dialog) {
	        this.dialog = dialog;
	        this.explanation = dialog.context.explanation;
	    }
	    ExplanationModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Step Explanation\n    </h4>\n  </div>\n\n  <force-directed-graph [graph]=\"explanation\"></force-directed-graph>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      OK\n    </button>\n  </div>\n  ",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], ExplanationModalComponent);
	    return ExplanationModalComponent;
	}());
	exports.ExplanationModalComponent = ExplanationModalComponent;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var GenericObjectContext = (function (_super) {
	    __extends(GenericObjectContext, _super);
	    function GenericObjectContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return GenericObjectContext;
	}(bootstrap_1.BSModalContext));
	exports.GenericObjectContext = GenericObjectContext;
	var JsonModalComponent = (function () {
	    function JsonModalComponent(dialog) {
	        this.dialog = dialog;
	        this.object = "modal uninitialized";
	        if (typeof dialog.context.object !== "object") {
	            console.error("Could not open JsonModalComponent: non-Object");
	            dialog.dismiss();
	        }
	        else {
	            this.object = dialog.context.object;
	            this.note = dialog.context.note;
	        }
	    }
	    JsonModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Debug JSON Structure\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <p *ngIf=\"note\"><strong>Note:</strong> {{note}}</p>\n    <prettyjson [obj]=\"object\"></prettyjson>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      OK\n    </button>\n  </div>\n  ",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], JsonModalComponent);
	    return JsonModalComponent;
	}());
	exports.JsonModalComponent = JsonModalComponent;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var report_step_1 = __webpack_require__(584);
	var badge_service_1 = __webpack_require__(921);
	var BadgeComponent = (function () {
	    function BadgeComponent(badges) {
	        this.badges = badges;
	    }
	    Object.defineProperty(BadgeComponent.prototype, "report", {
	        set: function (step) {
	            if (!(step instanceof report_step_1.ReportStep)) {
	                throw new Error("Badge report attribute must be a ReportStep object!");
	            }
	            this.badge = this.badges.get(step.name);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", report_step_1.ReportStep),
	        __metadata("design:paramtypes", [report_step_1.ReportStep])
	    ], BadgeComponent.prototype, "report", null);
	    BadgeComponent = __decorate([
	        core_1.Component({
	            selector: "badge",
	            template: "\n    <span *ngIf=\"badge.knownType\">\n      <img\n        [src]=\"badge?.url\"\n        [class]=\"badge?.overlay\">\n      <img\n        *ngIf=\"badge?.overlay && badge?.overlayUrl\"\n        [src]=\"badge?.overlayUrl\"\n        class=\"overlay\">\n    </span>\n    <span\n      *ngIf=\"!badge?.knownType\"\n      class=\"cell notConfigured\">\n        no badge\n    </span>\n",
	            styles: [
	                ":host {\n      display: inline-block;\n      position: relative;\n      width: 48px;\n      height: 48px;\n    }",
	                ".cell {\n      display: table-cell;\n      text-align: center;\n      vertical-align: middle;\n    }",
	                "img {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n    }\n    img.ineligible, img.information {\n      -webkit-filter: saturate(0%) blur(0.3px);\n      filter: saturate(0%) blur(0.3px);\n    }\n    img.DEBUG {\n      -webkit-filter: hue-rotate(215deg) blur(1px);\n      filter: hue-rotate(215deg) blur(1px);\n    }\n    img.overlay {\n      z-index: 5;\n    }\n    img.inexact + .overlay {\n      filter: invert(100%) drop-shadow(0px 0px 3px black);\n    }",
	                ".imgMissing {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: -1;\n      width: 100%;\n      height: 100%;\n    }\n    .notConfigured {\n      position: relative;\n      overflow: hidden;\n      width: 48px;\n      height: 48px;\n      background-color: rgba(0, 128, 128, 0.6);\n      color: white;\n      font-size: 0.8em;\n      border-radius: 0.5em;\n    }"
	            ]
	        }),
	        __metadata("design:paramtypes", [badge_service_1.BadgeService])
	    ], BadgeComponent);
	    return BadgeComponent;
	}());
	exports.BadgeComponent = BadgeComponent;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var messaging_service_1 = __webpack_require__(533);
	var collaboration_service_1 = __webpack_require__(750);
	var CollaboratorPanelComponent = (function () {
	    function CollaboratorPanelComponent(messaging, collaboration) {
	        this.messaging = messaging;
	        this.collaboration = collaboration;
	        this.panelOpen = this.startOpen || false;
	        this.openOnChanges = false;
	    }
	    CollaboratorPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.collaboration.userEvents.subscribe(function (changes) {
	            if (_this.openOnChanges && changes) {
	                _this.panelOpen = true;
	            }
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CollaboratorPanelComponent.prototype, "startOpen", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CollaboratorPanelComponent.prototype, "openOnChanges", void 0);
	    CollaboratorPanelComponent = __decorate([
	        core_1.Component({
	            selector: "collaborator-panel",
	            template: "\n    <div\n      class=\"panel panel-default fade\"\n      [class.in]=\"!hideWhenEmpty || users.length\">\n      <div class=\"panel-heading\" (click)=\"panelOpen = !panelOpen\">\n        <h3 class=\"panel-title\">\n          Editing this subject\n          <span class=\"badge\">{{collaboration.users.length || 0}}</span>\n        </h3>\n      </div>\n      <table class=\"user-list text-center collapse\"\n      [class.in]=\"panelOpen\">\n        <tr *ngFor=\"let user of collaboration.users\">\n          <td class=\"h3\">\n            <span class=\"glyphicon glyphicon-user\"></span>\n          </td>\n          <td>\n            <strong>{{user.name}}</strong>\n            <span\n              *ngIf=\"user.userId.length > 1\"\n              class=\"text-info\"\n              title=\"This user has multiple active tabs or windows open.\">\n              <br>({{user.userId.length}} connections)\n            </span>\n          </td>\n          <td>\n            <em>{{user?.org || \"Unknown organization\"}}</em>\n          </td>\n        </tr>\n        <tr *ngIf=\"!collaboration?.users?.length\">\n          <td colspan=\"3\">No one is accessing this document.</td>\n        </tr>\n      </table>\n    </div>\n",
	            styles: [
	                ".user-list {\n      width: 100%;\n      padding: 0.5em;\n    }",
	                ".user-list.collapse.in { display: table; }",
	                ".user-list td:first-child { padding: 10px; }"
	            ]
	        }),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            collaboration_service_1.CollaborationService])
	    ], CollaboratorPanelComponent);
	    return CollaboratorPanelComponent;
	}());
	exports.CollaboratorPanelComponent = CollaboratorPanelComponent;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var Rx_1 = __webpack_require__(214);
	var algorithm_service_1 = __webpack_require__(213);
	var answer_proxy_1 = __webpack_require__(743);
	var intake_step_service_1 = __webpack_require__(751);
	var step_update_1 = __webpack_require__(697);
	var report_step_service_1 = __webpack_require__(849);
	var intake_step_1 = __webpack_require__(68);
	var alert_service_1 = __webpack_require__(689);
	var setting_service_1 = __webpack_require__(690);
	var explanation_modal_component_1 = __webpack_require__(935);
	var json_modal_component_1 = __webpack_require__(936);
	var graph_service_1 = __webpack_require__(918);
	var messaging_service_1 = __webpack_require__(533);
	var validation_messages_component_1 = __webpack_require__(738);
	var utilities_1 = __webpack_require__(523);
	var functions_1 = __webpack_require__(206);
	var jump_to_step_modal_component_1 = __webpack_require__(940);
	var control_group_1 = __webpack_require__(744);
	var bootstrap_1 = __webpack_require__(24);
	var ANSWER_PROVIDER = {
	    provide: answer_proxy_1.AnswerProxy,
	    useExisting: core_1.forwardRef(function () { return IntakeStepListComponent; })
	};
	var IntakeStepListComponent = (function () {
	    function IntakeStepListComponent(intakeService, reportService, algorithms, messaging, settings, alerts, graphs, modal) {
	        this.intakeService = intakeService;
	        this.reportService = reportService;
	        this.algorithms = algorithms;
	        this.messaging = messaging;
	        this.settings = settings;
	        this.alerts = alerts;
	        this.graphs = graphs;
	        this.modal = modal;
	        this.tableGroups = new Map();
	        this.orderedGroups = [];
	        this.groupAssignment = new Map();
	        this.tablesEnabled = true;
	        this.waitingAutofills = [];
	        this.allReportsInline = this.algorithms.running.name === "a-first-check-wi";
	        this.FORCE_IGNORE = [
	            "q-fcwi-estimated-unearned-monthly-income",
	            "q-fcwi-estimated-earned-monthly-household",
	            "q-fcwi-estimated-unearned-monthly-household"
	        ];
	    }
	    IntakeStepListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (!this.algorithms.isRunning) {
	            throw new Error("No algorithm context initialized");
	        }
	        this.sub = this.intakeService.updates().subscribe(function (u) {
	            if (u instanceof step_update_1.StepDefinition && u.source instanceof intake_step_1.IntakeStep) {
	                _this.form.addControl(u.source.name, u.source.control);
	                if (u.effects.autofilled && u.effects.autofillTarget) {
	                    _this.waitingAutofills.push(u.effects.autofillTarget);
	                    u.effects.autofillTarget.control.markAsDirty();
	                }
	                if (u.source.control && u.source.differsFromOriginalValue) {
	                    u.source.control.markAsDirty();
	                    u.source.provider = "a collaborator before you joined";
	                }
	            }
	            if (u instanceof step_update_1.ReceivedAnswer && u.source.provider) {
	                var target = _this.intakeService.get(u.id);
	                target.provider = u.source.provider;
	                target.control.markAsDirty();
	                if (u.source.value === null) {
	                    _this.alerts.userInfo(u.source.provider + " cleared the value of\n              " + (target.displayName || "unknown"));
	                }
	                else {
	                    _this.alerts.userInfo(u.source.provider + " submitted an answer for\n              <em>" + (target.displayName || "unknown") + "</em>");
	                }
	            }
	        });
	        this.sub.add(this.intakeService.updatingSet().debounceTime(400)
	            .subscribe(function (steps) {
	            _this.groupSteps(steps);
	            if (_this.waitingAutofills.length > 0) {
	                _this.submitMultiple(_this.waitingAutofills, [new Event("autofill")]);
	                _this.waitingAutofills = [];
	            }
	        }));
	        this.sub.add(this.reportService.updatingSet().debounceTime(400).subscribe(function (steps) { return _this.injectInlineReports(steps); }));
	        this.groups = [];
	        this.newGroup("ordered", "", { order: 1 });
	    };
	    IntakeStepListComponent.prototype.groupSteps = function (steps) {
	        var _this = this;
	        steps.filter(function (step) { return !_this.groupAssignment.get(step.id); }).forEach(function (step) { return _this.newStep(step); });
	        console.info("update:", this.groups, this.tableGroups, this.orderedGroups);
	    };
	    IntakeStepListComponent.prototype.injectInlineReports = function (steps) {
	        var _this = this;
	        this.groupSteps(steps.filter(function (step) {
	            return (_this.allReportsInline || step.hints.inline)
	                && step.isActive;
	        }).map(function (step) { return step.asEmptyIntake(); }));
	    };
	    IntakeStepListComponent.prototype.newGroup = function (type, name, config) {
	        var _this = this;
	        if (type === void 0) { type = null; }
	        if (config === void 0) { config = {}; }
	        var group;
	        if (type === "tabular" && this.tablesEnabled) {
	            var gridColumnMax = this.settings.get("table column max");
	            group = new control_group_1.TabularControlGroup(name, gridColumnMax);
	            this.tableGroups.set(name, group);
	            if (config.order) {
	                var toSplit = this.findOrdered(config.order);
	                if (toSplit) {
	                    var upperPart_1 = new control_group_1.OrderedControlGroup(config.order + 1, toSplit.max);
	                    this.orderedGroups.push(upperPart_1);
	                    toSplit.setMax(config.order - 1).forEach(function (s) {
	                        upperPart_1.add(s);
	                        _this.groupAssignment.set(s.id, upperPart_1);
	                    });
	                    this.groups.splice(this.groups.indexOf(toSplit) + 1, 0, group, upperPart_1);
	                    return group;
	                }
	            }
	        }
	        else if (type === "ordered") {
	            group = new control_group_1.OrderedControlGroup(config.min, config.max);
	            this.orderedGroups.push(group);
	        }
	        else {
	            group = new control_group_1.ControlGroup(type, name);
	        }
	        this.groups.push(group);
	        return group;
	    };
	    IntakeStepListComponent.prototype.newStep = function (step) {
	        if (this.FORCE_IGNORE.indexOf(step.name) > -1) {
	            console.warn("Ignoring step " + step.name + " due to FORCE_IGNORE");
	            return;
	        }
	        if (step.hints.table && this.tablesEnabled) {
	            if (!this.tableGroups.has(step.hints.table)) {
	                this.newGroup("tabular", step.hints.table, { order: step.order });
	            }
	            this.addToGroup(step, step.hints.table);
	        }
	        else if (intake_step_1.IntakeStep.ordered(step)) {
	            this.addToGroup(step, "ordered");
	        }
	        else {
	            this.addToGroup(step);
	        }
	    };
	    IntakeStepListComponent.prototype.addToGroup = function (step, target) {
	        var group;
	        if (typeof target === "string") {
	            if (target === "ordered") {
	                group = this.findOrdered(step.order);
	                if (!group) {
	                    console.error(step, this.orderedGroups);
	                    throw new Error("Could not find group for order " + step.order);
	                }
	            }
	            else {
	                group = this.tableGroups.get(target);
	            }
	        }
	        else if (Number.isInteger(target)) {
	            group = this.groups[target];
	        }
	        else {
	            group = this.groups.slice(-1)[0];
	            if (group.name) {
	                group = this.newGroup();
	            }
	        }
	        if (!group) {
	            console.error(step, this.groups);
	            throw new Error("Could not add to group target " + target + ", unknown group");
	        }
	        if (!group.add(step)) {
	            console.error(step, group);
	            throw new Error("Group is full or prohibits steps of this type");
	        }
	        this.groupAssignment.set(step.id, group);
	    };
	    IntakeStepListComponent.prototype.findOrdered = function (order) {
	        for (var _i = 0, _a = this.orderedGroups; _i < _a.length; _i++) {
	            var group = _a[_i];
	            if (order >= group.min && order <= group.max) {
	                return group;
	            }
	        }
	        return null;
	    };
	    IntakeStepListComponent.prototype.removeBlanks = function (list) {
	        if (Array.isArray(list)) {
	            list = list.filter(function (x) { return !functions_1.valueless(x); });
	        }
	        return list;
	    };
	    IntakeStepListComponent.prototype.collapseListBlanksToNulls = function (list) {
	        if (Array.isArray(list)) {
	            list = list.map(function (x) { return functions_1.inputless(x) ? null : x; });
	        }
	        return list;
	    };
	    IntakeStepListComponent.prototype.removeEndNulls = function (list) {
	        var i;
	        for (i = list.length; i > 0; i--) {
	            if (list[i - 1] !== null) {
	                break;
	            }
	        }
	        return list.slice(0, i);
	    };
	    IntakeStepListComponent.prototype.prepareForSubmission = function (step) {
	        if (!(step instanceof intake_step_1.IntakeStep) || !step.control) {
	            console.error("non-intake / control-less step:", step);
	            throw new Error();
	        }
	        if (!validation_messages_component_1.ValidationMessages.submittable(step.control)) {
	            this.alerts.warn("Cannot submit " + step.name + ": invalid value for step!");
	            console.log(step.control.value, step.control.errors);
	            return;
	        }
	        console.log("Submitting answer", step);
	        step.value = step.control.value;
	        step.provider = null;
	        if (Array.isArray(step.value)) {
	            step.value = this.removeEndNulls(this.collapseListBlanksToNulls(step.value));
	        }
	        console.info("collapsed value", step.value);
	    };
	    IntakeStepListComponent.prototype.submitByName = function (name, e) {
	        var step = this.intakeService.findNamed(name);
	        return this.submitAnswer(step, e);
	    };
	    IntakeStepListComponent.prototype.submitRaw = function (name, value) {
	        var step = this.intakeService.findNamed(name);
	        if (!step) {
	            console.error("Step " + name + " is unknown! Skipping submission");
	            return Rx_1.Observable.never();
	        }
	        step.value = value;
	        step.provider = null;
	        console.warn("Submitting RAW answer", step);
	        var o = this.intakeService.submit(step.completedIntakeStep());
	        o.subscribe();
	        return o;
	    };
	    IntakeStepListComponent.prototype.submitAnswer = function (step, e) {
	        this.prepareForSubmission(step);
	        var o = this.intakeService.submit(step.completedIntakeStep());
	        o.subscribe();
	        return o;
	    };
	    IntakeStepListComponent.prototype.submitMultiple = function (steps, e) {
	        var _this = this;
	        steps.forEach(function (step) { return _this.prepareForSubmission(step); });
	        var o = this.intakeService.submit(steps.map(function (step) { return step.completedIntakeStep(); }));
	        o.subscribe();
	        return o;
	    };
	    IntakeStepListComponent.prototype.ngOnDestroy = function () {
	    };
	    IntakeStepListComponent.prototype.requestMore = function () {
	        var _this = this;
	        this.intakeService.requestMore().subscribe(function (m) {
	            if (!m.ok) {
	                _this.alerts.notify("The server does not have any more steps available at this time");
	            }
	        });
	    };
	    IntakeStepListComponent.prototype.handleAction = function (_a) {
	        var name = _a[0], args = _a[1];
	        if (name === "explain") {
	            return this.explain(args);
	        }
	        if (name === "details") {
	            return this.details(args);
	        }
	        console.error(name, args);
	        throw new Error("Unknown group action occurred!");
	    };
	    IntakeStepListComponent.prototype.explain = function (step) {
	        var _this = this;
	        this.graphs.explainStep(step).subscribe(function (explanation) {
	            return utilities_1.ModalHelpers.openCustom(_this.modal, explanation_modal_component_1.ExplanationModalComponent, { explanation: explanation });
	        });
	    };
	    IntakeStepListComponent.prototype.details = function (step) {
	        Object.defineProperty(step, "control", { enumerable: false });
	        Object.defineProperty(step.hints, "_group", { enumerable: false });
	        console.info("Suppressed control value:", step.control);
	        utilities_1.ModalHelpers.openCustom(this.modal, json_modal_component_1.JsonModalComponent, {
	            object: step,
	            note: "control and _group may have been suppressed to reduce clutter"
	        });
	    };
	    IntakeStepListComponent.prototype.jumpToDialog = function (event) {
	        event.preventDefault();
	        utilities_1.ModalHelpers.observeCustom(this.modal, jump_to_step_modal_component_1.JumpToStepModalComponent, { groups: this.groups, size: "med" }).subscribe(function (id) {
	            if (id !== null) {
	                var e = document.getElementById("" + id);
	                if (e) {
	                    e.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
	                }
	                else {
	                    console.warn("Could not find step matching id " + typeof id + " " + id);
	                }
	            }
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", forms_1.FormGroup)
	    ], IntakeStepListComponent.prototype, "form", void 0);
	    __decorate([
	        core_1.HostListener("document:keydown.control.j", ["$event"]),
	        core_1.HostListener("document:keydown.meta.j", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], IntakeStepListComponent.prototype, "jumpToDialog", null);
	    IntakeStepListComponent = __decorate([
	        core_1.Component({
	            selector: "intake-step-list",
	            template: "\n    <spinner *ngIf=\"(!groups || !groups.length)\"></spinner>\n    <control-group\n      *ngFor=\"let group of groups\"\n      [group]=\"group\"\n      (action)=\"handleAction($event)\">\n    </control-group>\n    <div class=\"watermark\">WORKING DRAFT</div>\n    <!--<div class=\"more-button\">\n      <button\n        type=\"button\"\n        class=\"btn btn-default btn-lg\"\n        (click)=\"requestMore()\"\n        [disabled]=\"!context?.algorithmContext?.stepsAvailable\"\n        tabindex=\"-1\">\n        Load more questions\n      </button>\n    </div>-->\n  ",
	            styles: [
	                "spinner {font-size: 1.5em; margin: 2em;}\n    /deep/ .intake-step {position: relative; max-width: 98vw;}\n    .more-button {text-align: center; padding-top: 1.5em;}\n    .a-first-check.wi /deep/ control-group+control-group .classic {\n      border-top: 2px dashed;\n      padding-top: 20px;\n      margin-top: 10px;\n    }\n    .watermark {display: none;}\n    :host.a-first-check-wi .watermark {\n      display: block;\n      position: absolute;\n      top: 40px;\n      left: -20px;\n      width: 100%;\n      margin: auto;\n      text-align: center;\n      color: red;\n      font-family: sans-serif;\n      font-size: x-large;\n      text-shadow: 0px 0px 10px gray;\n      transform: rotate(-30deg);\n    }\n    .special-income-table {\n      width: 100%;\n    }\n    .special-income-table th {\n      text-align: center;\n    }\n    "
	            ],
	            providers: [ANSWER_PROVIDER]
	        }),
	        __metadata("design:paramtypes", [intake_step_service_1.IntakeStepService,
	            report_step_service_1.ReportStepService,
	            algorithm_service_1.AlgorithmService,
	            messaging_service_1.MessagingService,
	            setting_service_1.SettingService,
	            alert_service_1.AlertService,
	            graph_service_1.GraphService,
	            bootstrap_1.Modal])
	    ], IntakeStepListComponent);
	    return IntakeStepListComponent;
	}());
	exports.IntakeStepListComponent = IntakeStepListComponent;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var GroupListContext = (function (_super) {
	    __extends(GroupListContext, _super);
	    function GroupListContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return GroupListContext;
	}(bootstrap_1.BSModalContext));
	exports.GroupListContext = GroupListContext;
	var JumpToStepModalComponent = (function () {
	    function JumpToStepModalComponent(dialog) {
	        var _this = this;
	        this.dialog = dialog;
	        this.steps = [];
	        this.selected = new forms_1.FormControl();
	        dialog.context.groups.forEach(function (group) {
	            _this.steps = _this.steps.concat(group.steps);
	        });
	        this.steps.sort(function (a, b) {
	            return ((a.displayName || a.name || "").localeCompare(b.displayName || b.name));
	        });
	    }
	    JumpToStepModalComponent.prototype.jump = function () {
	        console.warn("JUMP", this.selected.value);
	        if (this.selected.value) {
	            this.dialog.close(this.selected.value);
	        }
	    };
	    JumpToStepModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Jump to Step...\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <p>Select a step to jump to:</p>\n    <select\n      [formControl]=\"selected\"\n      class=\"form-control\"\n      (change)=\"jump()\">\n      <option\n        *ngFor=\"let step of steps\"\n        [ngValue]=\"step.id\">\n        {{step.displayName || step.name}}\n      </option>\n    </select>\n  </div>\n  ",
	            styles: []
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
	    ], JumpToStepModalComponent);
	    return JumpToStepModalComponent;
	}());
	exports.JumpToStepModalComponent = JumpToStepModalComponent;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var intake_step_service_1 = __webpack_require__(751);
	var QuickLinkComponent = (function () {
	    function QuickLinkComponent(steps) {
	        this.steps = steps;
	        this.links = [];
	    }
	    QuickLinkComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.steps.updatingSet().debounceTime(300)
	            .subscribe(function (steps) {
	            _this.links = steps.filter(function (s) { return s.hints && s.hints.quicklink; });
	        });
	    };
	    QuickLinkComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    QuickLinkComponent.prototype.scrollTo = function (link) {
	        if (link.hints.table && Array.isArray(link.value)) {
	            var id = link.id + ":" + (link.value.length - 1);
	            var e_1 = document.getElementById(id);
	            if (e_1) {
	                e_1.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
	                return;
	            }
	        }
	        var e = document.getElementById("" + link.id);
	        if (e) {
	            e.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
	        }
	        else {
	            console.warn("Could not find step matching id " + typeof link.id + " " + link.id);
	        }
	    };
	    QuickLinkComponent = __decorate([
	        core_1.Component({
	            selector: "quick-links",
	            template: "\n    <!--<label *ngIf=\"links.length > 0\"></label>-->\n    <div class=\"btn-group\">\n      <button\n        class=\"btn btn-sm btn-default\"\n        *ngFor=\"let link of links\"\n        (click)=\"scrollTo(link)\">\n        Jump to {{link.hints.quicklink || link.displayName || link.name}}\n      </button>\n    </div>\n",
	            styles: [
	                ""
	            ]
	        }),
	        __metadata("design:paramtypes", [intake_step_service_1.IntakeStepService])
	    ], QuickLinkComponent);
	    return QuickLinkComponent;
	}());
	exports.QuickLinkComponent = QuickLinkComponent;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(21);
	var algorithm_step_service_1 = __webpack_require__(856);
	var report_step_service_1 = __webpack_require__(849);
	var print_service_1 = __webpack_require__(920);
	var graph_service_1 = __webpack_require__(918);
	var graphs_1 = __webpack_require__(857);
	var messaging_service_1 = __webpack_require__(533);
	var bootstrap_1 = __webpack_require__(24);
	var utilities_1 = __webpack_require__(523);
	var report_details_modal_component_1 = __webpack_require__(850);
	var ReportPanelComponent = (function () {
	    function ReportPanelComponent(messaging, reports, algorithmSteps, graphs, modal, print, sanitizer) {
	        this.messaging = messaging;
	        this.reports = reports;
	        this.algorithmSteps = algorithmSteps;
	        this.graphs = graphs;
	        this.modal = modal;
	        this.print = print;
	        this.sanitizer = sanitizer;
	        this.steps = [];
	        this.panelOpen = true;
	        this.activeCount = 0;
	    }
	    ReportPanelComponent.prototype.safeHtml = function (step) {
	        return this.sanitizer.bypassSecurityTrustHtml(step.presentation);
	    };
	    ReportPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.steps = [];
	        this.reports.updates().subscribe(function (update) {
	            var applied = update.findAndApply(_this.steps);
	            if (!applied && update.canCreate) {
	                var addedStep = update.create();
	                if (addedStep.hints.inline) {
	                    return;
	                }
	                _this.insertStep(addedStep);
	            }
	            _this.activeCount = _this.steps.reduce((function (count, step) {
	                return step.isActive ? count + 1 : count;
	            }), 0);
	        });
	        this.print.printEvents.subscribe(function () { return _this.openAll(); });
	    };
	    ReportPanelComponent.prototype.insertStep = function (newStep) {
	        if (!Number.isInteger(newStep.order)
	            || newStep.order === Number.MAX_SAFE_INTEGER) {
	            newStep.order = Number.MAX_SAFE_INTEGER;
	            this.steps.push(newStep);
	            return;
	        }
	        var i = 0;
	        while (i < this.steps.length) {
	            if (newStep.order < this.steps[i].order) {
	                this.steps.splice(i, 0, newStep);
	                return;
	            }
	            i++;
	        }
	        this.steps.push(newStep);
	    };
	    ReportPanelComponent.prototype.getPredeccesors = function (step) {
	        var _this = this;
	        console.log("Seeking predecessors");
	        var unknowns = [];
	        this.messaging.send(new graphs_1.PredecessorStepsRequest([step.id]))
	            .subscribe(function (m) {
	            step.predecessors = m.predecessors.map(function (preId) {
	                var predecessor = _this.algorithmSteps.get(preId);
	                if (!predecessor) {
	                    unknowns.push(preId);
	                    return null;
	                }
	                return predecessor;
	            }).filter(function (x) { return x; });
	            if (unknowns.length > 0) {
	                _this.algorithmSteps.requestDefinitions(unknowns).subscribe(function (steps) {
	                    step.predecessors = step.predecessors.concat(steps);
	                });
	            }
	        });
	        return step;
	    };
	    ReportPanelComponent.prototype.getExplanationGraph = function (step) {
	        return this.graphs.explainStep(step);
	    };
	    ReportPanelComponent.prototype.showDetails = function (step) {
	        utilities_1.ModalHelpers.openCustom(this.modal, report_details_modal_component_1.ReportDetailsModalComponent, { selected: step, explanation: this.getExplanationGraph(step) });
	    };
	    ReportPanelComponent.prototype.specialReportClick = function (event, step) {
	        if (event.target.classList.contains("click-to-copy")) {
	            navigator.clipboard.writeText(event.target.innerText);
	        }
	    };
	    ReportPanelComponent.prototype.openAll = function () {
	        this.steps.forEach(function (step) {
	            step._expanded = true;
	        });
	    };
	    ReportPanelComponent = __decorate([
	        core_1.Component({
	            selector: "report-panel",
	            template: "\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\" (click)=\"panelOpen = !panelOpen\">\n        <h3 class=\"panel-title\">\n          Reports\n          <span class=\"badge nonprint\">{{activeCount}}</span>\n        </h3>\n      </div>\n      <table class=\"collapse\" [class.in]=\"panelOpen\">\n        <tbody>\n          <template ngFor let-step [ngForOf]=\"steps\">\n            <tr\n              class=\"report border-between\"\n              [@slowRemoval]=\"!step.isActive ? 'remove' : 'keep'\">\n              <td>\n                <badge [report]=\"step\" (click)=\"showDetails(step)\"></badge>\n              </td>\n              <td>\n                <h4 (click)=\"step.hints.expanded = !step.hints.expanded\">\n                  <span\n                    class=\"glyphicon\"\n                    [class.glyphicon-expand]=\"!step.hints.expanded\"\n                    [class.glyphicon-collapse-down]=\"step.hints.expanded\">\n                  </span>\n                  {{step.displayName}}\n                </h4>\n                <p *ngIf=\"step.hints.expanded\" [innerHtml]=\"step.presentation | unsafe\" (click)=\"specialReportClick($event, step)\"></p>\n              </td>\n            </tr>\n          </template>\n\n          <tr *ngIf=\"activeCount === 0\" @slowAttach>\n            <td colspan=\"2\"><em>No reports available.</em></td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n",
	            styles: [
	                "badge {margin: 10px;}\n    .badge-label {font-size: 1.2em;}\n    .partial {\n      display: inline-block;\n      overflow: hidden;\n      height: 1em;\n      width: 100%;\n      text-overflow: ellipsis;\n\t\t}\n\t\t.panel >>> .progress {background-color: #dadada;}\n    ",
	                ".panel table {padding: 5px; width: 100%;}"
	            ],
	            animations: [utilities_1.SLOW_ATTACH, utilities_1.SLOW_REMOVAL]
	        }),
	        __metadata("design:paramtypes", [messaging_service_1.MessagingService,
	            report_step_service_1.ReportStepService,
	            algorithm_step_service_1.AlgorithmStepService,
	            graph_service_1.GraphService,
	            bootstrap_1.Modal,
	            print_service_1.PrintService,
	            platform_browser_1.DomSanitizer])
	    ], ReportPanelComponent);
	    return ReportPanelComponent;
	}());
	exports.ReportPanelComponent = ReportPanelComponent;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var angular2_modal_1 = __webpack_require__(25);
	var bootstrap_1 = __webpack_require__(24);
	var relation_graph_1 = __webpack_require__(822);
	var subject_service_1 = __webpack_require__(821);
	var RelationGraphContext = (function (_super) {
	    __extends(RelationGraphContext, _super);
	    function RelationGraphContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return RelationGraphContext;
	}(bootstrap_1.BSModalContext));
	exports.RelationGraphContext = RelationGraphContext;
	var RelationGraphModalComponent = (function () {
	    function RelationGraphModalComponent(dialog, subjects) {
	        var _this = this;
	        this.dialog = dialog;
	        this.subjects = subjects;
	        this.highlight = null;
	        this.typeFilter = new forms_1.FormControl(null);
	        this.roleFilter = new forms_1.FormControl(null);
	        console.warn(dialog);
	        this.graph = dialog.context.graph;
	        this.typeFilter.valueChanges.subscribe(function (value) { return _this.filter(); });
	        this.roleFilter.valueChanges.subscribe(function (value) { return _this.filter(); });
	    }
	    RelationGraphModalComponent.prototype.open = function (node) {
	        this.dialog.close(node);
	    };
	    RelationGraphModalComponent.prototype.expand = function (node) {
	        if (!node.alreadyExpanded) {
	            this.graph.expand(node);
	        }
	    };
	    RelationGraphModalComponent.prototype.enableNodesByEdgePossession = function () {
	        this.graph.nodes.forEach(function (n) {
	            n.simulated = false;
	            n.enabled = false;
	        });
	        this.graph.edges.forEach(function (e) {
	            if (e.enabled) {
	                e.source.enabled = true;
	                e.target.enabled = true;
	            }
	        });
	    };
	    RelationGraphModalComponent.prototype.enableAndDesim = function (x) {
	        x.simulated = false;
	        x.enabled = true;
	    };
	    RelationGraphModalComponent.prototype.filter = function () {
	        var _this = this;
	        var relType = this.typeFilter.value;
	        var roleType = this.roleFilter.value;
	        var clear = (!relType && !roleType);
	        if (clear) {
	            this.graph.edges.forEach(function (e) { return _this.enableAndDesim(e); });
	            this.graph.nodes.forEach(function (n) { return _this.enableAndDesim(n); });
	        }
	        else {
	            this.graph.edges.forEach(function (e) {
	                e.simulated = false;
	                e.enableAll();
	                if (relType) {
	                    e.filterByType(relType.name);
	                }
	                if (roleType) {
	                    e.filterByRole(roleType.name);
	                }
	            });
	            this.enableNodesByEdgePossession();
	        }
	        this.graph = Object.assign(new relation_graph_1.RelationGraph(), this.graph);
	    };
	    RelationGraphModalComponent = __decorate([
	        core_1.Component({
	            template: "\n  <div class=\"modal-header\">\n    <button\n      type=\"button\"\n      class=\"close\"\n      (click)=\"dialog.dismiss()\"\n      aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">\n      Relationship Network Graph\n    </h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-sm-4\">\n        <p>\n          Subjects and their relationships can be filtered using these controls.\n          Subjects with no matching relationships will be removed from the graph\n          and displayed in gray in the table below.\n        </p>\n        <p>\n          Filters can be removed by selecting the blank entry in each list.\n        </p>\n      </div>\n      <div class=\"col-sm-4\">\n        <label>Filter by relationship type:</label>\n        <select class=\"form-control\" [formControl]=\"typeFilter\">\n          <option [ngValue]=\"null\"></option>\n          <option\n            *ngFor=\"let type of subjects.relationshipTypes\"\n            [ngValue]=\"type\">\n            {{type.displayName}}\n          </option>\n        </select>\n      </div>\n      <div class=\"col-sm-4\">\n        <label>Filter by relationships with role:</label>\n        <select class=\"form-control\" [formControl]=\"roleFilter\">\n          <option [ngValue]=\"null\"></option>\n          <option\n            *ngFor=\"let role of subjects.roles\"\n            [ngValue]=\"role\">\n            {{role.displayName}}\n          </option>\n        </select>\n      </div>\n    </div>\n  </div>\n\n  <table\n    *ngFor=\"let type of graph.knownNodeCategories; let firstType = first\"\n    class=\"table center-items text-center\">\n    <caption\n      *ngIf=\"graph.knownNodeCategories.length > 1\"\n      class=\"capitalized\">\n      <!-- (only shown if there are multiple node types) -->\n      {{type}}\n    </caption>\n    <thead *ngIf=\"firstType\">\n      <th class=\"text-center\">ID</th>\n      <template [ngIf]=\"graph?.nodes?.length > 0\">\n        <th\n          *ngFor=\"let col of graph.nodes[0].summary\"\n          class=\"capitalized text-center\">\n          {{col.displayName || col.name}}\n        </th>\n      </template>\n      <th class=\"text-center\">Actions</th>\n    </thead>\n    <tbody>\n      <tr\n        *ngFor=\"let node of graph?.nodes\"\n        [class.highlight]=\"highlight == node.id\"\n        [class.disabled]=\"!node.enabled\"\n        (mouseenter)=\"highlight = node.id\"\n        (mouseleave)=\"highlight = null\">\n        <template [ngIf]=\"node.category === type\">\n          <td>{{node.id}}</td>\n          <td *ngFor=\"let summaryField of node.summary\">\n            <typed-display [input]=\"summaryField\"></typed-display>\n          </td>\n          <td>\n            <button\n              class=\"btn btn-default btn-xs\"\n              width=\"50%\"\n              (click)=\"expand(node)\"\n              [disabled]=\"node.alreadyExpanded\">\n              Expand\n            </button>\n            <button\n              class=\"btn btn-primary btn-xs\"\n              width=\"50%\"\n              (click)=\"open(node)\">\n              Open\n            </button>\n          </td>\n        </template>\n      </tr>\n      <tr *ngIf=\"graph?.nodes?.length === 0\">\n        <td colspan=\"3\" class=\"text-center text-danger\">\n          No subjects found in network!\n        </td>\n      </tr>\n      <tr *ngIf=\"!graph\">\n        <td colspan=\"3\" class=\"text-center\">\n          <spinner></spinner>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <force-directed-graph\n    [graph]=\"graph\"\n    [highlight]=\"highlight\"\n    [width]=\"800\"\n    [height]=\"400\"\n    (selected)=\"highlight = $event\"\n    (expand)=\"expand($event)\"\n    (simulation)=\"simulation = $event\"\n    [coolingRate]=\"0.005\">\n  </force-directed-graph>\n\n  <p class=\"text-center\">\n    Nodes with a dotted ring may have additional relationships. Either click on\n    the node itself, or the corresponding \"expand\" button to search.\n  </p>\n\n  <div class=\"modal-footer\">\n    <button\n      type=\"button\"\n      class=\"btn btn-primary\"\n      (click)=\"dialog.close()\">\n      OK\n    </button>\n  </div>\n  ",
	            styles: ["\n    table {\n      width: 100%;\n    }\n    badge {\n      margin: 15px;\n    }\n    /deep/ table td div p:last-child {\n      margin-bottom: 0;\n    }\n    table .special-message td {\n      text-align: center;\n    }\n    table caption {\n      text-align: left;\n      padding-left: 2em;\n      font-style: italic;\n    }\n    .fit-to-modal td:first-child, .fit-to-modal th:first-child {\n      padding-left: 30px;\n    }\n    .fit-to-modal td:last-child, .fit-to-modal th:last-child {\n      padding-right: 30px;\n    }\n    .table.fit-to-modal {\n      margin-bottom: 0;\n    }\n    .table tbody {border-bottom: 1px solid #ddd;}\n    .table tr.highlight {background-color: lightyellow;}\n    .table tr td {padding: 3px;}\n    tr.disabled {\n      background: #eee !important;\n      color: #888 !important;\n    }\n    "]
	        }),
	        __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
	            subject_service_1.SubjectService])
	    ], RelationGraphModalComponent);
	    return RelationGraphModalComponent;
	}());
	exports.RelationGraphModalComponent = RelationGraphModalComponent;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var bootstrap_1 = __webpack_require__(24);
	var utilities_1 = __webpack_require__(523);
	var relation_graph_modal_component_1 = __webpack_require__(943);
	var relationship_1 = __webpack_require__(826);
	var subject_1 = __webpack_require__(828);
	var subject_service_1 = __webpack_require__(821);
	var RelationshipPanelComponent = (function () {
	    function RelationshipPanelComponent(subjects, modal) {
	        this.subjects = subjects;
	        this.modal = modal;
	        this.panelOpen = false;
	    }
	    RelationshipPanelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.newRelationshipType = new forms_1.FormControl(null, forms_1.Validators.required);
	        this.newRelationshipType.valueChanges.subscribe(function (type) {
	            _this.selectedTarget = null;
	            if (!type) {
	                _this.newRelationship = null;
	            }
	            else {
	                _this.newRelationship = new relationship_1.Relationship({ relationshipType: type.name }, _this.subjects.relationshipTypes, _this.subjects.roles, _this.subject);
	                _this.newRelationship.startEditing();
	            }
	        });
	    };
	    RelationshipPanelComponent.prototype.traverse = function (rel) {
	        var partner = this.subjects.fromReference(rel.buildRef());
	        this.subjects.open(partner).subscribe();
	    };
	    RelationshipPanelComponent.prototype.delete = function (rel) {
	        this.subject.removeRelationship(rel).subscribe();
	    };
	    RelationshipPanelComponent.prototype.selectTargetFrom = function (mode) {
	        var _this = this;
	        this.subjects.selectViaDialog("Choose relationship target...", mode, this.determinePartnerType()).subscribe(function (selected) {
	            if (_this.subject.sameAs(selected)) {
	                alert("You cannot relate this exact subject with itself!\n          <br><br>\n          (NOTE: There is no such restriction on relating two <em>different</em>\n          subjects that happen to represent the same real-world thing.)");
	            }
	            else {
	                _this.selectedTarget = selected;
	            }
	        });
	    };
	    RelationshipPanelComponent.prototype.determinePartnerType = function () {
	        if (!this.newRelationship) {
	            return null;
	        }
	        if (this.newRelationship.type.sourceType === this.subject.type) {
	            return this.newRelationship.type.targetType;
	        }
	        else if (this.newRelationship.type.targetType === this.subject.type) {
	            return this.newRelationship.type.sourceType;
	        }
	        else {
	            console.error("Relationship invalid for subject type!", this.newRelationship.type, this.subject);
	            throw new Error("Relationship invalid for subject type!");
	        }
	    };
	    RelationshipPanelComponent.prototype.clearNewRelationship = function () {
	        this.newRelationshipType.reset();
	    };
	    RelationshipPanelComponent.prototype.create = function () {
	        var _this = this;
	        if (!this.newRelationship.sourceRoleEdit.value ||
	            !this.newRelationship.targetRoleEdit.value) {
	            return alert("You are missing required fields.");
	        }
	        if (!this.selectedTarget) {
	            return alert("You must select a partner for the relationship!");
	        }
	        this.subject.relateTo(this.selectedTarget, this.newRelationship.type, this.newRelationship.sourceRoleEdit.value, this.newRelationship.targetRoleEdit.value).subscribe(function (related) {
	            if (related) {
	                _this.clearNewRelationship();
	            }
	        });
	    };
	    RelationshipPanelComponent.prototype.saveEdits = function (rel) {
	        this.subject.updateRelation(rel.id, rel.sourceRoleEdit.value, rel.targetRoleEdit.value).subscribe(function (saved) {
	            if (saved) {
	                rel.cancelEditing();
	            }
	        });
	    };
	    RelationshipPanelComponent.prototype.openNetworkModal = function () {
	        var _this = this;
	        this.subjects.startRelationshipGraph(this.subject).subscribe(function (graph) {
	            return utilities_1.ModalHelpers.observeCustom(_this.modal, relation_graph_modal_component_1.RelationGraphModalComponent, { graph: graph, size: "lg", dialogClass: "modal-dialog modal-full" }).subscribe(function (openTarget) {
	                if (openTarget) {
	                    _this.subjects.openRelationGraphNode(graph, openTarget);
	                }
	            });
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", subject_1.Subject)
	    ], RelationshipPanelComponent.prototype, "subject", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], RelationshipPanelComponent.prototype, "panelOpen", void 0);
	    RelationshipPanelComponent = __decorate([
	        core_1.Component({
	            selector: "relationship-panel",
	            template: "\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\" (click)=\"panelOpen = !panelOpen\">\n        <h3 class=\"panel-title\">\n          Relationships\n          <span class=\"badge\">\n            {{subject.relationships?.length || 0}}\n          </span>\n          <button\n            class=\"btn btn-xs btn-default pull-right\"\n            (click)=\"$event.stopPropagation(); openNetworkModal()\">\n            View graph\n            <span class=\"glyphicon glyphicon-blackboard\"></span>\n          </button>\n        </h3>\n      </div>\n      <table class=\"table collapse\" [class.in]=\"panelOpen\">\n        <tbody>\n          <tr\n            *ngFor=\"let rel of subject.relationships\"\n            class=\"report border-between\">\n\n            <!-- self -->\n            <td width=\"50%\">\n              <label>Role</label>\n              <p *ngIf=\"!rel.editing\" class=\"text-primary\">\n                {{rel.sourceRole.displayName}}\n              </p>\n              <select\n                *ngIf=\"rel.editing\"\n                class=\"form-control\"\n                [formControl]=\"rel.sourceRoleEdit\">\n                <option\n                  *ngFor=\"let role of rel.getAvailableRoles()\"\n                  [ngValue]=\"role\">\n                  {{role.displayName}}\n                </option>\n              </select>\n              <p>\n                <label>Type</label>\n                <select\n                  class=\"form-control\"\n                  disabled\n                  title=\"The type is locked for existing relationships.\">\n                  <option default>{{rel.type.displayName}}</option>\n                </select>\n              </p>\n              <p>\n                <button\n                  *ngIf=\"!rel.editing\"\n                  class=\"btn btn-primary form-control\"\n                  (click)=\"rel.startEditing()\">\n                  Change Roles\n                </button>\n                <button\n                  *ngIf=\"rel.editing\"\n                  class=\"btn btn-success form-control\"\n                  (click)=\"saveEdits(rel)\">\n                  Save Changes\n                </button>\n              </p>\n              <p>\n                <button\n                  *ngIf=\"rel.editing\"\n                  class=\"btn btn-default form-control\"\n                  (click)=\"rel.cancelEditing()\">\n                  Cancel Changes\n                </button>\n              </p>\n              <p>\n                <button\n                  class=\"btn btn-danger form-control\"\n                  (click)=\"delete(rel)\">\n                  Delete\n                </button>\n              </p>\n            </td>\n\n            <!-- partner -->\n            <td width=\"50%\">\n              <label>Partner Role</label>\n              <p *ngIf=\"!rel.editing\" class=\"text-primary\">\n                {{rel.targetRole.displayName}}\n              </p>\n              <select\n                *ngIf=\"rel.editing\"\n                class=\"form-control\"\n                [formControl]=\"rel.targetRoleEdit\">\n                <option\n                  *ngFor=\"let role of rel.getAvailablePartnerRoles()\"\n                  [ngValue]=\"role\">\n                  {{role.displayName}}\n                </option>\n              </select>\n              <div\n                *ngFor=\"let datum of rel.targetSummary?.summary\">\n                <label class=\"capitalized\">\n                  {{datum.displayName || datum.name}}:\n                </label>\n                <typed-display [input]=\"datum\"></typed-display>\n              </div>\n              <button\n                class=\"btn btn-default form-control\"\n                (click)=\"traverse(rel)\">\n                Open Partner\n              </button>\n            </td>\n          </tr>\n          <tr *ngIf=\"!subject.relationships?.length\">\n            <td colspan=\"2\"><em>No relationships.</em></td>\n          </tr>\n        </tbody>\n\n        <tfoot>\n          <tr>\n            <td colspan=\"2\">\n              <label>Add Relationship</label>\n              <select\n                class=\"form-control\"\n                [formControl]=\"newRelationshipType\">\n                <option\n                  *ngFor=\"let type of subjects.relationshipTypes\"\n                  [ngValue]=\"type\">\n                  {{type.displayName}}\n                </option>\n              </select>\n            </td>\n          </tr>\n          <tr *ngIf=\"newRelationship\">\n            <td width=\"50%\">\n              <label>This role</label>\n              <select\n                class=\"form-control\"\n                [formControl]=\"newRelationship.sourceRoleEdit\">\n                <option\n                  *ngFor=\"let r of newRelationship.getAvailableRoles()\"\n                  [ngValue]=\"r\">\n                  {{r.displayName}}\n                </option>\n              </select>\n            </td>\n            <td width=\"50%\">\n              <label>Partner role</label>\n              <select\n                class=\"form-control\"\n                [formControl]=\"newRelationship.targetRoleEdit\">\n                <option\n                  *ngFor=\"let r of newRelationship.getAvailablePartnerRoles()\"\n                  [ngValue]=\"r\">\n                  {{r.displayName}}\n                </option>\n              </select>\n            </td>\n          </tr>\n          <tr *ngIf=\"newRelationship\">\n            <td class=\"center-item text-center\">\n              <p>\n                <label>Partner</label>\n                <span\n                  *ngIf=\"!selectedTarget\"\n                  class=\"glyphicon glyphicon glyphicon-remove-circle text-danger\">\n                </span>\n                <span\n                  *ngIf=\"selectedTarget\"\n                  class=\"glyphicon glyphicon glyphicon-ok-circle text-success\">\n                </span>\n              </p>\n              <button\n                class=\"btn btn-xs btn-default\"\n                (click)=\"selectTargetFrom('watchlist')\">\n                Select from Work List\n              </button>\n              <br>\n              <button\n                class=\"btn btn-xs btn-default\"\n                (click)=\"selectTargetFrom('search')\">\n                Find via Search\n              </button>\n            </td>\n            <td class=\"center-item\">\n              <span *ngIf=\"!selectedTarget\" class=\"text-danger\">\n                \u00ABnot selected\u00BB\n              </span>\n              <div *ngFor=\"let datum of selectedTarget?.summary\">\n                <label class=\"capitalized\">\n                  {{datum.displayName || datum.name}}:\n                </label>\n                <typed-display [input]=\"datum\"></typed-display>\n              </div>\n            </td>\n          </tr>\n          <tr *ngIf=\"newRelationship\">\n            <td colspan=\"2\">\n              <button\n                class=\"btn btn-default form-control\"\n                (click)=\"clearNewRelationship()\">\n                Clear\n              </button>\n              <button\n                class=\"btn btn-success form-control\"\n                (click)=\"create()\"\n                [disabled]=\"!selectedTarget || !newRelationship.editsValid\">\n                Create Relationship\n              </button>\n            </td>\n          </tr>\n      </table>\n    </div>\n",
	            styles: [
	                "badge {margin: 10px;}\n    .badge-label {font-size: 1.2em;}\n    .partial {\n      display: inline-block;\n      overflow: hidden;\n      height: 1em;\n      width: 100%;\n      text-overflow: ellipsis;\n    }\n    tfoot {\n      border-top: 1px solid #EEE;\n    }\n    tfoot td:last-of-type {\n      width: 500px; /* force full width */\n    }\n    ",
	                ".panel table {width: 100%;}"
	            ]
	        }),
	        __metadata("design:paramtypes", [subject_service_1.SubjectService,
	            bootstrap_1.Modal])
	    ], RelationshipPanelComponent);
	    return RelationshipPanelComponent;
	}());
	exports.RelationshipPanelComponent = RelationshipPanelComponent;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(64);
	var moment = __webpack_require__(70);
	var watchlist_service_1 = __webpack_require__(842);
	var ReminderListComponent = (function () {
	    function ReminderListComponent(watchlist) {
	        this.watchlist = watchlist;
	        this.showHeaders = true;
	        this.summary = new forms_1.FormControl("", forms_1.Validators.required);
	        this.triggerTime = new forms_1.FormControl(null, forms_1.Validators.required);
	        this.form = new forms_1.FormGroup({
	            summary: this.summary,
	            triggerTime: this.triggerTime
	        });
	    }
	    ReminderListComponent.prototype.ngOnInit = function () {
	        this.triggerTime.setValue(this.thisHourTomorrow);
	    };
	    Object.defineProperty(ReminderListComponent.prototype, "thisHourTomorrow", {
	        get: function () {
	            return moment().add(1, "d").startOf("hour").toDate();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ReminderListComponent.prototype.add = function () {
	        var _this = this;
	        if (this.triggerTime.invalid) {
	            return alert("You must enter a date to create a reminder!");
	        }
	        if (this.summary.invalid) {
	            return alert("You must enter a memo/label to create a reminder!");
	        }
	        this.watchlist.addReminder(this.summary.value, this.triggerTime.value).subscribe(function (added) {
	            _this.form.reset();
	        });
	    };
	    ReminderListComponent.prototype.remove = function (reminder) {
	        this.watchlist.removeReminder(reminder.notificationId).subscribe();
	    };
	    ReminderListComponent.prototype.open = function (reminder) {
	        this.watchlist.openReminderLinkedRecord(reminder).subscribe();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ReminderListComponent.prototype, "showHeaders", void 0);
	    ReminderListComponent = __decorate([
	        core_1.Component({
	            selector: "reminder-list",
	            template: "\n    <h2>\n      Reminders\n      <span class=\"badge success\">{{watchlist.activeReminderCount()}} active</span>\n      <span class=\"badge\">{{watchlist.reminders.length - watchlist.activeReminderCount()}} upcoming</span>\n    </h2>\n    <table class=\"table table-responsive\">\n      <thead *ngIf=\"showHeaders\">\n        <tr>\n          <th>Timestamp</th>\n          <th>Summary</th>\n          <th><!-- Remove --></th>\n        </tr>\n      </thead>\n      <tbody>\n        <!-- add entry -->\n        <tr>\n          <td>\n            <input\n              type=\"datetime-local\"\n              class=\"form-control\"\n              [formControl]=\"triggerTime\">\n          </td>\n          <td width=\"50%\">\n            <input\n              type=\"text\"\n              class=\"form-control\"\n              [formControl]=\"summary\"\n              placeholder=\"Enter reminder memo...\">\n          </td>\n          <td>\n            <button\n              class=\"btn btn-success form-control\"\n              (click)=\"add()\"\n              [disabled]=\"watchlist.reminderListObjectId === null\">\n              <span class=\"glyphicon glyphicon-plus\"></span>\n              Create Reminder\n            </button>\n          </td>\n        </tr>\n        <!-- existing entries -->\n        <tr\n          *ngFor=\"let reminder of (watchlist.reminders | paginate)\"\n          [class.bg-warning]=\"reminder.alert\">\n          <td class=\"text-center\" style=\"padding-right: 60px\">\n            <span *ngIf=\"reminder.alert\">\n              <span class=\"glyphicon glyphicon-exclamation-sign\">\n              </span>\n              &emsp;\n            </span>\n            {{reminder.triggerTime | date:\"MMM d, y h:mm a\"}}\n          </td>\n          <td style=\"padding-left: 22px\">\n            {{reminder.summary}}\n          </td>\n          <td>\n            <button\n              *ngIf=\"reminder.hasLink\"\n              type=\"button\"\n              class=\"btn btn-info form-control half\"\n              (click)=\"open(reminder)\">\n              <span class=\"glyphicon glyphicon-folder-open\"></span>\n              <!-- Open -->\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn btn-danger form-control\"\n              [class.half]=\"reminder.hasLink\"\n              (click)=\"remove(reminder)\">\n              <span class=\"glyphicon glyphicon-trash\"></span>\n              {{reminder.hasLink ? \"\" : \" Remove\"}}\n            </button>\n          </td>\n        </tr>\n      </tbody>\n      <caption *ngIf=\"!watchlist.reminders?.length\">\n        No scheduled reminders!\n      </caption>\n    </table>\n    <pager [asNeeded]=\"true\" [array]=\"watchlist.reminders\"></pager>\n",
	            styles: ["\n    caption {\n      caption-side: bottom;\n      text-align: center;\n      font-size: 1.7em;\n      font-style: italic;\n      padding: 0.5em;\n    }\n    .faded {\n      color: #DDDDDD;\n    }\n    table.table>tbody>tr>td {\n      vertical-align: middle;\n    }\n    input[type=datetime-local] {\n      text-align: center;\n    }\n    .btn.half {\n      width: calc(50% - 2px);\n    }\n  "]
	        }),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService])
	    ], ReminderListComponent);
	    return ReminderListComponent;
	}());
	exports.ReminderListComponent = ReminderListComponent;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var subject_1 = __webpack_require__(828);
	var watchlist_service_1 = __webpack_require__(842);
	var user_service_1 = __webpack_require__(713);
	var test = false;
	var WatchButtonComponent = (function () {
	    function WatchButtonComponent(watchlist, users) {
	        this.watchlist = watchlist;
	        this.users = users;
	        this.disabled = false;
	        this.knownLists = [];
	        this.loading = false;
	    }
	    WatchButtonComponent.prototype.watch = function () {
	        this.watchlist.watchSubject(this.subject).subscribe();
	    };
	    WatchButtonComponent.prototype.unwatch = function () {
	        this.watchlist.unwatch(this.subject).subscribe();
	    };
	    WatchButtonComponent.prototype.watchShared = function (targetList) {
	        this.watchlist.watchShared(this.subject, targetList).subscribe();
	    };
	    WatchButtonComponent.prototype.readExistingLists = function () {
	        var _this = this;
	        this.knownLists = [];
	        Array.from(this.watchlist.sharedListsByGroup.values())
	            .forEach(function (groupLists) {
	            _this.knownLists = _this.knownLists.concat(groupLists);
	        });
	        this.knownLists.sort(function (la, lb) { return la.title.localeCompare(lb.title); });
	    };
	    WatchButtonComponent.prototype.ngOnInit = function () {
	        this.readExistingLists();
	    };
	    WatchButtonComponent.prototype.loadAllShared = function () {
	        var _this = this;
	        this.loading = true;
	        this.watchlist.requestListsForAll(this.users.self.sharedListGroups).subscribe(function (_) {
	            _this.readExistingLists();
	            _this.loading = false;
	        });
	    };
	    WatchButtonComponent.prototype.toggleDropdown = function (openOptions) {
	        if (openOptions.open) {
	            openOptions.open = !openOptions.open;
	        }
	        else {
	            openOptions.open = true;
	            if (this.watchlist.hasLoadedSharedLists.size < this.users.self.sharedListGroups.length) {
	                this.loadAllShared();
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", subject_1.Subject)
	    ], WatchButtonComponent.prototype, "subject", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], WatchButtonComponent.prototype, "disabled", void 0);
	    WatchButtonComponent = __decorate([
	        core_1.Component({
	            selector: "watch-button",
	            template: "\n<div\n    #openOptions\n    class=\"btn-group\"\n    [class.open]=\"openOptions.open\"\n    (mouseleave)=\"openOptions.open = false\">\n    <a\n        *ngIf=\"subject && subject.incomingWatchId === null\"\n        (click)=\"watch()\"\n        class=\"btn btn-info\"\n        [attr.disabled]=\"disabled ? '' : null\">\n        <span class=\"glyphicon glyphicon-eye-open pull-left\"></span>\n        Add to List\n    </a>\n    <a\n        *ngIf=\"subject && subject.incomingWatchId !== null\"\n        (click)=\"unwatch()\"\n        class=\"btn btn btn-warning\"\n        [attr.disabled]=\"disabled ? '' : null\">\n        <span class=\"glyphicon glyphicon-eye-close pull-left\"></span>\n        Remove from List\n    </a>\n    <button\n    type=\"button\"\n    class=\"btn dropdown-toggle\"\n    [class.btn-primary]=\"!subject || subject.incomingWatchId === null\"\n    [class.btn-warning]=\"subject && subject.incomingWatchId !== null\"\n    data-toggle=\"dropdown\"\n    aria-haspopup=\"true\"\n    [attr.aria-expanded]=\"!!openOptions.open\"\n    (click)=\"toggleDropdown(openOptions)\">\n    <span class=\"caret\"></span>\n    </button>\n    <ul class=\"dropdown-menu contain-strict right-edge\">\n        <li *ngIf=\"loading\"><spinner></spinner></li>\n        <li *ngFor=\"let list of knownLists\">\n            <a (click)=\"watchShared(list)\">\n                Add to <em>{{list.title}}</em>\n            </a>\n        </li>\n        <!-- <li *ngIf=\"knownLists?.length > 0\" role=\"separator\" class=\"divider\"></li> -->\n        <!-- <li>\n            <a (click)=\"loadShared()\">\n            Load Shared Lists...\n            </a>\n        </li> -->\n    </ul>\n    </div>\n",
	            styles: ["\n    .btn-group {\n        margin-bottom: 20px;\n        width: 100%;\n    }\n    a.btn {\n        width: calc(100% - 26px);\n     }\n    .btn.dropdown-toggle {\n        width: 26px;\n    }\n    .dropdown-menu {\n        min-width: 50%;\n    }\n    .btn .glyphicon {\n        line-height: 20px;\n    }\n    "]
	        }),
	        __metadata("design:paramtypes", [watchlist_service_1.WatchlistService, user_service_1.UserService])
	    ], WatchButtonComponent);
	    return WatchButtonComponent;
	}());
	exports.WatchButtonComponent = WatchButtonComponent;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var user_service_1 = __webpack_require__(713);
	var branding_service_1 = __webpack_require__(830);
	var modal_service_1 = __webpack_require__(837);
	var configuration_service_1 = __webpack_require__(512);
	var navigation_history_service_1 = __webpack_require__(724);
	var support_service_1 = __webpack_require__(886);
	var launch_dependencies_1 = __webpack_require__(923);
	var add_reminder_modal_component_1 = __webpack_require__(851);
	var watchlist_service_1 = __webpack_require__(842);
	var sounds_service_1 = __webpack_require__(756);
	__webpack_require__(948);
	var utilities_1 = __webpack_require__(523);
	var messaging_service_1 = __webpack_require__(533);
	var debug_1 = __webpack_require__(613);
	var console_interceptor_1 = __webpack_require__(722);
	var iframe_modal_dialog_component_1 = __webpack_require__(931);
	var algorithm_service_1 = __webpack_require__(213);
	var setting_service_1 = __webpack_require__(690);
	var MCPApplicationComponent = (function () {
	    function MCPApplicationComponent(ld, users, modal, el, config, branding, support, navHistory, watchlist, messaging, algorithms, settings) {
	        var _this = this;
	        this.users = users;
	        this.modal = modal;
	        this.el = el;
	        this.config = config;
	        this.branding = branding;
	        this.watchlist = watchlist;
	        this.messaging = messaging;
	        this.algorithms = algorithms;
	        this.settings = settings;
	        this.audioPreloads = Array.from(sounds_service_1.SoundsService.PreloadMedia.entries());
	        this.shortcutsEnabled = false;
	        this.contactPageCloser = null;
	        navHistory.logAll();
	        support.checkBrowser();
	        this.users.ready.subscribe(function (loggedIn) { return _this.shortcutsEnabled = loggedIn; });
	    }
	    MCPApplicationComponent.prototype.addReminder = function (event) {
	        var _this = this;
	        if (!this.shortcutsEnabled) {
	            return;
	        }
	        event.preventDefault();
	        this.modal.observe(add_reminder_modal_component_1.AddReminderModalComponent, {
	            size: "md",
	            initialDate: event.targetDate,
	            hasImpliedLink: this.algorithms.isRunning
	        }).subscribe(function (r) {
	            if (r) {
	                _this.watchlist.addReminder(r.summary, r.triggerTime, r.linkedRecord ? _this.algorithms.running.subject.id : undefined).subscribe();
	            }
	        });
	    };
	    MCPApplicationComponent.prototype.showContactPage = function (event) {
	        var _this = this;
	        if (typeof this.contactPageCloser === "function") {
	            this.contactPageCloser();
	            this.contactPageCloser = null;
	        }
	        else {
	            this.modal.display(iframe_modal_dialog_component_1.IframeModalComponent, { url: "/zone/documents/faq.html", title: "Frequently Asked Questions" }).subscribe(function (closeFn) {
	                _this.contactPageCloser = closeFn;
	            });
	        }
	    };
	    MCPApplicationComponent.prototype.reportIssueOOB = function () {
	        var _this = this;
	        this.modal.stringPrompt({
	            title: "Submit Performance / Crash Report",
	            body: utilities_1.oneline(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        Enter a note to submit with this report, ideally describing why you are\n        submitting it."], ["\n        Enter a note to submit with this report, ideally describing why you are\n        submitting it."]))),
	            placeholder: "Note (required)"
	        }).subscribe(function (note) {
	            if (!note) {
	                return;
	            }
	            var recentErrors = console_interceptor_1.CONSOLE_HISTORY
	                .filter(function (_a) {
	                var e = _a[0], t = _a[1], a = _a[2];
	                return (e === "warn" || e === "error");
	            })
	                .map(function (c) { return utilities_1.jsonify(c, 200, true); })
	                .join("\n");
	            var content = "\nsent: " + (new Date()).toLocaleDateString + "\nsent by: " + _this.users.self.name + "\nnote: " + note + "\nrecent pings: " + _this.messaging.recentPingsRTT.list() + "\nconsole history: " + recentErrors;
	            _this.messaging.sendSideChannelOneOff(new debug_1.DebugLogUpstreamMessage("WARNING", content, true)).subscribe();
	        });
	    };
	    __decorate([
	        core_1.HostListener("document:keydown.control.m", ["$event"]),
	        core_1.HostListener("document:keydown.meta.m", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], MCPApplicationComponent.prototype, "addReminder", null);
	    __decorate([
	        core_1.HostListener("document:keydown.f5", ["$event"]),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], MCPApplicationComponent.prototype, "showContactPage", null);
	    MCPApplicationComponent = __decorate([
	        core_1.Component({
	            selector: "mcp-application",
	            template: "\n  <!-- at present our application just contains the \"outlet\" of the router\n  but eventually there will probably be styling at this level -->\n  <div class=\"alert-container\" [class.bottom-alerts]=\"settings.getOr('alert position', 'top') === 'bottom'\"><alert-list></alert-list></div>\n  <article defaultOverlayTarget [class.developer]=\"users.self.dev\">\n    <router-outlet></router-outlet>\n  </article>\n  <navbar></navbar>\n  <footer>\n    <template [ngIf]=\"branding.strings.footer\">\n      <p>{{branding.strings.footer}}</p>\n      <p> \u2767 </p>\n    </template>\n    <p>\n      \u00A92016-2024 My Coverage Plan, Inc. | Patent #8126727\n    </p>\n  </footer>\n  <div id=\"media-preload\">\n    <audio *ngFor=\"let audio of audioPreloads\" [id]=\"audio[0]\" [src]=\"audio[1]\">\n    </audio>\n  </div>\n  ",
	            styles: [
	                "article {position: relative; margin-top: 71px;}\n    @media print {\n      article {margin-top: 0px;}\n    }\n    footer {\n      margin: 1.5em auto;\n      position: relative;\n      z-index: -1000;\n    }\n    .alert-container {\n      position: fixed;\n      top: 72px;\n      z-index: 20;\n      width: 100%;\n      text-align: center;\n      pointer-events: none;\n    }\n    .alert-container.bottom-alerts {\n      top: unset;\n      bottom: 20px;\n    }\n    #media-preload {\n      display: none;\n    }"
	            ]
	        }),
	        __param(0, core_1.Inject(launch_dependencies_1.LAUNCH_DEPENDENCIES)),
	        __metadata("design:paramtypes", [Object, user_service_1.UserService,
	            modal_service_1.ModalService,
	            core_1.ElementRef,
	            configuration_service_1.ConfigurationService,
	            branding_service_1.BrandingService,
	            support_service_1.SupportService,
	            navigation_history_service_1.NavigationHistoryService,
	            watchlist_service_1.WatchlistService,
	            messaging_service_1.MessagingService,
	            algorithm_service_1.AlgorithmService,
	            setting_service_1.SettingService])
	    ], MCPApplicationComponent);
	    return MCPApplicationComponent;
	}());
	exports.MCPApplicationComponent = MCPApplicationComponent;
	var templateObject_1;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(949);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(951)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js?-url!../node_modules/sass-loader/index.js?sourceMap!./styles.sass", function() {
				var newContent = require("!!../node_modules/css-loader/index.js?-url!../node_modules/sass-loader/index.js?sourceMap!./styles.sass");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(950)();
	// imports
	
	
	// module
	exports.push([module.id, "html{position:relative}body,html{min-height:100%}body{margin:0;font-family:Palatino,Palatino Linotype,Palatino LT STD,Book Antiqua,Georgia,serif}:root{--header-font:$header-font-stack;--title-font:$title-font-stack;--body-font:$body-font-stack;--mono-font:$mono-font-stack;--color-blue:$color-blue;--color-green:$color-green;--color-dark:$color-dark;--color-pale:$color-pale;--color-red:$color-red;--color-yellow:$color-yellow;--context-bg:var(--color-pale)}.form-control select[size=\"1\"],select[size=\"1\"].form-control{height:34px}.form-control select{width:100%;height:100%;background:none;box-shadow:none;border:0 transparent}.form-control select[disabled]{background-color:#eee;opacity:1;cursor:not-allowed}.form-control select[size]{padding:4px 0 4px 10px}.form-control.wrapper{padding:0;height:auto}.form-control.wrapper.focus-helper{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control.wrapper input:focus,.form-control.wrapper select:focus,.form-control.wrapper textarea:focus{outline:0}.container{width:100%}.sheet{border:1px solid #e5dedc;border-radius:4px;padding:20px}.sheet,body .panel,body .well{background:url(/zone/images/light_odd_noise.png) #fbfaf9;box-shadow:0 0 4px rgba(0,0,0,.1)}body .panel,body .well{border-color:#e5dedc}body .panel hr,body .well hr{margin:10px;border-top:1px solid #aaa}body .panel .btn.btn-default,body .well .btn.btn-default{background:url(/zone/images/light_odd_noise.png) #fff}.panel div+.panel-heading,.panel table+.panel-heading{border-top:1px solid #ddd;border-top-left-radius:0;border-top-right-radius:0}.panel-body h1:first-child,.panel-body h2:first-child,.panel-body h3:first-child,.panel-body h4:first-child{margin-top:0}navbar{width:100%;position:fixed;top:0}.navbar{box-shadow:0 0 5px rgba(0,0,0,.5);font-family:-apple-system,\\.SFNSText-Regular,San Francisco,Roboto,Segoe UI,Fira Sans,Helvetica Neue,Lucida Grande,sans-serif;font-size:1.1em;font-weight:200}.navbar .navbar-toggle{padding:5px 10px}.nav-pills{font-family:-apple-system,\\.SFNSText-Regular,San Francisco,Roboto,Segoe UI,Fira Sans,Helvetica Neue,Lucida Grande,sans-serif;font-size:1.1em}.nav-pills li a{padding:9px 14px;border:1px solid #ccc}.nav-pills li.active a{padding:10px 14px;border:none}.nav-pills li+li{margin-left:10px}body .h1,body .h2,body .h3,body .h4,body .h5,body .h6,body .modal-header,body caption,body h1,body h2,body h3,body h4,body h5,body h6{font-family:Futura,Futura-Medium,Futura Medium,Muli,Century Gothic,CenturyGothic,sans-serif}.alert .close,.pager,input,label,select,textarea,th{font-family:-apple-system,\\.SFNSText-Regular,San Francisco,Roboto,Segoe UI,Fira Sans,Helvetica Neue,Lucida Grande,sans-serif}h1 .badge,h2 .badge{font-size:.5em}.badge{font-weight:400;font-family:Futura,Futura-Medium,Futura Medium,Muli,Century Gothic,CenturyGothic,sans-serif}.badge.success{background-color:#259150}.badge.warning{background-color:#d3b24e}.btn{color:#fff;font-family:-apple-system,\\.SFNSText-Regular,San Francisco,Roboto,Segoe UI,Fira Sans,Helvetica Neue,Lucida Grande,sans-serif;box-shadow:0 0 4px rgba(0,0,0,.1);transition:.25s}.btn:focus,.btn:hover{outline:0;border-color:#333!important;box-shadow:0 0 8px rgba(0,0,0,.3)}.btn.btn-default{color:#333;background:url(/zone/images/light_odd_noise.png) #fbfaf9;border-color:#cfc2bf}.btn.btn-default:focus,.btn.btn-default:hover{background:#fff}.btn.btn-primary{background:url(/zone/images/light_odd_noise.png) #1d3559;border-color:#2a4c7f}.btn.btn-primary:focus,.btn.btn-primary:hover{background:url(/zone/images/light_odd_noise.png) #305793}.btn.btn-info{background:url(/zone/images/light_odd_noise.png) #258ab2;border-color:#217a9d}.btn.btn-info:focus,.btn.btn-info:hover{background:url(/zone/images/light_odd_noise.png) #35a8d5}.btn.btn-success{background:url(/zone/images/light_odd_noise.png) #259150;border-color:#207d45}.btn.btn-success:focus,.btn.btn-success:hover{background:url(/zone/images/light_odd_noise.png) #2aa55b}.btn.btn-warning{background:url(/zone/images/light_odd_noise.png) #d3b24e;border-color:#cea93a}.btn.btn-warning:focus,.btn.btn-warning:hover{background:url(/zone/images/light_odd_noise.png) #ddc477}.btn.btn-danger{background:url(/zone/images/light_odd_noise.png) #a06876;border-color:#a06876}.btn.btn-danger:focus,.btn.btn-danger:hover{background:url(/zone/images/light_odd_noise.png) #b48792}.alert{color:#444!important;box-shadow:0 0 4px rgba(0,0,0,.1);background:url(/zone/images/light_odd_noise.png);border-color:#333}.alert.alert-info{background-color:#def1f8;border-color:#b4deef}.alert.alert-success{background-color:#d9f5e4;border-color:#b1ebc8}.alert.alert-warning{background-color:#f1e7c9;border-color:#e7d6a0}.alert.alert-danger{background-color:#efe5e8;border-color:#dbc6cb}body .modal-backdrop{background:url(/zone/images/light_odd_noise.png) rgba(100,110,140,.3);transition:.1s}body .modal-backdrop.in{opacity:1;transition:.5s}body mcp-application>*{filter:brightness(100%) blur(0);transition:filter .1s}body.modal-open mcp-application>*{filter:brightness(120%) blur(5px);transition:filter .5s}div.modal-content{box-shadow:0 5px 25px rgba(0,0,0,.4);border-color:rgba(0,0,0,.1)}.sidebar{position:fixed;right:100px;top:50px}footer{position:relative;left:0;bottom:0;width:100%}footer p{color:#ccc;text-align:center}.intake-step-id{display:inline;font-family:Monaco,Menlo,Courier New,monospace;font-variant:small-caps;font-size:smaller;color:#ccc}.a-first-check-wi .comment-crumb,.a-first-check-wi .comment-edits,.a-first-check-wi .intake-step-id,.a-first-check-wi .new-comment,.a-first-check-wi comment-list{display:none!important}.minor-outcome{display:list-item;list-style-type:circle;margin-left:1em}fieldset legend{margin-bottom:0;border-bottom:0}details{border:1px solid gray;padding:10px;border-radius:5px}details[open] summary{padding-bottom:5px;margin-bottom:5px;border-bottom:1px dotted}.add-field{margin-top:5px}.dim{opacity:.3}.debug-only{background:repeating-linear-gradient(-45deg,rgba(255,255,0,.4),rgba(255,255,0,.4) 10px,transparent 0,transparent 20px)!important}textarea+.input-group-btn,textarea+.input-group-btn .btn{height:100%}em.phrasal{font-style:normal;text-decoration:underline}.dotted,dfn{border-bottom:1px dotted #555}kbd,pre.literal{background-color:#f4f7f8;transition:background-color .25s;border-radius:3px;border:1px solid #b4b4b4;color:#333;box-shadow:0 1px 1px rgba(0,0,0,.2),inset 0 2px 0 0 hsla(0,0%,100%,.7);display:inline-block;font-family:Consolas,Liberation Mono,Courier,monospace;font-size:.85em;font-weight:700;line-height:inherit;padding:2px 4px}.capitalized{text-transform:capitalize}.uppercase{text-transform:uppercase}.lowercase{text-transform:lowercase}.auto-width{width:auto!important}table.center-items>tbody>tr>td,table.center-items>tbody>tr>th{vertical-align:middle}table.center-items td>p:last-child{margin-bottom:0}td.center-item,th.center-item{vertical-align:middle!important}.border-between{border-bottom:1px solid #ccc}.border-between:last-child{border-bottom:none}.table-sm{margin-bottom:0}.table-sm>tbody>tr>td,.table-sm>tbody>tr>th,.table-sm>thead>tr>td,.table-sm>thead>tr>th{padding:2px 5px}pre.click-to-copy:before{content:\"\\29C9\";float:right;margin:-8px -5px}.loader.ellipsis{text-align:center}.loader.ellipsis div{width:1.2em;height:1.2em;background-color:#333;border-radius:100%;display:inline-block;-webkit-animation:sk-bouncedelay 1.4s infinite ease-in-out both;animation:sk-bouncedelay 1.4s infinite ease-in-out both}.loader.ellipsis .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader.ellipsis .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}.input-tray{width:40px;text-align:center}.invalid .input-tray{background:url(/zone/images/light_odd_noise.png) #a06876;color:#fff}.empty .input-tray{background:url(/zone/images/light_odd_noise.png) #1d3559;color:#fff}.saved .input-tray{background:url(/zone/images/light_odd_noise.png) #259150;color:#fff}.answered .input-tray{background:url(/zone/images/light_odd_noise.png) #d3b24e;color:#fff}.received .input-tray{background:url(/zone/images/light_odd_noise.png) #e5dedc;color:#333}.message{padding:4px 15px}.validation-tray .message{background:url(/zone/images/light_odd_noise.png) #e5dedc}.info-tray .message{background:url(/zone/images/light_odd_noise.png) #def1f8}.intake-step textarea{resize:vertical}.collapsed-statuses .invalid .form-control{border:1px solid #a06876;box-shadow:inset 0 0 1px #b48792}.collapsed-statuses .invalid .form-control.wrapper.focus-helper,.collapsed-statuses .invalid .form-control:focus{box-shadow:inset 0 1px 2px #b48792}.collapsed-statuses .saved .form-control{border:1px solid #259150;box-shadow:inset 0 0 1px #4bd180}.collapsed-statuses .saved .form-control.wrapper.focus-helper,.collapsed-statuses .saved .form-control:focus{box-shadow:inset 0 1px 2px #2fba66}.collapsed-statuses .answered .form-control{border:1px solid #d3b24e;box-shadow:inset 0 0 1px #ddc477}.collapsed-statuses .answered .form-control.wrapper.focus-helper,.collapsed-statuses .answered .form-control:focus{box-shadow:inset 0 1px 2px #ddc477}.collapsed-statuses .received .form-control{border:1px solid #e5dedc;box-shadow:inset 0 0 1px #fbfaf9}.collapsed-statuses .received .form-control.wrapper.focus-helper,.collapsed-statuses .received .form-control:focus{box-shadow:inset 0 1px 2px #fbfaf9}.untyped-statuses .form-control.ng-invalid{border:1px solid #a06876}.untyped-statuses .form-control.ng-invalid:focus{box-shadow:inset 0 1px 1px #b48792}.untyped-statuses .form-control.ng-valid.ng-dirty{border:1px solid #d3b24e}.untyped-statuses .form-control.ng-valid.ng-dirty:focus{box-shadow:inset 0 1px 1px #ddc477}.dev-only{visibility:hidden}.developer .dev-only{visibility:visible}.oneline-ellipsis{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}input[type=checkbox].icon{-webkit-appearance:none}input[type=checkbox].icon:after{content:\"\\E157\";font-family:Glyphicons Halflings;display:inline-block;font-size:1.5em;line-height:1;padding:4px}input[type=checkbox].icon:checked:after{content:\"\\E067\";color:#259150}input[type=checkbox].icon.nonboolean:after{content:\"\\E065\";color:#d3b24e}input[type=checkbox].icon:focus{outline:none}.modal-full{width:95%}.modal-full .modal-content{overflow-x:auto}.autohyphen{-webkit-hyphens:auto;-ms-hyphens:auto;-o-hyphens:auto;hyphens:auto}.progress{font-family:-apple-system,\\.SFNSText-Regular,San Francisco,Roboto,Segoe UI,Fira Sans,Helvetica Neue,Lucida Grande,sans-serif}.no-border{border:none!important}.display-none{display:none}@media print{font-size:1.1em;input{border:1px solid #ccc!important;padding:0 10px}.actions-tray,.booleanSubmit,.comment-edits,.debug-buttons,.details-bar .contents>button,.end-buttons,.icon-tray,.info-tray,.input-tray,.intake-step-id,.menu-button,.new-comment,.nonprint,.row-actions,.size-controls,chat-panel,collaborator-panel,comment-list .visibility,details:not([open]),nav{display:none!important}select option:not(:checked){opacity:1%}select option:checked{background:rgba(0,0,0,.1)!important;font-weight:700}.presentation{font-size:1.1em}.presentation p:last-of-type{margin:0}.question-column{padding-left:0!important;margin:auto 20px}.menu{max-height:none!important;opacity:1!important;padding-top:0!important}.collated>.well{border-radius:0;border:none;border-left:1px solid #ccc;padding:5px 10px;margin-bottom:0}.collapsed-statuses .form-control{border-color:#ccc!important}.panel,.panel table{border:none}.panel .panel-heading{border:none;border-top:1px solid #ccc}.panel .panel-title{font-size:1.8em}.details-bar{top:0!important}}@media print and (max-width:768px){.details-bar{position:relative!important;width:100%!important}}@media print{.boolean .btn{border:1px solid #ccc}.boolean .active{background:#ccc!important;font-weight:700}coverage-form>.container{padding:10px!important;max-width:none!important}}.collated .well>table,.intake-step,.tabular-grid,table.grid{page-break-inside:avoid}.progress-bar-invisible{background-color:transparent;color:#333}.p100{width:100%}.bg-warning{background-color:rgba(255,248,153,.4)}.table-striped tr.bg-warning{background-color:rgba(255,248,153,.4)!important}.align-with-labels{margin-top:25px}.align-with-labels.checkbox{margin-top:32px}.emph{font-style:italic}.progress-bar-disabled{background-color:#e5dedc;color:#333}.progress{position:relative}.progress>label{position:absolute;left:0;top:0;width:100%;text-align:center;text-shadow:0 0 3px #fff}.btn-group .dropdown-menu{z-index:25;margin:0}.btn-group .dropdown-menu.contain-strict{max-width:100%;max-height:75vh;overflow-x:hidden;overflow-y:scroll}.btn-group .dropdown-menu.right-edge{left:auto;right:0}", ""]);
	
	// exports


/***/ })
]);


// WEBPACK FOOTER //
// app.14ec9f68594aed1f5177.js